var _asyncToGenerator = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _assertThisInitialized = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _construct = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _regeneratorRuntime = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _get = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _toConsumableArray = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/mnt/c/Users/angel/projects/xhq-community-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

/*!
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (t) {
  t.en = Object.assign(t.en || {}, {
    a: "Cannot upload file:",
    b: "Words: %0",
    c: "Characters: %0",
    d: "Bold",
    e: "Block quote",
    f: "Italic",
    g: "Insert image or file",
    h: "Choose heading",
    i: "Heading",
    j: "Insert table",
    k: "Header column",
    l: "Insert column left",
    m: "Insert column right",
    n: "Delete column",
    o: "Column",
    p: "Header row",
    q: "Insert row below",
    r: "Insert row above",
    s: "Delete row",
    t: "Row",
    u: "Merge cell up",
    v: "Merge cell right",
    w: "Merge cell down",
    x: "Merge cell left",
    y: "Split cell vertically",
    z: "Split cell horizontally",
    aa: "Merge cells",
    ab: "Align left",
    ac: "Align right",
    ad: "Align center",
    ae: "Justify",
    af: "Text alignment",
    ag: "Underline",
    ah: "Full size image",
    ai: "Side image",
    aj: "Left aligned image",
    ak: "Centered image",
    al: "Right aligned image",
    am: "Numbered List",
    an: "Bulleted List",
    ao: "image widget",
    ap: "Insert image",
    aq: "media widget",
    ar: "Insert media",
    as: "The URL must not be empty.",
    at: "This media URL is not supported.",
    au: "Enter image caption",
    av: "Upload failed",
    aw: "Link",
    ax: "Upload in progress",
    ay: "Could not obtain resized image URL.",
    az: "Selecting resized image failed",
    ba: "Could not insert image at the current position.",
    bb: "Inserting image failed",
    bc: "Paragraph",
    bd: "Heading 1",
    be: "Heading 2",
    bf: "Heading 3",
    bg: "Heading 4",
    bh: "Heading 5",
    bi: "Heading 6",
    bj: "Change image text alternative",
    bk: "Rich Text Editor",
    bl: "Undo",
    bm: "Redo",
    bn: "%0 of %1",
    bo: "Previous",
    bp: "Next",
    bq: "Save",
    br: "Cancel",
    bs: "Text alternative",
    bt: "Open in a new tab",
    bu: "Downloadable",
    bv: "Unlink",
    bw: "Edit link",
    bx: "Open link in new tab",
    by: "This link has no URL",
    bz: "Link URL",
    ca: "Paste the media URL in the input.",
    cb: "Tip: Paste the URL into the content to embed faster.",
    cc: "Media URL",
    cd: "Rich Text Editor, %0"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ClassicEditor = e() : t.ClassicEditor = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var o = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(i, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 128);
  }([function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return o;
    }), n.d(e, "a", function () {
      return r;
    });
    var i = "https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html";

    var o =
    /*#__PURE__*/
    function (_Error) {
      _inherits(o, _Error);

      function o(t, e, n) {
        var _this;

        _classCallCheck(this, o);

        t = r(t), n && (t += " " + JSON.stringify(n)), _this = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, t)), _this.name = "CKEditorError", _this.context = e, _this.data = n;
        return _this;
      }

      _createClass(o, [{
        key: "is",
        value: function is(t) {
          return "CKEditorError" === t;
        }
      }]);

      return o;
    }(_wrapNativeSuper(Error));

    function r(t) {
      var e = t.match(/^([^:]+):/);
      return e ? t + " Read more: ".concat(i, "#error-").concat(e[1], "\n") : t;
    }
  }, function (t, e, n) {
    "use strict";

    var i = n(0);
    var o = {
      error: function error(t, e) {
        console.error(Object(i.a)(t), e);
      },
      warn: function warn(t, e) {
        console.warn(Object(i.a)(t), e);
      }
    };
    e.a = o;
  }, function (t, e, n) {
    var i = {},
        o = function (t) {
      var e;
      return function () {
        return void 0 === e && (e = t.apply(this, arguments)), e;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        r = function (t) {
      var e = {};
      return function (t, n) {
        if ("function" == typeof t) return t();

        if (void 0 === e[t]) {
          var i = function (t, e) {
            return e ? e.querySelector(t) : document.querySelector(t);
          }.call(this, t, n);

          if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
            i = i.contentDocument.head;
          } catch (t) {
            i = null;
          }
          e[t] = i;
        }

        return e[t];
      };
    }(),
        s = null,
        a = 0,
        c = [],
        l = n(52);

    function d(t, e) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n],
            r = i[o.id];

        if (r) {
          r.refs++;

          for (var s = 0; s < r.parts.length; s++) {
            r.parts[s](o.parts[s]);
          }

          for (; s < o.parts.length; s++) {
            r.parts.push(g(o.parts[s], e));
          }
        } else {
          var a = [];

          for (s = 0; s < o.parts.length; s++) {
            a.push(g(o.parts[s], e));
          }

          i[o.id] = {
            id: o.id,
            refs: 1,
            parts: a
          };
        }
      }
    }

    function u(t, e) {
      for (var n = [], i = {}, o = 0; o < t.length; o++) {
        var r = t[o],
            s = e.base ? r[0] + e.base : r[0],
            a = {
          css: r[1],
          media: r[2],
          sourceMap: r[3]
        };
        i[s] ? i[s].parts.push(a) : n.push(i[s] = {
          id: s,
          parts: [a]
        });
      }

      return n;
    }

    function h(t, e) {
      var n = r(t.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var i = c[c.length - 1];
      if ("top" === t.insertAt) i ? i.nextSibling ? n.insertBefore(e, i.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), c.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
        if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = r(t.insertAt.before, n);
        n.insertBefore(e, o);
      }
    }

    function f(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var e = c.indexOf(t);
      e >= 0 && c.splice(e, 1);
    }

    function m(t) {
      var e = document.createElement("style");

      if (void 0 === t.attrs.type && (t.attrs.type = "text/css"), void 0 === t.attrs.nonce) {
        var i = function () {
          0;
          return n.nc;
        }();

        i && (t.attrs.nonce = i);
      }

      return p(e, t.attrs), h(t, e), e;
    }

    function p(t, e) {
      Object.keys(e).forEach(function (n) {
        t.setAttribute(n, e[n]);
      });
    }

    function g(t, e) {
      var n, i, o, r;

      if (e.transform && t.css) {
        if (!(r = "function" == typeof e.transform ? e.transform(t.css) : e.transform.default(t.css))) return function () {};
        t.css = r;
      }

      if (e.singleton) {
        var c = a++;
        n = s || (s = m(e)), i = w.bind(null, n, c, !1), o = w.bind(null, n, c, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (t) {
        var e = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", p(e, t.attrs), h(t, e), e;
      }(e), i = function (t, e, n) {
        var i = n.css,
            o = n.sourceMap,
            r = void 0 === e.convertToAbsoluteUrls && o;
        (e.convertToAbsoluteUrls || r) && (i = l(i));
        o && (i += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var s = new Blob([i], {
          type: "text/css"
        }),
            a = t.href;
        t.href = URL.createObjectURL(s), a && URL.revokeObjectURL(a);
      }.bind(null, n, e), o = function o() {
        f(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = m(e), i = function (t, e) {
        var n = e.css,
            i = e.media;
        i && t.setAttribute("media", i);
        if (t.styleSheet) t.styleSheet.cssText = n;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), o = function o() {
        f(n);
      });

      return i(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          i(t = e);
        } else o();
      };
    }

    t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = o()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var n = u(t, e);
      return d(n, e), function (t) {
        for (var o = [], r = 0; r < n.length; r++) {
          var s = n[r];
          (a = i[s.id]).refs--, o.push(a);
        }

        t && d(u(t, e), e);

        for (r = 0; r < o.length; r++) {
          var a;

          if (0 === (a = o[r]).refs) {
            for (var c = 0; c < a.parts.length; c++) {
              a.parts[c]();
            }

            delete i[a.id];
          }
        }
      };
    };

    var b = function () {
      var t = [];
      return function (e, n) {
        return t[e] = n, t.filter(Boolean).join("\n");
      };
    }();

    function w(t, e, n, i) {
      var o = n ? "" : i.css;
      if (t.styleSheet) t.styleSheet.cssText = b(e, o);else {
        var r = document.createTextNode(o),
            s = t.childNodes;
        s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
      }
    }
  },, function (t, e, n) {
    "use strict";

    var i = n(10),
        o = "object" == typeof self && self && self.Object === Object && self,
        r = i.a || o || Function("return this")();
    e.a = r;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(10),
          o = "object" == typeof exports && exports && !exports.nodeType && exports,
          r = o && "object" == typeof t && t && !t.nodeType && t,
          s = r && r.exports === o && i.a.process,
          a = function () {
        try {
          var t = r && r.require && r.require("util").types;

          return t || s && s.binding && s.binding("util");
        } catch (t) {}
      }();

      e.a = a;
    }).call(this, n(12)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(4),
          o = n(19),
          r = "object" == typeof exports && exports && !exports.nodeType && exports,
          s = r && "object" == typeof t && t && !t.nodeType && t,
          a = s && s.exports === r ? i.a.Buffer : void 0,
          c = (a ? a.isBuffer : void 0) || o.a;
      e.a = c;
    }).call(this, n(12)(t));
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.591 10.177l4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var e = n(1),
          i = n(21);
      var o = "object" == typeof window ? window : t;
      o.CKEDITOR_VERSION ? e.a.error("ckeditor-duplicated-modules: Some CKEditor 5 modules are duplicated.") : o.CKEDITOR_VERSION = i.a;
    }).call(this, n(17));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.a = n;
    }).call(this, n(17));
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';
  }, function (t, e) {
    t.exports = function (t) {
      if (!t.webpackPolyfill) {
        var e = Object.create(t);
        e.children || (e.children = []), Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function get() {
            return e.l;
          }
        }), Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function get() {
            return e.i;
          }
        }), Object.defineProperty(e, "exports", {
          enumerable: !0
        }), e.webpackPolyfill = 1;
      }

      return e;
    };
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>';
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    var i = n(105);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e, n) {
    "use strict";

    e.a = function () {
      return !1;
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(4),
          o = "object" == typeof exports && exports && !exports.nodeType && exports,
          r = o && "object" == typeof t && t && !t.nodeType && t,
          s = r && r.exports === o ? i.a.Buffer : void 0,
          a = s ? s.allocUnsafe : void 0;

      e.a = function (t, e) {
        if (e) return t.slice();
        var n = t.length,
            i = a ? a(n) : new t.constructor(n);
        return t.copy(i), i;
      };
    }).call(this, n(12)(t));
  }, function (t) {
    t.exports = JSON.parse('{"a":"12.3.1"}');
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.042 9.367l2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.958 9.367l-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 18v-1.5h14V18zM5.2 10V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.586 14.633l.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z" /></svg>\n';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>\n';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22L2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21l-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562l-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.3 17.37l-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506L13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5L9.375 17H19v1.5H8z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18.68 2.53c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.08c0-.58-.01-.55.6-.55h17.38zM15.77 14.5v-10H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 6.677a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V6.676z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>';
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>';
  }, function (t, e, n) {
    var i = n(51);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-placeholder:before,.ck .ck-placeholder:before{content:attr(data-placeholder);pointer-events:none;cursor:text;color:var(--ck-color-engine-placeholder-text)}";
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var n = e.protocol + "//" + e.host,
          i = n + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var o,
            r = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r) ? t : (o = 0 === r.indexOf("//") ? r : 0 === r.indexOf("/") ? n + r : i + r.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (t, e, n) {
    var i = n(54);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999);--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border:#47a4f5;--ck-color-focus-shadow:rgba(119,186,248,0.5);--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#5c5c5c;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-upload-infinite-background:rgba(0,0,0,0.1);--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}";
  }, function (t, e, n) {
    var i = n(56);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}";
  }, function (t, e, n) {
    var i = n(58);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}";
  }, function (t, e, n) {
    var i = n(60);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}";
  }, function (t, e, n) {
    var i = n(62);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row wrap;align-items:center}.ck.ck-toolbar.ck-toolbar_vertical{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating{flex-wrap:nowrap}.ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar__newline{display:block;width:100%}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar>:last-child{margin-right:0}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar__separator{align-self:stretch;width:1px;margin-top:0;margin-bottom:0;background:var(--ck-color-toolbar-border)}.ck.ck-toolbar__newline{margin:0}";
  }, function (t, e, n) {
    var i = n(64);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}";
  }, function (t, e, n) {
    var i = n(66);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}";
  }, function (t, e, n) {
    var i = n(68);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck-tooltip .ck-tooltip__text{display:inline-block}.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0}.ck.ck-tooltip.ck-tooltip_s{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_n{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{border-style:solid;left:50%}.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s}';
  }, function (t, e, n) {
    var i = n(70);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button .ck-button__label,.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button .ck-button__label,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;border-color:transparent}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}.ck.ck-button.ck-button_with-text .ck-button__icon,a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(-1*var(--ck-spacing-small));margin-right:var(--ck-spacing-small)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}";
  }, function (t, e, n) {
    var i = n(72);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;font-style:italic;border-left:5px solid #ccc}";
  }, function (t, e, n) {
    var i = n(74);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-widget.ck-widget_with-selection-handler{position:relative}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler{visibility:hidden;position:absolute}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler,.ck .ck-widget.ck-widget_with-selection-handler:hover .ck-widget__selection-handler{visibility:visible}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck-editor__editable>.ck-widget.ck-widget_with-selection-handler:first-child,.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handler:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler,.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected:hover .ck-widget__selection-handler{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected:hover .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handler:hover .ck-widget__selection-handler{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected .ck-widget__selection-handler,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected .ck-widget__selection-handler:hover,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover .ck-widget__selection-handler,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover .ck-widget__selection-handler:hover{background:var(--ck-color-widget-blurred-border)}.ck-editor__editable.ck-read-only .ck-widget{--ck-widget-outline-thickness:0}";
  }, function (t, e, n) {
    var i = n(76);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-labeled-input .ck-labeled-input__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-input .ck-labeled-input__status_error{color:var(--ck-color-base-error)}";
  }, function (t, e, n) {
    var i = n(78);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{box-shadow:var(--ck-inner-shadow),0 0;background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition-property:box-shadow,border;transition:.2s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),var(--ck-inner-shadow)}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}";
  }, function (t, e, n) {
    var i = n(80);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-input{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-input{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}.ck.ck-text-alternative-form{padding:var(--ck-spacing-standard)}.ck.ck-text-alternative-form:focus{outline:none}.ck.ck-text-alternative-form>:not(:first-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-text-alternative-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-text-alternative-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-text-alternative-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-text-alternative-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);margin-left:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}.ck.ck-text-alternative-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(82);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}';
  }, function (t, e, n) {
    var i = n(84);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}";
  }, function (t, e, n) {
    var i = n(86);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}";
  }, function (t, e, n) {
    var i = n(88);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .image{clear:both;text-align:center;margin:1em 0}.ck-content .image>img{display:block;margin:0 auto;max-width:100%}";
  }, function (t, e, n) {
    var i = n(90);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .image{position:relative;overflow:hidden}.ck-content .image .ck-progress-bar{position:absolute;top:0;left:0}:root{--ck-image-upload-progress-line-width:30px}.ck-content .image.ck-appear{animation:fadeIn .7s}.ck-content .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
  }, function (t, e, n) {
    var i = n(92);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}';
  }, function (t, e, n) {
    var i = n(94);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}';
  }, function (t, e, n) {
    var i = n(96);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block;will-change:transform}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{transform:translate3d(0,100%,0)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}:root{--ck-dropdown-arrow-size:calc(0.5*var(--ck-icon-size))}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);width:var(--ck-dropdown-arrow-size);margin-left:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}";
  }, function (t, e, n) {
    var i = n(98);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;border:0;padding:calc(0.2*var(--ck-line-height-base)*var(--ck-font-size-base)) calc(0.4*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(1.2*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:hover:not(ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}";
  }, function (t, e, n) {
    var i = n(100);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px}.ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(2*var(--ck-spacing-large))}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto;transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(0.5*var(--ck-border-radius))}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(1.3846153847em)}";
  }, function (t, e, n) {
    var i = n(102);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-toolbar-dropdown .ck-toolbar{flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}";
  }, function (t, e, n) {
    var i = n(104);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}";
  }, function (t, e) {
    t.exports = ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}";
  }, function (t, e, n) {
    var i = n(107);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .image>figcaption{color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}";
  }, function (t, e, n) {
    var i = n(109);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-image-style-spacing:1.5em}.ck-content .image-style-align-center,.ck-content .image-style-align-left,.ck-content .image-style-align-right,.ck-content .image-style-side{max-width:50%}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}";
  }, function (t, e, n) {
    var i = n(111);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}";
  }, function (t, e, n) {
    var i = n(113);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-input{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form{padding:var(--ck-spacing-standard)}.ck.ck-link-form:focus{outline:none}.ck.ck-link-form>:not(:first-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-link-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);margin-left:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}.ck.ck-link-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}.ck.ck-link-form_layout-vertical .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin-left:0}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}";
  }, function (t, e, n) {
    var i = n(115);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions{padding:var(--ck-spacing-standard)}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions:focus{outline:none}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);margin-left:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):first-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(117);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(3*var(--ck-spacing-standard));background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c8,#b900b4,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}';
  }, function (t, e, n) {
    var i = n(119);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-input{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-input{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}.ck.ck-media-form{padding:var(--ck-spacing-standard)}.ck.ck-media-form:focus{outline:none}.ck.ck-media-form>:not(:first-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-media-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-media-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-media-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-media-form .ck-labeled-input .ck-labeled-input__error{white-space:normal}.ck.ck-media-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);margin-left:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}.ck.ck-media-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(121);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}";
  }, function (t, e, n) {
    var i = n(123);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-color-table-focused-cell-background:#f5fafe}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}";
  }, function (t, e, n) {
    var i = n(125);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px;--ck-insert-table-dropdown-box-border-color:#bfbfbf;--ck-insert-table-dropdown-box-border-active-color:#53a0e4;--ck-insert-table-dropdown-box-active-background:#c7e5ff}.ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-insert-table-dropdown-box-border-color);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-insert-table-dropdown-box-border-active-color);background:var(--ck-insert-table-dropdown-box-active-background)}";
  }, function (t, e, n) {
    var i = n(127);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      singleton: !0,
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(2)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .table{margin:1em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border-color:#d9d9d9}.ck-content .table table th{font-weight:700;background:#fafafa}";
  }, function (t, e, n) {
    "use strict";

    var _marked =
    /*#__PURE__*/
    _regeneratorRuntime.mark($a),
        _marked2 =
    /*#__PURE__*/
    _regeneratorRuntime.mark(Ga);

    n.r(e);
    var i = n(4),
        o = i.a.Symbol,
        r = Object.prototype,
        s = r.hasOwnProperty,
        a = r.toString,
        c = o ? o.toStringTag : void 0;

    var l = function l(t) {
      var e = s.call(t, c),
          n = t[c];

      try {
        t[c] = void 0;
        var i = !0;
      } catch (t) {}

      var o = a.call(t);
      return i && (e ? t[c] = n : delete t[c]), o;
    },
        d = Object.prototype.toString;

    var u = function u(t) {
      return d.call(t);
    },
        h = "[object Null]",
        f = "[object Undefined]",
        m = o ? o.toStringTag : void 0;

    var p = function p(t) {
      return null == t ? void 0 === t ? f : h : m && m in Object(t) ? l(t) : u(t);
    };

    var g = function g(t, e) {
      return function (n) {
        return t(e(n));
      };
    },
        b = g(Object.getPrototypeOf, Object);

    var w = function w(t) {
      return null != t && "object" == typeof t;
    },
        _ = "[object Object]",
        k = Function.prototype,
        v = Object.prototype,
        y = k.toString,
        x = v.hasOwnProperty,
        A = y.call(Object);

    var C = function C(t) {
      if (!w(t) || p(t) != _) return !1;
      var e = b(t);
      if (null === e) return !0;
      var n = x.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && y.call(n) == A;
    };

    var T = function T() {
      this.__data__ = [], this.size = 0;
    };

    var P = function P(t, e) {
      return t === e || t != t && e != e;
    };

    var M = function M(t, e) {
      for (var n = t.length; n--;) {
        if (P(t[n][0], e)) return n;
      }

      return -1;
    },
        S = Array.prototype.splice;

    var E = function E(t) {
      var e = this.__data__,
          n = M(e, t);
      return !(n < 0 || (n == e.length - 1 ? e.pop() : S.call(e, n, 1), --this.size, 0));
    };

    var I = function I(t) {
      var e = this.__data__,
          n = M(e, t);
      return n < 0 ? void 0 : e[n][1];
    };

    var N = function N(t) {
      return M(this.__data__, t) > -1;
    };

    var O = function O(t, e) {
      var n = this.__data__,
          i = M(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    };

    function R(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    R.prototype.clear = T, R.prototype.delete = E, R.prototype.get = I, R.prototype.has = N, R.prototype.set = O;
    var D = R;

    var L = function L() {
      this.__data__ = new D(), this.size = 0;
    };

    var j = function j(t) {
      var e = this.__data__,
          n = e.delete(t);
      return this.size = e.size, n;
    };

    var V = function V(t) {
      return this.__data__.get(t);
    };

    var B = function B(t) {
      return this.__data__.has(t);
    };

    var z = function z(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    },
        F = "[object AsyncFunction]",
        U = "[object Function]",
        H = "[object GeneratorFunction]",
        q = "[object Proxy]";

    var W = function W(t) {
      if (!z(t)) return !1;
      var e = p(t);
      return e == U || e == H || e == F || e == q;
    },
        Y = i.a["__core-js_shared__"],
        $ = function () {
      var t = /[^.]+$/.exec(Y && Y.keys && Y.keys.IE_PROTO || "");
      return t ? "Symbol(src)_1." + t : "";
    }();

    var G = function G(t) {
      return !!$ && $ in t;
    },
        Q = Function.prototype.toString;

    var J = function J(t) {
      if (null != t) {
        try {
          return Q.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    },
        K = /^\[object .+?Constructor\]$/,
        Z = Function.prototype,
        X = Object.prototype,
        tt = Z.toString,
        et = X.hasOwnProperty,
        nt = RegExp("^" + tt.call(et).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    var it = function it(t) {
      return !(!z(t) || G(t)) && (W(t) ? nt : K).test(J(t));
    };

    var ot = function ot(t, e) {
      return null == t ? void 0 : t[e];
    };

    var rt = function rt(t, e) {
      var n = ot(t, e);
      return it(n) ? n : void 0;
    },
        st = rt(i.a, "Map"),
        at = rt(Object, "create");

    var ct = function ct() {
      this.__data__ = at ? at(null) : {}, this.size = 0;
    };

    var lt = function lt(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    },
        dt = "__lodash_hash_undefined__",
        ut = Object.prototype.hasOwnProperty;

    var ht = function ht(t) {
      var e = this.__data__;

      if (at) {
        var n = e[t];
        return n === dt ? void 0 : n;
      }

      return ut.call(e, t) ? e[t] : void 0;
    },
        ft = Object.prototype.hasOwnProperty;

    var mt = function mt(t) {
      var e = this.__data__;
      return at ? void 0 !== e[t] : ft.call(e, t);
    },
        pt = "__lodash_hash_undefined__";

    var gt = function gt(t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = at && void 0 === e ? pt : e, this;
    };

    function bt(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    bt.prototype.clear = ct, bt.prototype.delete = lt, bt.prototype.get = ht, bt.prototype.has = mt, bt.prototype.set = gt;
    var wt = bt;

    var _t = function _t() {
      this.size = 0, this.__data__ = {
        hash: new wt(),
        map: new (st || D)(),
        string: new wt()
      };
    };

    var kt = function kt(t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };

    var vt = function vt(t, e) {
      var n = t.__data__;
      return kt(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };

    var yt = function yt(t) {
      var e = vt(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    };

    var xt = function xt(t) {
      return vt(this, t).get(t);
    };

    var At = function At(t) {
      return vt(this, t).has(t);
    };

    var Ct = function Ct(t, e) {
      var n = vt(this, t),
          i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    };

    function Tt(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    Tt.prototype.clear = _t, Tt.prototype.delete = yt, Tt.prototype.get = xt, Tt.prototype.has = At, Tt.prototype.set = Ct;
    var Pt = Tt,
        Mt = 200;

    var St = function St(t, e) {
      var n = this.__data__;

      if (n instanceof D) {
        var i = n.__data__;
        if (!st || i.length < Mt - 1) return i.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new Pt(i);
      }

      return n.set(t, e), this.size = n.size, this;
    };

    function Et(t) {
      var e = this.__data__ = new D(t);
      this.size = e.size;
    }

    Et.prototype.clear = L, Et.prototype.delete = j, Et.prototype.get = V, Et.prototype.has = B, Et.prototype.set = St;
    var It = Et;

    var Nt = function Nt(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i && !1 !== e(t[n], n, t);) {
        ;
      }

      return t;
    },
        Ot = function () {
      try {
        var t = rt(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();

    var Rt = function Rt(t, e, n) {
      "__proto__" == e && Ot ? Ot(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    },
        Dt = Object.prototype.hasOwnProperty;

    var Lt = function Lt(t, e, n) {
      var i = t[e];
      Dt.call(t, e) && P(i, n) && (void 0 !== n || e in t) || Rt(t, e, n);
    };

    var jt = function jt(t, e, n, i) {
      var o = !n;
      n || (n = {});

      for (var r = -1, s = e.length; ++r < s;) {
        var a = e[r],
            c = i ? i(n[a], t[a], a, n, t) : void 0;
        void 0 === c && (c = t[a]), o ? Rt(n, a, c) : Lt(n, a, c);
      }

      return n;
    };

    var Vt = function Vt(t, e) {
      for (var n = -1, i = Array(t); ++n < t;) {
        i[n] = e(n);
      }

      return i;
    },
        Bt = "[object Arguments]";

    var zt = function zt(t) {
      return w(t) && p(t) == Bt;
    },
        Ft = Object.prototype,
        Ut = Ft.hasOwnProperty,
        Ht = Ft.propertyIsEnumerable,
        qt = zt(function () {
      return arguments;
    }()) ? zt : function (t) {
      return w(t) && Ut.call(t, "callee") && !Ht.call(t, "callee");
    },
        Wt = Array.isArray,
        Yt = n(6),
        $t = 9007199254740991,
        Gt = /^(?:0|[1-9]\d*)$/;

    var Qt = function Qt(t, e) {
      var n = typeof t;
      return !!(e = null == e ? $t : e) && ("number" == n || "symbol" != n && Gt.test(t)) && t > -1 && t % 1 == 0 && t < e;
    },
        Jt = 9007199254740991;

    var Kt = function Kt(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= Jt;
    },
        Zt = {};

    Zt["[object Float32Array]"] = Zt["[object Float64Array]"] = Zt["[object Int8Array]"] = Zt["[object Int16Array]"] = Zt["[object Int32Array]"] = Zt["[object Uint8Array]"] = Zt["[object Uint8ClampedArray]"] = Zt["[object Uint16Array]"] = Zt["[object Uint32Array]"] = !0, Zt["[object Arguments]"] = Zt["[object Array]"] = Zt["[object ArrayBuffer]"] = Zt["[object Boolean]"] = Zt["[object DataView]"] = Zt["[object Date]"] = Zt["[object Error]"] = Zt["[object Function]"] = Zt["[object Map]"] = Zt["[object Number]"] = Zt["[object Object]"] = Zt["[object RegExp]"] = Zt["[object Set]"] = Zt["[object String]"] = Zt["[object WeakMap]"] = !1;

    var Xt = function Xt(t) {
      return w(t) && Kt(t.length) && !!Zt[p(t)];
    };

    var te = function te(t) {
      return function (e) {
        return t(e);
      };
    },
        ee = n(5),
        ne = ee.a && ee.a.isTypedArray,
        ie = ne ? te(ne) : Xt,
        oe = Object.prototype.hasOwnProperty;

    var re = function re(t, e) {
      var n = Wt(t),
          i = !n && qt(t),
          o = !n && !i && Object(Yt.a)(t),
          r = !n && !i && !o && ie(t),
          s = n || i || o || r,
          a = s ? Vt(t.length, String) : [],
          c = a.length;

      for (var l in t) {
        !e && !oe.call(t, l) || s && ("length" == l || o && ("offset" == l || "parent" == l) || r && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || Qt(l, c)) || a.push(l);
      }

      return a;
    },
        se = Object.prototype;

    var ae = function ae(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || se);
    },
        ce = g(Object.keys, Object),
        le = Object.prototype.hasOwnProperty;

    var de = function de(t) {
      if (!ae(t)) return ce(t);
      var e = [];

      for (var n in Object(t)) {
        le.call(t, n) && "constructor" != n && e.push(n);
      }

      return e;
    };

    var ue = function ue(t) {
      return null != t && Kt(t.length) && !W(t);
    };

    var he = function he(t) {
      return ue(t) ? re(t) : de(t);
    };

    var fe = function fe(t, e) {
      return t && jt(e, he(e), t);
    };

    var me = function me(t) {
      var e = [];
      if (null != t) for (var n in Object(t)) {
        e.push(n);
      }
      return e;
    },
        pe = Object.prototype.hasOwnProperty;

    var ge = function ge(t) {
      if (!z(t)) return me(t);
      var e = ae(t),
          n = [];

      for (var i in t) {
        ("constructor" != i || !e && pe.call(t, i)) && n.push(i);
      }

      return n;
    };

    var be = function be(t) {
      return ue(t) ? re(t, !0) : ge(t);
    };

    var we = function we(t, e) {
      return t && jt(e, be(e), t);
    },
        _e = n(20);

    var ke = function ke(t, e) {
      var n = -1,
          i = t.length;

      for (e || (e = Array(i)); ++n < i;) {
        e[n] = t[n];
      }

      return e;
    };

    var ve = function ve(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, o = 0, r = []; ++n < i;) {
        var s = t[n];
        e(s, n, t) && (r[o++] = s);
      }

      return r;
    };

    var ye = function ye() {
      return [];
    },
        xe = Object.prototype.propertyIsEnumerable,
        Ae = Object.getOwnPropertySymbols,
        Ce = Ae ? function (t) {
      return null == t ? [] : (t = Object(t), ve(Ae(t), function (e) {
        return xe.call(t, e);
      }));
    } : ye;

    var Te = function Te(t, e) {
      return jt(t, Ce(t), e);
    };

    var Pe = function Pe(t, e) {
      for (var n = -1, i = e.length, o = t.length; ++n < i;) {
        t[o + n] = e[n];
      }

      return t;
    },
        Me = Object.getOwnPropertySymbols ? function (t) {
      for (var e = []; t;) {
        Pe(e, Ce(t)), t = b(t);
      }

      return e;
    } : ye;

    var Se = function Se(t, e) {
      return jt(t, Me(t), e);
    };

    var Ee = function Ee(t, e, n) {
      var i = e(t);
      return Wt(t) ? i : Pe(i, n(t));
    };

    var Ie = function Ie(t) {
      return Ee(t, he, Ce);
    };

    var Ne = function Ne(t) {
      return Ee(t, be, Me);
    },
        Oe = rt(i.a, "DataView"),
        Re = rt(i.a, "Promise"),
        De = rt(i.a, "Set"),
        Le = rt(i.a, "WeakMap"),
        je = J(Oe),
        Ve = J(st),
        Be = J(Re),
        ze = J(De),
        Fe = J(Le),
        Ue = p;

    (Oe && "[object DataView]" != Ue(new Oe(new ArrayBuffer(1))) || st && "[object Map]" != Ue(new st()) || Re && "[object Promise]" != Ue(Re.resolve()) || De && "[object Set]" != Ue(new De()) || Le && "[object WeakMap]" != Ue(new Le())) && (Ue = function Ue(t) {
      var e = p(t),
          n = "[object Object]" == e ? t.constructor : void 0,
          i = n ? J(n) : "";
      if (i) switch (i) {
        case je:
          return "[object DataView]";

        case Ve:
          return "[object Map]";

        case Be:
          return "[object Promise]";

        case ze:
          return "[object Set]";

        case Fe:
          return "[object WeakMap]";
      }
      return e;
    });
    var He = Ue,
        qe = Object.prototype.hasOwnProperty;

    var We = function We(t) {
      var e = t.length,
          n = new t.constructor(e);
      return e && "string" == typeof t[0] && qe.call(t, "index") && (n.index = t.index, n.input = t.input), n;
    },
        Ye = i.a.Uint8Array;

    var $e = function $e(t) {
      var e = new t.constructor(t.byteLength);
      return new Ye(e).set(new Ye(t)), e;
    };

    var Ge = function Ge(t, e) {
      var n = e ? $e(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.byteLength);
    },
        Qe = /\w*$/;

    var Je = function Je(t) {
      var e = new t.constructor(t.source, Qe.exec(t));
      return e.lastIndex = t.lastIndex, e;
    },
        Ke = o ? o.prototype : void 0,
        Ze = Ke ? Ke.valueOf : void 0;

    var Xe = function Xe(t) {
      return Ze ? Object(Ze.call(t)) : {};
    };

    var tn = function tn(t, e) {
      var n = e ? $e(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    },
        en = "[object Boolean]",
        nn = "[object Date]",
        on = "[object Map]",
        rn = "[object Number]",
        sn = "[object RegExp]",
        an = "[object Set]",
        cn = "[object String]",
        ln = "[object Symbol]",
        dn = "[object ArrayBuffer]",
        un = "[object DataView]",
        hn = "[object Float32Array]",
        fn = "[object Float64Array]",
        mn = "[object Int8Array]",
        pn = "[object Int16Array]",
        gn = "[object Int32Array]",
        bn = "[object Uint8Array]",
        wn = "[object Uint8ClampedArray]",
        _n = "[object Uint16Array]",
        kn = "[object Uint32Array]";

    var vn = function vn(t, e, n) {
      var i = t.constructor;

      switch (e) {
        case dn:
          return $e(t);

        case en:
        case nn:
          return new i(+t);

        case un:
          return Ge(t, n);

        case hn:
        case fn:
        case mn:
        case pn:
        case gn:
        case bn:
        case wn:
        case _n:
        case kn:
          return tn(t, n);

        case on:
          return new i();

        case rn:
        case cn:
          return new i(t);

        case sn:
          return Je(t);

        case an:
          return new i();

        case ln:
          return Xe(t);
      }
    },
        yn = Object.create,
        xn = function () {
      function t() {}

      return function (e) {
        if (!z(e)) return {};
        if (yn) return yn(e);
        t.prototype = e;
        var n = new t();
        return t.prototype = void 0, n;
      };
    }();

    var An = function An(t) {
      return "function" != typeof t.constructor || ae(t) ? {} : xn(b(t));
    },
        Cn = "[object Map]";

    var Tn = function Tn(t) {
      return w(t) && He(t) == Cn;
    },
        Pn = ee.a && ee.a.isMap,
        Mn = Pn ? te(Pn) : Tn,
        Sn = "[object Set]";

    var En = function En(t) {
      return w(t) && He(t) == Sn;
    },
        In = ee.a && ee.a.isSet,
        Nn = In ? te(In) : En,
        On = 1,
        Rn = 2,
        Dn = 4,
        Ln = "[object Arguments]",
        jn = "[object Function]",
        Vn = "[object GeneratorFunction]",
        Bn = "[object Object]",
        zn = {};

    zn[Ln] = zn["[object Array]"] = zn["[object ArrayBuffer]"] = zn["[object DataView]"] = zn["[object Boolean]"] = zn["[object Date]"] = zn["[object Float32Array]"] = zn["[object Float64Array]"] = zn["[object Int8Array]"] = zn["[object Int16Array]"] = zn["[object Int32Array]"] = zn["[object Map]"] = zn["[object Number]"] = zn[Bn] = zn["[object RegExp]"] = zn["[object Set]"] = zn["[object String]"] = zn["[object Symbol]"] = zn["[object Uint8Array]"] = zn["[object Uint8ClampedArray]"] = zn["[object Uint16Array]"] = zn["[object Uint32Array]"] = !0, zn["[object Error]"] = zn[jn] = zn["[object WeakMap]"] = !1;

    var Fn = function t(e, n, i, o, r, s) {
      var a,
          c = n & On,
          l = n & Rn,
          d = n & Dn;
      if (i && (a = r ? i(e, o, r, s) : i(e)), void 0 !== a) return a;
      if (!z(e)) return e;
      var u = Wt(e);

      if (u) {
        if (a = We(e), !c) return ke(e, a);
      } else {
        var h = He(e),
            f = h == jn || h == Vn;
        if (Object(Yt.a)(e)) return Object(_e.a)(e, c);

        if (h == Bn || h == Ln || f && !r) {
          if (a = l || f ? {} : An(e), !c) return l ? Se(e, we(a, e)) : Te(e, fe(a, e));
        } else {
          if (!zn[h]) return r ? e : {};
          a = vn(e, h, c);
        }
      }

      s || (s = new It());
      var m = s.get(e);
      if (m) return m;
      s.set(e, a), Nn(e) ? e.forEach(function (o) {
        a.add(t(o, n, i, o, e, s));
      }) : Mn(e) && e.forEach(function (o, r) {
        a.set(r, t(o, n, i, r, e, s));
      });
      var p = d ? l ? Ne : Ie : l ? keysIn : he,
          g = u ? void 0 : p(e);
      return Nt(g || e, function (o, r) {
        g && (o = e[r = o]), Lt(a, r, t(o, n, i, r, e, s));
      }), a;
    },
        Un = 1,
        Hn = 4;

    var qn = function qn(t, e) {
      return Fn(t, Un | Hn, e = "function" == typeof e ? e : void 0);
    };

    var Wn = function Wn(t) {
      return w(t) && 1 === t.nodeType && !C(t);
    };

    var Yn =
    /*#__PURE__*/
    function () {
      function Yn(t, e) {
        _classCallCheck(this, Yn);

        this._config = {}, e && this.define(e), t && this._setObjectToTarget(this._config, t);
      }

      _createClass(Yn, [{
        key: "set",
        value: function set(t, e) {
          this._setToTarget(this._config, t, e);
        }
      }, {
        key: "define",
        value: function define(t, e) {
          this._setToTarget(this._config, t, e, !0);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._getFromSource(this._config, t);
        }
      }, {
        key: "_setToTarget",
        value: function _setToTarget(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          if (C(e)) return void this._setObjectToTarget(t, e, i);
          var o = e.split(".");
          e = o.pop();
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _e2 = _step.value;
              C(t[_e2]) || (t[_e2] = {}), t = t[_e2];
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (C(n)) return C(t[e]) || (t[e] = {}), t = t[e], void this._setObjectToTarget(t, n, i);
          i && void 0 !== t[e] || (t[e] = n);
        }
      }, {
        key: "_getFromSource",
        value: function _getFromSource(t, e) {
          var n = e.split(".");
          e = n.pop();
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = n[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _e3 = _step2.value;

              if (!C(t[_e3])) {
                t = null;
                break;
              }

              t = t[_e3];
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          return t ? function (t) {
            return qn(t, $n);
          }(t[e]) : void 0;
        }
      }, {
        key: "_setObjectToTarget",
        value: function _setObjectToTarget(t, e, n) {
          var _this2 = this;

          Object.keys(e).forEach(function (i) {
            _this2._setToTarget(t, i, e[i], n);
          });
        }
      }]);

      return Yn;
    }();

    function $n(t) {
      return Wn(t) ? t : void 0;
    }

    var Gn = n(0);

    var Qn = function Qn() {
      return function t() {
        t.called = !0;
      };
    };

    var Jn = function Jn(t, e) {
      _classCallCheck(this, Jn);

      this.source = t, this.name = e, this.path = [], this.stop = Qn(), this.off = Qn();
    };

    function Kn() {
      var t = "e";

      for (var _e4 = 0; _e4 < 8; _e4++) {
        t += Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
      }

      return t;
    }

    var Zn = {
      get: function get(t) {
        return "number" != typeof t ? this[t] || this.normal : t;
      },
      highest: 1e5,
      high: 1e3,
      normal: 0,
      low: -1e3,
      lowest: -1e5
    };
    n(9);
    var Xn = Symbol("listeningTo"),
        ti = Symbol("emitterId");
    var ei = {
      on: function on(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.listenTo(this, t, e, n);
      },
      once: function once(t, e, n) {
        var i = !1;
        this.listenTo(this, t, function (t) {
          for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            n[_key - 1] = arguments[_key];
          }

          i || (i = !0, t.off(), e.call.apply(e, [this, t].concat(n)));
        }, n);
      },
      off: function off(t, e) {
        this.stopListening(this, t, e);
      },
      listenTo: function listenTo(t, e, n) {
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var o, r;
        this[Xn] || (this[Xn] = {});
        var s = this[Xn];
        ii(t) || ni(t);
        var a = ii(t);
        (o = s[a]) || (o = s[a] = {
          emitter: t,
          callbacks: {}
        }), (r = o.callbacks[e]) || (r = o.callbacks[e] = []), r.push(n), function (t, e) {
          var n = oi(t);
          if (n[e]) return;
          var i = e,
              o = null;
          var r = [];

          for (; "" !== i && !n[i];) {
            n[i] = {
              callbacks: [],
              childEvents: []
            }, r.push(n[i]), o && n[i].childEvents.push(o), o = i, i = i.substr(0, i.lastIndexOf(":"));
          }

          if ("" !== i) {
            for (var _i2 = 0, _r2 = r; _i2 < _r2.length; _i2++) {
              var _t2 = _r2[_i2];
              _t2.callbacks = n[i].callbacks.slice();
            }

            n[i].childEvents.push(o);
          }
        }(t, e);
        var c = ri(t, e),
            l = Zn.get(i.priority),
            d = {
          callback: n,
          priority: l
        };
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = c[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _t3 = _step3.value;

            var _e5 = !1;

            for (var _n2 = 0; _n2 < _t3.length; _n2++) {
              if (_t3[_n2].priority < l) {
                _t3.splice(_n2, 0, d), _e5 = !0;
                break;
              }
            }

            _e5 || _t3.push(d);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      },
      stopListening: function stopListening(t, e, n) {
        var i = this[Xn];
        var o = t && ii(t);
        var r = i && o && i[o],
            s = r && e && r.callbacks[e];
        if (!(!i || t && !r || e && !s)) if (n) ai(t, e, n);else if (s) {
          for (; n = s.pop();) {
            ai(t, e, n);
          }

          delete r.callbacks[e];
        } else if (r) {
          for (e in r.callbacks) {
            this.stopListening(t, e);
          }

          delete i[o];
        } else {
          for (o in i) {
            this.stopListening(i[o].emitter);
          }

          delete this[Xn];
        }
      },
      fire: function fire(t) {
        var n = t instanceof Jn ? t : new Jn(this, t),
            i = n.name;

        var o = function t(e, n) {
          var i;
          if (!e._events || !(i = e._events[n]) || !i.callbacks.length) return n.indexOf(":") > -1 ? t(e, n.substr(0, n.lastIndexOf(":"))) : null;
          return i.callbacks;
        }(this, i);

        for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          e[_key2 - 1] = arguments[_key2];
        }

        if (n.path.push(this), o) {
          var _t4 = [n].concat(e);

          o = Array.from(o);

          for (var _e6 = 0; _e6 < o.length && (o[_e6].callback.apply(this, _t4), n.off.called && (delete n.off.called, ai(this, i, o[_e6].callback)), !n.stop.called); _e6++) {
            ;
          }
        }

        if (this._delegations) {
          var _t5 = this._delegations.get(i),
              _o2 = this._delegations.get("*");

          _t5 && si(_t5, n, e), _o2 && si(_o2, n, e);
        }

        return n.return;
      },
      delegate: function delegate() {
        var _this3 = this;

        for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          t[_key3] = arguments[_key3];
        }

        return {
          to: function to(e, n) {
            _this3._delegations || (_this3._delegations = new Map()), t.forEach(function (t) {
              var i = _this3._delegations.get(t);

              i ? i.set(e, n) : _this3._delegations.set(t, new Map([[e, n]]));
            });
          }
        };
      },
      stopDelegating: function stopDelegating(t, e) {
        if (this._delegations) if (t) {
          if (e) {
            var _n3 = this._delegations.get(t);

            _n3 && _n3.delete(e);
          } else this._delegations.delete(t);
        } else this._delegations.clear();
      }
    };

    function ni(t, e) {
      t[ti] || (t[ti] = e || Kn());
    }

    function ii(t) {
      return t[ti];
    }

    function oi(t) {
      return t._events || Object.defineProperty(t, "_events", {
        value: {}
      }), t._events;
    }

    function ri(t, e) {
      var n = oi(t)[e];
      if (!n) return [];
      var i = [n.callbacks];

      for (var _e7 = 0; _e7 < n.childEvents.length; _e7++) {
        var _o3 = ri(t, n.childEvents[_e7]);

        i = i.concat(_o3);
      }

      return i;
    }

    function si(t, e, n) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = t[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref3 = _step4.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var _i3 = _ref2[0];
          var _o4 = _ref2[1];
          _o4 ? "function" == typeof _o4 && (_o4 = _o4(e.name)) : _o4 = e.name;

          var _t6 = new Jn(e.source, _o4);

          _t6.path = _toConsumableArray(e.path), _i3.fire.apply(_i3, [_t6].concat(_toConsumableArray(n)));
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }

    function ai(t, e, n) {
      var i = ri(t, e);
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = i[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _t7 = _step5.value;

          for (var _e8 = 0; _e8 < _t7.length; _e8++) {
            _t7[_e8].callback == n && (_t7.splice(_e8, 1), _e8--);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }

    function ci(t) {
      for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        e[_key4 - 1] = arguments[_key4];
      }

      e.forEach(function (e) {
        Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e)).forEach(function (n) {
          if (n in t.prototype) return;
          var i = Object.getOwnPropertyDescriptor(e, n);
          i.enumerable = !1, Object.defineProperty(t.prototype, n, i);
        });
      });
    }

    function li(t, e) {
      var n = Math.min(t.length, e.length);

      for (var _i4 = 0; _i4 < n; _i4++) {
        if (t[_i4] != e[_i4]) return _i4;
      }

      return t.length == e.length ? "same" : t.length < e.length ? "prefix" : "extension";
    }

    var di = 4;

    var ui = function ui(t) {
      return Fn(t, di);
    };

    var hi =
    /*#__PURE__*/
    function () {
      function hi() {
        _classCallCheck(this, hi);

        this.parent = null;
      }

      _createClass(hi, [{
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;

          for (; e.parent;) {
            t.unshift(e.index), e = e.parent;
          }

          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e),
              i = t.getAncestors(e);
          var o = 0;

          for (; n[o] == i[o] && n[o];) {
            o++;
          }

          return 0 === o ? null : n[o - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) return !1;
          if (this.root !== t.root) return !1;
          var e = this.getPath(),
              n = t.getPath(),
              i = li(e, n);

          switch (i) {
            case "prefix":
              return !0;

            case "extension":
              return !1;

            default:
              return e[i] < n[i];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e), this.parent && this.parent._fireChange(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = ui(this);
          return delete t.parent, t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "node" == t;
        }
      }, {
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (-1 == (t = this.parent.getChildIndex(this))) throw new Gn.b("view-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;

          for (; t.parent;) {
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "document",
        get: function get() {
          return this.parent instanceof hi ? this.parent.document : null;
        }
      }]);

      return hi;
    }();

    ci(hi, ei);

    var fi =
    /*#__PURE__*/
    function (_hi) {
      _inherits(fi, _hi);

      function fi(t) {
        var _this4;

        _classCallCheck(this, fi);

        _this4 = _possibleConstructorReturn(this, _getPrototypeOf(fi).call(this)), _this4._textData = t;
        return _this4;
      }

      _createClass(fi, [{
        key: "is",
        value: function is(t) {
          return "text" == t || _get(_getPrototypeOf(fi.prototype), "is", this).call(this, t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return t instanceof fi && (this === t || this.data === t.data);
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new fi(this.data);
        }
      }, {
        key: "data",
        get: function get() {
          return this._textData;
        }
      }, {
        key: "_data",
        get: function get() {
          return this.data;
        },
        set: function set(t) {
          this._fireChange("text", this), this._textData = t;
        }
      }]);

      return fi;
    }(hi);

    var mi =
    /*#__PURE__*/
    function () {
      function mi(t, e, n) {
        _classCallCheck(this, mi);

        if (this.textNode = t, e < 0 || e > t.data.length) throw new Gn.b("view-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.", this);
        if (n < 0 || e + n > t.data.length) throw new Gn.b("view-textproxy-wrong-length: Given length value is incorrect.", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }

      _createClass(mi, [{
        key: "is",
        value: function is(t) {
          return "textProxy" == t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this.textNode : this.parent;

          for (; null !== n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.data.length !== this.textNode.data.length;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }]);

      return mi;
    }();

    function pi(t) {
      var e = new Map();

      for (var _n4 in t) {
        e.set(_n4, t[_n4]);
      }

      return e;
    }

    function gi(t) {
      return !(!t || !t[Symbol.iterator]);
    }

    var bi =
    /*#__PURE__*/
    function () {
      function bi() {
        _classCallCheck(this, bi);

        this._patterns = [], this.add.apply(this, arguments);
      }

      _createClass(bi, [{
        key: "add",
        value: function add() {
          for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t[_key5] = arguments[_key5];
          }

          for (var _i5 = 0, _t8 = t; _i5 < _t8.length; _i5++) {
            var _e9 = _t8[_i5];
            ("string" == typeof _e9 || _e9 instanceof RegExp) && (_e9 = {
              name: _e9
            }), _e9.classes && ("string" == typeof _e9.classes || _e9.classes instanceof RegExp) && (_e9.classes = [_e9.classes]), this._patterns.push(_e9);
          }
        }
      }, {
        key: "match",
        value: function match() {
          for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            t[_key6] = arguments[_key6];
          }

          for (var _i6 = 0, _t9 = t; _i6 < _t9.length; _i6++) {
            var _e10 = _t9[_i6];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = this._patterns[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _t10 = _step6.value;

                var _n5 = wi(_e10, _t10);

                if (_n5) return {
                  element: _e10,
                  pattern: _t10,
                  match: _n5
                };
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }

          return null;
        }
      }, {
        key: "matchAll",
        value: function matchAll() {
          var e = [];

          for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            t[_key7] = arguments[_key7];
          }

          for (var _i7 = 0, _t11 = t; _i7 < _t11.length; _i7++) {
            var _n6 = _t11[_i7];
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = this._patterns[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var _t12 = _step7.value;

                var _i8 = wi(_n6, _t12);

                _i8 && e.push({
                  element: _n6,
                  pattern: _t12,
                  match: _i8
                });
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          }

          return e.length > 0 ? e : null;
        }
      }, {
        key: "getElementName",
        value: function getElementName() {
          if (1 !== this._patterns.length) return null;
          var t = this._patterns[0],
              e = t.name;
          return "function" == typeof t || !e || e instanceof RegExp ? null : e;
        }
      }]);

      return bi;
    }();

    function wi(t, e) {
      if ("function" == typeof e) return e(t);
      var n = {};
      return e.name && (n.name = function (t, e) {
        if (t instanceof RegExp) return t.test(e);
        return t === e;
      }(e.name, t.name), !n.name) ? null : e.attributes && (n.attributes = function (t, e) {
        var n = [];

        for (var _i9 in t) {
          var _o5 = t[_i9];
          if (!e.hasAttribute(_i9)) return null;
          {
            var _t13 = e.getAttribute(_i9);

            if (!0 === _o5) n.push(_i9);else if (_o5 instanceof RegExp) {
              if (!_o5.test(_t13)) return null;
              n.push(_i9);
            } else {
              if (_t13 !== _o5) return null;
              n.push(_i9);
            }
          }
        }

        return n;
      }(e.attributes, t), !n.attributes) ? null : !(e.classes && (n.classes = function (t, e) {
        var n = [];
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = t[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var _i10 = _step8.value;

            if (_i10 instanceof RegExp) {
              var _t14 = e.getClassNames();

              var _iteratorNormalCompletion9 = true;
              var _didIteratorError9 = false;
              var _iteratorError9 = undefined;

              try {
                for (var _iterator9 = _t14[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                  var _e11 = _step9.value;
                  _i10.test(_e11) && n.push(_e11);
                }
              } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                    _iterator9.return();
                  }
                } finally {
                  if (_didIteratorError9) {
                    throw _iteratorError9;
                  }
                }
              }

              if (0 === n.length) return null;
            } else {
              if (!e.hasClass(_i10)) return null;
              n.push(_i10);
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }

        return n;
      }(e.classes, t), !n.classes)) && !(e.styles && (n.styles = function (t, e) {
        var n = [];

        for (var _i11 in t) {
          var _o6 = t[_i11];
          if (!e.hasStyle(_i11)) return null;
          {
            var _t15 = e.getStyle(_i11);

            if (_o6 instanceof RegExp) {
              if (!_o6.test(_t15)) return null;
              n.push(_i11);
            } else {
              if (_t15 !== _o6) return null;
              n.push(_i11);
            }
          }
        }

        return n;
      }(e.styles, t), !n.styles)) && n;
    }

    var _i =
    /*#__PURE__*/
    function (_hi2) {
      _inherits(_i, _hi2);

      function _i(t, e, n) {
        var _this5;

        _classCallCheck(this, _i);

        if (_this5 = _possibleConstructorReturn(this, _getPrototypeOf(_i).call(this)), _this5.name = t, _this5._attrs = function (t) {
          t = C(t) ? pi(t) : new Map(t);
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = t[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var _ref6 = _step10.value;

              var _ref5 = _slicedToArray(_ref6, 2);

              var _e12 = _ref5[0];
              var _n7 = _ref5[1];
              null === _n7 ? t.delete(_e12) : "string" != typeof _n7 && t.set(_e12, String(_n7));
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }

          return t;
        }(e), _this5._children = [], n && _this5._insertChild(0, n), _this5._classes = new Set(), _this5._attrs.has("class")) {
          var _t16 = _this5._attrs.get("class");

          vi(_this5._classes, _t16), _this5._attrs.delete("class");
        }

        _this5._styles = new Map(), _this5._attrs.has("style") && (ki(_this5._styles, _this5._attrs.get("style")), _this5._attrs.delete("style")), _this5._customProperties = new Map();
        return _possibleConstructorReturn(_this5);
      }

      _createClass(_i, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? "element" == t && e == this.name : "element" == t || t == this.name || _get(_getPrototypeOf(_i.prototype), "is", this).call(this, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getAttributeKeys",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = this._classes.size > 0;

                  if (!_context.t0) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return "class";

                case 4:
                  _context.t1 = this._styles.size > 0;

                  if (!_context.t1) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 8;
                  return "style";

                case 8:
                  return _context.delegateYield(this._attrs.keys(), "t2", 9);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, getAttributeKeys, this);
        })
      }, {
        key: "getAttributes",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributes() {
          return _regeneratorRuntime.wrap(function getAttributes$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.delegateYield(this._attrs.entries(), "t0", 1);

                case 1:
                  _context2.t1 = this._classes.size > 0;

                  if (!_context2.t1) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return ["class", this.getAttribute("class")];

                case 5:
                  _context2.t2 = this._styles.size > 0;

                  if (!_context2.t2) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 9;
                  return ["style", this.getAttribute("style")];

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, getAttributes, this);
        })
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          if ("class" == t) return this._classes.size > 0 ? _toConsumableArray(this._classes).join(" ") : void 0;
          if ("style" != t) return this._attrs.get(t);

          if (this._styles.size > 0) {
            var _t17 = "";
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
              for (var _iterator11 = this._styles[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var _ref9 = _step11.value;

                var _ref8 = _slicedToArray(_ref9, 2);

                var _e13 = _ref8[0];
                var _n8 = _ref8[1];
                _t17 += "".concat(_e13, ":").concat(_n8, ";");
              }
            } catch (err) {
              _didIteratorError11 = true;
              _iteratorError11 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                  _iterator11.return();
                }
              } finally {
                if (_didIteratorError11) {
                  throw _iteratorError11;
                }
              }
            }

            return _t17;
          }
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return "class" == t ? this._classes.size > 0 : "style" == t ? this._styles.size > 0 : this._attrs.has(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (!(t instanceof _i)) return !1;
          if (this === t) return !0;
          if (this.name != t.name) return !1;
          if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) return !1;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = this._attrs[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var _ref14 = _step12.value;

              var _ref11 = _slicedToArray(_ref14, 2);

              var _e14 = _ref11[0];
              var _n9 = _ref11[1];
              if (!t._attrs.has(_e14) || t._attrs.get(_e14) !== _n9) return !1;
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = this._classes[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var _e15 = _step13.value;
              if (!t._classes.has(_e15)) return !1;
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }

          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = this._styles[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var _ref15 = _step14.value;

              var _ref13 = _slicedToArray(_ref15, 2);

              var _e16 = _ref13[0];
              var _n10 = _ref13[1];
              if (!t._styles.has(_e16) || t._styles.get(_e16) !== _n10) return !1;
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }

          return !0;
        }
      }, {
        key: "hasClass",
        value: function hasClass() {
          for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            t[_key8] = arguments[_key8];
          }

          for (var _i12 = 0, _t18 = t; _i12 < _t18.length; _i12++) {
            var _e17 = _t18[_i12];
            if (!this._classes.has(_e17)) return !1;
          }

          return !0;
        }
      }, {
        key: "getClassNames",
        value: function getClassNames() {
          return this._classes.keys();
        }
      }, {
        key: "getStyle",
        value: function getStyle(t) {
          return this._styles.get(t);
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          return this._styles.keys();
        }
      }, {
        key: "hasStyle",
        value: function hasStyle() {
          for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            t[_key9] = arguments[_key9];
          }

          for (var _i13 = 0, _t19 = t; _i13 < _t19.length; _i13++) {
            var _e18 = _t19[_i13];
            if (!this._styles.has(_e18)) return !1;
          }

          return !0;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor() {
          for (var _len10 = arguments.length, t = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            t[_key10] = arguments[_key10];
          }

          var e = _construct(bi, t);

          var n = this.parent;

          for (; n;) {
            if (e.match(n)) return n;
            n = n.parent;
          }

          return null;
        }
      }, {
        key: "getCustomProperty",
        value: function getCustomProperty(t) {
          return this._customProperties.get(t);
        }
      }, {
        key: "getCustomProperties",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getCustomProperties() {
          return _regeneratorRuntime.wrap(function getCustomProperties$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.delegateYield(this._customProperties.entries(), "t0", 1);

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, getCustomProperties, this);
        })
      }, {
        key: "getIdentity",
        value: function getIdentity() {
          var t = Array.from(this._classes).sort().join(","),
              e = Array.from(this._styles).map(function (t) {
            return "".concat(t[0], ":").concat(t[1]);
          }).sort().join(";"),
              n = Array.from(this._attrs).map(function (t) {
            return "".concat(t[0], "=\"").concat(t[1], "\"");
          }).sort().join(" ");
          return this.name + ("" == t ? "" : " class=\"".concat(t, "\"")) + ("" == e ? "" : " style=\"".concat(e, "\"")) + ("" == n ? "" : " ".concat(n));
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = [];

          if (t) {
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
              for (var _iterator15 = this.getChildren()[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                var _n11 = _step15.value;
                e.push(_n11._clone(t));
              }
            } catch (err) {
              _didIteratorError15 = true;
              _iteratorError15 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
                  _iterator15.return();
                }
              } finally {
                if (_didIteratorError15) {
                  throw _iteratorError15;
                }
              }
            }
          }

          var n = new this.constructor(this.name, this._attrs, e);
          return n._classes = new Set(this._classes), n._styles = new Map(this._styles), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);

          var n = 0;

          var i = function (t) {
            if ("string" == typeof t) return [new fi(t)];
            gi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new fi(t) : t instanceof mi ? new fi(t.data) : t;
            });
          }(e);

          var _iteratorNormalCompletion16 = true;
          var _didIteratorError16 = false;
          var _iteratorError16 = undefined;

          try {
            for (var _iterator16 = i[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
              var _e19 = _step16.value;
              null !== _e19.parent && _e19._remove(), _e19.parent = this, this._children.splice(t, 0, _e19), t++, n++;
            }
          } catch (err) {
            _didIteratorError16 = true;
            _iteratorError16 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
                _iterator16.return();
              }
            } finally {
              if (_didIteratorError16) {
                throw _iteratorError16;
              }
            }
          }

          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          this._fireChange("children", this);

          for (var _n12 = t; _n12 < t + e; _n12++) {
            this._children[_n12].parent = null;
          }

          return this._children.splice(t, e);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          e = String(e), this._fireChange("attributes", this), "class" == t ? vi(this._classes, e) : "style" == t ? ki(this._styles, e) : this._attrs.set(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._fireChange("attributes", this), "class" == t ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == t ? this._styles.size > 0 && (this._styles.clear(), !0) : this._attrs.delete(t);
        }
      }, {
        key: "_addClass",
        value: function _addClass(t) {
          var _this6 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this6._classes.add(t);
          });
        }
      }, {
        key: "_removeClass",
        value: function _removeClass(t) {
          var _this7 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this7._classes.delete(t);
          });
        }
      }, {
        key: "_setStyle",
        value: function _setStyle(t, e) {
          if (this._fireChange("attributes", this), C(t)) {
            var _e20 = Object.keys(t);

            for (var _i14 = 0, _e21 = _e20; _i14 < _e21.length; _i14++) {
              var _n13 = _e21[_i14];

              this._styles.set(_n13, t[_n13]);
            }
          } else this._styles.set(t, e);
        }
      }, {
        key: "_removeStyle",
        value: function _removeStyle(t) {
          var _this8 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this8._styles.delete(t);
          });
        }
      }, {
        key: "_setCustomProperty",
        value: function _setCustomProperty(t, e) {
          this._customProperties.set(t, e);
        }
      }, {
        key: "_removeCustomProperty",
        value: function _removeCustomProperty(t) {
          return this._customProperties.delete(t);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this._children.length;
        }
      }]);

      return _i;
    }(hi);

    function ki(t, e) {
      var n = null,
          i = 0,
          o = 0,
          r = null;

      if (t.clear(), "" !== e) {
        ";" != e.charAt(e.length - 1) && (e += ";");

        for (var _s2 = 0; _s2 < e.length; _s2++) {
          var _a2 = e.charAt(_s2);

          if (null === n) switch (_a2) {
            case ":":
              r || (r = e.substr(i, _s2 - i), o = _s2 + 1);
              break;

            case '"':
            case "'":
              n = _a2;
              break;

            case ";":
              {
                var _n14 = e.substr(o, _s2 - o);

                r && t.set(r.trim(), _n14.trim()), r = null, i = _s2 + 1;
                break;
              }
          } else _a2 === n && (n = null);
        }
      }
    }

    function vi(t, e) {
      var n = e.split(/\s+/);
      t.clear(), n.forEach(function (e) {
        return t.add(e);
      });
    }

    var yi =
    /*#__PURE__*/
    function (_i15) {
      _inherits(yi, _i15);

      function yi(t, e, n) {
        var _this9;

        _classCallCheck(this, yi);

        _this9 = _possibleConstructorReturn(this, _getPrototypeOf(yi).call(this, t, e, n)), _this9.getFillerOffset = xi;
        return _this9;
      }

      _createClass(yi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? "containerElement" == t && e == this.name || _get(_getPrototypeOf(yi.prototype), "is", this).call(this, t, e) : "containerElement" == t || _get(_getPrototypeOf(yi.prototype), "is", this).call(this, t);
        }
      }]);

      return yi;
    }(_i);

    function xi() {
      var t = _toConsumableArray(this.getChildren()),
          e = t[this.childCount - 1];

      if (e && e.is("element", "br")) return this.childCount;
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = t[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var _e22 = _step17.value;
          if (!_e22.is("uiElement")) return null;
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      return this.childCount;
    }

    var Ai = function Ai(t) {
      return t;
    };

    var Ci = function Ci(t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);

        case 1:
          return t.call(e, n[0]);

        case 2:
          return t.call(e, n[0], n[1]);

        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }

      return t.apply(e, n);
    },
        Ti = Math.max;

    var Pi = function Pi(t, e, n) {
      return e = Ti(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var i = arguments, o = -1, r = Ti(i.length - e, 0), s = Array(r); ++o < r;) {
          s[o] = i[e + o];
        }

        o = -1;

        for (var a = Array(e + 1); ++o < e;) {
          a[o] = i[o];
        }

        return a[e] = n(s), Ci(t, this, a);
      };
    };

    var Mi = function Mi(t) {
      return function () {
        return t;
      };
    },
        Si = Ot ? function (t, e) {
      return Ot(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Mi(e),
        writable: !0
      });
    } : Ai,
        Ei = 800,
        Ii = 16,
        Ni = Date.now;

    var Oi = function (t) {
      var e = 0,
          n = 0;
      return function () {
        var i = Ni(),
            o = Ii - (i - n);

        if (n = i, o > 0) {
          if (++e >= Ei) return arguments[0];
        } else e = 0;

        return t.apply(void 0, arguments);
      };
    }(Si);

    var Ri = function Ri(t, e) {
      return Oi(Pi(t, e, Ai), t + "");
    };

    var Di = function Di(t, e, n) {
      if (!z(n)) return !1;
      var i = typeof e;
      return !!("number" == i ? ue(n) && Qt(e, n.length) : "string" == i && e in n) && P(n[e], t);
    };

    var Li = function (t) {
      return Ri(function (e, n) {
        var i = -1,
            o = n.length,
            r = o > 1 ? n[o - 1] : void 0,
            s = o > 2 ? n[2] : void 0;

        for (r = t.length > 3 && "function" == typeof r ? (o--, r) : void 0, s && Di(n[0], n[1], s) && (r = o < 3 ? void 0 : r, o = 1), e = Object(e); ++i < o;) {
          var a = n[i];
          a && t(e, a, i, r);
        }

        return e;
      });
    }(function (t, e) {
      jt(e, be(e), t);
    });

    var ji = Symbol("observableProperties"),
        Vi = Symbol("boundObservables"),
        Bi = Symbol("boundProperties"),
        zi = {
      set: function set(t, e) {
        var _this10 = this;

        if (z(t)) return void Object.keys(t).forEach(function (e) {
          _this10.set(e, t[e]);
        }, this);
        Ui(this);
        var n = this[ji];
        if (t in this && !n.has(t)) throw new Gn.b("observable-set-cannot-override: Cannot override an existing property.", this);
        Object.defineProperty(this, t, {
          enumerable: !0,
          configurable: !0,
          get: function get() {
            return n.get(t);
          },
          set: function set(e) {
            var i = n.get(t);
            var o = this.fire("set:" + t, t, e, i);
            void 0 === o && (o = e), i === o && n.has(t) || (n.set(t, o), this.fire("change:" + t, t, o, i));
          }
        }), this[t] = e;
      },
      bind: function bind() {
        var _this11 = this;

        for (var _len11 = arguments.length, t = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          t[_key11] = arguments[_key11];
        }

        if (!t.length || !Wi(t)) throw new Gn.b("observable-bind-wrong-properties: All properties must be strings.", this);
        if (new Set(t).size !== t.length) throw new Gn.b("observable-bind-duplicate-properties: Properties must be unique.", this);
        Ui(this);
        var e = this[Bi];
        t.forEach(function (t) {
          if (e.has(t)) throw new Gn.b("observable-bind-rebind: Cannot bind the same property more that once.", _this11);
        });
        var n = new Map();
        return t.forEach(function (t) {
          var i = {
            property: t,
            to: []
          };
          e.set(t, i), n.set(t, i);
        }), {
          to: Hi,
          toMany: qi,
          _observable: this,
          _bindProperties: t,
          _to: [],
          _bindings: n
        };
      },
      unbind: function unbind() {
        var _this12 = this;

        if (!(ji in this)) return;
        var e = this[Bi],
            n = this[Vi];

        for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          t[_key12] = arguments[_key12];
        }

        if (t.length) {
          if (!Wi(t)) throw new Gn.b("observable-unbind-wrong-properties: Properties must be strings.", this);
          t.forEach(function (t) {
            var i = e.get(t);
            if (!i) return;
            var o, r, s, a;
            i.to.forEach(function (t) {
              o = t[0], r = t[1], s = n.get(o), (a = s[r]).delete(i), a.size || delete s[r], Object.keys(s).length || (n.delete(o), _this12.stopListening(o, "change"));
            }), e.delete(t);
          });
        } else n.forEach(function (t, e) {
          _this12.stopListening(e, "change");
        }), n.clear(), e.clear();
      },
      decorate: function decorate(t) {
        var _this13 = this;

        var e = this[t];
        if (!e) throw new Gn.b("observablemixin-cannot-decorate-undefined: Cannot decorate an undefined method.", this, {
          object: this,
          methodName: t
        });
        this.on(t, function (t, n) {
          t.return = e.apply(_this13, n);
        }), this[t] = function () {
          for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            e[_key13] = arguments[_key13];
          }

          return this.fire(t, e);
        };
      }
    };
    Li(zi, ei);
    var Fi = zi;

    function Ui(t) {
      ji in t || (Object.defineProperty(t, ji, {
        value: new Map()
      }), Object.defineProperty(t, Vi, {
        value: new Map()
      }), Object.defineProperty(t, Bi, {
        value: new Map()
      }));
    }

    function Hi() {
      var _this14 = this;

      var e = function () {
        for (var _len14 = arguments.length, t = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
          t[_key14] = arguments[_key14];
        }

        if (!t.length) throw new Gn.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.", null);
        var e = {
          to: []
        };
        var n;
        "function" == typeof t[t.length - 1] && (e.callback = t.pop());
        return t.forEach(function (t) {
          if ("string" == typeof t) n.properties.push(t);else {
            if ("object" != typeof t) throw new Gn.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.", null);
            n = {
              observable: t,
              properties: []
            }, e.to.push(n);
          }
        }), e;
      }.apply(void 0, arguments),
          n = Array.from(this._bindings.keys()),
          i = n.length;

      if (!e.callback && e.to.length > 1) throw new Gn.b("observable-bind-to-no-callback: Binding multiple observables only possible with callback.", this);
      if (i > 1 && e.callback) throw new Gn.b("observable-bind-to-extra-callback: Cannot bind multiple properties and use a callback in one binding.", this);
      e.to.forEach(function (t) {
        if (t.properties.length && t.properties.length !== i) throw new Gn.b("observable-bind-to-properties-length: The number of properties must match.", _this14);
        t.properties.length || (t.properties = _this14._bindProperties);
      }), this._to = e.to, e.callback && (this._bindings.get(n[0]).callback = e.callback), function (t, e) {
        e.forEach(function (e) {
          var n = t[Vi];
          var i;
          n.get(e.observable) || t.listenTo(e.observable, "change", function (o, r) {
            (i = n.get(e.observable)[r]) && i.forEach(function (e) {
              Yi(t, e.property);
            });
          });
        });
      }(this._observable, this._to), function (t) {
        var e;

        t._bindings.forEach(function (n, i) {
          t._to.forEach(function (o) {
            e = o.properties[n.callback ? 0 : t._bindProperties.indexOf(i)], n.to.push([o.observable, e]), function (t, e, n, i) {
              var o = t[Vi],
                  r = o.get(n),
                  s = r || {};
              s[i] || (s[i] = new Set());
              s[i].add(e), r || o.set(n, s);
            }(t._observable, n, o.observable, e);
          });
        });
      }(this), this._bindProperties.forEach(function (t) {
        Yi(_this14._observable, t);
      });
    }

    function qi(t, e, n) {
      if (this._bindings.size > 1) throw new Gn.b("observable-bind-to-many-not-one-binding: Cannot bind multiple properties with toMany().", this);
      this.to.apply(this, _toConsumableArray(function (t, e) {
        var n = t.map(function (t) {
          return [t, e];
        });
        return Array.prototype.concat.apply([], n);
      }(t, e)).concat([n]));
    }

    function Wi(t) {
      return t.every(function (t) {
        return "string" == typeof t;
      });
    }

    function Yi(t, e) {
      var n = t[Bi].get(e);
      var i;
      i = n.callback ? n.callback.apply(t, n.to.map(function (t) {
        return t[0][t[1]];
      })) : (i = n.to[0])[0][i[1]], t.hasOwnProperty(e) ? t[e] = i : t.set(e, i);
    }

    var $i = Symbol("document");

    var Gi =
    /*#__PURE__*/
    function (_yi) {
      _inherits(Gi, _yi);

      function Gi(t, e, n) {
        var _this15;

        _classCallCheck(this, Gi);

        _this15 = _possibleConstructorReturn(this, _getPrototypeOf(Gi).call(this, t, e, n)), _this15.set("isReadOnly", !1), _this15.set("isFocused", !1);
        return _this15;
      }

      _createClass(Gi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? "editableElement" == t && e == this.name || _get(_getPrototypeOf(Gi.prototype), "is", this).call(this, t, e) : "editableElement" == t || _get(_getPrototypeOf(Gi.prototype), "is", this).call(this, t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "document",
        get: function get() {
          return this.getCustomProperty($i);
        }
      }, {
        key: "_document",
        set: function set(t) {
          var _this16 = this;

          if (this.getCustomProperty($i)) throw new Gn.b("view-editableelement-document-already-set: View document is already set.", this);
          this._setCustomProperty($i, t), this.bind("isReadOnly").to(t), this.bind("isFocused").to(t, "isFocused", function (e) {
            return e && t.selection.editableElement == _this16;
          }), this.listenTo(t.selection, "change", function () {
            _this16.isFocused = t.isFocused && t.selection.editableElement == _this16;
          });
        }
      }]);

      return Gi;
    }(yi);

    ci(Gi, Fi);
    var Qi = Symbol("rootName");

    var Ji =
    /*#__PURE__*/
    function (_Gi) {
      _inherits(Ji, _Gi);

      function Ji(t) {
        var _this17;

        _classCallCheck(this, Ji);

        _this17 = _possibleConstructorReturn(this, _getPrototypeOf(Ji).call(this, t)), _this17.rootName = "main";
        return _this17;
      }

      _createClass(Ji, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? "rootElement" == t && e == this.name || _get(_getPrototypeOf(Ji.prototype), "is", this).call(this, t, e) : "rootElement" == t || _get(_getPrototypeOf(Ji.prototype), "is", this).call(this, t);
        }
      }, {
        key: "rootName",
        get: function get() {
          return this.getCustomProperty(Qi);
        },
        set: function set(t) {
          this._setCustomProperty(Qi, t);
        }
      }, {
        key: "_name",
        set: function set(t) {
          this.name = t;
        }
      }]);

      return Ji;
    }(Gi);

    var Ki =
    /*#__PURE__*/
    function () {
      function Ki() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Ki);

        if (!t.boundaries && !t.startPosition) throw new Gn.b("view-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.", null);
        if (t.direction && "forward" != t.direction && "backward" != t.direction) throw new Gn.b("view-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.", t.startPosition, {
          direction: t.direction
        });
        this.boundaries = t.boundaries || null, t.startPosition ? this.position = Zi._createAt(t.startPosition) : this.position = Zi._createAt(t.boundaries["backward" == t.direction ? "end" : "start"]), this.direction = t.direction || "forward", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }

      _createClass(Ki, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, i;

          do {
            var _this$next;

            i = this.position, (_this$next = this.next(), e = _this$next.done, n = _this$next.value, _this$next);
          } while (!e && t(n));

          e || (this.position = i);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position.clone();
          var e = this.position,
              n = t.parent;
          if (null === n.parent && t.offset === n.childCount) return {
            done: !0
          };
          if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var i;

          if (n instanceof fi) {
            if (t.isAtEnd) return this.position = Zi._createAfter(n), this._next();
            i = n.data[t.offset];
          } else i = n.getChild(t.offset);

          if (i instanceof _i) return this.shallow ? t.offset++ : t = new Zi(i, 0), this.position = t, this._formatReturnValue("elementStart", i, e, t, 1);

          if (i instanceof fi) {
            if (this.singleCharacters) return t = new Zi(i, 0), this.position = t, this._next();
            {
              var _n15,
                  _o7 = i.data.length;

              return i == this._boundaryEndParent ? (_o7 = this.boundaries.end.offset, _n15 = new mi(i, 0, _o7), t = Zi._createAfter(_n15)) : (_n15 = new mi(i, 0, i.data.length), t.offset++), this.position = t, this._formatReturnValue("text", _n15, e, t, _o7);
            }
          }

          if ("string" == typeof i) {
            var _i16;

            if (this.singleCharacters) _i16 = 1;else {
              _i16 = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - t.offset;
            }

            var _o8 = new mi(n, t.offset, _i16);

            return t.offset += _i16, this.position = t, this._formatReturnValue("text", _o8, e, t, _i16);
          }

          return t = Zi._createAfter(n), this.position = t, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, e, t);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position.clone();
          var e = this.position,
              n = t.parent;
          if (null === n.parent && 0 === t.offset) return {
            done: !0
          };
          if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var i;

          if (n instanceof fi) {
            if (t.isAtStart) return this.position = Zi._createBefore(n), this._previous();
            i = n.data[t.offset - 1];
          } else i = n.getChild(t.offset - 1);

          if (i instanceof _i) return this.shallow ? (t.offset--, this.position = t, this._formatReturnValue("elementStart", i, e, t, 1)) : (t = new Zi(i, i.childCount), this.position = t, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", i, e, t));

          if (i instanceof fi) {
            if (this.singleCharacters) return t = new Zi(i, i.data.length), this.position = t, this._previous();
            {
              var _n16,
                  _o9 = i.data.length;

              if (i == this._boundaryStartParent) {
                var _e23 = this.boundaries.start.offset;
                _o9 = (_n16 = new mi(i, _e23, i.data.length - _e23)).data.length, t = Zi._createBefore(_n16);
              } else _n16 = new mi(i, 0, i.data.length), t.offset--;

              return this.position = t, this._formatReturnValue("text", _n16, e, t, _o9);
            }
          }

          if ("string" == typeof i) {
            var _i17;

            if (this.singleCharacters) _i17 = 1;else {
              var _e24 = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;

              _i17 = t.offset - _e24;
            }
            t.offset -= _i17;

            var _o10 = new mi(n, t.offset, _i17);

            return this.position = t, this._formatReturnValue("text", _o10, e, t, _i17);
          }

          return t = Zi._createBefore(n), this.position = t, this._formatReturnValue("elementStart", n, e, t, 1);
        }
      }, {
        key: "_formatReturnValue",
        value: function _formatReturnValue(t, e, n, i, o) {
          return e instanceof mi && (e.offsetInText + e.data.length == e.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = Zi._createAfter(e.textNode) : (i = Zi._createAfter(e.textNode), this.position = i)), 0 === e.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = Zi._createBefore(e.textNode) : (i = Zi._createBefore(e.textNode), this.position = i))), {
            done: !1,
            value: {
              type: t,
              item: e,
              previousPosition: n,
              nextPosition: i,
              length: o
            }
          };
        }
      }]);

      return Ki;
    }();

    var Zi =
    /*#__PURE__*/
    function () {
      function Zi(t, e) {
        _classCallCheck(this, Zi);

        this.parent = t, this.offset = e;
      }

      _createClass(Zi, [{
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = Zi._createAt(this),
              n = e.offset + t;

          return e.offset = n < 0 ? 0 : n, e;
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new Ki(e);
          return n.skip(t), n.position;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors(),
              n = t.getAncestors();
          var i = 0;

          for (; e[i] == n[i] && e[i];) {
            i++;
          }

          return 0 === i ? null : e[i - 1];
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.parent == t.parent && this.offset == t.offset;
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return "before" == this.compareWith(t);
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return "after" == this.compareWith(t);
        }
      }, {
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root !== t.root) return "different";
          if (this.isEqual(t)) return "same";
          var e = this.parent.is("node") ? this.parent.getPath() : [],
              n = t.parent.is("node") ? t.parent.getPath() : [];
          e.push(this.offset), n.push(t.offset);
          var i = li(e, n);

          switch (i) {
            case "prefix":
              return "before";

            case "extension":
              return "after";

            default:
              return e[i] < n[i] ? "before" : "after";
          }
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.startPosition = this, new Ki(t);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new Zi(this.parent, this.offset);
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          return this.parent.is("text") ? null : this.parent.getChild(this.offset) || null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          return this.parent.is("text") ? null : this.parent.getChild(this.offset - 1) || null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          var t = this.parent.is("text") ? this.parent.data.length : this.parent.childCount;
          return this.offset === t;
        }
      }, {
        key: "root",
        get: function get() {
          return this.parent.root;
        }
      }, {
        key: "editableElement",
        get: function get() {
          var t = this.parent;

          for (; !(t instanceof Gi);) {
            if (!t.parent) return null;
            t = t.parent;
          }

          return t;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          if (t instanceof Zi) return new this(t.parent, t.offset);
          {
            var _n17 = t;
            if ("end" == e) e = _n17.is("text") ? _n17.data.length : _n17.childCount;else {
              if ("before" == e) return this._createBefore(_n17);
              if ("after" == e) return this._createAfter(_n17);
              if (0 !== e && !e) throw new Gn.b("view-createPositionAt-offset-required: View#createPositionAt() requires the offset when the first parameter is a view item.", _n17);
            }
            return new Zi(_n17, e);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t) {
          if (t.is("textProxy")) return new Zi(t.textNode, t.offsetInText + t.data.length);
          if (!t.parent) throw new Gn.b("view-position-after-root: You can not make position after root.", t, {
            root: t
          });
          return new Zi(t.parent, t.index + 1);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t) {
          if (t.is("textProxy")) return new Zi(t.textNode, t.offsetInText);
          if (!t.parent) throw new Gn.b("view-position-before-root: You can not make position before root.", t, {
            root: t
          });
          return new Zi(t.parent, t.index);
        }
      }]);

      return Zi;
    }();

    var Xi =
    /*#__PURE__*/
    function () {
      function Xi(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, Xi);

        this.start = t.clone(), this.end = e ? e.clone() : t.clone();
      }

      _createClass(Xi, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          return _regeneratorRuntime.wrap(function value$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.delegateYield(new Ki({
                    boundaries: this,
                    ignoreElementEnd: !0
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, value, this);
        })
      }, {
        key: "getEnlarged",
        value: function getEnlarged() {
          var t = this.start.getLastMatchingPosition(to, {
            direction: "backward"
          }),
              e = this.end.getLastMatchingPosition(to);
          return t.parent.is("text") && t.isAtStart && (t = Zi._createBefore(t.parent)), e.parent.is("text") && e.isAtEnd && (e = Zi._createAfter(e.parent)), new Xi(t, e);
        }
      }, {
        key: "getTrimmed",
        value: function getTrimmed() {
          var t = this.start.getLastMatchingPosition(to);
          if (t.isAfter(this.end) || t.isEqual(this.end)) return new Xi(t, t);
          var e = this.end.getLastMatchingPosition(to, {
            direction: "backward"
          });
          var n = t.nodeAfter,
              i = e.nodeBefore;
          return n && n.is("text") && (t = new Zi(n, 0)), i && i.is("text") && (e = new Zi(i, i.data.length)), new Xi(t, e);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t.isCollapsed && (e = !1);
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
              i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && i;
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new Xi(this.start, t.start)), this.containsPosition(t.end) && e.push(new Xi(t.end, this.end))) : e.push(this.clone()), e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e25 = this.start,
                _n18 = this.end;
            return this.containsPosition(t.start) && (_e25 = t.start), this.containsPosition(t.end) && (_n18 = t.end), new Xi(_e25, _n18);
          }

          return null;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.boundaries = this, new Ki(t);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new Xi(this.start, this.end);
        }
      }, {
        key: "getItems",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getItems() {
          var t,
              e,
              _iteratorNormalCompletion18,
              _didIteratorError18,
              _iteratorError18,
              _iterator18,
              _step18,
              _t20,
              _args5 = arguments;

          return _regeneratorRuntime.wrap(function getItems$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  t = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                  t.boundaries = this, t.ignoreElementEnd = !0;
                  e = new Ki(t);
                  _iteratorNormalCompletion18 = true;
                  _didIteratorError18 = false;
                  _iteratorError18 = undefined;
                  _context5.prev = 6;
                  _iterator18 = e[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done) {
                    _context5.next = 15;
                    break;
                  }

                  _t20 = _step18.value;
                  _context5.next = 12;
                  return _t20.item;

                case 12:
                  _iteratorNormalCompletion18 = true;
                  _context5.next = 8;
                  break;

                case 15:
                  _context5.next = 21;
                  break;

                case 17:
                  _context5.prev = 17;
                  _context5.t0 = _context5["catch"](6);
                  _didIteratorError18 = true;
                  _iteratorError18 = _context5.t0;

                case 21:
                  _context5.prev = 21;
                  _context5.prev = 22;

                  if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
                    _iterator18.return();
                  }

                case 24:
                  _context5.prev = 24;

                  if (!_didIteratorError18) {
                    _context5.next = 27;
                    break;
                  }

                  throw _iteratorError18;

                case 27:
                  return _context5.finish(24);

                case 28:
                  return _context5.finish(21);

                case 29:
                case "end":
                  return _context5.stop();
              }
            }
          }, getItems, this, [[6, 17, 21, 29], [22,, 24, 28]]);
        })
      }, {
        key: "getPositions",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getPositions() {
          var t,
              e,
              _iteratorNormalCompletion19,
              _didIteratorError19,
              _iteratorError19,
              _iterator19,
              _step19,
              _t21,
              _args6 = arguments;

          return _regeneratorRuntime.wrap(function getPositions$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  t = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
                  t.boundaries = this;
                  e = new Ki(t);
                  _context6.next = 5;
                  return e.position;

                case 5:
                  _iteratorNormalCompletion19 = true;
                  _didIteratorError19 = false;
                  _iteratorError19 = undefined;
                  _context6.prev = 8;
                  _iterator19 = e[Symbol.iterator]();

                case 10:
                  if (_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done) {
                    _context6.next = 17;
                    break;
                  }

                  _t21 = _step19.value;
                  _context6.next = 14;
                  return _t21.nextPosition;

                case 14:
                  _iteratorNormalCompletion19 = true;
                  _context6.next = 10;
                  break;

                case 17:
                  _context6.next = 23;
                  break;

                case 19:
                  _context6.prev = 19;
                  _context6.t0 = _context6["catch"](8);
                  _didIteratorError19 = true;
                  _iteratorError19 = _context6.t0;

                case 23:
                  _context6.prev = 23;
                  _context6.prev = 24;

                  if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
                    _iterator19.return();
                  }

                case 26:
                  _context6.prev = 26;

                  if (!_didIteratorError19) {
                    _context6.next = 29;
                    break;
                  }

                  throw _iteratorError19;

                case 29:
                  return _context6.finish(26);

                case 30:
                  return _context6.finish(23);

                case 31:
                case "end":
                  return _context6.stop();
              }
            }
          }, getPositions, this, [[8, 19, 23, 31], [24,, 26, 30]]);
        })
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return this.start.parent === this.end.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromParentsAndOffsets",
        value: function _createFromParentsAndOffsets(t, e, n, i) {
          return new this(new Zi(t, e), new Zi(n, i));
        }
      }, {
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t,
              i = t.getShiftedBy(e);
          return e > 0 ? new this(n, i) : new this(i, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          var e = t.is("textProxy") ? t.offsetSize : 1;
          return this._createFromPositionAndShift(Zi._createBefore(t), e);
        }
      }]);

      return Xi;
    }();

    function to(t) {
      return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
    }

    function eo(t) {
      var e = 0;
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = t[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var _n19 = _step20.value;
          e++;
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      return e;
    }

    var no =
    /*#__PURE__*/
    function () {
      function no() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, no);

        this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", this.setTo(t, e, n);
      }

      _createClass(no, [{
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          var _iteratorNormalCompletion21, _didIteratorError21, _iteratorError21, _iterator21, _step21, _t22;

          return _regeneratorRuntime.wrap(function getRanges$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _iteratorNormalCompletion21 = true;
                  _didIteratorError21 = false;
                  _iteratorError21 = undefined;
                  _context7.prev = 3;
                  _iterator21 = this._ranges[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done) {
                    _context7.next = 12;
                    break;
                  }

                  _t22 = _step21.value;
                  _context7.next = 9;
                  return _t22.clone();

                case 9:
                  _iteratorNormalCompletion21 = true;
                  _context7.next = 5;
                  break;

                case 12:
                  _context7.next = 18;
                  break;

                case 14:
                  _context7.prev = 14;
                  _context7.t0 = _context7["catch"](3);
                  _didIteratorError21 = true;
                  _iteratorError21 = _context7.t0;

                case 18:
                  _context7.prev = 18;
                  _context7.prev = 19;

                  if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
                    _iterator21.return();
                  }

                case 21:
                  _context7.prev = 21;

                  if (!_didIteratorError21) {
                    _context7.next = 24;
                    break;
                  }

                  throw _iteratorError21;

                case 24:
                  return _context7.finish(21);

                case 25:
                  return _context7.finish(18);

                case 26:
                case "end":
                  return _context7.stop();
              }
            }
          }, getRanges, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;
          var _iteratorNormalCompletion22 = true;
          var _didIteratorError22 = false;
          var _iteratorError22 = undefined;

          try {
            for (var _iterator22 = this._ranges[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
              var _e26 = _step22.value;
              t && !_e26.start.isBefore(t.start) || (t = _e26);
            }
          } catch (err) {
            _didIteratorError22 = true;
            _iteratorError22 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
                _iterator22.return();
              }
            } finally {
              if (_didIteratorError22) {
                throw _iteratorError22;
              }
            }
          }

          return t ? t.clone() : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;
          var _iteratorNormalCompletion23 = true;
          var _didIteratorError23 = false;
          var _iteratorError23 = undefined;

          try {
            for (var _iterator23 = this._ranges[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
              var _e27 = _step23.value;
              t && !_e27.end.isAfter(t.end) || (t = _e27);
            }
          } catch (err) {
            _didIteratorError23 = true;
            _iteratorError23 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
                _iterator23.return();
              }
            } finally {
              if (_didIteratorError23) {
                throw _iteratorError23;
              }
            }
          }

          return t ? t.clone() : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          if (this.isFake != t.isFake) return !1;
          if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) return !1;
          if (this.rangeCount != t.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
          var _iteratorNormalCompletion24 = true;
          var _didIteratorError24 = false;
          var _iteratorError24 = undefined;

          try {
            for (var _iterator24 = this._ranges[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
              var _e28 = _step24.value;

              var _n20 = !1;

              var _iteratorNormalCompletion25 = true;
              var _didIteratorError25 = false;
              var _iteratorError25 = undefined;

              try {
                for (var _iterator25 = t._ranges[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                  var _i18 = _step25.value;

                  if (_e28.isEqual(_i18)) {
                    _n20 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError25 = true;
                _iteratorError25 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
                    _iterator25.return();
                  }
                } finally {
                  if (_didIteratorError25) {
                    throw _iteratorError25;
                  }
                }
              }

              if (!_n20) return !1;
            }
          } catch (err) {
            _didIteratorError24 = true;
            _iteratorError24 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
                _iterator24.return();
              }
            } finally {
              if (_didIteratorError24) {
                throw _iteratorError24;
              }
            }
          }

          return !0;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (this.isBackward != t.isBackward) return !1;
          var e = eo(this.getRanges());
          if (e != eo(t.getRanges())) return !1;
          if (0 == e) return !0;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = this.getRanges()[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var _e29 = _step26.value;
              _e29 = _e29.getTrimmed();

              var _n21 = !1;

              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = t.getRanges()[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var _i19 = _step27.value;

                  if (_i19 = _i19.getTrimmed(), _e29.start.isEqual(_i19.start) && _e29.end.isEqual(_i19.end)) {
                    _n21 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return != null) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }

              if (!_n21) return !1;
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return != null) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }

          return !0;
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          if (1 !== this.rangeCount) return null;
          var t = this.getFirstRange();
          var e = t.start.nodeAfter,
              n = t.end.nodeBefore;
          return t.start.parent.is("text") && t.start.isAtEnd && t.start.parent.nextSibling && (e = t.start.parent.nextSibling), t.end.parent.is("text") && t.end.isAtStart && t.end.parent.previousSibling && (n = t.end.parent.previousSibling), e instanceof _i && e == n ? e : null;
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (null === t) this._setRanges([]), this._setFakeOptions(e);else if (t instanceof no || t instanceof io) this._setRanges(t.getRanges(), t.isBackward), this._setFakeOptions({
            fake: t.isFake,
            label: t.fakeSelectionLabel
          });else if (t instanceof Xi) this._setRanges([t], e && e.backward), this._setFakeOptions(e);else if (t instanceof Zi) this._setRanges([new Xi(t)]), this._setFakeOptions(e);else if (t instanceof hi) {
            var _i20 = !!n && !!n.backward;

            var _o11;

            if (void 0 === e) throw new Gn.b("view-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.", this);
            _o11 = "in" == e ? Xi._createIn(t) : "on" == e ? Xi._createOn(t) : new Xi(Zi._createAt(t, e)), this._setRanges([_o11], _i20), this._setFakeOptions(n);
          } else {
            if (!gi(t)) throw new Gn.b("view-selection-setTo-not-selectable: Cannot set selection to given place.", this);
            this._setRanges(t, e && e.backward), this._setFakeOptions(e);
          }
          this.fire("change");
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (null === this.anchor) throw new Gn.b("view-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.", this);

          var n = Zi._createAt(t, e);

          if ("same" == n.compareWith(this.focus)) return;
          var i = this.anchor;
          this._ranges.pop(), "before" == n.compareWith(i) ? this._addRange(new Xi(n, i), !0) : this._addRange(new Xi(i, n)), this.fire("change");
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t;
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t = Array.from(t), this._ranges = [];
          var _iteratorNormalCompletion28 = true;
          var _didIteratorError28 = false;
          var _iteratorError28 = undefined;

          try {
            for (var _iterator28 = t[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
              var _e30 = _step28.value;

              this._addRange(_e30);
            }
          } catch (err) {
            _didIteratorError28 = true;
            _iteratorError28 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion28 && _iterator28.return != null) {
                _iterator28.return();
              }
            } finally {
              if (_didIteratorError28) {
                throw _iteratorError28;
              }
            }
          }

          this._lastRangeBackward = !!e;
        }
      }, {
        key: "_setFakeOptions",
        value: function _setFakeOptions() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
        }
      }, {
        key: "_addRange",
        value: function _addRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (!(t instanceof Xi)) throw new Gn.b("view-selection-add-range-not-range: Selection range set to an object that is not an instance of view.Range", this);
          this._pushRange(t), this._lastRangeBackward = !!e;
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = this._ranges[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var _e31 = _step29.value;
              if (t.isIntersecting(_e31)) throw new Gn.b("view-selection-range-intersects: Trying to add a range that intersects with another range from selection.", this, {
                addedRange: t,
                intersectingRange: _e31
              });
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return != null) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }

          this._ranges.push(new Xi(t.start, t.end));
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          if (!this._ranges.length) return null;
          var t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.end : t.start).clone();
        }
      }, {
        key: "focus",
        get: function get() {
          if (!this._ranges.length) return null;
          var t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.start : t.end).clone();
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this.rangeCount && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this.anchor ? this.anchor.editableElement : null;
        }
      }]);

      return no;
    }();

    ci(no, ei);

    var io =
    /*#__PURE__*/
    function () {
      function io() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, io);

        this._selection = new no(), this._selection.delegate("change").to(this), this._selection.setTo(t, e, n);
      }

      _createClass(io, [{
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          return _regeneratorRuntime.wrap(function getRanges$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  return _context8.delegateYield(this._selection.getRanges(), "t0", 1);

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this._selection.isEqual(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return this._selection.isSimilar(t);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "documentSelection" == t;
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._selection.isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._selection.fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this._selection.editableElement;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }]);

      return io;
    }();

    ci(io, ei);

    var oo =
    /*#__PURE__*/
    function () {
      function oo() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, oo);

        this._items = [], this._itemMap = new Map(), this._idProperty = t.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [];
      }

      _createClass(oo, [{
        key: "add",
        value: function add(t, e) {
          var n;
          var i = this._idProperty;

          if (i in t) {
            if ("string" != typeof (n = t[i])) throw new Gn.b("collection-add-invalid-id", this);
            if (this.get(n)) throw new Gn.b("collection-add-item-already-exists", this);
          } else t[i] = n = Kn();

          if (void 0 === e) e = this._items.length;else if (e > this._items.length || e < 0) throw new Gn.b("collection-add-item-invalid-index", this);
          return this._items.splice(e, 0, t), this._itemMap.set(n, t), this.fire("add", t, e), this;
        }
      }, {
        key: "get",
        value: function get(t) {
          var e;
          if ("string" == typeof t) e = this._itemMap.get(t);else {
            if ("number" != typeof t) throw new Gn.b("collection-get-invalid-arg: Index or id must be given.", this);
            e = this._items[t];
          }
          return e || null;
        }
      }, {
        key: "has",
        value: function has(t) {
          if ("string" == typeof t) return this._itemMap.has(t);
          {
            var _e32 = t[this._idProperty];
            return this._itemMap.has(_e32);
          }
        }
      }, {
        key: "getIndex",
        value: function getIndex(t) {
          var e;
          return e = "string" == typeof t ? this._itemMap.get(t) : t, this._items.indexOf(e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e,
              n,
              i,
              o = !1;
          var r = this._idProperty;
          if ("string" == typeof t ? (n = t, o = !(i = this._itemMap.get(n)), i && (e = this._items.indexOf(i))) : "number" == typeof t ? (e = t, o = !(i = this._items[e]), i && (n = i[r])) : (n = (i = t)[r], o = -1 == (e = this._items.indexOf(i)) || !this._itemMap.get(n)), o) throw new Gn.b("collection-remove-404: Item not found.", this);
          this._items.splice(e, 1), this._itemMap.delete(n);

          var s = this._bindToInternalToExternalMap.get(i);

          return this._bindToInternalToExternalMap.delete(i), this._bindToExternalToInternalMap.delete(s), this.fire("remove", i, e), i;
        }
      }, {
        key: "map",
        value: function map(t, e) {
          return this._items.map(t, e);
        }
      }, {
        key: "find",
        value: function find(t, e) {
          return this._items.find(t, e);
        }
      }, {
        key: "filter",
        value: function filter(t, e) {
          return this._items.filter(t, e);
        }
      }, {
        key: "clear",
        value: function clear() {
          for (this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null); this.length;) {
            this.remove(0);
          }
        }
      }, {
        key: "bindTo",
        value: function bindTo(t) {
          var _this18 = this;

          if (this._bindToCollection) throw new Gn.b("collection-bind-to-rebind: The collection cannot be bound more than once.", this);
          return this._bindToCollection = t, {
            as: function as(t) {
              _this18._setUpBindToBinding(function (e) {
                return new t(e);
              });
            },
            using: function using(t) {
              "function" == typeof t ? _this18._setUpBindToBinding(function (e) {
                return t(e);
              }) : _this18._setUpBindToBinding(function (e) {
                return e[t];
              });
            }
          };
        }
      }, {
        key: "_setUpBindToBinding",
        value: function _setUpBindToBinding(t) {
          var _this19 = this;

          var e = this._bindToCollection,
              n = function n(_n23, i, o) {
            var r = e._bindToCollection == _this19,
                s = e._bindToInternalToExternalMap.get(i);

            if (r && s) _this19._bindToExternalToInternalMap.set(i, s), _this19._bindToInternalToExternalMap.set(s, i);else {
              var _n22 = t(i);

              if (!_n22) return void _this19._skippedIndexesFromExternal.push(o);
              var _r3 = o;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = _this19._skippedIndexesFromExternal[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var _t24 = _step30.value;
                  o > _t24 && _r3--;
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return != null) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }

              var _iteratorNormalCompletion31 = true;
              var _didIteratorError31 = false;
              var _iteratorError31 = undefined;

              try {
                for (var _iterator31 = e._skippedIndexesFromExternal[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                  var _t25 = _step31.value;
                  _r3 >= _t25 && _r3++;
                }
              } catch (err) {
                _didIteratorError31 = true;
                _iteratorError31 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion31 && _iterator31.return != null) {
                    _iterator31.return();
                  }
                } finally {
                  if (_didIteratorError31) {
                    throw _iteratorError31;
                  }
                }
              }

              _this19._bindToExternalToInternalMap.set(i, _n22), _this19._bindToInternalToExternalMap.set(_n22, i), _this19.add(_n22, _r3);

              for (var _t23 = 0; _t23 < e._skippedIndexesFromExternal.length; _t23++) {
                _r3 <= e._skippedIndexesFromExternal[_t23] && e._skippedIndexesFromExternal[_t23]++;
              }
            }
          };

          var _iteratorNormalCompletion32 = true;
          var _didIteratorError32 = false;
          var _iteratorError32 = undefined;

          try {
            for (var _iterator32 = e[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
              var _t26 = _step32.value;
              n(0, _t26, e.getIndex(_t26));
            }
          } catch (err) {
            _didIteratorError32 = true;
            _iteratorError32 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion32 && _iterator32.return != null) {
                _iterator32.return();
              }
            } finally {
              if (_didIteratorError32) {
                throw _iteratorError32;
              }
            }
          }

          this.listenTo(e, "add", n), this.listenTo(e, "remove", function (t, e, n) {
            var i = _this19._bindToExternalToInternalMap.get(e);

            i && _this19.remove(i), _this19._skippedIndexesFromExternal = _this19._skippedIndexesFromExternal.reduce(function (t, e) {
              return n < e && t.push(e - 1), n > e && t.push(e), t;
            }, []);
          });
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "first",
        get: function get() {
          return this._items[0] || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this.length - 1] || null;
        }
      }]);

      return oo;
    }();

    ci(oo, ei);

    var ro =
    /*#__PURE__*/
    function () {
      function ro() {
        _classCallCheck(this, ro);

        this.selection = new io(), this.roots = new oo({
          idProperty: "rootName"
        }), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isComposing", !1), this._postFixers = new Set();
      }

      _createClass(ro, [{
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.roots.map(function (t) {
            return t.destroy();
          }), this.stopListening();
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = !1;

          do {
            var _iteratorNormalCompletion33 = true;
            var _didIteratorError33 = false;
            var _iteratorError33 = undefined;

            try {
              for (var _iterator33 = this._postFixers[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
                var _n24 = _step33.value;
                if (e = _n24(t)) break;
              }
            } catch (err) {
              _didIteratorError33 = true;
              _iteratorError33 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion33 && _iterator33.return != null) {
                  _iterator33.return();
                }
              } finally {
                if (_didIteratorError33) {
                  throw _iteratorError33;
                }
              }
            }
          } while (e);
        }
      }]);

      return ro;
    }();

    ci(ro, Fi);
    var so = 10;

    var ao =
    /*#__PURE__*/
    function (_i21) {
      _inherits(ao, _i21);

      function ao(t, e, n) {
        var _this20;

        _classCallCheck(this, ao);

        _this20 = _possibleConstructorReturn(this, _getPrototypeOf(ao).call(this, t, e, n)), _this20.getFillerOffset = co, _this20._priority = so, _this20._id = null, _this20._clonesGroup = null;
        return _this20;
      }

      _createClass(ao, [{
        key: "getElementsWithSameId",
        value: function getElementsWithSameId() {
          if (null === this.id) throw new Gn.b("attribute-element-get-elements-with-same-id-no-id: Cannot get elements with the same id for an attribute element without id.", this);
          return new Set(this._clonesGroup);
        }
      }, {
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? "attributeElement" == t && e == this.name || _get(_getPrototypeOf(ao.prototype), "is", this).call(this, t, e) : "attributeElement" == t || _get(_getPrototypeOf(ao.prototype), "is", this).call(this, t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return null !== this.id || null !== t.id ? this.id === t.id : _get(_getPrototypeOf(ao.prototype), "isSimilar", this).call(this, t) && this.priority == t.priority;
        }
      }, {
        key: "_clone",
        value: function _clone(t) {
          var e = _get(_getPrototypeOf(ao.prototype), "_clone", this).call(this, t);

          return e._priority = this._priority, e._id = this._id, e;
        }
      }, {
        key: "priority",
        get: function get() {
          return this._priority;
        }
      }, {
        key: "id",
        get: function get() {
          return this._id;
        }
      }]);

      return ao;
    }(_i);

    function co() {
      if (lo(this)) return null;
      var t = this.parent;

      for (; t && t.is("attributeElement");) {
        if (lo(t) > 1) return null;
        t = t.parent;
      }

      return !t || lo(t) > 1 ? null : this.childCount;
    }

    function lo(t) {
      return Array.from(t.getChildren()).filter(function (t) {
        return !t.is("uiElement");
      }).length;
    }

    ao.DEFAULT_PRIORITY = so;

    var uo =
    /*#__PURE__*/
    function (_i22) {
      _inherits(uo, _i22);

      function uo(t, e, n) {
        var _this21;

        _classCallCheck(this, uo);

        _this21 = _possibleConstructorReturn(this, _getPrototypeOf(uo).call(this, t, e, n)), _this21.getFillerOffset = ho;
        return _this21;
      }

      _createClass(uo, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? "emptyElement" == t && e == this.name || _get(_getPrototypeOf(uo.prototype), "is", this).call(this, t, e) : "emptyElement" == t || _get(_getPrototypeOf(uo.prototype), "is", this).call(this, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof hi || Array.from(e).length > 0)) throw new Gn.b("view-emptyelement-cannot-add: Cannot add child nodes to EmptyElement instance.", [this, e]);
        }
      }]);

      return uo;
    }(_i);

    function ho() {
      return null;
    }

    var fo = navigator.userAgent.toLowerCase();
    var mo = {
      isMac: function (t) {
        return t.indexOf("macintosh") > -1;
      }(fo),
      isEdge: function (t) {
        return !!t.match(/edge\/(\d+.?\d*)/);
      }(fo),
      isGecko: function (t) {
        return !!t.match(/gecko\/\d+/);
      }(fo),
      isSafari: function (t) {
        return t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome");
      }(fo),
      isAndroid: function (t) {
        return t.indexOf("android") > -1;
      }(fo)
    };

    var po = {
      "⌘": "ctrl",
      "⇧": "shift",
      "⌥": "alt"
    },
        go = {
      ctrl: "⌘",
      shift: "⇧",
      alt: "⌥"
    },
        bo = function () {
      var t = {
        arrowleft: 37,
        arrowup: 38,
        arrowright: 39,
        arrowdown: 40,
        backspace: 8,
        delete: 46,
        enter: 13,
        space: 32,
        esc: 27,
        tab: 9,
        ctrl: 1114112,
        cmd: 1114112,
        shift: 2228224,
        alt: 4456448
      };

      for (var _e33 = 65; _e33 <= 90; _e33++) {
        var _n25 = String.fromCharCode(_e33);

        t[_n25.toLowerCase()] = _e33;
      }

      for (var _e34 = 48; _e34 <= 57; _e34++) {
        t[_e34 - 48] = _e34;
      }

      for (var _e35 = 112; _e35 <= 123; _e35++) {
        t["f" + (_e35 - 111)] = _e35;
      }

      return t;
    }();

    function wo(t) {
      var e;

      if ("string" == typeof t) {
        if (!(e = bo[t.toLowerCase()])) throw new Gn.b("keyboard-unknown-key: Unknown key name.", null, {
          key: t
        });
      } else e = t.keyCode + (t.altKey ? bo.alt : 0) + (t.ctrlKey ? bo.ctrl : 0) + (t.shiftKey ? bo.shift : 0);

      return e;
    }

    function _o(t) {
      return "string" == typeof t && (t = ko(t)), t.map(function (t) {
        return "string" == typeof t ? wo(t) : t;
      }).reduce(function (t, e) {
        return e + t;
      }, 0);
    }

    function ko(t) {
      return t.split(/\s*\+\s*/);
    }

    var vo =
    /*#__PURE__*/
    function (_i23) {
      _inherits(vo, _i23);

      function vo(t, e, n) {
        var _this22;

        _classCallCheck(this, vo);

        _this22 = _possibleConstructorReturn(this, _getPrototypeOf(vo).call(this, t, e, n)), _this22.getFillerOffset = xo;
        return _this22;
      }

      _createClass(vo, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? "uiElement" == t && e == this.name || _get(_getPrototypeOf(vo.prototype), "is", this).call(this, t, e) : "uiElement" == t || _get(_getPrototypeOf(vo.prototype), "is", this).call(this, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof hi || Array.from(e).length > 0)) throw new Gn.b("view-uielement-cannot-add: Cannot add child nodes to UIElement instance.", this);
        }
      }, {
        key: "render",
        value: function render(t) {
          return this.toDomElement(t);
        }
      }, {
        key: "toDomElement",
        value: function toDomElement(t) {
          var e = t.createElement(this.name);
          var _iteratorNormalCompletion34 = true;
          var _didIteratorError34 = false;
          var _iteratorError34 = undefined;

          try {
            for (var _iterator34 = this.getAttributeKeys()[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
              var _t27 = _step34.value;
              e.setAttribute(_t27, this.getAttribute(_t27));
            }
          } catch (err) {
            _didIteratorError34 = true;
            _iteratorError34 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion34 && _iterator34.return != null) {
                _iterator34.return();
              }
            } finally {
              if (_didIteratorError34) {
                throw _iteratorError34;
              }
            }
          }

          return e;
        }
      }]);

      return vo;
    }(_i);

    function yo(t) {
      t.document.on("keydown", function (e, n) {
        return function (t, e, n) {
          if (e.keyCode == bo.arrowright) {
            var _t28 = e.domTarget.ownerDocument.defaultView.getSelection(),
                _i24 = 1 == _t28.rangeCount && _t28.getRangeAt(0).collapsed;

            if (_i24 || e.shiftKey) {
              var _e36 = _t28.focusNode,
                  _o12 = _t28.focusOffset,
                  _r4 = n.domPositionToView(_e36, _o12);

              if (null === _r4) return;

              var _s3 = !1;

              var _a3 = _r4.getLastMatchingPosition(function (t) {
                return t.item.is("uiElement") && (_s3 = !0), !(!t.item.is("uiElement") && !t.item.is("attributeElement"));
              });

              if (_s3) {
                var _e37 = n.viewPositionToDom(_a3);

                _i24 ? _t28.collapse(_e37.parent, _e37.offset) : _t28.extend(_e37.parent, _e37.offset);
              }
            }
          }
        }(0, n, t.domConverter);
      });
    }

    function xo() {
      return null;
    }

    var Ao =
    /*#__PURE__*/
    function () {
      function Ao(t) {
        _classCallCheck(this, Ao);

        this._children = [], t && this._insertChild(0, t);
      }

      _createClass(Ao, [{
        key: Symbol.iterator,
        value: function value() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "documentFragment" == t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);

          var n = 0;

          var i = function (t) {
            if ("string" == typeof t) return [new fi(t)];
            gi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new fi(t) : t instanceof mi ? new fi(t.data) : t;
            });
          }(e);

          var _iteratorNormalCompletion35 = true;
          var _didIteratorError35 = false;
          var _iteratorError35 = undefined;

          try {
            for (var _iterator35 = i[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
              var _e38 = _step35.value;
              null !== _e38.parent && _e38._remove(), _e38.parent = this, this._children.splice(t, 0, _e38), t++, n++;
            }
          } catch (err) {
            _didIteratorError35 = true;
            _iteratorError35 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion35 && _iterator35.return != null) {
                _iterator35.return();
              }
            } finally {
              if (_didIteratorError35) {
                throw _iteratorError35;
              }
            }
          }

          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          this._fireChange("children", this);

          for (var _n26 = t; _n26 < t + e; _n26++) {
            this._children[_n26].parent = null;
          }

          return this._children.splice(t, e);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }]);

      return Ao;
    }();

    ci(Ao, ei);

    var Co =
    /*#__PURE__*/
    function () {
      function Co(t) {
        _classCallCheck(this, Co);

        this.document = t, this._cloneGroups = new Map();
      }

      _createClass(Co, [{
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this.document.selection._setFocus(t, e);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new fi(t);
        }
      }, {
        key: "createAttributeElement",
        value: function createAttributeElement(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var i = new ao(t, e);
          return n.priority && (i._priority = n.priority), n.id && (i._id = n.id), i;
        }
      }, {
        key: "createContainerElement",
        value: function createContainerElement(t, e) {
          return new yi(t, e);
        }
      }, {
        key: "createEditableElement",
        value: function createEditableElement(t, e) {
          var n = new Gi(t, e);
          return n._document = this.document, n;
        }
      }, {
        key: "createEmptyElement",
        value: function createEmptyElement(t, e) {
          return new uo(t, e);
        }
      }, {
        key: "createUIElement",
        value: function createUIElement(t, e, n) {
          var i = new vo(t, e);
          return n && (i.render = n), i;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          C(t) && void 0 === n && (n = e), n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "breakAttributes",
        value: function breakAttributes(t) {
          return t instanceof Zi ? this._breakAttributes(t) : this._breakAttributesRange(t);
        }
      }, {
        key: "breakContainer",
        value: function breakContainer(t) {
          var e = t.parent;
          if (!e.is("containerElement")) throw new Gn.b("view-writer-break-non-container-element: Trying to break an element which is not a container element.", this.document);
          if (!e.parent) throw new Gn.b("view-writer-break-root: Trying to break root element.", this.document);
          if (t.isAtStart) return Zi._createBefore(e);

          if (!t.isAtEnd) {
            var _n27 = e._clone(!1);

            this.insert(Zi._createAfter(e), _n27);

            var _i25 = new Xi(t, Zi._createAt(e, "end")),
                _o13 = new Zi(_n27, 0);

            this.move(_i25, _o13);
          }

          return Zi._createAfter(e);
        }
      }, {
        key: "mergeAttributes",
        value: function mergeAttributes(t) {
          var e = t.offset,
              n = t.parent;
          if (n.is("text")) return t;

          if (n.is("attributeElement") && 0 === n.childCount) {
            var _t29 = n.parent,
                _e39 = n.index;
            return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new Zi(_t29, _e39));
          }

          var i = n.getChild(e - 1),
              o = n.getChild(e);
          if (!i || !o) return t;
          if (i.is("text") && o.is("text")) return Eo(i, o);

          if (i.is("attributeElement") && o.is("attributeElement") && i.isSimilar(o)) {
            var _t30 = i.childCount;
            return i._appendChild(o.getChildren()), o._remove(), this._removeFromClonedElementsGroup(o), this.mergeAttributes(new Zi(i, _t30));
          }

          return t;
        }
      }, {
        key: "mergeContainers",
        value: function mergeContainers(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          if (!(e && n && e.is("containerElement") && n.is("containerElement"))) throw new Gn.b("view-writer-merge-containers-invalid-position: Element before and after given position cannot be merged.", this.document);
          var i = e.getChild(e.childCount - 1),
              o = i instanceof fi ? Zi._createAt(i, "end") : Zi._createAt(e, "end");
          return this.move(Xi._createIn(n), Zi._createAt(e, "end")), this.remove(Xi._createOn(n)), o;
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          (function t(e, n) {
            var _iteratorNormalCompletion36 = true;
            var _didIteratorError36 = false;
            var _iteratorError36 = undefined;

            try {
              var _loop = function _loop() {
                var i = _step36.value;
                if (!Io.some(function (t) {
                  return i instanceof t;
                })) throw new Gn.b("view-writer-insert-invalid-node", n);
                i.is("text") || t(i.getChildren(), n);
              };

              for (var _iterator36 = e[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
                _loop();
              }
            } catch (err) {
              _didIteratorError36 = true;
              _iteratorError36 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion36 && _iterator36.return != null) {
                  _iterator36.return();
                }
              } finally {
                if (_didIteratorError36) {
                  throw _iteratorError36;
                }
              }
            }
          })(e = gi(e) ? _toConsumableArray(e) : [e], this.document);

          var n = To(t);
          if (!n) throw new Gn.b("view-writer-invalid-position-container", this.document);

          var i = this._breakAttributes(t, !0),
              o = n._insertChild(i.offset, e);

          var _iteratorNormalCompletion37 = true;
          var _didIteratorError37 = false;
          var _iteratorError37 = undefined;

          try {
            for (var _iterator37 = e[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
              var _t32 = _step37.value;

              this._addToClonedElementsGroup(_t32);
            }
          } catch (err) {
            _didIteratorError37 = true;
            _iteratorError37 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion37 && _iterator37.return != null) {
                _iterator37.return();
              }
            } finally {
              if (_didIteratorError37) {
                throw _iteratorError37;
              }
            }
          }

          var r = i.getShiftedBy(o),
              s = this.mergeAttributes(i);
          if (0 === o) return new Xi(s, s);
          {
            s.isEqual(i) || r.offset--;

            var _t31 = this.mergeAttributes(r);

            return new Xi(s, _t31);
          }
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t instanceof Xi ? t : Xi._createOn(t);
          if (Oo(e, this.document), e.isCollapsed) return new Ao();

          var _this$_breakAttribute = this._breakAttributesRange(e, !0),
              n = _this$_breakAttribute.start,
              i = _this$_breakAttribute.end,
              o = n.parent,
              r = i.offset - n.offset,
              s = o._removeChildren(n.offset, r);

          var _iteratorNormalCompletion38 = true;
          var _didIteratorError38 = false;
          var _iteratorError38 = undefined;

          try {
            for (var _iterator38 = s[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
              var _t33 = _step38.value;

              this._removeFromClonedElementsGroup(_t33);
            }
          } catch (err) {
            _didIteratorError38 = true;
            _iteratorError38 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion38 && _iterator38.return != null) {
                _iterator38.return();
              }
            } finally {
              if (_didIteratorError38) {
                throw _iteratorError38;
              }
            }
          }

          var a = this.mergeAttributes(n);
          return e.start = a, e.end = a.clone(), new Ao(s);
        }
      }, {
        key: "clear",
        value: function clear(t, e) {
          Oo(t, this.document);
          var n = t.getWalker({
            direction: "backward",
            ignoreElementEnd: !0
          });
          var _iteratorNormalCompletion39 = true;
          var _didIteratorError39 = false;
          var _iteratorError39 = undefined;

          try {
            for (var _iterator39 = n[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
              var _i26 = _step39.value;
              var _n28 = _i26.item;

              var _o14 = void 0;

              if (_n28.is("element") && e.isSimilar(_n28)) _o14 = Xi._createOn(_n28);else if (!_i26.nextPosition.isAfter(t.start) && _n28.is("textProxy")) {
                var _t34 = _n28.getAncestors().find(function (t) {
                  return t.is("element") && e.isSimilar(t);
                });

                _t34 && (_o14 = Xi._createIn(_t34));
              }
              _o14 && (_o14.end.isAfter(t.end) && (_o14.end = t.end), _o14.start.isBefore(t.start) && (_o14.start = t.start), this.remove(_o14));
            }
          } catch (err) {
            _didIteratorError39 = true;
            _iteratorError39 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion39 && _iterator39.return != null) {
                _iterator39.return();
              }
            } finally {
              if (_didIteratorError39) {
                throw _iteratorError39;
              }
            }
          }
        }
      }, {
        key: "move",
        value: function move(t, e) {
          var n;

          if (e.isAfter(t.end)) {
            var _i27 = (e = this._breakAttributes(e, !0)).parent,
                _o15 = _i27.childCount;

            t = this._breakAttributesRange(t, !0), n = this.remove(t), e.offset += _i27.childCount - _o15;
          } else n = this.remove(t);

          return this.insert(e, n);
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (!(e instanceof ao)) throw new Gn.b("view-writer-wrap-invalid-attribute", this.document);

          if (Oo(t, this.document), t.isCollapsed) {
            var _n29 = t.start;
            _n29.parent.is("element") && !function (t) {
              return Array.from(t.getChildren()).some(function (t) {
                return !t.is("uiElement");
              });
            }(_n29.parent) && (_n29 = _n29.getLastMatchingPosition(function (t) {
              return t.item.is("uiElement");
            })), _n29 = this._wrapPosition(_n29, e);
            var _i28 = this.document.selection;
            return _i28.isCollapsed && _i28.getFirstPosition().isEqual(t.start) && this.setSelection(_n29), new Xi(_n29);
          }

          return this._wrapRange(t, e);
        }
      }, {
        key: "unwrap",
        value: function unwrap(t, e) {
          if (!(e instanceof ao)) throw new Gn.b("view-writer-unwrap-invalid-attribute", this.document);
          if (Oo(t, this.document), t.isCollapsed) return t;

          var _this$_breakAttribute2 = this._breakAttributesRange(t, !0),
              n = _this$_breakAttribute2.start,
              i = _this$_breakAttribute2.end,
              o = n.parent,
              r = this._unwrapChildren(o, n.offset, i.offset, e),
              s = this.mergeAttributes(r.start);

          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new Xi(s, a);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new yi(t, e.getAttributes());
          return this.insert(Zi._createAfter(e), n), this.move(Xi._createIn(e), Zi._createAt(n, 0)), this.remove(Xi._createOn(e)), n;
        }
      }, {
        key: "clearClonedElementsGroup",
        value: function clearClonedElementsGroup(t) {
          this._cloneGroups.delete(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Zi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Zi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Zi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Xi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Xi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Xi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new no(t, e, n);
        }
      }, {
        key: "_wrapChildren",
        value: function _wrapChildren(t, e, n, i) {
          var o = e;
          var r = [];

          for (; o < n;) {
            var _e40 = t.getChild(o),
                _n30 = _e40.is("text"),
                _s4 = _e40.is("attributeElement"),
                _a4 = _e40.is("emptyElement"),
                _c2 = _e40.is("uiElement");

            if (_s4 && this._wrapAttributeElement(i, _e40)) r.push(new Zi(t, o));else if (_n30 || _a4 || _c2 || _s4 && Po(i, _e40)) {
              var _n31 = i._clone();

              _e40._remove(), _n31._appendChild(_e40), t._insertChild(o, _n31), this._addToClonedElementsGroup(_n31), r.push(new Zi(t, o));
            } else _s4 && this._wrapChildren(_e40, 0, _e40.childCount, i);
            o++;
          }

          var s = 0;

          for (var _i29 = 0, _r5 = r; _i29 < _r5.length; _i29++) {
            var _t35 = _r5[_i29];
            if (_t35.offset -= s, _t35.offset == e) continue;
            this.mergeAttributes(_t35).isEqual(_t35) || (s++, n--);
          }

          return Xi._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_unwrapChildren",
        value: function _unwrapChildren(t, e, n, i) {
          var o = e;
          var r = [];

          for (; o < n;) {
            var _e41 = t.getChild(o);

            if (_e41.is("attributeElement")) {
              if (_e41.isSimilar(i)) {
                var _i30 = _e41.getChildren(),
                    _s5 = _e41.childCount;

                _e41._remove(), t._insertChild(o, _i30), this._removeFromClonedElementsGroup(_e41), r.push(new Zi(t, o), new Zi(t, o + _s5)), o += _s5, n += _s5 - 1;
              } else this._unwrapAttributeElement(i, _e41) ? (r.push(new Zi(t, o), new Zi(t, o + 1)), o++) : (this._unwrapChildren(_e41, 0, _e41.childCount, i), o++);
            } else o++;
          }

          var s = 0;

          for (var _i31 = 0, _r6 = r; _i31 < _r6.length; _i31++) {
            var _t36 = _r6[_i31];
            if (_t36.offset -= s, _t36.offset == e || _t36.offset == n) continue;
            this.mergeAttributes(_t36).isEqual(_t36) || (s++, n--);
          }

          return Xi._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_wrapRange",
        value: function _wrapRange(t, e) {
          var _this$_breakAttribute3 = this._breakAttributesRange(t, !0),
              n = _this$_breakAttribute3.start,
              i = _this$_breakAttribute3.end,
              o = n.parent,
              r = this._wrapChildren(o, n.offset, i.offset, e),
              s = this.mergeAttributes(r.start);

          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new Xi(s, a);
        }
      }, {
        key: "_wrapPosition",
        value: function _wrapPosition(t, e) {
          if (e.isSimilar(t.parent)) return Mo(t.clone());
          t.parent.is("text") && (t = So(t));
          var n = this.createAttributeElement();
          n._priority = Number.POSITIVE_INFINITY, n.isSimilar = function () {
            return !1;
          }, t.parent._insertChild(t.offset, n);
          var i = new Xi(t, t.getShiftedBy(1));
          this.wrap(i, e);
          var o = new Zi(n.parent, n.index);

          n._remove();

          var r = o.nodeBefore,
              s = o.nodeAfter;
          return r instanceof fi && s instanceof fi ? Eo(r, s) : Mo(o);
        }
      }, {
        key: "_wrapAttributeElement",
        value: function _wrapAttributeElement(t, e) {
          if (!Ro(t, e)) return !1;
          if (t.name !== e.name || t.priority !== e.priority) return !1;
          var _iteratorNormalCompletion40 = true;
          var _didIteratorError40 = false;
          var _iteratorError40 = undefined;

          try {
            for (var _iterator40 = t.getAttributeKeys()[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
              var _n32 = _step40.value;
              if ("class" !== _n32 && "style" !== _n32 && e.hasAttribute(_n32) && e.getAttribute(_n32) !== t.getAttribute(_n32)) return !1;
            }
          } catch (err) {
            _didIteratorError40 = true;
            _iteratorError40 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion40 && _iterator40.return != null) {
                _iterator40.return();
              }
            } finally {
              if (_didIteratorError40) {
                throw _iteratorError40;
              }
            }
          }

          var _iteratorNormalCompletion41 = true;
          var _didIteratorError41 = false;
          var _iteratorError41 = undefined;

          try {
            for (var _iterator41 = t.getStyleNames()[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
              var _n33 = _step41.value;
              if (e.hasStyle(_n33) && e.getStyle(_n33) !== t.getStyle(_n33)) return !1;
            }
          } catch (err) {
            _didIteratorError41 = true;
            _iteratorError41 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion41 && _iterator41.return != null) {
                _iterator41.return();
              }
            } finally {
              if (_didIteratorError41) {
                throw _iteratorError41;
              }
            }
          }

          var _iteratorNormalCompletion42 = true;
          var _didIteratorError42 = false;
          var _iteratorError42 = undefined;

          try {
            for (var _iterator42 = t.getAttributeKeys()[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
              var _n34 = _step42.value;
              "class" !== _n34 && "style" !== _n34 && (e.hasAttribute(_n34) || this.setAttribute(_n34, t.getAttribute(_n34), e));
            }
          } catch (err) {
            _didIteratorError42 = true;
            _iteratorError42 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion42 && _iterator42.return != null) {
                _iterator42.return();
              }
            } finally {
              if (_didIteratorError42) {
                throw _iteratorError42;
              }
            }
          }

          var _iteratorNormalCompletion43 = true;
          var _didIteratorError43 = false;
          var _iteratorError43 = undefined;

          try {
            for (var _iterator43 = t.getStyleNames()[Symbol.iterator](), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
              var _n35 = _step43.value;
              e.hasStyle(_n35) || this.setStyle(_n35, t.getStyle(_n35), e);
            }
          } catch (err) {
            _didIteratorError43 = true;
            _iteratorError43 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion43 && _iterator43.return != null) {
                _iterator43.return();
              }
            } finally {
              if (_didIteratorError43) {
                throw _iteratorError43;
              }
            }
          }

          var _iteratorNormalCompletion44 = true;
          var _didIteratorError44 = false;
          var _iteratorError44 = undefined;

          try {
            for (var _iterator44 = t.getClassNames()[Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
              var _n36 = _step44.value;
              e.hasClass(_n36) || this.addClass(_n36, e);
            }
          } catch (err) {
            _didIteratorError44 = true;
            _iteratorError44 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion44 && _iterator44.return != null) {
                _iterator44.return();
              }
            } finally {
              if (_didIteratorError44) {
                throw _iteratorError44;
              }
            }
          }

          return !0;
        }
      }, {
        key: "_unwrapAttributeElement",
        value: function _unwrapAttributeElement(t, e) {
          if (!Ro(t, e)) return !1;
          if (t.name !== e.name || t.priority !== e.priority) return !1;
          var _iteratorNormalCompletion45 = true;
          var _didIteratorError45 = false;
          var _iteratorError45 = undefined;

          try {
            for (var _iterator45 = t.getAttributeKeys()[Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
              var _n37 = _step45.value;
              if ("class" !== _n37 && "style" !== _n37 && (!e.hasAttribute(_n37) || e.getAttribute(_n37) !== t.getAttribute(_n37))) return !1;
            }
          } catch (err) {
            _didIteratorError45 = true;
            _iteratorError45 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion45 && _iterator45.return != null) {
                _iterator45.return();
              }
            } finally {
              if (_didIteratorError45) {
                throw _iteratorError45;
              }
            }
          }

          if (!e.hasClass.apply(e, _toConsumableArray(t.getClassNames()))) return !1;
          var _iteratorNormalCompletion46 = true;
          var _didIteratorError46 = false;
          var _iteratorError46 = undefined;

          try {
            for (var _iterator46 = t.getStyleNames()[Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
              var _n38 = _step46.value;
              if (!e.hasStyle(_n38) || e.getStyle(_n38) !== t.getStyle(_n38)) return !1;
            }
          } catch (err) {
            _didIteratorError46 = true;
            _iteratorError46 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion46 && _iterator46.return != null) {
                _iterator46.return();
              }
            } finally {
              if (_didIteratorError46) {
                throw _iteratorError46;
              }
            }
          }

          var _iteratorNormalCompletion47 = true;
          var _didIteratorError47 = false;
          var _iteratorError47 = undefined;

          try {
            for (var _iterator47 = t.getAttributeKeys()[Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
              var _n39 = _step47.value;
              "class" !== _n39 && "style" !== _n39 && this.removeAttribute(_n39, e);
            }
          } catch (err) {
            _didIteratorError47 = true;
            _iteratorError47 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion47 && _iterator47.return != null) {
                _iterator47.return();
              }
            } finally {
              if (_didIteratorError47) {
                throw _iteratorError47;
              }
            }
          }

          return this.removeClass(Array.from(t.getClassNames()), e), this.removeStyle(Array.from(t.getStyleNames()), e), !0;
        }
      }, {
        key: "_breakAttributesRange",
        value: function _breakAttributesRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.start,
              i = t.end;

          if (Oo(t, this.document), t.isCollapsed) {
            var _n40 = this._breakAttributes(t.start, e);

            return new Xi(_n40, _n40);
          }

          var o = this._breakAttributes(i, e),
              r = o.parent.childCount,
              s = this._breakAttributes(n, e);

          return o.offset += o.parent.childCount - r, new Xi(s, o);
        }
      }, {
        key: "_breakAttributes",
        value: function _breakAttributes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.offset,
              i = t.parent;
          if (t.parent.is("emptyElement")) throw new Gn.b("view-writer-cannot-break-empty-element", this.document);
          if (t.parent.is("uiElement")) throw new Gn.b("view-writer-cannot-break-ui-element", this.document);
          if (!e && i.is("text") && No(i.parent)) return t.clone();
          if (No(i)) return t.clone();
          if (i.is("text")) return this._breakAttributes(So(t), e);

          if (n == i.childCount) {
            var _t37 = new Zi(i.parent, i.index + 1);

            return this._breakAttributes(_t37, e);
          }

          if (0 === n) {
            var _t38 = new Zi(i.parent, i.index);

            return this._breakAttributes(_t38, e);
          }

          {
            var _t39 = i.index + 1,
                _o16 = i._clone();

            i.parent._insertChild(_t39, _o16), this._addToClonedElementsGroup(_o16);

            var _r7 = i.childCount - n,
                _s6 = i._removeChildren(n, _r7);

            _o16._appendChild(_s6);

            var _a5 = new Zi(i.parent, _t39);

            return this._breakAttributes(_a5, e);
          }
        }
      }, {
        key: "_addToClonedElementsGroup",
        value: function _addToClonedElementsGroup(t) {
          if (!t.root.is("rootElement")) return;

          if (t.is("element")) {
            var _iteratorNormalCompletion48 = true;
            var _didIteratorError48 = false;
            var _iteratorError48 = undefined;

            try {
              for (var _iterator48 = t.getChildren()[Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
                var _e42 = _step48.value;

                this._addToClonedElementsGroup(_e42);
              }
            } catch (err) {
              _didIteratorError48 = true;
              _iteratorError48 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion48 && _iterator48.return != null) {
                  _iterator48.return();
                }
              } finally {
                if (_didIteratorError48) {
                  throw _iteratorError48;
                }
              }
            }
          }

          var e = t.id;
          if (!e) return;

          var n = this._cloneGroups.get(e);

          n || (n = new Set(), this._cloneGroups.set(e, n)), n.add(t), t._clonesGroup = n;
        }
      }, {
        key: "_removeFromClonedElementsGroup",
        value: function _removeFromClonedElementsGroup(t) {
          if (t.is("element")) {
            var _iteratorNormalCompletion49 = true;
            var _didIteratorError49 = false;
            var _iteratorError49 = undefined;

            try {
              for (var _iterator49 = t.getChildren()[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
                var _e43 = _step49.value;

                this._removeFromClonedElementsGroup(_e43);
              }
            } catch (err) {
              _didIteratorError49 = true;
              _iteratorError49 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion49 && _iterator49.return != null) {
                  _iterator49.return();
                }
              } finally {
                if (_didIteratorError49) {
                  throw _iteratorError49;
                }
              }
            }
          }

          var e = t.id;
          if (!e) return;

          var n = this._cloneGroups.get(e);

          n && n.delete(t);
        }
      }]);

      return Co;
    }();

    function To(t) {
      var e = t.parent;

      for (; !No(e);) {
        if (!e) return;
        e = e.parent;
      }

      return e;
    }

    function Po(t, e) {
      return t.priority < e.priority || !(t.priority > e.priority) && t.getIdentity() < e.getIdentity();
    }

    function Mo(t) {
      var e = t.nodeBefore;
      if (e && e.is("text")) return new Zi(e, e.data.length);
      var n = t.nodeAfter;
      return n && n.is("text") ? new Zi(n, 0) : t;
    }

    function So(t) {
      if (t.offset == t.parent.data.length) return new Zi(t.parent.parent, t.parent.index + 1);
      if (0 === t.offset) return new Zi(t.parent.parent, t.parent.index);
      var e = t.parent.data.slice(t.offset);
      return t.parent._data = t.parent.data.slice(0, t.offset), t.parent.parent._insertChild(t.parent.index + 1, new fi(e)), new Zi(t.parent.parent, t.parent.index + 1);
    }

    function Eo(t, e) {
      var n = t.data.length;
      return t._data += e.data, e._remove(), new Zi(t, n);
    }

    var Io = [fi, ao, yi, uo, vo];

    function No(t) {
      return t && (t.is("containerElement") || t.is("documentFragment"));
    }

    function Oo(t, e) {
      var n = To(t.start),
          i = To(t.end);
      if (!n || !i || n !== i) throw new Gn.b("view-writer-invalid-range-container", e);
    }

    function Ro(t, e) {
      return null === t.id && null === e.id;
    }

    function Do(t) {
      return "[object Text]" == Object.prototype.toString.call(t);
    }

    var Lo = function Lo(t) {
      var e = t.createElement("br");
      return e.dataset.ckeFiller = !0, e;
    },
        jo = function jo(t) {
      return t.createTextNode(" ");
    },
        Vo = 7;

    var Bo = "";

    for (var _t40 = 0; _t40 < Vo; _t40++) {
      Bo += "​";
    }

    function zo(t) {
      return Do(t) && t.data.substr(0, Vo) === Bo;
    }

    function Fo(t) {
      return t.data.length == Vo && zo(t);
    }

    function Uo(t) {
      return zo(t) ? t.data.slice(Vo) : t.data;
    }

    var Ho = new WeakMap();

    function qo(t, e) {
      var n = Ho.get(e);
      return n || (n = e(window.document), Ho.set(e, n)), t.isEqualNode(n);
    }

    function Wo(t, e) {
      if (e.keyCode == bo.arrowleft) {
        var _t41 = e.domTarget.ownerDocument.defaultView.getSelection();

        if (1 == _t41.rangeCount && _t41.getRangeAt(0).collapsed) {
          var _e44 = _t41.getRangeAt(0).startContainer,
              _n41 = _t41.getRangeAt(0).startOffset;

          zo(_e44) && _n41 <= Vo && _t41.collapse(_e44, 0);
        }
      }
    }

    function Yo(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      n = n || function (t, e) {
        return t === e;
      }, Array.isArray(t) || (t = Array.from(t)), Array.isArray(e) || (e = Array.from(e));

      var o = function (t, e, n) {
        var i = $o(t, e, n);
        if (-1 === i) return {
          firstIndex: -1,
          lastIndexOld: -1,
          lastIndexNew: -1
        };
        var o = Go(t, i),
            r = Go(e, i),
            s = $o(o, r, n),
            a = t.length - s,
            c = e.length - s;
        return {
          firstIndex: i,
          lastIndexOld: a,
          lastIndexNew: c
        };
      }(t, e, n);

      return i ? function (t, e) {
        var n = t.firstIndex,
            i = t.lastIndexOld,
            o = t.lastIndexNew;
        if (-1 === n) return Array(e).fill("equal");
        var r = [];
        n > 0 && (r = r.concat(Array(n).fill("equal")));
        o - n > 0 && (r = r.concat(Array(o - n).fill("insert")));
        i - n > 0 && (r = r.concat(Array(i - n).fill("delete")));
        o < e && (r = r.concat(Array(e - o).fill("equal")));
        return r;
      }(o, e.length) : function (t, e) {
        var n = [],
            i = e.firstIndex,
            o = e.lastIndexOld,
            r = e.lastIndexNew;
        r - i > 0 && n.push({
          index: i,
          type: "insert",
          values: t.slice(i, r)
        });
        o - i > 0 && n.push({
          index: i + (r - i),
          type: "delete",
          howMany: o - i
        });
        return n;
      }(e, o);
    }

    function $o(t, e, n) {
      for (var _i32 = 0; _i32 < Math.max(t.length, e.length); _i32++) {
        if (void 0 === t[_i32] || void 0 === e[_i32] || !n(t[_i32], e[_i32])) return _i32;
      }

      return -1;
    }

    function Go(t, e) {
      return t.slice(e).reverse();
    }

    function Qo(t, e, n) {
      n = n || function (t, e) {
        return t === e;
      };

      var i = t.length,
          o = e.length;
      if (i > 200 || o > 200 || i + o > 300) return Qo.fastDiff(t, e, n, !0);
      var r, s;

      if (o < i) {
        var _n42 = t;
        t = e, e = _n42, r = "delete", s = "insert";
      } else r = "insert", s = "delete";

      var a = t.length,
          c = e.length,
          l = c - a,
          d = {},
          u = {};

      function h(i) {
        var o = (void 0 !== u[i - 1] ? u[i - 1] : -1) + 1,
            l = void 0 !== u[i + 1] ? u[i + 1] : -1,
            h = o > l ? -1 : 1;
        d[i + h] && (d[i] = d[i + h].slice(0)), d[i] || (d[i] = []), d[i].push(o > l ? r : s);
        var f = Math.max(o, l),
            m = f - i;

        for (; m < a && f < c && n(t[m], e[f]);) {
          m++, f++, d[i].push("equal");
        }

        return f;
      }

      var f,
          m = 0;

      do {
        for (f = -m; f < l; f++) {
          u[f] = h(f);
        }

        for (f = l + m; f > l; f--) {
          u[f] = h(f);
        }

        u[l] = h(l), m++;
      } while (u[l] !== c);

      return d[l].slice(1);
    }

    function Jo(t, e, n) {
      t.insertBefore(n, t.childNodes[e] || null);
    }

    function Ko(t) {
      var e = t.parentNode;
      e && e.removeChild(t);
    }

    function Zo(t) {
      if (t) {
        if (t.defaultView) return t instanceof t.defaultView.Document;
        if (t.ownerDocument && t.ownerDocument.defaultView) return t instanceof t.ownerDocument.defaultView.Node;
      }

      return !1;
    }

    Qo.fastDiff = Yo;

    var Xo =
    /*#__PURE__*/
    function () {
      function Xo(t, e) {
        _classCallCheck(this, Xo);

        this.domDocuments = new Set(), this.domConverter = t, this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this.selection = e, this.isFocused = !1, this._inlineFiller = null, this._fakeSelectionContainer = null;
      }

      _createClass(Xo, [{
        key: "markToSync",
        value: function markToSync(t, e) {
          if ("text" === t) this.domConverter.mapViewToDom(e.parent) && this.markedTexts.add(e);else {
            if (!this.domConverter.mapViewToDom(e)) return;
            if ("attributes" === t) this.markedAttributes.add(e);else {
              if ("children" !== t) throw new Gn.b("view-renderer-unknown-type: Unknown type passed to Renderer.markToSync.", this);
              this.markedChildren.add(e);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var t;
          var _iteratorNormalCompletion50 = true;
          var _didIteratorError50 = false;
          var _iteratorError50 = undefined;

          try {
            for (var _iterator50 = this.markedChildren[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
              var _t42 = _step50.value;

              this._updateChildrenMappings(_t42);
            }
          } catch (err) {
            _didIteratorError50 = true;
            _iteratorError50 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion50 && _iterator50.return != null) {
                _iterator50.return();
              }
            } finally {
              if (_didIteratorError50) {
                throw _iteratorError50;
              }
            }
          }

          this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent));
          var _iteratorNormalCompletion51 = true;
          var _didIteratorError51 = false;
          var _iteratorError51 = undefined;

          try {
            for (var _iterator51 = this.markedAttributes[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
              var _t43 = _step51.value;

              this._updateAttrs(_t43);
            }
          } catch (err) {
            _didIteratorError51 = true;
            _iteratorError51 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion51 && _iterator51.return != null) {
                _iterator51.return();
              }
            } finally {
              if (_didIteratorError51) {
                throw _iteratorError51;
              }
            }
          }

          var _iteratorNormalCompletion52 = true;
          var _didIteratorError52 = false;
          var _iteratorError52 = undefined;

          try {
            for (var _iterator52 = this.markedChildren[Symbol.iterator](), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
              var _e46 = _step52.value;

              this._updateChildren(_e46, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _didIteratorError52 = true;
            _iteratorError52 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion52 && _iterator52.return != null) {
                _iterator52.return();
              }
            } finally {
              if (_didIteratorError52) {
                throw _iteratorError52;
              }
            }
          }

          var _iteratorNormalCompletion53 = true;
          var _didIteratorError53 = false;
          var _iteratorError53 = undefined;

          try {
            for (var _iterator53 = this.markedTexts[Symbol.iterator](), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
              var _e47 = _step53.value;
              !this.markedChildren.has(_e47.parent) && this.domConverter.mapViewToDom(_e47.parent) && this._updateText(_e47, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _didIteratorError53 = true;
            _iteratorError53 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion53 && _iterator53.return != null) {
                _iterator53.return();
              }
            } finally {
              if (_didIteratorError53) {
                throw _iteratorError53;
              }
            }
          }

          if (t) {
            var _e45 = this.domConverter.viewPositionToDom(t),
                _n43 = _e45.parent.ownerDocument;

            zo(_e45.parent) ? this._inlineFiller = _e45.parent : this._inlineFiller = tr(_n43, _e45.parent, _e45.offset);
          } else this._inlineFiller = null;

          this._updateSelection(), this._updateFocus(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
        }
      }, {
        key: "_updateChildrenMappings",
        value: function _updateChildrenMappings(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) return;

          var n = this.domConverter.mapViewToDom(t).childNodes,
              i = Array.from(this.domConverter.viewChildrenToDom(t, e.ownerDocument, {
            withChildren: !1
          })),
              o = this._diffNodeLists(n, i),
              r = this._findReplaceActions(o, n, i);

          if (-1 !== r.indexOf("replace")) {
            var _e48 = {
              equal: 0,
              insert: 0,
              delete: 0
            };
            var _iteratorNormalCompletion54 = true;
            var _didIteratorError54 = false;
            var _iteratorError54 = undefined;

            try {
              for (var _iterator54 = r[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
                var _o17 = _step54.value;

                if ("replace" === _o17) {
                  var _o18 = _e48.equal + _e48.insert,
                      _r8 = _e48.equal + _e48.delete,
                      _s7 = t.getChild(_o18);

                  _s7 && !_s7.is("uiElement") && this._updateElementMappings(_s7, n[_r8]), Ko(i[_o18]), _e48.equal++;
                } else _e48[_o17]++;
              }
            } catch (err) {
              _didIteratorError54 = true;
              _iteratorError54 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion54 && _iterator54.return != null) {
                  _iterator54.return();
                }
              } finally {
                if (_didIteratorError54) {
                  throw _iteratorError54;
                }
              }
            }
          }
        }
      }, {
        key: "_updateElementMappings",
        value: function _updateElementMappings(t, e) {
          this.domConverter.unbindDomElement(e), this.domConverter.bindElements(e, t), this.markedChildren.add(t), this.markedAttributes.add(t);
        }
      }, {
        key: "_getInlineFillerPosition",
        value: function _getInlineFillerPosition() {
          var t = this.selection.getFirstPosition();
          return t.parent.is("text") ? Zi._createBefore(this.selection.getFirstPosition().parent) : t;
        }
      }, {
        key: "_isSelectionInInlineFiller",
        value: function _isSelectionInInlineFiller() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var t = this.selection.getFirstPosition(),
              e = this.domConverter.viewPositionToDom(t);
          return !!(e && Do(e.parent) && zo(e.parent));
        }
      }, {
        key: "_removeInlineFiller",
        value: function _removeInlineFiller() {
          var t = this._inlineFiller;
          if (!zo(t)) throw new Gn.b("view-renderer-filler-was-lost: The inline filler node was lost.", this);
          Fo(t) ? t.parentNode.removeChild(t) : t.data = t.data.substr(Vo), this._inlineFiller = null;
        }
      }, {
        key: "_needsInlineFillerAtSelection",
        value: function _needsInlineFillerAtSelection() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var t = this.selection.getFirstPosition(),
              e = t.parent,
              n = t.offset;
          if (!this.domConverter.mapViewToDom(e.root)) return !1;
          if (!e.is("element")) return !1;
          if (!function (t) {
            if ("false" == t.getAttribute("contenteditable")) return !1;
            var e = t.findAncestor(function (t) {
              return t.hasAttribute("contenteditable");
            });
            return !e || "true" == e.getAttribute("contenteditable");
          }(e)) return !1;
          if (n === e.getFillerOffset()) return !1;
          var i = t.nodeBefore,
              o = t.nodeAfter;
          return !(i instanceof fi || o instanceof fi);
        }
      }, {
        key: "_updateText",
        value: function _updateText(t, e) {
          var n = this.domConverter.findCorrespondingDomText(t),
              i = this.domConverter.viewToDom(t, n.ownerDocument),
              o = n.data;
          var r = i.data;
          var s = e.inlineFillerPosition;

          if (s && s.parent == t.parent && s.offset == t.index && (r = Bo + r), o != r) {
            var _t44 = Yo(o, r);

            var _iteratorNormalCompletion55 = true;
            var _didIteratorError55 = false;
            var _iteratorError55 = undefined;

            try {
              for (var _iterator55 = _t44[Symbol.iterator](), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
                var _e49 = _step55.value;
                "insert" === _e49.type ? n.insertData(_e49.index, _e49.values.join("")) : n.deleteData(_e49.index, _e49.howMany);
              }
            } catch (err) {
              _didIteratorError55 = true;
              _iteratorError55 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion55 && _iterator55.return != null) {
                  _iterator55.return();
                }
              } finally {
                if (_didIteratorError55) {
                  throw _iteratorError55;
                }
              }
            }
          }
        }
      }, {
        key: "_updateAttrs",
        value: function _updateAttrs(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) return;
          var n = Array.from(e.attributes).map(function (t) {
            return t.name;
          }),
              i = t.getAttributeKeys();
          var _iteratorNormalCompletion56 = true;
          var _didIteratorError56 = false;
          var _iteratorError56 = undefined;

          try {
            for (var _iterator56 = i[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
              var _n44 = _step56.value;
              e.setAttribute(_n44, t.getAttribute(_n44));
            }
          } catch (err) {
            _didIteratorError56 = true;
            _iteratorError56 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion56 && _iterator56.return != null) {
                _iterator56.return();
              }
            } finally {
              if (_didIteratorError56) {
                throw _iteratorError56;
              }
            }
          }

          var _iteratorNormalCompletion57 = true;
          var _didIteratorError57 = false;
          var _iteratorError57 = undefined;

          try {
            for (var _iterator57 = n[Symbol.iterator](), _step57; !(_iteratorNormalCompletion57 = (_step57 = _iterator57.next()).done); _iteratorNormalCompletion57 = true) {
              var _i33 = _step57.value;
              t.hasAttribute(_i33) || e.removeAttribute(_i33);
            }
          } catch (err) {
            _didIteratorError57 = true;
            _iteratorError57 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion57 && _iterator57.return != null) {
                _iterator57.return();
              }
            } finally {
              if (_didIteratorError57) {
                throw _iteratorError57;
              }
            }
          }
        }
      }, {
        key: "_updateChildren",
        value: function _updateChildren(t, e) {
          var n = this.domConverter.mapViewToDom(t);
          if (!n) return;
          var i = e.inlineFillerPosition,
              o = this.domConverter.mapViewToDom(t).childNodes,
              r = Array.from(this.domConverter.viewChildrenToDom(t, n.ownerDocument, {
            bind: !0,
            inlineFillerPosition: i
          }));
          i && i.parent === t && tr(n.ownerDocument, r, i.offset);

          var s = this._diffNodeLists(o, r);

          var a = 0;
          var c = new Set();
          var _iteratorNormalCompletion58 = true;
          var _didIteratorError58 = false;
          var _iteratorError58 = undefined;

          try {
            for (var _iterator58 = s[Symbol.iterator](), _step58; !(_iteratorNormalCompletion58 = (_step58 = _iterator58.next()).done); _iteratorNormalCompletion58 = true) {
              var _t45 = _step58.value;
              "insert" === _t45 ? (Jo(n, a, r[a]), a++) : "delete" === _t45 ? (c.add(o[a]), Ko(o[a])) : (this._markDescendantTextToSync(this.domConverter.domToView(r[a])), a++);
            }
          } catch (err) {
            _didIteratorError58 = true;
            _iteratorError58 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion58 && _iterator58.return != null) {
                _iterator58.return();
              }
            } finally {
              if (_didIteratorError58) {
                throw _iteratorError58;
              }
            }
          }

          var _iteratorNormalCompletion59 = true;
          var _didIteratorError59 = false;
          var _iteratorError59 = undefined;

          try {
            for (var _iterator59 = c[Symbol.iterator](), _step59; !(_iteratorNormalCompletion59 = (_step59 = _iterator59.next()).done); _iteratorNormalCompletion59 = true) {
              var _t46 = _step59.value;
              _t46.parentNode || this.domConverter.unbindDomElement(_t46);
            }
          } catch (err) {
            _didIteratorError59 = true;
            _iteratorError59 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion59 && _iterator59.return != null) {
                _iterator59.return();
              }
            } finally {
              if (_didIteratorError59) {
                throw _iteratorError59;
              }
            }
          }
        }
      }, {
        key: "_diffNodeLists",
        value: function _diffNodeLists(t, e) {
          return Qo(t = function (t, e) {
            var n = Array.from(t);
            if (0 == n.length || !e) return n;
            n[n.length - 1] == e && n.pop();
            return n;
          }(t, this._fakeSelectionContainer), e, function (t, e, n) {
            if (e === n) return !0;
            if (Do(e) && Do(n)) return e.data === n.data;
            if (qo(e, t) && qo(n, t)) return !0;
            return !1;
          }.bind(null, this.domConverter.blockFiller));
        }
      }, {
        key: "_findReplaceActions",
        value: function _findReplaceActions(t, e, n) {
          if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete")) return t;
          var i = [],
              o = [],
              r = [];
          var s = {
            equal: 0,
            insert: 0,
            delete: 0
          };
          var _iteratorNormalCompletion60 = true;
          var _didIteratorError60 = false;
          var _iteratorError60 = undefined;

          try {
            for (var _iterator60 = t[Symbol.iterator](), _step60; !(_iteratorNormalCompletion60 = (_step60 = _iterator60.next()).done); _iteratorNormalCompletion60 = true) {
              var _a6 = _step60.value;
              "insert" === _a6 ? r.push(n[s.equal + s.insert]) : "delete" === _a6 ? o.push(e[s.equal + s.delete]) : ((i = i.concat(Qo(o, r, er).map(function (t) {
                return "equal" === t ? "replace" : t;
              }))).push("equal"), o = [], r = []), s[_a6]++;
            }
          } catch (err) {
            _didIteratorError60 = true;
            _iteratorError60 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion60 && _iterator60.return != null) {
                _iterator60.return();
              }
            } finally {
              if (_didIteratorError60) {
                throw _iteratorError60;
              }
            }
          }

          return i.concat(Qo(o, r, er).map(function (t) {
            return "equal" === t ? "replace" : t;
          }));
        }
      }, {
        key: "_markDescendantTextToSync",
        value: function _markDescendantTextToSync(t) {
          if (t) if (t.is("text")) this.markedTexts.add(t);else if (t.is("element")) {
            var _iteratorNormalCompletion61 = true;
            var _didIteratorError61 = false;
            var _iteratorError61 = undefined;

            try {
              for (var _iterator61 = t.getChildren()[Symbol.iterator](), _step61; !(_iteratorNormalCompletion61 = (_step61 = _iterator61.next()).done); _iteratorNormalCompletion61 = true) {
                var _e50 = _step61.value;

                this._markDescendantTextToSync(_e50);
              }
            } catch (err) {
              _didIteratorError61 = true;
              _iteratorError61 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion61 && _iterator61.return != null) {
                  _iterator61.return();
                }
              } finally {
                if (_didIteratorError61) {
                  throw _iteratorError61;
                }
              }
            }
          }
        }
      }, {
        key: "_updateSelection",
        value: function _updateSelection() {
          if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
          var t = this.domConverter.mapViewToDom(this.selection.editableElement);
          this.isFocused && t && (this.selection.isFake ? this._updateFakeSelection(t) : (this._removeFakeSelection(), this._updateDomSelection(t)));
        }
      }, {
        key: "_updateFakeSelection",
        value: function _updateFakeSelection(t) {
          var e = t.ownerDocument;
          var n = this._fakeSelectionContainer;
          n || (this._fakeSelectionContainer = n = e.createElement("div"), Object.assign(n.style, {
            position: "fixed",
            top: 0,
            left: "-9999px",
            width: "42px"
          }), n.textContent = " "), n.parentElement && n.parentElement == t || t.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
          var i = e.getSelection(),
              o = e.createRange();
          i.removeAllRanges(), o.selectNodeContents(n), i.addRange(o), this.domConverter.bindFakeSelection(n, this.selection);
        }
      }, {
        key: "_updateDomSelection",
        value: function _updateDomSelection(t) {
          var e = t.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(e)) return;
          var n = this.domConverter.viewPositionToDom(this.selection.anchor),
              i = this.domConverter.viewPositionToDom(this.selection.focus);
          t.focus(), e.collapse(n.parent, n.offset), e.extend(i.parent, i.offset), mo.isGecko && function (t, e) {
            var n = t.parent;
            if (n.nodeType != Node.ELEMENT_NODE || t.offset != n.childNodes.length - 1) return;
            var i = n.childNodes[t.offset];
            i && "BR" == i.tagName && e.addRange(e.getRangeAt(0));
          }(i, e);
        }
      }, {
        key: "_domSelectionNeedsUpdate",
        value: function _domSelectionNeedsUpdate(t) {
          if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
          var e = t && this.domConverter.domSelectionToView(t);
          return (!e || !this.selection.isEqual(e)) && !(!this.selection.isCollapsed && this.selection.isSimilar(e));
        }
      }, {
        key: "_removeDomSelection",
        value: function _removeDomSelection() {
          var _iteratorNormalCompletion62 = true;
          var _didIteratorError62 = false;
          var _iteratorError62 = undefined;

          try {
            for (var _iterator62 = this.domDocuments[Symbol.iterator](), _step62; !(_iteratorNormalCompletion62 = (_step62 = _iterator62.next()).done); _iteratorNormalCompletion62 = true) {
              var _t47 = _step62.value;

              if (_t47.getSelection().rangeCount) {
                var _e51 = _t47.activeElement,
                    _n45 = this.domConverter.mapDomToView(_e51);

                _e51 && _n45 && _t47.getSelection().removeAllRanges();
              }
            }
          } catch (err) {
            _didIteratorError62 = true;
            _iteratorError62 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion62 && _iterator62.return != null) {
                _iterator62.return();
              }
            } finally {
              if (_didIteratorError62) {
                throw _iteratorError62;
              }
            }
          }
        }
      }, {
        key: "_removeFakeSelection",
        value: function _removeFakeSelection() {
          var t = this._fakeSelectionContainer;
          t && t.remove();
        }
      }, {
        key: "_updateFocus",
        value: function _updateFocus() {
          if (this.isFocused) {
            var _t48 = this.selection.editableElement;
            _t48 && this.domConverter.focus(_t48);
          }
        }
      }]);

      return Xo;
    }();

    function tr(t, e, n) {
      var i = e instanceof Array ? e : e.childNodes,
          o = i[n];
      if (Do(o)) return o.data = Bo + o.data, o;
      {
        var _o19 = t.createTextNode(Bo);

        return Array.isArray(e) ? i.splice(n, 0, _o19) : Jo(e, n, _o19), _o19;
      }
    }

    function er(t, e) {
      return Zo(t) && Zo(e) && !Do(t) && !Do(e) && t.tagName.toLowerCase() === e.tagName.toLowerCase();
    }

    ci(Xo, Fi);
    var nr = {
      window: window,
      document: document
    };

    function ir(t) {
      var e = 0;

      for (; t.previousSibling;) {
        t = t.previousSibling, e++;
      }

      return e;
    }

    function or(t) {
      var e = [];

      for (; t && t.nodeType != Node.DOCUMENT_NODE;) {
        e.unshift(t), t = t.parentNode;
      }

      return e;
    }

    var rr =
    /*#__PURE__*/
    function () {
      function rr() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, rr);

        this.blockFiller = t.blockFiller || Lo, this.preElements = ["pre"], this.blockElements = ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"], this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap();
      }

      _createClass(rr, [{
        key: "bindFakeSelection",
        value: function bindFakeSelection(t, e) {
          this._fakeSelectionMapping.set(t, new no(e));
        }
      }, {
        key: "fakeSelectionToView",
        value: function fakeSelectionToView(t) {
          return this._fakeSelectionMapping.get(t);
        }
      }, {
        key: "bindElements",
        value: function bindElements(t, e) {
          this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "unbindDomElement",
        value: function unbindDomElement(t) {
          var e = this._domToViewMapping.get(t);

          if (e) {
            this._domToViewMapping.delete(t), this._viewToDomMapping.delete(e);

            for (var _i34 = 0, _Array$from = Array.from(t.childNodes); _i34 < _Array$from.length; _i34++) {
              var _e52 = _Array$from[_i34];
              this.unbindDomElement(_e52);
            }
          }
        }
      }, {
        key: "bindDocumentFragments",
        value: function bindDocumentFragments(t, e) {
          this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "viewToDom",
        value: function viewToDom(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if (t.is("text")) {
            var _n46 = this._processDataFromViewText(t);

            return e.createTextNode(_n46);
          }

          {
            if (this.mapViewToDom(t)) return this.mapViewToDom(t);

            var _i35;

            if (t.is("documentFragment")) _i35 = e.createDocumentFragment(), n.bind && this.bindDocumentFragments(_i35, t);else {
              if (t.is("uiElement")) return _i35 = t.render(e), n.bind && this.bindElements(_i35, t), _i35;
              _i35 = e.createElement(t.name), n.bind && this.bindElements(_i35, t);
              var _iteratorNormalCompletion63 = true;
              var _didIteratorError63 = false;
              var _iteratorError63 = undefined;

              try {
                for (var _iterator63 = t.getAttributeKeys()[Symbol.iterator](), _step63; !(_iteratorNormalCompletion63 = (_step63 = _iterator63.next()).done); _iteratorNormalCompletion63 = true) {
                  var _e53 = _step63.value;

                  _i35.setAttribute(_e53, t.getAttribute(_e53));
                }
              } catch (err) {
                _didIteratorError63 = true;
                _iteratorError63 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion63 && _iterator63.return != null) {
                    _iterator63.return();
                  }
                } finally {
                  if (_didIteratorError63) {
                    throw _iteratorError63;
                  }
                }
              }
            }

            if (n.withChildren || void 0 === n.withChildren) {
              var _iteratorNormalCompletion64 = true;
              var _didIteratorError64 = false;
              var _iteratorError64 = undefined;

              try {
                for (var _iterator64 = this.viewChildrenToDom(t, e, n)[Symbol.iterator](), _step64; !(_iteratorNormalCompletion64 = (_step64 = _iterator64.next()).done); _iteratorNormalCompletion64 = true) {
                  var _o20 = _step64.value;

                  _i35.appendChild(_o20);
                }
              } catch (err) {
                _didIteratorError64 = true;
                _iteratorError64 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion64 && _iterator64.return != null) {
                    _iterator64.return();
                  }
                } finally {
                  if (_didIteratorError64) {
                    throw _iteratorError64;
                  }
                }
              }
            }

            return _i35;
          }
        }
      }, {
        key: "viewChildrenToDom",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function viewChildrenToDom(t, e) {
          var n,
              i,
              o,
              _iteratorNormalCompletion65,
              _didIteratorError65,
              _iteratorError65,
              _iterator65,
              _step65,
              _r9,
              _args9 = arguments;

          return _regeneratorRuntime.wrap(function viewChildrenToDom$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  n = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
                  i = t.getFillerOffset && t.getFillerOffset();
                  o = 0;
                  _iteratorNormalCompletion65 = true;
                  _didIteratorError65 = false;
                  _iteratorError65 = undefined;
                  _context9.prev = 6;
                  _iterator65 = t.getChildren()[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion65 = (_step65 = _iterator65.next()).done) {
                    _context9.next = 20;
                    break;
                  }

                  _r9 = _step65.value;
                  _context9.t0 = i === o;

                  if (!_context9.t0) {
                    _context9.next = 14;
                    break;
                  }

                  _context9.next = 14;
                  return this.blockFiller(e);

                case 14:
                  _context9.next = 16;
                  return this.viewToDom(_r9, e, n);

                case 16:
                  o++;

                case 17:
                  _iteratorNormalCompletion65 = true;
                  _context9.next = 8;
                  break;

                case 20:
                  _context9.next = 26;
                  break;

                case 22:
                  _context9.prev = 22;
                  _context9.t1 = _context9["catch"](6);
                  _didIteratorError65 = true;
                  _iteratorError65 = _context9.t1;

                case 26:
                  _context9.prev = 26;
                  _context9.prev = 27;

                  if (!_iteratorNormalCompletion65 && _iterator65.return != null) {
                    _iterator65.return();
                  }

                case 29:
                  _context9.prev = 29;

                  if (!_didIteratorError65) {
                    _context9.next = 32;
                    break;
                  }

                  throw _iteratorError65;

                case 32:
                  return _context9.finish(29);

                case 33:
                  return _context9.finish(26);

                case 34:
                  _context9.t2 = i === o;

                  if (!_context9.t2) {
                    _context9.next = 38;
                    break;
                  }

                  _context9.next = 38;
                  return this.blockFiller(e);

                case 38:
                case "end":
                  return _context9.stop();
              }
            }
          }, viewChildrenToDom, this, [[6, 22, 26, 34], [27,, 29, 33]]);
        })
      }, {
        key: "viewRangeToDom",
        value: function viewRangeToDom(t) {
          var e = this.viewPositionToDom(t.start),
              n = this.viewPositionToDom(t.end),
              i = document.createRange();
          return i.setStart(e.parent, e.offset), i.setEnd(n.parent, n.offset), i;
        }
      }, {
        key: "viewPositionToDom",
        value: function viewPositionToDom(t) {
          var e = t.parent;

          if (e.is("text")) {
            var _n47 = this.findCorrespondingDomText(e);

            if (!_n47) return null;
            var _i36 = t.offset;
            return zo(_n47) && (_i36 += Vo), {
              parent: _n47,
              offset: _i36
            };
          }

          {
            var _n48, _i37, _o21;

            if (0 === t.offset) {
              if (!(_n48 = this.mapViewToDom(e))) return null;
              _o21 = _n48.childNodes[0];
            } else {
              var _e54 = t.nodeBefore;
              if (!(_i37 = _e54.is("text") ? this.findCorrespondingDomText(_e54) : this.mapViewToDom(t.nodeBefore))) return null;
              _n48 = _i37.parentNode, _o21 = _i37.nextSibling;
            }

            if (Do(_o21) && zo(_o21)) return {
              parent: _o21,
              offset: Vo
            };
            return {
              parent: _n48,
              offset: _i37 ? ir(_i37) + 1 : 0
            };
          }
        }
      }, {
        key: "domToView",
        value: function domToView(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (qo(t, this.blockFiller)) return null;
          var n = this.getParentUIElement(t, this._domToViewMapping);
          if (n) return n;

          if (Do(t)) {
            if (Fo(t)) return null;
            {
              var _e55 = this._processDataFromDomText(t);

              return "" === _e55 ? null : new fi(_e55);
            }
          }

          if (this.isComment(t)) return null;
          {
            if (this.mapDomToView(t)) return this.mapDomToView(t);

            var _n49;

            if (this.isDocumentFragment(t)) _n49 = new Ao(), e.bind && this.bindDocumentFragments(t, _n49);else {
              var _i38 = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();

              _n49 = new _i(_i38), e.bind && this.bindElements(t, _n49);
              var _o22 = t.attributes;

              for (var _t49 = _o22.length - 1; _t49 >= 0; _t49--) {
                _n49._setAttribute(_o22[_t49].name, _o22[_t49].value);
              }
            }

            if (e.withChildren || void 0 === e.withChildren) {
              var _iteratorNormalCompletion66 = true;
              var _didIteratorError66 = false;
              var _iteratorError66 = undefined;

              try {
                for (var _iterator66 = this.domChildrenToView(t, e)[Symbol.iterator](), _step66; !(_iteratorNormalCompletion66 = (_step66 = _iterator66.next()).done); _iteratorNormalCompletion66 = true) {
                  var _i39 = _step66.value;

                  _n49._appendChild(_i39);
                }
              } catch (err) {
                _didIteratorError66 = true;
                _iteratorError66 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion66 && _iterator66.return != null) {
                    _iterator66.return();
                  }
                } finally {
                  if (_didIteratorError66) {
                    throw _iteratorError66;
                  }
                }
              }
            }

            return _n49;
          }
        }
      }, {
        key: "domChildrenToView",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function domChildrenToView(t) {
          var e,
              _n50,
              _i40,
              _o23,
              _args10 = arguments;

          return _regeneratorRuntime.wrap(function domChildrenToView$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  e = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
                  _n50 = 0;

                case 2:
                  if (!(_n50 < t.childNodes.length)) {
                    _context10.next = 11;
                    break;
                  }

                  _i40 = t.childNodes[_n50], _o23 = this.domToView(_i40, e);
                  _context10.t0 = null !== _o23;

                  if (!_context10.t0) {
                    _context10.next = 8;
                    break;
                  }

                  _context10.next = 8;
                  return _o23;

                case 8:
                  _n50++;
                  _context10.next = 2;
                  break;

                case 11:
                case "end":
                  return _context10.stop();
              }
            }
          }, domChildrenToView, this);
        })
      }, {
        key: "domSelectionToView",
        value: function domSelectionToView(t) {
          if (1 === t.rangeCount) {
            var _e56 = t.getRangeAt(0).startContainer;
            Do(_e56) && (_e56 = _e56.parentNode);

            var _n51 = this.fakeSelectionToView(_e56);

            if (_n51) return _n51;
          }

          var e = this.isDomSelectionBackward(t),
              n = [];

          for (var _e57 = 0; _e57 < t.rangeCount; _e57++) {
            var _i41 = t.getRangeAt(_e57),
                _o24 = this.domRangeToView(_i41);

            _o24 && n.push(_o24);
          }

          return new no(n, {
            backward: e
          });
        }
      }, {
        key: "domRangeToView",
        value: function domRangeToView(t) {
          var e = this.domPositionToView(t.startContainer, t.startOffset),
              n = this.domPositionToView(t.endContainer, t.endOffset);
          return e && n ? new Xi(e, n) : null;
        }
      }, {
        key: "domPositionToView",
        value: function domPositionToView(t, e) {
          if (qo(t, this.blockFiller)) return this.domPositionToView(t.parentNode, ir(t));
          var n = this.mapDomToView(t);
          if (n && n.is("uiElement")) return Zi._createBefore(n);

          if (Do(t)) {
            if (Fo(t)) return this.domPositionToView(t.parentNode, ir(t));

            var _n52 = this.findCorrespondingViewText(t);

            var _i42 = e;
            return _n52 ? (zo(t) && (_i42 = (_i42 -= Vo) < 0 ? 0 : _i42), new Zi(_n52, _i42)) : null;
          }

          if (0 === e) {
            var _e58 = this.mapDomToView(t);

            if (_e58) return new Zi(_e58, 0);
          } else {
            var _n53 = t.childNodes[e - 1],
                _i43 = Do(_n53) ? this.findCorrespondingViewText(_n53) : this.mapDomToView(_n53);

            if (_i43 && _i43.parent) return new Zi(_i43.parent, _i43.index + 1);
          }

          return null;
        }
      }, {
        key: "mapDomToView",
        value: function mapDomToView(t) {
          return this.getParentUIElement(t) || this._domToViewMapping.get(t);
        }
      }, {
        key: "findCorrespondingViewText",
        value: function findCorrespondingViewText(t) {
          if (Fo(t)) return null;
          var e = this.getParentUIElement(t);
          if (e) return e;
          var n = t.previousSibling;

          if (n) {
            if (!this.isElement(n)) return null;

            var _t50 = this.mapDomToView(n);

            if (_t50) {
              return _t50.nextSibling instanceof fi ? _t50.nextSibling : null;
            }
          } else {
            var _e59 = this.mapDomToView(t.parentNode);

            if (_e59) {
              var _t51 = _e59.getChild(0);

              return _t51 instanceof fi ? _t51 : null;
            }
          }

          return null;
        }
      }, {
        key: "mapViewToDom",
        value: function mapViewToDom(t) {
          return this._viewToDomMapping.get(t);
        }
      }, {
        key: "findCorrespondingDomText",
        value: function findCorrespondingDomText(t) {
          var e = t.previousSibling;
          return e && this.mapViewToDom(e) ? this.mapViewToDom(e).nextSibling : !e && t.parent && this.mapViewToDom(t.parent) ? this.mapViewToDom(t.parent).childNodes[0] : null;
        }
      }, {
        key: "focus",
        value: function focus(t) {
          var e = this.mapViewToDom(t);

          if (e && e.ownerDocument.activeElement !== e) {
            var _nr$window = nr.window,
                _t52 = _nr$window.scrollX,
                _n54 = _nr$window.scrollY,
                _i44 = [];
            ar(e, function (t) {
              var e = t.scrollLeft,
                  n = t.scrollTop;

              _i44.push([e, n]);
            }), e.focus(), ar(e, function (t) {
              var _i44$shift = _i44.shift(),
                  _i44$shift2 = _slicedToArray(_i44$shift, 2),
                  e = _i44$shift2[0],
                  n = _i44$shift2[1];

              t.scrollLeft = e, t.scrollTop = n;
            }), nr.window.scrollTo(_t52, _n54);
          }
        }
      }, {
        key: "isElement",
        value: function isElement(t) {
          return t && t.nodeType == Node.ELEMENT_NODE;
        }
      }, {
        key: "isDocumentFragment",
        value: function isDocumentFragment(t) {
          return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
      }, {
        key: "isComment",
        value: function isComment(t) {
          return t && t.nodeType == Node.COMMENT_NODE;
        }
      }, {
        key: "isDomSelectionBackward",
        value: function isDomSelectionBackward(t) {
          if (t.isCollapsed) return !1;
          var e = document.createRange();
          e.setStart(t.anchorNode, t.anchorOffset), e.setEnd(t.focusNode, t.focusOffset);
          var n = e.collapsed;
          return e.detach(), n;
        }
      }, {
        key: "getParentUIElement",
        value: function getParentUIElement(t) {
          var e = or(t);

          for (e.pop(); e.length;) {
            var _t53 = e.pop(),
                _n55 = this._domToViewMapping.get(_t53);

            if (_n55 && _n55.is("uiElement")) return _n55;
          }

          return null;
        }
      }, {
        key: "isDomSelectionCorrect",
        value: function isDomSelectionCorrect(t) {
          return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
        }
      }, {
        key: "_isDomSelectionPositionCorrect",
        value: function _isDomSelectionPositionCorrect(t, e) {
          if (Do(t) && zo(t) && e < Vo) return !1;
          if (this.isElement(t) && zo(t.childNodes[e])) return !1;
          var n = this.mapDomToView(t);
          return !n || !n.is("uiElement");
        }
      }, {
        key: "_processDataFromViewText",
        value: function _processDataFromViewText(t) {
          var _this23 = this;

          var e = t.data;
          if (t.getAncestors().some(function (t) {
            return _this23.preElements.includes(t.name);
          })) return e;

          if (" " == e.charAt(0)) {
            var _n56 = this._getTouchingViewTextNode(t, !1);

            !(_n56 && this._nodeEndsWithSpace(_n56)) && _n56 || (e = " " + e.substr(1));
          }

          if (" " == e.charAt(e.length - 1)) {
            var _n57 = this._getTouchingViewTextNode(t, !0);

            " " != e.charAt(e.length - 2) && _n57 && " " != _n57.data.charAt(0) || (e = e.substr(0, e.length - 1) + " ");
          }

          return e.replace(/ {2}/g, "  ");
        }
      }, {
        key: "_nodeEndsWithSpace",
        value: function _nodeEndsWithSpace(t) {
          var _this24 = this;

          if (t.getAncestors().some(function (t) {
            return _this24.preElements.includes(t.name);
          })) return !1;

          var e = this._processDataFromViewText(t);

          return " " == e.charAt(e.length - 1);
        }
      }, {
        key: "_processDataFromDomText",
        value: function _processDataFromDomText(t) {
          var e = t.data;
          if (sr(t, this.preElements)) return Uo(t);
          e = e.replace(/[ \n\t\r]{1,}/g, " ");

          var n = this._getTouchingInlineDomNode(t, !1),
              i = this._getTouchingInlineDomNode(t, !0),
              o = this._checkShouldLeftTrimDomText(n),
              r = this._checkShouldRightTrimDomText(t, i);

          return o && (e = e.replace(/^ /, "")), r && (e = e.replace(/ $/, "")), e = (e = Uo(new Text(e))).replace(/ \u00A0/g, "  "), (/( |\u00A0)\u00A0$/.test(e) || !i || i.data && " " == i.data.charAt(0)) && (e = e.replace(/\u00A0$/, " ")), o && (e = e.replace(/^\u00A0/, " ")), e;
        }
      }, {
        key: "_checkShouldLeftTrimDomText",
        value: function _checkShouldLeftTrimDomText(t) {
          return !t || !!Wn(t) || /[^\S\u00A0]/.test(t.data.charAt(t.data.length - 1));
        }
      }, {
        key: "_checkShouldRightTrimDomText",
        value: function _checkShouldRightTrimDomText(t, e) {
          return !e && !zo(t);
        }
      }, {
        key: "_getTouchingViewTextNode",
        value: function _getTouchingViewTextNode(t, e) {
          var n = new Ki({
            startPosition: e ? Zi._createAfter(t) : Zi._createBefore(t),
            direction: e ? "forward" : "backward"
          });
          var _iteratorNormalCompletion67 = true;
          var _didIteratorError67 = false;
          var _iteratorError67 = undefined;

          try {
            for (var _iterator67 = n[Symbol.iterator](), _step67; !(_iteratorNormalCompletion67 = (_step67 = _iterator67.next()).done); _iteratorNormalCompletion67 = true) {
              var _t54 = _step67.value;
              if (_t54.item.is("containerElement")) return null;
              if (_t54.item.is("br")) return null;
              if (_t54.item.is("textProxy")) return _t54.item;
            }
          } catch (err) {
            _didIteratorError67 = true;
            _iteratorError67 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion67 && _iterator67.return != null) {
                _iterator67.return();
              }
            } finally {
              if (_didIteratorError67) {
                throw _iteratorError67;
              }
            }
          }

          return null;
        }
      }, {
        key: "_getTouchingInlineDomNode",
        value: function _getTouchingInlineDomNode(t, e) {
          if (!t.parentNode) return null;
          var n = e ? "nextNode" : "previousNode",
              i = t.ownerDocument,
              o = or(t)[0],
              r = i.createTreeWalker(o, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
            acceptNode: function acceptNode(t) {
              return Do(t) ? NodeFilter.FILTER_ACCEPT : "BR" == t.tagName ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
          });
          r.currentNode = t;
          var s = r[n]();

          if (null !== s) {
            var _e60 = function (t, e) {
              var n = or(t),
                  i = or(e);
              var o = 0;

              for (; n[o] == i[o] && n[o];) {
                o++;
              }

              return 0 === o ? null : n[o - 1];
            }(t, s);

            if (_e60 && !sr(t, this.blockElements, _e60) && !sr(s, this.blockElements, _e60)) return s;
          }

          return null;
        }
      }]);

      return rr;
    }();

    function sr(t, e, n) {
      var i = or(t);
      return n && (i = i.slice(i.indexOf(n) + 1)), i.some(function (t) {
        return t.tagName && e.includes(t.tagName.toLowerCase());
      });
    }

    function ar(t, e) {
      for (; t && t != nr.document;) {
        e(t), t = t.parentNode;
      }
    }

    function cr(t) {
      var e = Object.prototype.toString.apply(t);
      return "[object Window]" == e || "[object global]" == e;
    }

    var lr = Li({}, ei, {
      listenTo: function listenTo(t) {
        var _ei$listenTo;

        for (var _len15 = arguments.length, e = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
          e[_key15 - 1] = arguments[_key15];
        }

        if (Zo(t) || cr(t)) {
          var _n58 = this._getProxyEmitter(t) || new dr(t);

          _n58.attach.apply(_n58, e), t = _n58;
        }

        (_ei$listenTo = ei.listenTo).call.apply(_ei$listenTo, [this, t].concat(e));
      },
      stopListening: function stopListening(t, e, n) {
        if (Zo(t) || cr(t)) {
          var _e61 = this._getProxyEmitter(t);

          if (!_e61) return;
          t = _e61;
        }

        ei.stopListening.call(this, t, e, n), t instanceof dr && t.detach(e);
      },
      _getProxyEmitter: function _getProxyEmitter(t) {
        return function (t, e) {
          return t[Xn] && t[Xn][e] ? t[Xn][e].emitter : null;
        }(this, ur(t));
      }
    });

    var dr = function dr(t) {
      _classCallCheck(this, dr);

      ni(this, ur(t)), this._domNode = t;
    };

    function ur(t) {
      return t["data-ck-expando"] || (t["data-ck-expando"] = Kn());
    }

    Li(dr.prototype, ei, {
      attach: function attach(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (this._domListeners && this._domListeners[t]) return;

        var i = this._createDomListener(t, !!n.useCapture);

        this._domNode.addEventListener(t, i, !!n.useCapture), this._domListeners || (this._domListeners = {}), this._domListeners[t] = i;
      },
      detach: function detach(t) {
        var e;
        !this._domListeners[t] || (e = this._events[t]) && e.callbacks.length || this._domListeners[t].removeListener();
      },
      _createDomListener: function _createDomListener(t, e) {
        var _this25 = this;

        var n = function n(e) {
          _this25.fire(t, e);
        };

        return n.removeListener = function () {
          _this25._domNode.removeEventListener(t, n, e), delete _this25._domListeners[t];
        }, n;
      }
    });

    var hr =
    /*#__PURE__*/
    function () {
      function hr(t) {
        _classCallCheck(this, hr);

        this.view = t, this.document = t.document, this.isEnabled = !1;
      }

      _createClass(hr, [{
        key: "enable",
        value: function enable() {
          this.isEnabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this.isEnabled = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.disable(), this.stopListening();
        }
      }]);

      return hr;
    }();

    ci(hr, lr);
    var fr = "__lodash_hash_undefined__";

    var mr = function mr(t) {
      return this.__data__.set(t, fr), this;
    };

    var pr = function pr(t) {
      return this.__data__.has(t);
    };

    function gr(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.__data__ = new Pt(); ++e < n;) {
        this.add(t[e]);
      }
    }

    gr.prototype.add = gr.prototype.push = mr, gr.prototype.has = pr;
    var br = gr;

    var wr = function wr(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i;) {
        if (e(t[n], n, t)) return !0;
      }

      return !1;
    };

    var _r = function _r(t, e) {
      return t.has(e);
    },
        kr = 1,
        vr = 2;

    var yr = function yr(t, e, n, i, o, r) {
      var s = n & kr,
          a = t.length,
          c = e.length;
      if (a != c && !(s && c > a)) return !1;
      var l = r.get(t);
      if (l && r.get(e)) return l == e;
      var d = -1,
          u = !0,
          h = n & vr ? new br() : void 0;

      for (r.set(t, e), r.set(e, t); ++d < a;) {
        var f = t[d],
            m = e[d];
        if (i) var p = s ? i(m, f, d, e, t, r) : i(f, m, d, t, e, r);

        if (void 0 !== p) {
          if (p) continue;
          u = !1;
          break;
        }

        if (h) {
          if (!wr(e, function (t, e) {
            if (!_r(h, e) && (f === t || o(f, t, n, i, r))) return h.push(e);
          })) {
            u = !1;
            break;
          }
        } else if (f !== m && !o(f, m, n, i, r)) {
          u = !1;
          break;
        }
      }

      return r.delete(t), r.delete(e), u;
    };

    var xr = function xr(t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t, i) {
        n[++e] = [i, t];
      }), n;
    };

    var Ar = function Ar(t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    },
        Cr = 1,
        Tr = 2,
        Pr = "[object Boolean]",
        Mr = "[object Date]",
        Sr = "[object Error]",
        Er = "[object Map]",
        Ir = "[object Number]",
        Nr = "[object RegExp]",
        Or = "[object Set]",
        Rr = "[object String]",
        Dr = "[object Symbol]",
        Lr = "[object ArrayBuffer]",
        jr = "[object DataView]",
        Vr = o ? o.prototype : void 0,
        Br = Vr ? Vr.valueOf : void 0;

    var zr = function zr(t, e, n, i, o, r, s) {
      switch (n) {
        case jr:
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;

        case Lr:
          return !(t.byteLength != e.byteLength || !r(new Ye(t), new Ye(e)));

        case Pr:
        case Mr:
        case Ir:
          return P(+t, +e);

        case Sr:
          return t.name == e.name && t.message == e.message;

        case Nr:
        case Rr:
          return t == e + "";

        case Er:
          var a = xr;

        case Or:
          var c = i & Cr;
          if (a || (a = Ar), t.size != e.size && !c) return !1;
          var l = s.get(t);
          if (l) return l == e;
          i |= Tr, s.set(t, e);
          var d = yr(a(t), a(e), i, o, r, s);
          return s.delete(t), d;

        case Dr:
          if (Br) return Br.call(t) == Br.call(e);
      }

      return !1;
    },
        Fr = 1,
        Ur = Object.prototype.hasOwnProperty;

    var Hr = function Hr(t, e, n, i, o, r) {
      var s = n & Fr,
          a = Ie(t),
          c = a.length;
      if (c != Ie(e).length && !s) return !1;

      for (var l = c; l--;) {
        var d = a[l];
        if (!(s ? d in e : Ur.call(e, d))) return !1;
      }

      var u = r.get(t);
      if (u && r.get(e)) return u == e;
      var h = !0;
      r.set(t, e), r.set(e, t);

      for (var f = s; ++l < c;) {
        var m = t[d = a[l]],
            p = e[d];
        if (i) var g = s ? i(p, m, d, e, t, r) : i(m, p, d, t, e, r);

        if (!(void 0 === g ? m === p || o(m, p, n, i, r) : g)) {
          h = !1;
          break;
        }

        f || (f = "constructor" == d);
      }

      if (h && !f) {
        var b = t.constructor,
            w = e.constructor;
        b != w && "constructor" in t && "constructor" in e && !("function" == typeof b && b instanceof b && "function" == typeof w && w instanceof w) && (h = !1);
      }

      return r.delete(t), r.delete(e), h;
    },
        qr = 1,
        Wr = "[object Arguments]",
        Yr = "[object Array]",
        $r = "[object Object]",
        Gr = Object.prototype.hasOwnProperty;

    var Qr = function Qr(t, e, n, i, o, r) {
      var s = Wt(t),
          a = Wt(e),
          c = s ? Yr : He(t),
          l = a ? Yr : He(e),
          d = (c = c == Wr ? $r : c) == $r,
          u = (l = l == Wr ? $r : l) == $r,
          h = c == l;

      if (h && Object(Yt.a)(t)) {
        if (!Object(Yt.a)(e)) return !1;
        s = !0, d = !1;
      }

      if (h && !d) return r || (r = new It()), s || ie(t) ? yr(t, e, n, i, o, r) : zr(t, e, c, n, i, o, r);

      if (!(n & qr)) {
        var f = d && Gr.call(t, "__wrapped__"),
            m = u && Gr.call(e, "__wrapped__");

        if (f || m) {
          var p = f ? t.value() : t,
              g = m ? e.value() : e;
          return r || (r = new It()), o(p, g, n, i, r);
        }
      }

      return !!h && (r || (r = new It()), Hr(t, e, n, i, o, r));
    };

    var Jr = function t(e, n, i, o, r) {
      return e === n || (null == e || null == n || !w(e) && !w(n) ? e != e && n != n : Qr(e, n, i, o, t, r));
    };

    var Kr = function Kr(t, e, n) {
      var i = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
      return void 0 === i ? Jr(t, e, void 0, n) : !!i;
    };

    var Zr =
    /*#__PURE__*/
    function (_hr) {
      _inherits(Zr, _hr);

      function Zr(t) {
        var _this26;

        _classCallCheck(this, Zr);

        _this26 = _possibleConstructorReturn(this, _getPrototypeOf(Zr).call(this, t)), _this26._config = {
          childList: !0,
          characterData: !0,
          characterDataOldValue: !0,
          subtree: !0
        }, _this26.domConverter = t.domConverter, _this26.renderer = t._renderer, _this26._domElements = [], _this26._mutationObserver = new window.MutationObserver(_this26._onMutations.bind(_assertThisInitialized(_this26)));
        return _this26;
      }

      _createClass(Zr, [{
        key: "flush",
        value: function flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
      }, {
        key: "observe",
        value: function observe(t) {
          this._domElements.push(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
        }
      }, {
        key: "enable",
        value: function enable() {
          _get(_getPrototypeOf(Zr.prototype), "enable", this).call(this);

          var _iteratorNormalCompletion68 = true;
          var _didIteratorError68 = false;
          var _iteratorError68 = undefined;

          try {
            for (var _iterator68 = this._domElements[Symbol.iterator](), _step68; !(_iteratorNormalCompletion68 = (_step68 = _iterator68.next()).done); _iteratorNormalCompletion68 = true) {
              var _t55 = _step68.value;

              this._mutationObserver.observe(_t55, this._config);
            }
          } catch (err) {
            _didIteratorError68 = true;
            _iteratorError68 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion68 && _iterator68.return != null) {
                _iterator68.return();
              }
            } finally {
              if (_didIteratorError68) {
                throw _iteratorError68;
              }
            }
          }
        }
      }, {
        key: "disable",
        value: function disable() {
          _get(_getPrototypeOf(Zr.prototype), "disable", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Zr.prototype), "destroy", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "_onMutations",
        value: function _onMutations(t) {
          if (0 === t.length) return;
          var e = this.domConverter,
              n = new Map(),
              i = new Set();
          var _iteratorNormalCompletion69 = true;
          var _didIteratorError69 = false;
          var _iteratorError69 = undefined;

          try {
            for (var _iterator69 = t[Symbol.iterator](), _step69; !(_iteratorNormalCompletion69 = (_step69 = _iterator69.next()).done); _iteratorNormalCompletion69 = true) {
              var _n60 = _step69.value;

              if ("childList" === _n60.type) {
                var _t57 = e.mapDomToView(_n60.target);

                if (_t57 && _t57.is("uiElement")) continue;
                _t57 && !this._isBogusBrMutation(_n60) && i.add(_t57);
              }
            }
          } catch (err) {
            _didIteratorError69 = true;
            _iteratorError69 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion69 && _iterator69.return != null) {
                _iterator69.return();
              }
            } finally {
              if (_didIteratorError69) {
                throw _iteratorError69;
              }
            }
          }

          var _iteratorNormalCompletion70 = true;
          var _didIteratorError70 = false;
          var _iteratorError70 = undefined;

          try {
            for (var _iterator70 = t[Symbol.iterator](), _step70; !(_iteratorNormalCompletion70 = (_step70 = _iterator70.next()).done); _iteratorNormalCompletion70 = true) {
              var _o25 = _step70.value;

              var _t58 = e.mapDomToView(_o25.target);

              if ((!_t58 || !_t58.is("uiElement")) && "characterData" === _o25.type) {
                var _t59 = e.findCorrespondingViewText(_o25.target);

                _t59 && !i.has(_t59.parent) ? n.set(_t59, {
                  type: "text",
                  oldText: _t59.data,
                  newText: Uo(_o25.target),
                  node: _t59
                }) : !_t59 && zo(_o25.target) && i.add(e.mapDomToView(_o25.target.parentNode));
              }
            }
          } catch (err) {
            _didIteratorError70 = true;
            _iteratorError70 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion70 && _iterator70.return != null) {
                _iterator70.return();
              }
            } finally {
              if (_didIteratorError70) {
                throw _iteratorError70;
              }
            }
          }

          var o = [];
          var _iteratorNormalCompletion71 = true;
          var _didIteratorError71 = false;
          var _iteratorError71 = undefined;

          try {
            for (var _iterator71 = n.values()[Symbol.iterator](), _step71; !(_iteratorNormalCompletion71 = (_step71 = _iterator71.next()).done); _iteratorNormalCompletion71 = true) {
              var _t60 = _step71.value;
              this.renderer.markToSync("text", _t60.node), o.push(_t60);
            }
          } catch (err) {
            _didIteratorError71 = true;
            _iteratorError71 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion71 && _iterator71.return != null) {
                _iterator71.return();
              }
            } finally {
              if (_didIteratorError71) {
                throw _iteratorError71;
              }
            }
          }

          var _iteratorNormalCompletion72 = true;
          var _didIteratorError72 = false;
          var _iteratorError72 = undefined;

          try {
            for (var _iterator72 = i[Symbol.iterator](), _step72; !(_iteratorNormalCompletion72 = (_step72 = _iterator72.next()).done); _iteratorNormalCompletion72 = true) {
              var _t61 = _step72.value;

              var _n61 = e.mapViewToDom(_t61),
                  _i45 = Array.from(_t61.getChildren()),
                  _r10 = Array.from(e.domChildrenToView(_n61, {
                withChildren: !1
              }));

              Kr(_i45, _r10, a) || (this.renderer.markToSync("children", _t61), o.push({
                type: "children",
                oldChildren: _i45,
                newChildren: _r10,
                node: _t61
              }));
            }
          } catch (err) {
            _didIteratorError72 = true;
            _iteratorError72 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion72 && _iterator72.return != null) {
                _iterator72.return();
              }
            } finally {
              if (_didIteratorError72) {
                throw _iteratorError72;
              }
            }
          }

          var r = t[0].target.ownerDocument.getSelection();
          var s = null;

          if (r && r.anchorNode) {
            var _t56 = e.domPositionToView(r.anchorNode, r.anchorOffset),
                _n59 = e.domPositionToView(r.focusNode, r.focusOffset);

            _t56 && _n59 && (s = new no(_t56)).setFocus(_n59);
          }

          function a(t, e) {
            if (!Array.isArray(t)) return t === e || !(!t.is("text") || !e.is("text")) && t.data === e.data;
          }

          this.document.fire("mutations", o, s), this.view.forceRender();
        }
      }, {
        key: "_isBogusBrMutation",
        value: function _isBogusBrMutation(t) {
          var e = null;
          return null === t.nextSibling && 0 === t.removedNodes.length && 1 == t.addedNodes.length && (e = this.domConverter.domToView(t.addedNodes[0], {
            withChildren: !1
          })), e && e.is("element", "br");
        }
      }]);

      return Zr;
    }(hr);

    var Xr =
    /*#__PURE__*/
    function () {
      function Xr(t, e, n) {
        _classCallCheck(this, Xr);

        this.view = t, this.document = t.document, this.domEvent = e, this.domTarget = e.target, Li(this, n);
      }

      _createClass(Xr, [{
        key: "preventDefault",
        value: function preventDefault() {
          this.domEvent.preventDefault();
        }
      }, {
        key: "stopPropagation",
        value: function stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }, {
        key: "target",
        get: function get() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
      }]);

      return Xr;
    }();

    var ts =
    /*#__PURE__*/
    function (_hr2) {
      _inherits(ts, _hr2);

      function ts(t) {
        var _this27;

        _classCallCheck(this, ts);

        _this27 = _possibleConstructorReturn(this, _getPrototypeOf(ts).call(this, t)), _this27.useCapture = !1;
        return _this27;
      }

      _createClass(ts, [{
        key: "observe",
        value: function observe(t) {
          var _this28 = this;

          ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(function (e) {
            _this28.listenTo(t, e, function (t, e) {
              _this28.isEnabled && _this28.onDomEvent(e);
            }, {
              useCapture: _this28.useCapture
            });
          });
        }
      }, {
        key: "fire",
        value: function fire(t, e, n) {
          this.isEnabled && this.document.fire(t, new Xr(this.view, e, n));
        }
      }]);

      return ts;
    }(hr);

    var es =
    /*#__PURE__*/
    function (_ts) {
      _inherits(es, _ts);

      function es(t) {
        var _this29;

        _classCallCheck(this, es);

        _this29 = _possibleConstructorReturn(this, _getPrototypeOf(es).call(this, t)), _this29.domEventType = ["keydown", "keyup"];
        return _this29;
      }

      _createClass(es, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t, {
            keyCode: t.keyCode,
            altKey: t.altKey,
            ctrlKey: t.ctrlKey || t.metaKey,
            shiftKey: t.shiftKey,

            get keystroke() {
              return wo(this);
            }

          });
        }
      }]);

      return es;
    }(ts);

    var ns = function ns() {
      return i.a.Date.now();
    },
        is = "[object Symbol]";

    var os = function os(t) {
      return "symbol" == typeof t || w(t) && p(t) == is;
    },
        rs = NaN,
        ss = /^\s+|\s+$/g,
        as = /^[-+]0x[0-9a-f]+$/i,
        cs = /^0b[01]+$/i,
        ls = /^0o[0-7]+$/i,
        ds = parseInt;

    var us = function us(t) {
      if ("number" == typeof t) return t;
      if (os(t)) return rs;

      if (z(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = z(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = t.replace(ss, "");
      var n = cs.test(t);
      return n || ls.test(t) ? ds(t.slice(2), n ? 2 : 8) : as.test(t) ? rs : +t;
    },
        hs = "Expected a function",
        fs = Math.max,
        ms = Math.min;

    var ps = function ps(t, e, n) {
      var i,
          o,
          r,
          s,
          a,
          c,
          l = 0,
          d = !1,
          u = !1,
          h = !0;
      if ("function" != typeof t) throw new TypeError(hs);

      function f(e) {
        var n = i,
            r = o;
        return i = o = void 0, l = e, s = t.apply(r, n);
      }

      function m(t) {
        var n = t - c;
        return void 0 === c || n >= e || n < 0 || u && t - l >= r;
      }

      function p() {
        var t = ns();
        if (m(t)) return g(t);
        a = setTimeout(p, function (t) {
          var n = e - (t - c);
          return u ? ms(n, r - (t - l)) : n;
        }(t));
      }

      function g(t) {
        return a = void 0, h && i ? f(t) : (i = o = void 0, s);
      }

      function b() {
        var t = ns(),
            n = m(t);

        if (i = arguments, o = this, c = t, n) {
          if (void 0 === a) return function (t) {
            return l = t, a = setTimeout(p, e), d ? f(t) : s;
          }(c);
          if (u) return clearTimeout(a), a = setTimeout(p, e), f(c);
        }

        return void 0 === a && (a = setTimeout(p, e)), s;
      }

      return e = us(e) || 0, z(n) && (d = !!n.leading, r = (u = "maxWait" in n) ? fs(us(n.maxWait) || 0, e) : r, h = "trailing" in n ? !!n.trailing : h), b.cancel = function () {
        void 0 !== a && clearTimeout(a), l = 0, i = c = o = a = void 0;
      }, b.flush = function () {
        return void 0 === a ? s : g(ns());
      }, b;
    };

    var gs =
    /*#__PURE__*/
    function (_hr3) {
      _inherits(gs, _hr3);

      function gs(t) {
        var _this30;

        _classCallCheck(this, gs);

        _this30 = _possibleConstructorReturn(this, _getPrototypeOf(gs).call(this, t)), _this30._fireSelectionChangeDoneDebounced = ps(function (t) {
          return _this30.document.fire("selectionChangeDone", t);
        }, 200);
        return _this30;
      }

      _createClass(gs, [{
        key: "observe",
        value: function observe() {
          var _this31 = this;

          var t = this.document;
          t.on("keydown", function (e, n) {
            t.selection.isFake && function (t) {
              return t == bo.arrowright || t == bo.arrowleft || t == bo.arrowup || t == bo.arrowdown;
            }(n.keyCode) && _this31.isEnabled && (n.preventDefault(), _this31._handleSelectionMove(n.keyCode));
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(gs.prototype), "destroy", this).call(this), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionMove",
        value: function _handleSelectionMove(t) {
          var e = this.document.selection,
              n = new no(e.getRanges(), {
            backward: e.isBackward,
            fake: !1
          });
          t != bo.arrowleft && t != bo.arrowup || n.setTo(n.getFirstPosition()), t != bo.arrowright && t != bo.arrowdown || n.setTo(n.getLastPosition());
          var i = {
            oldSelection: e,
            newSelection: n,
            domSelection: null
          };
          this.document.fire("selectionChange", i), this._fireSelectionChangeDoneDebounced(i);
        }
      }]);

      return gs;
    }(hr);

    var bs = n(1);

    var ws =
    /*#__PURE__*/
    function (_hr4) {
      _inherits(ws, _hr4);

      function ws(t) {
        var _this32;

        _classCallCheck(this, ws);

        _this32 = _possibleConstructorReturn(this, _getPrototypeOf(ws).call(this, t)), _this32.mutationObserver = t.getObserver(Zr), _this32.selection = _this32.document.selection, _this32.domConverter = t.domConverter, _this32._documents = new WeakSet(), _this32._fireSelectionChangeDoneDebounced = ps(function (t) {
          return _this32.document.fire("selectionChangeDone", t);
        }, 200), _this32._clearInfiniteLoopInterval = setInterval(function () {
          return _this32._clearInfiniteLoop();
        }, 1e3), _this32._loopbackCounter = 0;
        return _this32;
      }

      _createClass(ws, [{
        key: "observe",
        value: function observe(t) {
          var _this33 = this;

          var e = t.ownerDocument;
          this._documents.has(e) || (this.listenTo(e, "selectionchange", function () {
            _this33._handleSelectionChange(e);
          }), this._documents.add(e));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(ws.prototype), "destroy", this).call(this), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionChange",
        value: function _handleSelectionChange(t) {
          if (!this.isEnabled || !this.document.isFocused && !this.document.isReadOnly) return;
          this.mutationObserver.flush();
          var e = t.defaultView.getSelection(),
              n = this.domConverter.domSelectionToView(e);
          if (!this.selection.isEqual(n) || !this.domConverter.isDomSelectionCorrect(e)) if (++this._loopbackCounter > 60) bs.a.warn("selectionchange-infinite-loop: Selection change observer detected an infinite rendering loop.");else if (this.selection.isSimilar(n)) this.view.forceRender();else {
            var _t62 = {
              oldSelection: this.selection,
              newSelection: n,
              domSelection: e
            };
            this.document.fire("selectionChange", _t62), this._fireSelectionChangeDoneDebounced(_t62);
          }
        }
      }, {
        key: "_clearInfiniteLoop",
        value: function _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }]);

      return ws;
    }(hr);

    var _s =
    /*#__PURE__*/
    function (_ts2) {
      _inherits(_s, _ts2);

      function _s(t) {
        var _this34;

        _classCallCheck(this, _s);

        _this34 = _possibleConstructorReturn(this, _getPrototypeOf(_s).call(this, t)), _this34.domEventType = ["focus", "blur"], _this34.useCapture = !0;
        var e = _this34.document;
        e.on("focus", function () {
          e.isFocused = !0, _this34._renderTimeoutId = setTimeout(function () {
            return t.forceRender();
          }, 50);
        }), e.on("blur", function (n, i) {
          var o = e.selection.editableElement;
          null !== o && o !== i.target || (e.isFocused = !1, t.forceRender());
        });
        return _this34;
      }

      _createClass(_s, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._renderTimeoutId && clearTimeout(this._renderTimeoutId), _get(_getPrototypeOf(_s.prototype), "destroy", this).call(this);
        }
      }]);

      return _s;
    }(ts);

    var ks =
    /*#__PURE__*/
    function (_ts3) {
      _inherits(ks, _ts3);

      function ks(t) {
        var _this35;

        _classCallCheck(this, ks);

        _this35 = _possibleConstructorReturn(this, _getPrototypeOf(ks).call(this, t)), _this35.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        var e = _this35.document;
        e.on("compositionstart", function () {
          e.isComposing = !0;
        }), e.on("compositionend", function () {
          e.isComposing = !1;
        });
        return _this35;
      }

      _createClass(ks, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return ks;
    }(ts);

    var vs =
    /*#__PURE__*/
    function (_ts4) {
      _inherits(vs, _ts4);

      function vs(t) {
        var _this36;

        _classCallCheck(this, vs);

        _this36 = _possibleConstructorReturn(this, _getPrototypeOf(vs).call(this, t)), _this36.domEventType = ["beforeinput"];
        return _this36;
      }

      _createClass(vs, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return vs;
    }(ts);

    function ys(t) {
      return "[object Range]" == Object.prototype.toString.apply(t);
    }

    function xs(t) {
      var e = t.ownerDocument.defaultView.getComputedStyle(t);
      return {
        top: parseInt(e.borderTopWidth, 10),
        right: parseInt(e.borderRightWidth, 10),
        bottom: parseInt(e.borderBottomWidth, 10),
        left: parseInt(e.borderLeftWidth, 10)
      };
    }

    var As = ["top", "right", "bottom", "left", "width", "height"];

    var Cs =
    /*#__PURE__*/
    function () {
      function Cs(t) {
        _classCallCheck(this, Cs);

        var e = ys(t);

        if (Object.defineProperty(this, "_source", {
          value: t._source || t,
          writable: !0,
          enumerable: !1
        }), Wn(t) || e) {
          var _n62 = e ? t.startContainer : t;

          _n62.ownerDocument && _n62.ownerDocument.body.contains(_n62) || bs.a.warn("rect-source-not-in-dom: The source of this rect does not belong to any rendered DOM tree.", {
            source: t
          }), Ts(this, e ? Cs.getDomRangeRects(t)[0] : t.getBoundingClientRect());
        } else if (cr(t)) {
          var _e62 = t.innerWidth,
              _n63 = t.innerHeight;
          Ts(this, {
            top: 0,
            right: _e62,
            bottom: _n63,
            left: 0,
            width: _e62,
            height: _n63
          });
        } else Ts(this, t);
      }

      _createClass(Cs, [{
        key: "clone",
        value: function clone() {
          return new Cs(this);
        }
      }, {
        key: "moveTo",
        value: function moveTo(t, e) {
          return this.top = e, this.right = t + this.width, this.bottom = e + this.height, this.left = t, this;
        }
      }, {
        key: "moveBy",
        value: function moveBy(t, e) {
          return this.top += e, this.right += t, this.left += t, this.bottom += e, this;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          var e = {
            top: Math.max(this.top, t.top),
            right: Math.min(this.right, t.right),
            bottom: Math.min(this.bottom, t.bottom),
            left: Math.max(this.left, t.left)
          };
          return e.width = e.right - e.left, e.height = e.bottom - e.top, e.width < 0 || e.height < 0 ? null : new Cs(e);
        }
      }, {
        key: "getIntersectionArea",
        value: function getIntersectionArea(t) {
          var e = this.getIntersection(t);
          return e ? e.getArea() : 0;
        }
      }, {
        key: "getArea",
        value: function getArea() {
          return this.width * this.height;
        }
      }, {
        key: "getVisible",
        value: function getVisible() {
          var t = this._source;
          var e = this.clone();

          if (!Ps(t)) {
            var _n64 = t.parentNode || t.commonAncestorContainer;

            for (; _n64 && !Ps(_n64);) {
              var _t63 = new Cs(_n64),
                  _i46 = e.getIntersection(_t63);

              if (!_i46) return null;
              _i46.getArea() < e.getArea() && (e = _i46), _n64 = _n64.parentNode;
            }
          }

          return e;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          for (var _i47 = 0, _As = As; _i47 < _As.length; _i47++) {
            var _e63 = _As[_i47];
            if (this[_e63] !== t[_e63]) return !1;
          }

          return !0;
        }
      }, {
        key: "contains",
        value: function contains(t) {
          var e = this.getIntersection(t);
          return !(!e || !e.isEqual(t));
        }
      }, {
        key: "excludeScrollbarsAndBorders",
        value: function excludeScrollbarsAndBorders() {
          var t = this._source;
          var e, n;
          if (cr(t)) e = t.innerWidth - t.document.documentElement.clientWidth, n = t.innerHeight - t.document.documentElement.clientHeight;else {
            var _i48 = xs(this._source);

            e = t.offsetWidth - t.clientWidth, n = t.offsetHeight - t.clientHeight, this.moveBy(_i48.left, _i48.top);
          }
          return this.width -= e, this.right -= e, this.height -= n, this.bottom -= n, this;
        }
      }], [{
        key: "getDomRangeRects",
        value: function getDomRangeRects(t) {
          var e = [],
              n = Array.from(t.getClientRects());

          if (n.length) {
            for (var _i49 = 0, _n65 = n; _i49 < _n65.length; _i49++) {
              var _t64 = _n65[_i49];
              e.push(new Cs(_t64));
            }
          } else {
            var _n66 = t.startContainer;
            Do(_n66) && (_n66 = _n66.parentNode);

            var _i50 = new Cs(_n66.getBoundingClientRect());

            _i50.right = _i50.left, _i50.width = 0, e.push(_i50);
          }

          return e;
        }
      }]);

      return Cs;
    }();

    function Ts(t, e) {
      for (var _i51 = 0, _As2 = As; _i51 < _As2.length; _i51++) {
        var _n67 = _As2[_i51];
        t[_n67] = e[_n67];
      }
    }

    function Ps(t) {
      return !!Wn(t) && t === t.ownerDocument.body;
    }

    function Ms(_ref16) {
      var t = _ref16.target,
          _ref16$viewportOffset = _ref16.viewportOffset,
          e = _ref16$viewportOffset === void 0 ? 0 : _ref16$viewportOffset;
      var n = Ds(t);
      var i = n,
          o = null;

      for (; i;) {
        var _r11 = void 0;

        Es(_r11 = Ls(i == n ? t : o), function () {
          return js(t, i);
        });

        var _s8 = js(t, i);

        if (Ss(i, _s8, e), i.parent != i) {
          if (o = i.frameElement, i = i.parent, !o) return;
        } else i = null;
      }
    }

    function Ss(t, e, n) {
      var i = e.clone().moveBy(0, n),
          o = e.clone().moveBy(0, -n),
          r = new Cs(t).excludeScrollbarsAndBorders();

      if (![o, i].every(function (t) {
        return r.contains(t);
      })) {
        var _s9 = t.scrollX,
            _a7 = t.scrollY;
        Ns(o, r) ? _a7 -= r.top - e.top + n : Is(i, r) && (_a7 += e.bottom - r.bottom + n), Os(e, r) ? _s9 -= r.left - e.left + n : Rs(e, r) && (_s9 += e.right - r.right + n), t.scrollTo(_s9, _a7);
      }
    }

    function Es(t, e) {
      var n = Ds(t);
      var i, o;

      for (; t != n.document.body;) {
        o = e(), (i = new Cs(t).excludeScrollbarsAndBorders()).contains(o) || (Ns(o, i) ? t.scrollTop -= i.top - o.top : Is(o, i) && (t.scrollTop += o.bottom - i.bottom), Os(o, i) ? t.scrollLeft -= i.left - o.left : Rs(o, i) && (t.scrollLeft += o.right - i.right)), t = t.parentNode;
      }
    }

    function Is(t, e) {
      return t.bottom > e.bottom;
    }

    function Ns(t, e) {
      return t.top < e.top;
    }

    function Os(t, e) {
      return t.left < e.left;
    }

    function Rs(t, e) {
      return t.right > e.right;
    }

    function Ds(t) {
      return ys(t) ? t.startContainer.ownerDocument.defaultView : t.ownerDocument.defaultView;
    }

    function Ls(t) {
      if (ys(t)) {
        var _e64 = t.commonAncestorContainer;
        return Do(_e64) && (_e64 = _e64.parentNode), _e64;
      }

      return t.parentNode;
    }

    function js(t, e) {
      var n = Ds(t),
          i = new Cs(t);
      if (n === e) return i;
      {
        var _t65 = n;

        for (; _t65 != e;) {
          var _e65 = _t65.frameElement,
              _n68 = new Cs(_e65).excludeScrollbarsAndBorders();

          i.moveBy(_n68.left, _n68.top), _t65 = _t65.parent;
        }
      }
      return i;
    }

    Object.assign({}, {
      scrollViewportToShowTarget: Ms,
      scrollAncestorsToShowTarget: function scrollAncestorsToShowTarget(t) {
        Es(Ls(t), function () {
          return new Cs(t);
        });
      }
    });

    var Vs =
    /*#__PURE__*/
    function () {
      function Vs() {
        var _this37 = this;

        _classCallCheck(this, Vs);

        this.document = new ro(), this.domConverter = new rr(), this.domRoots = new Map(), this.set("isRenderingInProgress", !1), this._renderer = new Xo(this.domConverter, this.document.selection), this._renderer.bind("isFocused").to(this.document), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new Co(this.document), this.addObserver(Zr), this.addObserver(ws), this.addObserver(_s), this.addObserver(es), this.addObserver(gs), this.addObserver(ks), mo.isAndroid && this.addObserver(vs), function (t) {
          t.document.on("keydown", Wo);
        }(this), yo(this), this.on("render", function () {
          _this37._render(), _this37.document.fire("layoutChanged"), _this37._hasChangedSinceTheLastRendering = !1;
        }), this.listenTo(this.document.selection, "change", function () {
          _this37._hasChangedSinceTheLastRendering = !0;
        });
      }

      _createClass(Vs, [{
        key: "attachDomRoot",
        value: function attachDomRoot(t) {
          var _this38 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          var n = this.document.getRoot(e);
          n._name = t.tagName.toLowerCase();
          var i = {};

          for (var _i52 = 0, _Array$from2 = Array.from(t.attributes); _i52 < _Array$from2.length; _i52++) {
            var _ref18 = _Array$from2[_i52];
            var _e66 = _ref18.name;
            var _o26 = _ref18.value;
            i[_e66] = _o26, "class" === _e66 ? this._writer.addClass(_o26.split(" "), n) : this._writer.setAttribute(_e66, _o26, n);
          }

          this._initialDomRootAttributes.set(t, i);

          var o = function o() {
            _this38._writer.setAttribute("contenteditable", !n.isReadOnly, n), n.isReadOnly ? _this38._writer.addClass("ck-read-only", n) : _this38._writer.removeClass("ck-read-only", n);
          };

          o(), this.domRoots.set(e, t), this.domConverter.bindElements(t, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(t.ownerDocument), n.on("change:children", function (t, e) {
            return _this38._renderer.markToSync("children", e);
          }), n.on("change:attributes", function (t, e) {
            return _this38._renderer.markToSync("attributes", e);
          }), n.on("change:text", function (t, e) {
            return _this38._renderer.markToSync("text", e);
          }), n.on("change:isReadOnly", function () {
            return _this38.change(o);
          }), n.on("change", function () {
            _this38._hasChangedSinceTheLastRendering = !0;
          });
          var _iteratorNormalCompletion73 = true;
          var _didIteratorError73 = false;
          var _iteratorError73 = undefined;

          try {
            for (var _iterator73 = this._observers.values()[Symbol.iterator](), _step73; !(_iteratorNormalCompletion73 = (_step73 = _iterator73.next()).done); _iteratorNormalCompletion73 = true) {
              var _n69 = _step73.value;

              _n69.observe(t, e);
            }
          } catch (err) {
            _didIteratorError73 = true;
            _iteratorError73 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion73 && _iterator73.return != null) {
                _iterator73.return();
              }
            } finally {
              if (_didIteratorError73) {
                throw _iteratorError73;
              }
            }
          }
        }
      }, {
        key: "detachDomRoot",
        value: function detachDomRoot(t) {
          var e = this.domRoots.get(t);
          Array.from(e.attributes).forEach(function (_ref19) {
            var t = _ref19.name;
            return e.removeAttribute(t);
          });

          var n = this._initialDomRootAttributes.get(e);

          for (var _t66 in n) {
            e.setAttribute(_t66, n[_t66]);
          }

          this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
        }
      }, {
        key: "getDomRoot",
        value: function getDomRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.domRoots.get(t);
        }
      }, {
        key: "addObserver",
        value: function addObserver(t) {
          var e = this._observers.get(t);

          if (e) return e;
          e = new t(this), this._observers.set(t, e);
          var _iteratorNormalCompletion74 = true;
          var _didIteratorError74 = false;
          var _iteratorError74 = undefined;

          try {
            for (var _iterator74 = this.domRoots[Symbol.iterator](), _step74; !(_iteratorNormalCompletion74 = (_step74 = _iterator74.next()).done); _iteratorNormalCompletion74 = true) {
              var _ref22 = _step74.value;

              var _ref21 = _slicedToArray(_ref22, 2);

              var _t67 = _ref21[0];
              var _n70 = _ref21[1];
              e.observe(_n70, _t67);
            }
          } catch (err) {
            _didIteratorError74 = true;
            _iteratorError74 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion74 && _iterator74.return != null) {
                _iterator74.return();
              }
            } finally {
              if (_didIteratorError74) {
                throw _iteratorError74;
              }
            }
          }

          return e.enable(), e;
        }
      }, {
        key: "getObserver",
        value: function getObserver(t) {
          return this._observers.get(t);
        }
      }, {
        key: "disableObservers",
        value: function disableObservers() {
          var _iteratorNormalCompletion75 = true;
          var _didIteratorError75 = false;
          var _iteratorError75 = undefined;

          try {
            for (var _iterator75 = this._observers.values()[Symbol.iterator](), _step75; !(_iteratorNormalCompletion75 = (_step75 = _iterator75.next()).done); _iteratorNormalCompletion75 = true) {
              var _t68 = _step75.value;

              _t68.disable();
            }
          } catch (err) {
            _didIteratorError75 = true;
            _iteratorError75 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion75 && _iterator75.return != null) {
                _iterator75.return();
              }
            } finally {
              if (_didIteratorError75) {
                throw _iteratorError75;
              }
            }
          }
        }
      }, {
        key: "enableObservers",
        value: function enableObservers() {
          var _iteratorNormalCompletion76 = true;
          var _didIteratorError76 = false;
          var _iteratorError76 = undefined;

          try {
            for (var _iterator76 = this._observers.values()[Symbol.iterator](), _step76; !(_iteratorNormalCompletion76 = (_step76 = _iterator76.next()).done); _iteratorNormalCompletion76 = true) {
              var _t69 = _step76.value;

              _t69.enable();
            }
          } catch (err) {
            _didIteratorError76 = true;
            _iteratorError76 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion76 && _iterator76.return != null) {
                _iterator76.return();
              }
            } finally {
              if (_didIteratorError76) {
                throw _iteratorError76;
              }
            }
          }
        }
      }, {
        key: "scrollToTheSelection",
        value: function scrollToTheSelection() {
          var t = this.document.selection.getFirstRange();
          t && Ms({
            target: this.domConverter.viewRangeToDom(t),
            viewportOffset: 20
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          if (!this.document.isFocused) {
            var _t70 = this.document.selection.editableElement;
            _t70 ? (this.domConverter.focus(_t70), this.forceRender()) : bs.a.warn("view-focus-no-selection: There is no selection in any editable to focus.");
          }
        }
      }, {
        key: "change",
        value: function change(t) {
          if (this.isRenderingInProgress || this._postFixersInProgress) throw new Gn.b("cannot-change-view-tree: Attempting to make changes to the view when it is in an incorrect state: rendering or post-fixers are in progress. This may cause some unexpected behavior and inconsistency between the DOM and the view.", this);
          if (this._ongoingChange) return t(this._writer);
          this._ongoingChange = !0;
          var e = t(this._writer);
          return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), e;
        }
      }, {
        key: "forceRender",
        value: function forceRender() {
          this._hasChangedSinceTheLastRendering = !0, this.change(function () {});
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion77 = true;
          var _didIteratorError77 = false;
          var _iteratorError77 = undefined;

          try {
            for (var _iterator77 = this._observers.values()[Symbol.iterator](), _step77; !(_iteratorNormalCompletion77 = (_step77 = _iterator77.next()).done); _iteratorNormalCompletion77 = true) {
              var _t71 = _step77.value;

              _t71.destroy();
            }
          } catch (err) {
            _didIteratorError77 = true;
            _iteratorError77 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion77 && _iterator77.return != null) {
                _iterator77.return();
              }
            } finally {
              if (_didIteratorError77) {
                throw _iteratorError77;
              }
            }
          }

          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Zi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Zi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Zi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Xi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Xi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Xi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new no(t, e, n);
        }
      }, {
        key: "_disableRendering",
        value: function _disableRendering(t) {
          this._renderingDisabled = t, 0 == t && this.change(function () {});
        }
      }, {
        key: "_render",
        value: function _render() {
          this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
        }
      }]);

      return Vs;
    }();

    function Bs(t) {
      return C(t) ? pi(t) : new Map(t);
    }

    ci(Vs, Fi);

    var zs =
    /*#__PURE__*/
    function () {
      function zs(t) {
        _classCallCheck(this, zs);

        this.parent = null, this._attrs = Bs(t);
      }

      _createClass(zs, [{
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;

          for (; e.parent;) {
            t.unshift(e.startOffset), e = e.parent;
          }

          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e),
              i = t.getAncestors(e);
          var o = 0;

          for (; n[o] == i[o] && n[o];) {
            o++;
          }

          return 0 === o ? null : n[o - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) return !1;
          if (this.root !== t.root) return !1;
          var e = this.getPath(),
              n = t.getPath(),
              i = li(e, n);

          switch (i) {
            case "prefix":
              return !0;

            case "extension":
              return !1;

            default:
              return e[i] < n[i];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = {};
          return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce(function (t, e) {
            return t[e[0]] = e[1], t;
          }, {})), t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new zs(this._attrs);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._attrs.set(t, e);
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          this._attrs = Bs(t);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._attrs.delete(t);
        }
      }, {
        key: "_clearAttributes",
        value: function _clearAttributes() {
          this._attrs.clear();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "node" == t;
        }
      }, {
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (null === (t = this.parent.getChildIndex(this))) throw new Gn.b("model-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "startOffset",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (null === (t = this.parent.getChildStartOffset(this))) throw new Gn.b("model-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return 1;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return this.parent ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;

          for (; t.parent;) {
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "document",
        get: function get() {
          return this.root == this ? null : this.root.document || null;
        }
      }]);

      return zs;
    }();

    var Fs =
    /*#__PURE__*/
    function (_zs) {
      _inherits(Fs, _zs);

      function Fs(t, e) {
        var _this39;

        _classCallCheck(this, Fs);

        _this39 = _possibleConstructorReturn(this, _getPrototypeOf(Fs).call(this, e)), _this39._data = t || "";
        return _this39;
      }

      _createClass(Fs, [{
        key: "is",
        value: function is(t) {
          return "text" == t || _get(_getPrototypeOf(Fs.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Fs.prototype), "toJSON", this).call(this);

          return t.data = this.data, t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Fs(this.data, this.getAttributes());
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new Fs(t.data, t.attributes);
        }
      }]);

      return Fs;
    }(zs);

    var Us =
    /*#__PURE__*/
    function () {
      function Us(t, e, n) {
        _classCallCheck(this, Us);

        if (this.textNode = t, e < 0 || e > t.offsetSize) throw new Gn.b("model-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.", this);
        if (n < 0 || e + n > t.offsetSize) throw new Gn.b("model-textproxy-wrong-length: Given length value is incorrect.", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }

      _createClass(Us, [{
        key: "is",
        value: function is(t) {
          return "textProxy" == t;
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = this.textNode.getPath();
          return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this.textNode.hasAttribute(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this.textNode.getAttribute(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this.textNode.getAttributes();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }, {
        key: "startOffset",
        get: function get() {
          return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }]);

      return Us;
    }();

    var Hs =
    /*#__PURE__*/
    function () {
      function Hs(t) {
        _classCallCheck(this, Hs);

        this._nodes = [], t && this._insertNodes(0, t);
      }

      _createClass(Hs, [{
        key: Symbol.iterator,
        value: function value() {
          return this._nodes[Symbol.iterator]();
        }
      }, {
        key: "getNode",
        value: function getNode(t) {
          return this._nodes[t] || null;
        }
      }, {
        key: "getNodeIndex",
        value: function getNodeIndex(t) {
          var e = this._nodes.indexOf(t);

          return -1 == e ? null : e;
        }
      }, {
        key: "getNodeStartOffset",
        value: function getNodeStartOffset(t) {
          var e = this.getNodeIndex(t);
          return null === e ? null : this._nodes.slice(0, e).reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }, {
        key: "indexToOffset",
        value: function indexToOffset(t) {
          if (t == this._nodes.length) return this.maxOffset;
          var e = this._nodes[t];
          if (!e) throw new Gn.b("model-nodelist-index-out-of-bounds: Given index cannot be found in the node list.", this);
          return this.getNodeStartOffset(e);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          var e = 0;
          var _iteratorNormalCompletion78 = true;
          var _didIteratorError78 = false;
          var _iteratorError78 = undefined;

          try {
            for (var _iterator78 = this._nodes[Symbol.iterator](), _step78; !(_iteratorNormalCompletion78 = (_step78 = _iterator78.next()).done); _iteratorNormalCompletion78 = true) {
              var _n71 = _step78.value;
              if (t >= e && t < e + _n71.offsetSize) return this.getNodeIndex(_n71);
              e += _n71.offsetSize;
            }
          } catch (err) {
            _didIteratorError78 = true;
            _iteratorError78 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion78 && _iterator78.return != null) {
                _iterator78.return();
              }
            } finally {
              if (_didIteratorError78) {
                throw _iteratorError78;
              }
            }
          }

          if (e != t) throw new Gn.b("model-nodelist-offset-out-of-bounds: Given offset cannot be found in the node list.", this, {
            offset: t,
            nodeList: this
          });
          return this.length;
        }
      }, {
        key: "_insertNodes",
        value: function _insertNodes(t, e) {
          var _this$_nodes;

          var _iteratorNormalCompletion79 = true;
          var _didIteratorError79 = false;
          var _iteratorError79 = undefined;

          try {
            for (var _iterator79 = e[Symbol.iterator](), _step79; !(_iteratorNormalCompletion79 = (_step79 = _iterator79.next()).done); _iteratorNormalCompletion79 = true) {
              var _t72 = _step79.value;
              if (!(_t72 instanceof zs)) throw new Gn.b("model-nodelist-insertNodes-not-node: Trying to insert an object which is not a Node instance.", this);
            }
          } catch (err) {
            _didIteratorError79 = true;
            _iteratorError79 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion79 && _iterator79.return != null) {
                _iterator79.return();
              }
            } finally {
              if (_didIteratorError79) {
                throw _iteratorError79;
              }
            }
          }

          (_this$_nodes = this._nodes).splice.apply(_this$_nodes, [t, 0].concat(_toConsumableArray(e)));
        }
      }, {
        key: "_removeNodes",
        value: function _removeNodes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          return this._nodes.splice(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this._nodes.map(function (t) {
            return t.toJSON();
          });
        }
      }, {
        key: "length",
        get: function get() {
          return this._nodes.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._nodes.reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }]);

      return Hs;
    }();

    var qs =
    /*#__PURE__*/
    function (_zs2) {
      _inherits(qs, _zs2);

      function qs(t, e, n) {
        var _this40;

        _classCallCheck(this, qs);

        _this40 = _possibleConstructorReturn(this, _getPrototypeOf(qs).call(this, e)), _this40.name = t, _this40._children = new Hs(), n && _this40._insertChild(0, n);
        return _this40;
      }

      _createClass(qs, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? "element" == t && e == this.name : "element" == t || t == this.name || _get(_getPrototypeOf(qs.prototype), "is", this).call(this, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;
          var _iteratorNormalCompletion80 = true;
          var _didIteratorError80 = false;
          var _iteratorError80 = undefined;

          try {
            for (var _iterator80 = t[Symbol.iterator](), _step80; !(_iteratorNormalCompletion80 = (_step80 = _iterator80.next()).done); _iteratorNormalCompletion80 = true) {
              var _n72 = _step80.value;
              e = e.getChild(e.offsetToIndex(_n72));
            }
          } catch (err) {
            _didIteratorError80 = true;
            _iteratorError80 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion80 && _iterator80.return != null) {
                _iterator80.return();
              }
            } finally {
              if (_didIteratorError80) {
                throw _iteratorError80;
              }
            }
          }

          return e;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(qs.prototype), "toJSON", this).call(this);

          if (t.name = this.name, this._children.length > 0) {
            t.children = [];
            var _iteratorNormalCompletion81 = true;
            var _didIteratorError81 = false;
            var _iteratorError81 = undefined;

            try {
              for (var _iterator81 = this._children[Symbol.iterator](), _step81; !(_iteratorNormalCompletion81 = (_step81 = _iterator81.next()).done); _iteratorNormalCompletion81 = true) {
                var _e67 = _step81.value;
                t.children.push(_e67.toJSON());
              }
            } catch (err) {
              _didIteratorError81 = true;
              _iteratorError81 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion81 && _iterator81.return != null) {
                  _iterator81.return();
                }
              } finally {
                if (_didIteratorError81) {
                  throw _iteratorError81;
                }
              }
            }
          }

          return t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = t ? Array.from(this._children).map(function (t) {
            return t._clone(!0);
          }) : null;
          return new qs(this.name, this.getAttributes(), e);
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = function (t) {
            if ("string" == typeof t) return [new Fs(t)];
            gi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new Fs(t) : t instanceof Us ? new Fs(t.data, t.getAttributes()) : t;
            });
          }(e);

          var _iteratorNormalCompletion82 = true;
          var _didIteratorError82 = false;
          var _iteratorError82 = undefined;

          try {
            for (var _iterator82 = n[Symbol.iterator](), _step82; !(_iteratorNormalCompletion82 = (_step82 = _iterator82.next()).done); _iteratorNormalCompletion82 = true) {
              var _t73 = _step82.value;
              null !== _t73.parent && _t73._remove(), _t73.parent = this;
            }
          } catch (err) {
            _didIteratorError82 = true;
            _iteratorError82 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion82 && _iterator82.return != null) {
                _iterator82.return();
              }
            } finally {
              if (_didIteratorError82) {
                throw _iteratorError82;
              }
            }
          }

          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          var n = this._children._removeNodes(t, e);

          var _iteratorNormalCompletion83 = true;
          var _didIteratorError83 = false;
          var _iteratorError83 = undefined;

          try {
            for (var _iterator83 = n[Symbol.iterator](), _step83; !(_iteratorNormalCompletion83 = (_step83 = _iterator83.next()).done); _iteratorNormalCompletion83 = true) {
              var _t74 = _step83.value;
              _t74.parent = null;
            }
          } catch (err) {
            _didIteratorError83 = true;
            _iteratorError83 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion83 && _iterator83.return != null) {
                _iterator83.return();
              }
            } finally {
              if (_didIteratorError83) {
                throw _iteratorError83;
              }
            }
          }

          return n;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = null;

          if (t.children) {
            e = [];
            var _iteratorNormalCompletion84 = true;
            var _didIteratorError84 = false;
            var _iteratorError84 = undefined;

            try {
              for (var _iterator84 = t.children[Symbol.iterator](), _step84; !(_iteratorNormalCompletion84 = (_step84 = _iterator84.next()).done); _iteratorNormalCompletion84 = true) {
                var _n73 = _step84.value;
                _n73.name ? e.push(qs.fromJSON(_n73)) : e.push(Fs.fromJSON(_n73));
              }
            } catch (err) {
              _didIteratorError84 = true;
              _iteratorError84 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion84 && _iterator84.return != null) {
                  _iterator84.return();
                }
              } finally {
                if (_didIteratorError84) {
                  throw _iteratorError84;
                }
              }
            }
          }

          return new qs(t.name, t.attributes, e);
        }
      }]);

      return qs;
    }(zs);

    var Ws =
    /*#__PURE__*/
    function () {
      function Ws() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Ws);

        if (!t.boundaries && !t.startPosition) throw new Gn.b("model-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.", null);
        var e = t.direction || "forward";
        if ("forward" != e && "backward" != e) throw new Gn.b("model-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.", t, {
          direction: e
        });
        this.direction = e, this.boundaries = t.boundaries || null, t.startPosition ? this.position = t.startPosition.clone() : this.position = Gs._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
      }

      _createClass(Ws, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, i, o;

          do {
            var _this$next2;

            i = this.position, o = this._visitedParent, (_this$next2 = this.next(), e = _this$next2.done, n = _this$next2.value, _this$next2);
          } while (!e && t(n));

          e || (this.position = i, this._visitedParent = o);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position,
              e = this.position.clone(),
              n = this._visitedParent;
          if (null === n.parent && e.offset === n.maxOffset) return {
            done: !0
          };
          if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var i = e.textNode ? e.textNode : e.nodeAfter;
          if (i instanceof qs) return this.shallow ? e.offset++ : (e.path.push(0), this._visitedParent = i), this.position = e, Ys("elementStart", i, t, e, 1);

          if (i instanceof Fs) {
            var _o27;

            if (this.singleCharacters) _o27 = 1;else {
              var _t75 = i.endOffset;
              this._boundaryEndParent == n && this.boundaries.end.offset < _t75 && (_t75 = this.boundaries.end.offset), _o27 = _t75 - e.offset;
            }

            var _r12 = e.offset - i.startOffset,
                _s10 = new Us(i, _r12, _o27);

            return e.offset += _o27, this.position = e, Ys("text", _s10, t, e, _o27);
          }

          return e.path.pop(), e.offset++, this.position = e, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : Ys("elementEnd", n, t, e);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position,
              e = this.position.clone(),
              n = this._visitedParent;
          if (null === n.parent && 0 === e.offset) return {
            done: !0
          };
          if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var i = e.textNode ? e.textNode : e.nodeBefore;
          if (i instanceof qs) return e.offset--, this.shallow ? (this.position = e, Ys("elementStart", i, t, e, 1)) : (e.path.push(i.maxOffset), this.position = e, this._visitedParent = i, this.ignoreElementEnd ? this._previous() : Ys("elementEnd", i, t, e));

          if (i instanceof Fs) {
            var _o28;

            if (this.singleCharacters) _o28 = 1;else {
              var _t76 = i.startOffset;
              this._boundaryStartParent == n && this.boundaries.start.offset > _t76 && (_t76 = this.boundaries.start.offset), _o28 = e.offset - _t76;
            }

            var _r13 = e.offset - i.startOffset,
                _s11 = new Us(i, _r13 - _o28, _o28);

            return e.offset -= _o28, this.position = e, Ys("text", _s11, t, e, _o28);
          }

          return e.path.pop(), this.position = e, this._visitedParent = n.parent, Ys("elementStart", n, t, e, 1);
        }
      }]);

      return Ws;
    }();

    function Ys(t, e, n, i, o) {
      return {
        done: !1,
        value: {
          type: t,
          item: e,
          previousPosition: n,
          nextPosition: i,
          length: o
        }
      };
    }

    var $s = function $s(t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };

    var Gs =
    /*#__PURE__*/
    function () {
      function Gs(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

        _classCallCheck(this, Gs);

        if (!t.is("element") && !t.is("documentFragment")) throw new Gn.b("model-position-root-invalid: Position root invalid.", t);
        if (!(e instanceof Array) || 0 === e.length) throw new Gn.b("model-position-path-incorrect: Position path must be an array with at least one item.", t, {
          path: e
        });
        e = t.getPath().concat(e), t = t.root, this.root = t, this.path = e, this.stickiness = n;
      }

      _createClass(Gs, [{
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root != t.root) return "different";
          var e = li(this.path, t.path);

          switch (e) {
            case "same":
              return "same";

            case "prefix":
              return "before";

            case "extension":
              return "after";

            default:
              return this.path[e] < t.path[e] ? "before" : "after";
          }
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new Ws(e);
          return n.skip(t), n.position;
        }
      }, {
        key: "getParentPath",
        value: function getParentPath() {
          return this.path.slice(0, -1);
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "getCommonPath",
        value: function getCommonPath(t) {
          if (this.root != t.root) return [];
          var e = li(this.path, t.path),
              n = "string" == typeof e ? Math.min(this.path.length, t.path.length) : e;
          return this.path.slice(0, n);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors(),
              n = t.getAncestors();
          var i = 0;

          for (; e[i] == n[i] && e[i];) {
            i++;
          }

          return 0 === i ? null : e[i - 1];
        }
      }, {
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = this.clone(),
              n = e.offset + t;
          return e.offset = n < 0 ? 0 : n, e;
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return "after" == this.compareWith(t);
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return "before" == this.compareWith(t);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return "same" == this.compareWith(t);
        }
      }, {
        key: "isTouching",
        value: function isTouching(t) {
          var e = null,
              n = null;

          switch (this.compareWith(t)) {
            case "same":
              return !0;

            case "before":
              e = Gs._createAt(this), n = Gs._createAt(t);
              break;

            case "after":
              e = Gs._createAt(t), n = Gs._createAt(this);
              break;

            default:
              return !1;
          }

          var i = e.parent;

          for (; e.path.length + n.path.length;) {
            if (e.isEqual(n)) return !0;

            if (e.path.length > n.path.length) {
              if (e.offset !== i.maxOffset) return !1;
              e.path = e.path.slice(0, -1), i = i.parent, e.offset++;
            } else {
              if (0 !== n.offset) return !1;
              n.path = n.path.slice(0, -1);
            }
          }
        }
      }, {
        key: "hasSameParentAs",
        value: function hasSameParentAs(t) {
          if (this.root !== t.root) return !1;
          return "same" == li(this.getParentPath(), t.getParentPath());
        }
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          var e;

          switch (t.type) {
            case "insert":
              e = this._getTransformedByInsertOperation(t);
              break;

            case "move":
            case "remove":
            case "reinsert":
              e = this._getTransformedByMoveOperation(t);
              break;

            case "split":
              e = this._getTransformedBySplitOperation(t);
              break;

            case "merge":
              e = this._getTransformedByMergeOperation(t);
              break;

            default:
              e = Gs._createAt(this);
          }

          return e;
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          return this._getTransformedByInsertion(t.position, t.howMany);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = t.movedRange;
          return e.containsPosition(this) || e.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          var e = t.movedRange;
          var n;
          return e.containsPosition(this) || e.start.isEqual(this) ? (n = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (n = n._getTransformedByDeletion(t.deletionPosition, 1))) : n = this.isEqual(t.deletionPosition) ? Gs._createAt(t.deletionPosition) : this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), n;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = Gs._createAt(this);

          if (this.root != t.root) return n;

          if ("same" == li(t.getParentPath(), this.getParentPath())) {
            if (t.offset < this.offset) {
              if (t.offset + e > this.offset) return null;
              n.offset -= e;
            }
          } else if ("prefix" == li(t.getParentPath(), this.getParentPath())) {
            var _i53 = t.path.length - 1;

            if (t.offset <= this.path[_i53]) {
              if (t.offset + e > this.path[_i53]) return null;
              n.path[_i53] -= e;
            }
          }

          return n;
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = Gs._createAt(this);

          if (this.root != t.root) return n;
          if ("same" == li(t.getParentPath(), this.getParentPath())) (t.offset < this.offset || t.offset == this.offset && "toPrevious" != this.stickiness) && (n.offset += e);else if ("prefix" == li(t.getParentPath(), this.getParentPath())) {
            var _i54 = t.path.length - 1;

            t.offset <= this.path[_i54] && (n.path[_i54] += e);
          }
          return n;
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          if (e = e._getTransformedByDeletion(t, n), t.isEqual(e)) return Gs._createAt(this);

          var i = this._getTransformedByDeletion(t, n);

          return null === i || t.isEqual(this) && "toNext" == this.stickiness || t.getShiftedBy(n).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(t, e) : i._getTransformedByInsertion(e, n);
        }
      }, {
        key: "_getCombined",
        value: function _getCombined(t, e) {
          var n = t.path.length - 1,
              i = Gs._createAt(e);

          return i.stickiness = this.stickiness, i.offset = i.offset + this.path[n] - t.offset, i.path = i.path.concat(this.path.slice(n + 1)), i;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
      }, {
        key: "offset",
        get: function get() {
          return $s(this.path);
        },
        set: function set(t) {
          this.path[this.path.length - 1] = t;
        }
      }, {
        key: "parent",
        get: function get() {
          var t = this.root;

          for (var _e68 = 0; _e68 < this.path.length - 1; _e68++) {
            t = t.getChild(t.offsetToIndex(this.path[_e68]));
          }

          return t;
        }
      }, {
        key: "index",
        get: function get() {
          return this.parent.offsetToIndex(this.offset);
        }
      }, {
        key: "textNode",
        get: function get() {
          var t = this.parent.getChild(this.index);
          return t instanceof Fs && t.startOffset < this.offset ? t : null;
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          return null === this.textNode ? this.parent.getChild(this.index) : null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          return null === this.textNode ? this.parent.getChild(this.index - 1) : null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          return this.offset == this.parent.maxOffset;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
          if (t instanceof Gs) return new Gs(t.root, t.path, t.stickiness);
          {
            var _i55 = t;
            if ("end" == e) e = _i55.maxOffset;else {
              if ("before" == e) return this._createBefore(_i55, n);
              if ("after" == e) return this._createAfter(_i55, n);
              if (0 !== e && !e) throw new Gn.b("model-createPositionAt-offset-required: Model#createPositionAt() requires the offset when the first parameter is a model item.", [this, t]);
            }
            if (!_i55.is("element") && !_i55.is("documentFragment")) throw new Gn.b("model-position-parent-incorrect: Position parent have to be a element or document fragment.", [this, t]);

            var _o29 = _i55.getPath();

            return _o29.push(e), new this(_i55.root, _o29, n);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t, e) {
          if (!t.parent) throw new Gn.b("model-position-after-root: You cannot make a position after root.", [this, t], {
            root: t
          });
          return this._createAt(t.parent, t.endOffset, e);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t, e) {
          if (!t.parent) throw new Gn.b("model-position-before-root: You cannot make a position before root.", t, {
            root: t
          });
          return this._createAt(t.parent, t.startOffset, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if ("$graveyard" === t.root) {
            var _n74 = new Gs(e.graveyard, t.path);

            return _n74.stickiness = t.stickiness, _n74;
          }

          if (!e.getRoot(t.root)) throw new Gn.b("model-position-fromjson-no-root: Cannot create position for document. Root with specified name does not exist.", e, {
            rootName: t.root
          });
          return new Gs(e.getRoot(t.root), t.path, t.stickiness);
        }
      }]);

      return Gs;
    }();

    var Qs =
    /*#__PURE__*/
    function () {
      function Qs(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, Qs);

        this.start = Gs._createAt(t), this.end = e ? Gs._createAt(e) : Gs._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }

      _createClass(Qs, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          return _regeneratorRuntime.wrap(function value$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  return _context11.delegateYield(new Ws({
                    boundaries: this,
                    ignoreElementEnd: !0
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, value, this);
        })
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t.isCollapsed && (e = !1);
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
              i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && i;
        }
      }, {
        key: "containsItem",
        value: function containsItem(t) {
          var e = Gs._createBefore(t);

          return this.containsPosition(e) || this.start.isEqual(e);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new Qs(this.start, t.start)), this.containsPosition(t.end) && e.push(new Qs(t.end, this.end))) : e.push(new Qs(this.start, this.end)), e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e69 = this.start,
                _n75 = this.end;
            return this.containsPosition(t.start) && (_e69 = t.start), this.containsPosition(t.end) && (_n75 = t.end), new Qs(_e69, _n75);
          }

          return null;
        }
      }, {
        key: "getMinimalFlatRanges",
        value: function getMinimalFlatRanges() {
          var t = [],
              e = this.start.getCommonPath(this.end).length,
              n = Gs._createAt(this.start);

          var i = n.parent;

          for (; n.path.length > e + 1;) {
            var _e70 = i.maxOffset - n.offset;

            0 !== _e70 && t.push(new Qs(n, n.getShiftedBy(_e70))), n.path = n.path.slice(0, -1), n.offset++, i = i.parent;
          }

          for (; n.path.length <= this.end.path.length;) {
            var _e71 = this.end.path[n.path.length - 1],
                _i56 = _e71 - n.offset;

            0 !== _i56 && t.push(new Qs(n, n.getShiftedBy(_i56))), n.offset = _e71, n.path.push(0);
          }

          return t;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.boundaries = this, new Ws(t);
        }
      }, {
        key: "getItems",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getItems() {
          var t,
              e,
              _iteratorNormalCompletion85,
              _didIteratorError85,
              _iteratorError85,
              _iterator85,
              _step85,
              _t77,
              _args12 = arguments;

          return _regeneratorRuntime.wrap(function getItems$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  t = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
                  t.boundaries = this, t.ignoreElementEnd = !0;
                  e = new Ws(t);
                  _iteratorNormalCompletion85 = true;
                  _didIteratorError85 = false;
                  _iteratorError85 = undefined;
                  _context12.prev = 6;
                  _iterator85 = e[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion85 = (_step85 = _iterator85.next()).done) {
                    _context12.next = 15;
                    break;
                  }

                  _t77 = _step85.value;
                  _context12.next = 12;
                  return _t77.item;

                case 12:
                  _iteratorNormalCompletion85 = true;
                  _context12.next = 8;
                  break;

                case 15:
                  _context12.next = 21;
                  break;

                case 17:
                  _context12.prev = 17;
                  _context12.t0 = _context12["catch"](6);
                  _didIteratorError85 = true;
                  _iteratorError85 = _context12.t0;

                case 21:
                  _context12.prev = 21;
                  _context12.prev = 22;

                  if (!_iteratorNormalCompletion85 && _iterator85.return != null) {
                    _iterator85.return();
                  }

                case 24:
                  _context12.prev = 24;

                  if (!_didIteratorError85) {
                    _context12.next = 27;
                    break;
                  }

                  throw _iteratorError85;

                case 27:
                  return _context12.finish(24);

                case 28:
                  return _context12.finish(21);

                case 29:
                case "end":
                  return _context12.stop();
              }
            }
          }, getItems, this, [[6, 17, 21, 29], [22,, 24, 28]]);
        })
      }, {
        key: "getPositions",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getPositions() {
          var t,
              e,
              _iteratorNormalCompletion86,
              _didIteratorError86,
              _iteratorError86,
              _iterator86,
              _step86,
              _t78,
              _args13 = arguments;

          return _regeneratorRuntime.wrap(function getPositions$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  t = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
                  t.boundaries = this;
                  e = new Ws(t);
                  _context13.next = 5;
                  return e.position;

                case 5:
                  _iteratorNormalCompletion86 = true;
                  _didIteratorError86 = false;
                  _iteratorError86 = undefined;
                  _context13.prev = 8;
                  _iterator86 = e[Symbol.iterator]();

                case 10:
                  if (_iteratorNormalCompletion86 = (_step86 = _iterator86.next()).done) {
                    _context13.next = 17;
                    break;
                  }

                  _t78 = _step86.value;
                  _context13.next = 14;
                  return _t78.nextPosition;

                case 14:
                  _iteratorNormalCompletion86 = true;
                  _context13.next = 10;
                  break;

                case 17:
                  _context13.next = 23;
                  break;

                case 19:
                  _context13.prev = 19;
                  _context13.t0 = _context13["catch"](8);
                  _didIteratorError86 = true;
                  _iteratorError86 = _context13.t0;

                case 23:
                  _context13.prev = 23;
                  _context13.prev = 24;

                  if (!_iteratorNormalCompletion86 && _iterator86.return != null) {
                    _iterator86.return();
                  }

                case 26:
                  _context13.prev = 26;

                  if (!_didIteratorError86) {
                    _context13.next = 29;
                    break;
                  }

                  throw _iteratorError86;

                case 29:
                  return _context13.finish(26);

                case 30:
                  return _context13.finish(23);

                case 31:
                case "end":
                  return _context13.stop();
              }
            }
          }, getPositions, this, [[8, 19, 23, 31], [24,, 26, 30]]);
        })
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          switch (t.type) {
            case "insert":
              return this._getTransformedByInsertOperation(t);

            case "move":
            case "remove":
            case "reinsert":
              return this._getTransformedByMoveOperation(t);

            case "split":
              return [this._getTransformedBySplitOperation(t)];

            case "merge":
              return [this._getTransformedByMergeOperation(t)];
          }

          return [new Qs(this.start, this.end)];
        }
      }, {
        key: "getTransformedByOperations",
        value: function getTransformedByOperations(t) {
          var e = [new Qs(this.start, this.end)];
          var _iteratorNormalCompletion87 = true;
          var _didIteratorError87 = false;
          var _iteratorError87 = undefined;

          try {
            for (var _iterator87 = t[Symbol.iterator](), _step87; !(_iteratorNormalCompletion87 = (_step87 = _iterator87.next()).done); _iteratorNormalCompletion87 = true) {
              var _n77 = _step87.value;

              for (var _t81 = 0; _t81 < e.length; _t81++) {
                var _i58 = e[_t81].getTransformedByOperation(_n77);

                e.splice.apply(e, [_t81, 1].concat(_toConsumableArray(_i58))), _t81 += _i58.length - 1;
              }
            }
          } catch (err) {
            _didIteratorError87 = true;
            _iteratorError87 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion87 && _iterator87.return != null) {
                _iterator87.return();
              }
            } finally {
              if (_didIteratorError87) {
                throw _iteratorError87;
              }
            }
          }

          for (var _t79 = 0; _t79 < e.length; _t79++) {
            var _n76 = e[_t79];

            for (var _i57 = _t79 + 1; _i57 < e.length; _i57++) {
              var _t80 = e[_i57];
              (_n76.containsRange(_t80) || _t80.containsRange(_n76) || _n76.isEqual(_t80)) && e.splice(_i57, 1);
            }
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            start: this.start.toJSON(),
            end: this.end.toJSON()
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.start, this.end);
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return this._getTransformedByInsertion(t.position, t.howMany, e);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.sourcePosition,
              i = t.howMany,
              o = t.targetPosition;
          return this._getTransformedByMove(n, o, i, e);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = this.start._getTransformedBySplitOperation(t);

          var n = this.end._getTransformedBySplitOperation(t);

          return this.end.isEqual(t.insertionPosition) && (n = this.end.getShiftedBy(1)), e.root != n.root && (n = this.end.getShiftedBy(-1)), new Qs(e, n);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) return new Qs(this.start);

          var e = this.start._getTransformedByMergeOperation(t),
              n = this.end._getTransformedByMergeOperation(t);

          return e.root != n.root && (n = this.end.getShiftedBy(-1)), e.isAfter(n) ? (t.sourcePosition.isBefore(t.targetPosition) ? (e = Gs._createAt(n)).offset = 0 : (t.deletionPosition.isEqual(e) || (n = t.deletionPosition), e = t.targetPosition), new Qs(e, n)) : new Qs(e, n);
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          if (n && this.containsPosition(t)) return [new Qs(this.start, t), new Qs(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
          {
            var _n78 = new Qs(this.start, this.end);

            return _n78.start = _n78.start._getTransformedByInsertion(t, e), _n78.end = _n78.end._getTransformedByInsertion(t, e), [_n78];
          }
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

          if (this.isCollapsed) {
            var _i59 = this.start._getTransformedByMove(t, e, n);

            return [new Qs(_i59)];
          }

          var o = Qs._createFromPositionAndShift(t, n),
              r = e._getTransformedByDeletion(t, n);

          if (this.containsPosition(e) && !i && (o.containsPosition(this.start) || o.containsPosition(this.end))) {
            var _i60 = this.start._getTransformedByMove(t, e, n),
                _o30 = this.end._getTransformedByMove(t, e, n);

            return [new Qs(_i60, _o30)];
          }

          var s;
          var a = this.getDifference(o);
          var c = null;
          var l = this.getIntersection(o);

          if (1 == a.length ? c = new Qs(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n)) : 2 == a.length && (c = new Qs(this.start, this.end._getTransformedByDeletion(t, n))), s = c ? c._getTransformedByInsertion(r, n, null !== l || i) : [], l) {
            var _t82 = new Qs(l.start._getCombined(o.start, r), l.end._getCombined(o.start, r));

            2 == s.length ? s.splice(1, 0, _t82) : s.push(_t82);
          }

          return s;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = this.start._getTransformedByDeletion(t, e),
              i = this.end._getTransformedByDeletion(t, e);

          return null == n && null == i ? null : (null == n && (n = t), null == i && (i = t), new Qs(n, i));
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return "same" == li(this.start.getParentPath(), this.end.getParentPath());
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t,
              i = t.getShiftedBy(e);
          return e > 0 ? new this(n, i) : new this(i, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return new this(Gs._createAt(t, 0), Gs._createAt(t, t.maxOffset));
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          return this._createFromPositionAndShift(Gs._createBefore(t), t.offsetSize);
        }
      }, {
        key: "_createFromRanges",
        value: function _createFromRanges(t) {
          if (0 === t.length) throw new Gn.b("range-create-from-ranges-empty-array: At least one range has to be passed.", null);
          if (1 == t.length) return t[0].clone();
          var e = t[0];
          t.sort(function (t, e) {
            return t.start.isAfter(e.start) ? 1 : -1;
          });
          var n = t.indexOf(e),
              i = new this(e.start, e.end);
          if (n > 0) for (var _e72 = n - 1; t[_e72].end.isEqual(i.start); _e72++) {
            i.start = Gs._createAt(t[_e72].start);
          }

          for (var _e73 = n + 1; _e73 < t.length && t[_e73].start.isEqual(i.end); _e73++) {
            i.end = Gs._createAt(t[_e73].end);
          }

          return i;
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new this(Gs.fromJSON(t.start, e), Gs.fromJSON(t.end, e));
        }
      }]);

      return Qs;
    }();

    var Js =
    /*#__PURE__*/
    function () {
      function Js() {
        var _this41 = this;

        _classCallCheck(this, Js);

        this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this.on("modelToViewPosition", function (t, e) {
          if (e.viewPosition) return;

          var n = _this41._modelToViewMapping.get(e.modelPosition.parent);

          e.viewPosition = _this41._findPositionIn(n, e.modelPosition.offset);
        }, {
          priority: "low"
        }), this.on("viewToModelPosition", function (t, e) {
          if (e.modelPosition) return;

          var n = _this41.findMappedViewAncestor(e.viewPosition),
              i = _this41._viewToModelMapping.get(n),
              o = _this41._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);

          e.modelPosition = Gs._createAt(i, o);
        }, {
          priority: "low"
        });
      }

      _createClass(Js, [{
        key: "bindElements",
        value: function bindElements(t, e) {
          this._modelToViewMapping.set(t, e), this._viewToModelMapping.set(e, t);
        }
      }, {
        key: "unbindViewElement",
        value: function unbindViewElement(t) {
          var e = this.toModelElement(t);
          this._viewToModelMapping.delete(t), this._modelToViewMapping.get(e) == t && this._modelToViewMapping.delete(e);
        }
      }, {
        key: "unbindModelElement",
        value: function unbindModelElement(t) {
          var e = this.toViewElement(t);
          this._modelToViewMapping.delete(t), this._viewToModelMapping.get(e) == t && this._viewToModelMapping.delete(e);
        }
      }, {
        key: "bindElementToMarker",
        value: function bindElementToMarker(t, e) {
          var n = this._markerNameToElements.get(e) || new Set();
          n.add(t), this._markerNameToElements.set(e, n);
        }
      }, {
        key: "unbindElementsFromMarkerName",
        value: function unbindElementsFromMarkerName(t) {
          this._markerNameToElements.delete(t);
        }
      }, {
        key: "clearBindings",
        value: function clearBindings() {
          this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map();
        }
      }, {
        key: "toModelElement",
        value: function toModelElement(t) {
          return this._viewToModelMapping.get(t);
        }
      }, {
        key: "toViewElement",
        value: function toViewElement(t) {
          return this._modelToViewMapping.get(t);
        }
      }, {
        key: "toModelRange",
        value: function toModelRange(t) {
          return new Qs(this.toModelPosition(t.start), this.toModelPosition(t.end));
        }
      }, {
        key: "toViewRange",
        value: function toViewRange(t) {
          return new Xi(this.toViewPosition(t.start), this.toViewPosition(t.end));
        }
      }, {
        key: "toModelPosition",
        value: function toModelPosition(t) {
          var e = {
            viewPosition: t,
            mapper: this
          };
          return this.fire("viewToModelPosition", e), e.modelPosition;
        }
      }, {
        key: "toViewPosition",
        value: function toViewPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            isPhantom: !1
          };
          var n = {
            modelPosition: t,
            mapper: this,
            isPhantom: e.isPhantom
          };
          return this.fire("modelToViewPosition", n), n.viewPosition;
        }
      }, {
        key: "markerNameToElements",
        value: function markerNameToElements(t) {
          var e = this._markerNameToElements.get(t);

          if (!e) return null;
          var n = new Set();
          var _iteratorNormalCompletion88 = true;
          var _didIteratorError88 = false;
          var _iteratorError88 = undefined;

          try {
            for (var _iterator88 = e[Symbol.iterator](), _step88; !(_iteratorNormalCompletion88 = (_step88 = _iterator88.next()).done); _iteratorNormalCompletion88 = true) {
              var _t83 = _step88.value;

              if (_t83.is("attributeElement")) {
                var _iteratorNormalCompletion89 = true;
                var _didIteratorError89 = false;
                var _iteratorError89 = undefined;

                try {
                  for (var _iterator89 = _t83.getElementsWithSameId()[Symbol.iterator](), _step89; !(_iteratorNormalCompletion89 = (_step89 = _iterator89.next()).done); _iteratorNormalCompletion89 = true) {
                    var _e74 = _step89.value;
                    n.add(_e74);
                  }
                } catch (err) {
                  _didIteratorError89 = true;
                  _iteratorError89 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion89 && _iterator89.return != null) {
                      _iterator89.return();
                    }
                  } finally {
                    if (_didIteratorError89) {
                      throw _iteratorError89;
                    }
                  }
                }
              } else n.add(_t83);
            }
          } catch (err) {
            _didIteratorError88 = true;
            _iteratorError88 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion88 && _iterator88.return != null) {
                _iterator88.return();
              }
            } finally {
              if (_didIteratorError88) {
                throw _iteratorError88;
              }
            }
          }

          return n;
        }
      }, {
        key: "registerViewToModelLength",
        value: function registerViewToModelLength(t, e) {
          this._viewToModelLengthCallbacks.set(t, e);
        }
      }, {
        key: "findMappedViewAncestor",
        value: function findMappedViewAncestor(t) {
          var e = t.parent;

          for (; !this._viewToModelMapping.has(e);) {
            e = e.parent;
          }

          return e;
        }
      }, {
        key: "_toModelOffset",
        value: function _toModelOffset(t, e, n) {
          if (n != t) {
            return this._toModelOffset(t.parent, t.index, n) + this._toModelOffset(t, e, t);
          }

          if (t.is("text")) return e;
          var i = 0;

          for (var _n79 = 0; _n79 < e; _n79++) {
            i += this.getModelLength(t.getChild(_n79));
          }

          return i;
        }
      }, {
        key: "getModelLength",
        value: function getModelLength(t) {
          if (this._viewToModelLengthCallbacks.get(t.name)) {
            return this._viewToModelLengthCallbacks.get(t.name)(t);
          }

          if (this._viewToModelMapping.has(t)) return 1;
          if (t.is("text")) return t.data.length;
          if (t.is("uiElement")) return 0;
          {
            var _e75 = 0;
            var _iteratorNormalCompletion90 = true;
            var _didIteratorError90 = false;
            var _iteratorError90 = undefined;

            try {
              for (var _iterator90 = t.getChildren()[Symbol.iterator](), _step90; !(_iteratorNormalCompletion90 = (_step90 = _iterator90.next()).done); _iteratorNormalCompletion90 = true) {
                var _n80 = _step90.value;
                _e75 += this.getModelLength(_n80);
              }
            } catch (err) {
              _didIteratorError90 = true;
              _iteratorError90 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion90 && _iterator90.return != null) {
                  _iterator90.return();
                }
              } finally {
                if (_didIteratorError90) {
                  throw _iteratorError90;
                }
              }
            }

            return _e75;
          }
        }
      }, {
        key: "_findPositionIn",
        value: function _findPositionIn(t, e) {
          var n,
              i = 0,
              o = 0,
              r = 0;
          if (t.is("text")) return new Zi(t, e);

          for (; o < e;) {
            n = t.getChild(r), o += i = this.getModelLength(n), r++;
          }

          return o == e ? this._moveViewPositionToTextNode(new Zi(t, r)) : this._findPositionIn(n, e - (o - i));
        }
      }, {
        key: "_moveViewPositionToTextNode",
        value: function _moveViewPositionToTextNode(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          return e instanceof fi ? new Zi(e, e.data.length) : n instanceof fi ? new Zi(n, 0) : t;
        }
      }]);

      return Js;
    }();

    ci(Js, ei);

    var Ks =
    /*#__PURE__*/
    function () {
      function Ks() {
        _classCallCheck(this, Ks);

        this._consumable = new Map(), this._textProxyRegistry = new Map();
      }

      _createClass(Ks, [{
        key: "add",
        value: function add(t, e) {
          e = Zs(e), t instanceof Us && (t = this._getSymbolForTextProxy(t)), this._consumable.has(t) || this._consumable.set(t, new Map()), this._consumable.get(t).set(e, !0);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          return e = Zs(e), t instanceof Us && (t = this._getSymbolForTextProxy(t)), !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0);
        }
      }, {
        key: "test",
        value: function test(t, e) {
          e = Zs(e), t instanceof Us && (t = this._getSymbolForTextProxy(t));

          var n = this._consumable.get(t);

          if (void 0 === n) return null;
          var i = n.get(e);
          return void 0 === i ? null : i;
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          e = Zs(e), t instanceof Us && (t = this._getSymbolForTextProxy(t));
          var n = this.test(t, e);
          return !1 === n ? (this._consumable.get(t).set(e, !0), !0) : !0 !== n && null;
        }
      }, {
        key: "_getSymbolForTextProxy",
        value: function _getSymbolForTextProxy(t) {
          var e = null;

          var n = this._textProxyRegistry.get(t.startOffset);

          if (n) {
            var _i61 = n.get(t.endOffset);

            _i61 && (e = _i61.get(t.parent));
          }

          return e || (e = this._addSymbolForTextProxy(t.startOffset, t.endOffset, t.parent)), e;
        }
      }, {
        key: "_addSymbolForTextProxy",
        value: function _addSymbolForTextProxy(t, e, n) {
          var i = Symbol("textProxySymbol");
          var o, r;
          return (o = this._textProxyRegistry.get(t)) || (o = new Map(), this._textProxyRegistry.set(t, o)), (r = o.get(e)) || (r = new Map(), o.set(e, r)), r.set(n, i), i;
        }
      }]);

      return Ks;
    }();

    function Zs(t) {
      var e = t.split(":");
      return e.length > 1 ? e[0] + ":" + e[1] : e[0];
    }

    var Xs =
    /*#__PURE__*/
    function () {
      function Xs() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Xs);

        this.conversionApi = Li({
          dispatcher: this
        }, t);
      }

      _createClass(Xs, [{
        key: "convertChanges",
        value: function convertChanges(t, e) {
          var _iteratorNormalCompletion91 = true;
          var _didIteratorError91 = false;
          var _iteratorError91 = undefined;

          try {
            for (var _iterator91 = t.getMarkersToRemove()[Symbol.iterator](), _step91; !(_iteratorNormalCompletion91 = (_step91 = _iterator91.next()).done); _iteratorNormalCompletion91 = true) {
              var _n81 = _step91.value;
              this.convertMarkerRemove(_n81.name, _n81.range, e);
            }
          } catch (err) {
            _didIteratorError91 = true;
            _iteratorError91 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion91 && _iterator91.return != null) {
                _iterator91.return();
              }
            } finally {
              if (_didIteratorError91) {
                throw _iteratorError91;
              }
            }
          }

          var _iteratorNormalCompletion92 = true;
          var _didIteratorError92 = false;
          var _iteratorError92 = undefined;

          try {
            for (var _iterator92 = t.getChanges()[Symbol.iterator](), _step92; !(_iteratorNormalCompletion92 = (_step92 = _iterator92.next()).done); _iteratorNormalCompletion92 = true) {
              var _n82 = _step92.value;
              "insert" == _n82.type ? this.convertInsert(Qs._createFromPositionAndShift(_n82.position, _n82.length), e) : "remove" == _n82.type ? this.convertRemove(_n82.position, _n82.length, _n82.name, e) : this.convertAttribute(_n82.range, _n82.attributeKey, _n82.attributeOldValue, _n82.attributeNewValue, e);
            }
          } catch (err) {
            _didIteratorError92 = true;
            _iteratorError92 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion92 && _iterator92.return != null) {
                _iterator92.return();
              }
            } finally {
              if (_didIteratorError92) {
                throw _iteratorError92;
              }
            }
          }

          var _iteratorNormalCompletion93 = true;
          var _didIteratorError93 = false;
          var _iteratorError93 = undefined;

          try {
            for (var _iterator93 = t.getMarkersToAdd()[Symbol.iterator](), _step93; !(_iteratorNormalCompletion93 = (_step93 = _iterator93.next()).done); _iteratorNormalCompletion93 = true) {
              var _n83 = _step93.value;
              this.convertMarkerAdd(_n83.name, _n83.range, e);
            }
          } catch (err) {
            _didIteratorError93 = true;
            _iteratorError93 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion93 && _iterator93.return != null) {
                _iterator93.return();
              }
            } finally {
              if (_didIteratorError93) {
                throw _iteratorError93;
              }
            }
          }
        }
      }, {
        key: "convertInsert",
        value: function convertInsert(t, e) {
          this.conversionApi.writer = e, this.conversionApi.consumable = this._createInsertConsumable(t);
          var _iteratorNormalCompletion94 = true;
          var _didIteratorError94 = false;
          var _iteratorError94 = undefined;

          try {
            for (var _iterator94 = t[Symbol.iterator](), _step94; !(_iteratorNormalCompletion94 = (_step94 = _iterator94.next()).done); _iteratorNormalCompletion94 = true) {
              var _e76 = _step94.value;
              var _t84 = _e76.item,
                  _n84 = {
                item: _t84,
                range: Qs._createFromPositionAndShift(_e76.previousPosition, _e76.length)
              };

              this._testAndFire("insert", _n84);

              var _iteratorNormalCompletion95 = true;
              var _didIteratorError95 = false;
              var _iteratorError95 = undefined;

              try {
                for (var _iterator95 = _t84.getAttributeKeys()[Symbol.iterator](), _step95; !(_iteratorNormalCompletion95 = (_step95 = _iterator95.next()).done); _iteratorNormalCompletion95 = true) {
                  var _e77 = _step95.value;
                  _n84.attributeKey = _e77, _n84.attributeOldValue = null, _n84.attributeNewValue = _t84.getAttribute(_e77), this._testAndFire("attribute:".concat(_e77), _n84);
                }
              } catch (err) {
                _didIteratorError95 = true;
                _iteratorError95 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion95 && _iterator95.return != null) {
                    _iterator95.return();
                  }
                } finally {
                  if (_didIteratorError95) {
                    throw _iteratorError95;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError94 = true;
            _iteratorError94 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion94 && _iterator94.return != null) {
                _iterator94.return();
              }
            } finally {
              if (_didIteratorError94) {
                throw _iteratorError94;
              }
            }
          }

          this._clearConversionApi();
        }
      }, {
        key: "convertRemove",
        value: function convertRemove(t, e, n, i) {
          this.conversionApi.writer = i, this.fire("remove:" + n, {
            position: t,
            length: e
          }, this.conversionApi), this._clearConversionApi();
        }
      }, {
        key: "convertAttribute",
        value: function convertAttribute(t, e, n, i, o) {
          this.conversionApi.writer = o, this.conversionApi.consumable = this._createConsumableForRange(t, "attribute:".concat(e));
          var _iteratorNormalCompletion96 = true;
          var _didIteratorError96 = false;
          var _iteratorError96 = undefined;

          try {
            for (var _iterator96 = t[Symbol.iterator](), _step96; !(_iteratorNormalCompletion96 = (_step96 = _iterator96.next()).done); _iteratorNormalCompletion96 = true) {
              var _o31 = _step96.value;
              var _t85 = {
                item: _o31.item,
                range: Qs._createFromPositionAndShift(_o31.previousPosition, _o31.length),
                attributeKey: e,
                attributeOldValue: n,
                attributeNewValue: i
              };

              this._testAndFire("attribute:".concat(e), _t85);
            }
          } catch (err) {
            _didIteratorError96 = true;
            _iteratorError96 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion96 && _iterator96.return != null) {
                _iterator96.return();
              }
            } finally {
              if (_didIteratorError96) {
                throw _iteratorError96;
              }
            }
          }

          this._clearConversionApi();
        }
      }, {
        key: "convertSelection",
        value: function convertSelection(t, e, n) {
          var i = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));

          if (this.conversionApi.writer = n, this.conversionApi.consumable = this._createSelectionConsumable(t, i), this.fire("selection", {
            selection: t
          }, this.conversionApi), t.isCollapsed) {
            for (var _i63 = 0, _i62 = i; _i63 < _i62.length; _i63++) {
              var _e78 = _i62[_i63];

              var _n85 = _e78.getRange();

              if (!ta(t.getFirstPosition(), _e78, this.conversionApi.mapper)) continue;
              var _i64 = {
                item: t,
                markerName: _e78.name,
                markerRange: _n85
              };
              this.conversionApi.consumable.test(t, "addMarker:" + _e78.name) && this.fire("addMarker:" + _e78.name, _i64, this.conversionApi);
            }

            var _iteratorNormalCompletion97 = true;
            var _didIteratorError97 = false;
            var _iteratorError97 = undefined;

            try {
              for (var _iterator97 = t.getAttributeKeys()[Symbol.iterator](), _step97; !(_iteratorNormalCompletion97 = (_step97 = _iterator97.next()).done); _iteratorNormalCompletion97 = true) {
                var _e79 = _step97.value;
                var _n86 = {
                  item: t,
                  range: t.getFirstRange(),
                  attributeKey: _e79,
                  attributeOldValue: null,
                  attributeNewValue: t.getAttribute(_e79)
                };
                this.conversionApi.consumable.test(t, "attribute:" + _n86.attributeKey) && this.fire("attribute:" + _n86.attributeKey + ":$text", _n86, this.conversionApi);
              }
            } catch (err) {
              _didIteratorError97 = true;
              _iteratorError97 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion97 && _iterator97.return != null) {
                  _iterator97.return();
                }
              } finally {
                if (_didIteratorError97) {
                  throw _iteratorError97;
                }
              }
            }

            this._clearConversionApi();
          }
        }
      }, {
        key: "convertMarkerAdd",
        value: function convertMarkerAdd(t, e, n) {
          if (!e.root.document || "$graveyard" == e.root.rootName) return;
          this.conversionApi.writer = n;
          var i = "addMarker:" + t,
              o = new Ks();

          if (o.add(e, i), this.conversionApi.consumable = o, this.fire(i, {
            markerName: t,
            markerRange: e
          }, this.conversionApi), o.test(e, i)) {
            this.conversionApi.consumable = this._createConsumableForRange(e, i);
            var _iteratorNormalCompletion98 = true;
            var _didIteratorError98 = false;
            var _iteratorError98 = undefined;

            try {
              for (var _iterator98 = e.getItems()[Symbol.iterator](), _step98; !(_iteratorNormalCompletion98 = (_step98 = _iterator98.next()).done); _iteratorNormalCompletion98 = true) {
                var _n87 = _step98.value;
                if (!this.conversionApi.consumable.test(_n87, i)) continue;
                var _o32 = {
                  item: _n87,
                  range: Qs._createOn(_n87),
                  markerName: t,
                  markerRange: e
                };
                this.fire(i, _o32, this.conversionApi);
              }
            } catch (err) {
              _didIteratorError98 = true;
              _iteratorError98 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion98 && _iterator98.return != null) {
                  _iterator98.return();
                }
              } finally {
                if (_didIteratorError98) {
                  throw _iteratorError98;
                }
              }
            }

            this._clearConversionApi();
          }
        }
      }, {
        key: "convertMarkerRemove",
        value: function convertMarkerRemove(t, e, n) {
          e.root.document && "$graveyard" != e.root.rootName && (this.conversionApi.writer = n, this.fire("removeMarker:" + t, {
            markerName: t,
            markerRange: e
          }, this.conversionApi), this._clearConversionApi());
        }
      }, {
        key: "_createInsertConsumable",
        value: function _createInsertConsumable(t) {
          var e = new Ks();
          var _iteratorNormalCompletion99 = true;
          var _didIteratorError99 = false;
          var _iteratorError99 = undefined;

          try {
            for (var _iterator99 = t[Symbol.iterator](), _step99; !(_iteratorNormalCompletion99 = (_step99 = _iterator99.next()).done); _iteratorNormalCompletion99 = true) {
              var _n88 = _step99.value;
              var _t86 = _n88.item;
              e.add(_t86, "insert");
              var _iteratorNormalCompletion100 = true;
              var _didIteratorError100 = false;
              var _iteratorError100 = undefined;

              try {
                for (var _iterator100 = _t86.getAttributeKeys()[Symbol.iterator](), _step100; !(_iteratorNormalCompletion100 = (_step100 = _iterator100.next()).done); _iteratorNormalCompletion100 = true) {
                  var _n89 = _step100.value;
                  e.add(_t86, "attribute:" + _n89);
                }
              } catch (err) {
                _didIteratorError100 = true;
                _iteratorError100 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion100 && _iterator100.return != null) {
                    _iterator100.return();
                  }
                } finally {
                  if (_didIteratorError100) {
                    throw _iteratorError100;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError99 = true;
            _iteratorError99 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion99 && _iterator99.return != null) {
                _iterator99.return();
              }
            } finally {
              if (_didIteratorError99) {
                throw _iteratorError99;
              }
            }
          }

          return e;
        }
      }, {
        key: "_createConsumableForRange",
        value: function _createConsumableForRange(t, e) {
          var n = new Ks();
          var _iteratorNormalCompletion101 = true;
          var _didIteratorError101 = false;
          var _iteratorError101 = undefined;

          try {
            for (var _iterator101 = t.getItems()[Symbol.iterator](), _step101; !(_iteratorNormalCompletion101 = (_step101 = _iterator101.next()).done); _iteratorNormalCompletion101 = true) {
              var _i65 = _step101.value;
              n.add(_i65, e);
            }
          } catch (err) {
            _didIteratorError101 = true;
            _iteratorError101 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion101 && _iterator101.return != null) {
                _iterator101.return();
              }
            } finally {
              if (_didIteratorError101) {
                throw _iteratorError101;
              }
            }
          }

          return n;
        }
      }, {
        key: "_createSelectionConsumable",
        value: function _createSelectionConsumable(t, e) {
          var n = new Ks();
          n.add(t, "selection");
          var _iteratorNormalCompletion102 = true;
          var _didIteratorError102 = false;
          var _iteratorError102 = undefined;

          try {
            for (var _iterator102 = e[Symbol.iterator](), _step102; !(_iteratorNormalCompletion102 = (_step102 = _iterator102.next()).done); _iteratorNormalCompletion102 = true) {
              var _i66 = _step102.value;
              n.add(t, "addMarker:" + _i66.name);
            }
          } catch (err) {
            _didIteratorError102 = true;
            _iteratorError102 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion102 && _iterator102.return != null) {
                _iterator102.return();
              }
            } finally {
              if (_didIteratorError102) {
                throw _iteratorError102;
              }
            }
          }

          var _iteratorNormalCompletion103 = true;
          var _didIteratorError103 = false;
          var _iteratorError103 = undefined;

          try {
            for (var _iterator103 = t.getAttributeKeys()[Symbol.iterator](), _step103; !(_iteratorNormalCompletion103 = (_step103 = _iterator103.next()).done); _iteratorNormalCompletion103 = true) {
              var _e80 = _step103.value;
              n.add(t, "attribute:" + _e80);
            }
          } catch (err) {
            _didIteratorError103 = true;
            _iteratorError103 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion103 && _iterator103.return != null) {
                _iterator103.return();
              }
            } finally {
              if (_didIteratorError103) {
                throw _iteratorError103;
              }
            }
          }

          return n;
        }
      }, {
        key: "_testAndFire",
        value: function _testAndFire(t, e) {
          if (!this.conversionApi.consumable.test(e.item, t)) return;
          var n = e.item.name || "$text";
          this.fire(t + ":" + n, e, this.conversionApi);
        }
      }, {
        key: "_clearConversionApi",
        value: function _clearConversionApi() {
          delete this.conversionApi.writer, delete this.conversionApi.consumable;
        }
      }]);

      return Xs;
    }();

    function ta(t, e, n) {
      var i = e.getRange(),
          o = Array.from(t.getAncestors());
      return o.shift(), o.reverse(), !o.some(function (t) {
        if (i.containsItem(t)) {
          return !!n.toViewElement(t).getCustomProperty("addHighlight");
        }
      });
    }

    ci(Xs, ei);

    var ea =
    /*#__PURE__*/
    function () {
      function ea(t, e, n) {
        _classCallCheck(this, ea);

        this._lastRangeBackward = !1, this._ranges = [], this._attrs = new Map(), t && this.setTo(t, e, n);
      }

      _createClass(ea, [{
        key: "isEqual",
        value: function isEqual(t) {
          if (this.rangeCount != t.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
          var _iteratorNormalCompletion104 = true;
          var _didIteratorError104 = false;
          var _iteratorError104 = undefined;

          try {
            for (var _iterator104 = this._ranges[Symbol.iterator](), _step104; !(_iteratorNormalCompletion104 = (_step104 = _iterator104.next()).done); _iteratorNormalCompletion104 = true) {
              var _e81 = _step104.value;

              var _n90 = !1;

              var _iteratorNormalCompletion105 = true;
              var _didIteratorError105 = false;
              var _iteratorError105 = undefined;

              try {
                for (var _iterator105 = t._ranges[Symbol.iterator](), _step105; !(_iteratorNormalCompletion105 = (_step105 = _iterator105.next()).done); _iteratorNormalCompletion105 = true) {
                  var _i67 = _step105.value;

                  if (_e81.isEqual(_i67)) {
                    _n90 = !0;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError105 = true;
                _iteratorError105 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion105 && _iterator105.return != null) {
                    _iterator105.return();
                  }
                } finally {
                  if (_didIteratorError105) {
                    throw _iteratorError105;
                  }
                }
              }

              if (!_n90) return !1;
            }
          } catch (err) {
            _didIteratorError104 = true;
            _iteratorError104 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion104 && _iterator104.return != null) {
                _iterator104.return();
              }
            } finally {
              if (_didIteratorError104) {
                throw _iteratorError104;
              }
            }
          }

          return !0;
        }
      }, {
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          var _iteratorNormalCompletion106, _didIteratorError106, _iteratorError106, _iterator106, _step106, _t87;

          return _regeneratorRuntime.wrap(function getRanges$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  _iteratorNormalCompletion106 = true;
                  _didIteratorError106 = false;
                  _iteratorError106 = undefined;
                  _context14.prev = 3;
                  _iterator106 = this._ranges[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion106 = (_step106 = _iterator106.next()).done) {
                    _context14.next = 12;
                    break;
                  }

                  _t87 = _step106.value;
                  _context14.next = 9;
                  return new Qs(_t87.start, _t87.end);

                case 9:
                  _iteratorNormalCompletion106 = true;
                  _context14.next = 5;
                  break;

                case 12:
                  _context14.next = 18;
                  break;

                case 14:
                  _context14.prev = 14;
                  _context14.t0 = _context14["catch"](3);
                  _didIteratorError106 = true;
                  _iteratorError106 = _context14.t0;

                case 18:
                  _context14.prev = 18;
                  _context14.prev = 19;

                  if (!_iteratorNormalCompletion106 && _iterator106.return != null) {
                    _iterator106.return();
                  }

                case 21:
                  _context14.prev = 21;

                  if (!_didIteratorError106) {
                    _context14.next = 24;
                    break;
                  }

                  throw _iteratorError106;

                case 24:
                  return _context14.finish(21);

                case 25:
                  return _context14.finish(18);

                case 26:
                case "end":
                  return _context14.stop();
              }
            }
          }, getRanges, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;
          var _iteratorNormalCompletion107 = true;
          var _didIteratorError107 = false;
          var _iteratorError107 = undefined;

          try {
            for (var _iterator107 = this._ranges[Symbol.iterator](), _step107; !(_iteratorNormalCompletion107 = (_step107 = _iterator107.next()).done); _iteratorNormalCompletion107 = true) {
              var _e82 = _step107.value;
              t && !_e82.start.isBefore(t.start) || (t = _e82);
            }
          } catch (err) {
            _didIteratorError107 = true;
            _iteratorError107 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion107 && _iterator107.return != null) {
                _iterator107.return();
              }
            } finally {
              if (_didIteratorError107) {
                throw _iteratorError107;
              }
            }
          }

          return t ? new Qs(t.start, t.end) : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;
          var _iteratorNormalCompletion108 = true;
          var _didIteratorError108 = false;
          var _iteratorError108 = undefined;

          try {
            for (var _iterator108 = this._ranges[Symbol.iterator](), _step108; !(_iteratorNormalCompletion108 = (_step108 = _iterator108.next()).done); _iteratorNormalCompletion108 = true) {
              var _e83 = _step108.value;
              t && !_e83.end.isAfter(t.end) || (t = _e83);
            }
          } catch (err) {
            _didIteratorError108 = true;
            _iteratorError108 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion108 && _iterator108.return != null) {
                _iterator108.return();
              }
            } finally {
              if (_didIteratorError108) {
                throw _iteratorError108;
              }
            }
          }

          return t ? new Qs(t.start, t.end) : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (null === t) this._setRanges([]);else if (t instanceof ea) this._setRanges(t.getRanges(), t.isBackward);else if (t && "function" == typeof t.getRanges) this._setRanges(t.getRanges(), t.isBackward);else if (t instanceof Qs) this._setRanges([t], !!e && !!e.backward);else if (t instanceof Gs) this._setRanges([new Qs(t)]);else if (t instanceof zs) {
            var _i68 = !!n && !!n.backward;

            var _o33;

            if ("in" == e) _o33 = Qs._createIn(t);else if ("on" == e) _o33 = Qs._createOn(t);else {
              if (void 0 === e) throw new Gn.b("model-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.", [this, t]);
              _o33 = new Qs(Gs._createAt(t, e));
            }

            this._setRanges([_o33], _i68);
          } else {
            if (!gi(t)) throw new Gn.b("model-selection-setTo-not-selectable: Cannot set the selection to the given place.", [this, t]);

            this._setRanges(t, e && !!e.backward);
          }
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var _this42 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = (t = Array.from(t)).some(function (e) {
            if (!(e instanceof Qs)) throw new Gn.b("model-selection-set-ranges-not-range: Selection range set to an object that is not an instance of model.Range.", [_this42, t]);
            return _this42._ranges.every(function (t) {
              return !t.isEqual(e);
            });
          });

          if (t.length !== this._ranges.length || n) {
            this._removeAllRanges();

            var _iteratorNormalCompletion109 = true;
            var _didIteratorError109 = false;
            var _iteratorError109 = undefined;

            try {
              for (var _iterator109 = t[Symbol.iterator](), _step109; !(_iteratorNormalCompletion109 = (_step109 = _iterator109.next()).done); _iteratorNormalCompletion109 = true) {
                var _e84 = _step109.value;

                this._pushRange(_e84);
              }
            } catch (err) {
              _didIteratorError109 = true;
              _iteratorError109 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion109 && _iterator109.return != null) {
                  _iterator109.return();
                }
              } finally {
                if (_didIteratorError109) {
                  throw _iteratorError109;
                }
              }
            }

            this._lastRangeBackward = !!e, this.fire("change:range", {
              directChange: !0
            });
          }
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (null === this.anchor) throw new Gn.b("model-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.", [this, t]);

          var n = Gs._createAt(t, e);

          if ("same" == n.compareWith(this.focus)) return;
          var i = this.anchor;
          this._ranges.length && this._popRange(), "before" == n.compareWith(i) ? (this._pushRange(new Qs(n, i)), this._lastRangeBackward = !0) : (this._pushRange(new Qs(i, n)), this._lastRangeBackward = !1), this.fire("change:range", {
            directChange: !0
          });
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", {
            attributeKeys: [t],
            directChange: !0
          }));
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          this.getAttribute(t) !== e && (this._attrs.set(t, e), this.fire("change:attribute", {
            attributeKeys: [t],
            directChange: !0
          }));
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          if (1 !== this.rangeCount) return null;
          var t = this.getFirstRange(),
              e = t.start.nodeAfter,
              n = t.end.nodeBefore;
          return e instanceof qs && e == n ? e : null;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t;
        }
      }, {
        key: "getSelectedBlocks",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getSelectedBlocks() {
          var t, _iteratorNormalCompletion110, _didIteratorError110, _iteratorError110, _iterator110, _step110, _e85, _n91, _iteratorNormalCompletion111, _didIteratorError111, _iteratorError111, _iterator111, _step111, _n92, _i69;

          return _regeneratorRuntime.wrap(function getSelectedBlocks$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  t = new WeakSet();
                  _iteratorNormalCompletion110 = true;
                  _didIteratorError110 = false;
                  _iteratorError110 = undefined;
                  _context15.prev = 4;
                  _iterator110 = this.getRanges()[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion110 = (_step110 = _iterator110.next()).done) {
                    _context15.next = 49;
                    break;
                  }

                  _e85 = _step110.value;
                  _n91 = ia(_e85.start, t);
                  _context15.t0 = _n91;

                  if (!_context15.t0) {
                    _context15.next = 13;
                    break;
                  }

                  _context15.next = 13;
                  return _n91;

                case 13:
                  _iteratorNormalCompletion111 = true;
                  _didIteratorError111 = false;
                  _iteratorError111 = undefined;
                  _context15.prev = 16;
                  _iterator111 = _e85.getWalker()[Symbol.iterator]();

                case 18:
                  if (_iteratorNormalCompletion111 = (_step111 = _iterator111.next()).done) {
                    _context15.next = 27;
                    break;
                  }

                  _n92 = _step111.value;
                  _context15.t1 = "elementEnd" == _n92.type && na(_n92.item, t);

                  if (!_context15.t1) {
                    _context15.next = 24;
                    break;
                  }

                  _context15.next = 24;
                  return _n92.item;

                case 24:
                  _iteratorNormalCompletion111 = true;
                  _context15.next = 18;
                  break;

                case 27:
                  _context15.next = 33;
                  break;

                case 29:
                  _context15.prev = 29;
                  _context15.t2 = _context15["catch"](16);
                  _didIteratorError111 = true;
                  _iteratorError111 = _context15.t2;

                case 33:
                  _context15.prev = 33;
                  _context15.prev = 34;

                  if (!_iteratorNormalCompletion111 && _iterator111.return != null) {
                    _iterator111.return();
                  }

                case 36:
                  _context15.prev = 36;

                  if (!_didIteratorError111) {
                    _context15.next = 39;
                    break;
                  }

                  throw _iteratorError111;

                case 39:
                  return _context15.finish(36);

                case 40:
                  return _context15.finish(33);

                case 41:
                  _i69 = ia(_e85.end, t);
                  _context15.t3 = _i69 && !_e85.end.isTouching(Gs._createAt(_i69, 0));

                  if (!_context15.t3) {
                    _context15.next = 46;
                    break;
                  }

                  _context15.next = 46;
                  return _i69;

                case 46:
                  _iteratorNormalCompletion110 = true;
                  _context15.next = 6;
                  break;

                case 49:
                  _context15.next = 55;
                  break;

                case 51:
                  _context15.prev = 51;
                  _context15.t4 = _context15["catch"](4);
                  _didIteratorError110 = true;
                  _iteratorError110 = _context15.t4;

                case 55:
                  _context15.prev = 55;
                  _context15.prev = 56;

                  if (!_iteratorNormalCompletion110 && _iterator110.return != null) {
                    _iterator110.return();
                  }

                case 58:
                  _context15.prev = 58;

                  if (!_didIteratorError110) {
                    _context15.next = 61;
                    break;
                  }

                  throw _iteratorError110;

                case 61:
                  return _context15.finish(58);

                case 62:
                  return _context15.finish(55);

                case 63:
                case "end":
                  return _context15.stop();
              }
            }
          }, getSelectedBlocks, this, [[4, 51, 55, 63], [16, 29, 33, 41], [34,, 36, 40], [56,, 58, 62]]);
        })
      }, {
        key: "getTopMostBlocks",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getTopMostBlocks() {
          var t, _i70, _t88, _e86, _n93;

          return _regeneratorRuntime.wrap(function getTopMostBlocks$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  t = Array.from(this.getSelectedBlocks());
                  _i70 = 0, _t88 = t;

                case 2:
                  if (!(_i70 < _t88.length)) {
                    _context16.next = 12;
                    break;
                  }

                  _e86 = _t88[_i70];
                  _n93 = oa(_e86);
                  _context16.t0 = _n93 && t.includes(_n93);

                  if (_context16.t0) {
                    _context16.next = 9;
                    break;
                  }

                  _context16.next = 9;
                  return _e86;

                case 9:
                  _i70++;
                  _context16.next = 2;
                  break;

                case 12:
                case "end":
                  return _context16.stop();
              }
            }
          }, getTopMostBlocks, this);
        })
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;

          var e = Gs._createAt(t, 0),
              n = Gs._createAt(t, "end");

          return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          this._checkRange(t), this._ranges.push(new Qs(t.start, t.end));
        }
      }, {
        key: "_checkRange",
        value: function _checkRange(t) {
          for (var _e87 = 0; _e87 < this._ranges.length; _e87++) {
            if (t.isIntersecting(this._ranges[_e87])) throw new Gn.b("model-selection-range-intersects: Trying to add a range that intersects with another range in the selection.", [this, t], {
              addedRange: t,
              intersectingRange: this._ranges[_e87]
            });
          }
        }
      }, {
        key: "_removeAllRanges",
        value: function _removeAllRanges() {
          for (; this._ranges.length > 0;) {
            this._popRange();
          }
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop();
        }
      }, {
        key: "anchor",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t89 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t89.end : _t89.start;
          }

          return null;
        }
      }, {
        key: "focus",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t90 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t90.start : _t90.end;
          }

          return null;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this._ranges.length && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }]);

      return ea;
    }();

    function na(t, e) {
      return !e.has(t) && (e.add(t), t.document.model.schema.isBlock(t) && t.parent);
    }

    function ia(t, e) {
      var n = t.parent.document.model.schema,
          i = t.parent.getAncestors({
        parentFirst: !0,
        includeSelf: !0
      });
      var o = !1;
      var r = i.find(function (t) {
        return !o && !(o = n.isLimit(t)) && na(t, e);
      });
      return i.forEach(function (t) {
        return e.add(t);
      }), r;
    }

    function oa(t) {
      var e = t.document.model.schema;
      var n = t.parent;

      for (; n;) {
        if (e.isBlock(n)) return n;
        n = n.parent;
      }
    }

    ci(ea, ei);

    var ra =
    /*#__PURE__*/
    function (_Qs) {
      _inherits(ra, _Qs);

      function ra(t, e) {
        var _this43;

        _classCallCheck(this, ra);

        _this43 = _possibleConstructorReturn(this, _getPrototypeOf(ra).call(this, t, e)), function () {
          var _this44 = this;

          this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
            var n = e[0];
            n.isDocumentOperation && function (t) {
              var e = this.getTransformedByOperation(t),
                  n = Qs._createFromRanges(e),
                  i = !n.isEqual(this),
                  o = function (t, e) {
                switch (e.type) {
                  case "insert":
                    return t.containsPosition(e.position);

                  case "move":
                  case "remove":
                  case "reinsert":
                  case "merge":
                    return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);

                  case "split":
                    return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
                }

                return !1;
              }(this, t);

              var r = null;

              if (i) {
                "$graveyard" == n.root.rootName && (r = "remove" == t.type ? t.sourcePosition : t.deletionPosition);

                var _e88 = this.toRange();

                this.start = n.start, this.end = n.end, this.fire("change:range", _e88, {
                  deletionPosition: r
                });
              } else o && this.fire("change:content", this.toRange(), {
                deletionPosition: r
              });
            }.call(_this44, n);
          }, {
            priority: "low"
          });
        }.call(_assertThisInitialized(_this43));
        return _this43;
      }

      _createClass(ra, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "toRange",
        value: function toRange() {
          return new Qs(this.start, this.end);
        }
      }], [{
        key: "fromRange",
        value: function fromRange(t) {
          return new ra(t.start, t.end);
        }
      }]);

      return ra;
    }(Qs);

    ci(ra, ei);
    var sa = "selection:";

    var aa =
    /*#__PURE__*/
    function () {
      function aa(t) {
        _classCallCheck(this, aa);

        this._selection = new ca(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this);
      }

      _createClass(aa, [{
        key: "getRanges",
        value: function getRanges() {
          return this._selection.getRanges();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getSelectedBlocks",
        value: function getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
      }, {
        key: "getTopMostBlocks",
        value: function getTopMostBlocks() {
          return this._selection.getTopMostBlocks();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent(t) {
          return this._selection.containsEntireContent(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._selection.destroy();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._selection.getAttributes();
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._selection.getAttribute(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._selection.hasAttribute(t);
        }
      }, {
        key: "refresh",
        value: function refresh() {
          this._selection._updateMarkers(), this._selection._updateAttributes(!1);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "documentSelection" == t;
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._selection.setAttribute(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          this._selection.removeAttribute(t);
        }
      }, {
        key: "_getStoredAttributes",
        value: function _getStoredAttributes() {
          return this._selection._getStoredAttributes();
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          return this._selection.overrideGravity();
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity(t) {
          this._selection.restoreGravity(t);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._selection.hasOwnRange;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return this._selection.isGravityOverridden;
        }
      }, {
        key: "markers",
        get: function get() {
          return this._selection.markers;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }], [{
        key: "_getStoreAttributeKey",
        value: function _getStoreAttributeKey(t) {
          return sa + t;
        }
      }, {
        key: "_isStoreAttributeKey",
        value: function _isStoreAttributeKey(t) {
          return t.startsWith(sa);
        }
      }]);

      return aa;
    }();

    ci(aa, ei);

    var ca =
    /*#__PURE__*/
    function (_ea) {
      _inherits(ca, _ea);

      function ca(t) {
        var _this45;

        _classCallCheck(this, ca);

        _this45 = _possibleConstructorReturn(this, _getPrototypeOf(ca).call(this)), _this45.markers = new oo({
          idProperty: "name"
        }), _this45._model = t.model, _this45._document = t, _this45._attributePriority = new Map(), _this45._fixGraveyardRangesData = [], _this45._hasChangedRange = !1, _this45._overriddenGravityRegister = new Set(), _this45.listenTo(_this45._model, "applyOperation", function (t, e) {
          var n = e[0];

          if (n.isDocumentOperation && "marker" != n.type && "rename" != n.type && "noop" != n.type) {
            for (; _this45._fixGraveyardRangesData.length;) {
              var _this45$_fixGraveyard = _this45._fixGraveyardRangesData.shift(),
                  _t91 = _this45$_fixGraveyard.liveRange,
                  _e89 = _this45$_fixGraveyard.sourcePosition;

              _this45._fixGraveyardSelection(_t91, _e89);
            }

            _this45._hasChangedRange && (_this45._hasChangedRange = !1, _this45.fire("change:range", {
              directChange: !1
            }));
          }
        }, {
          priority: "lowest"
        }), _this45.on("change:range", function () {
          var _iteratorNormalCompletion112 = true;
          var _didIteratorError112 = false;
          var _iteratorError112 = undefined;

          try {
            for (var _iterator112 = _this45.getRanges()[Symbol.iterator](), _step112; !(_iteratorNormalCompletion112 = (_step112 = _iterator112.next()).done); _iteratorNormalCompletion112 = true) {
              var _t92 = _step112.value;
              if (!_this45._document._validateSelectionRange(_t92)) throw new Gn.b("document-selection-wrong-position: Range from document selection starts or ends at incorrect position.", _assertThisInitialized(_this45), {
                range: _t92
              });
            }
          } catch (err) {
            _didIteratorError112 = true;
            _iteratorError112 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion112 && _iterator112.return != null) {
                _iterator112.return();
              }
            } finally {
              if (_didIteratorError112) {
                throw _iteratorError112;
              }
            }
          }
        }), _this45.listenTo(_this45._model.markers, "update", function () {
          return _this45._updateMarkers();
        }), _this45.listenTo(_this45._document, "change", function (t, e) {
          !function (t, e) {
            var n = t.document.differ;
            var _iteratorNormalCompletion113 = true;
            var _didIteratorError113 = false;
            var _iteratorError113 = undefined;

            try {
              var _loop2 = function _loop2() {
                var i = _step113.value;
                if ("insert" != i.type) return "continue";
                var n = i.position.parent,
                    o = i.length === n.maxOffset;
                o && t.enqueueChange(e, function (t) {
                  var e = Array.from(n.getAttributeKeys()).filter(function (t) {
                    return t.startsWith(sa);
                  });
                  var _iteratorNormalCompletion114 = true;
                  var _didIteratorError114 = false;
                  var _iteratorError114 = undefined;

                  try {
                    for (var _iterator114 = e[Symbol.iterator](), _step114; !(_iteratorNormalCompletion114 = (_step114 = _iterator114.next()).done); _iteratorNormalCompletion114 = true) {
                      var _i71 = _step114.value;
                      t.removeAttribute(_i71, n);
                    }
                  } catch (err) {
                    _didIteratorError114 = true;
                    _iteratorError114 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion114 && _iterator114.return != null) {
                        _iterator114.return();
                      }
                    } finally {
                      if (_didIteratorError114) {
                        throw _iteratorError114;
                      }
                    }
                  }
                });
              };

              for (var _iterator113 = n.getChanges()[Symbol.iterator](), _step113; !(_iteratorNormalCompletion113 = (_step113 = _iterator113.next()).done); _iteratorNormalCompletion113 = true) {
                var _ret = _loop2();

                if (_ret === "continue") continue;
              }
            } catch (err) {
              _didIteratorError113 = true;
              _iteratorError113 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion113 && _iterator113.return != null) {
                  _iterator113.return();
                }
              } finally {
                if (_didIteratorError113) {
                  throw _iteratorError113;
                }
              }
            }
          }(_this45._model, e);
        });
        return _this45;
      }

      _createClass(ca, [{
        key: "destroy",
        value: function destroy() {
          for (var _t93 = 0; _t93 < this._ranges.length; _t93++) {
            this._ranges[_t93].detach();
          }

          this.stopListening();
        }
      }, {
        key: "getRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getRanges() {
          return _regeneratorRuntime.wrap(function getRanges$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  if (!this._ranges.length) {
                    _context17.next = 4;
                    break;
                  }

                  return _context17.delegateYield(_get(_getPrototypeOf(ca.prototype), "getRanges", this).call(this), "t0", 2);

                case 2:
                  _context17.next = 6;
                  break;

                case 4:
                  _context17.next = 6;
                  return this._document._getDefaultRange();

                case 6:
                case "end":
                  return _context17.stop();
              }
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return _get(_getPrototypeOf(ca.prototype), "getFirstRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return _get(_getPrototypeOf(ca.prototype), "getLastRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          _get(_getPrototypeOf(ca.prototype), "setTo", this).call(this, t, e, n), this._updateAttributes(!0);
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          _get(_getPrototypeOf(ca.prototype), "setFocus", this).call(this, t, e), this._updateAttributes(!0);
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          if (this._setAttribute(t, e)) {
            var _e90 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e90,
              directChange: !0
            });
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          if (this._removeAttribute(t)) {
            var _e91 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e91,
              directChange: !0
            });
          }
        }
      }, {
        key: "overrideGravity",
        value: function overrideGravity() {
          var t = Kn();
          return this._overriddenGravityRegister.add(t), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), t;
        }
      }, {
        key: "restoreGravity",
        value: function restoreGravity(t) {
          if (!this._overriddenGravityRegister.has(t)) throw new Gn.b("document-selection-gravity-wrong-restore: Attempting to restore the selection gravity for an unknown UID.", this, {
            uid: t
          });
          this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop().detach();
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var e = this._prepareRange(t);

          e && this._ranges.push(e);
        }
      }, {
        key: "_prepareRange",
        value: function _prepareRange(t) {
          var _this46 = this;

          if (this._checkRange(t), t.root == this._document.graveyard) return void bs.a.warn("model-selection-range-in-graveyard: Trying to add a Range that is in the graveyard root. Range rejected.");
          var e = ra.fromRange(t);
          return e.on("change:range", function (t, n, i) {
            _this46._hasChangedRange = !0, e.root == _this46._document.graveyard && _this46._fixGraveyardRangesData.push({
              liveRange: e,
              sourcePosition: i.deletionPosition
            });
          }), e;
        }
      }, {
        key: "_updateMarkers",
        value: function _updateMarkers() {
          var t = [];
          var _iteratorNormalCompletion115 = true;
          var _didIteratorError115 = false;
          var _iteratorError115 = undefined;

          try {
            for (var _iterator115 = this._model.markers[Symbol.iterator](), _step115; !(_iteratorNormalCompletion115 = (_step115 = _iterator115.next()).done); _iteratorNormalCompletion115 = true) {
              var _e92 = _step115.value;

              var _n94 = _e92.getRange();

              var _iteratorNormalCompletion116 = true;
              var _didIteratorError116 = false;
              var _iteratorError116 = undefined;

              try {
                for (var _iterator116 = this.getRanges()[Symbol.iterator](), _step116; !(_iteratorNormalCompletion116 = (_step116 = _iterator116.next()).done); _iteratorNormalCompletion116 = true) {
                  var _i74 = _step116.value;
                  _n94.containsRange(_i74, !_i74.isCollapsed) && t.push(_e92);
                }
              } catch (err) {
                _didIteratorError116 = true;
                _iteratorError116 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion116 && _iterator116.return != null) {
                    _iterator116.return();
                  }
                } finally {
                  if (_didIteratorError116) {
                    throw _iteratorError116;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError115 = true;
            _iteratorError115 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion115 && _iterator115.return != null) {
                _iterator115.return();
              }
            } finally {
              if (_didIteratorError115) {
                throw _iteratorError115;
              }
            }
          }

          for (var _i72 = 0, _t94 = t; _i72 < _t94.length; _i72++) {
            var _e93 = _t94[_i72];
            this.markers.has(_e93) || this.markers.add(_e93);
          }

          for (var _i73 = 0, _Array$from3 = Array.from(this.markers); _i73 < _Array$from3.length; _i73++) {
            var _e94 = _Array$from3[_i73];
            t.includes(_e94) || this.markers.remove(_e94);
          }
        }
      }, {
        key: "_updateAttributes",
        value: function _updateAttributes(t) {
          var e = Bs(this._getSurroundingAttributes()),
              n = Bs(this.getAttributes());
          if (t) this._attributePriority = new Map(), this._attrs = new Map();else {
            var _iteratorNormalCompletion117 = true;
            var _didIteratorError117 = false;
            var _iteratorError117 = undefined;

            try {
              for (var _iterator117 = this._attributePriority[Symbol.iterator](), _step117; !(_iteratorNormalCompletion117 = (_step117 = _iterator117.next()).done); _iteratorNormalCompletion117 = true) {
                var _ref25 = _step117.value;

                var _ref24 = _slicedToArray(_ref25, 2);

                var _t95 = _ref24[0];
                var _e95 = _ref24[1];
                "low" == _e95 && (this._attrs.delete(_t95), this._attributePriority.delete(_t95));
              }
            } catch (err) {
              _didIteratorError117 = true;
              _iteratorError117 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion117 && _iterator117.return != null) {
                  _iterator117.return();
                }
              } finally {
                if (_didIteratorError117) {
                  throw _iteratorError117;
                }
              }
            }
          }

          this._setAttributesTo(e);

          var i = [];
          var _iteratorNormalCompletion118 = true;
          var _didIteratorError118 = false;
          var _iteratorError118 = undefined;

          try {
            for (var _iterator118 = this.getAttributes()[Symbol.iterator](), _step118; !(_iteratorNormalCompletion118 = (_step118 = _iterator118.next()).done); _iteratorNormalCompletion118 = true) {
              var _ref30 = _step118.value;

              var _ref27 = _slicedToArray(_ref30, 2);

              var _t96 = _ref27[0];
              var _e96 = _ref27[1];
              n.has(_t96) && n.get(_t96) === _e96 || i.push(_t96);
            }
          } catch (err) {
            _didIteratorError118 = true;
            _iteratorError118 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion118 && _iterator118.return != null) {
                _iterator118.return();
              }
            } finally {
              if (_didIteratorError118) {
                throw _iteratorError118;
              }
            }
          }

          var _iteratorNormalCompletion119 = true;
          var _didIteratorError119 = false;
          var _iteratorError119 = undefined;

          try {
            for (var _iterator119 = n[Symbol.iterator](), _step119; !(_iteratorNormalCompletion119 = (_step119 = _iterator119.next()).done); _iteratorNormalCompletion119 = true) {
              var _ref31 = _step119.value;

              var _ref29 = _slicedToArray(_ref31, 1);

              var _t97 = _ref29[0];
              this.hasAttribute(_t97) || i.push(_t97);
            }
          } catch (err) {
            _didIteratorError119 = true;
            _iteratorError119 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion119 && _iterator119.return != null) {
                _iterator119.return();
              }
            } finally {
              if (_didIteratorError119) {
                throw _iteratorError119;
              }
            }
          }

          i.length > 0 && this.fire("change:attribute", {
            attributeKeys: i,
            directChange: !1
          });
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          var i = n ? "normal" : "low";
          return ("low" != i || "normal" != this._attributePriority.get(t)) && _get(_getPrototypeOf(ca.prototype), "getAttribute", this).call(this, t) !== e && (this._attrs.set(t, e), this._attributePriority.set(t, i), !0);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var n = e ? "normal" : "low";
          return ("low" != n || "normal" != this._attributePriority.get(t)) && (this._attributePriority.set(t, n), !!_get(_getPrototypeOf(ca.prototype), "hasAttribute", this).call(this, t) && (this._attrs.delete(t), !0));
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          var e = new Set();
          var _iteratorNormalCompletion120 = true;
          var _didIteratorError120 = false;
          var _iteratorError120 = undefined;

          try {
            for (var _iterator120 = this.getAttributes()[Symbol.iterator](), _step120; !(_iteratorNormalCompletion120 = (_step120 = _iterator120.next()).done); _iteratorNormalCompletion120 = true) {
              var _ref36 = _step120.value;

              var _ref33 = _slicedToArray(_ref36, 2);

              var _e97 = _ref33[0];
              var _n95 = _ref33[1];
              t.get(_e97) !== _n95 && this._removeAttribute(_e97, !1);
            }
          } catch (err) {
            _didIteratorError120 = true;
            _iteratorError120 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion120 && _iterator120.return != null) {
                _iterator120.return();
              }
            } finally {
              if (_didIteratorError120) {
                throw _iteratorError120;
              }
            }
          }

          var _iteratorNormalCompletion121 = true;
          var _didIteratorError121 = false;
          var _iteratorError121 = undefined;

          try {
            for (var _iterator121 = t[Symbol.iterator](), _step121; !(_iteratorNormalCompletion121 = (_step121 = _iterator121.next()).done); _iteratorNormalCompletion121 = true) {
              var _ref37 = _step121.value;

              var _ref35 = _slicedToArray(_ref37, 2);

              var _n96 = _ref35[0];
              var _i75 = _ref35[1];
              this._setAttribute(_n96, _i75, !1) && e.add(_n96);
            }
          } catch (err) {
            _didIteratorError121 = true;
            _iteratorError121 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion121 && _iterator121.return != null) {
                _iterator121.return();
              }
            } finally {
              if (_didIteratorError121) {
                throw _iteratorError121;
              }
            }
          }

          return e;
        }
      }, {
        key: "_getStoredAttributes",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _getStoredAttributes() {
          var t, _iteratorNormalCompletion122, _didIteratorError122, _iteratorError122, _iterator122, _step122, _e98;

          return _regeneratorRuntime.wrap(function _getStoredAttributes$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  t = this.getFirstPosition().parent;

                  if (!(this.isCollapsed && t.isEmpty)) {
                    _context18.next = 29;
                    break;
                  }

                  _iteratorNormalCompletion122 = true;
                  _didIteratorError122 = false;
                  _iteratorError122 = undefined;
                  _context18.prev = 5;
                  _iterator122 = t.getAttributeKeys()[Symbol.iterator]();

                case 7:
                  if (_iteratorNormalCompletion122 = (_step122 = _iterator122.next()).done) {
                    _context18.next = 15;
                    break;
                  }

                  _e98 = _step122.value;

                  if (!_e98.startsWith(sa)) {
                    _context18.next = 12;
                    break;
                  }

                  _context18.next = 12;
                  return [_e98.substr(sa.length), t.getAttribute(_e98)];

                case 12:
                  _iteratorNormalCompletion122 = true;
                  _context18.next = 7;
                  break;

                case 15:
                  _context18.next = 21;
                  break;

                case 17:
                  _context18.prev = 17;
                  _context18.t0 = _context18["catch"](5);
                  _didIteratorError122 = true;
                  _iteratorError122 = _context18.t0;

                case 21:
                  _context18.prev = 21;
                  _context18.prev = 22;

                  if (!_iteratorNormalCompletion122 && _iterator122.return != null) {
                    _iterator122.return();
                  }

                case 24:
                  _context18.prev = 24;

                  if (!_didIteratorError122) {
                    _context18.next = 27;
                    break;
                  }

                  throw _iteratorError122;

                case 27:
                  return _context18.finish(24);

                case 28:
                  return _context18.finish(21);

                case 29:
                case "end":
                  return _context18.stop();
              }
            }
          }, _getStoredAttributes, this, [[5, 17, 21, 29], [22,, 24, 28]]);
        })
      }, {
        key: "_getSurroundingAttributes",
        value: function _getSurroundingAttributes() {
          var t = this.getFirstPosition(),
              e = this._model.schema;
          var n = null;

          if (this.isCollapsed) {
            var _e99 = t.textNode ? t.textNode : t.nodeBefore,
                _i76 = t.textNode ? t.textNode : t.nodeAfter;

            if (this.isGravityOverridden || (n = la(_e99)), n || (n = la(_i76)), !this.isGravityOverridden && !n) {
              var _t98 = _e99;

              for (; _t98 && !n;) {
                n = la(_t98 = _t98.previousSibling);
              }
            }

            if (!n) {
              var _t99 = _i76;

              for (; _t99 && !n;) {
                n = la(_t99 = _t99.nextSibling);
              }
            }

            n || (n = this._getStoredAttributes());
          } else {
            var _t100 = this.getFirstRange();

            var _iteratorNormalCompletion123 = true;
            var _didIteratorError123 = false;
            var _iteratorError123 = undefined;

            try {
              for (var _iterator123 = _t100[Symbol.iterator](), _step123; !(_iteratorNormalCompletion123 = (_step123 = _iterator123.next()).done); _iteratorNormalCompletion123 = true) {
                var _i77 = _step123.value;
                if (_i77.item.is("element") && e.isObject(_i77.item)) break;

                if ("text" == _i77.type) {
                  n = _i77.item.getAttributes();
                  break;
                }
              }
            } catch (err) {
              _didIteratorError123 = true;
              _iteratorError123 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion123 && _iterator123.return != null) {
                  _iterator123.return();
                }
              } finally {
                if (_didIteratorError123) {
                  throw _iteratorError123;
                }
              }
            }
          }

          return n;
        }
      }, {
        key: "_fixGraveyardSelection",
        value: function _fixGraveyardSelection(t, e) {
          var n = e.clone(),
              i = this._model.schema.getNearestSelectionRange(n),
              o = this._ranges.indexOf(t);

          if (this._ranges.splice(o, 1), t.detach(), i) {
            var _t101 = this._prepareRange(i);

            this._ranges.splice(o, 0, _t101);
          }
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : _get(_getPrototypeOf(ca.prototype), "isCollapsed", this);
        }
      }, {
        key: "anchor",
        get: function get() {
          return _get(_getPrototypeOf(ca.prototype), "anchor", this) || this._document._getDefaultRange().start;
        }
      }, {
        key: "focus",
        get: function get() {
          return _get(_getPrototypeOf(ca.prototype), "focus", this) || this._document._getDefaultRange().end;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length ? this._ranges.length : 1;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._ranges.length > 0;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return !!this._overriddenGravityRegister.size;
        }
      }]);

      return ca;
    }(ea);

    function la(t) {
      return t instanceof Us || t instanceof Fs ? t.getAttributes() : null;
    }

    var da =
    /*#__PURE__*/
    function () {
      function da(t) {
        _classCallCheck(this, da);

        this._dispatchers = t;
      }

      _createClass(da, [{
        key: "add",
        value: function add(t) {
          var _iteratorNormalCompletion124 = true;
          var _didIteratorError124 = false;
          var _iteratorError124 = undefined;

          try {
            for (var _iterator124 = this._dispatchers[Symbol.iterator](), _step124; !(_iteratorNormalCompletion124 = (_step124 = _iterator124.next()).done); _iteratorNormalCompletion124 = true) {
              var _e100 = _step124.value;
              t(_e100);
            }
          } catch (err) {
            _didIteratorError124 = true;
            _iteratorError124 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion124 && _iterator124.return != null) {
                _iterator124.return();
              }
            } finally {
              if (_didIteratorError124) {
                throw _iteratorError124;
              }
            }
          }

          return this;
        }
      }]);

      return da;
    }();

    var ua = 1,
        ha = 4;

    var fa = function fa(t) {
      return Fn(t, ua | ha);
    };

    var ma =
    /*#__PURE__*/
    function (_da) {
      _inherits(ma, _da);

      function ma() {
        _classCallCheck(this, ma);

        return _possibleConstructorReturn(this, _getPrototypeOf(ma).apply(this, arguments));
      }

      _createClass(ma, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(function (t) {
            return (t = fa(t)).view = ga(t.view, "container"), function (e) {
              e.on("insert:" + t.model, function (t) {
                return function (e, n, i) {
                  var o = t(n.item, i.writer);
                  if (!o) return;
                  if (!i.consumable.consume(n.item, "insert")) return;
                  var r = i.mapper.toViewPosition(n.range.start);
                  i.mapper.bindElements(n.item, o), i.writer.insert(r, o);
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          return this.add(function (t) {
            var e = "attribute:" + ((t = fa(t)).model.key ? t.model.key : t.model);
            t.model.name && (e += ":" + t.model.name);

            if (t.model.values) {
              var _iteratorNormalCompletion125 = true;
              var _didIteratorError125 = false;
              var _iteratorError125 = undefined;

              try {
                for (var _iterator125 = t.model.values[Symbol.iterator](), _step125; !(_iteratorNormalCompletion125 = (_step125 = _iterator125.next()).done); _iteratorNormalCompletion125 = true) {
                  var _e101 = _step125.value;
                  t.view[_e101] = ga(t.view[_e101], "attribute");
                }
              } catch (err) {
                _didIteratorError125 = true;
                _iteratorError125 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion125 && _iterator125.return != null) {
                    _iterator125.return();
                  }
                } finally {
                  if (_didIteratorError125) {
                    throw _iteratorError125;
                  }
                }
              }
            } else t.view = ga(t.view, "attribute");

            var n = ba(t);
            return function (i) {
              i.on(e, function (t) {
                return function (e, n, i) {
                  var o = t(n.attributeOldValue, i.writer),
                      r = t(n.attributeNewValue, i.writer);
                  if (!o && !r) return;
                  if (!i.consumable.consume(n.item, e.name)) return;
                  var s = i.writer,
                      a = s.document.selection;
                  if (n.item instanceof ea || n.item instanceof aa) s.wrap(a.getFirstRange(), r);else {
                    var _t102 = i.mapper.toViewRange(n.range);

                    null !== n.attributeOldValue && o && (_t102 = s.unwrap(_t102, o)), null !== n.attributeNewValue && r && s.wrap(_t102, r);
                  }
                };
              }(n), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(function (t) {
            var e = "attribute:" + ((t = fa(t)).model.key ? t.model.key : t.model);
            t.model.name && (e += ":" + t.model.name);

            if (t.model.values) {
              var _iteratorNormalCompletion126 = true;
              var _didIteratorError126 = false;
              var _iteratorError126 = undefined;

              try {
                for (var _iterator126 = t.model.values[Symbol.iterator](), _step126; !(_iteratorNormalCompletion126 = (_step126 = _iterator126.next()).done); _iteratorNormalCompletion126 = true) {
                  var _e102 = _step126.value;
                  t.view[_e102] = wa(t.view[_e102]);
                }
              } catch (err) {
                _didIteratorError126 = true;
                _iteratorError126 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion126 && _iterator126.return != null) {
                    _iterator126.return();
                  }
                } finally {
                  if (_didIteratorError126) {
                    throw _iteratorError126;
                  }
                }
              }
            } else t.view = wa(t.view);

            var n = ba(t);
            return function (i) {
              i.on(e, function (t) {
                return function (e, n, i) {
                  var o = t(n.attributeOldValue, n),
                      r = t(n.attributeNewValue, n);
                  if (!o && !r) return;
                  if (!i.consumable.consume(n.item, e.name)) return;
                  var s = i.mapper.toViewElement(n.item),
                      a = i.writer;

                  if (s) {
                    if (null !== n.attributeOldValue && o) if ("class" == o.key) {
                      var _t103 = Array.isArray(o.value) ? o.value : [o.value];

                      var _iteratorNormalCompletion127 = true;
                      var _didIteratorError127 = false;
                      var _iteratorError127 = undefined;

                      try {
                        for (var _iterator127 = _t103[Symbol.iterator](), _step127; !(_iteratorNormalCompletion127 = (_step127 = _iterator127.next()).done); _iteratorNormalCompletion127 = true) {
                          var _e103 = _step127.value;
                          a.removeClass(_e103, s);
                        }
                      } catch (err) {
                        _didIteratorError127 = true;
                        _iteratorError127 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion127 && _iterator127.return != null) {
                            _iterator127.return();
                          }
                        } finally {
                          if (_didIteratorError127) {
                            throw _iteratorError127;
                          }
                        }
                      }
                    } else if ("style" == o.key) {
                      var _t104 = Object.keys(o.value);

                      for (var _i78 = 0, _t105 = _t104; _i78 < _t105.length; _i78++) {
                        var _e104 = _t105[_i78];
                        a.removeStyle(_e104, s);
                      }
                    } else a.removeAttribute(o.key, s);
                    if (null !== n.attributeNewValue && r) if ("class" == r.key) {
                      var _t106 = Array.isArray(r.value) ? r.value : [r.value];

                      var _iteratorNormalCompletion128 = true;
                      var _didIteratorError128 = false;
                      var _iteratorError128 = undefined;

                      try {
                        for (var _iterator128 = _t106[Symbol.iterator](), _step128; !(_iteratorNormalCompletion128 = (_step128 = _iterator128.next()).done); _iteratorNormalCompletion128 = true) {
                          var _e105 = _step128.value;
                          a.addClass(_e105, s);
                        }
                      } catch (err) {
                        _didIteratorError128 = true;
                        _iteratorError128 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion128 && _iterator128.return != null) {
                            _iterator128.return();
                          }
                        } finally {
                          if (_didIteratorError128) {
                            throw _iteratorError128;
                          }
                        }
                      }
                    } else if ("style" == r.key) {
                      var _t107 = Object.keys(r.value);

                      for (var _i79 = 0, _t108 = _t107; _i79 < _t108.length; _i79++) {
                        var _e106 = _t108[_i79];
                        a.setStyle(_e106, r.value[_e106], s);
                      }
                    } else a.setAttribute(r.key, r.value, s);
                  } else bs.a.warn("conversion-attribute-to-attribute-on-text: Trying to convert text node's attribute with attribute-to-attribute converter.");
                };
              }(n), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToElement",
        value: function markerToElement(t) {
          return this.add(function (t) {
            return (t = fa(t)).view = ga(t.view, "ui"), function (e) {
              e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  n.isOpening = !0;
                  var o = t(n, i.writer);
                  n.isOpening = !1;
                  var r = t(n, i.writer);
                  if (!o || !r) return;
                  var s = n.markerRange;
                  if (s.isCollapsed && !i.consumable.consume(s, e.name)) return;
                  var _iteratorNormalCompletion129 = true;
                  var _didIteratorError129 = false;
                  var _iteratorError129 = undefined;

                  try {
                    for (var _iterator129 = s[Symbol.iterator](), _step129; !(_iteratorNormalCompletion129 = (_step129 = _iterator129.next()).done); _iteratorNormalCompletion129 = true) {
                      var _t109 = _step129.value;
                      if (!i.consumable.consume(_t109.item, e.name)) return;
                    }
                  } catch (err) {
                    _didIteratorError129 = true;
                    _iteratorError129 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion129 && _iterator129.return != null) {
                        _iterator129.return();
                      }
                    } finally {
                      if (_didIteratorError129) {
                        throw _iteratorError129;
                      }
                    }
                  }

                  var a = i.mapper,
                      c = i.writer;
                  c.insert(a.toViewPosition(s.start), o), i.mapper.bindElementToMarker(o, n.markerName), s.isCollapsed || (c.insert(a.toViewPosition(s.end), r), i.mapper.bindElementToMarker(r, n.markerName)), e.stop();
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("removeMarker:" + t.model, (t.view, function (t, e, n) {
                var i = n.mapper.markerNameToElements(e.markerName);

                if (i) {
                  n.mapper.unbindElementsFromMarkerName(e.markerName);
                  var _iteratorNormalCompletion130 = true;
                  var _didIteratorError130 = false;
                  var _iteratorError130 = undefined;

                  try {
                    for (var _iterator130 = i[Symbol.iterator](), _step130; !(_iteratorNormalCompletion130 = (_step130 = _iterator130.next()).done); _iteratorNormalCompletion130 = true) {
                      var _t110 = _step130.value;
                      n.writer.clear(n.writer.createRangeOn(_t110), _t110);
                    }
                  } catch (err) {
                    _didIteratorError130 = true;
                    _iteratorError130 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion130 && _iterator130.return != null) {
                        _iterator130.return();
                      }
                    } finally {
                      if (_didIteratorError130) {
                        throw _iteratorError130;
                      }
                    }
                  }

                  n.writer.clearClonedElementsGroup(e.markerName), t.stop();
                }
              }), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToHighlight",
        value: function markerToHighlight(t) {
          return this.add(function (t) {
            return function (e) {
              e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (!n.item) return;
                  if (!(n.item instanceof ea || n.item instanceof aa || n.item.is("textProxy"))) return;

                  var o = _a(t, n, i);

                  if (!o) return;
                  if (!i.consumable.consume(n.item, e.name)) return;
                  var r = pa(o),
                      s = i.writer,
                      a = s.document.selection;
                  if (n.item instanceof ea || n.item instanceof aa) s.wrap(a.getFirstRange(), r, a);else {
                    var _t111 = i.mapper.toViewRange(n.range),
                        _e107 = s.wrap(_t111, r);

                    var _iteratorNormalCompletion131 = true;
                    var _didIteratorError131 = false;
                    var _iteratorError131 = undefined;

                    try {
                      for (var _iterator131 = _e107.getItems()[Symbol.iterator](), _step131; !(_iteratorNormalCompletion131 = (_step131 = _iterator131.next()).done); _iteratorNormalCompletion131 = true) {
                        var _t112 = _step131.value;

                        if (_t112.is("attributeElement") && _t112.isSimilar(r)) {
                          i.mapper.bindElementToMarker(_t112, n.markerName);
                          break;
                        }
                      }
                    } catch (err) {
                      _didIteratorError131 = true;
                      _iteratorError131 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion131 && _iterator131.return != null) {
                          _iterator131.return();
                        }
                      } finally {
                        if (_didIteratorError131) {
                          throw _iteratorError131;
                        }
                      }
                    }
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (!n.item) return;
                  if (!(n.item instanceof qs)) return;

                  var o = _a(t, n, i);

                  if (!o) return;
                  if (!i.consumable.test(n.item, e.name)) return;
                  var r = i.mapper.toViewElement(n.item);

                  if (r && r.getCustomProperty("addHighlight")) {
                    i.consumable.consume(n.item, e.name);
                    var _iteratorNormalCompletion132 = true;
                    var _didIteratorError132 = false;
                    var _iteratorError132 = undefined;

                    try {
                      for (var _iterator132 = Qs._createIn(n.item)[Symbol.iterator](), _step132; !(_iteratorNormalCompletion132 = (_step132 = _iterator132.next()).done); _iteratorNormalCompletion132 = true) {
                        var _t113 = _step132.value;
                        i.consumable.consume(_t113.item, e.name);
                      }
                    } catch (err) {
                      _didIteratorError132 = true;
                      _iteratorError132 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion132 && _iterator132.return != null) {
                          _iterator132.return();
                        }
                      } finally {
                        if (_didIteratorError132) {
                          throw _iteratorError132;
                        }
                      }
                    }

                    r.getCustomProperty("addHighlight")(r, o, i.writer), i.mapper.bindElementToMarker(r, n.markerName);
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("removeMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (n.markerRange.isCollapsed) return;

                  var o = _a(t, n, i);

                  if (!o) return;
                  var r = pa(o),
                      s = i.mapper.markerNameToElements(n.markerName);

                  if (s) {
                    i.mapper.unbindElementsFromMarkerName(n.markerName);
                    var _iteratorNormalCompletion133 = true;
                    var _didIteratorError133 = false;
                    var _iteratorError133 = undefined;

                    try {
                      for (var _iterator133 = s[Symbol.iterator](), _step133; !(_iteratorNormalCompletion133 = (_step133 = _iterator133.next()).done); _iteratorNormalCompletion133 = true) {
                        var _t114 = _step133.value;
                        _t114.is("attributeElement") ? i.writer.unwrap(i.writer.createRangeOn(_t114), r) : _t114.getCustomProperty("removeHighlight")(_t114, o.id, i.writer);
                      }
                    } catch (err) {
                      _didIteratorError133 = true;
                      _iteratorError133 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion133 && _iterator133.return != null) {
                          _iterator133.return();
                        }
                      } finally {
                        if (_didIteratorError133) {
                          throw _iteratorError133;
                        }
                      }
                    }

                    i.writer.clearClonedElementsGroup(n.markerName), e.stop();
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }]);

      return ma;
    }(da);

    function pa(t) {
      var e = new ao("span", t.attributes);
      return t.classes && e._addClass(t.classes), t.priority && (e._priority = t.priority), e._id = t.id, e;
    }

    function ga(t, e) {
      return "function" == typeof t ? t : function (n, i) {
        return function (t, e, n) {
          "string" == typeof t && (t = {
            name: t
          });
          var i;
          var o = Object.assign({}, t.attributes);
          if ("container" == n) i = e.createContainerElement(t.name, o);else if ("attribute" == n) {
            var _n97 = {
              priority: t.priority || ao.DEFAULT_PRIORITY
            };
            i = e.createAttributeElement(t.name, o, _n97);
          } else i = e.createUIElement(t.name, o);

          if (t.styles) {
            var _n98 = Object.keys(t.styles);

            for (var _i80 = 0, _n99 = _n98; _i80 < _n99.length; _i80++) {
              var _o34 = _n99[_i80];
              e.setStyle(_o34, t.styles[_o34], i);
            }
          }

          if (t.classes) {
            var _n100 = t.classes;
            if ("string" == typeof _n100) e.addClass(_n100, i);else {
              var _iteratorNormalCompletion134 = true;
              var _didIteratorError134 = false;
              var _iteratorError134 = undefined;

              try {
                for (var _iterator134 = _n100[Symbol.iterator](), _step134; !(_iteratorNormalCompletion134 = (_step134 = _iterator134.next()).done); _iteratorNormalCompletion134 = true) {
                  var _t115 = _step134.value;
                  e.addClass(_t115, i);
                }
              } catch (err) {
                _didIteratorError134 = true;
                _iteratorError134 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion134 && _iterator134.return != null) {
                    _iterator134.return();
                  }
                } finally {
                  if (_didIteratorError134) {
                    throw _iteratorError134;
                  }
                }
              }
            }
          }

          return i;
        }(t, i, e);
      };
    }

    function ba(t) {
      return t.model.values ? function (e, n) {
        var i = t.view[e];
        return i ? i(e, n) : null;
      } : t.view;
    }

    function wa(t) {
      return "string" == typeof t ? function (e) {
        return {
          key: t,
          value: e
        };
      } : "object" == typeof t ? t.value ? function () {
        return t;
      } : function (e) {
        return {
          key: t.key,
          value: e
        };
      } : t;
    }

    function _a(t, e, n) {
      var i = "function" == typeof t ? t(e, n) : t;
      return i ? (i.priority || (i.priority = 10), i.id || (i.id = e.markerName), i) : null;
    }

    var ka =
    /*#__PURE__*/
    function (_da2) {
      _inherits(ka, _da2);

      function ka() {
        _classCallCheck(this, ka);

        return _possibleConstructorReturn(this, _getPrototypeOf(ka).apply(this, arguments));
      }

      _createClass(ka, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(va(t));
        }
      }, {
        key: "elementToAttribute",
        value: function elementToAttribute(t) {
          return this.add(function (t) {
            xa(t = fa(t));
            var e = Aa(t, !1),
                n = ya(t),
                i = n ? "element:" + n : "element";
            return function (n) {
              n.on(i, e, {
                priority: t.converterPriority || "low"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(function (t) {
            var e = null;
            ("string" == typeof (t = fa(t)).view || t.view.key) && (e = function (t) {
              "string" == typeof t.view && (t.view = {
                key: t.view
              });
              var e = t.view.key;
              var n;

              if ("class" == e || "style" == e) {
                var _i81 = "class" == e ? "classes" : "styles";

                n = _defineProperty({}, _i81, t.view.value);
              } else {
                var _i82 = void 0 === t.view.value ? /[\s\S]*/ : t.view.value;

                n = {
                  attributes: _defineProperty({}, e, _i82)
                };
              }

              t.view.name && (n.name = t.view.name);
              return t.view = n, e;
            }(t));
            xa(t, e);
            var n = Aa(t, !0);
            return function (e) {
              e.on("element", n, {
                priority: t.converterPriority || "low"
              });
            };
          }(t));
        }
      }, {
        key: "elementToMarker",
        value: function elementToMarker(t) {
          return this.add(function (t) {
            return function (t) {
              var e = t.model;

              t.model = function (t, n) {
                var i = "string" == typeof e ? e : e(t);
                return n.createElement("$marker", {
                  "data-name": i
                });
              };
            }(t = fa(t)), va(t);
          }(t));
        }
      }]);

      return ka;
    }(da);

    function va(t) {
      var e = function (t) {
        var e = t.view ? new bi(t.view) : null;
        return function (n, i, o) {
          var r = {};

          if (e) {
            var _t116 = e.match(i.viewItem);

            if (!_t116) return;
            r = _t116.match;
          }

          r.name = !0;

          var s = function (t, e, n) {
            return t instanceof Function ? t(e, n) : n.createElement(t);
          }(t.model, i.viewItem, o.writer);

          if (!s) return;
          if (!o.consumable.test(i.viewItem, r)) return;
          var a = o.splitToAllowedParent(s, i.modelCursor);
          if (!a) return;
          o.writer.insert(s, a.position), o.convertChildren(i.viewItem, o.writer.createPositionAt(s, 0)), o.consumable.consume(i.viewItem, r);
          var c = o.getSplitParts(s);
          i.modelRange = new Qs(o.writer.createPositionBefore(s), o.writer.createPositionAfter(c[c.length - 1])), a.cursorParent ? i.modelCursor = o.writer.createPositionAt(a.cursorParent, 0) : i.modelCursor = i.modelRange.end;
        };
      }(t = fa(t)),
          n = ya(t),
          i = n ? "element:" + n : "element";

      return function (n) {
        n.on(i, e, {
          priority: t.converterPriority || "normal"
        });
      };
    }

    function ya(t) {
      return "string" == typeof t.view ? t.view : "object" == typeof t.view && "string" == typeof t.view.name ? t.view.name : null;
    }

    function xa(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var n = null === e || function (t) {
        return t.getAttribute(e);
      },
          i = "object" != typeof t.model ? t.model : t.model.key,
          o = "object" != typeof t.model || void 0 === t.model.value ? n : t.model.value;

      t.model = {
        key: i,
        value: o
      };
    }

    function Aa(t, e) {
      var n = new bi(t.view);
      return function (i, o, r) {
        var s = n.match(o.viewItem);
        if (!s) return;
        var a = t.model.key,
            c = "function" == typeof t.model.value ? t.model.value(o.viewItem) : t.model.value;
        null !== c && (!function (t) {
          if ("object" == typeof t.view && !ya(t)) return !1;
          return !t.view.classes && !t.view.attributes && !t.view.styles;
        }(t) ? delete s.match.name : s.match.name = !0, r.consumable.test(o.viewItem, s.match) && (o.modelRange || (o = Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor))), function (t, e, n, i) {
          var o = !1;

          for (var _i83 = 0, _Array$from4 = Array.from(t.getItems({
            shallow: n
          })); _i83 < _Array$from4.length; _i83++) {
            var _r14 = _Array$from4[_i83];
            i.schema.checkAttribute(_r14, e.key) && (i.writer.setAttribute(e.key, e.value, _r14), o = !0);
          }

          return o;
        }(o.modelRange, {
          key: a,
          value: c
        }, e, r) && r.consumable.consume(o.viewItem, s.match)));
      };
    }

    var Ca =
    /*#__PURE__*/
    function () {
      function Ca(t) {
        var _this47 = this;

        _classCallCheck(this, Ca);

        this.model = t, this.view = new Vs(), this.mapper = new Js(), this.downcastDispatcher = new Xs({
          mapper: this.mapper
        });
        var e = this.model.document,
            n = e.selection,
            i = this.model.markers;
        this.listenTo(this.model, "_beforeChanges", function () {
          _this47.view._disableRendering(!0);
        }, {
          priority: "highest"
        }), this.listenTo(this.model, "_afterChanges", function () {
          _this47.view._disableRendering(!1);
        }, {
          priority: "lowest"
        }), this.listenTo(e, "change", function () {
          _this47.view.change(function (t) {
            _this47.downcastDispatcher.convertChanges(e.differ, t), _this47.downcastDispatcher.convertSelection(n, i, t);
          });
        }, {
          priority: "low"
        }), this.listenTo(this.view.document, "selectionChange", function (t, e) {
          return function (n, i) {
            var o = i.newSelection,
                r = new ea(),
                s = [];
            var _iteratorNormalCompletion135 = true;
            var _didIteratorError135 = false;
            var _iteratorError135 = undefined;

            try {
              for (var _iterator135 = o.getRanges()[Symbol.iterator](), _step135; !(_iteratorNormalCompletion135 = (_step135 = _iterator135.next()).done); _iteratorNormalCompletion135 = true) {
                var _t117 = _step135.value;
                s.push(e.toModelRange(_t117));
              }
            } catch (err) {
              _didIteratorError135 = true;
              _iteratorError135 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion135 && _iterator135.return != null) {
                  _iterator135.return();
                }
              } finally {
                if (_didIteratorError135) {
                  throw _iteratorError135;
                }
              }
            }

            r.setTo(s, {
              backward: o.isBackward
            }), r.isEqual(t.document.selection) || t.change(function (t) {
              t.setSelection(r);
            });
          };
        }(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
          if (!n.consumable.consume(e.item, "insert")) return;
          var i = n.writer,
              o = n.mapper.toViewPosition(e.range.start),
              r = i.createText(e.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("remove", function (t, e, n) {
          var i = n.mapper.toViewPosition(e.position),
              o = e.position.getShiftedBy(e.length),
              r = n.mapper.toViewPosition(o, {
            isPhantom: !0
          }),
              s = n.writer.createRange(i, r),
              a = n.writer.remove(s.getTrimmed());
          var _iteratorNormalCompletion136 = true;
          var _didIteratorError136 = false;
          var _iteratorError136 = undefined;

          try {
            for (var _iterator136 = n.writer.createRangeIn(a).getItems()[Symbol.iterator](), _step136; !(_iteratorNormalCompletion136 = (_step136 = _iterator136.next()).done); _iteratorNormalCompletion136 = true) {
              var _t118 = _step136.value;
              n.mapper.unbindViewElement(_t118);
            }
          } catch (err) {
            _didIteratorError136 = true;
            _iteratorError136 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion136 && _iterator136.return != null) {
                _iterator136.return();
              }
            } finally {
              if (_didIteratorError136) {
                throw _iteratorError136;
              }
            }
          }
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = n.writer,
              o = i.document.selection;
          var _iteratorNormalCompletion137 = true;
          var _didIteratorError137 = false;
          var _iteratorError137 = undefined;

          try {
            for (var _iterator137 = o.getRanges()[Symbol.iterator](), _step137; !(_iteratorNormalCompletion137 = (_step137 = _iterator137.next()).done); _iteratorNormalCompletion137 = true) {
              var _t119 = _step137.value;
              _t119.isCollapsed && _t119.end.parent.document && n.writer.mergeAttributes(_t119.start);
            }
          } catch (err) {
            _didIteratorError137 = true;
            _iteratorError137 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion137 && _iterator137.return != null) {
                _iterator137.return();
              }
            } finally {
              if (_didIteratorError137) {
                throw _iteratorError137;
              }
            }
          }

          i.setSelection(null);
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = e.selection;
          if (i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          var o = [];
          var _iteratorNormalCompletion138 = true;
          var _didIteratorError138 = false;
          var _iteratorError138 = undefined;

          try {
            for (var _iterator138 = i.getRanges()[Symbol.iterator](), _step138; !(_iteratorNormalCompletion138 = (_step138 = _iterator138.next()).done); _iteratorNormalCompletion138 = true) {
              var _t120 = _step138.value;

              var _e108 = n.mapper.toViewRange(_t120);

              o.push(_e108);
            }
          } catch (err) {
            _didIteratorError138 = true;
            _iteratorError138 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion138 && _iterator138.return != null) {
                _iterator138.return();
              }
            } finally {
              if (_didIteratorError138) {
                throw _iteratorError138;
              }
            }
          }

          n.writer.setSelection(o, {
            backward: i.isBackward
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = e.selection;
          if (!i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          var o = n.writer,
              r = i.getFirstPosition(),
              s = n.mapper.toViewPosition(r),
              a = o.breakAttributes(s);
          o.setSelection(a);
        }, {
          priority: "low"
        }), this.view.document.roots.bindTo(this.model.document.roots).using(function (t) {
          if ("$graveyard" == t.rootName) return null;
          var e = new Ji(t.name);
          return e.rootName = t.rootName, e._document = _this47.view.document, _this47.mapper.bindElements(t, e), e;
        });
      }

      _createClass(Ca, [{
        key: "destroy",
        value: function destroy() {
          this.view.destroy(), this.stopListening();
        }
      }]);

      return Ca;
    }();

    ci(Ca, Fi);

    var Ta =
    /*#__PURE__*/
    function () {
      function Ta(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        _classCallCheck(this, Ta);

        this._editor = t, this._availablePlugins = new Map(), this._plugins = new Map();
        var _iteratorNormalCompletion139 = true;
        var _didIteratorError139 = false;
        var _iteratorError139 = undefined;

        try {
          for (var _iterator139 = e[Symbol.iterator](), _step139; !(_iteratorNormalCompletion139 = (_step139 = _iterator139.next()).done); _iteratorNormalCompletion139 = true) {
            var _t121 = _step139.value;
            this._availablePlugins.set(_t121, _t121), _t121.pluginName && this._availablePlugins.set(_t121.pluginName, _t121);
          }
        } catch (err) {
          _didIteratorError139 = true;
          _iteratorError139 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion139 && _iterator139.return != null) {
              _iterator139.return();
            }
          } finally {
            if (_didIteratorError139) {
              throw _iteratorError139;
            }
          }
        }
      }

      _createClass(Ta, [{
        key: Symbol.iterator,
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function value() {
          var _iteratorNormalCompletion140, _didIteratorError140, _iteratorError140, _iterator140, _step140, _t122;

          return _regeneratorRuntime.wrap(function value$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  _iteratorNormalCompletion140 = true;
                  _didIteratorError140 = false;
                  _iteratorError140 = undefined;
                  _context19.prev = 3;
                  _iterator140 = this._plugins[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion140 = (_step140 = _iterator140.next()).done) {
                    _context19.next = 14;
                    break;
                  }

                  _t122 = _step140.value;
                  _context19.t0 = "function" == typeof _t122[0];

                  if (!_context19.t0) {
                    _context19.next = 11;
                    break;
                  }

                  _context19.next = 11;
                  return _t122;

                case 11:
                  _iteratorNormalCompletion140 = true;
                  _context19.next = 5;
                  break;

                case 14:
                  _context19.next = 20;
                  break;

                case 16:
                  _context19.prev = 16;
                  _context19.t1 = _context19["catch"](3);
                  _didIteratorError140 = true;
                  _iteratorError140 = _context19.t1;

                case 20:
                  _context19.prev = 20;
                  _context19.prev = 21;

                  if (!_iteratorNormalCompletion140 && _iterator140.return != null) {
                    _iterator140.return();
                  }

                case 23:
                  _context19.prev = 23;

                  if (!_didIteratorError140) {
                    _context19.next = 26;
                    break;
                  }

                  throw _iteratorError140;

                case 26:
                  return _context19.finish(23);

                case 27:
                  return _context19.finish(20);

                case 28:
                case "end":
                  return _context19.stop();
              }
            }
          }, value, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "get",
        value: function get(t) {
          var e = this._plugins.get(t);

          if (!e) {
            var _e109 = "plugincollection-plugin-not-loaded: The requested plugin is not loaded.";
            var _n102 = t;
            throw "function" == typeof t && (_n102 = t.pluginName || t.name), new Gn.b(_e109, this._editor, {
              plugin: _n102
            });
          }

          return e;
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._plugins.has(t);
        }
      }, {
        key: "init",
        value: function init(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          var n = this,
              i = this._editor,
              o = new Set(),
              r = [],
              s = h(t),
              a = h(e),
              c = function (t) {
            var e = [];
            var _iteratorNormalCompletion141 = true;
            var _didIteratorError141 = false;
            var _iteratorError141 = undefined;

            try {
              for (var _iterator141 = t[Symbol.iterator](), _step141; !(_iteratorNormalCompletion141 = (_step141 = _iterator141.next()).done); _iteratorNormalCompletion141 = true) {
                var _n103 = _step141.value;
                u(_n103) || e.push(_n103);
              }
            } catch (err) {
              _didIteratorError141 = true;
              _iteratorError141 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion141 && _iterator141.return != null) {
                  _iterator141.return();
                }
              } finally {
                if (_didIteratorError141) {
                  throw _iteratorError141;
                }
              }
            }

            return e.length ? e : null;
          }(t);

          if (c) {
            var _t123 = "plugincollection-plugin-not-found: Some plugins are not available and could not be loaded.";
            return bs.a.error(_t123, {
              plugins: c
            }), Promise.reject(new Gn.b(_t123, this._editor, {
              plugins: c
            }));
          }

          return Promise.all(s.map(l)).then(function () {
            return d(r, "init");
          }).then(function () {
            return d(r, "afterInit");
          }).then(function () {
            return r;
          });

          function l(t) {
            if (!a.includes(t) && !n._plugins.has(t) && !o.has(t)) return function (t) {
              return new Promise(function (s) {
                o.add(t), t.requires && t.requires.forEach(function (n) {
                  var o = u(n);
                  if (e.includes(o)) throw new Gn.b("plugincollection-required: Cannot load a plugin because one of its dependencies is listed inthe `removePlugins` option.", i, {
                    plugin: o,
                    requiredBy: t
                  });
                  l(o);
                });
                var a = new t(i);
                n._add(t, a), r.push(a), s();
              });
            }(t).catch(function (e) {
              throw bs.a.error("plugincollection-load: It was not possible to load the plugin.", {
                plugin: t
              }), e;
            });
          }

          function d(t, e) {
            return t.reduce(function (t, n) {
              return n[e] ? t.then(n[e].bind(n)) : t;
            }, Promise.resolve());
          }

          function u(t) {
            return "function" == typeof t ? t : n._availablePlugins.get(t);
          }

          function h(t) {
            return t.map(function (t) {
              return u(t);
            }).filter(function (t) {
              return !!t;
            });
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = Array.from(this).map(function (_ref38) {
            var _ref39 = _slicedToArray(_ref38, 2),
                t = _ref39[1];

            return t;
          }).filter(function (t) {
            return "function" == typeof t.destroy;
          }).map(function (t) {
            return t.destroy();
          });
          return Promise.all(t);
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          this._plugins.set(t, e);

          var n = t.pluginName;
          n && (this._plugins.has(n) ? bs.a.warn("plugincollection-plugin-name-conflict: Two plugins with the same name were loaded.", {
            pluginName: n,
            plugin1: this._plugins.get(n).constructor,
            plugin2: t
          }) : this._plugins.set(n, e));
        }
      }]);

      return Ta;
    }();

    ci(Ta, ei);

    var Pa =
    /*#__PURE__*/
    function () {
      function Pa() {
        _classCallCheck(this, Pa);

        this._commands = new Map();
      }

      _createClass(Pa, [{
        key: "add",
        value: function add(t, e) {
          this._commands.set(t, e);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._commands.get(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var n = this.get(t);
          if (!n) throw new Gn.b("commandcollection-command-not-found: Command does not exist.", this, {
            commandName: t
          });

          for (var _len16 = arguments.length, e = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
            e[_key16 - 1] = arguments[_key16];
          }

          n.execute.apply(n, e);
        }
      }, {
        key: "names",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function names() {
          return _regeneratorRuntime.wrap(function names$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  return _context20.delegateYield(this._commands.keys(), "t0", 1);

                case 1:
                case "end":
                  return _context20.stop();
              }
            }
          }, names, this);
        })
      }, {
        key: "commands",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function commands() {
          return _regeneratorRuntime.wrap(function commands$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  return _context21.delegateYield(this._commands.values(), "t0", 1);

                case 1:
                case "end":
                  return _context21.stop();
              }
            }
          }, commands, this);
        })
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._commands[Symbol.iterator]();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion142 = true;
          var _didIteratorError142 = false;
          var _iteratorError142 = undefined;

          try {
            for (var _iterator142 = this.commands()[Symbol.iterator](), _step142; !(_iteratorNormalCompletion142 = (_step142 = _iterator142.next()).done); _iteratorNormalCompletion142 = true) {
              var _t124 = _step142.value;

              _t124.destroy();
            }
          } catch (err) {
            _didIteratorError142 = true;
            _iteratorError142 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion142 && _iterator142.return != null) {
                _iterator142.return();
              }
            } finally {
              if (_didIteratorError142) {
                throw _iteratorError142;
              }
            }
          }
        }
      }]);

      return Pa;
    }();

    function Ma(t, e) {
      var n = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
      return 1 === n && (t = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]), 0 !== n && function (t, e) {
        return t in window.CKEDITOR_TRANSLATIONS && e in window.CKEDITOR_TRANSLATIONS[t];
      }(t, e) ? window.CKEDITOR_TRANSLATIONS[t][e].replace(/ \[context: [^\]]+\]$/, "") : e.replace(/ \[context: [^\]]+\]$/, "");
    }

    window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});

    var Sa =
    /*#__PURE__*/
    function () {
      function Sa(t) {
        var _this48 = this;

        _classCallCheck(this, Sa);

        this.language = t || "en", this.t = function () {
          return _this48._t.apply(_this48, arguments);
        };
      }

      _createClass(Sa, [{
        key: "_t",
        value: function _t(t, e) {
          var n = Ma(this.language, t);
          return e && (n = n.replace(/%(\d+)/g, function (t, n) {
            return n < e.length ? e[n] : t;
          })), n;
        }
      }]);

      return Sa;
    }();

    var Ea =
    /*#__PURE__*/
    function () {
      function Ea() {
        _classCallCheck(this, Ea);

        this._consumables = new Map();
      }

      _createClass(Ea, [{
        key: "add",
        value: function add(t, e) {
          var n;
          t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !0) : (this._consumables.has(t) ? n = this._consumables.get(t) : (n = new Ia(), this._consumables.set(t, n)), n.add(e));
        }
      }, {
        key: "test",
        value: function test(t, e) {
          var n = this._consumables.get(t);

          return void 0 === n ? null : t.is("text") || t.is("documentFragment") ? n : n.test(e);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          return !!this.test(t, e) && (t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !1) : this._consumables.get(t).consume(e), !0);
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          var n = this._consumables.get(t);

          void 0 !== n && (t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !0) : n.revert(e));
        }
      }], [{
        key: "consumablesFromElement",
        value: function consumablesFromElement(t) {
          var e = {
            name: !0,
            attributes: [],
            classes: [],
            styles: []
          },
              n = t.getAttributeKeys();
          var _iteratorNormalCompletion143 = true;
          var _didIteratorError143 = false;
          var _iteratorError143 = undefined;

          try {
            for (var _iterator143 = n[Symbol.iterator](), _step143; !(_iteratorNormalCompletion143 = (_step143 = _iterator143.next()).done); _iteratorNormalCompletion143 = true) {
              var _t125 = _step143.value;
              "style" != _t125 && "class" != _t125 && e.attributes.push(_t125);
            }
          } catch (err) {
            _didIteratorError143 = true;
            _iteratorError143 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion143 && _iterator143.return != null) {
                _iterator143.return();
              }
            } finally {
              if (_didIteratorError143) {
                throw _iteratorError143;
              }
            }
          }

          var i = t.getClassNames();
          var _iteratorNormalCompletion144 = true;
          var _didIteratorError144 = false;
          var _iteratorError144 = undefined;

          try {
            for (var _iterator144 = i[Symbol.iterator](), _step144; !(_iteratorNormalCompletion144 = (_step144 = _iterator144.next()).done); _iteratorNormalCompletion144 = true) {
              var _t126 = _step144.value;
              e.classes.push(_t126);
            }
          } catch (err) {
            _didIteratorError144 = true;
            _iteratorError144 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion144 && _iterator144.return != null) {
                _iterator144.return();
              }
            } finally {
              if (_didIteratorError144) {
                throw _iteratorError144;
              }
            }
          }

          var o = t.getStyleNames();
          var _iteratorNormalCompletion145 = true;
          var _didIteratorError145 = false;
          var _iteratorError145 = undefined;

          try {
            for (var _iterator145 = o[Symbol.iterator](), _step145; !(_iteratorNormalCompletion145 = (_step145 = _iterator145.next()).done); _iteratorNormalCompletion145 = true) {
              var _t127 = _step145.value;
              e.styles.push(_t127);
            }
          } catch (err) {
            _didIteratorError145 = true;
            _iteratorError145 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion145 && _iterator145.return != null) {
                _iterator145.return();
              }
            } finally {
              if (_didIteratorError145) {
                throw _iteratorError145;
              }
            }
          }

          return e;
        }
      }, {
        key: "createFrom",
        value: function createFrom(t, e) {
          if (e || (e = new Ea()), t.is("text")) return e.add(t), e;
          t.is("element") && e.add(t, Ea.consumablesFromElement(t)), t.is("documentFragment") && e.add(t);
          var _iteratorNormalCompletion146 = true;
          var _didIteratorError146 = false;
          var _iteratorError146 = undefined;

          try {
            for (var _iterator146 = t.getChildren()[Symbol.iterator](), _step146; !(_iteratorNormalCompletion146 = (_step146 = _iterator146.next()).done); _iteratorNormalCompletion146 = true) {
              var _n104 = _step146.value;
              e = Ea.createFrom(_n104, e);
            }
          } catch (err) {
            _didIteratorError146 = true;
            _iteratorError146 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion146 && _iterator146.return != null) {
                _iterator146.return();
              }
            } finally {
              if (_didIteratorError146) {
                throw _iteratorError146;
              }
            }
          }

          return e;
        }
      }]);

      return Ea;
    }();

    var Ia =
    /*#__PURE__*/
    function () {
      function Ia() {
        _classCallCheck(this, Ia);

        this._canConsumeName = null, this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }

      _createClass(Ia, [{
        key: "add",
        value: function add(t) {
          t.name && (this._canConsumeName = !0);

          for (var _e110 in this._consumables) {
            _e110 in t && this._add(_e110, t[_e110]);
          }
        }
      }, {
        key: "test",
        value: function test(t) {
          if (t.name && !this._canConsumeName) return this._canConsumeName;

          for (var _e111 in this._consumables) {
            if (_e111 in t) {
              var _n105 = this._test(_e111, t[_e111]);

              if (!0 !== _n105) return _n105;
            }
          }

          return !0;
        }
      }, {
        key: "consume",
        value: function consume(t) {
          t.name && (this._canConsumeName = !1);

          for (var _e112 in this._consumables) {
            _e112 in t && this._consume(_e112, t[_e112]);
          }
        }
      }, {
        key: "revert",
        value: function revert(t) {
          t.name && (this._canConsumeName = !0);

          for (var _e113 in this._consumables) {
            _e113 in t && this._revert(_e113, t[_e113]);
          }
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          var n = Wt(e) ? e : [e],
              i = this._consumables[t];
          var _iteratorNormalCompletion147 = true;
          var _didIteratorError147 = false;
          var _iteratorError147 = undefined;

          try {
            for (var _iterator147 = n[Symbol.iterator](), _step147; !(_iteratorNormalCompletion147 = (_step147 = _iterator147.next()).done); _iteratorNormalCompletion147 = true) {
              var _e114 = _step147.value;
              if ("attributes" === t && ("class" === _e114 || "style" === _e114)) throw new Gn.b("viewconsumable-invalid-attribute: Classes and styles should be handled separately.", this);
              i.set(_e114, !0);
            }
          } catch (err) {
            _didIteratorError147 = true;
            _iteratorError147 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion147 && _iterator147.return != null) {
                _iterator147.return();
              }
            } finally {
              if (_didIteratorError147) {
                throw _iteratorError147;
              }
            }
          }
        }
      }, {
        key: "_test",
        value: function _test(t, e) {
          var n = Wt(e) ? e : [e],
              i = this._consumables[t];
          var _iteratorNormalCompletion148 = true;
          var _didIteratorError148 = false;
          var _iteratorError148 = undefined;

          try {
            for (var _iterator148 = n[Symbol.iterator](), _step148; !(_iteratorNormalCompletion148 = (_step148 = _iterator148.next()).done); _iteratorNormalCompletion148 = true) {
              var _e115 = _step148.value;

              if ("attributes" !== t || "class" !== _e115 && "style" !== _e115) {
                var _t128 = i.get(_e115);

                if (void 0 === _t128) return null;
                if (!_t128) return !1;
              } else {
                var _t129 = "class" == _e115 ? "classes" : "styles",
                    _n106 = this._test(_t129, _toConsumableArray(this._consumables[_t129].keys()));

                if (!0 !== _n106) return _n106;
              }
            }
          } catch (err) {
            _didIteratorError148 = true;
            _iteratorError148 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion148 && _iterator148.return != null) {
                _iterator148.return();
              }
            } finally {
              if (_didIteratorError148) {
                throw _iteratorError148;
              }
            }
          }

          return !0;
        }
      }, {
        key: "_consume",
        value: function _consume(t, e) {
          var n = Wt(e) ? e : [e],
              i = this._consumables[t];
          var _iteratorNormalCompletion149 = true;
          var _didIteratorError149 = false;
          var _iteratorError149 = undefined;

          try {
            for (var _iterator149 = n[Symbol.iterator](), _step149; !(_iteratorNormalCompletion149 = (_step149 = _iterator149.next()).done); _iteratorNormalCompletion149 = true) {
              var _e116 = _step149.value;
              if ("attributes" !== t || "class" !== _e116 && "style" !== _e116) i.set(_e116, !1);else {
                var _t130 = "class" == _e116 ? "classes" : "styles";

                this._consume(_t130, _toConsumableArray(this._consumables[_t130].keys()));
              }
            }
          } catch (err) {
            _didIteratorError149 = true;
            _iteratorError149 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion149 && _iterator149.return != null) {
                _iterator149.return();
              }
            } finally {
              if (_didIteratorError149) {
                throw _iteratorError149;
              }
            }
          }
        }
      }, {
        key: "_revert",
        value: function _revert(t, e) {
          var n = Wt(e) ? e : [e],
              i = this._consumables[t];
          var _iteratorNormalCompletion150 = true;
          var _didIteratorError150 = false;
          var _iteratorError150 = undefined;

          try {
            for (var _iterator150 = n[Symbol.iterator](), _step150; !(_iteratorNormalCompletion150 = (_step150 = _iterator150.next()).done); _iteratorNormalCompletion150 = true) {
              var _e117 = _step150.value;

              if ("attributes" !== t || "class" !== _e117 && "style" !== _e117) {
                !1 === i.get(_e117) && i.set(_e117, !0);
              } else {
                var _t131 = "class" == _e117 ? "classes" : "styles";

                this._revert(_t131, _toConsumableArray(this._consumables[_t131].keys()));
              }
            }
          } catch (err) {
            _didIteratorError150 = true;
            _iteratorError150 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion150 && _iterator150.return != null) {
                _iterator150.return();
              }
            } finally {
              if (_didIteratorError150) {
                throw _iteratorError150;
              }
            }
          }
        }
      }]);

      return Ia;
    }();

    var Na =
    /*#__PURE__*/
    function () {
      function Na() {
        var _this49 = this;

        _classCallCheck(this, Na);

        this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", function (t, e) {
          e[0] = new Oa(e[0]);
        }, {
          priority: "highest"
        }), this.on("checkChild", function (t, e) {
          e[0] = new Oa(e[0]), e[1] = _this49.getDefinition(e[1]);
        }, {
          priority: "highest"
        });
      }

      _createClass(Na, [{
        key: "register",
        value: function register(t, e) {
          if (this._sourceDefinitions[t]) throw new Gn.b("schema-cannot-register-item-twice: A single item cannot be registered twice in the schema.", this, {
            itemName: t
          });
          this._sourceDefinitions[t] = [Object.assign({}, e)], this._clearCache();
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (!this._sourceDefinitions[t]) throw new Gn.b("schema-cannot-extend-missing-item: Cannot extend an item which was not registered yet.", this, {
            itemName: t
          });
          this._sourceDefinitions[t].push(Object.assign({}, e)), this._clearCache();
        }
      }, {
        key: "getDefinitions",
        value: function getDefinitions() {
          return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
        }
      }, {
        key: "getDefinition",
        value: function getDefinition(t) {
          var e;
          return e = "string" == typeof t ? t : t.is && (t.is("text") || t.is("textProxy")) ? "$text" : t.name, this.getDefinitions()[e];
        }
      }, {
        key: "isRegistered",
        value: function isRegistered(t) {
          return !!this.getDefinition(t);
        }
      }, {
        key: "isBlock",
        value: function isBlock(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isBlock);
        }
      }, {
        key: "isLimit",
        value: function isLimit(t) {
          var e = this.getDefinition(t);
          return !!e && !(!e.isLimit && !e.isObject);
        }
      }, {
        key: "isObject",
        value: function isObject(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isObject);
        }
      }, {
        key: "isInline",
        value: function isInline(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isInline);
        }
      }, {
        key: "checkChild",
        value: function checkChild(t, e) {
          return !!e && this._checkContextMatch(e, t);
        }
      }, {
        key: "checkAttribute",
        value: function checkAttribute(t, e) {
          var n = this.getDefinition(t.last);
          return !!n && n.allowAttributes.includes(e);
        }
      }, {
        key: "checkMerge",
        value: function checkMerge(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

          if (t instanceof Gs) {
            var _e118 = t.nodeBefore,
                _n107 = t.nodeAfter;
            if (!(_e118 instanceof qs)) throw new Gn.b("schema-check-merge-no-element-before: The node before the merge position must be an element.", this);
            if (!(_n107 instanceof qs)) throw new Gn.b("schema-check-merge-no-element-after: The node after the merge position must be an element.", this);
            return this.checkMerge(_e118, _n107);
          }

          var _iteratorNormalCompletion151 = true;
          var _didIteratorError151 = false;
          var _iteratorError151 = undefined;

          try {
            for (var _iterator151 = e.getChildren()[Symbol.iterator](), _step151; !(_iteratorNormalCompletion151 = (_step151 = _iterator151.next()).done); _iteratorNormalCompletion151 = true) {
              var _n108 = _step151.value;
              if (!this.checkChild(t, _n108)) return !1;
            }
          } catch (err) {
            _didIteratorError151 = true;
            _iteratorError151 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion151 && _iterator151.return != null) {
                _iterator151.return();
              }
            } finally {
              if (_didIteratorError151) {
                throw _iteratorError151;
              }
            }
          }

          return !0;
        }
      }, {
        key: "addChildCheck",
        value: function addChildCheck(t) {
          this.on("checkChild", function (e, _ref40) {
            var _ref41 = _slicedToArray(_ref40, 2),
                n = _ref41[0],
                i = _ref41[1];

            if (!i) return;
            var o = t(n, i);
            "boolean" == typeof o && (e.stop(), e.return = o);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "addAttributeCheck",
        value: function addAttributeCheck(t) {
          this.on("checkAttribute", function (e, _ref42) {
            var _ref43 = _slicedToArray(_ref42, 2),
                n = _ref43[0],
                i = _ref43[1];

            var o = t(n, i);
            "boolean" == typeof o && (e.stop(), e.return = o);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "setAttributeProperties",
        value: function setAttributeProperties(t, e) {
          this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
        }
      }, {
        key: "getAttributeProperties",
        value: function getAttributeProperties(t) {
          return this._attributeProperties[t] || {};
        }
      }, {
        key: "getLimitElement",
        value: function getLimitElement(t) {
          var e;
          if (t instanceof Gs) e = t.parent;else {
            e = (t instanceof Qs ? [t] : Array.from(t.getRanges())).reduce(function (t, e) {
              var n = e.getCommonAncestor();
              return t ? t.getCommonAncestor(n, {
                includeSelf: !0
              }) : n;
            }, null);
          }

          for (; !this.isLimit(e) && e.parent;) {
            e = e.parent;
          }

          return e;
        }
      }, {
        key: "checkAttributeInSelection",
        value: function checkAttributeInSelection(t, e) {
          if (t.isCollapsed) {
            var _n109 = [].concat(_toConsumableArray(t.getFirstPosition().getAncestors()), [new Fs("", t.getAttributes())]);

            return this.checkAttribute(_n109, e);
          }

          {
            var _n110 = t.getRanges();

            var _iteratorNormalCompletion152 = true;
            var _didIteratorError152 = false;
            var _iteratorError152 = undefined;

            try {
              for (var _iterator152 = _n110[Symbol.iterator](), _step152; !(_iteratorNormalCompletion152 = (_step152 = _iterator152.next()).done); _iteratorNormalCompletion152 = true) {
                var _t132 = _step152.value;
                var _iteratorNormalCompletion153 = true;
                var _didIteratorError153 = false;
                var _iteratorError153 = undefined;

                try {
                  for (var _iterator153 = _t132[Symbol.iterator](), _step153; !(_iteratorNormalCompletion153 = (_step153 = _iterator153.next()).done); _iteratorNormalCompletion153 = true) {
                    var _n111 = _step153.value;
                    if (this.checkAttribute(_n111.item, e)) return !0;
                  }
                } catch (err) {
                  _didIteratorError153 = true;
                  _iteratorError153 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion153 && _iterator153.return != null) {
                      _iterator153.return();
                    }
                  } finally {
                    if (_didIteratorError153) {
                      throw _iteratorError153;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError152 = true;
              _iteratorError152 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion152 && _iterator152.return != null) {
                  _iterator152.return();
                }
              } finally {
                if (_didIteratorError152) {
                  throw _iteratorError152;
                }
              }
            }
          }
          return !1;
        }
      }, {
        key: "getValidRanges",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getValidRanges(t, e) {
          var _iteratorNormalCompletion155, _didIteratorError155, _iteratorError155, _iterator155, _step155, _n112;

          return _regeneratorRuntime.wrap(function getValidRanges$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  t =
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee(t) {
                    var _iteratorNormalCompletion154, _didIteratorError154, _iteratorError154, _iterator154, _step154, _e119;

                    return _regeneratorRuntime.wrap(function _callee$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            _iteratorNormalCompletion154 = true;
                            _didIteratorError154 = false;
                            _iteratorError154 = undefined;
                            _context22.prev = 3;
                            _iterator154 = t[Symbol.iterator]();

                          case 5:
                            if (_iteratorNormalCompletion154 = (_step154 = _iterator154.next()).done) {
                              _context22.next = 11;
                              break;
                            }

                            _e119 = _step154.value;
                            return _context22.delegateYield(_e119.getMinimalFlatRanges(), "t0", 8);

                          case 8:
                            _iteratorNormalCompletion154 = true;
                            _context22.next = 5;
                            break;

                          case 11:
                            _context22.next = 17;
                            break;

                          case 13:
                            _context22.prev = 13;
                            _context22.t1 = _context22["catch"](3);
                            _didIteratorError154 = true;
                            _iteratorError154 = _context22.t1;

                          case 17:
                            _context22.prev = 17;
                            _context22.prev = 18;

                            if (!_iteratorNormalCompletion154 && _iterator154.return != null) {
                              _iterator154.return();
                            }

                          case 20:
                            _context22.prev = 20;

                            if (!_didIteratorError154) {
                              _context22.next = 23;
                              break;
                            }

                            throw _iteratorError154;

                          case 23:
                            return _context22.finish(20);

                          case 24:
                            return _context22.finish(17);

                          case 25:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee, null, [[3, 13, 17, 25], [18,, 20, 24]]);
                  })(t);
                  _iteratorNormalCompletion155 = true;
                  _didIteratorError155 = false;
                  _iteratorError155 = undefined;
                  _context23.prev = 4;
                  _iterator155 = t[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion155 = (_step155 = _iterator155.next()).done) {
                    _context23.next = 12;
                    break;
                  }

                  _n112 = _step155.value;
                  return _context23.delegateYield(this._getValidRangesForRange(_n112, e), "t0", 9);

                case 9:
                  _iteratorNormalCompletion155 = true;
                  _context23.next = 6;
                  break;

                case 12:
                  _context23.next = 18;
                  break;

                case 14:
                  _context23.prev = 14;
                  _context23.t1 = _context23["catch"](4);
                  _didIteratorError155 = true;
                  _iteratorError155 = _context23.t1;

                case 18:
                  _context23.prev = 18;
                  _context23.prev = 19;

                  if (!_iteratorNormalCompletion155 && _iterator155.return != null) {
                    _iterator155.return();
                  }

                case 21:
                  _context23.prev = 21;

                  if (!_didIteratorError155) {
                    _context23.next = 24;
                    break;
                  }

                  throw _iteratorError155;

                case 24:
                  return _context23.finish(21);

                case 25:
                  return _context23.finish(18);

                case 26:
                case "end":
                  return _context23.stop();
              }
            }
          }, getValidRanges, this, [[4, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "getNearestSelectionRange",
        value: function getNearestSelectionRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
          if (this.checkChild(t, "$text")) return new Qs(t);
          var n, i;
          "both" != e && "backward" != e || (n = new Ws({
            startPosition: t,
            direction: "backward"
          })), "both" != e && "forward" != e || (i = new Ws({
            startPosition: t
          }));
          var _iteratorNormalCompletion156 = true;
          var _didIteratorError156 = false;
          var _iteratorError156 = undefined;

          try {
            for (var _iterator156 =
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2(t, e) {
              var n, _e121, _t134;

              return _regeneratorRuntime.wrap(function _callee2$(_context24) {
                while (1) {
                  switch (_context24.prev = _context24.next) {
                    case 0:
                      n = !1;

                    case 1:
                      if (n) {
                        _context24.next = 18;
                        break;
                      }

                      if (!(n = !0, t)) {
                        _context24.next = 9;
                        break;
                      }

                      _e121 = t.next();
                      _context24.t0 = _e121.done;

                      if (_context24.t0) {
                        _context24.next = 9;
                        break;
                      }

                      n = !1;
                      _context24.next = 9;
                      return {
                        walker: t,
                        value: _e121.value
                      };

                    case 9:
                      if (!e) {
                        _context24.next = 16;
                        break;
                      }

                      _t134 = e.next();
                      _context24.t1 = _t134.done;

                      if (_context24.t1) {
                        _context24.next = 16;
                        break;
                      }

                      n = !1;
                      _context24.next = 16;
                      return {
                        walker: e,
                        value: _t134.value
                      };

                    case 16:
                      _context24.next = 1;
                      break;

                    case 18:
                    case "end":
                      return _context24.stop();
                  }
                }
              }, _callee2);
            })(n, i)[Symbol.iterator](), _step156; !(_iteratorNormalCompletion156 = (_step156 = _iterator156.next()).done); _iteratorNormalCompletion156 = true) {
              var _t133 = _step156.value;

              var _e120 = _t133.walker == n ? "elementEnd" : "elementStart",
                  _i84 = _t133.value;

              if (_i84.type == _e120 && this.isObject(_i84.item)) return Qs._createOn(_i84.item);
              if (this.checkChild(_i84.nextPosition, "$text")) return new Qs(_i84.nextPosition);
            }
          } catch (err) {
            _didIteratorError156 = true;
            _iteratorError156 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion156 && _iterator156.return != null) {
                _iterator156.return();
              }
            } finally {
              if (_didIteratorError156) {
                throw _iteratorError156;
              }
            }
          }

          return null;
        }
      }, {
        key: "findAllowedParent",
        value: function findAllowedParent(t, e) {
          var n = t.parent;

          for (; n;) {
            if (this.checkChild(n, e)) return n;
            if (this.isLimit(n)) return null;
            n = n.parent;
          }

          return null;
        }
      }, {
        key: "removeDisallowedAttributes",
        value: function removeDisallowedAttributes(t, e) {
          var _iteratorNormalCompletion157 = true;
          var _didIteratorError157 = false;
          var _iteratorError157 = undefined;

          try {
            for (var _iterator157 = t[Symbol.iterator](), _step157; !(_iteratorNormalCompletion157 = (_step157 = _iterator157.next()).done); _iteratorNormalCompletion157 = true) {
              var _n113 = _step157.value;
              var _iteratorNormalCompletion158 = true;
              var _didIteratorError158 = false;
              var _iteratorError158 = undefined;

              try {
                for (var _iterator158 = _n113.getAttributeKeys()[Symbol.iterator](), _step158; !(_iteratorNormalCompletion158 = (_step158 = _iterator158.next()).done); _iteratorNormalCompletion158 = true) {
                  var _t135 = _step158.value;
                  this.checkAttribute(_n113, _t135) || e.removeAttribute(_t135, _n113);
                }
              } catch (err) {
                _didIteratorError158 = true;
                _iteratorError158 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion158 && _iterator158.return != null) {
                    _iterator158.return();
                  }
                } finally {
                  if (_didIteratorError158) {
                    throw _iteratorError158;
                  }
                }
              }

              _n113.is("element") && this.removeDisallowedAttributes(_n113.getChildren(), e);
            }
          } catch (err) {
            _didIteratorError157 = true;
            _iteratorError157 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion157 && _iterator157.return != null) {
                _iterator157.return();
              }
            } finally {
              if (_didIteratorError157) {
                throw _iteratorError157;
              }
            }
          }
        }
      }, {
        key: "createContext",
        value: function createContext(t) {
          return new Oa(t);
        }
      }, {
        key: "_clearCache",
        value: function _clearCache() {
          this._compiledDefinitions = null;
        }
      }, {
        key: "_compile",
        value: function _compile() {
          var t = {},
              e = this._sourceDefinitions,
              n = Object.keys(e);

          for (var _i85 = 0, _n114 = n; _i85 < _n114.length; _i85++) {
            var _i90 = _n114[_i85];
            t[_i90] = Ra(e[_i90], _i90);
          }

          for (var _i86 = 0, _n115 = n; _i86 < _n115.length; _i86++) {
            var _e122 = _n115[_i86];
            Da(t, _e122);
          }

          for (var _i87 = 0, _n116 = n; _i87 < _n116.length; _i87++) {
            var _e123 = _n116[_i87];
            La(t, _e123);
          }

          for (var _i88 = 0, _n117 = n; _i88 < _n117.length; _i88++) {
            var _e124 = _n117[_i88];
            ja(t, _e124), Va(t, _e124);
          }

          for (var _i89 = 0, _n118 = n; _i89 < _n118.length; _i89++) {
            var _e125 = _n118[_i89];
            Ba(t, _e125), za(t, _e125);
          }

          this._compiledDefinitions = t;
        }
      }, {
        key: "_checkContextMatch",
        value: function _checkContextMatch(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length - 1;
          var i = e.getItem(n);

          if (t.allowIn.includes(i.name)) {
            if (0 == n) return !0;
            {
              var _t136 = this.getDefinition(i);

              return this._checkContextMatch(_t136, e, n - 1);
            }
          }

          return !1;
        }
      }, {
        key: "_getValidRangesForRange",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _getValidRangesForRange(t, e) {
          var n, i, _iteratorNormalCompletion159, _didIteratorError159, _iteratorError159, _iterator159, _step159, _o35;

          return _regeneratorRuntime.wrap(function _getValidRangesForRange$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  n = t.start, i = t.start;
                  _iteratorNormalCompletion159 = true;
                  _didIteratorError159 = false;
                  _iteratorError159 = undefined;
                  _context25.prev = 4;
                  _iterator159 = t.getItems({
                    shallow: !0
                  })[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion159 = (_step159 = _iterator159.next()).done) {
                    _context25.next = 22;
                    break;
                  }

                  _o35 = _step159.value;
                  _context25.t0 = _o35.is("element");

                  if (!_context25.t0) {
                    _context25.next = 11;
                    break;
                  }

                  return _context25.delegateYield(this._getValidRangesForRange(Qs._createIn(_o35), e), "t1", 11);

                case 11:
                  _context25.t2 = this.checkAttribute(_o35, e);

                  if (_context25.t2) {
                    _context25.next = 18;
                    break;
                  }

                  _context25.t3 = n.isEqual(i);

                  if (_context25.t3) {
                    _context25.next = 17;
                    break;
                  }

                  _context25.next = 17;
                  return new Qs(n, i);

                case 17:
                  n = Gs._createAfter(_o35);

                case 18:
                  i = Gs._createAfter(_o35);

                case 19:
                  _iteratorNormalCompletion159 = true;
                  _context25.next = 6;
                  break;

                case 22:
                  _context25.next = 28;
                  break;

                case 24:
                  _context25.prev = 24;
                  _context25.t4 = _context25["catch"](4);
                  _didIteratorError159 = true;
                  _iteratorError159 = _context25.t4;

                case 28:
                  _context25.prev = 28;
                  _context25.prev = 29;

                  if (!_iteratorNormalCompletion159 && _iterator159.return != null) {
                    _iterator159.return();
                  }

                case 31:
                  _context25.prev = 31;

                  if (!_didIteratorError159) {
                    _context25.next = 34;
                    break;
                  }

                  throw _iteratorError159;

                case 34:
                  return _context25.finish(31);

                case 35:
                  return _context25.finish(28);

                case 36:
                  _context25.t5 = n.isEqual(i);

                  if (_context25.t5) {
                    _context25.next = 40;
                    break;
                  }

                  _context25.next = 40;
                  return new Qs(n, i);

                case 40:
                case "end":
                  return _context25.stop();
              }
            }
          }, _getValidRangesForRange, this, [[4, 24, 28, 36], [29,, 31, 35]]);
        })
      }]);

      return Na;
    }();

    ci(Na, Fi);

    var Oa =
    /*#__PURE__*/
    function () {
      function Oa(t) {
        _classCallCheck(this, Oa);

        if (t instanceof Oa) return t;
        "string" == typeof t ? t = [t] : Array.isArray(t) || (t = t.getAncestors({
          includeSelf: !0
        })), t[0] && "string" != typeof t[0] && t[0].is("documentFragment") && t.shift(), this._items = t.map(Ha);
      }

      _createClass(Oa, [{
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "push",
        value: function push(t) {
          var e = new Oa([t]);
          return e._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(e._items)), e;
        }
      }, {
        key: "getItem",
        value: function getItem(t) {
          return this._items[t];
        }
      }, {
        key: "getNames",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getNames() {
          return _regeneratorRuntime.wrap(function getNames$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  return _context26.delegateYield(this._items.map(function (t) {
                    return t.name;
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context26.stop();
              }
            }
          }, getNames, this);
        })
      }, {
        key: "endsWith",
        value: function endsWith(t) {
          return Array.from(this.getNames()).join(" ").endsWith(t);
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this._items.length - 1];
        }
      }]);

      return Oa;
    }();

    function Ra(t, e) {
      var n = {
        name: e,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        inheritTypesFrom: []
      };
      return function (t, e) {
        var _iteratorNormalCompletion160 = true;
        var _didIteratorError160 = false;
        var _iteratorError160 = undefined;

        try {
          for (var _iterator160 = t[Symbol.iterator](), _step160; !(_iteratorNormalCompletion160 = (_step160 = _iterator160.next()).done); _iteratorNormalCompletion160 = true) {
            var _n119 = _step160.value;

            var _t137 = Object.keys(_n119).filter(function (t) {
              return t.startsWith("is");
            });

            var _iteratorNormalCompletion161 = true;
            var _didIteratorError161 = false;
            var _iteratorError161 = undefined;

            try {
              for (var _iterator161 = _t137[Symbol.iterator](), _step161; !(_iteratorNormalCompletion161 = (_step161 = _iterator161.next()).done); _iteratorNormalCompletion161 = true) {
                var _i91 = _step161.value;
                e[_i91] = _n119[_i91];
              }
            } catch (err) {
              _didIteratorError161 = true;
              _iteratorError161 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion161 && _iterator161.return != null) {
                  _iterator161.return();
                }
              } finally {
                if (_didIteratorError161) {
                  throw _iteratorError161;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError160 = true;
          _iteratorError160 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion160 && _iterator160.return != null) {
              _iterator160.return();
            }
          } finally {
            if (_didIteratorError160) {
              throw _iteratorError160;
            }
          }
        }
      }(t, n), Fa(t, n, "allowIn"), Fa(t, n, "allowContentOf"), Fa(t, n, "allowWhere"), Fa(t, n, "allowAttributes"), Fa(t, n, "allowAttributesOf"), Fa(t, n, "inheritTypesFrom"), function (t, e) {
        var _iteratorNormalCompletion162 = true;
        var _didIteratorError162 = false;
        var _iteratorError162 = undefined;

        try {
          for (var _iterator162 = t[Symbol.iterator](), _step162; !(_iteratorNormalCompletion162 = (_step162 = _iterator162.next()).done); _iteratorNormalCompletion162 = true) {
            var _n120 = _step162.value;
            var _t138 = _n120.inheritAllFrom;
            _t138 && (e.allowContentOf.push(_t138), e.allowWhere.push(_t138), e.allowAttributesOf.push(_t138), e.inheritTypesFrom.push(_t138));
          }
        } catch (err) {
          _didIteratorError162 = true;
          _iteratorError162 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion162 && _iterator162.return != null) {
              _iterator162.return();
            }
          } finally {
            if (_didIteratorError162) {
              throw _iteratorError162;
            }
          }
        }
      }(t, n), n;
    }

    function Da(t, e) {
      var _iteratorNormalCompletion163 = true;
      var _didIteratorError163 = false;
      var _iteratorError163 = undefined;

      try {
        for (var _iterator163 = t[e].allowContentOf[Symbol.iterator](), _step163; !(_iteratorNormalCompletion163 = (_step163 = _iterator163.next()).done); _iteratorNormalCompletion163 = true) {
          var _n121 = _step163.value;

          if (t[_n121]) {
            Ua(t, _n121).forEach(function (t) {
              t.allowIn.push(e);
            });
          }
        }
      } catch (err) {
        _didIteratorError163 = true;
        _iteratorError163 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion163 && _iterator163.return != null) {
            _iterator163.return();
          }
        } finally {
          if (_didIteratorError163) {
            throw _iteratorError163;
          }
        }
      }

      delete t[e].allowContentOf;
    }

    function La(t, e) {
      var _iteratorNormalCompletion164 = true;
      var _didIteratorError164 = false;
      var _iteratorError164 = undefined;

      try {
        for (var _iterator164 = t[e].allowWhere[Symbol.iterator](), _step164; !(_iteratorNormalCompletion164 = (_step164 = _iterator164.next()).done); _iteratorNormalCompletion164 = true) {
          var _n122 = _step164.value;
          var _i92 = t[_n122];

          if (_i92) {
            var _t$e$allowIn;

            var _n123 = _i92.allowIn;

            (_t$e$allowIn = t[e].allowIn).push.apply(_t$e$allowIn, _toConsumableArray(_n123));
          }
        }
      } catch (err) {
        _didIteratorError164 = true;
        _iteratorError164 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion164 && _iterator164.return != null) {
            _iterator164.return();
          }
        } finally {
          if (_didIteratorError164) {
            throw _iteratorError164;
          }
        }
      }

      delete t[e].allowWhere;
    }

    function ja(t, e) {
      var _iteratorNormalCompletion165 = true;
      var _didIteratorError165 = false;
      var _iteratorError165 = undefined;

      try {
        for (var _iterator165 = t[e].allowAttributesOf[Symbol.iterator](), _step165; !(_iteratorNormalCompletion165 = (_step165 = _iterator165.next()).done); _iteratorNormalCompletion165 = true) {
          var _n124 = _step165.value;
          var _i93 = t[_n124];

          if (_i93) {
            var _t$e$allowAttributes;

            var _n125 = _i93.allowAttributes;

            (_t$e$allowAttributes = t[e].allowAttributes).push.apply(_t$e$allowAttributes, _toConsumableArray(_n125));
          }
        }
      } catch (err) {
        _didIteratorError165 = true;
        _iteratorError165 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion165 && _iterator165.return != null) {
            _iterator165.return();
          }
        } finally {
          if (_didIteratorError165) {
            throw _iteratorError165;
          }
        }
      }

      delete t[e].allowAttributesOf;
    }

    function Va(t, e) {
      var n = t[e];
      var _iteratorNormalCompletion166 = true;
      var _didIteratorError166 = false;
      var _iteratorError166 = undefined;

      try {
        for (var _iterator166 = n.inheritTypesFrom[Symbol.iterator](), _step166; !(_iteratorNormalCompletion166 = (_step166 = _iterator166.next()).done); _iteratorNormalCompletion166 = true) {
          var _e126 = _step166.value;
          var _i94 = t[_e126];

          if (_i94) {
            var _t139 = Object.keys(_i94).filter(function (t) {
              return t.startsWith("is");
            });

            var _iteratorNormalCompletion167 = true;
            var _didIteratorError167 = false;
            var _iteratorError167 = undefined;

            try {
              for (var _iterator167 = _t139[Symbol.iterator](), _step167; !(_iteratorNormalCompletion167 = (_step167 = _iterator167.next()).done); _iteratorNormalCompletion167 = true) {
                var _e127 = _step167.value;
                _e127 in n || (n[_e127] = _i94[_e127]);
              }
            } catch (err) {
              _didIteratorError167 = true;
              _iteratorError167 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion167 && _iterator167.return != null) {
                  _iterator167.return();
                }
              } finally {
                if (_didIteratorError167) {
                  throw _iteratorError167;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError166 = true;
        _iteratorError166 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion166 && _iterator166.return != null) {
            _iterator166.return();
          }
        } finally {
          if (_didIteratorError166) {
            throw _iteratorError166;
          }
        }
      }

      delete n.inheritTypesFrom;
    }

    function Ba(t, e) {
      var n = t[e],
          i = n.allowIn.filter(function (e) {
        return t[e];
      });
      n.allowIn = Array.from(new Set(i));
    }

    function za(t, e) {
      var n = t[e];
      n.allowAttributes = Array.from(new Set(n.allowAttributes));
    }

    function Fa(t, e, n) {
      var _iteratorNormalCompletion168 = true;
      var _didIteratorError168 = false;
      var _iteratorError168 = undefined;

      try {
        for (var _iterator168 = t[Symbol.iterator](), _step168; !(_iteratorNormalCompletion168 = (_step168 = _iterator168.next()).done); _iteratorNormalCompletion168 = true) {
          var _e$n;

          var _i95 = _step168.value;
          "string" == typeof _i95[n] ? e[n].push(_i95[n]) : Array.isArray(_i95[n]) && (_e$n = e[n]).push.apply(_e$n, _toConsumableArray(_i95[n]));
        }
      } catch (err) {
        _didIteratorError168 = true;
        _iteratorError168 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion168 && _iterator168.return != null) {
            _iterator168.return();
          }
        } finally {
          if (_didIteratorError168) {
            throw _iteratorError168;
          }
        }
      }
    }

    function Ua(t, e) {
      var n = t[e];
      return function (t) {
        return Object.keys(t).map(function (e) {
          return t[e];
        });
      }(t).filter(function (t) {
        return t.allowIn.includes(n.name);
      });
    }

    function Ha(t) {
      return "string" == typeof t ? {
        name: t,
        getAttributeKeys:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                case "end":
                  return _context27.stop();
              }
            }
          }, getAttributeKeys);
        }),
        getAttribute: function getAttribute() {}
      } : {
        name: t.is("element") ? t.name : "$text",
        getAttributeKeys:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  return _context28.delegateYield(t.getAttributeKeys(), "t0", 1);

                case 1:
                case "end":
                  return _context28.stop();
              }
            }
          }, getAttributeKeys);
        }),
        getAttribute: function getAttribute(e) {
          return t.getAttribute(e);
        }
      };
    }

    var qa =
    /*#__PURE__*/
    function () {
      function qa() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, qa);

        this._splitParts = new Map(), this._modelCursor = null, this.conversionApi = Object.assign({}, t), this.conversionApi.convertItem = this._convertItem.bind(this), this.conversionApi.convertChildren = this._convertChildren.bind(this), this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this), this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
      }

      _createClass(qa, [{
        key: "convert",
        value: function convert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
          this.fire("viewCleanup", t), this._modelCursor = function (t, e) {
            var n;
            var _iteratorNormalCompletion169 = true;
            var _didIteratorError169 = false;
            var _iteratorError169 = undefined;

            try {
              for (var _iterator169 = new Oa(t)[Symbol.iterator](), _step169; !(_iteratorNormalCompletion169 = (_step169 = _iterator169.next()).done); _iteratorNormalCompletion169 = true) {
                var _i96 = _step169.value;
                var _t140 = {};
                var _iteratorNormalCompletion170 = true;
                var _didIteratorError170 = false;
                var _iteratorError170 = undefined;

                try {
                  for (var _iterator170 = _i96.getAttributeKeys()[Symbol.iterator](), _step170; !(_iteratorNormalCompletion170 = (_step170 = _iterator170.next()).done); _iteratorNormalCompletion170 = true) {
                    var _e128 = _step170.value;
                    _t140[_e128] = _i96.getAttribute(_e128);
                  }
                } catch (err) {
                  _didIteratorError170 = true;
                  _iteratorError170 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion170 && _iterator170.return != null) {
                      _iterator170.return();
                    }
                  } finally {
                    if (_didIteratorError170) {
                      throw _iteratorError170;
                    }
                  }
                }

                var _o36 = e.createElement(_i96.name, _t140);

                n && e.append(_o36, n), n = Gs._createAt(_o36, 0);
              }
            } catch (err) {
              _didIteratorError169 = true;
              _iteratorError169 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion169 && _iterator169.return != null) {
                  _iterator169.return();
                }
              } finally {
                if (_didIteratorError169) {
                  throw _iteratorError169;
                }
              }
            }

            return n;
          }(n, e), this.conversionApi.writer = e, this.conversionApi.consumable = Ea.createFrom(t), this.conversionApi.store = {};

          var _this$_convertItem = this._convertItem(t, this._modelCursor),
              i = _this$_convertItem.modelRange,
              o = e.createDocumentFragment();

          if (i) {
            this._removeEmptyElements();

            for (var _i97 = 0, _Array$from5 = Array.from(this._modelCursor.parent.getChildren()); _i97 < _Array$from5.length; _i97++) {
              var _t143 = _Array$from5[_i97];
              e.append(_t143, o);
            }

            o.markers = function (t, e) {
              var n = new Set(),
                  i = new Map(),
                  o = Qs._createIn(t).getItems();

              var _iteratorNormalCompletion171 = true;
              var _didIteratorError171 = false;
              var _iteratorError171 = undefined;

              try {
                for (var _iterator171 = o[Symbol.iterator](), _step171; !(_iteratorNormalCompletion171 = (_step171 = _iterator171.next()).done); _iteratorNormalCompletion171 = true) {
                  var _t141 = _step171.value;
                  "$marker" == _t141.name && n.add(_t141);
                }
              } catch (err) {
                _didIteratorError171 = true;
                _iteratorError171 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion171 && _iterator171.return != null) {
                    _iterator171.return();
                  }
                } finally {
                  if (_didIteratorError171) {
                    throw _iteratorError171;
                  }
                }
              }

              var _iteratorNormalCompletion172 = true;
              var _didIteratorError172 = false;
              var _iteratorError172 = undefined;

              try {
                for (var _iterator172 = n[Symbol.iterator](), _step172; !(_iteratorNormalCompletion172 = (_step172 = _iterator172.next()).done); _iteratorNormalCompletion172 = true) {
                  var _t142 = _step172.value;

                  var _n126 = _t142.getAttribute("data-name"),
                      _o37 = e.createPositionBefore(_t142);

                  i.has(_n126) ? i.get(_n126).end = _o37.clone() : i.set(_n126, new Qs(_o37.clone())), e.remove(_t142);
                }
              } catch (err) {
                _didIteratorError172 = true;
                _iteratorError172 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion172 && _iterator172.return != null) {
                    _iterator172.return();
                  }
                } finally {
                  if (_didIteratorError172) {
                    throw _iteratorError172;
                  }
                }
              }

              return i;
            }(o, e);
          }

          return this._modelCursor = null, this._splitParts.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, o;
        }
      }, {
        key: "_convertItem",
        value: function _convertItem(t, e) {
          var n = Object.assign({
            viewItem: t,
            modelCursor: e,
            modelRange: null
          });
          if (t.is("element") ? this.fire("element:" + t.name, n, this.conversionApi) : t.is("text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof Qs)) throw new Gn.b("view-conversion-dispatcher-incorrect-result: Incorrect conversion result was dropped.", this);
          return {
            modelRange: n.modelRange,
            modelCursor: n.modelCursor
          };
        }
      }, {
        key: "_convertChildren",
        value: function _convertChildren(t, e) {
          var n = new Qs(e);
          var i = e;

          for (var _i98 = 0, _Array$from6 = Array.from(t.getChildren()); _i98 < _Array$from6.length; _i98++) {
            var _e129 = _Array$from6[_i98];

            var _t144 = this._convertItem(_e129, i);

            _t144.modelRange instanceof Qs && (n.end = _t144.modelRange.end, i = _t144.modelCursor);
          }

          return {
            modelRange: n,
            modelCursor: i
          };
        }
      }, {
        key: "_splitToAllowedParent",
        value: function _splitToAllowedParent(t, e) {
          var n = this.conversionApi.schema.findAllowedParent(e, t);
          if (!n) return null;
          if (n === e.parent) return {
            position: e
          };
          if (this._modelCursor.parent.getAncestors().includes(n)) return null;
          var i = this.conversionApi.writer.split(e, n),
              o = [];
          var _iteratorNormalCompletion173 = true;
          var _didIteratorError173 = false;
          var _iteratorError173 = undefined;

          try {
            for (var _iterator173 = i.range.getWalker()[Symbol.iterator](), _step173; !(_iteratorNormalCompletion173 = (_step173 = _iterator173.next()).done); _iteratorNormalCompletion173 = true) {
              var _t145 = _step173.value;
              if ("elementEnd" == _t145.type) o.push(_t145.item);else {
                var _e130 = o.pop(),
                    _n127 = _t145.item;

                this._registerSplitPair(_e130, _n127);
              }
            }
          } catch (err) {
            _didIteratorError173 = true;
            _iteratorError173 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion173 && _iterator173.return != null) {
                _iterator173.return();
              }
            } finally {
              if (_didIteratorError173) {
                throw _iteratorError173;
              }
            }
          }

          return {
            position: i.position,
            cursorParent: i.range.end.parent
          };
        }
      }, {
        key: "_registerSplitPair",
        value: function _registerSplitPair(t, e) {
          this._splitParts.has(t) || this._splitParts.set(t, [t]);

          var n = this._splitParts.get(t);

          this._splitParts.set(e, n), n.push(e);
        }
      }, {
        key: "_getSplitParts",
        value: function _getSplitParts(t) {
          var e;
          return e = this._splitParts.has(t) ? this._splitParts.get(t) : [t];
        }
      }, {
        key: "_removeEmptyElements",
        value: function _removeEmptyElements() {
          var t = !1;
          var _iteratorNormalCompletion174 = true;
          var _didIteratorError174 = false;
          var _iteratorError174 = undefined;

          try {
            for (var _iterator174 = this._splitParts.keys()[Symbol.iterator](), _step174; !(_iteratorNormalCompletion174 = (_step174 = _iterator174.next()).done); _iteratorNormalCompletion174 = true) {
              var _e131 = _step174.value;
              _e131.isEmpty && (this.conversionApi.writer.remove(_e131), this._splitParts.delete(_e131), t = !0);
            }
          } catch (err) {
            _didIteratorError174 = true;
            _iteratorError174 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion174 && _iterator174.return != null) {
                _iterator174.return();
              }
            } finally {
              if (_didIteratorError174) {
                throw _iteratorError174;
              }
            }
          }

          t && this._removeEmptyElements();
        }
      }]);

      return qa;
    }();

    ci(qa, ei);

    var Wa =
    /*#__PURE__*/
    function () {
      function Wa(t, e) {
        var _this50 = this;

        _classCallCheck(this, Wa);

        this.model = t, this.processor = e, this.mapper = new Js(), this.downcastDispatcher = new Xs({
          mapper: this.mapper
        }), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
          if (!n.consumable.consume(e.item, "insert")) return;
          var i = n.writer,
              o = n.mapper.toViewPosition(e.range.start),
              r = i.createText(e.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.upcastDispatcher = new qa({
          schema: t.schema
        }), this.upcastDispatcher.on("text", function (t, e, n) {
          if (n.schema.checkChild(e.modelCursor, "$text") && n.consumable.consume(e.viewItem)) {
            var _t146 = n.writer.createText(e.viewItem.data);

            n.writer.insert(_t146, e.modelCursor), e.modelRange = Qs._createFromPositionAndShift(e.modelCursor, _t146.offsetSize), e.modelCursor = e.modelRange.end;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("element", function (t, e, n) {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            var _n$convertChildren = n.convertChildren(e.viewItem, e.modelCursor),
                _t147 = _n$convertChildren.modelRange,
                _i99 = _n$convertChildren.modelCursor;

            e.modelRange = _t147, e.modelCursor = _i99;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("documentFragment", function (t, e, n) {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            var _n$convertChildren2 = n.convertChildren(e.viewItem, e.modelCursor),
                _t148 = _n$convertChildren2.modelRange,
                _i100 = _n$convertChildren2.modelCursor;

            e.modelRange = _t148, e.modelCursor = _i100;
          }
        }, {
          priority: "lowest"
        }), this.decorate("init"), this.on("init", function () {
          _this50.fire("ready");
        }, {
          priority: "lowest"
        });
      }

      _createClass(Wa, [{
        key: "get",
        value: function get(t) {
          var _ref44 = t || {},
              _ref44$rootName = _ref44.rootName,
              e = _ref44$rootName === void 0 ? "main" : _ref44$rootName,
              _ref44$trim = _ref44.trim,
              n = _ref44$trim === void 0 ? "empty" : _ref44$trim;

          if (!this._checkIfRootsExists([e])) throw new Gn.b("datacontroller-get-non-existent-root: Attempting to get data from a non-existing root.", this);
          var i = this.model.document.getRoot(e);
          return "empty" !== n || this.model.hasContent(i, {
            ignoreWhitespaces: !0
          }) ? this.stringify(i) : "";
        }
      }, {
        key: "stringify",
        value: function stringify(t) {
          var e = this.toView(t);
          return this.processor.toData(e);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          this.mapper.clearBindings();

          var e = Qs._createIn(t),
              n = new Ao(),
              i = new Co(new ro());

          if (this.mapper.bindElements(t, n), this.downcastDispatcher.convertInsert(e, i), !t.is("documentFragment")) {
            var _e132 = function (t) {
              var e = [],
                  n = t.root.document;
              if (!n) return [];

              var i = Qs._createIn(t);

              var _iteratorNormalCompletion175 = true;
              var _didIteratorError175 = false;
              var _iteratorError175 = undefined;

              try {
                for (var _iterator175 = n.model.markers[Symbol.iterator](), _step175; !(_iteratorNormalCompletion175 = (_step175 = _iterator175.next()).done); _iteratorNormalCompletion175 = true) {
                  var _t149 = _step175.value;

                  var _n128 = i.getIntersection(_t149.getRange());

                  _n128 && e.push([_t149.name, _n128]);
                }
              } catch (err) {
                _didIteratorError175 = true;
                _iteratorError175 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion175 && _iterator175.return != null) {
                    _iterator175.return();
                  }
                } finally {
                  if (_didIteratorError175) {
                    throw _iteratorError175;
                  }
                }
              }

              return e;
            }(t);

            var _iteratorNormalCompletion176 = true;
            var _didIteratorError176 = false;
            var _iteratorError176 = undefined;

            try {
              for (var _iterator176 = _e132[Symbol.iterator](), _step176; !(_iteratorNormalCompletion176 = (_step176 = _iterator176.next()).done); _iteratorNormalCompletion176 = true) {
                var _ref47 = _step176.value;

                var _ref46 = _slicedToArray(_ref47, 2);

                var _t150 = _ref46[0];
                var _n129 = _ref46[1];
                this.downcastDispatcher.convertMarkerAdd(_t150, _n129, i);
              }
            } catch (err) {
              _didIteratorError176 = true;
              _iteratorError176 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion176 && _iterator176.return != null) {
                  _iterator176.return();
                }
              } finally {
                if (_didIteratorError176) {
                  throw _iteratorError176;
                }
              }
            }
          }

          return n;
        }
      }, {
        key: "init",
        value: function init(t) {
          var _this51 = this;

          if (this.model.document.version) throw new Gn.b("datacontroller-init-document-not-empty: Trying to set initial data to not empty document.", this);
          var e = {};
          if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new Gn.b("datacontroller-init-non-existent-root: Attempting to init data on a non-existing root.", this);
          return this.model.enqueueChange("transparent", function (t) {
            for (var _i101 = 0, _Object$keys = Object.keys(e); _i101 < _Object$keys.length; _i101++) {
              var _n130 = _Object$keys[_i101];

              var _i102 = _this51.model.document.getRoot(_n130);

              t.insert(_this51.parse(e[_n130], _i102), _i102, 0);
            }
          }), Promise.resolve();
        }
      }, {
        key: "set",
        value: function set(t) {
          var _this52 = this;

          var e = {};
          if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new Gn.b("datacontroller-set-non-existent-root: Attempting to set data on a non-existing root.", this);
          this.model.enqueueChange("transparent", function (t) {
            t.setSelection(null), t.removeSelectionAttribute(_this52.model.document.selection.getAttributeKeys());

            for (var _i103 = 0, _Object$keys2 = Object.keys(e); _i103 < _Object$keys2.length; _i103++) {
              var _n131 = _Object$keys2[_i103];

              var _i104 = _this52.model.document.getRoot(_n131);

              t.remove(t.createRangeIn(_i104)), t.insert(_this52.parse(e[_n131], _i104), _i104, 0);
            }
          });
        }
      }, {
        key: "parse",
        value: function parse(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          var n = this.processor.toView(t);
          return this.toModel(n, e);
        }
      }, {
        key: "toModel",
        value: function toModel(t) {
          var _this53 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          return this.model.change(function (n) {
            return _this53.upcastDispatcher.convert(t, n, e);
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_checkIfRootsExists",
        value: function _checkIfRootsExists(t) {
          var _iteratorNormalCompletion177 = true;
          var _didIteratorError177 = false;
          var _iteratorError177 = undefined;

          try {
            for (var _iterator177 = t[Symbol.iterator](), _step177; !(_iteratorNormalCompletion177 = (_step177 = _iterator177.next()).done); _iteratorNormalCompletion177 = true) {
              var _e133 = _step177.value;
              if (!this.model.document.getRootNames().includes(_e133)) return !1;
            }
          } catch (err) {
            _didIteratorError177 = true;
            _iteratorError177 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion177 && _iterator177.return != null) {
                _iterator177.return();
              }
            } finally {
              if (_didIteratorError177) {
                throw _iteratorError177;
              }
            }
          }

          return !0;
        }
      }]);

      return Wa;
    }();

    ci(Wa, Fi);

    var Ya =
    /*#__PURE__*/
    function () {
      function Ya(t, e) {
        _classCallCheck(this, Ya);

        this._helpers = new Map(), this._downcast = Array.isArray(t) ? t : [t], this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: !0
        }), this._upcast = Array.isArray(e) ? e : [e], this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: !1
        });
      }

      _createClass(Ya, [{
        key: "addAlias",
        value: function addAlias(t, e) {
          var n = this._downcast.includes(e);

          if (!this._upcast.includes(e) && !n) throw new Gn.b("conversion-add-alias-dispatcher-not-registered: Trying to register and alias for a dispatcher that nas not been registered.", this);

          this._createConversionHelpers({
            name: t,
            dispatchers: [e],
            isDowncast: n
          });
        }
      }, {
        key: "for",
        value: function _for(t) {
          if (!this._helpers.has(t)) throw new Gn.b("conversion-for-unknown-group: Trying to add a converter to an unknown dispatchers group.", this);
          return this._helpers.get(t);
        }
      }, {
        key: "elementToElement",
        value: function elementToElement(t) {
          this.for("downcast").elementToElement(t);
          var _iteratorNormalCompletion178 = true;
          var _didIteratorError178 = false;
          var _iteratorError178 = undefined;

          try {
            for (var _iterator178 = $a(t)[Symbol.iterator](), _step178; !(_iteratorNormalCompletion178 = (_step178 = _iterator178.next()).done); _iteratorNormalCompletion178 = true) {
              var _ref49 = _step178.value;
              var _e134 = _ref49.model;
              var _n132 = _ref49.view;
              this.for("upcast").elementToElement({
                model: _e134,
                view: _n132,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _didIteratorError178 = true;
            _iteratorError178 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion178 && _iterator178.return != null) {
                _iterator178.return();
              }
            } finally {
              if (_didIteratorError178) {
                throw _iteratorError178;
              }
            }
          }
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          this.for("downcast").attributeToElement(t);
          var _iteratorNormalCompletion179 = true;
          var _didIteratorError179 = false;
          var _iteratorError179 = undefined;

          try {
            for (var _iterator179 = $a(t)[Symbol.iterator](), _step179; !(_iteratorNormalCompletion179 = (_step179 = _iterator179.next()).done); _iteratorNormalCompletion179 = true) {
              var _ref51 = _step179.value;
              var _e135 = _ref51.model;
              var _n133 = _ref51.view;
              this.for("upcast").elementToAttribute({
                view: _n133,
                model: _e135,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _didIteratorError179 = true;
            _iteratorError179 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion179 && _iterator179.return != null) {
                _iterator179.return();
              }
            } finally {
              if (_didIteratorError179) {
                throw _iteratorError179;
              }
            }
          }
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          this.for("downcast").attributeToAttribute(t);
          var _iteratorNormalCompletion180 = true;
          var _didIteratorError180 = false;
          var _iteratorError180 = undefined;

          try {
            for (var _iterator180 = $a(t)[Symbol.iterator](), _step180; !(_iteratorNormalCompletion180 = (_step180 = _iterator180.next()).done); _iteratorNormalCompletion180 = true) {
              var _ref53 = _step180.value;
              var _e136 = _ref53.model;
              var _n134 = _ref53.view;
              this.for("upcast").attributeToAttribute({
                view: _n134,
                model: _e136
              });
            }
          } catch (err) {
            _didIteratorError180 = true;
            _iteratorError180 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion180 && _iterator180.return != null) {
                _iterator180.return();
              }
            } finally {
              if (_didIteratorError180) {
                throw _iteratorError180;
              }
            }
          }
        }
      }, {
        key: "_createConversionHelpers",
        value: function _createConversionHelpers(_ref54) {
          var t = _ref54.name,
              e = _ref54.dispatchers,
              n = _ref54.isDowncast;
          if (this._helpers.has(t)) throw new Gn.b("conversion-group-exists: Trying to register a group name that has already been registered.", this);
          var i = n ? new ma(e) : new ka(e);

          this._helpers.set(t, i);
        }
      }]);

      return Ya;
    }();

    function $a(t) {
      var _iteratorNormalCompletion181, _didIteratorError181, _iteratorError181, _iterator181, _step181, _e137;

      return _regeneratorRuntime.wrap(function $a$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              if (!t.model.values) {
                _context29.next = 28;
                break;
              }

              _iteratorNormalCompletion181 = true;
              _didIteratorError181 = false;
              _iteratorError181 = undefined;
              _context29.prev = 4;
              _iterator181 = t.model.values[Symbol.iterator]();

            case 6:
              if (_iteratorNormalCompletion181 = (_step181 = _iterator181.next()).done) {
                _context29.next = 12;
                break;
              }

              _e137 = _step181.value;
              return _context29.delegateYield(Ga({
                key: t.model.key,
                value: _e137
              }, t.view[_e137], t.upcastAlso ? t.upcastAlso[_e137] : void 0), "t0", 9);

            case 9:
              _iteratorNormalCompletion181 = true;
              _context29.next = 6;
              break;

            case 12:
              _context29.next = 18;
              break;

            case 14:
              _context29.prev = 14;
              _context29.t1 = _context29["catch"](4);
              _didIteratorError181 = true;
              _iteratorError181 = _context29.t1;

            case 18:
              _context29.prev = 18;
              _context29.prev = 19;

              if (!_iteratorNormalCompletion181 && _iterator181.return != null) {
                _iterator181.return();
              }

            case 21:
              _context29.prev = 21;

              if (!_didIteratorError181) {
                _context29.next = 24;
                break;
              }

              throw _iteratorError181;

            case 24:
              return _context29.finish(21);

            case 25:
              return _context29.finish(18);

            case 26:
              _context29.next = 29;
              break;

            case 28:
              return _context29.delegateYield(Ga(t.model, t.view, t.upcastAlso), "t2", 29);

            case 29:
            case "end":
              return _context29.stop();
          }
        }
      }, _marked, null, [[4, 14, 18, 26], [19,, 21, 25]]);
    }

    function Ga(t, e, n) {
      var _iteratorNormalCompletion182, _didIteratorError182, _iteratorError182, _iterator182, _step182, _e138;

      return _regeneratorRuntime.wrap(function Ga$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return {
                model: t,
                view: e
              };

            case 2:
              if (!n) {
                _context30.next = 30;
                break;
              }

              n = Array.isArray(n) ? n : [n];
              _iteratorNormalCompletion182 = true;
              _didIteratorError182 = false;
              _iteratorError182 = undefined;
              _context30.prev = 7;
              _iterator182 = n[Symbol.iterator]();

            case 9:
              if (_iteratorNormalCompletion182 = (_step182 = _iterator182.next()).done) {
                _context30.next = 16;
                break;
              }

              _e138 = _step182.value;
              _context30.next = 13;
              return {
                model: t,
                view: _e138
              };

            case 13:
              _iteratorNormalCompletion182 = true;
              _context30.next = 9;
              break;

            case 16:
              _context30.next = 22;
              break;

            case 18:
              _context30.prev = 18;
              _context30.t0 = _context30["catch"](7);
              _didIteratorError182 = true;
              _iteratorError182 = _context30.t0;

            case 22:
              _context30.prev = 22;
              _context30.prev = 23;

              if (!_iteratorNormalCompletion182 && _iterator182.return != null) {
                _iterator182.return();
              }

            case 25:
              _context30.prev = 25;

              if (!_didIteratorError182) {
                _context30.next = 28;
                break;
              }

              throw _iteratorError182;

            case 28:
              return _context30.finish(25);

            case 29:
              return _context30.finish(22);

            case 30:
            case "end":
              return _context30.stop();
          }
        }
      }, _marked2, null, [[7, 18, 22, 30], [23,, 25, 29]]);
    }

    var Qa =
    /*#__PURE__*/
    function () {
      function Qa() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";

        _classCallCheck(this, Qa);

        this.operations = [], this.type = t;
      }

      _createClass(Qa, [{
        key: "addOperation",
        value: function addOperation(t) {
          return t.batch = this, this.operations.push(t), t;
        }
      }, {
        key: "baseVersion",
        get: function get() {
          var _iteratorNormalCompletion183 = true;
          var _didIteratorError183 = false;
          var _iteratorError183 = undefined;

          try {
            for (var _iterator183 = this.operations[Symbol.iterator](), _step183; !(_iteratorNormalCompletion183 = (_step183 = _iterator183.next()).done); _iteratorNormalCompletion183 = true) {
              var _t151 = _step183.value;
              if (null !== _t151.baseVersion) return _t151.baseVersion;
            }
          } catch (err) {
            _didIteratorError183 = true;
            _iteratorError183 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion183 && _iterator183.return != null) {
                _iterator183.return();
              }
            } finally {
              if (_didIteratorError183) {
                throw _iteratorError183;
              }
            }
          }

          return null;
        }
      }]);

      return Qa;
    }();

    var Ja =
    /*#__PURE__*/
    function () {
      function Ja(t) {
        _classCallCheck(this, Ja);

        this.baseVersion = t, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
      }

      _createClass(Ja, [{
        key: "_validate",
        value: function _validate() {}
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = Object.assign({}, this);
          return t.__className = this.constructor.className, delete t.batch, delete t.isDocumentOperation, t;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new this(t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "Operation";
        }
      }]);

      return Ja;
    }();

    var Ka =
    /*#__PURE__*/
    function () {
      function Ka(t) {
        _classCallCheck(this, Ka);

        this.markers = new Map(), this._children = new Hs(), t && this._insertChild(0, t);
      }

      _createClass(Ka, [{
        key: Symbol.iterator,
        value: function value() {
          return this.getChildren();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "documentFragment" == t;
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "getPath",
        value: function getPath() {
          return [];
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;
          var _iteratorNormalCompletion184 = true;
          var _didIteratorError184 = false;
          var _iteratorError184 = undefined;

          try {
            for (var _iterator184 = t[Symbol.iterator](), _step184; !(_iteratorNormalCompletion184 = (_step184 = _iterator184.next()).done); _iteratorNormalCompletion184 = true) {
              var _n135 = _step184.value;
              e = e.getChild(e.offsetToIndex(_n135));
            }
          } catch (err) {
            _didIteratorError184 = true;
            _iteratorError184 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion184 && _iterator184.return != null) {
                _iterator184.return();
              }
            } finally {
              if (_didIteratorError184) {
                throw _iteratorError184;
              }
            }
          }

          return e;
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = [];
          var _iteratorNormalCompletion185 = true;
          var _didIteratorError185 = false;
          var _iteratorError185 = undefined;

          try {
            for (var _iterator185 = this._children[Symbol.iterator](), _step185; !(_iteratorNormalCompletion185 = (_step185 = _iterator185.next()).done); _iteratorNormalCompletion185 = true) {
              var _e139 = _step185.value;
              t.push(_e139.toJSON());
            }
          } catch (err) {
            _didIteratorError185 = true;
            _iteratorError185 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion185 && _iterator185.return != null) {
                _iterator185.return();
              }
            } finally {
              if (_didIteratorError185) {
                throw _iteratorError185;
              }
            }
          }

          return t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = function (t) {
            if ("string" == typeof t) return [new Fs(t)];
            gi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new Fs(t) : t instanceof Us ? new Fs(t.data, t.getAttributes()) : t;
            });
          }(e);

          var _iteratorNormalCompletion186 = true;
          var _didIteratorError186 = false;
          var _iteratorError186 = undefined;

          try {
            for (var _iterator186 = n[Symbol.iterator](), _step186; !(_iteratorNormalCompletion186 = (_step186 = _iterator186.next()).done); _iteratorNormalCompletion186 = true) {
              var _t152 = _step186.value;
              null !== _t152.parent && _t152._remove(), _t152.parent = this;
            }
          } catch (err) {
            _didIteratorError186 = true;
            _iteratorError186 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion186 && _iterator186.return != null) {
                _iterator186.return();
              }
            } finally {
              if (_didIteratorError186) {
                throw _iteratorError186;
              }
            }
          }

          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          var n = this._children._removeNodes(t, e);

          var _iteratorNormalCompletion187 = true;
          var _didIteratorError187 = false;
          var _iteratorError187 = undefined;

          try {
            for (var _iterator187 = n[Symbol.iterator](), _step187; !(_iteratorNormalCompletion187 = (_step187 = _iterator187.next()).done); _iteratorNormalCompletion187 = true) {
              var _t153 = _step187.value;
              _t153.parent = null;
            }
          } catch (err) {
            _didIteratorError187 = true;
            _iteratorError187 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion187 && _iterator187.return != null) {
                _iterator187.return();
              }
            } finally {
              if (_didIteratorError187) {
                throw _iteratorError187;
              }
            }
          }

          return n;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = [];
          var _iteratorNormalCompletion188 = true;
          var _didIteratorError188 = false;
          var _iteratorError188 = undefined;

          try {
            for (var _iterator188 = t[Symbol.iterator](), _step188; !(_iteratorNormalCompletion188 = (_step188 = _iterator188.next()).done); _iteratorNormalCompletion188 = true) {
              var _n136 = _step188.value;
              _n136.name ? e.push(qs.fromJSON(_n136)) : e.push(Fs.fromJSON(_n136));
            }
          } catch (err) {
            _didIteratorError188 = true;
            _iteratorError188 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion188 && _iterator188.return != null) {
                _iterator188.return();
              }
            } finally {
              if (_didIteratorError188) {
                throw _iteratorError188;
              }
            }
          }

          return new Ka(e);
        }
      }]);

      return Ka;
    }();

    function Za(t, e) {
      var n = (e = ec(e)).reduce(function (t, e) {
        return t + e.offsetSize;
      }, 0),
          i = t.parent;
      ic(t);
      var o = t.index;
      return i._insertChild(o, e), nc(i, o + e.length), nc(i, o), new Qs(t, t.getShiftedBy(n));
    }

    function Xa(t) {
      if (!t.isFlat) throw new Gn.b("operation-utils-remove-range-not-flat: Trying to remove a range which starts and ends in different element.", this);
      var e = t.start.parent;
      ic(t.start), ic(t.end);

      var n = e._removeChildren(t.start.index, t.end.index - t.start.index);

      return nc(e, t.start.index), n;
    }

    function tc(t, e) {
      if (!t.isFlat) throw new Gn.b("operation-utils-move-range-not-flat: Trying to move a range which starts and ends in different element.", this);
      var n = Xa(t);
      return Za(e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset), n);
    }

    function ec(t) {
      var e = [];
      t instanceof Array || (t = [t]);

      for (var _n137 = 0; _n137 < t.length; _n137++) {
        if ("string" == typeof t[_n137]) e.push(new Fs(t[_n137]));else if (t[_n137] instanceof Us) e.push(new Fs(t[_n137].data, t[_n137].getAttributes()));else if (t[_n137] instanceof Ka || t[_n137] instanceof Hs) {
          var _iteratorNormalCompletion189 = true;
          var _didIteratorError189 = false;
          var _iteratorError189 = undefined;

          try {
            for (var _iterator189 = t[_n137][Symbol.iterator](), _step189; !(_iteratorNormalCompletion189 = (_step189 = _iterator189.next()).done); _iteratorNormalCompletion189 = true) {
              var _i105 = _step189.value;
              e.push(_i105);
            }
          } catch (err) {
            _didIteratorError189 = true;
            _iteratorError189 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion189 && _iterator189.return != null) {
                _iterator189.return();
              }
            } finally {
              if (_didIteratorError189) {
                throw _iteratorError189;
              }
            }
          }
        } else t[_n137] instanceof zs && e.push(t[_n137]);
      }

      for (var _t154 = 1; _t154 < e.length; _t154++) {
        var _n138 = e[_t154],
            _i106 = e[_t154 - 1];
        _n138 instanceof Fs && _i106 instanceof Fs && oc(_n138, _i106) && (e.splice(_t154 - 1, 2, new Fs(_i106.data + _n138.data, _i106.getAttributes())), _t154--);
      }

      return e;
    }

    function nc(t, e) {
      var n = t.getChild(e - 1),
          i = t.getChild(e);

      if (n && i && n.is("text") && i.is("text") && oc(n, i)) {
        var _o38 = new Fs(n.data + i.data, n.getAttributes());

        t._removeChildren(e - 1, 2), t._insertChild(e - 1, _o38);
      }
    }

    function ic(t) {
      var e = t.textNode,
          n = t.parent;

      if (e) {
        var _i107 = t.offset - e.startOffset,
            _o39 = e.index;

        n._removeChildren(_o39, 1);

        var _r15 = new Fs(e.data.substr(0, _i107), e.getAttributes()),
            _s12 = new Fs(e.data.substr(_i107), e.getAttributes());

        n._insertChild(_o39, [_r15, _s12]);
      }
    }

    function oc(t, e) {
      var n = t.getAttributes(),
          i = e.getAttributes();
      var _iteratorNormalCompletion190 = true;
      var _didIteratorError190 = false;
      var _iteratorError190 = undefined;

      try {
        for (var _iterator190 = n[Symbol.iterator](), _step190; !(_iteratorNormalCompletion190 = (_step190 = _iterator190.next()).done); _iteratorNormalCompletion190 = true) {
          var _t155 = _step190.value;
          if (_t155[1] !== e.getAttribute(_t155[0])) return !1;
          i.next();
        }
      } catch (err) {
        _didIteratorError190 = true;
        _iteratorError190 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion190 && _iterator190.return != null) {
            _iterator190.return();
          }
        } finally {
          if (_didIteratorError190) {
            throw _iteratorError190;
          }
        }
      }

      return i.next().done;
    }

    var rc = function rc(t, e) {
      return Jr(t, e);
    };

    var sc =
    /*#__PURE__*/
    function (_Ja) {
      _inherits(sc, _Ja);

      function sc(t, e, n, i, o) {
        var _this54;

        _classCallCheck(this, sc);

        _this54 = _possibleConstructorReturn(this, _getPrototypeOf(sc).call(this, o)), _this54.range = t.clone(), _this54.key = e, _this54.oldValue = void 0 === n ? null : n, _this54.newValue = void 0 === i ? null : i;
        return _this54;
      }

      _createClass(sc, [{
        key: "clone",
        value: function clone() {
          return new sc(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new sc(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(sc.prototype), "toJSON", this).call(this);

          return t.range = this.range.toJSON(), t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (!this.range.isFlat) throw new Gn.b("attribute-operation-range-not-flat: The range to change is not flat.", this);
          var _iteratorNormalCompletion191 = true;
          var _didIteratorError191 = false;
          var _iteratorError191 = undefined;

          try {
            for (var _iterator191 = this.range.getItems({
              shallow: !0
            })[Symbol.iterator](), _step191; !(_iteratorNormalCompletion191 = (_step191 = _iterator191.next()).done); _iteratorNormalCompletion191 = true) {
              var _t156 = _step191.value;
              if (null !== this.oldValue && !rc(_t156.getAttribute(this.key), this.oldValue)) throw new Gn.b("attribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.", this, {
                item: _t156,
                key: this.key,
                value: this.oldValue
              });
              if (null === this.oldValue && null !== this.newValue && _t156.hasAttribute(this.key)) throw new Gn.b("attribute-operation-attribute-exists: The attribute with given key already exists.", this, {
                node: _t156,
                key: this.key
              });
            }
          } catch (err) {
            _didIteratorError191 = true;
            _iteratorError191 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion191 && _iterator191.return != null) {
                _iterator191.return();
              }
            } finally {
              if (_didIteratorError191) {
                throw _iteratorError191;
              }
            }
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          rc(this.oldValue, this.newValue) || function (t, e, n) {
            ic(t.start), ic(t.end);
            var _iteratorNormalCompletion192 = true;
            var _didIteratorError192 = false;
            var _iteratorError192 = undefined;

            try {
              for (var _iterator192 = t.getItems({
                shallow: !0
              })[Symbol.iterator](), _step192; !(_iteratorNormalCompletion192 = (_step192 = _iterator192.next()).done); _iteratorNormalCompletion192 = true) {
                var _i108 = _step192.value;

                var _t157 = _i108.is("textProxy") ? _i108.textNode : _i108;

                null !== n ? _t157._setAttribute(e, n) : _t157._removeAttribute(e), nc(_t157.parent, _t157.index);
              }
            } catch (err) {
              _didIteratorError192 = true;
              _iteratorError192 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion192 && _iterator192.return != null) {
                  _iterator192.return();
                }
              } finally {
                if (_didIteratorError192) {
                  throw _iteratorError192;
                }
              }
            }

            nc(t.end.parent, t.end.index);
          }(this.range, this.key, this.newValue);
        }
      }, {
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new sc(Qs.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "AttributeOperation";
        }
      }]);

      return sc;
    }(Ja);

    var ac =
    /*#__PURE__*/
    function (_Ja2) {
      _inherits(ac, _Ja2);

      function ac(t, e) {
        var _this55;

        _classCallCheck(this, ac);

        _this55 = _possibleConstructorReturn(this, _getPrototypeOf(ac).call(this, null)), _this55.sourcePosition = t.clone(), _this55.howMany = e;
        return _this55;
      }

      _createClass(ac, [{
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(ac.prototype), "toJSON", this).call(this);

          return t.sourcePosition = this.sourcePosition.toJSON(), t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.sourcePosition.root.document) throw new Gn.b("detach-operation-on-document-node: Cannot detach document node.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          Xa(Qs._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
      }, {
        key: "type",
        get: function get() {
          return "detach";
        }
      }], [{
        key: "className",
        get: function get() {
          return "DetachOperation";
        }
      }]);

      return ac;
    }(Ja);

    var cc =
    /*#__PURE__*/
    function (_Ja3) {
      _inherits(cc, _Ja3);

      function cc(t, e, n, i) {
        var _this56;

        _classCallCheck(this, cc);

        _this56 = _possibleConstructorReturn(this, _getPrototypeOf(cc).call(this, i)), _this56.sourcePosition = t.clone(), _this56.sourcePosition.stickiness = "toNext", _this56.howMany = e, _this56.targetPosition = n.clone(), _this56.targetPosition.stickiness = "toNone";
        return _this56;
      }

      _createClass(cc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
        }
      }, {
        key: "getMovedRangeStart",
        value: function getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);

          return new this.constructor(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent,
              e = this.targetPosition.parent,
              n = this.sourcePosition.offset,
              i = this.targetPosition.offset;
          if (!t || !e) throw new Gn.b("move-operation-position-invalid: Source position or target position is invalid.", this);
          if (n + this.howMany > t.maxOffset) throw new Gn.b("move-operation-nodes-do-not-exist: The nodes which should be moved do not exist.", this);
          if (t === e && n < i && i < n + this.howMany) throw new Gn.b("move-operation-range-into-itself: Trying to move a range of nodes to the inside of that range.", this);

          if (this.sourcePosition.root == this.targetPosition.root && "prefix" == li(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
            var _t158 = this.sourcePosition.path.length - 1;

            if (this.targetPosition.path[_t158] >= n && this.targetPosition.path[_t158] < n + this.howMany) throw new Gn.b("move-operation-node-into-itself: Trying to move a range of nodes into one of nodes from that range.", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          tc(Qs._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(cc.prototype), "toJSON", this).call(this);

          return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Gs.fromJSON(t.sourcePosition, e),
              i = Gs.fromJSON(t.targetPosition, e);
          return new this(n, t.howMany, i, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MoveOperation";
        }
      }]);

      return cc;
    }(Ja);

    var lc =
    /*#__PURE__*/
    function (_Ja4) {
      _inherits(lc, _Ja4);

      function lc(t, e, n) {
        var _this57;

        _classCallCheck(this, lc);

        _this57 = _possibleConstructorReturn(this, _getPrototypeOf(lc).call(this, n)), _this57.position = t.clone(), _this57.position.stickiness = "toNone", _this57.nodes = new Hs(ec(e)), _this57.shouldReceiveAttributes = !1;
        return _this57;
      }

      _createClass(lc, [{
        key: "clone",
        value: function clone() {
          var t = new Hs(_toConsumableArray(this.nodes).map(function (t) {
            return t._clone(!0);
          })),
              e = new lc(this.position, t, this.baseVersion);
          return e.shouldReceiveAttributes = this.shouldReceiveAttributes, e;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.position.root.document.graveyard,
              e = new Gs(t, [0]);
          return new cc(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.parent;
          if (!t || t.maxOffset < this.position.offset) throw new Gn.b("insert-operation-position-invalid: Insertion position is invalid.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.nodes;
          this.nodes = new Hs(_toConsumableArray(t).map(function (t) {
            return t._clone(!0);
          })), Za(this.position, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(lc.prototype), "toJSON", this).call(this);

          return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "insert";
        }
      }, {
        key: "howMany",
        get: function get() {
          return this.nodes.maxOffset;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = [];
          var _iteratorNormalCompletion193 = true;
          var _didIteratorError193 = false;
          var _iteratorError193 = undefined;

          try {
            for (var _iterator193 = t.nodes[Symbol.iterator](), _step193; !(_iteratorNormalCompletion193 = (_step193 = _iterator193.next()).done); _iteratorNormalCompletion193 = true) {
              var _e140 = _step193.value;
              _e140.name ? n.push(qs.fromJSON(_e140)) : n.push(Fs.fromJSON(_e140));
            }
          } catch (err) {
            _didIteratorError193 = true;
            _iteratorError193 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion193 && _iterator193.return != null) {
                _iterator193.return();
              }
            } finally {
              if (_didIteratorError193) {
                throw _iteratorError193;
              }
            }
          }

          var i = new lc(Gs.fromJSON(t.position, e), n, t.baseVersion);
          return i.shouldReceiveAttributes = t.shouldReceiveAttributes, i;
        }
      }, {
        key: "className",
        get: function get() {
          return "InsertOperation";
        }
      }]);

      return lc;
    }(Ja);

    var dc =
    /*#__PURE__*/
    function (_Ja5) {
      _inherits(dc, _Ja5);

      function dc(t, e, n, i, o, r) {
        var _this58;

        _classCallCheck(this, dc);

        _this58 = _possibleConstructorReturn(this, _getPrototypeOf(dc).call(this, r)), _this58.name = t, _this58.oldRange = e ? e.clone() : null, _this58.newRange = n ? n.clone() : null, _this58.affectsData = o, _this58._markers = i;
        return _this58;
      }

      _createClass(dc, [{
        key: "clone",
        value: function clone() {
          return new dc(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new dc(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.newRange ? "_set" : "_remove";

          this._markers[t](this.name, this.newRange, !0, this.affectsData);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(dc.prototype), "toJSON", this).call(this);

          return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
        }
      }, {
        key: "type",
        get: function get() {
          return "marker";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new dc(t.name, t.oldRange ? Qs.fromJSON(t.oldRange, e) : null, t.newRange ? Qs.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MarkerOperation";
        }
      }]);

      return dc;
    }(Ja);

    var uc =
    /*#__PURE__*/
    function (_Ja6) {
      _inherits(uc, _Ja6);

      function uc(t, e, n, i) {
        var _this59;

        _classCallCheck(this, uc);

        _this59 = _possibleConstructorReturn(this, _getPrototypeOf(uc).call(this, i)), _this59.position = t, _this59.position.stickiness = "toNext", _this59.oldName = e, _this59.newName = n;
        return _this59;
      }

      _createClass(uc, [{
        key: "clone",
        value: function clone() {
          return new uc(this.position.clone(), this.oldName, this.newName, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new uc(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.nodeAfter;
          if (!(t instanceof qs)) throw new Gn.b("rename-operation-wrong-position: Given position is invalid or node after it is not an instance of Element.", this);
          if (t.name !== this.oldName) throw new Gn.b("rename-operation-wrong-name: Element to change has different name than operation's old name.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          this.position.nodeAfter.name = this.newName;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(uc.prototype), "toJSON", this).call(this);

          return t.position = this.position.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "rename";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new uc(Gs.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RenameOperation";
        }
      }]);

      return uc;
    }(Ja);

    var hc =
    /*#__PURE__*/
    function (_Ja7) {
      _inherits(hc, _Ja7);

      function hc(t, e, n, i, o) {
        var _this60;

        _classCallCheck(this, hc);

        _this60 = _possibleConstructorReturn(this, _getPrototypeOf(hc).call(this, o)), _this60.root = t, _this60.key = e, _this60.oldValue = n, _this60.newValue = i;
        return _this60;
      }

      _createClass(hc, [{
        key: "clone",
        value: function clone() {
          return new hc(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new hc(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.root != this.root.root || this.root.is("documentFragment")) throw new Gn.b("rootattribute-operation-not-a-root: The element to change is not a root element.", this, {
            root: this.root,
            key: this.key
          });
          if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new Gn.b("rootattribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.", this, {
            root: this.root,
            key: this.key
          });
          if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new Gn.b("rootattribute-operation-attribute-exists: The attribute with given key already exists.", this, {
            root: this.root,
            key: this.key
          });
        }
      }, {
        key: "_execute",
        value: function _execute() {
          null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(hc.prototype), "toJSON", this).call(this);

          return t.root = this.root.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if (!e.getRoot(t.root)) throw new Gn.b("rootattribute-operation-fromjson-no-root: Cannot create RootAttributeOperation. Root with specified name does not exist.", this, {
            rootName: t.root
          });
          return new hc(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RootAttributeOperation";
        }
      }]);

      return hc;
    }(Ja);

    var fc =
    /*#__PURE__*/
    function (_Ja8) {
      _inherits(fc, _Ja8);

      function fc(t, e, n, i, o) {
        var _this61;

        _classCallCheck(this, fc);

        _this61 = _possibleConstructorReturn(this, _getPrototypeOf(fc).call(this, o)), _this61.sourcePosition = t.clone(), _this61.sourcePosition.stickiness = "toPrevious", _this61.howMany = e, _this61.targetPosition = n.clone(), _this61.targetPosition.stickiness = "toNext", _this61.graveyardPosition = i.clone();
        return _this61;
      }

      _createClass(fc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.targetPosition._getTransformedByMergeOperation(this),
              e = this.sourcePosition.path.slice(0, -1),
              n = new Gs(this.sourcePosition.root, e)._getTransformedByMergeOperation(this),
              i = new mc(t, this.howMany, this.graveyardPosition, this.baseVersion + 1);

          return i.insertionPosition = n, i;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent,
              e = this.targetPosition.parent;
          if (!(t && t.is("element") && t.parent)) throw new Gn.b("merge-operation-source-position-invalid: Merge source position is invalid.", this);
          if (!(e && e.is("element") && e.parent)) throw new Gn.b("merge-operation-target-position-invalid: Merge target position is invalid.", this);
          if (this.howMany != t.maxOffset) throw new Gn.b("merge-operation-how-many-invalid: Merge operation specifies wrong number of nodes to move.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.sourcePosition.parent;
          tc(Qs._createIn(t), this.targetPosition), tc(Qs._createOn(t), this.graveyardPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(fc.prototype), "toJSON", this).call(this);

          return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "merge";
        }
      }, {
        key: "deletionPosition",
        get: function get() {
          return new Gs(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new Qs(this.sourcePosition, t);
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Gs.fromJSON(t.sourcePosition, e),
              i = Gs.fromJSON(t.targetPosition, e),
              o = Gs.fromJSON(t.graveyardPosition, e);
          return new this(n, t.howMany, i, o, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MergeOperation";
        }
      }]);

      return fc;
    }(Ja);

    var mc =
    /*#__PURE__*/
    function (_Ja9) {
      _inherits(mc, _Ja9);

      function mc(t, e, n, i) {
        var _this62;

        _classCallCheck(this, mc);

        _this62 = _possibleConstructorReturn(this, _getPrototypeOf(mc).call(this, i)), _this62.splitPosition = t.clone(), _this62.splitPosition.stickiness = "toNext", _this62.howMany = e, _this62.insertionPosition = mc.getInsertionPosition(t), _this62.insertionPosition.stickiness = "toNone", _this62.graveyardPosition = n ? n.clone() : null, _this62.graveyardPosition && (_this62.graveyardPosition.stickiness = "toNext");
        return _this62;
      }

      _createClass(mc, [{
        key: "clone",
        value: function clone() {
          var t = new this.constructor(this.splitPosition, this.howMany, this.graveyardPosition, this.baseVersion);
          return t.insertionPosition = this.insertionPosition, t;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.splitPosition.root.document.graveyard,
              e = new Gs(t, [0]);
          return new fc(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.splitPosition.parent,
              e = this.splitPosition.offset;
          if (!t || t.maxOffset < e) throw new Gn.b("split-operation-position-invalid: Split position is invalid.", this);
          if (!t.parent) throw new Gn.b("split-operation-split-in-root: Cannot split root element.", this);
          if (this.howMany != t.maxOffset - this.splitPosition.offset) throw new Gn.b("split-operation-how-many-invalid: Split operation specifies wrong number of nodes to move.", this);
          if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new Gn.b("split-operation-graveyard-position-invalid: Graveyard position invalid.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.splitPosition.parent;
          if (this.graveyardPosition) tc(Qs._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
            var _e141 = t._clone();

            Za(this.insertionPosition, _e141);
          }
          tc(new Qs(Gs._createAt(t, this.splitPosition.offset), Gs._createAt(t, t.maxOffset)), this.moveTargetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(mc.prototype), "toJSON", this).call(this);

          return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "split";
        }
      }, {
        key: "moveTargetPosition",
        get: function get() {
          var t = this.insertionPosition.path.slice();
          return t.push(0), new Gs(this.insertionPosition.root, t);
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new Qs(this.splitPosition, t);
        }
      }], [{
        key: "getInsertionPosition",
        value: function getInsertionPosition(t) {
          var e = t.path.slice(0, -1);
          return e[e.length - 1]++, new Gs(t.root, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Gs.fromJSON(t.splitPosition, e),
              i = Gs.fromJSON(t.insertionPosition, e),
              o = t.graveyardPosition ? Gs.fromJSON(t.graveyardPosition, e) : null,
              r = new this(n, t.howMany, o, t.baseVersion);
          return r.insertionPosition = i, r;
        }
      }, {
        key: "className",
        get: function get() {
          return "SplitOperation";
        }
      }]);

      return mc;
    }(Ja);

    var pc =
    /*#__PURE__*/
    function (_qs) {
      _inherits(pc, _qs);

      function pc(t, e) {
        var _this63;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";

        _classCallCheck(this, pc);

        _this63 = _possibleConstructorReturn(this, _getPrototypeOf(pc).call(this, e)), _this63._doc = t, _this63.rootName = n;
        return _this63;
      }

      _createClass(pc, [{
        key: "is",
        value: function is(t, e) {
          return e ? "rootElement" == t && e == this.name || _get(_getPrototypeOf(pc.prototype), "is", this).call(this, t, e) : "rootElement" == t || _get(_getPrototypeOf(pc.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this.rootName;
        }
      }, {
        key: "document",
        get: function get() {
          return this._doc;
        }
      }]);

      return pc;
    }(qs);

    var gc =
    /*#__PURE__*/
    function () {
      function gc(t, e) {
        _classCallCheck(this, gc);

        this.model = t, this.batch = e;
      }

      _createClass(gc, [{
        key: "createText",
        value: function createText(t, e) {
          return new Fs(t, e);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e) {
          return new qs(t, e);
        }
      }, {
        key: "createDocumentFragment",
        value: function createDocumentFragment() {
          return new Ka();
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          if (this._assertWriterUsedCorrectly(), t instanceof Fs && "" == t.data) return;

          var i = Gs._createAt(e, n);

          if (t.parent) {
            if (vc(t.root, i.root)) return void this.move(Qs._createOn(t), i);
            if (t.root.document) throw new Gn.b("model-writer-insert-forbidden-move: Cannot move a node from a document to a different tree. It is forbidden to move a node that was already in a document outside of it.", this);
            this.remove(t);
          }

          var o = i.root.document ? i.root.document.version : null,
              r = new lc(i, t, o);

          if (t instanceof Fs && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), t instanceof Ka) {
            var _iteratorNormalCompletion194 = true;
            var _didIteratorError194 = false;
            var _iteratorError194 = undefined;

            try {
              for (var _iterator194 = t.markers[Symbol.iterator](), _step194; !(_iteratorNormalCompletion194 = (_step194 = _iterator194.next()).done); _iteratorNormalCompletion194 = true) {
                var _ref57 = _step194.value;

                var _ref56 = _slicedToArray(_ref57, 2);

                var _e142 = _ref56[0];
                var _n139 = _ref56[1];

                var _t159 = Gs._createAt(_n139.root, 0),
                    _o40 = {
                  range: new Qs(_n139.start._getCombined(_t159, i), _n139.end._getCombined(_t159, i)),
                  usingOperation: !0,
                  affectsData: !0
                };

                this.model.markers.has(_e142) ? this.updateMarker(_e142, _o40) : this.addMarker(_e142, _o40);
              }
            } catch (err) {
              _didIteratorError194 = true;
              _iteratorError194 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion194 && _iterator194.return != null) {
                  _iterator194.return();
                }
              } finally {
                if (_didIteratorError194) {
                  throw _iteratorError194;
                }
              }
            }
          }
        }
      }, {
        key: "insertText",
        value: function insertText(t, e, n, i) {
          e instanceof Ka || e instanceof qs || e instanceof Gs ? this.insert(this.createText(t), e, n) : this.insert(this.createText(t, e), n, i);
        }
      }, {
        key: "insertElement",
        value: function insertElement(t, e, n, i) {
          e instanceof Ka || e instanceof qs || e instanceof Gs ? this.insert(this.createElement(t), e, n) : this.insert(this.createElement(t, e), n, i);
        }
      }, {
        key: "append",
        value: function append(t, e) {
          this.insert(t, e, "end");
        }
      }, {
        key: "appendText",
        value: function appendText(t, e, n) {
          e instanceof Ka || e instanceof qs ? this.insert(this.createText(t), e, "end") : this.insert(this.createText(t, e), n, "end");
        }
      }, {
        key: "appendElement",
        value: function appendElement(t, e, n) {
          e instanceof Ka || e instanceof qs ? this.insert(this.createElement(t), e, "end") : this.insert(this.createElement(t, e), n, "end");
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          if (this._assertWriterUsedCorrectly(), n instanceof Qs) {
            var _i109 = n.getMinimalFlatRanges();

            var _iteratorNormalCompletion195 = true;
            var _didIteratorError195 = false;
            var _iteratorError195 = undefined;

            try {
              for (var _iterator195 = _i109[Symbol.iterator](), _step195; !(_iteratorNormalCompletion195 = (_step195 = _iterator195.next()).done); _iteratorNormalCompletion195 = true) {
                var _n140 = _step195.value;
                bc(this, t, e, _n140);
              }
            } catch (err) {
              _didIteratorError195 = true;
              _iteratorError195 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion195 && _iterator195.return != null) {
                  _iterator195.return();
                }
              } finally {
                if (_didIteratorError195) {
                  throw _iteratorError195;
                }
              }
            }
          } else wc(this, t, e, n);
        }
      }, {
        key: "setAttributes",
        value: function setAttributes(t, e) {
          var _iteratorNormalCompletion196 = true;
          var _didIteratorError196 = false;
          var _iteratorError196 = undefined;

          try {
            for (var _iterator196 = Bs(t)[Symbol.iterator](), _step196; !(_iteratorNormalCompletion196 = (_step196 = _iterator196.next()).done); _iteratorNormalCompletion196 = true) {
              var _ref60 = _step196.value;

              var _ref59 = _slicedToArray(_ref60, 2);

              var _n141 = _ref59[0];
              var _i110 = _ref59[1];
              this.setAttribute(_n141, _i110, e);
            }
          } catch (err) {
            _didIteratorError196 = true;
            _iteratorError196 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion196 && _iterator196.return != null) {
                _iterator196.return();
              }
            } finally {
              if (_didIteratorError196) {
                throw _iteratorError196;
              }
            }
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          if (this._assertWriterUsedCorrectly(), e instanceof Qs) {
            var _n142 = e.getMinimalFlatRanges();

            var _iteratorNormalCompletion197 = true;
            var _didIteratorError197 = false;
            var _iteratorError197 = undefined;

            try {
              for (var _iterator197 = _n142[Symbol.iterator](), _step197; !(_iteratorNormalCompletion197 = (_step197 = _iterator197.next()).done); _iteratorNormalCompletion197 = true) {
                var _e143 = _step197.value;
                bc(this, t, null, _e143);
              }
            } catch (err) {
              _didIteratorError197 = true;
              _iteratorError197 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion197 && _iterator197.return != null) {
                  _iterator197.return();
                }
              } finally {
                if (_didIteratorError197) {
                  throw _iteratorError197;
                }
              }
            }
          } else wc(this, t, null, e);
        }
      }, {
        key: "clearAttributes",
        value: function clearAttributes(t) {
          var _this64 = this;

          this._assertWriterUsedCorrectly();

          var e = function e(t) {
            var _iteratorNormalCompletion198 = true;
            var _didIteratorError198 = false;
            var _iteratorError198 = undefined;

            try {
              for (var _iterator198 = t.getAttributeKeys()[Symbol.iterator](), _step198; !(_iteratorNormalCompletion198 = (_step198 = _iterator198.next()).done); _iteratorNormalCompletion198 = true) {
                var _e144 = _step198.value;

                _this64.removeAttribute(_e144, t);
              }
            } catch (err) {
              _didIteratorError198 = true;
              _iteratorError198 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion198 && _iterator198.return != null) {
                  _iterator198.return();
                }
              } finally {
                if (_didIteratorError198) {
                  throw _iteratorError198;
                }
              }
            }
          };

          if (t instanceof Qs) {
            var _iteratorNormalCompletion199 = true;
            var _didIteratorError199 = false;
            var _iteratorError199 = undefined;

            try {
              for (var _iterator199 = t.getItems()[Symbol.iterator](), _step199; !(_iteratorNormalCompletion199 = (_step199 = _iterator199.next()).done); _iteratorNormalCompletion199 = true) {
                var _n143 = _step199.value;
                e(_n143);
              }
            } catch (err) {
              _didIteratorError199 = true;
              _iteratorError199 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion199 && _iterator199.return != null) {
                  _iterator199.return();
                }
              } finally {
                if (_didIteratorError199) {
                  throw _iteratorError199;
                }
              }
            }
          } else e(t);
        }
      }, {
        key: "move",
        value: function move(t, e, n) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof Qs)) throw new Gn.b("writer-move-invalid-range: Invalid range to move.", this);
          if (!t.isFlat) throw new Gn.b("writer-move-range-not-flat: Range to move is not flat.", this);

          var i = Gs._createAt(e, n);

          if (i.isEqual(t.start)) return;
          if (this._addOperationForAffectedMarkers("move", t), !vc(t.root, i.root)) throw new Gn.b("writer-move-different-document: Range is going to be moved between different documents.", this);
          var o = t.root.document ? t.root.document.version : null,
              r = new cc(t.start, t.end.offset - t.start.offset, i, o);
          this.batch.addOperation(r), this.model.applyOperation(r);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._assertWriterUsedCorrectly();

          var e = (t instanceof Qs ? t : Qs._createOn(t)).getMinimalFlatRanges().reverse();
          var _iteratorNormalCompletion200 = true;
          var _didIteratorError200 = false;
          var _iteratorError200 = undefined;

          try {
            for (var _iterator200 = e[Symbol.iterator](), _step200; !(_iteratorNormalCompletion200 = (_step200 = _iterator200.next()).done); _iteratorNormalCompletion200 = true) {
              var _t160 = _step200.value;
              this._addOperationForAffectedMarkers("move", _t160), kc(_t160.start, _t160.end.offset - _t160.start.offset, this.batch, this.model);
            }
          } catch (err) {
            _didIteratorError200 = true;
            _iteratorError200 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion200 && _iterator200.return != null) {
                _iterator200.return();
              }
            } finally {
              if (_didIteratorError200) {
                throw _iteratorError200;
              }
            }
          }
        }
      }, {
        key: "merge",
        value: function merge(t) {
          this._assertWriterUsedCorrectly();

          var e = t.nodeBefore,
              n = t.nodeAfter;
          if (this._addOperationForAffectedMarkers("merge", t), !(e instanceof qs)) throw new Gn.b("writer-merge-no-element-before: Node before merge position must be an element.", this);
          if (!(n instanceof qs)) throw new Gn.b("writer-merge-no-element-after: Node after merge position must be an element.", this);
          t.root.document ? this._merge(t) : this._mergeDetached(t);
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return this.model.createPositionFromPath(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return this.model.createPositionAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return this.model.createPositionAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return this.model.createPositionBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return this.model.createRange(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return this.model.createRangeIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return this.model.createRangeOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return this.model.createSelection(t, e, n);
        }
      }, {
        key: "_mergeDetached",
        value: function _mergeDetached(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          this.move(Qs._createIn(n), Gs._createAt(e, "end")), this.remove(n);
        }
      }, {
        key: "_merge",
        value: function _merge(t) {
          var e = Gs._createAt(t.nodeBefore, "end"),
              n = Gs._createAt(t.nodeAfter, 0),
              i = t.root.document.graveyard,
              o = new Gs(i, [0]),
              r = t.root.document.version,
              s = new fc(n, t.nodeAfter.maxOffset, e, o, r);

          this.batch.addOperation(s), this.model.applyOperation(s);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof qs)) throw new Gn.b("writer-rename-not-element-instance: Trying to rename an object which is not an instance of Element.", this);
          var n = t.root.document ? t.root.document.version : null,
              i = new uc(Gs._createBefore(t), t.name, e, n);
          this.batch.addOperation(i), this.model.applyOperation(i);
        }
      }, {
        key: "split",
        value: function split(t, e) {
          this._assertWriterUsedCorrectly();

          var n,
              i,
              o = t.parent;
          if (!o.parent) throw new Gn.b("writer-split-element-no-parent: Element with no parent can not be split.", this);
          if (e || (e = o.parent), !t.parent.getAncestors({
            includeSelf: !0
          }).includes(e)) throw new Gn.b("writer-split-invalid-limit-element: Limit element is not a position ancestor.", this);

          do {
            var _e145 = o.root.document ? o.root.document.version : null,
                _r16 = o.maxOffset - t.offset,
                _s13 = new mc(t, _r16, null, _e145);

            this.batch.addOperation(_s13), this.model.applyOperation(_s13), n || i || (n = o, i = t.parent.nextSibling), o = (t = this.createPositionAfter(t.parent)).parent;
          } while (o !== e);

          return {
            position: t,
            range: new Qs(Gs._createAt(n, "end"), Gs._createAt(i, 0))
          };
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (this._assertWriterUsedCorrectly(), !t.isFlat) throw new Gn.b("writer-wrap-range-not-flat: Range to wrap is not flat.", this);
          var n = e instanceof qs ? e : new qs(e);
          if (n.childCount > 0) throw new Gn.b("writer-wrap-element-not-empty: Element to wrap with is not empty.", this);
          if (null !== n.parent) throw new Gn.b("writer-wrap-element-attached: Element to wrap with is already attached to tree model.", this);
          this.insert(n, t.start);
          var i = new Qs(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
          this.move(i, Gs._createAt(n, 0));
        }
      }, {
        key: "unwrap",
        value: function unwrap(t) {
          if (this._assertWriterUsedCorrectly(), null === t.parent) throw new Gn.b("writer-unwrap-element-no-parent: Trying to unwrap an element which has no parent.", this);
          this.move(Qs._createIn(t), this.createPositionAfter(t)), this.remove(t);
        }
      }, {
        key: "addMarker",
        value: function addMarker(t, e) {
          if (this._assertWriterUsedCorrectly(), !e || "boolean" != typeof e.usingOperation) throw new Gn.b("writer-addMarker-no-usingOperation: The options.usingOperation parameter is required when adding a new marker.", this);
          var n = e.usingOperation,
              i = e.range,
              o = void 0 !== e.affectsData && e.affectsData;
          if (this.model.markers.has(t)) throw new Gn.b("writer-addMarker-marker-exists: Marker with provided name already exists.", this);
          if (!i) throw new Gn.b("writer-addMarker-no-range: Range parameter is required when adding a new marker.", this);
          return n ? (_c(this, t, null, i, o), this.model.markers.get(t)) : this.model.markers._set(t, i, n, o);
        }
      }, {
        key: "updateMarker",
        value: function updateMarker(t, e) {
          this._assertWriterUsedCorrectly();

          var n = "string" == typeof t ? t : t.name,
              i = this.model.markers.get(n);
          if (!i) throw new Gn.b("writer-updateMarker-marker-not-exists: Marker with provided name does not exists.", this);
          if (!e) return void this.model.markers._refresh(i);
          var o = "boolean" == typeof e.usingOperation,
              r = "boolean" == typeof e.affectsData,
              s = r ? e.affectsData : i.affectsData;
          if (!o && !e.range && !r) throw new Gn.b("writer-updateMarker-wrong-options: One of the options is required - provide range, usingOperations or affectsData.", this);
          var a = i.getRange(),
              c = e.range ? e.range : a;
          o && e.usingOperation !== i.managedUsingOperations ? e.usingOperation ? _c(this, n, null, c, s) : (_c(this, n, a, null, s), this.model.markers._set(n, c, void 0, s)) : i.managedUsingOperations ? _c(this, n, a, c, s) : this.model.markers._set(n, c, void 0, s);
        }
      }, {
        key: "removeMarker",
        value: function removeMarker(t) {
          this._assertWriterUsedCorrectly();

          var e = "string" == typeof t ? t : t.name;
          if (!this.model.markers.has(e)) throw new Gn.b("writer-removeMarker-no-marker: Trying to remove marker which does not exist.", this);
          var n = this.model.markers.get(e);
          n.managedUsingOperations ? _c(this, e, n.getRange(), null, n.affectsData) : this.model.markers._remove(e);
        }
      }, {
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t, e);
        }
      }, {
        key: "setSelectionAttribute",
        value: function setSelectionAttribute(t, e) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._setSelectionAttribute(t, e);else {
            var _iteratorNormalCompletion201 = true;
            var _didIteratorError201 = false;
            var _iteratorError201 = undefined;

            try {
              for (var _iterator201 = Bs(t)[Symbol.iterator](), _step201; !(_iteratorNormalCompletion201 = (_step201 = _iterator201.next()).done); _iteratorNormalCompletion201 = true) {
                var _ref63 = _step201.value;

                var _ref62 = _slicedToArray(_ref63, 2);

                var _e146 = _ref62[0];
                var _n144 = _ref62[1];

                this._setSelectionAttribute(_e146, _n144);
              }
            } catch (err) {
              _didIteratorError201 = true;
              _iteratorError201 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion201 && _iterator201.return != null) {
                  _iterator201.return();
                }
              } finally {
                if (_didIteratorError201) {
                  throw _iteratorError201;
                }
              }
            }
          }
        }
      }, {
        key: "removeSelectionAttribute",
        value: function removeSelectionAttribute(t) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._removeSelectionAttribute(t);else {
            var _iteratorNormalCompletion202 = true;
            var _didIteratorError202 = false;
            var _iteratorError202 = undefined;

            try {
              for (var _iterator202 = t[Symbol.iterator](), _step202; !(_iteratorNormalCompletion202 = (_step202 = _iterator202.next()).done); _iteratorNormalCompletion202 = true) {
                var _e147 = _step202.value;

                this._removeSelectionAttribute(_e147);
              }
            } catch (err) {
              _didIteratorError202 = true;
              _iteratorError202 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion202 && _iterator202.return != null) {
                  _iterator202.return();
                }
              } finally {
                if (_didIteratorError202) {
                  throw _iteratorError202;
                }
              }
            }
          }
        }
      }, {
        key: "overrideSelectionGravity",
        value: function overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
      }, {
        key: "restoreSelectionGravity",
        value: function restoreSelectionGravity(t) {
          this.model.document.selection._restoreGravity(t);
        }
      }, {
        key: "_setSelectionAttribute",
        value: function _setSelectionAttribute(t, e) {
          var n = this.model.document.selection;

          if (n.isCollapsed && n.anchor.parent.isEmpty) {
            var _i111 = aa._getStoreAttributeKey(t);

            this.setAttribute(_i111, e, n.anchor.parent);
          }

          n._setAttribute(t, e);
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute(t) {
          var e = this.model.document.selection;

          if (e.isCollapsed && e.anchor.parent.isEmpty) {
            var _n145 = aa._getStoreAttributeKey(t);

            this.removeAttribute(_n145, e.anchor.parent);
          }

          e._removeAttribute(t);
        }
      }, {
        key: "_assertWriterUsedCorrectly",
        value: function _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this) throw new Gn.b("writer-incorrect-use: Trying to use a writer outside the change() block.", this);
        }
      }, {
        key: "_addOperationForAffectedMarkers",
        value: function _addOperationForAffectedMarkers(t, e) {
          var _iteratorNormalCompletion203 = true;
          var _didIteratorError203 = false;
          var _iteratorError203 = undefined;

          try {
            for (var _iterator203 = this.model.markers[Symbol.iterator](), _step203; !(_iteratorNormalCompletion203 = (_step203 = _iterator203.next()).done); _iteratorNormalCompletion203 = true) {
              var _n146 = _step203.value;
              if (!_n146.managedUsingOperations) continue;

              var _i112 = _n146.getRange();

              var _o41 = !1;

              if ("move" == t) _o41 = e.containsPosition(_i112.start) || e.start.isEqual(_i112.start) || e.containsPosition(_i112.end) || e.end.isEqual(_i112.end);else {
                var _t161 = e.nodeBefore,
                    _n147 = e.nodeAfter,
                    _r17 = _i112.start.parent == _t161 && _i112.start.isAtEnd,
                    _s14 = _i112.end.parent == _n147 && 0 == _i112.end.offset,
                    _a8 = _i112.end.nodeAfter == _n147,
                    _c3 = _i112.start.nodeAfter == _n147;

                _o41 = _r17 || _s14 || _a8 || _c3;
              }
              _o41 && this.updateMarker(_n146.name, {
                range: _i112
              });
            }
          } catch (err) {
            _didIteratorError203 = true;
            _iteratorError203 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion203 && _iterator203.return != null) {
                _iterator203.return();
              }
            } finally {
              if (_didIteratorError203) {
                throw _iteratorError203;
              }
            }
          }
        }
      }]);

      return gc;
    }();

    function bc(t, e, n, i) {
      var o = t.model,
          r = o.document;
      var s,
          a,
          c,
          l = i.start;
      var _iteratorNormalCompletion204 = true;
      var _didIteratorError204 = false;
      var _iteratorError204 = undefined;

      try {
        for (var _iterator204 = i.getWalker({
          shallow: !0
        })[Symbol.iterator](), _step204; !(_iteratorNormalCompletion204 = (_step204 = _iterator204.next()).done); _iteratorNormalCompletion204 = true) {
          var _t162 = _step204.value;
          c = _t162.item.getAttribute(e), s && a != c && (a != n && d(), l = s), s = _t162.nextPosition, a = c;
        }
      } catch (err) {
        _didIteratorError204 = true;
        _iteratorError204 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion204 && _iterator204.return != null) {
            _iterator204.return();
          }
        } finally {
          if (_didIteratorError204) {
            throw _iteratorError204;
          }
        }
      }

      function d() {
        var i = new Qs(l, s),
            c = i.root.document ? r.version : null,
            d = new sc(i, e, a, n, c);
        t.batch.addOperation(d), o.applyOperation(d);
      }

      s instanceof Gs && s != l && a != n && d();
    }

    function wc(t, e, n, i) {
      var o = t.model,
          r = o.document,
          s = i.getAttribute(e);
      var a, c;

      if (s != n) {
        if (i.root === i) {
          var _t163 = i.document ? r.version : null;

          c = new hc(i, e, s, n, _t163);
        } else {
          var _o42 = (a = new Qs(Gs._createBefore(i), t.createPositionAfter(i))).root.document ? r.version : null;

          c = new sc(a, e, s, n, _o42);
        }

        t.batch.addOperation(c), o.applyOperation(c);
      }
    }

    function _c(t, e, n, i, o) {
      var r = t.model,
          s = r.document,
          a = new dc(e, n, i, r.markers, o, s.version);
      t.batch.addOperation(a), r.applyOperation(a);
    }

    function kc(t, e, n, i) {
      var o;

      if (t.root.document) {
        var _n148 = i.document,
            _r18 = new Gs(_n148.graveyard, [0]);

        o = new cc(t, e, _r18, _n148.version);
      } else o = new ac(t, e);

      n.addOperation(o), i.applyOperation(o);
    }

    function vc(t, e) {
      return t === e || t instanceof pc && e instanceof pc;
    }

    var yc =
    /*#__PURE__*/
    function () {
      function yc(t) {
        _classCallCheck(this, yc);

        this._markerCollection = t, this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null;
      }

      _createClass(yc, [{
        key: "bufferOperation",
        value: function bufferOperation(t) {
          switch (t.type) {
            case "insert":
              if (this._isInInsertedElement(t.position.parent)) return;

              this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);

              break;

            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
              var _iteratorNormalCompletion205 = true;
              var _didIteratorError205 = false;
              var _iteratorError205 = undefined;

              try {
                for (var _iterator205 = t.range.getItems()[Symbol.iterator](), _step205; !(_iteratorNormalCompletion205 = (_step205 = _iterator205.next()).done); _iteratorNormalCompletion205 = true) {
                  var _e148 = _step205.value;
                  this._isInInsertedElement(_e148.parent) || this._markAttribute(_e148);
                }
              } catch (err) {
                _didIteratorError205 = true;
                _iteratorError205 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion205 && _iterator205.return != null) {
                    _iterator205.return();
                  }
                } finally {
                  if (_didIteratorError205) {
                    throw _iteratorError205;
                  }
                }
              }

              break;

            case "remove":
            case "move":
            case "reinsert":
              {
                if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) return;

                var _e149 = this._isInInsertedElement(t.sourcePosition.parent),
                    _n149 = this._isInInsertedElement(t.targetPosition.parent);

                _e149 || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany), _n149 || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
                break;
              }

            case "rename":
              {
                if (this._isInInsertedElement(t.position.parent)) return;
                this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);

                var _e150 = Qs._createFromPositionAndShift(t.position, 1);

                var _iteratorNormalCompletion206 = true;
                var _didIteratorError206 = false;
                var _iteratorError206 = undefined;

                try {
                  for (var _iterator206 = this._markerCollection.getMarkersIntersectingRange(_e150)[Symbol.iterator](), _step206; !(_iteratorNormalCompletion206 = (_step206 = _iterator206.next()).done); _iteratorNormalCompletion206 = true) {
                    var _t164 = _step206.value;

                    var _e151 = _t164.getRange();

                    this.bufferMarkerChange(_t164.name, _e151, _e151, _t164.affectsData);
                  }
                } catch (err) {
                  _didIteratorError206 = true;
                  _iteratorError206 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion206 && _iterator206.return != null) {
                      _iterator206.return();
                    }
                  } finally {
                    if (_didIteratorError206) {
                      throw _iteratorError206;
                    }
                  }
                }

                break;
              }

            case "split":
              {
                var _e152 = t.splitPosition.parent;
                this._isInInsertedElement(_e152) || this._markRemove(_e152, t.splitPosition.offset, t.howMany), this._isInInsertedElement(t.insertionPosition.parent) || this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1), t.graveyardPosition && this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
                break;
              }

            case "merge":
              {
                var _e153 = t.sourcePosition.parent;
                this._isInInsertedElement(_e153.parent) || this._markRemove(_e153.parent, _e153.startOffset, 1);
                var _n150 = t.graveyardPosition.parent;

                this._markInsert(_n150, t.graveyardPosition.offset, 1);

                var _i113 = t.targetPosition.parent;
                this._isInInsertedElement(_i113) || this._markInsert(_i113, t.targetPosition.offset, _e153.maxOffset);
                break;
              }
          }

          this._cachedChanges = null;
        }
      }, {
        key: "bufferMarkerChange",
        value: function bufferMarkerChange(t, e, n, i) {
          var o = this._changedMarkers.get(t);

          o ? (o.newRange = n, o.affectsData = i, null == o.oldRange && null == o.newRange && this._changedMarkers.delete(t)) : this._changedMarkers.set(t, {
            oldRange: e,
            newRange: n,
            affectsData: i
          });
        }
      }, {
        key: "getMarkersToRemove",
        value: function getMarkersToRemove() {
          var t = [];
          var _iteratorNormalCompletion207 = true;
          var _didIteratorError207 = false;
          var _iteratorError207 = undefined;

          try {
            for (var _iterator207 = this._changedMarkers[Symbol.iterator](), _step207; !(_iteratorNormalCompletion207 = (_step207 = _iterator207.next()).done); _iteratorNormalCompletion207 = true) {
              var _ref66 = _step207.value;

              var _ref65 = _slicedToArray(_ref66, 2);

              var _e154 = _ref65[0];
              var _n151 = _ref65[1];
              null != _n151.oldRange && t.push({
                name: _e154,
                range: _n151.oldRange
              });
            }
          } catch (err) {
            _didIteratorError207 = true;
            _iteratorError207 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion207 && _iterator207.return != null) {
                _iterator207.return();
              }
            } finally {
              if (_didIteratorError207) {
                throw _iteratorError207;
              }
            }
          }

          return t;
        }
      }, {
        key: "getMarkersToAdd",
        value: function getMarkersToAdd() {
          var t = [];
          var _iteratorNormalCompletion208 = true;
          var _didIteratorError208 = false;
          var _iteratorError208 = undefined;

          try {
            for (var _iterator208 = this._changedMarkers[Symbol.iterator](), _step208; !(_iteratorNormalCompletion208 = (_step208 = _iterator208.next()).done); _iteratorNormalCompletion208 = true) {
              var _ref69 = _step208.value;

              var _ref68 = _slicedToArray(_ref69, 2);

              var _e155 = _ref68[0];
              var _n152 = _ref68[1];
              null != _n152.newRange && t.push({
                name: _e155,
                range: _n152.newRange
              });
            }
          } catch (err) {
            _didIteratorError208 = true;
            _iteratorError208 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion208 && _iterator208.return != null) {
                _iterator208.return();
              }
            } finally {
              if (_didIteratorError208) {
                throw _iteratorError208;
              }
            }
          }

          return t;
        }
      }, {
        key: "getChangedMarkers",
        value: function getChangedMarkers() {
          return Array.from(this._changedMarkers).map(function (t) {
            return {
              name: t[0],
              data: {
                oldRange: t[1].oldRange,
                newRange: t[1].newRange
              }
            };
          });
        }
      }, {
        key: "hasDataChanges",
        value: function hasDataChanges() {
          var _iteratorNormalCompletion209 = true;
          var _didIteratorError209 = false;
          var _iteratorError209 = undefined;

          try {
            for (var _iterator209 = this._changedMarkers[Symbol.iterator](), _step209; !(_iteratorNormalCompletion209 = (_step209 = _iterator209.next()).done); _iteratorNormalCompletion209 = true) {
              var _ref72 = _step209.value;

              var _ref71 = _slicedToArray(_ref72, 2);

              var _t165 = _ref71[1];
              if (_t165.affectsData) return !0;
            }
          } catch (err) {
            _didIteratorError209 = true;
            _iteratorError209 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion209 && _iterator209.return != null) {
                _iterator209.return();
              }
            } finally {
              if (_didIteratorError209) {
                throw _iteratorError209;
              }
            }
          }

          return this._changesInElement.size > 0;
        }
      }, {
        key: "getChanges",
        value: function getChanges() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeChangesInGraveyard: !1
          };
          if (this._cachedChanges) return t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
          var e = [];
          var _iteratorNormalCompletion210 = true;
          var _didIteratorError210 = false;
          var _iteratorError210 = undefined;

          try {
            for (var _iterator210 = this._changesInElement.keys()[Symbol.iterator](), _step210; !(_iteratorNormalCompletion210 = (_step210 = _iterator210.next()).done); _iteratorNormalCompletion210 = true) {
              var _t167 = _step210.value;

              var _n154 = this._changesInElement.get(_t167).sort(function (t, e) {
                return t.offset === e.offset ? t.type != e.type ? "remove" == t.type ? -1 : 1 : 0 : t.offset < e.offset ? -1 : 1;
              }),
                  _i116 = this._elementSnapshots.get(_t167),
                  _o44 = xc(_t167.getChildren()),
                  _r20 = Ac(_i116.length, _n154);

              var _s16 = 0,
                  _a9 = 0;
              var _iteratorNormalCompletion211 = true;
              var _didIteratorError211 = false;
              var _iteratorError211 = undefined;

              try {
                for (var _iterator211 = _r20[Symbol.iterator](), _step211; !(_iteratorNormalCompletion211 = (_step211 = _iterator211.next()).done); _iteratorNormalCompletion211 = true) {
                  var _n155 = _step211.value;
                  if ("i" === _n155) e.push(this._getInsertDiff(_t167, _s16, _o44[_s16].name)), _s16++;else if ("r" === _n155) e.push(this._getRemoveDiff(_t167, _s16, _i116[_a9].name)), _a9++;else if ("a" === _n155) {
                    var _n156 = _o44[_s16].attributes,
                        _r21 = _i116[_a9].attributes;

                    var _c4 = void 0;

                    if ("$text" == _o44[_s16].name) _c4 = new Qs(Gs._createAt(_t167, _s16), Gs._createAt(_t167, _s16 + 1));else {
                      var _e157 = _t167.offsetToIndex(_s16);

                      _c4 = new Qs(Gs._createAt(_t167, _s16), Gs._createAt(_t167.getChild(_e157), 0));
                    }
                    e.push.apply(e, _toConsumableArray(this._getAttributesDiff(_c4, _r21, _n156))), _s16++, _a9++;
                  } else _s16++, _a9++;
                }
              } catch (err) {
                _didIteratorError211 = true;
                _iteratorError211 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion211 && _iterator211.return != null) {
                    _iterator211.return();
                  }
                } finally {
                  if (_didIteratorError211) {
                    throw _iteratorError211;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError210 = true;
            _iteratorError210 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion210 && _iterator210.return != null) {
                _iterator210.return();
              }
            } finally {
              if (_didIteratorError210) {
                throw _iteratorError210;
              }
            }
          }

          e.sort(function (t, e) {
            return t.position.root != e.position.root ? t.position.root.rootName < e.position.root.rootName ? -1 : 1 : t.position.isEqual(e.position) ? t.changeCount - e.changeCount : t.position.isBefore(e.position) ? -1 : 1;
          });

          for (var _t166 = 1; _t166 < e.length; _t166++) {
            var _n153 = e[_t166 - 1],
                _i114 = e[_t166],
                _o43 = "remove" == _n153.type && "remove" == _i114.type && "$text" == _n153.name && "$text" == _i114.name && _n153.position.isEqual(_i114.position),
                _r19 = "insert" == _n153.type && "insert" == _i114.type && "$text" == _n153.name && "$text" == _i114.name && _n153.position.parent == _i114.position.parent && _n153.position.offset + _n153.length == _i114.position.offset,
                _s15 = "attribute" == _n153.type && "attribute" == _i114.type && _n153.position.parent == _i114.position.parent && _n153.range.isFlat && _i114.range.isFlat && _n153.position.offset + _n153.length == _i114.position.offset && _n153.attributeKey == _i114.attributeKey && _n153.attributeOldValue == _i114.attributeOldValue && _n153.attributeNewValue == _i114.attributeNewValue;

            (_o43 || _r19 || _s15) && (e[_t166 - 1].length++, _s15 && (e[_t166 - 1].range.end = e[_t166 - 1].range.end.getShiftedBy(1)), e.splice(_t166, 1), _t166--);
          }

          for (var _i115 = 0, _e156 = e; _i115 < _e156.length; _i115++) {
            var _t168 = _e156[_i115];
            delete _t168.changeCount, "attribute" == _t168.type && (delete _t168.position, delete _t168.length);
          }

          return this._changeCount = 0, this._cachedChangesWithGraveyard = e.slice(), this._cachedChanges = e.slice().filter(Cc), t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard : this._cachedChanges;
        }
      }, {
        key: "reset",
        value: function reset() {
          this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._cachedChanges = null;
        }
      }, {
        key: "_markInsert",
        value: function _markInsert(t, e, n) {
          var i = {
            type: "insert",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };

          this._markChange(t, i);
        }
      }, {
        key: "_markRemove",
        value: function _markRemove(t, e, n) {
          var i = {
            type: "remove",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };
          this._markChange(t, i), this._removeAllNestedChanges(t, e, n);
        }
      }, {
        key: "_markAttribute",
        value: function _markAttribute(t) {
          var e = {
            type: "attribute",
            offset: t.startOffset,
            howMany: t.offsetSize,
            count: this._changeCount++
          };

          this._markChange(t.parent, e);
        }
      }, {
        key: "_markChange",
        value: function _markChange(t, e) {
          this._makeSnapshot(t);

          var n = this._getChangesForElement(t);

          this._handleChange(e, n), n.push(e);

          for (var _t169 = 0; _t169 < n.length; _t169++) {
            n[_t169].howMany < 1 && (n.splice(_t169, 1), _t169--);
          }
        }
      }, {
        key: "_getChangesForElement",
        value: function _getChangesForElement(t) {
          var e;
          return this._changesInElement.has(t) ? e = this._changesInElement.get(t) : (e = [], this._changesInElement.set(t, e)), e;
        }
      }, {
        key: "_makeSnapshot",
        value: function _makeSnapshot(t) {
          this._elementSnapshots.has(t) || this._elementSnapshots.set(t, xc(t.getChildren()));
        }
      }, {
        key: "_handleChange",
        value: function _handleChange(t, e) {
          t.nodesToHandle = t.howMany;
          var _iteratorNormalCompletion212 = true;
          var _didIteratorError212 = false;
          var _iteratorError212 = undefined;

          try {
            for (var _iterator212 = e[Symbol.iterator](), _step212; !(_iteratorNormalCompletion212 = (_step212 = _iterator212.next()).done); _iteratorNormalCompletion212 = true) {
              var _n157 = _step212.value;

              var _i117 = t.offset + t.howMany,
                  _o45 = _n157.offset + _n157.howMany;

              if ("insert" == t.type && ("insert" == _n157.type && (t.offset <= _n157.offset ? _n157.offset += t.howMany : t.offset < _o45 && (_n157.howMany += t.nodesToHandle, t.nodesToHandle = 0)), "remove" == _n157.type && t.offset < _n157.offset && (_n157.offset += t.howMany), "attribute" == _n157.type)) if (t.offset <= _n157.offset) _n157.offset += t.howMany;else if (t.offset < _o45) {
                var _o46 = _n157.howMany;
                _n157.howMany = t.offset - _n157.offset, e.unshift({
                  type: "attribute",
                  offset: _i117,
                  howMany: _o46 - _n157.howMany,
                  count: this._changeCount++
                });
              }

              if ("remove" == t.type) {
                if ("insert" == _n157.type) if (_i117 <= _n157.offset) _n157.offset -= t.howMany;else if (_i117 <= _o45) {
                  if (t.offset < _n157.offset) {
                    var _e158 = _i117 - _n157.offset;

                    _n157.offset = t.offset, _n157.howMany -= _e158, t.nodesToHandle -= _e158;
                  } else _n157.howMany -= t.nodesToHandle, t.nodesToHandle = 0;
                } else if (t.offset <= _n157.offset) t.nodesToHandle -= _n157.howMany, _n157.howMany = 0;else if (t.offset < _o45) {
                  var _e159 = _o45 - t.offset;

                  _n157.howMany -= _e159, t.nodesToHandle -= _e159;
                }
                if ("remove" == _n157.type && (_i117 <= _n157.offset ? _n157.offset -= t.howMany : t.offset < _n157.offset && (t.nodesToHandle += _n157.howMany, _n157.howMany = 0)), "attribute" == _n157.type) if (_i117 <= _n157.offset) _n157.offset -= t.howMany;else if (t.offset < _n157.offset) {
                  var _e160 = _i117 - _n157.offset;

                  _n157.offset = t.offset, _n157.howMany -= _e160;
                } else if (t.offset < _o45) if (_i117 <= _o45) {
                  var _i118 = _n157.howMany;
                  _n157.howMany = t.offset - _n157.offset;

                  var _o47 = _i118 - _n157.howMany - t.nodesToHandle;

                  e.unshift({
                    type: "attribute",
                    offset: t.offset,
                    howMany: _o47,
                    count: this._changeCount++
                  });
                } else _n157.howMany -= _o45 - t.offset;
              }

              if ("attribute" == t.type) {
                if ("insert" == _n157.type) if (t.offset < _n157.offset && _i117 > _n157.offset) {
                  if (_i117 > _o45) {
                    var _t170 = {
                      type: "attribute",
                      offset: _o45,
                      howMany: _i117 - _o45,
                      count: this._changeCount++
                    };
                    this._handleChange(_t170, e), e.push(_t170);
                  }

                  t.nodesToHandle = _n157.offset - t.offset, t.howMany = t.nodesToHandle;
                } else t.offset >= _n157.offset && t.offset < _o45 && (_i117 > _o45 ? (t.nodesToHandle = _i117 - _o45, t.offset = _o45) : t.nodesToHandle = 0);

                if ("remove" == _n157.type && t.offset < _n157.offset && _i117 > _n157.offset) {
                  var _o48 = {
                    type: "attribute",
                    offset: _n157.offset,
                    howMany: _i117 - _n157.offset,
                    count: this._changeCount++
                  };
                  this._handleChange(_o48, e), e.push(_o48), t.nodesToHandle = _n157.offset - t.offset, t.howMany = t.nodesToHandle;
                }

                "attribute" == _n157.type && (t.offset >= _n157.offset && _i117 <= _o45 ? (t.nodesToHandle = 0, t.howMany = 0, t.offset = 0) : t.offset <= _n157.offset && _i117 >= _o45 && (_n157.howMany = 0));
              }
            }
          } catch (err) {
            _didIteratorError212 = true;
            _iteratorError212 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion212 && _iterator212.return != null) {
                _iterator212.return();
              }
            } finally {
              if (_didIteratorError212) {
                throw _iteratorError212;
              }
            }
          }

          t.howMany = t.nodesToHandle, delete t.nodesToHandle;
        }
      }, {
        key: "_getInsertDiff",
        value: function _getInsertDiff(t, e, n) {
          return {
            type: "insert",
            position: Gs._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getRemoveDiff",
        value: function _getRemoveDiff(t, e, n) {
          return {
            type: "remove",
            position: Gs._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getAttributesDiff",
        value: function _getAttributesDiff(t, e, n) {
          var i = [];
          n = new Map(n);
          var _iteratorNormalCompletion213 = true;
          var _didIteratorError213 = false;
          var _iteratorError213 = undefined;

          try {
            for (var _iterator213 = e[Symbol.iterator](), _step213; !(_iteratorNormalCompletion213 = (_step213 = _iterator213.next()).done); _iteratorNormalCompletion213 = true) {
              var _ref77 = _step213.value;

              var _ref74 = _slicedToArray(_ref77, 2);

              var _o49 = _ref74[0];
              var _r22 = _ref74[1];

              var _e161 = n.has(_o49) ? n.get(_o49) : null;

              _e161 !== _r22 && i.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _o49,
                attributeOldValue: _r22,
                attributeNewValue: _e161,
                changeCount: this._changeCount++
              }), n.delete(_o49);
            }
          } catch (err) {
            _didIteratorError213 = true;
            _iteratorError213 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion213 && _iterator213.return != null) {
                _iterator213.return();
              }
            } finally {
              if (_didIteratorError213) {
                throw _iteratorError213;
              }
            }
          }

          var _iteratorNormalCompletion214 = true;
          var _didIteratorError214 = false;
          var _iteratorError214 = undefined;

          try {
            for (var _iterator214 = n[Symbol.iterator](), _step214; !(_iteratorNormalCompletion214 = (_step214 = _iterator214.next()).done); _iteratorNormalCompletion214 = true) {
              var _ref78 = _step214.value;

              var _ref76 = _slicedToArray(_ref78, 2);

              var _e162 = _ref76[0];
              var _o50 = _ref76[1];
              i.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _e162,
                attributeOldValue: null,
                attributeNewValue: _o50,
                changeCount: this._changeCount++
              });
            }
          } catch (err) {
            _didIteratorError214 = true;
            _iteratorError214 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion214 && _iterator214.return != null) {
                _iterator214.return();
              }
            } finally {
              if (_didIteratorError214) {
                throw _iteratorError214;
              }
            }
          }

          return i;
        }
      }, {
        key: "_isInInsertedElement",
        value: function _isInInsertedElement(t) {
          var e = t.parent;
          if (!e) return !1;

          var n = this._changesInElement.get(e),
              i = t.startOffset;

          if (n) {
            var _iteratorNormalCompletion215 = true;
            var _didIteratorError215 = false;
            var _iteratorError215 = undefined;

            try {
              for (var _iterator215 = n[Symbol.iterator](), _step215; !(_iteratorNormalCompletion215 = (_step215 = _iterator215.next()).done); _iteratorNormalCompletion215 = true) {
                var _t171 = _step215.value;
                if ("insert" == _t171.type && i >= _t171.offset && i < _t171.offset + _t171.howMany) return !0;
              }
            } catch (err) {
              _didIteratorError215 = true;
              _iteratorError215 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion215 && _iterator215.return != null) {
                  _iterator215.return();
                }
              } finally {
                if (_didIteratorError215) {
                  throw _iteratorError215;
                }
              }
            }
          }

          return this._isInInsertedElement(e);
        }
      }, {
        key: "_removeAllNestedChanges",
        value: function _removeAllNestedChanges(t, e, n) {
          var i = new Qs(Gs._createAt(t, e), Gs._createAt(t, e + n));
          var _iteratorNormalCompletion216 = true;
          var _didIteratorError216 = false;
          var _iteratorError216 = undefined;

          try {
            for (var _iterator216 = i.getItems({
              shallow: !0
            })[Symbol.iterator](), _step216; !(_iteratorNormalCompletion216 = (_step216 = _iterator216.next()).done); _iteratorNormalCompletion216 = true) {
              var _t172 = _step216.value;
              _t172.is("element") && (this._elementSnapshots.delete(_t172), this._changesInElement.delete(_t172), this._removeAllNestedChanges(_t172, 0, _t172.maxOffset));
            }
          } catch (err) {
            _didIteratorError216 = true;
            _iteratorError216 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion216 && _iterator216.return != null) {
                _iterator216.return();
              }
            } finally {
              if (_didIteratorError216) {
                throw _iteratorError216;
              }
            }
          }
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 == this._changesInElement.size && 0 == this._changedMarkers.size;
        }
      }]);

      return yc;
    }();

    function xc(t) {
      var e = [];
      var _iteratorNormalCompletion217 = true;
      var _didIteratorError217 = false;
      var _iteratorError217 = undefined;

      try {
        for (var _iterator217 = t[Symbol.iterator](), _step217; !(_iteratorNormalCompletion217 = (_step217 = _iterator217.next()).done); _iteratorNormalCompletion217 = true) {
          var _n158 = _step217.value;
          if (_n158.is("text")) for (var _t173 = 0; _t173 < _n158.data.length; _t173++) {
            e.push({
              name: "$text",
              attributes: new Map(_n158.getAttributes())
            });
          } else e.push({
            name: _n158.name,
            attributes: new Map(_n158.getAttributes())
          });
        }
      } catch (err) {
        _didIteratorError217 = true;
        _iteratorError217 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion217 && _iterator217.return != null) {
            _iterator217.return();
          }
        } finally {
          if (_didIteratorError217) {
            throw _iteratorError217;
          }
        }
      }

      return e;
    }

    function Ac(t, e) {
      var n = [];
      var i = 0,
          o = 0;
      var _iteratorNormalCompletion218 = true;
      var _didIteratorError218 = false;
      var _iteratorError218 = undefined;

      try {
        for (var _iterator218 = e[Symbol.iterator](), _step218; !(_iteratorNormalCompletion218 = (_step218 = _iterator218.next()).done); _iteratorNormalCompletion218 = true) {
          var _t174 = _step218.value;
          _t174.offset > i && (n.push.apply(n, _toConsumableArray("e".repeat(_t174.offset - i).split(""))), o += _t174.offset - i), "insert" == _t174.type ? (n.push.apply(n, _toConsumableArray("i".repeat(_t174.howMany).split(""))), i = _t174.offset + _t174.howMany) : "remove" == _t174.type ? (n.push.apply(n, _toConsumableArray("r".repeat(_t174.howMany).split(""))), i = _t174.offset, o += _t174.howMany) : (n.push.apply(n, _toConsumableArray("a".repeat(_t174.howMany).split(""))), i = _t174.offset + _t174.howMany, o += _t174.howMany);
        }
      } catch (err) {
        _didIteratorError218 = true;
        _iteratorError218 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion218 && _iterator218.return != null) {
            _iterator218.return();
          }
        } finally {
          if (_didIteratorError218) {
            throw _iteratorError218;
          }
        }
      }

      return o < t && n.push.apply(n, _toConsumableArray("e".repeat(t - o).split(""))), n;
    }

    function Cc(t) {
      var e = t.position && "$graveyard" == t.position.root.rootName,
          n = t.range && "$graveyard" == t.range.root.rootName;
      return !e && !n;
    }

    var Tc =
    /*#__PURE__*/
    function () {
      function Tc() {
        _classCallCheck(this, Tc);

        this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set();
      }

      _createClass(Tc, [{
        key: "addOperation",
        value: function addOperation(t) {
          this._operations.includes(t) || this._operations.push(t);
        }
      }, {
        key: "getOperations",
        value: function getOperations() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
          return t < 0 ? [] : this._operations.slice(t, e);
        }
      }, {
        key: "getOperation",
        value: function getOperation(t) {
          return this._operations[t];
        }
      }, {
        key: "setOperationAsUndone",
        value: function setOperationAsUndone(t, e) {
          this._undoPairs.set(e, t), this._undoneOperations.add(t);
        }
      }, {
        key: "isUndoingOperation",
        value: function isUndoingOperation(t) {
          return this._undoPairs.has(t);
        }
      }, {
        key: "isUndoneOperation",
        value: function isUndoneOperation(t) {
          return this._undoneOperations.has(t);
        }
      }, {
        key: "getUndoneOperation",
        value: function getUndoneOperation(t) {
          return this._undoPairs.get(t);
        }
      }]);

      return Tc;
    }();

    function Pc(t, e) {
      return function (t) {
        return !!t && 1 == t.length && /[\ud800-\udbff]/.test(t);
      }(t.charAt(e - 1)) && function (t) {
        return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
      }(t.charAt(e));
    }

    function Mc(t, e) {
      return function (t) {
        return !!t && 1 == t.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(t);
      }(t.charAt(e));
    }

    var Sc = "$graveyard";

    var Ec =
    /*#__PURE__*/
    function () {
      function Ec(t) {
        var _this65 = this;

        _classCallCheck(this, Ec);

        this.model = t, this.version = 0, this.history = new Tc(this), this.selection = new aa(this), this.roots = new oo({
          idProperty: "rootName"
        }), this.differ = new yc(t.markers), this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", Sc), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          if (n.isDocumentOperation && n.baseVersion !== _this65.version) throw new Gn.b("model-document-applyOperation-wrong-version: Only operations with matching versions can be applied.", _this65, {
            operation: n
          });
        }, {
          priority: "highest"
        }), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && _this65.differ.bufferOperation(n);
        }, {
          priority: "high"
        }), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && (_this65.version++, _this65.history.addOperation(n));
        }, {
          priority: "low"
        }), this.listenTo(this.selection, "change", function () {
          _this65._hasSelectionChangedFromTheLastChangeBlock = !0;
        }), this.listenTo(t.markers, "update", function (t, e, n, i) {
          _this65.differ.bufferMarkerChange(e.name, n, i, e.affectsData), null === n && e.on("change", function (t, n) {
            _this65.differ.bufferMarkerChange(e.name, n, e.getRange(), e.affectsData);
          });
        });
      }

      _createClass(Ec, [{
        key: "createRoot",
        value: function createRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          if (this.roots.get(e)) throw new Gn.b("model-document-createRoot-name-exists: Root with specified name already exists.", this, {
            name: e
          });
          var n = new pc(this, t, e);
          return this.roots.add(n), n;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.selection.destroy(), this.stopListening();
        }
      }, {
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "getRootNames",
        value: function getRootNames() {
          return Array.from(this.roots, function (t) {
            return t.rootName;
          }).filter(function (t) {
            return t != Sc;
          });
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = ui(this);
          return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
        }
      }, {
        key: "_handleChangeBlock",
        value: function _handleChangeBlock(t) {
          this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
        }
      }, {
        key: "_hasDocumentChangedFromTheLastChangeBlock",
        value: function _hasDocumentChangedFromTheLastChangeBlock() {
          return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
        }
      }, {
        key: "_getDefaultRoot",
        value: function _getDefaultRoot() {
          var _iteratorNormalCompletion219 = true;
          var _didIteratorError219 = false;
          var _iteratorError219 = undefined;

          try {
            for (var _iterator219 = this.roots[Symbol.iterator](), _step219; !(_iteratorNormalCompletion219 = (_step219 = _iterator219.next()).done); _iteratorNormalCompletion219 = true) {
              var _t175 = _step219.value;
              if (_t175 !== this.graveyard) return _t175;
            }
          } catch (err) {
            _didIteratorError219 = true;
            _iteratorError219 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion219 && _iterator219.return != null) {
                _iterator219.return();
              }
            } finally {
              if (_didIteratorError219) {
                throw _iteratorError219;
              }
            }
          }

          return this.graveyard;
        }
      }, {
        key: "_getDefaultRange",
        value: function _getDefaultRange() {
          var t = this._getDefaultRoot(),
              e = this.model,
              n = e.schema,
              i = e.createPositionFromPath(t, [0]);

          return n.getNearestSelectionRange(i) || e.createRange(i);
        }
      }, {
        key: "_validateSelectionRange",
        value: function _validateSelectionRange(t) {
          return Ic(t.start) && Ic(t.end);
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = !1;

          do {
            var _iteratorNormalCompletion220 = true;
            var _didIteratorError220 = false;
            var _iteratorError220 = undefined;

            try {
              for (var _iterator220 = this._postFixers[Symbol.iterator](), _step220; !(_iteratorNormalCompletion220 = (_step220 = _iterator220.next()).done); _iteratorNormalCompletion220 = true) {
                var _n159 = _step220.value;
                if (this.selection.refresh(), e = _n159(t)) break;
              }
            } catch (err) {
              _didIteratorError220 = true;
              _iteratorError220 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion220 && _iterator220.return != null) {
                  _iterator220.return();
                }
              } finally {
                if (_didIteratorError220) {
                  throw _iteratorError220;
                }
              }
            }
          } while (e);
        }
      }, {
        key: "graveyard",
        get: function get() {
          return this.getRoot(Sc);
        }
      }]);

      return Ec;
    }();

    function Ic(t) {
      var e = t.textNode;

      if (e) {
        var _n160 = e.data,
            _i119 = t.offset - e.startOffset;

        return !Pc(_n160, _i119) && !Mc(_n160, _i119);
      }

      return !0;
    }

    ci(Ec, ei);

    var Nc =
    /*#__PURE__*/
    function () {
      function Nc() {
        _classCallCheck(this, Nc);

        this._markers = new Map();
      }

      _createClass(Nc, [{
        key: Symbol.iterator,
        value: function value() {
          return this._markers.values();
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._markers.has(t);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._markers.get(t) || null;
        }
      }, {
        key: "_set",
        value: function _set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

          var o = t instanceof Oc ? t.name : t,
              r = this._markers.get(o);

          if (r) {
            var _t176 = r.getRange();

            var _s17 = !1;

            return _t176.isEqual(e) || (r._attachLiveRange(ra.fromRange(e)), _s17 = !0), n != r.managedUsingOperations && (r._managedUsingOperations = n, _s17 = !0), "boolean" == typeof i && i != r.affectsData && (r._affectsData = i, _s17 = !0), _s17 && this.fire("update:" + o, r, _t176, e), r;
          }

          var s = ra.fromRange(e),
              a = new Oc(o, s, n, i);
          return this._markers.set(o, a), this.fire("update:" + o, a, null, e), a;
        }
      }, {
        key: "_remove",
        value: function _remove(t) {
          var e = t instanceof Oc ? t.name : t,
              n = this._markers.get(e);

          return !!n && (this._markers.delete(e), this.fire("update:" + e, n, n.getRange(), null), this._destroyMarker(n), !0);
        }
      }, {
        key: "_refresh",
        value: function _refresh(t) {
          var e = t instanceof Oc ? t.name : t,
              n = this._markers.get(e);

          if (!n) throw new Gn.b("markercollection-refresh-marker-not-exists: Marker with provided name does not exists.", this);
          var i = n.getRange();
          this.fire("update:" + e, n, i, i, n.managedUsingOperations, n.affectsData);
        }
      }, {
        key: "getMarkersAtPosition",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersAtPosition(t) {
          var _iteratorNormalCompletion221, _didIteratorError221, _iteratorError221, _iterator221, _step221, _e163;

          return _regeneratorRuntime.wrap(function getMarkersAtPosition$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  _iteratorNormalCompletion221 = true;
                  _didIteratorError221 = false;
                  _iteratorError221 = undefined;
                  _context31.prev = 3;
                  _iterator221 = this[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion221 = (_step221 = _iterator221.next()).done) {
                    _context31.next = 14;
                    break;
                  }

                  _e163 = _step221.value;
                  _context31.t0 = _e163.getRange().containsPosition(t);

                  if (!_context31.t0) {
                    _context31.next = 11;
                    break;
                  }

                  _context31.next = 11;
                  return _e163;

                case 11:
                  _iteratorNormalCompletion221 = true;
                  _context31.next = 5;
                  break;

                case 14:
                  _context31.next = 20;
                  break;

                case 16:
                  _context31.prev = 16;
                  _context31.t1 = _context31["catch"](3);
                  _didIteratorError221 = true;
                  _iteratorError221 = _context31.t1;

                case 20:
                  _context31.prev = 20;
                  _context31.prev = 21;

                  if (!_iteratorNormalCompletion221 && _iterator221.return != null) {
                    _iterator221.return();
                  }

                case 23:
                  _context31.prev = 23;

                  if (!_didIteratorError221) {
                    _context31.next = 26;
                    break;
                  }

                  throw _iteratorError221;

                case 26:
                  return _context31.finish(23);

                case 27:
                  return _context31.finish(20);

                case 28:
                case "end":
                  return _context31.stop();
              }
            }
          }, getMarkersAtPosition, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "getMarkersIntersectingRange",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersIntersectingRange(t) {
          var _iteratorNormalCompletion222, _didIteratorError222, _iteratorError222, _iterator222, _step222, _e164;

          return _regeneratorRuntime.wrap(function getMarkersIntersectingRange$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  _iteratorNormalCompletion222 = true;
                  _didIteratorError222 = false;
                  _iteratorError222 = undefined;
                  _context32.prev = 3;
                  _iterator222 = this[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion222 = (_step222 = _iterator222.next()).done) {
                    _context32.next = 14;
                    break;
                  }

                  _e164 = _step222.value;
                  _context32.t0 = null !== _e164.getRange().getIntersection(t);

                  if (!_context32.t0) {
                    _context32.next = 11;
                    break;
                  }

                  _context32.next = 11;
                  return _e164;

                case 11:
                  _iteratorNormalCompletion222 = true;
                  _context32.next = 5;
                  break;

                case 14:
                  _context32.next = 20;
                  break;

                case 16:
                  _context32.prev = 16;
                  _context32.t1 = _context32["catch"](3);
                  _didIteratorError222 = true;
                  _iteratorError222 = _context32.t1;

                case 20:
                  _context32.prev = 20;
                  _context32.prev = 21;

                  if (!_iteratorNormalCompletion222 && _iterator222.return != null) {
                    _iterator222.return();
                  }

                case 23:
                  _context32.prev = 23;

                  if (!_didIteratorError222) {
                    _context32.next = 26;
                    break;
                  }

                  throw _iteratorError222;

                case 26:
                  return _context32.finish(23);

                case 27:
                  return _context32.finish(20);

                case 28:
                case "end":
                  return _context32.stop();
              }
            }
          }, getMarkersIntersectingRange, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "destroy",
        value: function destroy() {
          var _iteratorNormalCompletion223 = true;
          var _didIteratorError223 = false;
          var _iteratorError223 = undefined;

          try {
            for (var _iterator223 = this._markers.values()[Symbol.iterator](), _step223; !(_iteratorNormalCompletion223 = (_step223 = _iterator223.next()).done); _iteratorNormalCompletion223 = true) {
              var _t177 = _step223.value;

              this._destroyMarker(_t177);
            }
          } catch (err) {
            _didIteratorError223 = true;
            _iteratorError223 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion223 && _iterator223.return != null) {
                _iterator223.return();
              }
            } finally {
              if (_didIteratorError223) {
                throw _iteratorError223;
              }
            }
          }

          this._markers = null, this.stopListening();
        }
      }, {
        key: "getMarkersGroup",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getMarkersGroup(t) {
          var _iteratorNormalCompletion224, _didIteratorError224, _iteratorError224, _iterator224, _step224, _e165;

          return _regeneratorRuntime.wrap(function getMarkersGroup$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  _iteratorNormalCompletion224 = true;
                  _didIteratorError224 = false;
                  _iteratorError224 = undefined;
                  _context33.prev = 3;
                  _iterator224 = this._markers.values()[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion224 = (_step224 = _iterator224.next()).done) {
                    _context33.next = 14;
                    break;
                  }

                  _e165 = _step224.value;
                  _context33.t0 = _e165.name.startsWith(t + ":");

                  if (!_context33.t0) {
                    _context33.next = 11;
                    break;
                  }

                  _context33.next = 11;
                  return _e165;

                case 11:
                  _iteratorNormalCompletion224 = true;
                  _context33.next = 5;
                  break;

                case 14:
                  _context33.next = 20;
                  break;

                case 16:
                  _context33.prev = 16;
                  _context33.t1 = _context33["catch"](3);
                  _didIteratorError224 = true;
                  _iteratorError224 = _context33.t1;

                case 20:
                  _context33.prev = 20;
                  _context33.prev = 21;

                  if (!_iteratorNormalCompletion224 && _iterator224.return != null) {
                    _iterator224.return();
                  }

                case 23:
                  _context33.prev = 23;

                  if (!_didIteratorError224) {
                    _context33.next = 26;
                    break;
                  }

                  throw _iteratorError224;

                case 26:
                  return _context33.finish(23);

                case 27:
                  return _context33.finish(20);

                case 28:
                case "end":
                  return _context33.stop();
              }
            }
          }, getMarkersGroup, this, [[3, 16, 20, 28], [21,, 23, 27]]);
        })
      }, {
        key: "_destroyMarker",
        value: function _destroyMarker(t) {
          t.stopListening(), t._detachLiveRange();
        }
      }]);

      return Nc;
    }();

    ci(Nc, ei);

    var Oc =
    /*#__PURE__*/
    function () {
      function Oc(t, e, n, i) {
        _classCallCheck(this, Oc);

        this.name = t, this._liveRange = this._attachLiveRange(e), this._managedUsingOperations = n, this._affectsData = i;
      }

      _createClass(Oc, [{
        key: "getStart",
        value: function getStart() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.start.clone();
        }
      }, {
        key: "getEnd",
        value: function getEnd() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.end.clone();
        }
      }, {
        key: "getRange",
        value: function getRange() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.toRange();
        }
      }, {
        key: "_attachLiveRange",
        value: function _attachLiveRange(t) {
          return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
        }
      }, {
        key: "_detachLiveRange",
        value: function _detachLiveRange() {
          this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
        }
      }, {
        key: "managedUsingOperations",
        get: function get() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._managedUsingOperations;
        }
      }, {
        key: "affectsData",
        get: function get() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._affectsData;
        }
      }]);

      return Oc;
    }();

    ci(Oc, ei);

    var Rc =
    /*#__PURE__*/
    function (_Gs) {
      _inherits(Rc, _Gs);

      function Rc(t, e) {
        var _this66;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

        _classCallCheck(this, Rc);

        if (_this66 = _possibleConstructorReturn(this, _getPrototypeOf(Rc).call(this, t, e, n)), !_this66.root.is("rootElement")) throw new Gn.b("model-liveposition-root-not-rootelement: LivePosition's root has to be an instance of RootElement.", t);
        (function () {
          var _this67 = this;

          this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
            var n = e[0];
            n.isDocumentOperation && function (t) {
              var e = this.getTransformedByOperation(t);

              if (!this.isEqual(e)) {
                var _t178 = this.toPosition();

                this.path = e.path, this.root = e.root, this.fire("change", _t178);
              }
            }.call(_this67, n);
          }, {
            priority: "low"
          });
        }).call(_assertThisInitialized(_this66));
        return _possibleConstructorReturn(_this66);
      }

      _createClass(Rc, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "toPosition",
        value: function toPosition() {
          return new Gs(this.root, this.path.slice(), this.stickiness);
        }
      }], [{
        key: "fromPosition",
        value: function fromPosition(t, e) {
          return new this(t.root, t.path.slice(), e || t.stickiness);
        }
      }]);

      return Rc;
    }(Gs);

    ci(Rc, ei);

    var Dc =
    /*#__PURE__*/
    function () {
      function Dc(t, e, n) {
        _classCallCheck(this, Dc);

        this.model = t, this.writer = e, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = t.schema, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
      }

      _createClass(Dc, [{
        key: "handleNodes",
        value: function handleNodes(t, e) {
          t = Array.from(t);

          for (var _n161 = 0; _n161 < t.length; _n161++) {
            var _i120 = t[_n161];

            this._handleNode(_i120, {
              isFirst: 0 === _n161 && e.isFirst,
              isLast: _n161 === t.length - 1 && e.isLast
            });
          }

          this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
        }
      }, {
        key: "getSelectionRange",
        value: function getSelectionRange() {
          return this.nodeToSelect ? Qs._createOn(this.nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
        }
      }, {
        key: "getAffectedRange",
        value: function getAffectedRange() {
          return this._affectedStart ? new Qs(this._affectedStart, this._affectedEnd) : null;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
        }
      }, {
        key: "_handleNode",
        value: function _handleNode(t, e) {
          if (this.schema.isObject(t)) return void this._handleObject(t, e);
          this._checkAndSplitToAllowedPosition(t, e) ? (this._insert(t), this._mergeSiblingsOf(t, e)) : this._handleDisallowedNode(t, e);
        }
      }, {
        key: "_handleObject",
        value: function _handleObject(t, e) {
          this._checkAndSplitToAllowedPosition(t) ? this._insert(t) : this._tryAutoparagraphing(t, e);
        }
      }, {
        key: "_handleDisallowedNode",
        value: function _handleDisallowedNode(t, e) {
          t.is("element") ? this.handleNodes(t.getChildren(), e) : this._tryAutoparagraphing(t, e);
        }
      }, {
        key: "_insert",
        value: function _insert(t) {
          if (!this.schema.checkChild(this.position, t)) return void bs.a.error("insertcontent-wrong-position: The node cannot be inserted on the given position.", {
            node: t,
            position: this.position
          });
          var e = Rc.fromPosition(this.position, "toNext");
          this._setAffectedBoundaries(this.position), this.writer.insert(t, this.position), this.position = e.toPosition(), e.detach(), this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text") ? this.nodeToSelect = t : this.nodeToSelect = null, this._filterAttributesOf.push(t);
        }
      }, {
        key: "_setAffectedBoundaries",
        value: function _setAffectedBoundaries(t) {
          this._affectedStart || (this._affectedStart = Rc.fromPosition(t, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = Rc.fromPosition(t, "toNext"));
        }
      }, {
        key: "_mergeSiblingsOf",
        value: function _mergeSiblingsOf(t, e) {
          if (!(t instanceof qs)) return;

          var n = this._canMergeLeft(t, e),
              i = this._canMergeRight(t, e),
              o = Rc._createBefore(t);

          o.stickiness = "toNext";

          var r = Rc._createAfter(t);

          if (r.stickiness = "toNext", n) {
            var _t179 = Rc.fromPosition(this.position);

            _t179.stickiness = "toNext", this._affectedStart.isEqual(o) && (this._affectedStart.detach(), this._affectedStart = Rc._createAt(o.nodeBefore, "end", "toPrevious")), this.writer.merge(o), o.isEqual(this._affectedEnd) && e.isLast && (this._affectedEnd.detach(), this._affectedEnd = Rc._createAt(o.nodeBefore, "end", "toNext")), this.position = _t179.toPosition(), _t179.detach();
          }

          if (i) {
            this.position.isEqual(r) || bs.a.error("insertcontent-wrong-position-on-merge: The insertion position should equal the merge position"), this.position = Gs._createAt(r.nodeBefore, "end");

            var _t180 = Rc.fromPosition(this.position, "toPrevious");

            this._affectedEnd.isEqual(r) && (this._affectedEnd.detach(), this._affectedEnd = Rc._createAt(r.nodeBefore, "end", "toNext")), this.writer.merge(r), r.getShiftedBy(-1).isEqual(this._affectedStart) && e.isFirst && (this._affectedStart.detach(), this._affectedStart = Rc._createAt(r.nodeBefore, 0, "toPrevious")), this.position = _t180.toPosition(), _t180.detach();
          }

          (n || i) && this._filterAttributesOf.push(this.position.parent), o.detach(), r.detach();
        }
      }, {
        key: "_canMergeLeft",
        value: function _canMergeLeft(t, e) {
          var n = t.previousSibling;
          return e.isFirst && n instanceof qs && this.canMergeWith.has(n) && this.model.schema.checkMerge(n, t);
        }
      }, {
        key: "_canMergeRight",
        value: function _canMergeRight(t, e) {
          var n = t.nextSibling;
          return e.isLast && n instanceof qs && this.canMergeWith.has(n) && this.model.schema.checkMerge(t, n);
        }
      }, {
        key: "_tryAutoparagraphing",
        value: function _tryAutoparagraphing(t, e) {
          var n = this.writer.createElement("paragraph");
          this._getAllowedIn(n, this.position.parent) && this.schema.checkChild(n, t) && (n._appendChild(t), this._handleNode(n, e));
        }
      }, {
        key: "_checkAndSplitToAllowedPosition",
        value: function _checkAndSplitToAllowedPosition(t) {
          var e = this._getAllowedIn(t, this.position.parent);

          if (!e) return !1;

          for (; e != this.position.parent;) {
            if (this.schema.isLimit(this.position.parent)) return !1;

            if (this.position.isAtStart) {
              var _t181 = this.position.parent;
              this.position = this.writer.createPositionBefore(_t181), _t181.isEmpty && _t181.parent === e && this.writer.remove(_t181);
            } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
              var _t182 = this.writer.createPositionAfter(this.position.parent);

              this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = _t182, this.canMergeWith.add(this.position.nodeAfter);
            }
          }

          return !0;
        }
      }, {
        key: "_getAllowedIn",
        value: function _getAllowedIn(t, e) {
          return this.schema.checkChild(e, t) ? e : e.parent ? this._getAllowedIn(t, e.parent) : null;
        }
      }]);

      return Dc;
    }();

    function Lc(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (e.isCollapsed) return;
      var i = e.getFirstRange();
      if ("$graveyard" == i.root.rootName) return;
      var o = t.schema;
      t.change(function (t) {
        if (!n.doNotResetEntireContent && function (t, e) {
          var n = t.getLimitElement(e);
          if (!e.containsEntireContent(n)) return !1;
          var i = e.getFirstRange();
          if (i.start.parent == i.end.parent) return !1;
          return t.checkChild(n, "paragraph");
        }(o, e)) return void function (t, e) {
          var n = t.model.schema.getLimitElement(e);
          t.remove(t.createRangeIn(n)), jc(t, t.createPositionAt(n, 0), e);
        }(t, e);
        var r = i.start,
            s = Rc.fromPosition(i.end, "toNext");

        if (i.start.isTouching(i.end) || t.remove(i), n.leaveUnmerged || (!function t(e, n, i) {
          var o = n.parent;
          var r = i.parent;
          if (o == r) return;
          if (e.model.schema.isLimit(o) || e.model.schema.isLimit(r)) return;
          if (!function (t, e, n) {
            var i = new Qs(t, e);
            var _iteratorNormalCompletion225 = true;
            var _didIteratorError225 = false;
            var _iteratorError225 = undefined;

            try {
              for (var _iterator225 = i.getWalker()[Symbol.iterator](), _step225; !(_iteratorNormalCompletion225 = (_step225 = _iterator225.next()).done); _iteratorNormalCompletion225 = true) {
                var _t183 = _step225.value;
                if (n.isLimit(_t183.item)) return !1;
              }
            } catch (err) {
              _didIteratorError225 = true;
              _iteratorError225 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion225 && _iterator225.return != null) {
                  _iterator225.return();
                }
              } finally {
                if (_didIteratorError225) {
                  throw _iteratorError225;
                }
              }
            }

            return !0;
          }(n, i, e.model.schema)) return;
          n = e.createPositionAfter(o);
          i = e.createPositionBefore(r);
          i.isEqual(n) || e.insert(r, n);
          e.merge(n);

          for (; i.parent.isEmpty;) {
            var _t184 = i.parent;
            i = e.createPositionBefore(_t184), e.remove(_t184);
          }

          t(e, n, i);
        }(t, r, s), o.removeDisallowedAttributes(r.parent.getChildren(), t)), Vc(t, e, r), function (t, e) {
          var n = t.checkChild(e, "$text"),
              i = t.checkChild(e, "paragraph");
          return !n && i;
        }(o, r)) {
          var _i121 = o.getNearestSelectionRange(r);

          n.doNotAutoparagraph && _i121 ? Vc(t, e, _i121) : jc(t, r, e);
        }

        s.detach();
      });
    }

    function jc(t, e, n) {
      var i = t.createElement("paragraph");
      t.insert(i, e), Vc(t, n, t.createPositionAt(i, 0));
    }

    function Vc(t, e, n) {
      e instanceof aa ? t.setSelection(n) : e.setTo(n);
    }

    var Bc = ' ,.?!:;"-()';

    function zc(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = t.schema,
          o = "backward" != n.direction,
          r = n.unit ? n.unit : "character",
          s = e.focus,
          a = new Ws({
        boundaries: function (t, e) {
          var n = t.root,
              i = Gs._createAt(n, e ? "end" : 0);

          return e ? new Qs(t, i) : new Qs(i, t);
        }(s, o),
        singleCharacters: !0,
        direction: o ? "forward" : "backward"
      }),
          c = {
        walker: a,
        schema: i,
        isForward: o,
        unit: r
      };
      var l;

      var _loop3 = function _loop3() {
        if (l.done) return {
          v: void 0
        };
        var n = Fc(c, l.value);
        if (n) return {
          v: void (e instanceof aa ? t.change(function (t) {
            t.setSelectionFocus(n);
          }) : e.setFocus(n))
        };
      };

      for (; l = a.next();) {
        var _ret2 = _loop3();

        if (typeof _ret2 === "object") return _ret2.v;
      }
    }

    function Fc(t, e) {
      if ("text" == e.type) return "word" === t.unit ? function (t, e) {
        var n = t.position.textNode;

        if (n) {
          var _i122 = t.position.offset - n.startOffset;

          for (; !Uc(n.data, _i122, e) && !Hc(n, _i122, e);) {
            t.next();

            var _o51 = e ? t.position.nodeAfter : t.position.nodeBefore;

            if (_o51 && _o51.is("text")) {
              var _i123 = _o51.data.charAt(e ? 0 : _o51.data.length - 1);

              Bc.includes(_i123) || (t.next(), n = t.position.textNode);
            }

            _i122 = t.position.offset - n.startOffset;
          }
        }

        return t.position;
      }(t.walker, t.isForward) : function (t, e) {
        var n = t.position.textNode;

        if (n) {
          var _i124 = n.data;

          var _o52 = t.position.offset - n.startOffset;

          for (; Pc(_i124, _o52) || "character" == e && Mc(_i124, _o52);) {
            t.next(), _o52 = t.position.offset - n.startOffset;
          }
        }

        return t.position;
      }(t.walker, t.unit, t.isForward);

      if (e.type == (t.isForward ? "elementStart" : "elementEnd")) {
        if (t.schema.isObject(e.item)) return Gs._createAt(e.item, t.isForward ? "after" : "before");
        if (t.schema.checkChild(e.nextPosition, "$text")) return e.nextPosition;
      } else {
        if (t.schema.isLimit(e.item)) return void t.walker.skip(function () {
          return !0;
        });
        if (t.schema.checkChild(e.nextPosition, "$text")) return e.nextPosition;
      }
    }

    function Uc(t, e, n) {
      var i = e + (n ? 0 : -1);
      return Bc.includes(t.charAt(i));
    }

    function Hc(t, e, n) {
      return e === (n ? t.endOffset : 0);
    }

    function qc(t, e) {
      var n = [];
      Array.from(t.getItems({
        direction: "backward"
      })).map(function (t) {
        return e.createRangeOn(t);
      }).filter(function (e) {
        return (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end));
      }).forEach(function (t) {
        n.push(t.start.parent), e.remove(t);
      }), n.forEach(function (t) {
        var n = t;

        for (; n.parent && n.isEmpty;) {
          var _t185 = e.createRangeOn(n);

          n = n.parent, e.remove(_t185);
        }
      });
    }

    function Wc(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.selection,
              i = e.schema,
              o = [];
          var r = !1;
          var _iteratorNormalCompletion226 = true;
          var _didIteratorError226 = false;
          var _iteratorError226 = undefined;

          try {
            for (var _iterator226 = n.getRanges()[Symbol.iterator](), _step226; !(_iteratorNormalCompletion226 = (_step226 = _iterator226.next()).done); _iteratorNormalCompletion226 = true) {
              var _t187 = _step226.value;

              var _e167 = Yc(_t187, i);

              _e167 ? (o.push(_e167), r = !0) : o.push(_t187);
            }
          } catch (err) {
            _didIteratorError226 = true;
            _iteratorError226 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion226 && _iterator226.return != null) {
                _iterator226.return();
              }
            } finally {
              if (_didIteratorError226) {
                throw _iteratorError226;
              }
            }
          }

          if (r) {
            var _e166 = o;

            if (o.length > 1) {
              var _t186 = o[0].start,
                  _n162 = o[o.length - 1].end;
              _e166 = [new Qs(_t186, _n162)];
            }

            t.setSelection(_e166, {
              backward: n.isBackward
            });
          }
        }(e, t);
      });
    }

    function Yc(t, e) {
      return t.isCollapsed ? function (t, e) {
        var n = t.start,
            i = e.getNearestSelectionRange(n);
        if (!i) return null;
        var o = i.start;
        if (n.isEqual(o)) return null;
        if (o.nodeAfter && e.isLimit(o.nodeAfter)) return new Qs(o, Gs._createAfter(o.nodeAfter));
        return new Qs(o);
      }(t, e) : function (t, e) {
        var n = t.start,
            i = t.end,
            o = e.checkChild(n, "$text"),
            r = e.checkChild(i, "$text"),
            s = e.getLimitElement(n),
            a = e.getLimitElement(i);

        if (s === a) {
          if (o && r) return null;

          if (function (t, e, n) {
            var i = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text"),
                o = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
            return i || o;
          }(n, i, e)) {
            var _t188 = n.nodeAfter && e.isObject(n.nodeAfter),
                _o53 = _t188 ? null : e.getNearestSelectionRange(n, "forward"),
                _r23 = i.nodeBefore && e.isObject(i.nodeBefore),
                _s18 = _r23 ? null : e.getNearestSelectionRange(i, "backward"),
                _a10 = _o53 ? _o53.start : n,
                _c5 = _s18 ? _s18.start : i;

            return new Qs(_a10, _c5);
          }
        }

        var c = s && !s.is("rootElement"),
            l = a && !a.is("rootElement");

        if (c || l) {
          var _t189 = n.nodeAfter && i.nodeBefore && n.nodeAfter.parent === i.nodeBefore.parent,
              _o54 = c && (!_t189 || !Gc(n.nodeAfter, e)),
              _r24 = l && (!_t189 || !Gc(i.nodeBefore, e));

          var _d2 = n,
              _u2 = i;
          return _o54 && (_d2 = Gs._createBefore($c(s, e))), _r24 && (_u2 = Gs._createAfter($c(a, e))), new Qs(_d2, _u2);
        }

        return null;
      }(t, e);
    }

    function $c(t, e) {
      var n = t,
          i = n;

      for (; e.isLimit(i) && i.parent;) {
        n = i, i = i.parent;
      }

      return n;
    }

    function Gc(t, e) {
      return t && e.isObject(t);
    }

    var Qc =
    /*#__PURE__*/
    function () {
      function Qc() {
        var _this68 = this;

        _classCallCheck(this, Qc);

        this.markers = new Nc(), this.document = new Ec(this), this.schema = new Na(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (t) {
          return _this68.decorate(t);
        }), this.on("applyOperation", function (t, e) {
          e[0]._validate();
        }, {
          priority: "highest"
        }), this.schema.register("$root", {
          isLimit: !0
        }), this.schema.register("$block", {
          allowIn: "$root",
          isBlock: !0
        }), this.schema.register("$text", {
          allowIn: "$block",
          isInline: !0
        }), this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          isLimit: !0
        }), this.schema.extend("$text", {
          allowIn: "$clipboardHolder"
        }), this.schema.register("$marker"), this.schema.addChildCheck(function (t, e) {
          if ("$marker" === e.name) return !0;
        }), Wc(this);
      }

      _createClass(Qc, [{
        key: "change",
        value: function change(t) {
          return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
            batch: new Qa(),
            callback: t
          }), this._runPendingChanges()[0]) : t(this._currentWriter);
        }
      }, {
        key: "enqueueChange",
        value: function enqueueChange(t, e) {
          "string" == typeof t ? t = new Qa(t) : "function" == typeof t && (e = t, t = new Qa()), this._pendingChanges.push({
            batch: t,
            callback: e
          }), 1 == this._pendingChanges.length && this._runPendingChanges();
        }
      }, {
        key: "applyOperation",
        value: function applyOperation(t) {
          t._execute();
        }
      }, {
        key: "insertContent",
        value: function insertContent(t, e, n) {
          return function (t, e, n, i) {
            return t.change(function (o) {
              var r;
              var s = (r = n ? n instanceof ea || n instanceof aa ? n : o.createSelection(n, i) : t.document.selection).getFirstPosition();
              r.isCollapsed || t.deleteContent(r, {
                doNotAutoparagraph: !0
              });
              var a = new Dc(t, o, s);
              var c;
              c = e.is("documentFragment") ? e.getChildren() : [e], a.handleNodes(c, {
                isFirst: !0,
                isLast: !0
              });
              var l = a.getSelectionRange();
              l ? r instanceof aa ? o.setSelection(l) : r.setTo(l) : bs.a.warn("insertcontent-no-range: Cannot determine a proper selection range after insertion.");
              var d = a.getAffectedRange() || t.createRange(s);
              return a.destroy(), d;
            });
          }(this, t, e, n);
        }
      }, {
        key: "deleteContent",
        value: function deleteContent(t, e) {
          Lc(this, t, e);
        }
      }, {
        key: "modifySelection",
        value: function modifySelection(t, e) {
          zc(this, t, e);
        }
      }, {
        key: "getSelectedContent",
        value: function getSelectedContent(t) {
          return function (t, e) {
            return t.change(function (t) {
              var n = t.createDocumentFragment(),
                  i = e.getFirstRange();
              if (!i || i.isCollapsed) return n;
              var o = i.start.root,
                  r = i.start.getCommonPath(i.end),
                  s = o.getNodeByPath(r);
              var a;
              var c = (a = i.start.parent == i.end.parent ? i : t.createRange(t.createPositionAt(s, i.start.path[r.length]), t.createPositionAt(s, i.end.path[r.length] + 1))).end.offset - a.start.offset;
              var _iteratorNormalCompletion227 = true;
              var _didIteratorError227 = false;
              var _iteratorError227 = undefined;

              try {
                for (var _iterator227 = a.getItems({
                  shallow: !0
                })[Symbol.iterator](), _step227; !(_iteratorNormalCompletion227 = (_step227 = _iterator227.next()).done); _iteratorNormalCompletion227 = true) {
                  var _e169 = _step227.value;
                  _e169.is("textProxy") ? t.appendText(_e169.data, _e169.getAttributes(), n) : t.append(_e169._clone(!0), n);
                }
              } catch (err) {
                _didIteratorError227 = true;
                _iteratorError227 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion227 && _iterator227.return != null) {
                    _iterator227.return();
                  }
                } finally {
                  if (_didIteratorError227) {
                    throw _iteratorError227;
                  }
                }
              }

              if (a != i) {
                var _e168 = i._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0],
                    _o55 = t.createRange(t.createPositionAt(n, 0), _e168.start);

                qc(t.createRange(_e168.end, t.createPositionAt(n, "end")), t), qc(_o55, t);
              }

              return n;
            });
          }(this, t);
        }
      }, {
        key: "hasContent",
        value: function hasContent(t, e) {
          var n = t instanceof qs ? Qs._createIn(t) : t;
          if (n.isCollapsed) return !1;
          var _iteratorNormalCompletion228 = true;
          var _didIteratorError228 = false;
          var _iteratorError228 = undefined;

          try {
            for (var _iterator228 = this.markers.getMarkersIntersectingRange(n)[Symbol.iterator](), _step228; !(_iteratorNormalCompletion228 = (_step228 = _iterator228.next()).done); _iteratorNormalCompletion228 = true) {
              var _t190 = _step228.value;
              if (_t190.affectsData) return !0;
            }
          } catch (err) {
            _didIteratorError228 = true;
            _iteratorError228 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion228 && _iterator228.return != null) {
                _iterator228.return();
              }
            } finally {
              if (_didIteratorError228) {
                throw _iteratorError228;
              }
            }
          }

          var _ref79 = e || {},
              _ref79$ignoreWhitespa = _ref79.ignoreWhitespaces,
              i = _ref79$ignoreWhitespa === void 0 ? !1 : _ref79$ignoreWhitespa;

          var _iteratorNormalCompletion229 = true;
          var _didIteratorError229 = false;
          var _iteratorError229 = undefined;

          try {
            for (var _iterator229 = n.getItems()[Symbol.iterator](), _step229; !(_iteratorNormalCompletion229 = (_step229 = _iterator229.next()).done); _iteratorNormalCompletion229 = true) {
              var _t191 = _step229.value;

              if (_t191.is("textProxy")) {
                if (!i) return !0;
                if (-1 !== _t191.data.search(/\S/)) return !0;
              } else if (this.schema.isObject(_t191)) return !0;
            }
          } catch (err) {
            _didIteratorError229 = true;
            _iteratorError229 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion229 && _iterator229.return != null) {
                _iterator229.return();
              }
            } finally {
              if (_didIteratorError229) {
                throw _iteratorError229;
              }
            }
          }

          return !1;
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return new Gs(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Gs._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Gs._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Gs._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Qs(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Qs._createIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Qs._createOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new ea(t, e, n);
        }
      }, {
        key: "createBatch",
        value: function createBatch(t) {
          return new Qa(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "_runPendingChanges",
        value: function _runPendingChanges() {
          var t = [];

          for (this.fire("_beforeChanges"); this._pendingChanges.length;) {
            var _e170 = this._pendingChanges[0].batch;
            this._currentWriter = new gc(this, _e170);

            var _n163 = this._pendingChanges[0].callback(this._currentWriter);

            t.push(_n163), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }

          return this.fire("_afterChanges"), t;
        }
      }]);

      return Qc;
    }();

    ci(Qc, Fi);

    var Jc =
    /*#__PURE__*/
    function () {
      function Jc() {
        _classCallCheck(this, Jc);

        this._listener = Object.create(lr);
      }

      _createClass(Jc, [{
        key: "listenTo",
        value: function listenTo(t) {
          var _this69 = this;

          this._listener.listenTo(t, "keydown", function (t, e) {
            _this69._listener.fire("_keydown:" + wo(e), e);
          });
        }
      }, {
        key: "set",
        value: function set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          var i = _o(t),
              o = n.priority;

          this._listener.listenTo(this._listener, "_keydown:" + i, function (t, n) {
            e(n, function () {
              n.preventDefault(), n.stopPropagation(), t.stop();
            }), t.return = !0;
          }, {
            priority: o
          });
        }
      }, {
        key: "press",
        value: function press(t) {
          return !!this._listener.fire("_keydown:" + wo(t), t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._listener.stopListening();
        }
      }]);

      return Jc;
    }();

    var Kc =
    /*#__PURE__*/
    function (_Jc) {
      _inherits(Kc, _Jc);

      function Kc(t) {
        var _this70;

        _classCallCheck(this, Kc);

        _this70 = _possibleConstructorReturn(this, _getPrototypeOf(Kc).call(this)), _this70.editor = t;
        return _this70;
      }

      _createClass(Kc, [{
        key: "set",
        value: function set(t, e) {
          var _this71 = this;

          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if ("string" == typeof e) {
            var _t192 = e;

            e = function e(_e171, n) {
              _this71.editor.execute(_t192), n();
            };
          }

          _get(_getPrototypeOf(Kc.prototype), "set", this).call(this, t, e, n);
        }
      }]);

      return Kc;
    }(Jc);

    var Zc =
    /*#__PURE__*/
    function () {
      function Zc(t) {
        var _this72 = this;

        _classCallCheck(this, Zc);

        var e = this.constructor.builtinPlugins;
        this.config = new Yn(t, this.constructor.defaultConfig), this.config.define("plugins", e), this.plugins = new Ta(this, e), this.commands = new Pa(), this.locale = new Sa(this.config.get("language")), this.t = this.locale.t, this.set("state", "initializing"), this.once("ready", function () {
          return _this72.state = "ready";
        }, {
          priority: "high"
        }), this.once("destroy", function () {
          return _this72.state = "destroyed";
        }, {
          priority: "high"
        }), this.set("isReadOnly", !1), this.model = new Qc(), this.data = new Wa(this.model), this.editing = new Ca(this.model), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new Ya([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new Kc(this), this.keystrokes.listenTo(this.editing.view.document);
      }

      _createClass(Zc, [{
        key: "initPlugins",
        value: function initPlugins() {
          var t = this.config,
              e = t.get("plugins") || [],
              n = t.get("removePlugins") || [],
              i = t.get("extraPlugins") || [];
          return this.plugins.init(e.concat(i), n);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this73 = this;

          var t = Promise.resolve();
          return "initializing" == this.state && (t = new Promise(function (t) {
            return _this73.once("ready", t);
          })), t.then(function () {
            _this73.fire("destroy"), _this73.stopListening(), _this73.commands.destroy();
          }).then(function () {
            return _this73.plugins.destroy();
          }).then(function () {
            _this73.model.destroy(), _this73.data.destroy(), _this73.editing.destroy(), _this73.keystrokes.destroy();
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this$commands;

          (_this$commands = this.commands).execute.apply(_this$commands, arguments);
        }
      }]);

      return Zc;
    }();

    ci(Zc, Fi);
    var Xc = {
      setData: function setData(t) {
        this.data.set(t);
      },
      getData: function getData(t) {
        return this.data.get(t);
      }
    };
    var tl = {
      updateSourceElement: function updateSourceElement() {
        if (!this.sourceElement) throw new Gn.b("editor-missing-sourceelement: Cannot update the source element of a detached editor.", this);
        !function (t, e) {
          t instanceof HTMLTextAreaElement && (t.value = e), t.innerHTML = e;
        }(this.sourceElement, this.data.get());
      }
    };

    var el =
    /*#__PURE__*/
    function () {
      function el() {
        _classCallCheck(this, el);
      }

      _createClass(el, [{
        key: "getHtml",
        value: function getHtml(t) {
          var e = document.implementation.createHTMLDocument("").createElement("div");
          return e.appendChild(t), e.innerHTML;
        }
      }]);

      return el;
    }();

    var nl =
    /*#__PURE__*/
    function () {
      function nl() {
        _classCallCheck(this, nl);

        this._domParser = new DOMParser(), this._domConverter = new rr({
          blockFiller: jo
        }), this._htmlWriter = new el();
      }

      _createClass(nl, [{
        key: "toData",
        value: function toData(t) {
          var e = this._domConverter.viewToDom(t, document);

          return this._htmlWriter.getHtml(e);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          var e = this._toDom(t);

          return this._domConverter.domToView(e);
        }
      }, {
        key: "_toDom",
        value: function _toDom(t) {
          var e = this._domParser.parseFromString(t, "text/html"),
              n = e.createDocumentFragment(),
              i = e.body.childNodes;

          for (; i.length > 0;) {
            n.appendChild(i[0]);
          }

          return n;
        }
      }]);

      return nl;
    }();

    var il =
    /*#__PURE__*/
    function () {
      function il(t) {
        _classCallCheck(this, il);

        this.editor = t, this._components = new Map();
      }

      _createClass(il, [{
        key: "names",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function names() {
          var _iteratorNormalCompletion230, _didIteratorError230, _iteratorError230, _iterator230, _step230, _t193;

          return _regeneratorRuntime.wrap(function names$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  _iteratorNormalCompletion230 = true;
                  _didIteratorError230 = false;
                  _iteratorError230 = undefined;
                  _context34.prev = 3;
                  _iterator230 = this._components.values()[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion230 = (_step230 = _iterator230.next()).done) {
                    _context34.next = 12;
                    break;
                  }

                  _t193 = _step230.value;
                  _context34.next = 9;
                  return _t193.originalName;

                case 9:
                  _iteratorNormalCompletion230 = true;
                  _context34.next = 5;
                  break;

                case 12:
                  _context34.next = 18;
                  break;

                case 14:
                  _context34.prev = 14;
                  _context34.t0 = _context34["catch"](3);
                  _didIteratorError230 = true;
                  _iteratorError230 = _context34.t0;

                case 18:
                  _context34.prev = 18;
                  _context34.prev = 19;

                  if (!_iteratorNormalCompletion230 && _iterator230.return != null) {
                    _iterator230.return();
                  }

                case 21:
                  _context34.prev = 21;

                  if (!_didIteratorError230) {
                    _context34.next = 24;
                    break;
                  }

                  throw _iteratorError230;

                case 24:
                  return _context34.finish(21);

                case 25:
                  return _context34.finish(18);

                case 26:
                case "end":
                  return _context34.stop();
              }
            }
          }, names, this, [[3, 14, 18, 26], [19,, 21, 25]]);
        })
      }, {
        key: "add",
        value: function add(t, e) {
          if (this.has(t)) throw new Gn.b("componentfactory-item-exists: The item already exists in the component factory.", this, {
            name: t
          });

          this._components.set(ol(t), {
            callback: e,
            originalName: t
          });
        }
      }, {
        key: "create",
        value: function create(t) {
          if (!this.has(t)) throw new Gn.b("componentfactory-item-missing: The required component is not registered in the factory.", this, {
            name: t
          });
          return this._components.get(ol(t)).callback(this.editor.locale);
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._components.has(ol(t));
        }
      }]);

      return il;
    }();

    function ol(t) {
      return String(t).toLowerCase();
    }

    var rl =
    /*#__PURE__*/
    function () {
      function rl() {
        _classCallCheck(this, rl);

        this.set("isFocused", !1), this.set("focusedElement", null), this._elements = new Set(), this._nextEventLoopTimeout = null;
      }

      _createClass(rl, [{
        key: "add",
        value: function add(t) {
          var _this74 = this;

          if (this._elements.has(t)) throw new Gn.b("focusTracker-add-element-already-exist", this);
          this.listenTo(t, "focus", function () {
            return _this74._focus(t);
          }, {
            useCapture: !0
          }), this.listenTo(t, "blur", function () {
            return _this74._blur();
          }, {
            useCapture: !0
          }), this._elements.add(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          t === this.focusedElement && this._blur(t), this._elements.has(t) && (this.stopListening(t), this._elements.delete(t));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t, this.isFocused = !0;
        }
      }, {
        key: "_blur",
        value: function _blur() {
          var _this75 = this;

          clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(function () {
            _this75.focusedElement = null, _this75.isFocused = !1;
          }, 0);
        }
      }]);

      return rl;
    }();

    ci(rl, lr), ci(rl, Fi);

    var sl =
    /*#__PURE__*/
    function () {
      function sl(t) {
        var _this76 = this;

        _classCallCheck(this, sl);

        this.editor = t, this.componentFactory = new il(t), this.focusTracker = new rl(), this._editableElementsMap = new Map(), this.listenTo(t.editing.view.document, "layoutChanged", function () {
          return _this76.update();
        });
      }

      _createClass(sl, [{
        key: "update",
        value: function update() {
          this.fire("update");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this.focusTracker.destroy();
          var _iteratorNormalCompletion231 = true;
          var _didIteratorError231 = false;
          var _iteratorError231 = undefined;

          try {
            for (var _iterator231 = this._editableElementsMap.values()[Symbol.iterator](), _step231; !(_iteratorNormalCompletion231 = (_step231 = _iterator231.next()).done); _iteratorNormalCompletion231 = true) {
              var _t194 = _step231.value;
              _t194.ckeditorInstance = null;
            }
          } catch (err) {
            _didIteratorError231 = true;
            _iteratorError231 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion231 && _iterator231.return != null) {
                _iterator231.return();
              }
            } finally {
              if (_didIteratorError231) {
                throw _iteratorError231;
              }
            }
          }

          this._editableElementsMap = new Map();
        }
      }, {
        key: "setEditableElement",
        value: function setEditableElement(t, e) {
          this._editableElementsMap.set(t, e), e.ckeditorInstance = this.editor;
        }
      }, {
        key: "getEditableElement",
        value: function getEditableElement() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this._editableElementsMap.get(t);
        }
      }, {
        key: "getEditableElementsNames",
        value: function getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
      }, {
        key: "element",
        get: function get() {
          return null;
        }
      }, {
        key: "_editableElements",
        get: function get() {
          return bs.a.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
            editorUI: this
          }), this._editableElementsMap;
        }
      }]);

      return sl;
    }();

    ci(sl, ei);
    n(50);
    var al = new WeakMap();

    function cl(t) {
      var e = t.view,
          n = t.element,
          i = t.text,
          _t$isDirectHost = t.isDirectHost,
          o = _t$isDirectHost === void 0 ? !0 : _t$isDirectHost,
          r = e.document;
      al.has(r) || (al.set(r, new Map()), r.registerPostFixer(function (t) {
        return dl(r, t);
      })), al.get(r).set(n, {
        text: i,
        isDirectHost: o
      }), e.change(function (t) {
        return dl(r, t);
      });
    }

    function ll(t, e) {
      return !!e.hasClass("ck-placeholder") && (t.removeClass("ck-placeholder", e), !0);
    }

    function dl(t, e) {
      var n = al.get(t);
      var i = !1;
      var _iteratorNormalCompletion232 = true;
      var _didIteratorError232 = false;
      var _iteratorError232 = undefined;

      try {
        for (var _iterator232 = n[Symbol.iterator](), _step232; !(_iteratorNormalCompletion232 = (_step232 = _iterator232.next()).done); _iteratorNormalCompletion232 = true) {
          var _ref82 = _step232.value;

          var _ref81 = _slicedToArray(_ref82, 2);

          var _t195 = _ref81[0];
          var _o56 = _ref81[1];
          ul(e, _t195, _o56) && (i = !0);
        }
      } catch (err) {
        _didIteratorError232 = true;
        _iteratorError232 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion232 && _iterator232.return != null) {
            _iterator232.return();
          }
        } finally {
          if (_didIteratorError232) {
            throw _iteratorError232;
          }
        }
      }

      return i;
    }

    function ul(t, e, n) {
      var i = n.text,
          o = n.isDirectHost,
          r = o ? e : function (t) {
        if (1 === t.childCount) {
          var _e172 = t.getChild(0);

          if (_e172.is("element") && !_e172.is("uiElement")) return _e172;
        }

        return null;
      }(e);
      var s = !1;
      return !!r && (n.hostElement = r, r.getAttribute("data-placeholder") !== i && (t.setAttribute("data-placeholder", i, r), s = !0), !function (t) {
        var e = t.document;
        if (!e) return !1;
        var n = !Array.from(t.getChildren()).some(function (t) {
          return !t.is("uiElement");
        });
        if (!e.isFocused && n) return !0;
        var i = e.selection.anchor;
        return !(!n || !i || i.parent === t);
      }(r) ? ll(t, r) && (s = !0) : function (t, e) {
        return !e.hasClass("ck-placeholder") && (t.addClass("ck-placeholder", e), !0);
      }(t, r) && (s = !0), s);
    }

    var hl =
    /*#__PURE__*/
    function () {
      function hl() {
        _classCallCheck(this, hl);

        this._replacedElements = [];
      }

      _createClass(hl, [{
        key: "replace",
        value: function replace(t, e) {
          this._replacedElements.push({
            element: t,
            newElement: e
          }), t.style.display = "none", e && t.parentNode.insertBefore(e, t.nextSibling);
        }
      }, {
        key: "restore",
        value: function restore() {
          this._replacedElements.forEach(function (_ref83) {
            var t = _ref83.element,
                e = _ref83.newElement;
            t.style.display = "", e && e.remove();
          }), this._replacedElements = [];
        }
      }]);

      return hl;
    }();

    var fl =
    /*#__PURE__*/
    function (_sl) {
      _inherits(fl, _sl);

      function fl(t, e) {
        var _this77;

        _classCallCheck(this, fl);

        _this77 = _possibleConstructorReturn(this, _getPrototypeOf(fl).call(this, t)), _this77.view = e, _this77._toolbarConfig = function (t) {
          return Array.isArray(t) ? {
            items: t
          } : t ? Object.assign({
            items: []
          }, t) : {
            items: []
          };
        }(t.config.get("toolbar")), _this77._elementReplacer = new hl();
        return _this77;
      }

      _createClass(fl, [{
        key: "init",
        value: function init(t) {
          var e = this.editor,
              n = this.view,
              i = e.editing.view,
              o = n.editable,
              r = i.document.getRoot();
          o.name = r.rootName, n.render();
          var s = o.element;
          this.setEditableElement(o.name, s), this.focusTracker.add(s), n.editable.bind("isFocused").to(this.focusTracker), i.attachDomRoot(s), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.view,
              e = this.editor.editing.view;
          this._elementReplacer.restore(), e.detachDomRoot(t.editable.name), t.destroy(), _get(_getPrototypeOf(fl.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_initToolbar",
        value: function _initToolbar() {
          var t = this.editor,
              e = this.view,
              n = t.editing.view;
          e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), e.stickyPanel.limiterElement = e.element, this._toolbarConfig.viewportTopOffset && (e.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset), e.toolbar.fillFromConfig(this._toolbarConfig.items, this.componentFactory), function (_ref84) {
            var t = _ref84.origin,
                e = _ref84.originKeystrokeHandler,
                n = _ref84.originFocusTracker,
                i = _ref84.toolbar,
                o = _ref84.beforeFocus,
                r = _ref84.afterBlur;
            n.add(i.element), e.set("Alt+F10", function (t, e) {
              n.isFocused && !i.focusTracker.isFocused && (o && o(), i.focus(), e());
            }), i.keystrokes.set("Esc", function (e, n) {
              i.focusTracker.isFocused && (t.focus(), r && r(), n());
            });
          }({
            origin: n,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: t.keystrokes,
            toolbar: e.toolbar
          });
        }
      }, {
        key: "_initPlaceholder",
        value: function _initPlaceholder() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document.getRoot(),
              i = t.sourceElement,
              o = t.config.get("placeholder") || i && "textarea" === i.tagName.toLowerCase() && i.getAttribute("placeholder");
          o && cl({
            view: e,
            element: n,
            text: o,
            isDirectHost: !1
          });
        }
      }, {
        key: "element",
        get: function get() {
          return this.view.element;
        }
      }]);

      return fl;
    }(sl);

    var ml =
    /*#__PURE__*/
    function (_oo) {
      _inherits(ml, _oo);

      function ml(t) {
        var _this78;

        _classCallCheck(this, ml);

        _this78 = _possibleConstructorReturn(this, _getPrototypeOf(ml).call(this, {
          idProperty: "viewUid"
        })), _this78.on("add", function (t, e, n) {
          e.isRendered || e.render(), e.element && _this78._parentElement && _this78._parentElement.insertBefore(e.element, _this78._parentElement.children[n]);
        }), _this78.on("remove", function (t, e) {
          e.element && _this78._parentElement && e.element.remove();
        }), _this78.locale = t, _this78._parentElement = null;
        return _this78;
      }

      _createClass(ml, [{
        key: "destroy",
        value: function destroy() {
          this.map(function (t) {
            return t.destroy();
          });
        }
      }, {
        key: "setParent",
        value: function setParent(t) {
          this._parentElement = t;
        }
      }, {
        key: "delegate",
        value: function delegate() {
          var _this79 = this;

          for (var _len17 = arguments.length, t = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
            t[_key17] = arguments[_key17];
          }

          if (!t.length || !function (t) {
            return t.every(function (t) {
              return "string" == typeof t;
            });
          }(t)) throw new Gn.b("ui-viewcollection-delegate-wrong-events: All event names must be strings.", this);
          return {
            to: function to(e) {
              var _iteratorNormalCompletion233 = true;
              var _didIteratorError233 = false;
              var _iteratorError233 = undefined;

              try {
                for (var _iterator233 = _this79[Symbol.iterator](), _step233; !(_iteratorNormalCompletion233 = (_step233 = _iterator233.next()).done); _iteratorNormalCompletion233 = true) {
                  var _n166 = _step233.value;

                  for (var _i127 = 0, _t198 = t; _i127 < _t198.length; _i127++) {
                    var _i128 = _t198[_i127];

                    _n166.delegate(_i128).to(e);
                  }
                }
              } catch (err) {
                _didIteratorError233 = true;
                _iteratorError233 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion233 && _iterator233.return != null) {
                    _iterator233.return();
                  }
                } finally {
                  if (_didIteratorError233) {
                    throw _iteratorError233;
                  }
                }
              }

              _this79.on("add", function (n, i) {
                for (var _i125 = 0, _t196 = t; _i125 < _t196.length; _i125++) {
                  var _n164 = _t196[_i125];
                  i.delegate(_n164).to(e);
                }
              }), _this79.on("remove", function (n, i) {
                for (var _i126 = 0, _t197 = t; _i126 < _t197.length; _i126++) {
                  var _n165 = _t197[_i126];
                  i.stopDelegating(_n165, e);
                }
              });
            }
          };
        }
      }]);

      return ml;
    }(oo);

    var pl = "http://www.w3.org/1999/xhtml";

    var gl =
    /*#__PURE__*/
    function () {
      function gl(t) {
        _classCallCheck(this, gl);

        Object.assign(this, Cl(Al(t))), this._isRendered = !1, this._revertData = null;
      }

      _createClass(gl, [{
        key: "render",
        value: function render() {
          var t = this._renderNode({
            intoFragment: !0
          });

          return this._isRendered = !0, t;
        }
      }, {
        key: "apply",
        value: function apply(t) {
          return this._revertData = {
            children: [],
            bindings: [],
            attributes: {}
          }, this._renderNode({
            node: t,
            isApplying: !0,
            revertData: this._revertData
          }), t;
        }
      }, {
        key: "revert",
        value: function revert(t) {
          if (!this._revertData) throw new Gn.b("ui-template-revert-not-applied: Attempting to revert a template which has not been applied yet.", [this, t]);

          this._revertTemplateFromNode(t, this._revertData);
        }
      }, {
        key: "getViews",
        value:
        /*#__PURE__*/
        _regeneratorRuntime.mark(function getViews() {
          return _regeneratorRuntime.wrap(function getViews$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  return _context36.delegateYield(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function t(e) {
                    var _iteratorNormalCompletion234, _didIteratorError234, _iteratorError234, _iterator234, _step234, _n167;

                    return _regeneratorRuntime.wrap(function t$(_context35) {
                      while (1) {
                        switch (_context35.prev = _context35.next) {
                          case 0:
                            if (!e.children) {
                              _context35.next = 33;
                              break;
                            }

                            _iteratorNormalCompletion234 = true;
                            _didIteratorError234 = false;
                            _iteratorError234 = undefined;
                            _context35.prev = 4;
                            _iterator234 = e.children[Symbol.iterator]();

                          case 6:
                            if (_iteratorNormalCompletion234 = (_step234 = _iterator234.next()).done) {
                              _context35.next = 19;
                              break;
                            }

                            _n167 = _step234.value;

                            if (!El(_n167)) {
                              _context35.next = 13;
                              break;
                            }

                            _context35.next = 11;
                            return _n167;

                          case 11:
                            _context35.next = 16;
                            break;

                          case 13:
                            _context35.t0 = Il(_n167);

                            if (!_context35.t0) {
                              _context35.next = 16;
                              break;
                            }

                            return _context35.delegateYield(t(_n167), "t1", 16);

                          case 16:
                            _iteratorNormalCompletion234 = true;
                            _context35.next = 6;
                            break;

                          case 19:
                            _context35.next = 25;
                            break;

                          case 21:
                            _context35.prev = 21;
                            _context35.t2 = _context35["catch"](4);
                            _didIteratorError234 = true;
                            _iteratorError234 = _context35.t2;

                          case 25:
                            _context35.prev = 25;
                            _context35.prev = 26;

                            if (!_iteratorNormalCompletion234 && _iterator234.return != null) {
                              _iterator234.return();
                            }

                          case 28:
                            _context35.prev = 28;

                            if (!_didIteratorError234) {
                              _context35.next = 31;
                              break;
                            }

                            throw _iteratorError234;

                          case 31:
                            return _context35.finish(28);

                          case 32:
                            return _context35.finish(25);

                          case 33:
                          case "end":
                            return _context35.stop();
                        }
                      }
                    }, t, null, [[4, 21, 25, 33], [26,, 28, 32]]);
                  })(this), "t0", 1);

                case 1:
                case "end":
                  return _context36.stop();
              }
            }
          }, getViews, this);
        })
      }, {
        key: "_renderNode",
        value: function _renderNode(t) {
          var e;
          if (e = t.node ? this.tag && this.text : this.tag ? this.text : !this.text) throw new Gn.b('ui-template-wrong-syntax: Node definition must have either "tag" or "text" when rendering a new Node.', this);
          return this.text ? this._renderText(t) : this._renderElement(t);
        }
      }, {
        key: "_renderElement",
        value: function _renderElement(t) {
          var e = t.node;
          return e || (e = t.node = document.createElementNS(this.ns || pl, this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), e;
        }
      }, {
        key: "_renderText",
        value: function _renderText(t) {
          var e = t.node;
          return e ? t.revertData.text = e.textContent : e = t.node = document.createTextNode(""), kl(this.text) ? this._bindToObservable({
            schema: this.text,
            updater: function (t) {
              return {
                set: function set(e) {
                  t.textContent = e;
                },
                remove: function remove() {
                  t.textContent = "";
                }
              };
            }(e),
            data: t
          }) : e.textContent = this.text.join(""), e;
        }
      }, {
        key: "_renderAttributes",
        value: function _renderAttributes(t) {
          var e, n, i, o;
          if (!this.attributes) return;
          var r = t.node,
              s = t.revertData;

          for (e in this.attributes) {
            if (i = r.getAttribute(e), n = this.attributes[e], s && (s.attributes[e] = i), o = z(n[0]) && n[0].ns ? n[0].ns : null, kl(n)) {
              var _a11 = o ? n[0].value : n;

              s && Ol(e) && _a11.unshift(i), this._bindToObservable({
                schema: _a11,
                updater: yl(r, e, o),
                data: t
              });
            } else "style" == e && "string" != typeof n[0] ? this._renderStyleAttribute(n[0], t) : (s && i && Ol(e) && n.unshift(i), Sl(n = n.map(function (t) {
              return t && t.value || t;
            }).reduce(function (t, e) {
              return t.concat(e);
            }, []).reduce(Pl, "")) || r.setAttributeNS(o, e, n));
          }
        }
      }, {
        key: "_renderStyleAttribute",
        value: function _renderStyleAttribute(t, e) {
          var n = e.node;

          for (var _i129 in t) {
            var _o57 = t[_i129];
            kl(_o57) ? this._bindToObservable({
              schema: [_o57],
              updater: xl(n, _i129),
              data: e
            }) : n.style[_i129] = _o57;
          }
        }
      }, {
        key: "_renderElementChildren",
        value: function _renderElementChildren(t) {
          var e = t.node,
              n = t.intoFragment ? document.createDocumentFragment() : e,
              i = t.isApplying;
          var o = 0;
          var _iteratorNormalCompletion235 = true;
          var _didIteratorError235 = false;
          var _iteratorError235 = undefined;

          try {
            for (var _iterator235 = this.children[Symbol.iterator](), _step235; !(_iteratorNormalCompletion235 = (_step235 = _iterator235.next()).done); _iteratorNormalCompletion235 = true) {
              var _r25 = _step235.value;

              if (Nl(_r25)) {
                if (!i) {
                  _r25.setParent(e);

                  var _iteratorNormalCompletion236 = true;
                  var _didIteratorError236 = false;
                  var _iteratorError236 = undefined;

                  try {
                    for (var _iterator236 = _r25[Symbol.iterator](), _step236; !(_iteratorNormalCompletion236 = (_step236 = _iterator236.next()).done); _iteratorNormalCompletion236 = true) {
                      var _t199 = _step236.value;
                      n.appendChild(_t199.element);
                    }
                  } catch (err) {
                    _didIteratorError236 = true;
                    _iteratorError236 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion236 && _iterator236.return != null) {
                        _iterator236.return();
                      }
                    } finally {
                      if (_didIteratorError236) {
                        throw _iteratorError236;
                      }
                    }
                  }
                }
              } else if (El(_r25)) i || (_r25.isRendered || _r25.render(), n.appendChild(_r25.element));else if (Zo(_r25)) n.appendChild(_r25);else if (i) {
                var _e173 = {
                  children: [],
                  bindings: [],
                  attributes: {}
                };
                t.revertData.children.push(_e173), _r25._renderNode({
                  node: n.childNodes[o++],
                  isApplying: !0,
                  revertData: _e173
                });
              } else n.appendChild(_r25.render());
            }
          } catch (err) {
            _didIteratorError235 = true;
            _iteratorError235 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion235 && _iterator235.return != null) {
                _iterator235.return();
              }
            } finally {
              if (_didIteratorError235) {
                throw _iteratorError235;
              }
            }
          }

          t.intoFragment && e.appendChild(n);
        }
      }, {
        key: "_setUpListeners",
        value: function _setUpListeners(t) {
          var _this80 = this;

          if (this.eventListeners) {
            var _loop4 = function _loop4(_e174) {
              var n = _this80.eventListeners[_e174].map(function (n) {
                var _e174$split = _e174.split("@"),
                    _e174$split2 = _slicedToArray(_e174$split, 2),
                    i = _e174$split2[0],
                    o = _e174$split2[1];

                return n.activateDomEventListener(i, o, t);
              });

              t.revertData && t.revertData.bindings.push(n);
            };

            for (var _e174 in this.eventListeners) {
              _loop4(_e174);
            }
          }
        }
      }, {
        key: "_bindToObservable",
        value: function _bindToObservable(_ref85) {
          var t = _ref85.schema,
              e = _ref85.updater,
              n = _ref85.data;
          var i = n.revertData;
          vl(t, e, n);
          var o = t.filter(function (t) {
            return !Sl(t);
          }).filter(function (t) {
            return t.observable;
          }).map(function (i) {
            return i.activateAttributeListener(t, e, n);
          });
          i && i.bindings.push(o);
        }
      }, {
        key: "_revertTemplateFromNode",
        value: function _revertTemplateFromNode(t, e) {
          var _iteratorNormalCompletion237 = true;
          var _didIteratorError237 = false;
          var _iteratorError237 = undefined;

          try {
            for (var _iterator237 = e.bindings[Symbol.iterator](), _step237; !(_iteratorNormalCompletion237 = (_step237 = _iterator237.next()).done); _iteratorNormalCompletion237 = true) {
              var _t200 = _step237.value;
              var _iteratorNormalCompletion238 = true;
              var _didIteratorError238 = false;
              var _iteratorError238 = undefined;

              try {
                for (var _iterator238 = _t200[Symbol.iterator](), _step238; !(_iteratorNormalCompletion238 = (_step238 = _iterator238.next()).done); _iteratorNormalCompletion238 = true) {
                  var _e175 = _step238.value;

                  _e175();
                }
              } catch (err) {
                _didIteratorError238 = true;
                _iteratorError238 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion238 && _iterator238.return != null) {
                    _iterator238.return();
                  }
                } finally {
                  if (_didIteratorError238) {
                    throw _iteratorError238;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError237 = true;
            _iteratorError237 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion237 && _iterator237.return != null) {
                _iterator237.return();
              }
            } finally {
              if (_didIteratorError237) {
                throw _iteratorError237;
              }
            }
          }

          if (e.text) t.textContent = e.text;else {
            for (var _n168 in e.attributes) {
              var _i130 = e.attributes[_n168];
              null === _i130 ? t.removeAttribute(_n168) : t.setAttribute(_n168, _i130);
            }

            for (var _n169 = 0; _n169 < e.children.length; ++_n169) {
              this._revertTemplateFromNode(t.childNodes[_n169], e.children[_n169]);
            }
          }
        }
      }], [{
        key: "bind",
        value: function bind(t, e) {
          return {
            to: function to(n, i) {
              return new wl({
                eventNameOrFunction: n,
                attribute: n,
                observable: t,
                emitter: e,
                callback: i
              });
            },
            if: function _if(n, i, o) {
              return new _l({
                observable: t,
                emitter: e,
                attribute: n,
                valueIfTrue: i,
                callback: o
              });
            }
          };
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          t._isRendered && bs.a.warn("template-extend-render: Attempting to extend a template which has already been rendered."), function t(e, n) {
            var _e$text;

            n.attributes && (e.attributes || (e.attributes = {}), Ml(e.attributes, n.attributes));
            n.eventListeners && (e.eventListeners || (e.eventListeners = {}), Ml(e.eventListeners, n.eventListeners));
            n.text && (_e$text = e.text).push.apply(_e$text, _toConsumableArray(n.text));

            if (n.children && n.children.length) {
              if (e.children.length != n.children.length) throw new Gn.b("ui-template-extend-children-mismatch: The number of children in extended definition does not match.", e);
              var _i131 = 0;
              var _iteratorNormalCompletion239 = true;
              var _didIteratorError239 = false;
              var _iteratorError239 = undefined;

              try {
                for (var _iterator239 = n.children[Symbol.iterator](), _step239; !(_iteratorNormalCompletion239 = (_step239 = _iterator239.next()).done); _iteratorNormalCompletion239 = true) {
                  var _o58 = _step239.value;
                  t(e.children[_i131++], _o58);
                }
              } catch (err) {
                _didIteratorError239 = true;
                _iteratorError239 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion239 && _iterator239.return != null) {
                    _iterator239.return();
                  }
                } finally {
                  if (_didIteratorError239) {
                    throw _iteratorError239;
                  }
                }
              }
            }
          }(t, Cl(Al(e)));
        }
      }]);

      return gl;
    }();

    ci(gl, ei);

    var bl =
    /*#__PURE__*/
    function () {
      function bl(t) {
        _classCallCheck(this, bl);

        Object.assign(this, t);
      }

      _createClass(bl, [{
        key: "getValue",
        value: function getValue(t) {
          var e = this.observable[this.attribute];
          return this.callback ? this.callback(e, t) : e;
        }
      }, {
        key: "activateAttributeListener",
        value: function activateAttributeListener(t, e, n) {
          var _this81 = this;

          var i = function i() {
            return vl(t, e, n);
          };

          return this.emitter.listenTo(this.observable, "change:" + this.attribute, i), function () {
            _this81.emitter.stopListening(_this81.observable, "change:" + _this81.attribute, i);
          };
        }
      }]);

      return bl;
    }();

    var wl =
    /*#__PURE__*/
    function (_bl) {
      _inherits(wl, _bl);

      function wl() {
        _classCallCheck(this, wl);

        return _possibleConstructorReturn(this, _getPrototypeOf(wl).apply(this, arguments));
      }

      _createClass(wl, [{
        key: "activateDomEventListener",
        value: function activateDomEventListener(t, e, n) {
          var _this82 = this;

          var i = function i(t, n) {
            e && !n.target.matches(e) || ("function" == typeof _this82.eventNameOrFunction ? _this82.eventNameOrFunction(n) : _this82.observable.fire(_this82.eventNameOrFunction, n));
          };

          return this.emitter.listenTo(n.node, t, i), function () {
            _this82.emitter.stopListening(n.node, t, i);
          };
        }
      }]);

      return wl;
    }(bl);

    var _l =
    /*#__PURE__*/
    function (_bl2) {
      _inherits(_l, _bl2);

      function _l() {
        _classCallCheck(this, _l);

        return _possibleConstructorReturn(this, _getPrototypeOf(_l).apply(this, arguments));
      }

      _createClass(_l, [{
        key: "getValue",
        value: function getValue(t) {
          return !Sl(_get(_getPrototypeOf(_l.prototype), "getValue", this).call(this, t)) && (this.valueIfTrue || !0);
        }
      }]);

      return _l;
    }(bl);

    function kl(t) {
      return !!t && (t.value && (t = t.value), Array.isArray(t) ? t.some(kl) : t instanceof bl);
    }

    function vl(t, e, _ref86) {
      var n = _ref86.node;

      var i = function (t, e) {
        return t.map(function (t) {
          return t instanceof bl ? t.getValue(e) : t;
        });
      }(t, n);

      Sl(i = 1 == t.length && t[0] instanceof _l ? i[0] : i.reduce(Pl, "")) ? e.remove() : e.set(i);
    }

    function yl(t, e, n) {
      return {
        set: function set(i) {
          t.setAttributeNS(n, e, i);
        },
        remove: function remove() {
          t.removeAttributeNS(n, e);
        }
      };
    }

    function xl(t, e) {
      return {
        set: function set(n) {
          t.style[e] = n;
        },
        remove: function remove() {
          t.style[e] = null;
        }
      };
    }

    function Al(t) {
      return qn(t, function (t) {
        if (t && (t instanceof bl || Il(t) || El(t) || Nl(t))) return t;
      });
    }

    function Cl(t) {
      if ("string" == typeof t ? t = function (t) {
        return {
          text: [t]
        };
      }(t) : t.text && function (t) {
        Array.isArray(t.text) || (t.text = [t.text]);
      }(t), t.on && (t.eventListeners = function (t) {
        for (var _e176 in t) {
          Tl(t, _e176);
        }

        return t;
      }(t.on), delete t.on), !t.text) {
        t.attributes && function (t) {
          for (var _e178 in t) {
            t[_e178].value && (t[_e178].value = [].concat(t[_e178].value)), Tl(t, _e178);
          }
        }(t.attributes);
        var _e177 = [];
        if (t.children) if (Nl(t.children)) _e177.push(t.children);else {
          var _iteratorNormalCompletion240 = true;
          var _didIteratorError240 = false;
          var _iteratorError240 = undefined;

          try {
            for (var _iterator240 = t.children[Symbol.iterator](), _step240; !(_iteratorNormalCompletion240 = (_step240 = _iterator240.next()).done); _iteratorNormalCompletion240 = true) {
              var _n170 = _step240.value;
              Il(_n170) || El(_n170) || Zo(_n170) ? _e177.push(_n170) : _e177.push(new gl(_n170));
            }
          } catch (err) {
            _didIteratorError240 = true;
            _iteratorError240 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion240 && _iterator240.return != null) {
                _iterator240.return();
              }
            } finally {
              if (_didIteratorError240) {
                throw _iteratorError240;
              }
            }
          }
        }
        t.children = _e177;
      }

      return t;
    }

    function Tl(t, e) {
      Array.isArray(t[e]) || (t[e] = [t[e]]);
    }

    function Pl(t, e) {
      return Sl(e) ? t : Sl(t) ? e : "".concat(t, " ").concat(e);
    }

    function Ml(t, e) {
      for (var _n171 in e) {
        var _t$_n;

        t[_n171] ? (_t$_n = t[_n171]).push.apply(_t$_n, _toConsumableArray(e[_n171])) : t[_n171] = e[_n171];
      }
    }

    function Sl(t) {
      return !t && 0 !== t;
    }

    function El(t) {
      return t instanceof Rl;
    }

    function Il(t) {
      return t instanceof gl;
    }

    function Nl(t) {
      return t instanceof ml;
    }

    function Ol(t) {
      return "class" == t || "style" == t;
    }

    n(53);

    var Rl =
    /*#__PURE__*/
    function () {
      function Rl(t) {
        _classCallCheck(this, Rl);

        this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new oo(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", function (e, n) {
          n.locale = t;
        }), this.decorate("render");
      }

      _createClass(Rl, [{
        key: "createCollection",
        value: function createCollection() {
          var t = new ml();
          return this._viewCollections.add(t), t;
        }
      }, {
        key: "registerChild",
        value: function registerChild(t) {
          gi(t) || (t = [t]);
          var _iteratorNormalCompletion241 = true;
          var _didIteratorError241 = false;
          var _iteratorError241 = undefined;

          try {
            for (var _iterator241 = t[Symbol.iterator](), _step241; !(_iteratorNormalCompletion241 = (_step241 = _iterator241.next()).done); _iteratorNormalCompletion241 = true) {
              var _e179 = _step241.value;

              this._unboundChildren.add(_e179);
            }
          } catch (err) {
            _didIteratorError241 = true;
            _iteratorError241 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion241 && _iterator241.return != null) {
                _iterator241.return();
              }
            } finally {
              if (_didIteratorError241) {
                throw _iteratorError241;
              }
            }
          }
        }
      }, {
        key: "deregisterChild",
        value: function deregisterChild(t) {
          gi(t) || (t = [t]);
          var _iteratorNormalCompletion242 = true;
          var _didIteratorError242 = false;
          var _iteratorError242 = undefined;

          try {
            for (var _iterator242 = t[Symbol.iterator](), _step242; !(_iteratorNormalCompletion242 = (_step242 = _iterator242.next()).done); _iteratorNormalCompletion242 = true) {
              var _e180 = _step242.value;

              this._unboundChildren.remove(_e180);
            }
          } catch (err) {
            _didIteratorError242 = true;
            _iteratorError242 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion242 && _iterator242.return != null) {
                _iterator242.return();
              }
            } finally {
              if (_didIteratorError242) {
                throw _iteratorError242;
              }
            }
          }
        }
      }, {
        key: "setTemplate",
        value: function setTemplate(t) {
          this.template = new gl(t);
        }
      }, {
        key: "extendTemplate",
        value: function extendTemplate(t) {
          gl.extend(this.template, t);
        }
      }, {
        key: "render",
        value: function render() {
          if (this.isRendered) throw new Gn.b("ui-view-render-already-rendered: This View has already been rendered.", this);
          this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this._viewCollections.map(function (t) {
            return t.destroy();
          }), this.template && this.template._revertData && this.template.revert(this.element);
        }
      }, {
        key: "bindTemplate",
        get: function get() {
          return this._bindTemplate ? this._bindTemplate : this._bindTemplate = gl.bind(this, this);
        }
      }]);

      return Rl;
    }();

    ci(Rl, lr), ci(Rl, Fi);
    n(55);

    var Dl =
    /*#__PURE__*/
    function (_Rl) {
      _inherits(Dl, _Rl);

      function Dl(t) {
        var _this83;

        _classCallCheck(this, Dl);

        _this83 = _possibleConstructorReturn(this, _getPrototypeOf(Dl).call(this, t)), _this83.body = _this83.createCollection();
        return _this83;
      }

      _createClass(Dl, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Dl.prototype), "render", this).call(this), this._renderBodyCollection();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this._bodyCollectionContainer.remove(), _get(_getPrototypeOf(Dl.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_renderBodyCollection",
        value: function _renderBodyCollection() {
          var t = this._bodyCollectionContainer = new gl({
            tag: "div",
            attributes: {
              class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"]
            },
            children: this.body
          }).render();
          document.body.appendChild(t);
        }
      }]);

      return Dl;
    }(Rl);

    n(57);

    var Ll =
    /*#__PURE__*/
    function (_Rl2) {
      _inherits(Ll, _Rl2);

      function Ll(t) {
        var _this84;

        _classCallCheck(this, Ll);

        _this84 = _possibleConstructorReturn(this, _getPrototypeOf(Ll).call(this, t)), _this84.set("text"), _this84.set("for");
        var e = _this84.bindTemplate;

        _this84.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            for: e.to("for")
          },
          children: [{
            text: e.to("text")
          }]
        });

        return _this84;
      }

      return Ll;
    }(Rl);

    var jl =
    /*#__PURE__*/
    function (_Dl) {
      _inherits(jl, _Dl);

      function jl(t) {
        var _this85;

        _classCallCheck(this, jl);

        _this85 = _possibleConstructorReturn(this, _getPrototypeOf(jl).call(this, t));
        var e = Kn();
        _this85.top = _this85.createCollection(), _this85.main = _this85.createCollection(), _this85._voiceLabelView = _this85._createVoiceLabel(e), _this85.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: "ltr",
            lang: t.language,
            "aria-labelledby": "ck-editor__aria-label_".concat(e)
          },
          children: [_this85._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: _this85.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: _this85.main
          }]
        });
        return _this85;
      }

      _createClass(jl, [{
        key: "_createVoiceLabel",
        value: function _createVoiceLabel(t) {
          var e = this.t,
              n = new Ll();
          return n.text = e("bk"), n.extendTemplate({
            attributes: {
              id: "ck-editor__aria-label_".concat(t),
              class: "ck-voice-label"
            }
          }), n;
        }
      }]);

      return jl;
    }(Dl);

    var Vl =
    /*#__PURE__*/
    function (_Rl3) {
      _inherits(Vl, _Rl3);

      function Vl(t, e, n) {
        var _this86;

        _classCallCheck(this, Vl);

        _this86 = _possibleConstructorReturn(this, _getPrototypeOf(Vl).call(this, t)), _this86.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"]
          }
        }), _this86.name = null, _this86.set("isFocused", !1), _this86._editableElement = n, _this86._hasExternalElement = !!_this86._editableElement, _this86._editingView = e;
        return _this86;
      }

      _createClass(Vl, [{
        key: "render",
        value: function render() {
          var _this87 = this;

          _get(_getPrototypeOf(Vl.prototype), "render", this).call(this), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
            return _this87._updateIsFocusedClasses();
          }), this._updateIsFocusedClasses();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._hasExternalElement && this.template.revert(this._editableElement), _get(_getPrototypeOf(Vl.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_updateIsFocusedClasses",
        value: function _updateIsFocusedClasses() {
          var t = this._editingView;

          function e(e) {
            t.change(function (n) {
              var i = t.document.getRoot(e.name);
              n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", i), n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", i);
            });
          }

          t.isRenderingInProgress ? function n(i) {
            t.once("change:isRenderingInProgress", function (t, o, r) {
              r ? n(i) : e(i);
            });
          }(this) : e(this);
        }
      }]);

      return Vl;
    }(Rl);

    var Bl =
    /*#__PURE__*/
    function (_Vl) {
      _inherits(Bl, _Vl);

      function Bl(t, e, n) {
        var _this88;

        _classCallCheck(this, Bl);

        _this88 = _possibleConstructorReturn(this, _getPrototypeOf(Bl).call(this, t, e, n)), _this88.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        });
        return _this88;
      }

      _createClass(Bl, [{
        key: "render",
        value: function render() {
          var _this89 = this;

          _get(_getPrototypeOf(Bl.prototype), "render", this).call(this);

          var t = this._editingView,
              e = this.t;
          t.change(function (n) {
            var i = t.document.getRoot(_this89.name);
            n.setAttribute("aria-label", e("cd", [_this89.name]), i);
          });
        }
      }]);

      return Bl;
    }(Vl);

    function zl(t) {
      return function (e) {
        return e + t;
      };
    }

    n(59);
    var Fl = zl("px");

    var Ul =
    /*#__PURE__*/
    function (_Rl4) {
      _inherits(Ul, _Rl4);

      function Ul(t) {
        var _this90;

        _classCallCheck(this, Ul);

        _this90 = _possibleConstructorReturn(this, _getPrototypeOf(Ul).call(this, t));
        var e = _this90.bindTemplate;
        _this90.set("isActive", !1), _this90.set("isSticky", !1), _this90.set("limiterElement", null), _this90.set("limiterBottomOffset", 50), _this90.set("viewportTopOffset", 0), _this90.set("_marginLeft", null), _this90.set("_isStickyToTheLimiter", !1), _this90.set("_hasViewportTopOffset", !1), _this90.content = _this90.createCollection(), _this90._contentPanelPlaceholder = new gl({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: e.to("isSticky", function (t) {
                return t ? "block" : "none";
              }),
              height: e.to("isSticky", function (t) {
                return t ? Fl(_this90._panelRect.height) : null;
              })
            }
          }
        }).render(), _this90._contentPanel = new gl({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: e.to("isSticky", function (t) {
                return t ? Fl(_this90._contentPanelPlaceholder.getBoundingClientRect().width) : null;
              }),
              top: e.to("_hasViewportTopOffset", function (t) {
                return t ? Fl(_this90.viewportTopOffset) : null;
              }),
              bottom: e.to("_isStickyToTheLimiter", function (t) {
                return t ? Fl(_this90.limiterBottomOffset) : null;
              }),
              marginLeft: e.to("_marginLeft")
            }
          },
          children: _this90.content
        }).render(), _this90.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [_this90._contentPanelPlaceholder, _this90._contentPanel]
        });
        return _this90;
      }

      _createClass(Ul, [{
        key: "render",
        value: function render() {
          var _this91 = this;

          _get(_getPrototypeOf(Ul.prototype), "render", this).call(this), this._checkIfShouldBeSticky(), this.listenTo(nr.window, "scroll", function () {
            _this91._checkIfShouldBeSticky();
          }), this.listenTo(this, "change:isActive", function () {
            _this91._checkIfShouldBeSticky();
          });
        }
      }, {
        key: "_checkIfShouldBeSticky",
        value: function _checkIfShouldBeSticky() {
          var t = this._panelRect = this._contentPanel.getBoundingClientRect();

          var e;
          this.limiterElement ? (e = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && e.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < e.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = e.bottom < t.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : Fl(-nr.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
        }
      }]);

      return Ul;
    }(Rl);

    var Hl =
    /*#__PURE__*/
    function () {
      function Hl(t) {
        var _this92 = this;

        _classCallCheck(this, Hl);

        if (Object.assign(this, t), t.actions && t.keystrokeHandler) {
          var _loop5 = function _loop5(_e181) {
            var n = t.actions[_e181];
            "string" == typeof n && (n = [n]);
            var _iteratorNormalCompletion243 = true;
            var _didIteratorError243 = false;
            var _iteratorError243 = undefined;

            try {
              for (var _iterator243 = n[Symbol.iterator](), _step243; !(_iteratorNormalCompletion243 = (_step243 = _iterator243.next()).done); _iteratorNormalCompletion243 = true) {
                var _i132 = _step243.value;
                t.keystrokeHandler.set(_i132, function (t, n) {
                  _this92[_e181](), n();
                });
              }
            } catch (err) {
              _didIteratorError243 = true;
              _iteratorError243 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion243 && _iterator243.return != null) {
                  _iterator243.return();
                }
              } finally {
                if (_didIteratorError243) {
                  throw _iteratorError243;
                }
              }
            }
          };

          for (var _e181 in t.actions) {
            _loop5(_e181);
          }
        }
      }

      _createClass(Hl, [{
        key: "focusFirst",
        value: function focusFirst() {
          this._focus(this.first);
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focus(this.last);
        }
      }, {
        key: "focusNext",
        value: function focusNext() {
          this._focus(this.next);
        }
      }, {
        key: "focusPrevious",
        value: function focusPrevious() {
          this._focus(this.previous);
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          t && t.focus();
        }
      }, {
        key: "_getFocusableItem",
        value: function _getFocusableItem(t) {
          var e = this.current,
              n = this.focusables.length;
          if (!n) return null;
          if (null === e) return this[1 === t ? "first" : "last"];
          var i = (e + n + t) % n;

          do {
            var _e182 = this.focusables.get(i);

            if (ql(_e182)) return _e182;
            i = (i + n + t) % n;
          } while (i !== e);

          return null;
        }
      }, {
        key: "first",
        get: function get() {
          return this.focusables.find(ql) || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this.focusables.filter(ql).slice(-1)[0] || null;
        }
      }, {
        key: "next",
        get: function get() {
          return this._getFocusableItem(1);
        }
      }, {
        key: "previous",
        get: function get() {
          return this._getFocusableItem(-1);
        }
      }, {
        key: "current",
        get: function get() {
          var _this93 = this;

          var t = null;
          return null === this.focusTracker.focusedElement ? null : (this.focusables.find(function (e, n) {
            var i = e.element === _this93.focusTracker.focusedElement;
            return i && (t = n), i;
          }), t);
        }
      }]);

      return Hl;
    }();

    function ql(t) {
      return !(!t.focus || "none" == nr.window.getComputedStyle(t.element).display);
    }

    var Wl =
    /*#__PURE__*/
    function (_Rl5) {
      _inherits(Wl, _Rl5);

      function Wl(t) {
        var _this94;

        _classCallCheck(this, Wl);

        _this94 = _possibleConstructorReturn(this, _getPrototypeOf(Wl).call(this, t)), _this94.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
        return _this94;
      }

      return Wl;
    }(Rl);

    n(61);

    var Yl =
    /*#__PURE__*/
    function (_Rl6) {
      _inherits(Yl, _Rl6);

      function Yl(t) {
        var _this95;

        _classCallCheck(this, Yl);

        _this95 = _possibleConstructorReturn(this, _getPrototypeOf(Yl).call(this, t));
        var e = _this95.bindTemplate;
        _this95.items = _this95.createCollection(), _this95.focusTracker = new rl(), _this95.keystrokes = new Jc(), _this95.set("isVertical", !1), _this95.set("class"), _this95._focusCycler = new Hl({
          focusables: _this95.items,
          focusTracker: _this95.focusTracker,
          keystrokeHandler: _this95.keystrokes,
          actions: {
            focusPrevious: ["arrowleft", "arrowup"],
            focusNext: ["arrowright", "arrowdown"]
          }
        }), _this95.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar", e.if("isVertical", "ck-toolbar_vertical"), e.to("class")]
          },
          children: _this95.items,
          on: {
            mousedown: function (t) {
              return t.bindTemplate.to(function (e) {
                e.target === t.element && e.preventDefault();
              });
            }(_assertThisInitialized(_this95))
          }
        });
        return _this95;
      }

      _createClass(Yl, [{
        key: "render",
        value: function render() {
          var _this96 = this;

          _get(_getPrototypeOf(Yl.prototype), "render", this).call(this);

          var _iteratorNormalCompletion244 = true;
          var _didIteratorError244 = false;
          var _iteratorError244 = undefined;

          try {
            for (var _iterator244 = this.items[Symbol.iterator](), _step244; !(_iteratorNormalCompletion244 = (_step244 = _iterator244.next()).done); _iteratorNormalCompletion244 = true) {
              var _t201 = _step244.value;
              this.focusTracker.add(_t201.element);
            }
          } catch (err) {
            _didIteratorError244 = true;
            _iteratorError244 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion244 && _iterator244.return != null) {
                _iterator244.return();
              }
            } finally {
              if (_didIteratorError244) {
                throw _iteratorError244;
              }
            }
          }

          this.items.on("add", function (t, e) {
            _this96.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this96.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }, {
        key: "fillFromConfig",
        value: function fillFromConfig(t, e) {
          var _this97 = this;

          t.map(function (t) {
            "|" == t ? _this97.items.add(new Wl()) : e.has(t) ? _this97.items.add(e.create(t)) : bs.a.warn("toolbarview-item-unavailable: The requested toolbar item is unavailable.", {
              name: t
            });
          });
        }
      }]);

      return Yl;
    }(Rl);

    n(63);

    var $l =
    /*#__PURE__*/
    function (_jl) {
      _inherits($l, _jl);

      function $l(t, e) {
        var _this98;

        _classCallCheck(this, $l);

        _this98 = _possibleConstructorReturn(this, _getPrototypeOf($l).call(this, t)), _this98.stickyPanel = new Ul(t), _this98.toolbar = new Yl(t), _this98.editable = new Bl(t, e);
        return _this98;
      }

      _createClass($l, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf($l.prototype), "render", this).call(this), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
        }
      }]);

      return $l;
    }(jl);

    var Gl =
    /*#__PURE__*/
    function (_Zc) {
      _inherits(Gl, _Zc);

      function Gl(t, e) {
        var _this99;

        _classCallCheck(this, Gl);

        _this99 = _possibleConstructorReturn(this, _getPrototypeOf(Gl).call(this, e)), Wn(t) && (_this99.sourceElement = t), _this99.data.processor = new nl(), _this99.model.document.createRoot(), _this99.ui = new fl(_assertThisInitialized(_this99), new $l(_this99.locale, _this99.editing.view)), function (t) {
          if (!W(t.updateSourceElement)) throw new Gn.b("attachtoform-missing-elementapi-interface: Editor passed to attachToForm() must implement ElementApi.", t);
          var e = t.sourceElement;

          if (e && "textarea" === e.tagName.toLowerCase() && e.form) {
            var _n172;

            var _i133 = e.form,
                _o59 = function _o59() {
              return t.updateSourceElement();
            };

            W(_i133.submit) && (_n172 = _i133.submit, _i133.submit = function () {
              _o59(), _n172.apply(_i133);
            }), _i133.addEventListener("submit", _o59), t.on("destroy", function () {
              _i133.removeEventListener("submit", _o59), _n172 && (_i133.submit = _n172);
            });
          }
        }(_assertThisInitialized(_this99));
        return _this99;
      }

      _createClass(Gl, [{
        key: "destroy",
        value: function destroy() {
          return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), _get(_getPrototypeOf(Gl.prototype), "destroy", this).call(this);
        }
      }], [{
        key: "create",
        value: function create(t) {
          var _this100 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new Promise(function (n) {
            var i = new _this100(t, e);
            n(i.initPlugins().then(function () {
              return i.ui.init(Wn(t) ? t : null);
            }).then(function () {
              if (!Wn(t) && e.initialData) throw new Gn.b("editor-create-initial-data: The config.initialData option cannot be used together with initial data passed in Editor.create().", null);

              var n = e.initialData || function (t) {
                return Wn(t) ? function (t) {
                  return t instanceof HTMLTextAreaElement ? t.value : t.innerHTML;
                }(t) : t;
              }(t);

              return i.data.init(n);
            }).then(function () {
              return i.fire("ready");
            }).then(function () {
              return i;
            }));
          });
        }
      }]);

      return Gl;
    }(Zc);

    ci(Gl, Xc), ci(Gl, tl);

    var Ql =
    /*#__PURE__*/
    function () {
      function Ql(t) {
        _classCallCheck(this, Ql);

        this.editor = t;
      }

      _createClass(Ql, [{
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);

      return Ql;
    }();

    ci(Ql, Fi);

    var Jl =
    /*#__PURE__*/
    function () {
      function Jl(t) {
        _classCallCheck(this, Jl);

        this.files = function (t) {
          var e = t.files ? Array.from(t.files) : [],
              n = t.items ? Array.from(t.items) : [];
          if (e.length) return e;
          return n.filter(function (t) {
            return "file" === t.kind;
          }).map(function (t) {
            return t.getAsFile();
          });
        }(t), this._native = t;
      }

      _createClass(Jl, [{
        key: "getData",
        value: function getData(t) {
          return this._native.getData(t);
        }
      }, {
        key: "setData",
        value: function setData(t, e) {
          this._native.setData(t, e);
        }
      }, {
        key: "types",
        get: function get() {
          return this._native.types;
        }
      }]);

      return Jl;
    }();

    var Kl =
    /*#__PURE__*/
    function (_ts5) {
      _inherits(Kl, _ts5);

      function Kl(t) {
        var _this101;

        _classCallCheck(this, Kl);

        _this101 = _possibleConstructorReturn(this, _getPrototypeOf(Kl).call(this, t));
        var e = _this101.document;

        function n(t, n) {
          n.preventDefault();
          var i = n.dropRange ? [n.dropRange] : Array.from(e.selection.getRanges()),
              o = new Jn(e, "clipboardInput");
          e.fire(o, {
            dataTransfer: n.dataTransfer,
            targetRanges: i
          }), o.stop.called && n.stopPropagation();
        }

        _this101.domEventType = ["paste", "copy", "cut", "drop", "dragover"], _this101.listenTo(e, "paste", n, {
          priority: "low"
        }), _this101.listenTo(e, "drop", n, {
          priority: "low"
        });
        return _this101;
      }

      _createClass(Kl, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          var e = {
            dataTransfer: new Jl(t.clipboardData ? t.clipboardData : t.dataTransfer)
          };
          "drop" == t.type && (e.dropRange = function (t, e) {
            var n = e.target.ownerDocument,
                i = e.clientX,
                o = e.clientY;
            var r;
            n.caretRangeFromPoint && n.caretRangeFromPoint(i, o) ? r = n.caretRangeFromPoint(i, o) : e.rangeParent && ((r = n.createRange()).setStart(e.rangeParent, e.rangeOffset), r.collapse(!0));
            return r ? t.domConverter.domRangeToView(r) : t.document.selection.getFirstRange();
          }(this.view, t)), this.fire(t.type, t, e);
        }
      }]);

      return Kl;
    }(ts);

    var Zl = ["figcaption", "li"];

    var Xl =
    /*#__PURE__*/
    function (_Ql) {
      _inherits(Xl, _Ql);

      function Xl() {
        _classCallCheck(this, Xl);

        return _possibleConstructorReturn(this, _getPrototypeOf(Xl).apply(this, arguments));
      }

      _createClass(Xl, [{
        key: "init",
        value: function init() {
          var _this102 = this;

          var t = this.editor,
              e = t.model.document,
              n = t.editing.view,
              i = n.document;

          function o(n, o) {
            var r = o.dataTransfer;
            o.preventDefault();
            var s = t.data.toView(t.model.getSelectedContent(e.selection));
            i.fire("clipboardOutput", {
              dataTransfer: r,
              content: s,
              method: n.name
            });
          }

          this._htmlDataProcessor = new nl(), n.addObserver(Kl), this.listenTo(i, "clipboardInput", function (e) {
            t.isReadOnly && e.stop();
          }, {
            priority: "highest"
          }), this.listenTo(i, "clipboardInput", function (t, e) {
            var i = e.dataTransfer;
            var o = "";
            i.getData("text/html") ? o = function (t) {
              return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
                return 1 == e.length ? " " : e;
              });
            }(i.getData("text/html")) : i.getData("text/plain") && (o = function (t) {
              return (t = t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "</p><p>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).indexOf("</p><p>") > -1 && (t = "<p>".concat(t, "</p>")), t;
            }(i.getData("text/plain"))), o = _this102._htmlDataProcessor.toView(o), _this102.fire("inputTransformation", {
              content: o,
              dataTransfer: i
            }), n.scrollToTheSelection();
          }, {
            priority: "low"
          }), this.listenTo(this, "inputTransformation", function (t, e) {
            if (!e.content.isEmpty) {
              var _t202 = _this102.editor.data,
                  _n173 = _this102.editor.model,
                  _i134 = _t202.toModel(e.content, "$clipboardHolder");

              if (0 == _i134.childCount) return;

              _n173.insertContent(_i134);
            }
          }, {
            priority: "low"
          }), this.listenTo(i, "copy", o, {
            priority: "low"
          }), this.listenTo(i, "cut", function (e, n) {
            t.isReadOnly ? n.preventDefault() : o(e, n);
          }, {
            priority: "low"
          }), this.listenTo(i, "clipboardOutput", function (n, i) {
            i.content.isEmpty || (i.dataTransfer.setData("text/html", _this102._htmlDataProcessor.toData(i.content)), i.dataTransfer.setData("text/plain", function t(e) {
              var n = "";
              if (e.is("text") || e.is("textProxy")) n = e.data;else if (e.is("img") && e.hasAttribute("alt")) n = e.getAttribute("alt");else {
                var _i135 = null;
                var _iteratorNormalCompletion245 = true;
                var _didIteratorError245 = false;
                var _iteratorError245 = undefined;

                try {
                  for (var _iterator245 = e.getChildren()[Symbol.iterator](), _step245; !(_iteratorNormalCompletion245 = (_step245 = _iterator245.next()).done); _iteratorNormalCompletion245 = true) {
                    var _o60 = _step245.value;

                    var _e183 = t(_o60);

                    _i135 && (_i135.is("containerElement") || _o60.is("containerElement")) && (Zl.includes(_i135.name) || Zl.includes(_o60.name) ? n += "\n" : n += "\n\n"), n += _e183, _i135 = _o60;
                  }
                } catch (err) {
                  _didIteratorError245 = true;
                  _iteratorError245 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion245 && _iterator245.return != null) {
                      _iterator245.return();
                    }
                  } finally {
                    if (_didIteratorError245) {
                      throw _iteratorError245;
                    }
                  }
                }
              }
              return n;
            }(i.content))), "cut" == i.method && t.model.deleteContent(e.selection);
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Clipboard";
        }
      }]);

      return Xl;
    }(Ql);

    var td =
    /*#__PURE__*/
    function () {
      function td(t) {
        var _this103 = this;

        _classCallCheck(this, td);

        this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", function () {
          _this103.refresh();
        }), this.on("execute", function (t) {
          _this103.isEnabled || t.stop();
        }, {
          priority: "high"
        }), this.listenTo(t, "change:isReadOnly", function (t, e, n) {
          n ? _this103.forceDisabled("readOnlyMode") : _this103.clearForceDisabled("readOnlyMode");
        });
      }

      _createClass(td, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = !0;
        }
      }, {
        key: "forceDisabled",
        value: function forceDisabled(t) {
          this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", ed, {
            priority: "highest"
          }), this.isEnabled = !1);
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(t) {
          this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", ed), this.refresh());
        }
      }, {
        key: "execute",
        value: function execute() {}
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);

      return td;
    }();

    function ed(t) {
      t.return = !1, t.stop();
    }

    ci(td, Fi);

    var nd =
    /*#__PURE__*/
    function (_td) {
      _inherits(nd, _td);

      function nd() {
        _classCallCheck(this, nd);

        return _possibleConstructorReturn(this, _getPrototypeOf(nd).apply(this, arguments));
      }

      _createClass(nd, [{
        key: "execute",
        value: function execute() {
          var _this104 = this;

          var t = this.editor.model,
              e = t.document;
          t.change(function (n) {
            !function (t, e, n, i) {
              var o = n.isCollapsed,
                  r = n.getFirstRange(),
                  s = r.start.parent,
                  a = r.end.parent;
              if (i.isLimit(s) || i.isLimit(a)) return void (o || s != a || t.deleteContent(n));
              if (o) id(e, r.start);else {
                var _i136 = !(r.start.isAtStart && r.end.isAtEnd),
                    _o61 = s == a;

                t.deleteContent(n, {
                  leaveUnmerged: _i136
                }), _i136 && (_o61 ? id(e, n.focus) : e.setSelection(a, 0));
              }
            }(_this104.editor.model, n, e.selection, t.schema), _this104.fire("afterExecute", {
              writer: n
            });
          });
        }
      }]);

      return nd;
    }(td);

    function id(t, e) {
      t.split(e), t.setSelection(e.parent.nextSibling, 0);
    }

    var od =
    /*#__PURE__*/
    function (_hr5) {
      _inherits(od, _hr5);

      function od(t) {
        var _this105;

        _classCallCheck(this, od);

        _this105 = _possibleConstructorReturn(this, _getPrototypeOf(od).call(this, t));
        var e = _this105.document;
        e.on("keydown", function (t, n) {
          if (_this105.isEnabled && n.keyCode == bo.enter) {
            var _i137;

            e.once("enter", function (t) {
              return _i137 = t;
            }, {
              priority: "highest"
            }), e.fire("enter", new Xr(e, n.domEvent, {
              isSoft: n.shiftKey
            })), _i137 && _i137.stop.called && t.stop();
          }
        });
        return _this105;
      }

      _createClass(od, [{
        key: "observe",
        value: function observe() {}
      }]);

      return od;
    }(hr);

    var rd =
    /*#__PURE__*/
    function (_Ql2) {
      _inherits(rd, _Ql2);

      function rd() {
        _classCallCheck(this, rd);

        return _possibleConstructorReturn(this, _getPrototypeOf(rd).apply(this, arguments));
      }

      _createClass(rd, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document;
          e.addObserver(od), t.commands.add("enter", new nd(t)), this.listenTo(n, "enter", function (n, i) {
            i.preventDefault(), i.isSoft || (t.execute("enter"), e.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Enter";
        }
      }]);

      return rd;
    }(Ql);

    var sd =
    /*#__PURE__*/
    function (_td2) {
      _inherits(sd, _td2);

      function sd() {
        _classCallCheck(this, sd);

        return _possibleConstructorReturn(this, _getPrototypeOf(sd).apply(this, arguments));
      }

      _createClass(sd, [{
        key: "execute",
        value: function execute() {
          var _this106 = this;

          var t = this.editor.model,
              e = t.document;
          t.change(function (n) {
            !function (t, e, n) {
              var i = n.isCollapsed,
                  o = n.getFirstRange(),
                  r = o.start.parent,
                  s = o.end.parent,
                  a = r == s;
              if (i) ad(e, o.end);else {
                var _i138 = !(o.start.isAtStart && o.end.isAtEnd);

                t.deleteContent(n, {
                  leaveUnmerged: _i138
                }), a ? ad(e, n.focus) : _i138 && e.setSelection(s, 0);
              }
            }(t, n, e.selection), _this106.fire("afterExecute", {
              writer: n
            });
          });
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;

          this.isEnabled = function (t, e) {
            if (e.rangeCount > 1) return !1;
            var n = e.anchor;
            if (!n || !t.checkChild(n, "softBreak")) return !1;
            var i = e.getFirstRange(),
                o = i.start.parent,
                r = i.end.parent;
            if ((cd(o, t) || cd(r, t)) && o !== r) return !1;
            return !0;
          }(t.schema, e.selection);
        }
      }]);

      return sd;
    }(td);

    function ad(t, e) {
      var n = t.createElement("softBreak");
      t.insert(n, e), t.setSelection(n, "after");
    }

    function cd(t, e) {
      return !t.is("rootElement") && (e.isLimit(t) || cd(t.parent, e));
    }

    var ld =
    /*#__PURE__*/
    function (_Ql3) {
      _inherits(ld, _Ql3);

      function ld() {
        _classCallCheck(this, ld);

        return _possibleConstructorReturn(this, _getPrototypeOf(ld).apply(this, arguments));
      }

      _createClass(ld, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.conversion,
              i = t.editing.view,
              o = i.document;
          e.register("softBreak", {
            allowWhere: "$text",
            isInline: !0
          }), n.for("upcast").elementToElement({
            model: "softBreak",
            view: "br"
          }), n.for("downcast").elementToElement({
            model: "softBreak",
            view: function view(t, e) {
              return e.createEmptyElement("br");
            }
          }), i.addObserver(od), t.commands.add("shiftEnter", new sd(t)), this.listenTo(o, "enter", function (e, n) {
            n.preventDefault(), n.isSoft && (t.execute("shiftEnter"), i.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ShiftEnter";
        }
      }]);

      return ld;
    }(Ql);

    var dd =
    /*#__PURE__*/
    function () {
      function dd(t) {
        var _this107 = this;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

        _classCallCheck(this, dd);

        this.model = t, this.size = 0, this.limit = e, this.isLocked = !1, this._changeCallback = function (t, e) {
          "transparent" != e.type && e !== _this107._batch && _this107._reset(!0);
        }, this._selectionChangeCallback = function () {
          _this107._reset();
        }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }

      _createClass(dd, [{
        key: "input",
        value: function input(t) {
          this.size += t, this.size >= this.limit && this._reset(!0);
        }
      }, {
        key: "lock",
        value: function lock() {
          this.isLocked = !0;
        }
      }, {
        key: "unlock",
        value: function unlock() {
          this.isLocked = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
        }
      }, {
        key: "_reset",
        value: function _reset(t) {
          this.isLocked && !t || (this._batch = null, this.size = 0);
        }
      }, {
        key: "batch",
        get: function get() {
          return this._batch || (this._batch = this.model.createBatch()), this._batch;
        }
      }]);

      return dd;
    }();

    var ud =
    /*#__PURE__*/
    function (_td3) {
      _inherits(ud, _td3);

      function ud(t, e) {
        var _this108;

        _classCallCheck(this, ud);

        _this108 = _possibleConstructorReturn(this, _getPrototypeOf(ud).call(this, t)), _this108._buffer = new dd(t.model, e);
        return _this108;
      }

      _createClass(ud, [{
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(ud.prototype), "destroy", this).call(this), this._buffer.destroy();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this109 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document,
              i = t.text || "",
              o = i.length,
              r = t.range || n.selection.getFirstRange(),
              s = t.resultRange;
          e.enqueueChange(this._buffer.batch, function (t) {
            var a = r.isCollapsed;
            _this109._buffer.lock(), e.deleteContent(e.createSelection(r)), i && e.insertContent(t.createText(i, n.selection.getAttributes()), r.start), s ? t.setSelection(s) : a && t.setSelection(r.start.getShiftedBy(o)), _this109._buffer.unlock(), _this109._buffer.input(o);
          });
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);

      return ud;
    }(td);

    function hd(t) {
      var e = null;
      var n = t.model,
          i = t.editing.view,
          o = t.commands.get("input");

      function r(t) {
        var r = n.document,
            a = i.document.isComposing,
            c = e && e.isEqual(r.selection);
        e = null, o.isEnabled && (function (t) {
          if (t.ctrlKey) return !0;
          return fd.includes(t.keyCode);
        }(t) || r.selection.isCollapsed || a && 229 === t.keyCode || !a && 229 === t.keyCode && c || s());
      }

      function s() {
        var t = o.buffer;
        t.lock(), n.enqueueChange(t.batch, function () {
          n.deleteContent(n.document.selection);
        }), t.unlock();
      }

      mo.isAndroid ? i.document.on("beforeinput", function (t, e) {
        return r(e);
      }, {
        priority: "lowest"
      }) : i.document.on("keydown", function (t, e) {
        return r(e);
      }, {
        priority: "lowest"
      }), i.document.on("compositionstart", function () {
        var t = n.document,
            e = 1 !== t.selection.rangeCount || t.selection.getFirstRange().isFlat;
        if (t.selection.isCollapsed || e) return;
        s();
      }, {
        priority: "lowest"
      }), i.document.on("compositionend", function () {
        e = n.createSelection(n.document.selection);
      }, {
        priority: "lowest"
      });
    }

    var fd = [wo("arrowUp"), wo("arrowRight"), wo("arrowDown"), wo("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];

    for (var _t203 = 112; _t203 <= 135; _t203++) {
      fd.push(_t203);
    }

    function md(t) {
      if (t.newChildren.length - t.oldChildren.length != 1) return;

      var e = function (t, e) {
        var n = [];
        var i,
            o = 0;
        return t.forEach(function (t) {
          "equal" == t ? (r(), o++) : "insert" == t ? (s("insert") ? i.values.push(e[o]) : (r(), i = {
            type: "insert",
            index: o,
            values: [e[o]]
          }), o++) : s("delete") ? i.howMany++ : (r(), i = {
            type: "delete",
            index: o,
            howMany: 1
          });
        }), r(), n;

        function r() {
          i && (n.push(i), i = null);
        }

        function s(t) {
          return i && i.type == t;
        }
      }(Qo(t.oldChildren, t.newChildren, pd), t.newChildren);

      if (e.length > 1) return;
      var n = e[0];
      return n.values[0] && n.values[0].is("text") ? n : void 0;
    }

    function pd(t, e) {
      return t && t.is("text") && e && e.is("text") ? t.data === e.data : t === e;
    }

    var gd =
    /*#__PURE__*/
    function () {
      function gd(t) {
        _classCallCheck(this, gd);

        this.editor = t, this.editing = this.editor.editing;
      }

      _createClass(gd, [{
        key: "handle",
        value: function handle(t, e) {
          if (function (t) {
            if (0 == t.length) return !1;
            var _iteratorNormalCompletion246 = true;
            var _didIteratorError246 = false;
            var _iteratorError246 = undefined;

            try {
              for (var _iterator246 = t[Symbol.iterator](), _step246; !(_iteratorNormalCompletion246 = (_step246 = _iterator246.next()).done); _iteratorNormalCompletion246 = true) {
                var _e184 = _step246.value;
                if ("children" === _e184.type && !md(_e184)) return !0;
              }
            } catch (err) {
              _didIteratorError246 = true;
              _iteratorError246 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion246 && _iterator246.return != null) {
                  _iterator246.return();
                }
              } finally {
                if (_didIteratorError246) {
                  throw _iteratorError246;
                }
              }
            }

            return !1;
          }(t)) this._handleContainerChildrenMutations(t, e);else {
            var _iteratorNormalCompletion247 = true;
            var _didIteratorError247 = false;
            var _iteratorError247 = undefined;

            try {
              for (var _iterator247 = t[Symbol.iterator](), _step247; !(_iteratorNormalCompletion247 = (_step247 = _iterator247.next()).done); _iteratorNormalCompletion247 = true) {
                var _n174 = _step247.value;
                this._handleTextMutation(_n174, e), this._handleTextNodeInsertion(_n174);
              }
            } catch (err) {
              _didIteratorError247 = true;
              _iteratorError247 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion247 && _iterator247.return != null) {
                  _iterator247.return();
                }
              } finally {
                if (_didIteratorError247) {
                  throw _iteratorError247;
                }
              }
            }
          }
        }
      }, {
        key: "_handleContainerChildrenMutations",
        value: function _handleContainerChildrenMutations(t, e) {
          var n = function (t) {
            var e = t.map(function (t) {
              return t.node;
            }).reduce(function (t, e) {
              return t.getCommonAncestor(e, {
                includeSelf: !0
              });
            });
            if (!e) return;
            return e.getAncestors({
              includeSelf: !0,
              parentFirst: !0
            }).find(function (t) {
              return t.is("containerElement") || t.is("rootElement");
            });
          }(t);

          if (!n) return;
          var i = this.editor.editing.view.domConverter.mapViewToDom(n),
              o = new rr(),
              r = this.editor.data.toModel(o.domToView(i)).getChild(0),
              s = this.editor.editing.mapper.toModelElement(n);
          if (!s) return;
          var a = Array.from(r.getChildren()),
              c = Array.from(s.getChildren()),
              l = a[a.length - 1],
              d = c[c.length - 1];
          l && l.is("softBreak") && d && !d.is("softBreak") && a.pop();
          var u = this.editor.model.schema;
          if (!bd(a, u) || !bd(c, u)) return;
          var h = a.map(function (t) {
            return t.is("text") ? t.data : "@";
          }).join("").replace(/\u00A0/g, " "),
              f = c.map(function (t) {
            return t.is("text") ? t.data : "@";
          }).join("").replace(/\u00A0/g, " ");
          if (f === h) return;

          var m = Qo(f, h),
              _wd = wd(m),
              p = _wd.firstChangeAt,
              g = _wd.insertions,
              b = _wd.deletions;

          var w = null;
          e && (w = this.editing.mapper.toModelRange(e.getFirstRange()));

          var _ = h.substr(p, g),
              k = this.editor.model.createRange(this.editor.model.createPositionAt(s, p), this.editor.model.createPositionAt(s, p + b));

          this.editor.execute("input", {
            text: _,
            range: k,
            resultRange: w
          });
        }
      }, {
        key: "_handleTextMutation",
        value: function _handleTextMutation(t, e) {
          if ("text" != t.type) return;
          var n = t.newText.replace(/\u00A0/g, " "),
              i = t.oldText.replace(/\u00A0/g, " ");
          if (i === n) return;

          var o = Qo(i, n),
              _wd2 = wd(o),
              r = _wd2.firstChangeAt,
              s = _wd2.insertions,
              a = _wd2.deletions;

          var c = null;
          e && (c = this.editing.mapper.toModelRange(e.getFirstRange()));
          var l = this.editing.view.createPositionAt(t.node, r),
              d = this.editing.mapper.toModelPosition(l),
              u = this.editor.model.createRange(d, d.getShiftedBy(a)),
              h = n.substr(r, s);
          this.editor.execute("input", {
            text: h,
            range: u,
            resultRange: c
          });
        }
      }, {
        key: "_handleTextNodeInsertion",
        value: function _handleTextNodeInsertion(t) {
          if ("children" != t.type) return;
          var e = md(t),
              n = this.editing.view.createPositionAt(t.node, e.index),
              i = this.editing.mapper.toModelPosition(n),
              o = e.values[0].data;
          this.editor.execute("input", {
            text: o.replace(/\u00A0/g, " "),
            range: this.editor.model.createRange(i)
          });
        }
      }]);

      return gd;
    }();

    function bd(t, e) {
      return t.every(function (t) {
        return e.isInline(t);
      });
    }

    function wd(t) {
      var e = null,
          n = null;

      for (var _i139 = 0; _i139 < t.length; _i139++) {
        "equal" != t[_i139] && (e = null === e ? _i139 : e, n = _i139);
      }

      var i = 0,
          o = 0;

      for (var _r26 = e; _r26 <= n; _r26++) {
        "insert" != t[_r26] && i++, "delete" != t[_r26] && o++;
      }

      return {
        insertions: o,
        deletions: i,
        firstChangeAt: e
      };
    }

    var _d =
    /*#__PURE__*/
    function (_Ql4) {
      _inherits(_d, _Ql4);

      function _d() {
        _classCallCheck(this, _d);

        return _possibleConstructorReturn(this, _getPrototypeOf(_d).apply(this, arguments));
      }

      _createClass(_d, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = new ud(t, t.config.get("typing.undoStep") || 20);
          t.commands.add("input", e), hd(t), function (t) {
            t.editing.view.document.on("mutations", function (e, n, i) {
              new gd(t).handle(n, i);
            });
          }(t);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Input";
        }
      }]);

      return _d;
    }(Ql);

    var kd =
    /*#__PURE__*/
    function (_td4) {
      _inherits(kd, _td4);

      function kd(t, e) {
        var _this110;

        _classCallCheck(this, kd);

        _this110 = _possibleConstructorReturn(this, _getPrototypeOf(kd).call(this, t)), _this110.direction = e, _this110._buffer = new dd(t.model, t.config.get("typing.undoStep"));
        return _this110;
      }

      _createClass(kd, [{
        key: "execute",
        value: function execute() {
          var _this111 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document;
          e.enqueueChange(this._buffer.batch, function (i) {
            _this111._buffer.lock();

            var o = i.createSelection(t.selection || n.selection),
                r = o.isCollapsed;
            if (o.isCollapsed && e.modifySelection(o, {
              direction: _this111.direction,
              unit: t.unit
            }), _this111._shouldEntireContentBeReplacedWithParagraph(t.sequence || 1)) return void _this111._replaceEntireContentWithParagraph(i);
            if (o.isCollapsed) return;
            var s = 0;
            o.getFirstRange().getMinimalFlatRanges().forEach(function (t) {
              s += eo(t.getWalker({
                singleCharacters: !0,
                ignoreElementEnd: !0,
                shallow: !0
              }));
            }), e.deleteContent(o, {
              doNotResetEntireContent: r
            }), _this111._buffer.input(s), i.setSelection(o), _this111._buffer.unlock();
          });
        }
      }, {
        key: "_shouldEntireContentBeReplacedWithParagraph",
        value: function _shouldEntireContentBeReplacedWithParagraph(t) {
          if (t > 1) return !1;
          var e = this.editor.model,
              n = e.document.selection,
              i = e.schema.getLimitElement(n);
          if (!(n.isCollapsed && n.containsEntireContent(i))) return !1;
          if (!e.schema.checkChild(i, "paragraph")) return !1;
          var o = i.getChild(0);
          return !o || "paragraph" !== o.name;
        }
      }, {
        key: "_replaceEntireContentWithParagraph",
        value: function _replaceEntireContentWithParagraph(t) {
          var e = this.editor.model,
              n = e.document.selection,
              i = e.schema.getLimitElement(n),
              o = t.createElement("paragraph");
          t.remove(t.createRangeIn(i)), t.insert(o, i), t.setSelection(o, 0);
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);

      return kd;
    }(td);

    var vd =
    /*#__PURE__*/
    function (_hr6) {
      _inherits(vd, _hr6);

      function vd(t) {
        var _this112;

        _classCallCheck(this, vd);

        _this112 = _possibleConstructorReturn(this, _getPrototypeOf(vd).call(this, t));
        var e = t.document;
        var n = 0;

        function i(t, n, i) {
          var o;
          e.once("delete", function (t) {
            return o = t;
          }, {
            priority: Number.POSITIVE_INFINITY
          }), e.fire("delete", new Xr(e, n, i)), o && o.stop.called && t.stop();
        }

        e.on("keyup", function (t, e) {
          e.keyCode != bo.delete && e.keyCode != bo.backspace || (n = 0);
        }), e.on("keydown", function (t, e) {
          var o = {};
          if (e.keyCode == bo.delete) o.direction = "forward", o.unit = "character";else {
            if (e.keyCode != bo.backspace) return;
            o.direction = "backward", o.unit = "codePoint";
          }
          var r = mo.isMac ? e.altKey : e.ctrlKey;
          o.unit = r ? "word" : o.unit, o.sequence = ++n, i(t, e.domEvent, o);
        }), mo.isAndroid && e.on("beforeinput", function (e, n) {
          if ("deleteContentBackward" != n.domEvent.inputType) return;
          var o = {
            unit: "codepoint",
            direction: "backward",
            sequence: 1
          },
              r = n.domTarget.ownerDocument.defaultView.getSelection();
          r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset && (o.selectionToRemove = t.domConverter.domSelectionToView(r)), i(e, n.domEvent, o);
        });
        return _this112;
      }

      _createClass(vd, [{
        key: "observe",
        value: function observe() {}
      }]);

      return vd;
    }(hr);

    var yd =
    /*#__PURE__*/
    function (_Ql5) {
      _inherits(yd, _Ql5);

      function yd() {
        _classCallCheck(this, yd);

        return _possibleConstructorReturn(this, _getPrototypeOf(yd).apply(this, arguments));
      }

      _createClass(yd, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document;

          if (e.addObserver(vd), t.commands.add("forwardDelete", new kd(t, "forward")), t.commands.add("delete", new kd(t, "backward")), this.listenTo(n, "delete", function (n, i) {
            var o = {
              unit: i.unit,
              sequence: i.sequence
            };

            if (i.selectionToRemove) {
              var _e185 = t.model.createSelection(),
                  _n175 = [];

              var _iteratorNormalCompletion248 = true;
              var _didIteratorError248 = false;
              var _iteratorError248 = undefined;

              try {
                for (var _iterator248 = i.selectionToRemove.getRanges()[Symbol.iterator](), _step248; !(_iteratorNormalCompletion248 = (_step248 = _iterator248.next()).done); _iteratorNormalCompletion248 = true) {
                  var _e186 = _step248.value;

                  _n175.push(t.editing.mapper.toModelRange(_e186));
                }
              } catch (err) {
                _didIteratorError248 = true;
                _iteratorError248 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion248 && _iterator248.return != null) {
                    _iterator248.return();
                  }
                } finally {
                  if (_didIteratorError248) {
                    throw _iteratorError248;
                  }
                }
              }

              _e185.setTo(_n175), o.selection = _e185;
            }

            t.execute("forward" == i.direction ? "forwardDelete" : "delete", o), i.preventDefault(), e.scrollToTheSelection();
          }), mo.isAndroid) {
            var _t204 = null;
            this.listenTo(n, "delete", function (e, n) {
              var i = n.domTarget.ownerDocument.defaultView.getSelection();
              _t204 = {
                anchorNode: i.anchorNode,
                anchorOffset: i.anchorOffset,
                focusNode: i.focusNode,
                focusOffset: i.focusOffset
              };
            }, {
              priority: "lowest"
            }), this.listenTo(n, "keyup", function (e, n) {
              var i = n.domTarget.ownerDocument.defaultView.getSelection();
              i.collapse(_t204.anchorNode, _t204.anchorOffset), i.extend(_t204.focusNode, _t204.focusOffset), _t204 = null;
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Delete";
        }
      }]);

      return yd;
    }(Ql);

    var xd =
    /*#__PURE__*/
    function (_Ql6) {
      _inherits(xd, _Ql6);

      function xd() {
        _classCallCheck(this, xd);

        return _possibleConstructorReturn(this, _getPrototypeOf(xd).apply(this, arguments));
      }

      _createClass(xd, null, [{
        key: "requires",
        get: function get() {
          return [_d, yd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Typing";
        }
      }]);

      return xd;
    }(Ql);

    var Ad =
    /*#__PURE__*/
    function (_Ja10) {
      _inherits(Ad, _Ja10);

      function Ad() {
        _classCallCheck(this, Ad);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ad).apply(this, arguments));
      }

      _createClass(Ad, [{
        key: "clone",
        value: function clone() {
          return new Ad(this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Ad(this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {}
      }, {
        key: "type",
        get: function get() {
          return "noop";
        }
      }], [{
        key: "className",
        get: function get() {
          return "NoOperation";
        }
      }]);

      return Ad;
    }(Ja);

    var Cd = new Map();

    function Td(t, e, n) {
      var i = Cd.get(t);
      i || (i = new Map(), Cd.set(t, i)), i.set(e, n);
    }

    function Pd(t) {
      return [t];
    }

    function Md(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var i = function (t, e) {
        var n = Cd.get(t);
        return n && n.has(e) ? n.get(e) : Pd;
      }(t.constructor, e.constructor);

      try {
        return i(t = t.clone(), e, n);
      } catch (i) {
        throw bs.a.error("Error during operation transformation!", i.message), bs.a.error("Transformed operation", t), bs.a.error("Operation transformed by", e), bs.a.error("context.aIsStrong", n.aIsStrong), bs.a.error("context.aWasUndone", n.aWasUndone), bs.a.error("context.bWasUndone", n.bWasUndone), bs.a.error("context.abRelation", n.abRelation), bs.a.error("context.baRelation", n.baRelation), i;
      }
    }

    function Sd(t, e, n) {
      if (t = t.slice(), e = e.slice(), 0 == t.length || 0 == e.length) return {
        operationsA: t,
        operationsB: e
      };
      var i = new WeakMap();
      var _iteratorNormalCompletion249 = true;
      var _didIteratorError249 = false;
      var _iteratorError249 = undefined;

      try {
        for (var _iterator249 = t[Symbol.iterator](), _step249; !(_iteratorNormalCompletion249 = (_step249 = _iterator249.next()).done); _iteratorNormalCompletion249 = true) {
          var _e188 = _step249.value;
          i.set(_e188, 0);
        }
      } catch (err) {
        _didIteratorError249 = true;
        _iteratorError249 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion249 && _iterator249.return != null) {
            _iterator249.return();
          }
        } finally {
          if (_didIteratorError249) {
            throw _iteratorError249;
          }
        }
      }

      var o = {
        nextBaseVersionA: t[t.length - 1].baseVersion + 1,
        nextBaseVersionB: e[e.length - 1].baseVersion + 1,
        originalOperationsACount: t.length,
        originalOperationsBCount: e.length
      },
          r = new Ed(n.document, n.useRelations, n.forceWeakRemove);
      r.setOriginalOperations(t), r.setOriginalOperations(e);
      var s = 0;

      for (; s < t.length;) {
        var _t205, _e187;

        var _n176 = t[s],
            _o62 = i.get(_n176);

        if (_o62 == e.length) {
          s++;
          continue;
        }

        var _a12 = e[_o62],
            _c6 = Md(_n176, _a12, r.getContext(_n176, _a12, !0)),
            _l2 = Md(_a12, _n176, r.getContext(_a12, _n176, !1));

        r.updateRelation(_n176, _a12), r.setOriginalOperations(_c6, _n176), r.setOriginalOperations(_l2, _a12);
        var _iteratorNormalCompletion250 = true;
        var _didIteratorError250 = false;
        var _iteratorError250 = undefined;

        try {
          for (var _iterator250 = _c6[Symbol.iterator](), _step250; !(_iteratorNormalCompletion250 = (_step250 = _iterator250.next()).done); _iteratorNormalCompletion250 = true) {
            var _t206 = _step250.value;
            i.set(_t206, _o62 + _l2.length);
          }
        } catch (err) {
          _didIteratorError250 = true;
          _iteratorError250 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion250 && _iterator250.return != null) {
              _iterator250.return();
            }
          } finally {
            if (_didIteratorError250) {
              throw _iteratorError250;
            }
          }
        }

        (_t205 = t).splice.apply(_t205, [s, 1].concat(_toConsumableArray(_c6))), (_e187 = e).splice.apply(_e187, [_o62, 1].concat(_toConsumableArray(_l2)));
      }

      if (n.padWithNoOps) {
        var _n177 = t.length - o.originalOperationsACount,
            _i140 = e.length - o.originalOperationsBCount;

        Nd(t, _i140 - _n177), Nd(e, _n177 - _i140);
      }

      return Id(t, o.nextBaseVersionB), Id(e, o.nextBaseVersionA), {
        operationsA: t,
        operationsB: e
      };
    }

    var Ed =
    /*#__PURE__*/
    function () {
      function Ed(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

        _classCallCheck(this, Ed);

        this._history = t.history, this._useRelations = e, this._forceWeakRemove = !!n, this._originalOperations = new Map(), this._relations = new Map();
      }

      _createClass(Ed, [{
        key: "setOriginalOperations",
        value: function setOriginalOperations(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = e ? this._originalOperations.get(e) : null;
          var _iteratorNormalCompletion251 = true;
          var _didIteratorError251 = false;
          var _iteratorError251 = undefined;

          try {
            for (var _iterator251 = t[Symbol.iterator](), _step251; !(_iteratorNormalCompletion251 = (_step251 = _iterator251.next()).done); _iteratorNormalCompletion251 = true) {
              var _e189 = _step251.value;

              this._originalOperations.set(_e189, n || _e189);
            }
          } catch (err) {
            _didIteratorError251 = true;
            _iteratorError251 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion251 && _iterator251.return != null) {
                _iterator251.return();
              }
            } finally {
              if (_didIteratorError251) {
                throw _iteratorError251;
              }
            }
          }
        }
      }, {
        key: "updateRelation",
        value: function updateRelation(t, e) {
          switch (t.constructor) {
            case cc:
              switch (e.constructor) {
                case fc:
                  t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition) ? this._setRelation(t, e, "insertAtSource") : t.targetPosition.isEqual(e.deletionPosition) ? this._setRelation(t, e, "insertBetween") : t.targetPosition.isAfter(e.sourcePosition) && this._setRelation(t, e, "moveTargetAfter");
                  break;

                case cc:
                  t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition) ? this._setRelation(t, e, "insertBefore") : this._setRelation(t, e, "insertAfter");
              }

              break;

            case mc:
              switch (e.constructor) {
                case fc:
                  t.splitPosition.isBefore(e.sourcePosition) && this._setRelation(t, e, "splitBefore");
                  break;

                case cc:
                  (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) && this._setRelation(t, e, "splitBefore");
              }

              break;

            case fc:
              switch (e.constructor) {
                case fc:
                  t.targetPosition.isEqual(e.sourcePosition) || this._setRelation(t, e, "mergeTargetNotMoved"), t.sourcePosition.isEqual(e.targetPosition) && this._setRelation(t, e, "mergeSourceNotMoved"), t.sourcePosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeSameElement");
                  break;

                case mc:
                  t.sourcePosition.isEqual(e.splitPosition) && this._setRelation(t, e, "splitAtSource");
              }

              break;

            case dc:
              {
                var _n178 = t.newRange;
                if (!_n178) return;

                switch (e.constructor) {
                  case cc:
                    {
                      var _i141 = Qs._createFromPositionAndShift(e.sourcePosition, e.howMany),
                          _o63 = _i141.containsPosition(_n178.start) || _i141.start.isEqual(_n178.start),
                          _r27 = _i141.containsPosition(_n178.end) || _i141.end.isEqual(_n178.end);

                      !_o63 && !_r27 || _i141.containsRange(_n178) || this._setRelation(t, e, {
                        side: _o63 ? "left" : "right",
                        path: _o63 ? _n178.start.path.slice() : _n178.end.path.slice()
                      });
                      break;
                    }

                  case fc:
                    {
                      var _i142 = _n178.start.isEqual(e.targetPosition),
                          _o64 = _n178.start.isEqual(e.deletionPosition),
                          _r28 = _n178.end.isEqual(e.deletionPosition),
                          _s19 = _n178.end.isEqual(e.sourcePosition);

                      (_i142 || _o64 || _r28 || _s19) && this._setRelation(t, e, {
                        wasInLeftElement: _i142,
                        wasStartBeforeMergedElement: _o64,
                        wasEndBeforeMergedElement: _r28,
                        wasInRightElement: _s19
                      });
                      break;
                    }
                }

                break;
              }
          }
        }
      }, {
        key: "getContext",
        value: function getContext(t, e, n) {
          return {
            aIsStrong: n,
            aWasUndone: this._wasUndone(t),
            bWasUndone: this._wasUndone(e),
            abRelation: this._useRelations ? this._getRelation(t, e) : null,
            baRelation: this._useRelations ? this._getRelation(e, t) : null,
            forceWeakRemove: this._forceWeakRemove
          };
        }
      }, {
        key: "_wasUndone",
        value: function _wasUndone(t) {
          var e = this._originalOperations.get(t);

          return e.wasUndone || this._history.isUndoneOperation(e);
        }
      }, {
        key: "_getRelation",
        value: function _getRelation(t, e) {
          var n = this._originalOperations.get(e),
              i = this._history.getUndoneOperation(n);

          if (!i) return null;

          var o = this._originalOperations.get(t),
              r = this._relations.get(o);

          return r && r.get(i) || null;
        }
      }, {
        key: "_setRelation",
        value: function _setRelation(t, e, n) {
          var i = this._originalOperations.get(t),
              o = this._originalOperations.get(e);

          var r = this._relations.get(i);

          r || (r = new Map(), this._relations.set(i, r)), r.set(o, n);
        }
      }]);

      return Ed;
    }();

    function Id(t, e) {
      var _iteratorNormalCompletion252 = true;
      var _didIteratorError252 = false;
      var _iteratorError252 = undefined;

      try {
        for (var _iterator252 = t[Symbol.iterator](), _step252; !(_iteratorNormalCompletion252 = (_step252 = _iterator252.next()).done); _iteratorNormalCompletion252 = true) {
          var _n179 = _step252.value;
          _n179.baseVersion = e++;
        }
      } catch (err) {
        _didIteratorError252 = true;
        _iteratorError252 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion252 && _iterator252.return != null) {
            _iterator252.return();
          }
        } finally {
          if (_didIteratorError252) {
            throw _iteratorError252;
          }
        }
      }
    }

    function Nd(t, e) {
      for (var _n180 = 0; _n180 < e; _n180++) {
        t.push(new Ad(0));
      }
    }

    function Od(t, e, n) {
      var i = t.nodes.getNode(0).getAttribute(e);
      if (i == n) return null;
      var o = new Qs(t.position, t.position.getShiftedBy(t.howMany));
      return new sc(o, e, i, n, 0);
    }

    function Rd(t, e) {
      return null === t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
    }

    function Dd(t, e) {
      var n = [];

      for (var _i143 = 0; _i143 < t.length; _i143++) {
        var _o65 = t[_i143],
            _r29 = new cc(_o65.start, _o65.end.offset - _o65.start.offset, e, 0);

        n.push(_r29);

        for (var _e190 = _i143 + 1; _e190 < t.length; _e190++) {
          t[_e190] = t[_e190]._getTransformedByMove(_r29.sourcePosition, _r29.targetPosition, _r29.howMany)[0];
        }

        e = e._getTransformedByMove(_r29.sourcePosition, _r29.targetPosition, _r29.howMany);
      }

      return n;
    }

    Td(sc, sc, function (t, e, n) {
      if (t.key === e.key) {
        var _i144 = t.range.getDifference(e.range).map(function (e) {
          return new sc(e, t.key, t.oldValue, t.newValue, 0);
        }),
            _o66 = t.range.getIntersection(e.range);

        return _o66 && n.aIsStrong && _i144.push(new sc(_o66, e.key, e.newValue, t.newValue, 0)), 0 == _i144.length ? [new Ad(0)] : _i144;
      }

      return [t];
    }), Td(sc, lc, function (t, e) {
      if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
        var _n181 = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map(function (e) {
          return new sc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
        });

        if (e.shouldReceiveAttributes) {
          var _i145 = Od(e, t.key, t.oldValue);

          _i145 && _n181.unshift(_i145);
        }

        return _n181;
      }

      return t.range = t.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [t];
    }), Td(sc, fc, function (t, e) {
      var n = [];
      t.range.start.hasSameParentAs(e.deletionPosition) && (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) && n.push(Qs._createFromPositionAndShift(e.graveyardPosition, 1));

      var i = t.range._getTransformedByMergeOperation(e);

      return i.isCollapsed || n.push(i), n.map(function (e) {
        return new sc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    }), Td(sc, cc, function (t, e) {
      return function (t, e) {
        var n = Qs._createFromPositionAndShift(e.sourcePosition, e.howMany);

        var i = null,
            o = [];
        n.containsRange(t, !0) ? i = t : t.start.hasSameParentAs(n.start) ? (o = t.getDifference(n), i = t.getIntersection(n)) : o = [t];
        var r = [];
        var _iteratorNormalCompletion253 = true;
        var _didIteratorError253 = false;
        var _iteratorError253 = undefined;

        try {
          for (var _iterator253 = o[Symbol.iterator](), _step253; !(_iteratorNormalCompletion253 = (_step253 = _iterator253.next()).done); _iteratorNormalCompletion253 = true) {
            var _t207 = _step253.value;
            _t207 = _t207._getTransformedByDeletion(e.sourcePosition, e.howMany);

            var _n182 = e.getMovedRangeStart(),
                _i146 = _t207.start.hasSameParentAs(_n182);

            _t207 = _t207._getTransformedByInsertion(_n182, e.howMany, _i146), r.push.apply(r, _toConsumableArray(_t207));
          }
        } catch (err) {
          _didIteratorError253 = true;
          _iteratorError253 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion253 && _iterator253.return != null) {
              _iterator253.return();
            }
          } finally {
            if (_didIteratorError253) {
              throw _iteratorError253;
            }
          }
        }

        i && r.push(i._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, !1)[0]);
        return r;
      }(t.range, e).map(function (e) {
        return new sc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    }), Td(sc, mc, function (t, e) {
      if (t.range.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.range.end.offset++, [t];

      if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
        var _n183 = t.clone();

        return _n183.range = new Qs(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), t.range.end = e.splitPosition.clone(), t.range.end.stickiness = "toPrevious", [t, _n183];
      }

      return t.range = t.range._getTransformedBySplitOperation(e), [t];
    }), Td(lc, sc, function (t, e) {
      var n = [t];

      if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
        var _i147 = Od(t, e.key, e.newValue);

        _i147 && n.push(_i147);
      }

      return n;
    }), Td(lc, lc, function (t, e, n) {
      return t.position.isEqual(e.position) && n.aIsStrong ? [t] : (t.position = t.position._getTransformedByInsertOperation(e), [t]);
    }), Td(lc, cc, function (t, e) {
      return t.position = t.position._getTransformedByMoveOperation(e), [t];
    }), Td(lc, mc, function (t, e) {
      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), Td(lc, fc, function (t, e) {
      return t.position = t.position._getTransformedByMergeOperation(e), [t];
    }), Td(dc, lc, function (t, e) {
      return t.oldRange && (t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0]), t.newRange && (t.newRange = t.newRange._getTransformedByInsertOperation(e)[0]), [t];
    }), Td(dc, dc, function (t, e, n) {
      if (t.name == e.name) {
        if (!n.aIsStrong) return [new Ad(0)];
        t.oldRange = e.newRange ? e.newRange.clone() : null;
      }

      return [t];
    }), Td(dc, fc, function (t, e) {
      return t.oldRange && (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)), t.newRange && (t.newRange = t.newRange._getTransformedByMergeOperation(e)), [t];
    }), Td(dc, cc, function (t, e, n) {
      if (t.oldRange && (t.oldRange = Qs._createFromRanges(t.oldRange._getTransformedByMoveOperation(e))), t.newRange) {
        if (n.abRelation) {
          var _i148 = Qs._createFromRanges(t.newRange._getTransformedByMoveOperation(e));

          if ("left" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.start)) return t.newRange.start.path = n.abRelation.path, t.newRange.end = _i148.end, [t];
          if ("right" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.end)) return t.newRange.start = _i148.start, t.newRange.end.path = n.abRelation.path, [t];
        }

        t.newRange = Qs._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
      }

      return [t];
    }), Td(dc, mc, function (t, e, n) {
      if (t.oldRange && (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)), t.newRange) {
        if (n.abRelation) {
          var _i149 = t.newRange._getTransformedBySplitOperation(e);

          return t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement ? t.newRange.start = Gs._createAt(e.insertionPosition) : t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement && (t.newRange.start = Gs._createAt(e.moveTargetPosition)), t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement ? t.newRange.end = Gs._createAt(e.moveTargetPosition) : t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement ? t.newRange.end = Gs._createAt(e.insertionPosition) : t.newRange.end = _i149.end, [t];
        }

        t.newRange = t.newRange._getTransformedBySplitOperation(e);
      }

      return [t];
    }), Td(fc, lc, function (t, e) {
      return t.sourcePosition.hasSameParentAs(e.position) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e), t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e), [t];
    }), Td(fc, fc, function (t, e, n) {
      if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
        if (n.bWasUndone) {
          var _n184 = e.graveyardPosition.path.slice();

          return _n184.push(0), t.sourcePosition = new Gs(e.graveyardPosition.root, _n184), t.howMany = 0, [t];
        }

        return [new Ad(0)];
      }

      if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && "splitAtSource" != n.abRelation) {
        var _i150 = "$graveyard" == t.targetPosition.root.rootName,
            _o67 = "$graveyard" == e.targetPosition.root.rootName;

        if (_o67 && !_i150 || !(_i150 && !_o67) && n.aIsStrong) {
          var _n185 = e.targetPosition._getTransformedByMergeOperation(e),
              _i151 = t.targetPosition._getTransformedByMergeOperation(e);

          return [new cc(_n185, t.howMany, _i151, 0)];
        }

        return [new Ad(0)];
      }

      return t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), t.graveyardPosition.isEqual(e.graveyardPosition) && n.aIsStrong || (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), Td(fc, cc, function (t, e, n) {
      var i = Qs._createFromPositionAndShift(e.sourcePosition, e.howMany);

      return "remove" == e.type && !n.bWasUndone && !n.forceWeakRemove && t.deletionPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.sourcePosition) ? [new Ad(0)] : (t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition.hasSameParentAs(e.sourcePosition) && (t.howMany -= e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e), t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e), t.graveyardPosition.isEqual(e.targetPosition) || (t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e)), [t]);
    }), Td(fc, mc, function (t, e, n) {
      if (e.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), t.deletionPosition.isEqual(e.graveyardPosition) && (t.howMany = e.howMany)), t.targetPosition.isEqual(e.splitPosition)) {
        var _i152 = 0 != e.howMany,
            _o68 = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);

        if (_i152 || _o68 || "mergeTargetNotMoved" == n.abRelation) return t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), [t];
      }

      if (t.sourcePosition.isEqual(e.splitPosition)) {
        if ("mergeSourceNotMoved" == n.abRelation) return t.howMany = 0, t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
        if ("mergeSameElement" == n.abRelation || t.sourcePosition.offset > 0) return t.sourcePosition = e.moveTargetPosition.clone(), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
      }

      return t.sourcePosition.hasSameParentAs(e.splitPosition) && (t.howMany = e.splitPosition.offset), t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
    }), Td(cc, lc, function (t, e) {
      var n = Qs._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByInsertOperation(e, !1)[0];

      return t.sourcePosition = n.start, t.howMany = n.end.offset - n.start.offset, t.targetPosition.isEqual(e.position) || (t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e)), [t];
    }), Td(cc, cc, function (t, e, n) {
      var i = Qs._createFromPositionAndShift(t.sourcePosition, t.howMany),
          o = Qs._createFromPositionAndShift(e.sourcePosition, e.howMany);

      var r,
          s = n.aIsStrong,
          a = !n.aIsStrong;
      if ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation ? a = !0 : "insertAfter" != n.abRelation && "insertBefore" != n.baRelation || (a = !1), r = t.targetPosition.isEqual(e.targetPosition) && a ? t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Rd(t, e) && Rd(e, t)) return [e.getReversed()];
      if (i.containsPosition(e.targetPosition) && i.containsRange(o, !0)) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Dd([i], r);
      if (o.containsPosition(t.targetPosition) && o.containsRange(i, !0)) return i.start = i.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), i.end = i.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), Dd([i], r);
      var c = li(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
      if ("prefix" == c || "extension" == c) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Dd([i], r);
      "remove" != t.type || "remove" == e.type || n.aWasUndone || n.forceWeakRemove ? "remove" == t.type || "remove" != e.type || n.bWasUndone || n.forceWeakRemove || (s = !1) : s = !0;
      var l = [],
          d = i.getDifference(o);
      var _iteratorNormalCompletion254 = true;
      var _didIteratorError254 = false;
      var _iteratorError254 = undefined;

      try {
        for (var _iterator254 = d[Symbol.iterator](), _step254; !(_iteratorNormalCompletion254 = (_step254 = _iterator254.next()).done); _iteratorNormalCompletion254 = true) {
          var _t208 = _step254.value;
          _t208.start = _t208.start._getTransformedByDeletion(e.sourcePosition, e.howMany), _t208.end = _t208.end._getTransformedByDeletion(e.sourcePosition, e.howMany);

          var _n186 = "same" == li(_t208.start.getParentPath(), e.getMovedRangeStart().getParentPath()),
              _i153 = _t208._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, _n186);

          l.push.apply(l, _toConsumableArray(_i153));
        }
      } catch (err) {
        _didIteratorError254 = true;
        _iteratorError254 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion254 && _iterator254.return != null) {
            _iterator254.return();
          }
        } finally {
          if (_didIteratorError254) {
            throw _iteratorError254;
          }
        }
      }

      var u = i.getIntersection(o);
      return null !== u && s && (u.start = u.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), u.end = u.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), 0 === l.length ? l.push(u) : 1 == l.length ? o.start.isBefore(i.start) || o.start.isEqual(i.start) ? l.unshift(u) : l.push(u) : l.splice(1, 0, u)), 0 === l.length ? [new Ad(t.baseVersion)] : Dd(l, r);
    }), Td(cc, mc, function (t, e, n) {
      var i = t.targetPosition.clone();
      t.targetPosition.isEqual(e.insertionPosition) && e.graveyardPosition && "moveTargetAfter" != n.abRelation || (i = t.targetPosition._getTransformedBySplitOperation(e));

      var o = Qs._createFromPositionAndShift(t.sourcePosition, t.howMany);

      if (o.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.howMany++, t.targetPosition = i, [t];

      if (o.start.hasSameParentAs(e.splitPosition) && o.containsPosition(e.splitPosition)) {
        var _t209 = new Qs(e.splitPosition, o.end);

        return _t209 = _t209._getTransformedBySplitOperation(e), Dd([new Qs(o.start, e.splitPosition), _t209], i);
      }

      t.targetPosition.isEqual(e.splitPosition) && "insertAtSource" == n.abRelation && (i = e.moveTargetPosition), t.targetPosition.isEqual(e.insertionPosition) && "insertBetween" == n.abRelation && (i = t.targetPosition);
      var r = [o._getTransformedBySplitOperation(e)];

      if (e.graveyardPosition) {
        var _i154 = o.start.isEqual(e.graveyardPosition) || o.containsPosition(e.graveyardPosition);

        t.howMany > 1 && _i154 && !n.aWasUndone && r.push(Qs._createFromPositionAndShift(e.insertionPosition, 1));
      }

      return Dd(r, i);
    }), Td(cc, fc, function (t, e, n) {
      var i = Qs._createFromPositionAndShift(t.sourcePosition, t.howMany);

      if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && i.containsPosition(e.sourcePosition)) if ("remove" != t.type || n.forceWeakRemove) {
        if (1 == t.howMany) return n.bWasUndone ? (t.sourcePosition = e.graveyardPosition.clone(), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t]) : [new Ad(0)];
      } else if (!n.aWasUndone) {
        var _n187 = [];

        var _i155 = e.graveyardPosition.clone(),
            _o69 = e.targetPosition._getTransformedByMergeOperation(e);

        t.howMany > 1 && (_n187.push(new cc(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)), _i155 = _i155._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1), _o69 = _o69._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1));

        var _r30 = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition),
            _s20 = new cc(_i155, 1, _r30, 0),
            _a13 = _s20.getMovedRangeStart().path.slice();

        _a13.push(0);

        var _c7 = new Gs(_s20.targetPosition.root, _a13);

        _o69 = _o69._getTransformedByMove(_i155, _r30, 1);

        var _l3 = new cc(_o69, e.howMany, _c7, 0);

        return _n187.push(_s20), _n187.push(_l3), _n187;
      }

      var o = Qs._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByMergeOperation(e);

      return t.sourcePosition = o.start, t.howMany = o.end.offset - o.start.offset, t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t];
    }), Td(uc, lc, function (t, e) {
      return t.position = t.position._getTransformedByInsertOperation(e), [t];
    }), Td(uc, fc, function (t, e) {
      return t.position.isEqual(e.deletionPosition) ? (t.position = e.graveyardPosition.clone(), t.position.stickiness = "toNext", [t]) : (t.position = t.position._getTransformedByMergeOperation(e), [t]);
    }), Td(uc, cc, function (t, e) {
      return t.position = t.position._getTransformedByMoveOperation(e), [t];
    }), Td(uc, uc, function (t, e, n) {
      if (t.position.isEqual(e.position)) {
        if (!n.aIsStrong) return [new Ad(0)];
        t.oldName = e.newName;
      }

      return [t];
    }), Td(uc, mc, function (t, e) {
      if ("same" == li(t.position.path, e.splitPosition.getParentPath()) && !e.graveyardPosition) {
        return [t, new uc(t.position.getShiftedBy(1), t.oldName, t.newName, 0)];
      }

      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), Td(hc, hc, function (t, e, n) {
      if (t.root === e.root && t.key === e.key) {
        if (!n.aIsStrong || t.newValue === e.newValue) return [new Ad(0)];
        t.oldValue = e.newValue;
      }

      return [t];
    }), Td(mc, lc, function (t, e) {
      return t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e), t.insertionPosition = mc.getInsertionPosition(t.splitPosition), [t];
    }), Td(mc, fc, function (t, e, n) {
      if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
        var _n188 = e.graveyardPosition.path.slice();

        _n188.push(0);

        var _i156 = new Gs(e.graveyardPosition.root, _n188),
            _o70 = mc.getInsertionPosition(new Gs(e.graveyardPosition.root, _n188)),
            _r31 = new mc(_i156, 0, null, 0);

        return _r31.insertionPosition = _o70, t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = mc.getInsertionPosition(t.splitPosition), t.graveyardPosition = _r31.insertionPosition.clone(), t.graveyardPosition.stickiness = "toNext", [_r31, t];
      }

      return t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition) && t.howMany--, t.splitPosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = mc.getInsertionPosition(t.splitPosition), t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), Td(mc, cc, function (t, e, n) {
      var i = Qs._createFromPositionAndShift(e.sourcePosition, e.howMany);

      if (t.graveyardPosition) {
        var _o71 = i.start.isEqual(t.graveyardPosition) || i.containsPosition(t.graveyardPosition);

        if (!n.bWasUndone && _o71) {
          var _n189 = t.splitPosition._getTransformedByMoveOperation(e),
              _i157 = t.graveyardPosition._getTransformedByMoveOperation(e),
              _o72 = _i157.path.slice();

          _o72.push(0);

          var _r32 = new Gs(_i157.root, _o72);

          return [new cc(_n189, t.howMany, _r32, 0)];
        }

        t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
      }

      if (t.splitPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.splitPosition)) {
        var _n190 = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);

        return t.howMany -= _n190, t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany), t.splitPosition = e.sourcePosition.clone(), t.insertionPosition = mc.getInsertionPosition(t.splitPosition), [t];
      }

      return !t.splitPosition.isEqual(e.targetPosition) || "insertAtSource" != n.baRelation && "splitBefore" != n.abRelation ? (e.sourcePosition.isEqual(e.targetPosition) || (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset && (t.howMany -= e.howMany), t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany)), t.splitPosition.stickiness = "toNone", t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e), t.splitPosition.stickiness = "toNext", t.graveyardPosition ? t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e) : t.insertionPosition = mc.getInsertionPosition(t.splitPosition), [t]) : (t.howMany += e.howMany, t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), t.insertionPosition = mc.getInsertionPosition(t.splitPosition), [t]);
    }), Td(mc, mc, function (t, e, n) {
      if (t.splitPosition.isEqual(e.splitPosition)) {
        if (!t.graveyardPosition && !e.graveyardPosition) return [new Ad(0)];
        if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) return [new Ad(0)];
        if ("splitBefore" == n.abRelation) return t.howMany = 0, t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e), [t];
      }

      if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
        var _i158 = "$graveyard" == t.splitPosition.root.rootName,
            _o73 = "$graveyard" == e.splitPosition.root.rootName;

        if (_o73 && !_i158 || !(_i158 && !_o73) && n.aIsStrong) {
          var _n191 = [];
          return e.howMany && _n191.push(new cc(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), t.howMany && _n191.push(new cc(t.splitPosition, t.howMany, t.moveTargetPosition, 0)), _n191;
        }

        return [new Ad(0)];
      }

      if (t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e)), t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == n.abRelation) return t.howMany++, [t];

      if (e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == n.baRelation) {
        var _n192 = e.insertionPosition.path.slice();

        _n192.push(0);

        var _i159 = new Gs(e.insertionPosition.root, _n192);

        return [t, new cc(t.insertionPosition, 1, _i159, 0)];
      }

      return t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset && (t.howMany -= e.howMany), t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e), t.insertionPosition = mc.getInsertionPosition(t.splitPosition), [t];
    });

    var Ld =
    /*#__PURE__*/
    function (_td5) {
      _inherits(Ld, _td5);

      function Ld(t) {
        var _this113;

        _classCallCheck(this, Ld);

        _this113 = _possibleConstructorReturn(this, _getPrototypeOf(Ld).call(this, t)), _this113._stack = [], _this113._createdBatches = new WeakSet(), _this113.refresh();
        return _this113;
      }

      _createClass(Ld, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._stack.length > 0;
        }
      }, {
        key: "addBatch",
        value: function addBatch(t) {
          var e = this.editor.model.document.selection,
              n = {
            ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
            isBackward: e.isBackward
          };
          this._stack.push({
            batch: t,
            selection: n
          }), this.refresh();
        }
      }, {
        key: "clearStack",
        value: function clearStack() {
          this._stack = [], this.refresh();
        }
      }, {
        key: "_restoreSelection",
        value: function _restoreSelection(t, e, n) {
          var i = this.editor.model,
              o = i.document,
              r = [];
          var _iteratorNormalCompletion255 = true;
          var _didIteratorError255 = false;
          var _iteratorError255 = undefined;

          try {
            for (var _iterator255 = t[Symbol.iterator](), _step255; !(_iteratorNormalCompletion255 = (_step255 = _iterator255.next()).done); _iteratorNormalCompletion255 = true) {
              var _e191 = _step255.value;

              var _t210 = jd(_e191, n).find(function (t) {
                return t.start.root != o.graveyard;
              });

              _t210 && r.push(_t210);
            }
          } catch (err) {
            _didIteratorError255 = true;
            _iteratorError255 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion255 && _iterator255.return != null) {
                _iterator255.return();
              }
            } finally {
              if (_didIteratorError255) {
                throw _iteratorError255;
              }
            }
          }

          r.length && i.change(function (t) {
            t.setSelection(r, {
              backward: e
            });
          });
        }
      }, {
        key: "_undo",
        value: function _undo(t, e) {
          var n = this.editor.model,
              i = n.document;

          this._createdBatches.add(e);

          var o = t.operations.slice().filter(function (t) {
            return t.isDocumentOperation;
          });
          o.reverse();
          var _iteratorNormalCompletion256 = true;
          var _didIteratorError256 = false;
          var _iteratorError256 = undefined;

          try {
            for (var _iterator256 = o[Symbol.iterator](), _step256; !(_iteratorNormalCompletion256 = (_step256 = _iterator256.next()).done); _iteratorNormalCompletion256 = true) {
              var _t211 = _step256.value;

              var _o74 = _t211.baseVersion + 1,
                  _r33 = Array.from(i.history.getOperations(_o74)),
                  _s21 = Sd([_t211.getReversed()], _r33, {
                useRelations: !0,
                document: this.editor.model.document,
                padWithNoOps: !1,
                forceWeakRemove: !0
              }).operationsA;

              var _iteratorNormalCompletion257 = true;
              var _didIteratorError257 = false;
              var _iteratorError257 = undefined;

              try {
                for (var _iterator257 = _s21[Symbol.iterator](), _step257; !(_iteratorNormalCompletion257 = (_step257 = _iterator257.next()).done); _iteratorNormalCompletion257 = true) {
                  var _o75 = _step257.value;
                  e.addOperation(_o75), n.applyOperation(_o75), i.history.setOperationAsUndone(_t211, _o75);
                }
              } catch (err) {
                _didIteratorError257 = true;
                _iteratorError257 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion257 && _iterator257.return != null) {
                    _iterator257.return();
                  }
                } finally {
                  if (_didIteratorError257) {
                    throw _iteratorError257;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError256 = true;
            _iteratorError256 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion256 && _iterator256.return != null) {
                _iterator256.return();
              }
            } finally {
              if (_didIteratorError256) {
                throw _iteratorError256;
              }
            }
          }
        }
      }]);

      return Ld;
    }(td);

    function jd(t, e) {
      var n = t.getTransformedByOperations(e);
      n.sort(function (t, e) {
        return t.start.isBefore(e.start) ? -1 : 1;
      });

      for (var _t212 = 1; _t212 < n.length; _t212++) {
        var _e192 = n[_t212 - 1],
            _i160 = n[_t212];
        _e192.end.isTouching(_i160.start) && (_e192.end = _i160.end, n.splice(_t212, 1), _t212--);
      }

      return n;
    }

    var Vd =
    /*#__PURE__*/
    function (_Ld) {
      _inherits(Vd, _Ld);

      function Vd() {
        _classCallCheck(this, Vd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Vd).apply(this, arguments));
      }

      _createClass(Vd, [{
        key: "execute",
        value: function execute() {
          var _this114 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

          var e = t ? this._stack.findIndex(function (e) {
            return e.batch == t;
          }) : this._stack.length - 1,
              n = this._stack.splice(e, 1)[0],
              i = this.editor.model.createBatch("transparent");

          this.editor.model.enqueueChange(i, function () {
            _this114._undo(n.batch, i);

            var t = _this114.editor.model.document.history.getOperations(n.batch.baseVersion);

            _this114._restoreSelection(n.selection.ranges, n.selection.isBackward, t), _this114.fire("revert", n.batch, i);
          }), this.refresh();
        }
      }]);

      return Vd;
    }(Ld);

    var Bd =
    /*#__PURE__*/
    function (_Ld2) {
      _inherits(Bd, _Ld2);

      function Bd() {
        _classCallCheck(this, Bd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Bd).apply(this, arguments));
      }

      _createClass(Bd, [{
        key: "execute",
        value: function execute() {
          var _this115 = this;

          var t = this._stack.pop(),
              e = this.editor.model.createBatch("transparent");

          this.editor.model.enqueueChange(e, function () {
            var n = t.batch.operations[t.batch.operations.length - 1].baseVersion + 1,
                i = _this115.editor.model.document.history.getOperations(n);

            _this115._restoreSelection(t.selection.ranges, t.selection.isBackward, i), _this115._undo(t.batch, e);
          }), this.refresh();
        }
      }]);

      return Bd;
    }(Ld);

    var zd =
    /*#__PURE__*/
    function (_Ql7) {
      _inherits(zd, _Ql7);

      function zd(t) {
        var _this116;

        _classCallCheck(this, zd);

        _this116 = _possibleConstructorReturn(this, _getPrototypeOf(zd).call(this, t)), _this116._batchRegistry = new WeakSet();
        return _this116;
      }

      _createClass(zd, [{
        key: "init",
        value: function init() {
          var _this117 = this;

          var t = this.editor;
          this._undoCommand = new Vd(t), this._redoCommand = new Bd(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", function (t, e) {
            var n = e[0];
            if (!n.isDocumentOperation) return;

            var i = n.batch,
                o = _this117._redoCommand._createdBatches.has(i),
                r = _this117._undoCommand._createdBatches.has(i);

            _this117._batchRegistry.has(i) || "transparent" == i.type && !o && !r || (o ? _this117._undoCommand.addBatch(i) : r || (_this117._undoCommand.addBatch(i), _this117._redoCommand.clearStack()), _this117._batchRegistry.add(i));
          }, {
            priority: "highest"
          }), this.listenTo(this._undoCommand, "revert", function (t, e, n) {
            _this117._redoCommand.addBatch(n);
          }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo");
        }
      }]);

      return zd;
    }(Ql);

    n(65);

    var Fd =
    /*#__PURE__*/
    function (_Rl7) {
      _inherits(Fd, _Rl7);

      function Fd() {
        var _this118;

        _classCallCheck(this, Fd);

        _this118 = _possibleConstructorReturn(this, _getPrototypeOf(Fd).call(this));
        var t = _this118.bindTemplate;
        _this118.set("content", ""), _this118.set("viewBox", "0 0 20 20"), _this118.set("fillColor", ""), _this118.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon"],
            viewBox: t.to("viewBox")
          }
        });
        return _this118;
      }

      _createClass(Fd, [{
        key: "render",
        value: function render() {
          var _this119 = this;

          _get(_getPrototypeOf(Fd.prototype), "render", this).call(this), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
            _this119._updateXMLContent(), _this119._colorFillPaths();
          }), this.on("change:fillColor", function () {
            _this119._colorFillPaths();
          });
        }
      }, {
        key: "_updateXMLContent",
        value: function _updateXMLContent() {
          if (this.content) {
            var _t213 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
                _e193 = _t213.getAttribute("viewBox");

            for (_e193 && (this.viewBox = _e193), this.element.innerHTML = ""; _t213.childNodes.length > 0;) {
              this.element.appendChild(_t213.childNodes[0]);
            }
          }
        }
      }, {
        key: "_colorFillPaths",
        value: function _colorFillPaths() {
          var _this120 = this;

          this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (t) {
            t.style.fill = _this120.fillColor;
          });
        }
      }]);

      return Fd;
    }(Rl);

    n(67);

    var Ud =
    /*#__PURE__*/
    function (_Rl8) {
      _inherits(Ud, _Rl8);

      function Ud(t) {
        var _this121;

        _classCallCheck(this, Ud);

        _this121 = _possibleConstructorReturn(this, _getPrototypeOf(Ud).call(this, t)), _this121.set("text", ""), _this121.set("position", "s");
        var e = _this121.bindTemplate;

        _this121.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-tooltip", e.to("position", function (t) {
              return "ck-tooltip_" + t;
            }), e.if("text", "ck-hidden", function (t) {
              return !t.trim();
            })]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-tooltip__text"]
            },
            children: [{
              text: e.to("text")
            }]
          }]
        });

        return _this121;
      }

      return Ud;
    }(Rl);

    n(69);

    var Hd =
    /*#__PURE__*/
    function (_Rl9) {
      _inherits(Hd, _Rl9);

      function Hd(t) {
        var _this122;

        _classCallCheck(this, Hd);

        _this122 = _possibleConstructorReturn(this, _getPrototypeOf(Hd).call(this, t));
        var e = _this122.bindTemplate,
            n = Kn();
        _this122.set("class"), _this122.set("labelStyle"), _this122.set("icon"), _this122.set("isEnabled", !0), _this122.set("isOn", !1), _this122.set("isVisible", !0), _this122.set("keystroke"), _this122.set("label"), _this122.set("tabindex", -1), _this122.set("tooltip"), _this122.set("tooltipPosition", "s"), _this122.set("type", "button"), _this122.set("withText", !1), _this122.children = _this122.createCollection(), _this122.tooltipView = _this122._createTooltipView(), _this122.labelView = _this122._createLabelView(n), _this122.iconView = new Fd(), _this122.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        }), _this122.bind("_tooltipString").to(_assertThisInitialized(_this122), "tooltip", _assertThisInitialized(_this122), "label", _assertThisInitialized(_this122), "keystroke", _this122._getTooltipString.bind(_assertThisInitialized(_this122))), _this122.setTemplate({
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", e.to("class"), e.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            }), e.if("isVisible", "ck-hidden", function (t) {
              return !t;
            }), e.to("isOn", function (t) {
              return t ? "ck-on" : "ck-off";
            }), e.if("withText", "ck-button_with-text")],
            type: e.to("type", function (t) {
              return t || "button";
            }),
            tabindex: e.to("tabindex"),
            "aria-labelledby": "ck-editor__aria-label_".concat(n),
            "aria-disabled": e.if("isEnabled", !0, function (t) {
              return !t;
            }),
            "aria-pressed": e.if("isOn", !0)
          },
          children: _this122.children,
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function (t) {
              _this122.isEnabled ? _this122.fire("execute") : t.preventDefault();
            })
          }
        });
        return _this122;
      }

      _createClass(Hd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Hd.prototype), "render", this).call(this), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.tooltipView), this.children.add(this.labelView);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_createTooltipView",
        value: function _createTooltipView() {
          var t = new Ud();
          return t.bind("text").to(this, "_tooltipString"), t.bind("position").to(this, "tooltipPosition"), t;
        }
      }, {
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new Rl(),
              n = this.bindTemplate;
          return e.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__label"],
              style: n.to("labelStyle"),
              id: "ck-editor__aria-label_".concat(t)
            },
            children: [{
              text: this.bindTemplate.to("label")
            }]
          }), e;
        }
      }, {
        key: "_getTooltipString",
        value: function _getTooltipString(t, e, n) {
          return t ? "string" == typeof t ? t : (n && (n = function (t) {
            return mo.isMac ? ko(t).map(function (t) {
              return go[t.toLowerCase()] || t;
            }).reduce(function (t, e) {
              return t.slice(-1) in po ? t + e : t + "+" + e;
            }) : t;
          }(n)), t instanceof Function ? t(e, n) : "".concat(e).concat(n ? " (".concat(n, ")") : "")) : "";
        }
      }]);

      return Hd;
    }(Rl);

    var qd = n(22),
        Wd = n.n(qd),
        Yd = n(23),
        $d = n.n(Yd);

    var Gd =
    /*#__PURE__*/
    function (_Ql8) {
      _inherits(Gd, _Ql8);

      function Gd() {
        _classCallCheck(this, Gd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Gd).apply(this, arguments));
      }

      _createClass(Gd, [{
        key: "init",
        value: function init() {
          var t = this.editor.t;
          this._addButton("undo", t("bl"), "CTRL+Z", Wd.a), this._addButton("redo", t("bm"), "CTRL+Y", $d.a);
        }
      }, {
        key: "_addButton",
        value: function _addButton(t, e, n, i) {
          var _this123 = this;

          var o = this.editor;
          o.ui.componentFactory.add(t, function (r) {
            var s = o.commands.get(t),
                a = new Hd(r);
            return a.set({
              label: e,
              icon: i,
              keystroke: n,
              tooltip: !0
            }), a.bind("isEnabled").to(s, "isEnabled"), _this123.listenTo(a, "execute", function () {
              return o.execute(t);
            }), a;
          });
        }
      }]);

      return Gd;
    }(Ql);

    var Qd =
    /*#__PURE__*/
    function (_Ql9) {
      _inherits(Qd, _Ql9);

      function Qd() {
        _classCallCheck(this, Qd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Qd).apply(this, arguments));
      }

      _createClass(Qd, null, [{
        key: "requires",
        get: function get() {
          return [zd, Gd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Undo";
        }
      }]);

      return Qd;
    }(Ql);

    var Jd =
    /*#__PURE__*/
    function (_Ql10) {
      _inherits(Jd, _Ql10);

      function Jd() {
        _classCallCheck(this, Jd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Jd).apply(this, arguments));
      }

      _createClass(Jd, null, [{
        key: "requires",
        get: function get() {
          return [Xl, rd, ld, xd, Qd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Essentials";
        }
      }]);

      return Jd;
    }(Ql);

    var Kd =
    /*#__PURE__*/
    function (_Ql11) {
      _inherits(Kd, _Ql11);

      function Kd() {
        _classCallCheck(this, Kd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Kd).apply(this, arguments));
      }

      _createClass(Kd, [{
        key: "init",
        value: function init() {
          this.set("hasAny", !1), this._actions = new oo({
            idProperty: "_id"
          }), this._actions.delegate("add", "remove").to(this);
        }
      }, {
        key: "add",
        value: function add(t) {
          if ("string" != typeof t) throw new Gn.b("pendingactions-add-invalid-message: The message must be a string.", this);
          var e = Object.create(Fi);
          return e.set("message", t), this._actions.add(e), this.hasAny = !0, e;
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._actions.remove(t), this.hasAny = !!this._actions.length;
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._actions[Symbol.iterator]();
        }
      }, {
        key: "first",
        get: function get() {
          return this._actions.get(0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PendingActions";
        }
      }]);

      return Kd;
    }(Ql);

    var Zd =
    /*#__PURE__*/
    function () {
      function Zd() {
        var _this124 = this;

        _classCallCheck(this, Zd);

        var t = new window.FileReader();
        this._reader = t, this.set("loaded", 0), t.onprogress = function (t) {
          _this124.loaded = t.loaded;
        };
      }

      _createClass(Zd, [{
        key: "read",
        value: function read(t) {
          var _this125 = this;

          var e = this._reader;
          return this.total = t.size, new Promise(function (n, i) {
            e.onload = function () {
              n(e.result);
            }, e.onerror = function () {
              i("error");
            }, e.onabort = function () {
              i("aborted");
            }, _this125._reader.readAsDataURL(t);
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this._reader.abort();
        }
      }, {
        key: "error",
        get: function get() {
          return this._reader.error;
        }
      }]);

      return Zd;
    }();

    ci(Zd, Fi);

    var Xd =
    /*#__PURE__*/
    function (_Ql12) {
      _inherits(Xd, _Ql12);

      function Xd() {
        _classCallCheck(this, Xd);

        return _possibleConstructorReturn(this, _getPrototypeOf(Xd).apply(this, arguments));
      }

      _createClass(Xd, [{
        key: "init",
        value: function init() {
          var _this126 = this;

          this.loaders = new oo(), this.loaders.on("add", function () {
            return _this126._updatePendingAction();
          }), this.loaders.on("remove", function () {
            return _this126._updatePendingAction();
          }), this._loadersMap = new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
            return e ? t / e * 100 : 0;
          });
        }
      }, {
        key: "getLoader",
        value: function getLoader(t) {
          return this._loadersMap.get(t) || null;
        }
      }, {
        key: "createLoader",
        value: function createLoader(t) {
          var _this127 = this;

          if (!this.createUploadAdapter) return bs.a.error("filerepository-no-upload-adapter: Upload adapter is not defined."), null;
          var e = new tu(Promise.resolve(t), this.createUploadAdapter);
          return this.loaders.add(e), this._loadersMap.set(t, e), t instanceof Promise && e.file.then(function (t) {
            _this127._loadersMap.set(t, e);
          }), e.file.catch(function () {}), e.on("change:uploaded", function () {
            var t = 0;
            var _iteratorNormalCompletion258 = true;
            var _didIteratorError258 = false;
            var _iteratorError258 = undefined;

            try {
              for (var _iterator258 = _this127.loaders[Symbol.iterator](), _step258; !(_iteratorNormalCompletion258 = (_step258 = _iterator258.next()).done); _iteratorNormalCompletion258 = true) {
                var _e194 = _step258.value;
                t += _e194.uploaded;
              }
            } catch (err) {
              _didIteratorError258 = true;
              _iteratorError258 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion258 && _iterator258.return != null) {
                  _iterator258.return();
                }
              } finally {
                if (_didIteratorError258) {
                  throw _iteratorError258;
                }
              }
            }

            _this127.uploaded = t;
          }), e.on("change:uploadTotal", function () {
            var t = 0;
            var _iteratorNormalCompletion259 = true;
            var _didIteratorError259 = false;
            var _iteratorError259 = undefined;

            try {
              for (var _iterator259 = _this127.loaders[Symbol.iterator](), _step259; !(_iteratorNormalCompletion259 = (_step259 = _iterator259.next()).done); _iteratorNormalCompletion259 = true) {
                var _e195 = _step259.value;
                _e195.uploadTotal && (t += _e195.uploadTotal);
              }
            } catch (err) {
              _didIteratorError259 = true;
              _iteratorError259 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion259 && _iterator259.return != null) {
                  _iterator259.return();
                }
              } finally {
                if (_didIteratorError259) {
                  throw _iteratorError259;
                }
              }
            }

            _this127.uploadTotal = t;
          }), e;
        }
      }, {
        key: "destroyLoader",
        value: function destroyLoader(t) {
          var _this128 = this;

          var e = t instanceof tu ? t : this.getLoader(t);
          e._destroy(), this.loaders.remove(e), this._loadersMap.forEach(function (t, n) {
            t === e && _this128._loadersMap.delete(n);
          });
        }
      }, {
        key: "_updatePendingAction",
        value: function _updatePendingAction() {
          var t = this.editor.plugins.get(Kd);

          if (this.loaders.length) {
            if (!this._pendingAction) {
              var _e196 = this.editor.t,
                  _n193 = function _n193(t) {
                return "".concat(_e196("ax"), " ").concat(parseInt(t), "%.");
              };

              this._pendingAction = t.add(_n193(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", _n193);
            }
          } else t.remove(this._pendingAction), this._pendingAction = null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "FileRepository";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Kd];
        }
      }]);

      return Xd;
    }(Ql);

    ci(Xd, Fi);

    var tu =
    /*#__PURE__*/
    function () {
      function tu(t, e) {
        _classCallCheck(this, tu);

        this.id = Kn(), this._filePromiseWrapper = this._createFilePromiseWrapper(t), this._adapter = e(this), this._reader = new Zd(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
          return e ? t / e * 100 : 0;
        }), this.set("uploadResponse", null);
      }

      _createClass(tu, [{
        key: "read",
        value: function read() {
          var _this129 = this;

          if ("idle" != this.status) throw new Gn.b("filerepository-read-wrong-status: You cannot call read if the status is different than idle.", this);
          return this.status = "reading", this._filePromiseWrapper.promise.then(function (t) {
            return _this129._reader.read(t);
          }).then(function (t) {
            return _this129.status = "idle", t;
          }).catch(function (t) {
            if ("aborted" === t) throw _this129.status = "aborted", "aborted";
            throw _this129.status = "error", _this129._reader.error ? _this129._reader.error : t;
          });
        }
      }, {
        key: "upload",
        value: function upload() {
          var _this130 = this;

          if ("idle" != this.status) throw new Gn.b("filerepository-upload-wrong-status: You cannot call upload if the status is different than idle.", this);
          return this.status = "uploading", this._filePromiseWrapper.promise.then(function () {
            return _this130._adapter.upload();
          }).then(function (t) {
            return _this130.uploadResponse = t, _this130.status = "idle", t;
          }).catch(function (t) {
            if ("aborted" === _this130.status) throw "aborted";
            throw _this130.status = "error", t;
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          var t = this.status;
          this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == t ? this._reader.abort() : "uploading" == t && this._adapter.abort && this._adapter.abort() : this._filePromiseWrapper.rejecter("aborted"), this._destroy();
        }
      }, {
        key: "_destroy",
        value: function _destroy() {
          this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.data = void 0, this.uploadResponse = void 0;
        }
      }, {
        key: "_createFilePromiseWrapper",
        value: function _createFilePromiseWrapper(t) {
          var e = {};
          return e.promise = new Promise(function (n, i) {
            e.resolver = n, e.rejecter = i, e.isFulfilled = !1, t.then(function (t) {
              e.isFulfilled = !0, n(t);
            }).catch(function (t) {
              e.isFulfilled = !0, i(t);
            });
          }), e;
        }
      }, {
        key: "file",
        get: function get() {
          var _this131 = this;

          return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(function (t) {
            return _this131._filePromiseWrapper ? t : null;
          }) : Promise.resolve(null);
        }
      }]);

      return tu;
    }();

    ci(tu, Fi);
    var eu = "ckCsrfToken",
        nu = 40,
        iu = "abcdefghijklmnopqrstuvwxyz0123456789";

    function ou() {
      var t = function (t) {
        t = t.toLowerCase();
        var e = document.cookie.split(";");
        var _iteratorNormalCompletion260 = true;
        var _didIteratorError260 = false;
        var _iteratorError260 = undefined;

        try {
          for (var _iterator260 = e[Symbol.iterator](), _step260; !(_iteratorNormalCompletion260 = (_step260 = _iterator260.next()).done); _iteratorNormalCompletion260 = true) {
            var _n194 = _step260.value;

            var _e197 = _n194.split("="),
                _i161 = decodeURIComponent(_e197[0].trim().toLowerCase());

            if (_i161 === t) return decodeURIComponent(_e197[1]);
          }
        } catch (err) {
          _didIteratorError260 = true;
          _iteratorError260 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion260 && _iterator260.return != null) {
              _iterator260.return();
            }
          } finally {
            if (_didIteratorError260) {
              throw _iteratorError260;
            }
          }
        }

        return null;
      }(eu);

      return t && t.length == nu || (t = function (t) {
        var e = "";
        var n = new Uint8Array(t);
        window.crypto.getRandomValues(n);

        for (var _t214 = 0; _t214 < n.length; _t214++) {
          var _i162 = iu.charAt(n[_t214] % iu.length);

          e += Math.random() > .5 ? _i162.toUpperCase() : _i162;
        }

        return e;
      }(nu), function (t, e) {
        document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(e) + ";path=/";
      }(eu, t)), t;
    }

    var ru =
    /*#__PURE__*/
    function (_Ql13) {
      _inherits(ru, _Ql13);

      function ru() {
        _classCallCheck(this, ru);

        return _possibleConstructorReturn(this, _getPrototypeOf(ru).apply(this, arguments));
      }

      _createClass(ru, [{
        key: "init",
        value: function init() {
          var _this132 = this;

          var t = this.editor.config.get("ckfinder.uploadUrl");
          t && (this.editor.plugins.get(Xd).createUploadAdapter = function (e) {
            return new su(e, t, _this132.editor.t);
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Xd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "CKFinderUploadAdapter";
        }
      }]);

      return ru;
    }(Ql);

    var su =
    /*#__PURE__*/
    function () {
      function su(t, e, n) {
        _classCallCheck(this, su);

        this.loader = t, this.url = e, this.t = n;
      }

      _createClass(su, [{
        key: "upload",
        value: function upload() {
          var _this133 = this;

          return this.loader.file.then(function (t) {
            return new Promise(function (e, n) {
              _this133._initRequest(), _this133._initListeners(e, n, t), _this133._sendRequest(t);
            });
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr && this.xhr.abort();
        }
      }, {
        key: "_initRequest",
        value: function _initRequest() {
          var t = this.xhr = new XMLHttpRequest();
          t.open("POST", this.url, !0), t.responseType = "json";
        }
      }, {
        key: "_initListeners",
        value: function _initListeners(t, e, n) {
          var i = this.xhr,
              o = this.loader,
              r = (0, this.t)("a") + " ".concat(n.name, ".");
          i.addEventListener("error", function () {
            return e(r);
          }), i.addEventListener("abort", function () {
            return e();
          }), i.addEventListener("load", function () {
            var n = i.response;
            if (!n || !n.uploaded) return e(n && n.error && n.error.message ? n.error.message : r);
            t({
              default: n.url
            });
          }), i.upload && i.upload.addEventListener("progress", function (t) {
            t.lengthComputable && (o.uploadTotal = t.total, o.uploaded = t.loaded);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest(t) {
          var e = new FormData();
          e.append("upload", t), e.append("ckCsrfToken", ou()), this.xhr.send(e);
        }
      }]);

      return su;
    }();

    var au = function au(t, e, n) {
      _classCallCheck(this, au);

      var i,
          o = null;
      "function" == typeof n ? i = n : (o = t.commands.get(n), i = function i() {
        t.execute(n);
      }), t.model.document.on("change", function (n, r) {
        if (o && !o.isEnabled) return;
        if ("transparent" == r.type) return;
        var s = Array.from(t.model.document.differ.getChanges()),
            a = s[0];
        if (1 != s.length || "insert" !== a.type || "$text" != a.name || 1 != a.length) return;
        var c = a.position.textNode || a.position.nodeAfter;
        if (!c.parent.is("paragraph")) return;
        var l = e.exec(c.data);
        l && t.model.enqueueChange(function (t) {
          var e = t.createPositionAt(c.parent, 0),
              n = t.createPositionAt(c.parent, l[0].length),
              o = new ra(e, n);
          !1 !== i({
            match: l
          }) && t.remove(o), o.detach();
        });
      });
    };

    var cu = function cu(t, e, n) {
      _classCallCheck(this, cu);

      var i, o, r, s;
      e instanceof RegExp ? i = e : r = e, "string" == typeof n ? o = n : s = n, r = r || function (t) {
        var e;
        var n = [],
            o = [];

        for (; null !== (e = i.exec(t)) && !(e && e.length < 4);) {
          var _e198 = e,
              _t215 = _e198.index,
              _i163 = _e198[1],
              _r34 = _e198[2],
              _s22 = _e198[3];

          var _a14 = _i163 + _r34 + _s22,
              _c8 = [_t215 += e[0].length - _a14.length, _t215 + _i163.length],
              _l4 = [_t215 + _i163.length + _r34.length, _t215 + _i163.length + _r34.length + _s22.length];

          n.push(_c8), n.push(_l4), o.push([_t215 + _i163.length, _t215 + _i163.length + _r34.length]);
        }

        return {
          remove: n,
          format: o
        };
      }, s = s || function (e, n) {
        var i = t.model.schema.getValidRanges(n, o);
        var _iteratorNormalCompletion261 = true;
        var _didIteratorError261 = false;
        var _iteratorError261 = undefined;

        try {
          for (var _iterator261 = i[Symbol.iterator](), _step261; !(_iteratorNormalCompletion261 = (_step261 = _iterator261.next()).done); _iteratorNormalCompletion261 = true) {
            var _t216 = _step261.value;
            e.setAttribute(o, !0, _t216);
          }
        } catch (err) {
          _didIteratorError261 = true;
          _iteratorError261 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion261 && _iterator261.return != null) {
              _iterator261.return();
            }
          } finally {
            if (_didIteratorError261) {
              throw _iteratorError261;
            }
          }
        }

        e.removeSelectionAttribute(o);
      }, t.model.document.on("change", function (e, n) {
        if ("transparent" == n.type) return;
        var i = t.model.document.selection;
        if (!i.isCollapsed) return;
        var o = Array.from(t.model.document.differ.getChanges()),
            a = o[0];
        if (1 != o.length || "insert" !== a.type || "$text" != a.name || 1 != a.length) return;

        var c = i.focus.parent,
            l = function (t) {
          return Array.from(t.getChildren()).reduce(function (t, e) {
            return t + e.data;
          }, "");
        }(c).slice(0, i.focus.offset),
            d = r(l),
            u = lu(c, d.format, t.model),
            h = lu(c, d.remove, t.model);

        u.length && h.length && t.model.enqueueChange(function (t) {
          if (!1 !== s(t, u)) {
            var _iteratorNormalCompletion262 = true;
            var _didIteratorError262 = false;
            var _iteratorError262 = undefined;

            try {
              for (var _iterator262 = h.reverse()[Symbol.iterator](), _step262; !(_iteratorNormalCompletion262 = (_step262 = _iterator262.next()).done); _iteratorNormalCompletion262 = true) {
                var _e199 = _step262.value;
                t.remove(_e199);
              }
            } catch (err) {
              _didIteratorError262 = true;
              _iteratorError262 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion262 && _iterator262.return != null) {
                  _iterator262.return();
                }
              } finally {
                if (_didIteratorError262) {
                  throw _iteratorError262;
                }
              }
            }
          }
        });
      });
    };

    function lu(t, e, n) {
      return e.filter(function (t) {
        return void 0 !== t[0] && void 0 !== t[1];
      }).map(function (e) {
        return n.createRange(n.createPositionAt(t, e[0]), n.createPositionAt(t, e[1]));
      });
    }

    var du =
    /*#__PURE__*/
    function (_Ql14) {
      _inherits(du, _Ql14);

      function du() {
        _classCallCheck(this, du);

        return _possibleConstructorReturn(this, _getPrototypeOf(du).apply(this, arguments));
      }

      _createClass(du, [{
        key: "afterInit",
        value: function afterInit() {
          this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats();
        }
      }, {
        key: "_addListAutoformats",
        value: function _addListAutoformats() {
          var t = this.editor.commands;
          t.get("bulletedList") && new au(this.editor, /^[*-]\s$/, "bulletedList"), t.get("numberedList") && new au(this.editor, /^1[.|)]\s$/, "numberedList");
        }
      }, {
        key: "_addBasicStylesAutoformats",
        value: function _addBasicStylesAutoformats() {
          var t = this.editor.commands;

          if (t.get("bold")) {
            var _t217 = uu(this.editor, "bold");

            new cu(this.editor, /(\*\*)([^*]+)(\*\*)$/g, _t217), new cu(this.editor, /(__)([^_]+)(__)$/g, _t217);
          }

          if (t.get("italic")) {
            var _t218 = uu(this.editor, "italic");

            new cu(this.editor, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, _t218), new cu(this.editor, /(?:^|[^_])(_)([^_]+)(_)$/g, _t218);
          }

          if (t.get("code")) {
            var _t219 = uu(this.editor, "code");

            new cu(this.editor, /(`)([^`]+)(`)$/g, _t219);
          }
        }
      }, {
        key: "_addHeadingAutoformats",
        value: function _addHeadingAutoformats() {
          var _this134 = this;

          var t = this.editor.commands.get("heading");
          t && t.modelElements.filter(function (t) {
            return t.match(/^heading[1-6]$/);
          }).forEach(function (e) {
            var n = e[7],
                i = new RegExp("^(#{".concat(n, "})\\s$"));
            new au(_this134.editor, i, function () {
              if (!t.isEnabled) return !1;

              _this134.editor.execute("heading", {
                value: e
              });
            });
          });
        }
      }, {
        key: "_addBlockQuoteAutoformats",
        value: function _addBlockQuoteAutoformats() {
          this.editor.commands.get("blockQuote") && new au(this.editor, /^>\s$/, "blockQuote");
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Autoformat";
        }
      }]);

      return du;
    }(Ql);

    function uu(t, e) {
      return function (n, i) {
        if (!t.commands.get(e).isEnabled) return !1;
        var o = t.model.schema.getValidRanges(i, e);
        var _iteratorNormalCompletion263 = true;
        var _didIteratorError263 = false;
        var _iteratorError263 = undefined;

        try {
          for (var _iterator263 = o[Symbol.iterator](), _step263; !(_iteratorNormalCompletion263 = (_step263 = _iterator263.next()).done); _iteratorNormalCompletion263 = true) {
            var _t220 = _step263.value;
            n.setAttribute(e, !0, _t220);
          }
        } catch (err) {
          _didIteratorError263 = true;
          _iteratorError263 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion263 && _iterator263.return != null) {
              _iterator263.return();
            }
          } finally {
            if (_didIteratorError263) {
              throw _iteratorError263;
            }
          }
        }

        n.removeSelectionAttribute(e);
      };
    }

    var hu =
    /*#__PURE__*/
    function (_td6) {
      _inherits(hu, _td6);

      function hu(t, e) {
        var _this135;

        _classCallCheck(this, hu);

        _this135 = _possibleConstructorReturn(this, _getPrototypeOf(hu).call(this, t)), _this135.attributeKey = e;
        return _this135;
      }

      _createClass(hu, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;
          this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this136 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document.selection,
              i = void 0 === t.forceValue ? !this.value : t.forceValue;
          e.change(function (t) {
            if (n.isCollapsed) i ? t.setSelectionAttribute(_this136.attributeKey, !0) : t.removeSelectionAttribute(_this136.attributeKey);else {
              var _o76 = e.schema.getValidRanges(n.getRanges(), _this136.attributeKey);

              var _iteratorNormalCompletion264 = true;
              var _didIteratorError264 = false;
              var _iteratorError264 = undefined;

              try {
                for (var _iterator264 = _o76[Symbol.iterator](), _step264; !(_iteratorNormalCompletion264 = (_step264 = _iterator264.next()).done); _iteratorNormalCompletion264 = true) {
                  var _e200 = _step264.value;
                  i ? t.setAttribute(_this136.attributeKey, i, _e200) : t.removeAttribute(_this136.attributeKey, _e200);
                }
              } catch (err) {
                _didIteratorError264 = true;
                _iteratorError264 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion264 && _iterator264.return != null) {
                    _iterator264.return();
                  }
                } finally {
                  if (_didIteratorError264) {
                    throw _iteratorError264;
                  }
                }
              }
            }
          });
        }
      }, {
        key: "_getValueFromFirstAllowedNode",
        value: function _getValueFromFirstAllowedNode() {
          var t = this.editor.model,
              e = t.schema,
              n = t.document.selection;
          if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
          var _iteratorNormalCompletion265 = true;
          var _didIteratorError265 = false;
          var _iteratorError265 = undefined;

          try {
            for (var _iterator265 = n.getRanges()[Symbol.iterator](), _step265; !(_iteratorNormalCompletion265 = (_step265 = _iterator265.next()).done); _iteratorNormalCompletion265 = true) {
              var _t221 = _step265.value;
              var _iteratorNormalCompletion266 = true;
              var _didIteratorError266 = false;
              var _iteratorError266 = undefined;

              try {
                for (var _iterator266 = _t221.getItems()[Symbol.iterator](), _step266; !(_iteratorNormalCompletion266 = (_step266 = _iterator266.next()).done); _iteratorNormalCompletion266 = true) {
                  var _n195 = _step266.value;
                  if (e.checkAttribute(_n195, this.attributeKey)) return _n195.hasAttribute(this.attributeKey);
                }
              } catch (err) {
                _didIteratorError266 = true;
                _iteratorError266 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion266 && _iterator266.return != null) {
                    _iterator266.return();
                  }
                } finally {
                  if (_didIteratorError266) {
                    throw _iteratorError266;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError265 = true;
            _iteratorError265 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion265 && _iterator265.return != null) {
                _iterator265.return();
              }
            } finally {
              if (_didIteratorError265) {
                throw _iteratorError265;
              }
            }
          }

          return !1;
        }
      }]);

      return hu;
    }(td);

    var fu = "bold";

    var mu =
    /*#__PURE__*/
    function (_Ql15) {
      _inherits(mu, _Ql15);

      function mu() {
        _classCallCheck(this, mu);

        return _possibleConstructorReturn(this, _getPrototypeOf(mu).apply(this, arguments));
      }

      _createClass(mu, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: fu
          }), t.model.schema.setAttributeProperties(fu, {
            isFormatting: !0
          }), t.conversion.attributeToElement({
            model: fu,
            view: "strong",
            upcastAlso: ["b", {
              styles: {
                "font-weight": "bold"
              }
            }]
          }), t.commands.add(fu, new hu(t, fu)), t.keystrokes.set("CTRL+B", fu);
        }
      }]);

      return mu;
    }(Ql);

    var pu = n(24),
        gu = n.n(pu);
    var bu = "bold";

    var wu =
    /*#__PURE__*/
    function (_Ql16) {
      _inherits(wu, _Ql16);

      function wu() {
        _classCallCheck(this, wu);

        return _possibleConstructorReturn(this, _getPrototypeOf(wu).apply(this, arguments));
      }

      _createClass(wu, [{
        key: "init",
        value: function init() {
          var _this137 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add(bu, function (n) {
            var i = t.commands.get(bu),
                o = new Hd(n);
            return o.set({
              label: e("d"),
              icon: gu.a,
              keystroke: "CTRL+B",
              tooltip: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this137.listenTo(o, "execute", function () {
              return t.execute(bu);
            }), o;
          });
        }
      }]);

      return wu;
    }(Ql);

    var _u =
    /*#__PURE__*/
    function (_Ql17) {
      _inherits(_u, _Ql17);

      function _u() {
        _classCallCheck(this, _u);

        return _possibleConstructorReturn(this, _getPrototypeOf(_u).apply(this, arguments));
      }

      _createClass(_u, null, [{
        key: "requires",
        get: function get() {
          return [mu, wu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Bold";
        }
      }]);

      return _u;
    }(Ql);

    var ku = "underline";

    var vu =
    /*#__PURE__*/
    function (_Ql18) {
      _inherits(vu, _Ql18);

      function vu() {
        _classCallCheck(this, vu);

        return _possibleConstructorReturn(this, _getPrototypeOf(vu).apply(this, arguments));
      }

      _createClass(vu, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: ku
          }), t.model.schema.setAttributeProperties(ku, {
            isFormatting: !0
          }), t.conversion.attributeToElement({
            model: ku,
            view: "u",
            upcastAlso: {
              styles: {
                "text-decoration": "underline"
              }
            }
          }), t.commands.add(ku, new hu(t, ku)), t.keystrokes.set("CTRL+U", "underline");
        }
      }]);

      return vu;
    }(Ql);

    var yu = n(25),
        xu = n.n(yu);
    var Au = "underline";

    var Cu =
    /*#__PURE__*/
    function (_Ql19) {
      _inherits(Cu, _Ql19);

      function Cu() {
        _classCallCheck(this, Cu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Cu).apply(this, arguments));
      }

      _createClass(Cu, [{
        key: "init",
        value: function init() {
          var _this138 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add(Au, function (n) {
            var i = t.commands.get(Au),
                o = new Hd(n);
            return o.set({
              label: e("ag"),
              icon: xu.a,
              keystroke: "CTRL+U",
              tooltip: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this138.listenTo(o, "execute", function () {
              return t.execute(Au);
            }), o;
          });
        }
      }]);

      return Cu;
    }(Ql);

    var Tu =
    /*#__PURE__*/
    function (_Ql20) {
      _inherits(Tu, _Ql20);

      function Tu() {
        _classCallCheck(this, Tu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Tu).apply(this, arguments));
      }

      _createClass(Tu, null, [{
        key: "requires",
        get: function get() {
          return [vu, Cu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Underline";
        }
      }]);

      return Tu;
    }(Ql);

    var Pu = "italic";

    var Mu =
    /*#__PURE__*/
    function (_Ql21) {
      _inherits(Mu, _Ql21);

      function Mu() {
        _classCallCheck(this, Mu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Mu).apply(this, arguments));
      }

      _createClass(Mu, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: Pu
          }), t.model.schema.setAttributeProperties(Pu, {
            isFormatting: !0
          }), t.conversion.attributeToElement({
            model: Pu,
            view: "i",
            upcastAlso: ["em", {
              styles: {
                "font-style": "italic"
              }
            }]
          }), t.commands.add(Pu, new hu(t, Pu)), t.keystrokes.set("CTRL+I", Pu);
        }
      }]);

      return Mu;
    }(Ql);

    var Su = n(26),
        Eu = n.n(Su);
    var Iu = "italic";

    var Nu =
    /*#__PURE__*/
    function (_Ql22) {
      _inherits(Nu, _Ql22);

      function Nu() {
        _classCallCheck(this, Nu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Nu).apply(this, arguments));
      }

      _createClass(Nu, [{
        key: "init",
        value: function init() {
          var _this139 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add(Iu, function (n) {
            var i = t.commands.get(Iu),
                o = new Hd(n);
            return o.set({
              label: e("f"),
              icon: Eu.a,
              keystroke: "CTRL+I",
              tooltip: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this139.listenTo(o, "execute", function () {
              return t.execute(Iu);
            }), o;
          });
        }
      }]);

      return Nu;
    }(Ql);

    var Ou =
    /*#__PURE__*/
    function (_Ql23) {
      _inherits(Ou, _Ql23);

      function Ou() {
        _classCallCheck(this, Ou);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ou).apply(this, arguments));
      }

      _createClass(Ou, null, [{
        key: "requires",
        get: function get() {
          return [Mu, Nu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Italic";
        }
      }]);

      return Ou;
    }(Ql);

    function Ru(t) {
      var e = t.next();
      return e.done ? null : e.value;
    }

    var Du =
    /*#__PURE__*/
    function (_td7) {
      _inherits(Du, _td7);

      function Du() {
        _classCallCheck(this, Du);

        return _possibleConstructorReturn(this, _getPrototypeOf(Du).apply(this, arguments));
      }

      _createClass(Du, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this140 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = Array.from(i.getTopMostBlocks()),
              r = void 0 === t.forceValue ? !this.value : t.forceValue;
          e.change(function (t) {
            if (r) {
              var _e201 = o.filter(function (t) {
                return Lu(t) || Vu(n, t);
              });

              _this140._applyQuote(t, _e201);
            } else _this140._removeQuote(t, o.filter(Lu));
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = Ru(this.editor.model.document.selection.getTopMostBlocks());
          return !(!t || !Lu(t));
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var t = this.editor.model.document.selection,
              e = this.editor.model.schema,
              n = Ru(t.getSelectedBlocks());
          return !!n && Vu(e, n);
        }
      }, {
        key: "_removeQuote",
        value: function _removeQuote(t, e) {
          ju(t, e).reverse().forEach(function (e) {
            if (e.start.isAtStart && e.end.isAtEnd) return void t.unwrap(e.start.parent);

            if (e.start.isAtStart) {
              var _n196 = t.createPositionBefore(e.start.parent);

              return void t.move(e, _n196);
            }

            e.end.isAtEnd || t.split(e.end);
            var n = t.createPositionAfter(e.end.parent);
            t.move(e, n);
          });
        }
      }, {
        key: "_applyQuote",
        value: function _applyQuote(t, e) {
          var n = [];
          ju(t, e).reverse().forEach(function (e) {
            var i = Lu(e.start);
            i || (i = t.createElement("blockQuote"), t.wrap(e, i)), n.push(i);
          }), n.reverse().reduce(function (e, n) {
            return e.nextSibling == n ? (t.merge(t.createPositionAfter(e)), e) : n;
          });
        }
      }]);

      return Du;
    }(td);

    function Lu(t) {
      return "blockQuote" == t.parent.name ? t.parent : null;
    }

    function ju(t, e) {
      var n,
          i = 0;
      var o = [];

      for (; i < e.length;) {
        var _r35 = e[i],
            _s23 = e[i + 1];
        n || (n = t.createPositionBefore(_r35)), _s23 && _r35.nextSibling == _s23 || (o.push(t.createRange(n, t.createPositionAfter(_r35))), n = null), i++;
      }

      return o;
    }

    function Vu(t, e) {
      var n = t.checkChild(e.parent, "blockQuote"),
          i = t.checkChild(["$root", "blockQuote"], e);
      return n && i;
    }

    var Bu =
    /*#__PURE__*/
    function (_Ql24) {
      _inherits(Bu, _Ql24);

      function Bu() {
        _classCallCheck(this, Bu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Bu).apply(this, arguments));
      }

      _createClass(Bu, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema;
          t.commands.add("blockQuote", new Du(t)), e.register("blockQuote", {
            allowWhere: "$block",
            allowContentOf: "$root"
          }), e.addChildCheck(function (t, e) {
            if (t.endsWith("blockQuote") && "blockQuote" == e.name) return !1;
          }), t.conversion.elementToElement({
            model: "blockQuote",
            view: "blockquote"
          }), t.model.document.registerPostFixer(function (n) {
            var i = t.model.document.differ.getChanges();
            var _iteratorNormalCompletion267 = true;
            var _didIteratorError267 = false;
            var _iteratorError267 = undefined;

            try {
              for (var _iterator267 = i[Symbol.iterator](), _step267; !(_iteratorNormalCompletion267 = (_step267 = _iterator267.next()).done); _iteratorNormalCompletion267 = true) {
                var _t222 = _step267.value;

                if ("insert" == _t222.type) {
                  var _i164 = _t222.position.nodeAfter;
                  if (!_i164) continue;
                  if (_i164.is("blockQuote") && _i164.isEmpty) return n.remove(_i164), !0;
                  if (_i164.is("blockQuote") && !e.checkChild(_t222.position, _i164)) return n.unwrap(_i164), !0;

                  if (_i164.is("element")) {
                    var _t223 = n.createRangeIn(_i164);

                    var _iteratorNormalCompletion268 = true;
                    var _didIteratorError268 = false;
                    var _iteratorError268 = undefined;

                    try {
                      for (var _iterator268 = _t223.getItems()[Symbol.iterator](), _step268; !(_iteratorNormalCompletion268 = (_step268 = _iterator268.next()).done); _iteratorNormalCompletion268 = true) {
                        var _i165 = _step268.value;
                        if (_i165.is("blockQuote") && !e.checkChild(n.createPositionBefore(_i165), _i165)) return n.unwrap(_i165), !0;
                      }
                    } catch (err) {
                      _didIteratorError268 = true;
                      _iteratorError268 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion268 && _iterator268.return != null) {
                          _iterator268.return();
                        }
                      } finally {
                        if (_didIteratorError268) {
                          throw _iteratorError268;
                        }
                      }
                    }
                  }
                } else if ("remove" == _t222.type) {
                  var _e202 = _t222.position.parent;
                  if (_e202.is("blockQuote") && _e202.isEmpty) return n.remove(_e202), !0;
                }
              }
            } catch (err) {
              _didIteratorError267 = true;
              _iteratorError267 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion267 && _iterator267.return != null) {
                  _iterator267.return();
                }
              } finally {
                if (_didIteratorError267) {
                  throw _iteratorError267;
                }
              }
            }

            return !1;
          });
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var _this141 = this;

          var t = this.editor.commands.get("blockQuote");
          this.listenTo(this.editor.editing.view.document, "enter", function (e, n) {
            var i = _this141.editor.model.document,
                o = i.selection.getLastPosition().parent;
            i.selection.isCollapsed && o.isEmpty && t.value && (_this141.editor.execute("blockQuote"), _this141.editor.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
          });
        }
      }]);

      return Bu;
    }(Ql);

    var zu = n(27),
        Fu = n.n(zu);
    n(71);

    var Uu =
    /*#__PURE__*/
    function (_Ql25) {
      _inherits(Uu, _Ql25);

      function Uu() {
        _classCallCheck(this, Uu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Uu).apply(this, arguments));
      }

      _createClass(Uu, [{
        key: "init",
        value: function init() {
          var _this142 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("blockQuote", function (n) {
            var i = t.commands.get("blockQuote"),
                o = new Hd(n);
            return o.set({
              label: e("e"),
              icon: Fu.a,
              tooltip: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this142.listenTo(o, "execute", function () {
              return t.execute("blockQuote");
            }), o;
          });
        }
      }]);

      return Uu;
    }(Ql);

    var Hu =
    /*#__PURE__*/
    function (_Ql26) {
      _inherits(Hu, _Ql26);

      function Hu() {
        _classCallCheck(this, Hu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Hu).apply(this, arguments));
      }

      _createClass(Hu, null, [{
        key: "requires",
        get: function get() {
          return [Bu, Uu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "BlockQuote";
        }
      }]);

      return Hu;
    }(Ql);

    var qu = n(28),
        Wu = n.n(qu);

    var Yu =
    /*#__PURE__*/
    function (_Ql27) {
      _inherits(Yu, _Ql27);

      function Yu() {
        _classCallCheck(this, Yu);

        return _possibleConstructorReturn(this, _getPrototypeOf(Yu).apply(this, arguments));
      }

      _createClass(Yu, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.ui.componentFactory,
              n = t.t;
          e.add("ckfinder", function (e) {
            var i = t.commands.get("ckfinder"),
                o = new Hd(e);
            return o.set({
              label: n("g"),
              icon: Wu.a,
              tooltip: !0
            }), o.bind("isEnabled").to(i), o.on("execute", function () {
              t.execute("ckfinder"), t.editing.view.focus();
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderUI";
        }
      }]);

      return Yu;
    }(Ql);

    var $u =
    /*#__PURE__*/
    function (_Ql28) {
      _inherits($u, _Ql28);

      function $u() {
        _classCallCheck(this, $u);

        return _possibleConstructorReturn(this, _getPrototypeOf($u).apply(this, arguments));
      }

      _createClass($u, [{
        key: "init",
        value: function init() {
          this.on("show:warning", function (t, e) {
            window.alert(e.message);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "showSuccess",
        value: function showSuccess(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "success",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showInfo",
        value: function showInfo(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "info",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showWarning",
        value: function showWarning(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "warning",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "_showNotification",
        value: function _showNotification(t) {
          var e = "show:".concat(t.type) + (t.namespace ? ":".concat(t.namespace) : "");
          this.fire(e, {
            message: t.message,
            type: t.type,
            title: t.title || ""
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Notification";
        }
      }]);

      return $u;
    }(Ql);

    var Gu =
    /*#__PURE__*/
    function (_td8) {
      _inherits(Gu, _td8);

      function Gu(t) {
        var _this143;

        _classCallCheck(this, Gu);

        _this143 = _possibleConstructorReturn(this, _getPrototypeOf(Gu).call(this, t)), _this143.stopListening(_this143.editor.model.document, "change"), _this143.listenTo(_this143.editor.model.document, "change", function () {
          return _this143.refresh();
        }, {
          priority: "low"
        });
        return _this143;
      }

      _createClass(Gu, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.commands.get("imageUpload"),
              e = this.editor.commands.get("link");
          this.isEnabled = t && e && (t.isEnabled || e.isEnabled);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = this.editor.config.get("ckfinder.openerMethod") || "modal";
          if ("popup" != e && "modal" != e) throw new Gn.b('ckfinder-unknown-openerMethod: The openerMethod config option must by "popup" or "modal".', t);
          var n = this.editor.config.get("ckfinder.options") || {};
          n.chooseFiles = !0;
          var i = n.onInit;
          n.language || (n.language = t.locale.language), n.onInit = function (e) {
            i && i(), e.on("files:choose", function (n) {
              var i = n.data.files.toArray(),
                  o = i.filter(function (t) {
                return !t.isImage();
              }),
                  r = i.filter(function (t) {
                return t.isImage();
              });
              var _iteratorNormalCompletion269 = true;
              var _didIteratorError269 = false;
              var _iteratorError269 = undefined;

              try {
                for (var _iterator269 = o[Symbol.iterator](), _step269; !(_iteratorNormalCompletion269 = (_step269 = _iterator269.next()).done); _iteratorNormalCompletion269 = true) {
                  var _e203 = _step269.value;
                  t.execute("link", _e203.getUrl());
                }
              } catch (err) {
                _didIteratorError269 = true;
                _iteratorError269 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion269 && _iterator269.return != null) {
                    _iterator269.return();
                  }
                } finally {
                  if (_didIteratorError269) {
                    throw _iteratorError269;
                  }
                }
              }

              var s = [];
              var _iteratorNormalCompletion270 = true;
              var _didIteratorError270 = false;
              var _iteratorError270 = undefined;

              try {
                for (var _iterator270 = r[Symbol.iterator](), _step270; !(_iteratorNormalCompletion270 = (_step270 = _iterator270.next()).done); _iteratorNormalCompletion270 = true) {
                  var _t224 = _step270.value;

                  var _n197 = _t224.getUrl();

                  s.push(_n197 || e.request("file:getProxyUrl", {
                    file: _t224
                  }));
                }
              } catch (err) {
                _didIteratorError270 = true;
                _iteratorError270 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion270 && _iterator270.return != null) {
                    _iterator270.return();
                  }
                } finally {
                  if (_didIteratorError270) {
                    throw _iteratorError270;
                  }
                }
              }

              s.length && Qu(t, s);
            }), e.on("file:choose:resizedImage", function (e) {
              var n = e.data.resizedUrl;
              if (n) Qu(t, [n]);else {
                var _e204 = t.plugins.get("Notification"),
                    _n198 = t.locale.t;

                _e204.showWarning(_n198("ay"), {
                  title: _n198("az"),
                  namespace: "ckfinder"
                });
              }
            });
          }, window.CKFinder[e](n);
        }
      }]);

      return Gu;
    }(td);

    function Qu(t, e) {
      if (t.commands.get("imageUpload").isEnabled) t.execute("imageInsert", {
        source: e
      });else {
        var _e205 = t.plugins.get("Notification"),
            _n199 = t.locale.t;

        _e205.showWarning(_n199("ba"), {
          title: _n199("bb"),
          namespace: "ckfinder"
        });
      }
    }

    var Ju =
    /*#__PURE__*/
    function (_Ql29) {
      _inherits(Ju, _Ql29);

      function Ju() {
        _classCallCheck(this, Ju);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ju).apply(this, arguments));
      }

      _createClass(Ju, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.commands.add("ckfinder", new Gu(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [$u];
        }
      }]);

      return Ju;
    }(Ql);

    var Ku =
    /*#__PURE__*/
    function (_Ql30) {
      _inherits(Ku, _Ql30);

      function Ku() {
        _classCallCheck(this, Ku);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ku).apply(this, arguments));
      }

      _createClass(Ku, null, [{
        key: "pluginName",
        get: function get() {
          return "CKFinder";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Ju, Yu, ru];
        }
      }]);

      return Ku;
    }(Ql);

    var Zu = /^data:(\S*?);base64,/;

    var Xu =
    /*#__PURE__*/
    function () {
      function Xu(t, e, n) {
        _classCallCheck(this, Xu);

        if (!t) throw new Gn.b("fileuploader-missing-file: File must be provided as the first argument", null);
        if (!e) throw new Gn.b("fileuploader-missing-token: Token must be provided as the second argument.", null);
        if (!n) throw new Gn.b("fileuploader-missing-api-address: Api address must be provided as the third argument.", null);
        this.file = function (t) {
          if ("string" != typeof t) return !1;
          var e = t.match(Zu);
          return !(!e || !e.length);
        }(t) ? function (t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;

          try {
            var _n200 = t.match(Zu)[1],
                _i166 = atob(t.replace(Zu, "")),
                _o77 = [];

            for (var _t225 = 0; _t225 < _i166.length; _t225 += e) {
              var _n201 = _i166.slice(_t225, _t225 + e),
                  _r36 = new Array(_n201.length);

              for (var _t226 = 0; _t226 < _n201.length; _t226++) {
                _r36[_t226] = _n201.charCodeAt(_t226);
              }

              _o77.push(new Uint8Array(_r36));
            }

            return new Blob(_o77, {
              type: _n200
            });
          } catch (t) {
            throw new Gn.b("fileuploader-decoding-image-data-error: Problem with decoding Base64 image data.", null);
          }
        }(t) : t, this._token = e, this._apiAddress = n;
      }

      _createClass(Xu, [{
        key: "onProgress",
        value: function onProgress(t) {
          return this.on("progress", function (e, n) {
            return t(n);
          }), this;
        }
      }, {
        key: "onError",
        value: function onError(t) {
          return this.once("error", function (e, n) {
            return t(n);
          }), this;
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr.abort();
        }
      }, {
        key: "send",
        value: function send() {
          return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
        }
      }, {
        key: "_prepareRequest",
        value: function _prepareRequest() {
          var t = new XMLHttpRequest();
          t.open("POST", this._apiAddress), t.setRequestHeader("Authorization", this._token.value), t.responseType = "json", this.xhr = t;
        }
      }, {
        key: "_attachXHRListeners",
        value: function _attachXHRListeners() {
          var _this144 = this;

          var t = this,
              e = this.xhr;

          function n(e) {
            return function () {
              return t.fire("error", e);
            };
          }

          e.addEventListener("error", n("Network Error")), e.addEventListener("abort", n("Abort")), e.upload && e.upload.addEventListener("progress", function (t) {
            t.lengthComputable && _this144.fire("progress", {
              total: t.total,
              uploaded: t.loaded
            });
          }), e.addEventListener("load", function () {
            var t = e.status,
                n = e.response;
            if (t < 200 || t > 299) return _this144.fire("error", n.message || n.error);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest() {
          var _this145 = this;

          var t = new FormData(),
              e = this.xhr;
          return t.append("file", this.file), new Promise(function (n, i) {
            e.addEventListener("load", function () {
              var t = e.status,
                  o = e.response;
              return t < 200 || t > 299 ? o.message ? i(new Gn.b("fileuploader-uploading-data-failed: Uploading file failed.", _this145, {
                message: o.message
              })) : i(o.error) : n(o);
            }), e.addEventListener("error", function () {
              return i(new Error("Network Error"));
            }), e.addEventListener("abort", function () {
              return i(new Error("Abort"));
            }), e.send(t);
          });
        }
      }]);

      return Xu;
    }();

    ci(Xu, ei);
    var th = {
      refreshInterval: 36e5,
      autoRefresh: !0
    };

    var eh =
    /*#__PURE__*/
    function () {
      function eh(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : th;

        _classCallCheck(this, eh);

        if (!t) throw new Gn.b("token-missing-token-url: A `tokenUrl` must be provided as the first constructor argument.", this);
        this.set("value", e.initValue), this._refresh = "function" == typeof t ? t : function () {
          return function (t) {
            return new Promise(function (e, n) {
              var i = new XMLHttpRequest();
              i.open("GET", t), i.addEventListener("load", function () {
                var t = i.status,
                    o = i.response;
                return t < 200 || t > 299 ? n(new Gn.b("token-cannot-download-new-token: Cannot download new token from the provided url.", null)) : e(o);
              }), i.addEventListener("error", function () {
                return n(new Error("Network Error"));
              }), i.addEventListener("abort", function () {
                return n(new Error("Abort"));
              }), i.send();
            });
          }(t);
        }, this._options = Object.assign({}, th, e);
      }

      _createClass(eh, [{
        key: "init",
        value: function init() {
          var _this146 = this;

          return new Promise(function (t, e) {
            _this146._options.autoRefresh && _this146._startRefreshing(), _this146.value ? t(_this146) : _this146._refreshToken().then(t).catch(e);
          });
        }
      }, {
        key: "_refreshToken",
        value: function _refreshToken() {
          var _this147 = this;

          return this._refresh().then(function (t) {
            return _this147.set("value", t);
          }).then(function () {
            return _this147;
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._stopRefreshing();
        }
      }, {
        key: "_startRefreshing",
        value: function _startRefreshing() {
          var _this148 = this;

          this._refreshInterval = setInterval(function () {
            return _this148._refreshToken();
          }, this._options.refreshInterval);
        }
      }, {
        key: "_stopRefreshing",
        value: function _stopRefreshing() {
          clearInterval(this._refreshInterval);
        }
      }], [{
        key: "create",
        value: function create(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : th;
          return new eh(t, e).init();
        }
      }]);

      return eh;
    }();

    ci(eh, Fi);
    var nh = eh;

    var ih =
    /*#__PURE__*/
    function (_Ql31) {
      _inherits(ih, _Ql31);

      function ih() {
        _classCallCheck(this, ih);

        return _possibleConstructorReturn(this, _getPrototypeOf(ih).apply(this, arguments));
      }

      _createClass(ih, [{
        key: "init",
        value: function init() {
          var t = this.editor.config.get("cloudServices") || {};

          for (var _e206 in t) {
            this[_e206] = t[_e206];
          }

          if (this.tokenUrl) return this.token = new ih.Token(this.tokenUrl), this.token.init();
          this.token = null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CloudServices";
        }
      }]);

      return ih;
    }(Ql);

    ih.Token = nh;

    var oh =
    /*#__PURE__*/
    function (_Ql32) {
      _inherits(oh, _Ql32);

      function oh() {
        _classCallCheck(this, oh);

        return _possibleConstructorReturn(this, _getPrototypeOf(oh).apply(this, arguments));
      }

      _createClass(oh, [{
        key: "init",
        value: function init() {
          var _this149 = this;

          var t = this.editor,
              e = t.plugins.get(ih),
              n = e.token,
              i = e.uploadUrl;
          n && (this._uploadGateway = new oh._UploadGateway(n, i), t.plugins.get(Xd).createUploadAdapter = function (t) {
            return new rh(_this149._uploadGateway, t);
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Xd, ih];
        }
      }]);

      return oh;
    }(Ql);

    var rh =
    /*#__PURE__*/
    function () {
      function rh(t, e) {
        _classCallCheck(this, rh);

        this.uploadGateway = t, this.loader = e;
      }

      _createClass(rh, [{
        key: "upload",
        value: function upload() {
          var _this150 = this;

          return this.loader.file.then(function (t) {
            return _this150.fileUploader = _this150.uploadGateway.upload(t), _this150.fileUploader.on("progress", function (t, e) {
              _this150.loader.uploadTotal = e.total, _this150.loader.uploaded = e.uploaded;
            }), _this150.fileUploader.send();
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.fileUploader.abort();
        }
      }]);

      return rh;
    }();

    oh._UploadGateway =
    /*#__PURE__*/
    function () {
      function _class(t, e) {
        _classCallCheck(this, _class);

        if (!t) throw new Gn.b("uploadgateway-missing-token: Token must be provided.", null);
        if (!e) throw new Gn.b("uploadgateway-missing-api-address: Api address must be provided.", null);
        this._token = t, this._apiAddress = e;
      }

      _createClass(_class, [{
        key: "upload",
        value: function upload(t) {
          return new Xu(t, this._token, this._apiAddress);
        }
      }]);

      return _class;
    }();

    var sh =
    /*#__PURE__*/
    function (_hr7) {
      _inherits(sh, _hr7);

      function sh(t) {
        var _this151;

        _classCallCheck(this, sh);

        _this151 = _possibleConstructorReturn(this, _getPrototypeOf(sh).call(this, t)), _this151._observedElements = new Set();
        return _this151;
      }

      _createClass(sh, [{
        key: "observe",
        value: function observe(t, e) {
          var _this152 = this;

          this.document.getRoot(e).on("change:children", function (e, n) {
            _this152.view.once("render", function () {
              return _this152._updateObservedElements(t, n);
            });
          });
        }
      }, {
        key: "_updateObservedElements",
        value: function _updateObservedElements(t, e) {
          var _this153 = this;

          if (!e.is("element") || e.is("attributeElement")) return;
          var n = this.view.domConverter.mapViewToDom(e);

          if (n) {
            var _iteratorNormalCompletion271 = true;
            var _didIteratorError271 = false;
            var _iteratorError271 = undefined;

            try {
              for (var _iterator271 = n.querySelectorAll("img")[Symbol.iterator](), _step271; !(_iteratorNormalCompletion271 = (_step271 = _iterator271.next()).done); _iteratorNormalCompletion271 = true) {
                var _t227 = _step271.value;
                this._observedElements.has(_t227) || (this.listenTo(_t227, "load", function (t, e) {
                  return _this153._fireEvents(e);
                }), this._observedElements.add(_t227));
              }
            } catch (err) {
              _didIteratorError271 = true;
              _iteratorError271 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion271 && _iterator271.return != null) {
                  _iterator271.return();
                }
              } finally {
                if (_didIteratorError271) {
                  throw _iteratorError271;
                }
              }
            }

            var _iteratorNormalCompletion272 = true;
            var _didIteratorError272 = false;
            var _iteratorError272 = undefined;

            try {
              for (var _iterator272 = this._observedElements[Symbol.iterator](), _step272; !(_iteratorNormalCompletion272 = (_step272 = _iterator272.next()).done); _iteratorNormalCompletion272 = true) {
                var _e207 = _step272.value;
                t.contains(_e207) || (this.stopListening(_e207), this._observedElements.delete(_e207));
              }
            } catch (err) {
              _didIteratorError272 = true;
              _iteratorError272 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion272 && _iterator272.return != null) {
                  _iterator272.return();
                }
              } finally {
                if (_didIteratorError272) {
                  throw _iteratorError272;
                }
              }
            }
          }
        }
      }, {
        key: "_fireEvents",
        value: function _fireEvents(t) {
          this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._observedElements.clear(), _get(_getPrototypeOf(sh.prototype), "destroy", this).call(this);
        }
      }]);

      return sh;
    }(hr);

    function ah(t) {
      return function (n) {
        n.on("attribute:".concat(t, ":image"), e);
      };

      function e(t, e, n) {
        if (!n.consumable.consume(e.item, t.name)) return;
        var i = n.writer,
            o = n.mapper.toViewElement(e.item).getChild(0);
        null !== e.attributeNewValue ? i.setAttribute(e.attributeKey, e.attributeNewValue, o) : i.removeAttribute(e.attributeKey, o);
      }
    }

    var ch =
    /*#__PURE__*/
    function () {
      function ch() {
        _classCallCheck(this, ch);

        this._stack = [];
      }

      _createClass(ch, [{
        key: "add",
        value: function add(t, e) {
          var n = this._stack,
              i = n[0];

          this._insertDescriptor(t);

          var o = n[0];
          i === o || lh(i, o) || this.fire("change:top", {
            oldDescriptor: i,
            newDescriptor: o,
            writer: e
          });
        }
      }, {
        key: "remove",
        value: function remove(t, e) {
          var n = this._stack,
              i = n[0];

          this._removeDescriptor(t);

          var o = n[0];
          i === o || lh(i, o) || this.fire("change:top", {
            oldDescriptor: i,
            newDescriptor: o,
            writer: e
          });
        }
      }, {
        key: "_insertDescriptor",
        value: function _insertDescriptor(t) {
          var e = this._stack,
              n = e.findIndex(function (e) {
            return e.id === t.id;
          });
          if (lh(t, e[n])) return;
          n > -1 && e.splice(n, 1);
          var i = 0;

          for (; e[i] && dh(e[i], t);) {
            i++;
          }

          e.splice(i, 0, t);
        }
      }, {
        key: "_removeDescriptor",
        value: function _removeDescriptor(t) {
          var e = this._stack,
              n = e.findIndex(function (e) {
            return e.id === t;
          });
          n > -1 && e.splice(n, 1);
        }
      }]);

      return ch;
    }();

    function lh(t, e) {
      return t && e && t.priority == e.priority && uh(t.classes) == uh(e.classes);
    }

    function dh(t, e) {
      return t.priority > e.priority || !(t.priority < e.priority) && uh(t.classes) > uh(e.classes);
    }

    function uh(t) {
      return Array.isArray(t) ? t.sort().join(",") : t;
    }

    ci(ch, ei);
    var hh = n(29),
        fh = n.n(hh);
    var mh = "ck-widget",
        ph = "ck-widget_selected";

    function gh(t) {
      return !!t.is("element") && !!t.getCustomProperty("widget");
    }

    function bh(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return mo.isEdge || e.setAttribute("contenteditable", "false", t), e.addClass(mh, t), e.setCustomProperty("widget", !0, t), t.getFillerOffset = vh, n.label && function (t, e, n) {
        n.setCustomProperty("widgetLabel", e, t);
      }(t, n.label, e), n.hasSelectionHandler && function (t, e) {
        var n = e.createUIElement("div", {
          class: "ck ck-widget__selection-handler"
        }, function (t) {
          var e = this.toDomElement(t),
              n = new Fd();
          return n.set("content", fh.a), n.render(), e.appendChild(n.element), e;
        });
        e.insert(e.createPositionAt(t, 0), n), e.addClass(["ck-widget_with-selection-handler"], t);
      }(t, e), function (t, e, n, i) {
        var o = new ch();
        o.on("change:top", function (e, o) {
          o.oldDescriptor && i(t, o.oldDescriptor, o.writer), o.newDescriptor && n(t, o.newDescriptor, o.writer);
        }), e.setCustomProperty("addHighlight", function (t, e, n) {
          return o.add(e, n);
        }, t), e.setCustomProperty("removeHighlight", function (t, e, n) {
          return o.remove(e, n);
        }, t);
      }(t, e, function (t, e, n) {
        return n.addClass(i(e.classes), t);
      }, function (t, e, n) {
        return n.removeClass(i(e.classes), t);
      }), t;

      function i(t) {
        return Array.isArray(t) ? t : [t];
      }
    }

    function wh(t) {
      var e = t.getCustomProperty("widgetLabel");
      return e ? "function" == typeof e ? e() : e : "";
    }

    function _h(t, e) {
      return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t), mo.isEdge || (e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t), t.on("change:isReadOnly", function (n, i, o) {
        e.setAttribute("contenteditable", o ? "false" : "true", t);
      })), t.on("change:isFocused", function (n, i, o) {
        o ? e.addClass("ck-editor__nested-editable_focused", t) : e.removeClass("ck-editor__nested-editable_focused", t);
      }), t;
    }

    function kh(t, e) {
      var n = t.getSelectedElement();
      if (n && e.schema.isBlock(n)) return e.createPositionAfter(n);
      var i = t.getSelectedBlocks().next().value;

      if (i) {
        if (i.isEmpty) return e.createPositionAt(i, 0);

        var _n202 = e.createPositionAfter(i);

        return t.focus.isTouching(_n202) ? _n202 : e.createPositionBefore(i);
      }

      return t.focus;
    }

    function vh() {
      return null;
    }

    function yh(t) {
      var e = t.getSelectedElement();
      return e && function (t) {
        return !!t.getCustomProperty("image") && gh(t);
      }(e) ? e : null;
    }

    function xh(t) {
      return !!t && t.is("image");
    }

    function Ah(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = t.createElement("image", n),
          o = kh(e.document.selection, e);
      e.insertContent(i, o), i.parent && t.setSelection(i, "on");
    }

    function Ch(t) {
      var e = t.schema,
          n = t.document.selection;
      return function (t, e, n) {
        var i = function (t, e) {
          var n = kh(t, e).parent;
          if (n.isEmpty && !n.is("$root")) return n.parent;
          return n;
        }(t, n);

        return e.checkChild(i, "image");
      }(n, e, t) && !function (t, e) {
        var n = t.getSelectedElement();
        return n && e.isObject(n);
      }(n, e) && function (t) {
        return _toConsumableArray(t.focus.getAncestors()).every(function (t) {
          return !t.is("image");
        });
      }(n);
    }

    var Th =
    /*#__PURE__*/
    function (_td9) {
      _inherits(Th, _td9);

      function Th() {
        _classCallCheck(this, Th);

        return _possibleConstructorReturn(this, _getPrototypeOf(Th).apply(this, arguments));
      }

      _createClass(Th, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = Ch(this.editor.model);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          e.change(function (n) {
            var i = Array.isArray(t.source) ? t.source : [t.source];
            var _iteratorNormalCompletion273 = true;
            var _didIteratorError273 = false;
            var _iteratorError273 = undefined;

            try {
              for (var _iterator273 = i[Symbol.iterator](), _step273; !(_iteratorNormalCompletion273 = (_step273 = _iterator273.next()).done); _iteratorNormalCompletion273 = true) {
                var _t228 = _step273.value;
                Ah(n, e, {
                  src: _t228
                });
              }
            } catch (err) {
              _didIteratorError273 = true;
              _iteratorError273 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion273 && _iterator273.return != null) {
                  _iterator273.return();
                }
              } finally {
                if (_didIteratorError273) {
                  throw _iteratorError273;
                }
              }
            }
          });
        }
      }]);

      return Th;
    }(td);

    var Ph =
    /*#__PURE__*/
    function (_Ql33) {
      _inherits(Ph, _Ql33);

      function Ph() {
        _classCallCheck(this, Ph);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ph).apply(this, arguments));
      }

      _createClass(Ph, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.t,
              i = t.conversion;
          t.editing.view.addObserver(sh), e.register("image", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["alt", "src", "srcset"]
          }), i.for("dataDowncast").elementToElement({
            model: "image",
            view: function view(t, e) {
              return Mh(e);
            }
          }), i.for("editingDowncast").elementToElement({
            model: "image",
            view: function view(t, e) {
              return function (t, e, n) {
                return e.setCustomProperty("image", !0, t), bh(t, e, {
                  label: function label() {
                    var e = t.getChild(0).getAttribute("alt");
                    return e ? "".concat(e, " ").concat(n) : n;
                  }
                });
              }(Mh(e), e, n("ao"));
            }
          }), i.for("downcast").add(ah("src")).add(ah("alt")).add(function () {
            return function (e) {
              e.on("attribute:srcset:image", t);
            };

            function t(t, e, n) {
              if (!n.consumable.consume(e.item, t.name)) return;
              var i = n.writer,
                  o = n.mapper.toViewElement(e.item).getChild(0);

              if (null === e.attributeNewValue) {
                var _t229 = e.attributeOldValue;
                _t229.data && (i.removeAttribute("srcset", o), i.removeAttribute("sizes", o), _t229.width && i.removeAttribute("width", o));
              } else {
                var _t230 = e.attributeNewValue;
                _t230.data && (i.setAttribute("srcset", _t230.data, o), i.setAttribute("sizes", "100vw", o), _t230.width && i.setAttribute("width", _t230.width, o));
              }
            }
          }()), i.for("upcast").elementToElement({
            view: {
              name: "img",
              attributes: {
                src: !0
              }
            },
            model: function model(t, e) {
              return e.createElement("image", {
                src: t.getAttribute("src")
              });
            }
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "alt"
            },
            model: "alt"
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "srcset"
            },
            model: {
              key: "srcset",
              value: function value(t) {
                var e = {
                  data: t.getAttribute("srcset")
                };
                return t.hasAttribute("width") && (e.width = t.getAttribute("width")), e;
              }
            }
          }).add(function () {
            return function (e) {
              e.on("element:figure", t);
            };

            function t(t, e, n) {
              if (!n.consumable.test(e.viewItem, {
                name: !0,
                classes: "image"
              })) return;
              var i = Array.from(e.viewItem.getChildren()).find(function (t) {
                return t.is("img");
              });
              if (!i || !i.hasAttribute("src") || !n.consumable.test(i, {
                name: !0
              })) return;
              var o = n.convertItem(i, e.modelCursor),
                  r = Ru(o.modelRange.getItems());
              r && (n.convertChildren(e.viewItem, n.writer.createPositionAt(r, 0)), e.modelRange = o.modelRange, e.modelCursor = o.modelCursor);
            }
          }()), t.commands.add("imageInsert", new Th(t));
        }
      }]);

      return Ph;
    }(Ql);

    function Mh(t) {
      var e = t.createEmptyElement("img"),
          n = t.createContainerElement("figure", {
        class: "image"
      });
      return t.insert(t.createPositionAt(n, 0), e), n;
    }

    var Sh =
    /*#__PURE__*/
    function (_ts6) {
      _inherits(Sh, _ts6);

      function Sh(t) {
        var _this154;

        _classCallCheck(this, Sh);

        _this154 = _possibleConstructorReturn(this, _getPrototypeOf(Sh).call(this, t)), _this154.domEventType = "mousedown";
        return _this154;
      }

      _createClass(Sh, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return Sh;
    }(ts);

    n(73);

    var Eh = _o("Ctrl+A");

    var Ih =
    /*#__PURE__*/
    function (_Ql34) {
      _inherits(Ih, _Ql34);

      function Ih() {
        _classCallCheck(this, Ih);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ih).apply(this, arguments));
      }

      _createClass(Ih, [{
        key: "init",
        value: function init() {
          var _this155 = this;

          var t = this.editor.editing.view,
              e = t.document;
          this._previouslySelected = new Set(), this.editor.editing.downcastDispatcher.on("selection", function (t, e, n) {
            _this155._clearPreviouslySelectedWidgets(n.writer);

            var i = n.writer,
                o = i.document.selection,
                r = o.getSelectedElement();
            var s = null;
            var _iteratorNormalCompletion274 = true;
            var _didIteratorError274 = false;
            var _iteratorError274 = undefined;

            try {
              for (var _iterator274 = o.getRanges()[Symbol.iterator](), _step274; !(_iteratorNormalCompletion274 = (_step274 = _iterator274.next()).done); _iteratorNormalCompletion274 = true) {
                var _t231 = _step274.value;
                var _iteratorNormalCompletion275 = true;
                var _didIteratorError275 = false;
                var _iteratorError275 = undefined;

                try {
                  for (var _iterator275 = _t231[Symbol.iterator](), _step275; !(_iteratorNormalCompletion275 = (_step275 = _iterator275.next()).done); _iteratorNormalCompletion275 = true) {
                    var _e208 = _step275.value;
                    var _t232 = _e208.item;
                    gh(_t232) && !Nh(_t232, s) && (i.addClass(ph, _t232), _this155._previouslySelected.add(_t232), s = _t232, _t232 == r && i.setSelection(o.getRanges(), {
                      fake: !0,
                      label: wh(r)
                    }));
                  }
                } catch (err) {
                  _didIteratorError275 = true;
                  _iteratorError275 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion275 && _iterator275.return != null) {
                      _iterator275.return();
                    }
                  } finally {
                    if (_didIteratorError275) {
                      throw _iteratorError275;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError274 = true;
              _iteratorError274 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion274 && _iterator274.return != null) {
                  _iterator274.return();
                }
              } finally {
                if (_didIteratorError274) {
                  throw _iteratorError274;
                }
              }
            }
          }, {
            priority: "low"
          }), t.addObserver(Sh), this.listenTo(e, "mousedown", function () {
            return _this155._onMousedown.apply(_this155, arguments);
          }), this.listenTo(e, "keydown", function () {
            return _this155._onKeydown.apply(_this155, arguments);
          }, {
            priority: "high"
          }), this.listenTo(e, "delete", function (t, e) {
            _this155._handleDelete("forward" == e.direction) && (e.preventDefault(), t.stop());
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_onMousedown",
        value: function _onMousedown(t, e) {
          var n = this.editor,
              i = n.editing.view,
              o = i.document;
          var r = e.target;

          if (function (t) {
            for (; t;) {
              if (t.is("editableElement") && !t.is("rootElement")) return !0;
              if (gh(t)) return !1;
              t = t.parent;
            }

            return !1;
          }(r)) {
            if (mo.isSafari && e.domEvent.detail >= 3) {
              var _t233 = n.editing.mapper.toModelElement(r);

              this.editor.model.change(function (n) {
                e.preventDefault(), n.setSelection(_t233, "in");
              });
            }

            return;
          }

          if (!gh(r) && !(r = r.findAncestor(gh))) return;
          e.preventDefault(), o.isFocused || i.focus();
          var s = n.editing.mapper.toModelElement(r);

          this._setSelectionOverElement(s);
        }
      }, {
        key: "_onKeydown",
        value: function _onKeydown(t, e) {
          var n = e.keyCode,
              i = n == bo.arrowdown || n == bo.arrowright;
          var o = !1;
          !function (t) {
            return t == bo.arrowright || t == bo.arrowleft || t == bo.arrowup || t == bo.arrowdown;
          }(n) ? !function (t) {
            return wo(t) == Eh;
          }(e) ? n === bo.enter && (o = this._handleEnterKey(e.shiftKey)) : o = this._selectAllNestedEditableContent() || this._selectAllContent() : o = this._handleArrowKeys(i), o && (e.preventDefault(), t.stop());
        }
      }, {
        key: "_handleDelete",
        value: function _handleDelete(t) {
          var _this156 = this;

          if (this.editor.isReadOnly) return;
          var e = this.editor.model.document.selection;
          if (!e.isCollapsed) return;

          var n = this._getObjectElementNextToSelection(t);

          return n ? (this.editor.model.change(function (t) {
            var i = e.anchor.parent;

            for (; i.isEmpty;) {
              var _e209 = i;
              i = _e209.parent, t.remove(_e209);
            }

            _this156._setSelectionOverElement(n);
          }), !0) : void 0;
        }
      }, {
        key: "_handleArrowKeys",
        value: function _handleArrowKeys(t) {
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = i.getSelectedElement();

          if (o && n.isObject(o)) {
            var _o78 = t ? i.getLastPosition() : i.getFirstPosition(),
                _r37 = n.getNearestSelectionRange(_o78, t ? "forward" : "backward");

            return _r37 && e.change(function (t) {
              t.setSelection(_r37);
            }), !0;
          }

          if (!i.isCollapsed) return;

          var r = this._getObjectElementNextToSelection(t);

          return r && n.isObject(r) ? (this._setSelectionOverElement(r), !0) : void 0;
        }
      }, {
        key: "_handleEnterKey",
        value: function _handleEnterKey(t) {
          var e = this.editor.model,
              n = e.document.selection.getSelectedElement();
          if (function (t, e) {
            return t && e.isObject(t) && !e.isInline(t);
          }(n, e.schema)) return e.change(function (i) {
            var o = i.createPositionAt(n, t ? "before" : "after");
            var r = i.createElement("paragraph");

            if (e.schema.isBlock(n.parent)) {
              var _t234 = e.schema.findAllowedParent(o, r);

              o = i.split(o, _t234).position;
            }

            i.insert(r, o), i.setSelection(r, "in");
          }), !0;
        }
      }, {
        key: "_selectAllNestedEditableContent",
        value: function _selectAllNestedEditableContent() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema.getLimitElement(e);
          return e.getFirstRange().root != n && (t.change(function (t) {
            t.setSelection(t.createRangeIn(n));
          }), !0);
        }
      }, {
        key: "_selectAllContent",
        value: function _selectAllContent() {
          var t = this.editor.model,
              e = this.editor.editing,
              n = e.view.document.selection.getSelectedElement();

          if (n && gh(n)) {
            var _i167 = e.mapper.toModelElement(n.parent);

            return t.change(function (t) {
              t.setSelection(t.createRangeIn(_i167));
            }), !0;
          }

          return !1;
        }
      }, {
        key: "_setSelectionOverElement",
        value: function _setSelectionOverElement(t) {
          this.editor.model.change(function (e) {
            e.setSelection(e.createRangeOn(t));
          });
        }
      }, {
        key: "_getObjectElementNextToSelection",
        value: function _getObjectElementNextToSelection(t) {
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = e.createSelection(i);
          e.modifySelection(o, {
            direction: t ? "forward" : "backward"
          });
          var r = t ? o.focus.nodeBefore : o.focus.nodeAfter;
          return r && n.isObject(r) ? r : null;
        }
      }, {
        key: "_clearPreviouslySelectedWidgets",
        value: function _clearPreviouslySelectedWidgets(t) {
          var _iteratorNormalCompletion276 = true;
          var _didIteratorError276 = false;
          var _iteratorError276 = undefined;

          try {
            for (var _iterator276 = this._previouslySelected[Symbol.iterator](), _step276; !(_iteratorNormalCompletion276 = (_step276 = _iterator276.next()).done); _iteratorNormalCompletion276 = true) {
              var _e210 = _step276.value;
              t.removeClass(ph, _e210);
            }
          } catch (err) {
            _didIteratorError276 = true;
            _iteratorError276 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion276 && _iterator276.return != null) {
                _iterator276.return();
              }
            } finally {
              if (_didIteratorError276) {
                throw _iteratorError276;
              }
            }
          }

          this._previouslySelected.clear();
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Widget";
        }
      }]);

      return Ih;
    }(Ql);

    function Nh(t, e) {
      return !!e && Array.from(t.getAncestors()).includes(e);
    }

    var Oh =
    /*#__PURE__*/
    function (_td10) {
      _inherits(Oh, _td10);

      function Oh() {
        _classCallCheck(this, Oh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Oh).apply(this, arguments));
      }

      _createClass(Oh, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = xh(t), xh(t) && t.hasAttribute("alt") ? this.value = t.getAttribute("alt") : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document.selection.getSelectedElement();
          e.change(function (e) {
            e.setAttribute("alt", t.newValue, n);
          });
        }
      }]);

      return Oh;
    }(td);

    var Rh =
    /*#__PURE__*/
    function (_Ql35) {
      _inherits(Rh, _Ql35);

      function Rh() {
        _classCallCheck(this, Rh);

        return _possibleConstructorReturn(this, _getPrototypeOf(Rh).apply(this, arguments));
      }

      _createClass(Rh, [{
        key: "init",
        value: function init() {
          this.editor.commands.add("imageTextAlternative", new Oh(this.editor));
        }
      }]);

      return Rh;
    }(Ql);

    function Dh(_ref87) {
      var t = _ref87.emitter,
          e = _ref87.activator,
          n = _ref87.callback,
          i = _ref87.contextElements;
      t.listenTo(document, "mousedown", function (t, _ref88) {
        var o = _ref88.target;

        if (e()) {
          var _iteratorNormalCompletion277 = true;
          var _didIteratorError277 = false;
          var _iteratorError277 = undefined;

          try {
            for (var _iterator277 = i[Symbol.iterator](), _step277; !(_iteratorNormalCompletion277 = (_step277 = _iterator277.next()).done); _iteratorNormalCompletion277 = true) {
              var _t235 = _step277.value;
              if (_t235.contains(o)) return;
            }
          } catch (err) {
            _didIteratorError277 = true;
            _iteratorError277 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion277 && _iterator277.return != null) {
                _iterator277.return();
              }
            } finally {
              if (_didIteratorError277) {
                throw _iteratorError277;
              }
            }
          }

          n();
        }
      });
    }

    n(75);

    var Lh =
    /*#__PURE__*/
    function (_Rl10) {
      _inherits(Lh, _Rl10);

      function Lh(t, e) {
        var _this157;

        _classCallCheck(this, Lh);

        _this157 = _possibleConstructorReturn(this, _getPrototypeOf(Lh).call(this, t));
        var n = "ck-input-".concat(Kn()),
            i = "ck-status-".concat(Kn());
        _this157.set("label"), _this157.set("value"), _this157.set("isReadOnly", !1), _this157.set("errorText", null), _this157.set("infoText", null), _this157.labelView = _this157._createLabelView(n), _this157.inputView = _this157._createInputView(e, n, i), _this157.statusView = _this157._createStatusView(i), _this157.bind("_statusText").to(_assertThisInitialized(_this157), "errorText", _assertThisInitialized(_this157), "infoText", function (t, e) {
          return t || e;
        });
        var o = _this157.bindTemplate;

        _this157.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-input", o.if("isReadOnly", "ck-disabled")]
          },
          children: [_this157.labelView, _this157.inputView, _this157.statusView]
        });

        return _this157;
      }

      _createClass(Lh, [{
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new Ll(this.locale);
          return e.for = t, e.bind("text").to(this, "label"), e;
        }
      }, {
        key: "_createInputView",
        value: function _createInputView(t, e, n) {
          var _this158 = this;

          var i = new t(this.locale, n);
          return i.id = e, i.ariaDescribedById = n, i.bind("value").to(this), i.bind("isReadOnly").to(this), i.bind("hasError").to(this, "errorText", function (t) {
            return !!t;
          }), i.on("input", function () {
            _this158.errorText = null;
          }), i;
        }
      }, {
        key: "_createStatusView",
        value: function _createStatusView(t) {
          var e = new Rl(this.locale),
              n = this.bindTemplate;
          return e.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-input__status", n.if("errorText", "ck-labeled-input__status_error"), n.if("_statusText", "ck-hidden", function (t) {
                return !t;
              })],
              id: t
            },
            children: [{
              text: n.to("_statusText")
            }]
          }), e;
        }
      }, {
        key: "select",
        value: function select() {
          this.inputView.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.inputView.focus();
        }
      }]);

      return Lh;
    }(Rl);

    n(77);

    var jh =
    /*#__PURE__*/
    function (_Rl11) {
      _inherits(jh, _Rl11);

      function jh(t) {
        var _this159;

        _classCallCheck(this, jh);

        _this159 = _possibleConstructorReturn(this, _getPrototypeOf(jh).call(this, t)), _this159.set("value"), _this159.set("id"), _this159.set("placeholder"), _this159.set("isReadOnly", !1), _this159.set("hasError", !1), _this159.set("ariaDescribedById");
        var e = _this159.bindTemplate;

        _this159.setTemplate({
          tag: "input",
          attributes: {
            type: "text",
            class: ["ck", "ck-input", "ck-input-text", e.if("hasError", "ck-error")],
            id: e.to("id"),
            placeholder: e.to("placeholder"),
            readonly: e.to("isReadOnly"),
            "aria-invalid": e.if("hasError", !0),
            "aria-describedby": e.to("ariaDescribedById")
          },
          on: {
            input: e.to("input")
          }
        });

        return _this159;
      }

      _createClass(jh, [{
        key: "render",
        value: function render() {
          var _this160 = this;

          _get(_getPrototypeOf(jh.prototype), "render", this).call(this);

          var t = function t(_t236) {
            _this160.element.value = _t236 || 0 === _t236 ? _t236 : "";
          };

          t(this.value), this.on("change:value", function (e, n, i) {
            t(i);
          });
        }
      }, {
        key: "select",
        value: function select() {
          this.element.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }]);

      return jh;
    }(Rl);

    function Vh(_ref89) {
      var t = _ref89.view;
      t.listenTo(t.element, "submit", function (e, n) {
        n.preventDefault(), t.fire("submit");
      }, {
        useCapture: !0
      });
    }

    var Bh = n(7),
        zh = n.n(Bh),
        Fh = n(8),
        Uh = n.n(Fh);
    n(79);

    var Hh =
    /*#__PURE__*/
    function (_Rl12) {
      _inherits(Hh, _Rl12);

      function Hh(t) {
        var _this161;

        _classCallCheck(this, Hh);

        _this161 = _possibleConstructorReturn(this, _getPrototypeOf(Hh).call(this, t));
        var e = _this161.locale.t;
        _this161.focusTracker = new rl(), _this161.keystrokes = new Jc(), _this161.labeledInput = _this161._createLabeledInputView(), _this161.saveButtonView = _this161._createButton(e("bq"), zh.a, "ck-button-save"), _this161.saveButtonView.type = "submit", _this161.cancelButtonView = _this161._createButton(e("br"), Uh.a, "ck-button-cancel", "cancel"), _this161._focusables = new ml(), _this161._focusCycler = new Hl({
          focusables: _this161._focusables,
          focusTracker: _this161.focusTracker,
          keystrokeHandler: _this161.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this161.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form"],
            tabindex: "-1"
          },
          children: [_this161.labeledInput, _this161.saveButtonView, _this161.cancelButtonView]
        });
        return _this161;
      }

      _createClass(Hh, [{
        key: "render",
        value: function render() {
          var _this162 = this;

          _get(_getPrototypeOf(Hh.prototype), "render", this).call(this), this.keystrokes.listenTo(this.element), Vh({
            view: this
          }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this162._focusables.add(t), _this162.focusTracker.add(t.element);
          });
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new Hd(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }, {
        key: "_createLabeledInputView",
        value: function _createLabeledInputView() {
          var t = this.locale.t,
              e = new Lh(this.locale, jh);
          return e.label = t("bs"), e.inputView.placeholder = t("bs"), e;
        }
      }]);

      return Hh;
    }(Rl);

    function qh(_ref90) {
      var t = _ref90.element,
          e = _ref90.target,
          n = _ref90.positions,
          i = _ref90.limiter,
          o = _ref90.fitInViewport;
      W(e) && (e = e()), W(i) && (i = i());

      var r = function (t) {
        for (; t && "html" != t.tagName.toLowerCase();) {
          if ("static" != nr.window.getComputedStyle(t).position) return t;
          t = t.parentElement;
        }

        return null;
      }(t.parentElement),
          s = new Cs(t),
          a = new Cs(e);

      var c, l;

      if (i || o) {
        var _t237 = i && new Cs(i).getVisible(),
            _e211 = o && new Cs(nr.window);

        var _ref91 = function (t, e, n, i, o) {
          var r,
              s,
              a = 0,
              c = 0;
          var l = n.getArea();
          return t.some(function (t) {
            var _Wh = Wh(t, e, n),
                _Wh2 = _slicedToArray(_Wh, 2),
                d = _Wh2[0],
                u = _Wh2[1];

            var h, f;
            if (i) if (o) {
              var _t238 = i.getIntersection(o);

              h = _t238 ? _t238.getIntersectionArea(u) : 0;
            } else h = i.getIntersectionArea(u);

            function m() {
              c = f, a = h, r = u, s = d;
            }

            return o && (f = o.getIntersectionArea(u)), o && !i ? f > c && m() : !o && i ? h > a && m() : f > c && h >= a ? m() : f >= c && h > a && m(), h === l;
          }), r ? [s, r] : null;
        }(n, a, s, _t237, _e211) || Wh(n[0], a, s);

        var _ref92 = _slicedToArray(_ref91, 2);

        l = _ref92[0];
        c = _ref92[1];
      } else {
        var _Wh3 = Wh(n[0], a, s);

        var _Wh4 = _slicedToArray(_Wh3, 2);

        l = _Wh4[0];
        c = _Wh4[1];
      }

      var _Yh = Yh(c),
          d = _Yh.left,
          u = _Yh.top;

      if (r) {
        var _t239 = Yh(new Cs(r)),
            _e212 = xs(r);

        d -= _t239.left, u -= _t239.top, d += r.scrollLeft, u += r.scrollTop, d -= _e212.left, u -= _e212.top;
      }

      return {
        left: d,
        top: u,
        name: l
      };
    }

    function Wh(t, e, n) {
      var _t240 = t(e, n),
          i = _t240.left,
          o = _t240.top,
          r = _t240.name;

      return [r, n.clone().moveTo(i, o)];
    }

    function Yh(_ref93) {
      var t = _ref93.left,
          e = _ref93.top;
      var _nr$window2 = nr.window,
          n = _nr$window2.scrollX,
          i = _nr$window2.scrollY;
      return {
        left: t + n,
        top: e + i
      };
    }

    n(81);
    var $h = zl("px"),
        Gh = nr.document.body;

    var Qh =
    /*#__PURE__*/
    function (_Rl13) {
      _inherits(Qh, _Rl13);

      function Qh(t) {
        var _this163;

        _classCallCheck(this, Qh);

        _this163 = _possibleConstructorReturn(this, _getPrototypeOf(Qh).call(this, t));
        var e = _this163.bindTemplate;
        _this163.set("top", 0), _this163.set("left", 0), _this163.set("position", "arrow_nw"), _this163.set("isVisible", !1), _this163.set("withArrow", !0), _this163.set("class"), _this163.content = _this163.createCollection(), _this163.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-panel", e.to("position", function (t) {
              return "ck-balloon-panel_".concat(t);
            }), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")],
            style: {
              top: e.to("top", $h),
              left: e.to("left", $h)
            }
          },
          children: _this163.content
        });
        return _this163;
      }

      _createClass(Qh, [{
        key: "show",
        value: function show() {
          this.isVisible = !0;
        }
      }, {
        key: "hide",
        value: function hide() {
          this.isVisible = !1;
        }
      }, {
        key: "attachTo",
        value: function attachTo(t) {
          this.show();

          var e = Qh.defaultPositions,
              n = Object.assign({}, {
            element: this.element,
            positions: [e.southArrowNorth, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthWest, e.northArrowSouthEast],
            limiter: Gh,
            fitInViewport: !0
          }, t),
              i = Qh._getOptimalPosition(n),
              o = parseInt(i.left),
              r = parseInt(i.top),
              s = i.name;

          Object.assign(this, {
            top: r,
            left: o,
            position: s
          });
        }
      }, {
        key: "pin",
        value: function pin(t) {
          var _this164 = this;

          this.unpin(), this._pinWhenIsVisibleCallback = function () {
            _this164.isVisible ? _this164._startPinning(t) : _this164._stopPinning();
          }, this._startPinning(t), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
      }, {
        key: "unpin",
        value: function unpin() {
          this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
        }
      }, {
        key: "_startPinning",
        value: function _startPinning(t) {
          var _this165 = this;

          this.attachTo(t);
          var e = Jh(t.target),
              n = t.limiter ? Jh(t.limiter) : Gh;
          this.listenTo(nr.document, "scroll", function (i, o) {
            var r = o.target,
                s = e && r.contains(e),
                a = n && r.contains(n);
            !s && !a && e && n || _this165.attachTo(t);
          }, {
            useCapture: !0
          }), this.listenTo(nr.window, "resize", function () {
            _this165.attachTo(t);
          });
        }
      }, {
        key: "_stopPinning",
        value: function _stopPinning() {
          this.stopListening(nr.document, "scroll"), this.stopListening(nr.window, "resize");
        }
      }]);

      return Qh;
    }(Rl);

    function Jh(t) {
      return Wn(t) ? t : ys(t) ? t.commonAncestorContainer : "function" == typeof t ? Jh(t()) : null;
    }

    function Kh(t, e) {
      return t.top - e.height - Qh.arrowVerticalOffset;
    }

    function Zh(t) {
      return t.bottom + Qh.arrowVerticalOffset;
    }

    Qh.arrowHorizontalOffset = 25, Qh.arrowVerticalOffset = 10, Qh._getOptimalPosition = qh, Qh.defaultPositions = {
      northArrowSouth: function northArrowSouth(t, e) {
        return {
          top: Kh(t, e),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_s"
        };
      },
      northArrowSouthEast: function northArrowSouthEast(t, e) {
        return {
          top: Kh(t, e),
          left: t.left + t.width / 2 - e.width + Qh.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northArrowSouthWest: function northArrowSouthWest(t, e) {
        return {
          top: Kh(t, e),
          left: t.left + t.width / 2 - Qh.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouth: function northWestArrowSouth(t, e) {
        return {
          top: Kh(t, e),
          left: t.left - e.width / 2,
          name: "arrow_s"
        };
      },
      northWestArrowSouthWest: function northWestArrowSouthWest(t, e) {
        return {
          top: Kh(t, e),
          left: t.left - Qh.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouthEast: function northWestArrowSouthEast(t, e) {
        return {
          top: Kh(t, e),
          left: t.left - e.width + Qh.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouth: function northEastArrowSouth(t, e) {
        return {
          top: Kh(t, e),
          left: t.right - e.width / 2,
          name: "arrow_s"
        };
      },
      northEastArrowSouthEast: function northEastArrowSouthEast(t, e) {
        return {
          top: Kh(t, e),
          left: t.right - e.width + Qh.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouthWest: function northEastArrowSouthWest(t, e) {
        return {
          top: Kh(t, e),
          left: t.right - Qh.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      southArrowNorth: function southArrowNorth(t, e) {
        return {
          top: Zh(t),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_n"
        };
      },
      southArrowNorthEast: function southArrowNorthEast(t, e) {
        return {
          top: Zh(t),
          left: t.left + t.width / 2 - e.width + Qh.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southArrowNorthWest: function southArrowNorthWest(t, e) {
        return {
          top: Zh(t),
          left: t.left + t.width / 2 - Qh.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorth: function southWestArrowNorth(t, e) {
        return {
          top: Zh(t),
          left: t.left - e.width / 2,
          name: "arrow_n"
        };
      },
      southWestArrowNorthWest: function southWestArrowNorthWest(t, e) {
        return {
          top: Zh(t),
          left: t.left - Qh.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorthEast: function southWestArrowNorthEast(t, e) {
        return {
          top: Zh(t),
          left: t.left - e.width + Qh.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorth: function southEastArrowNorth(t, e) {
        return {
          top: Zh(t),
          left: t.right - e.width / 2,
          name: "arrow_n"
        };
      },
      southEastArrowNorthEast: function southEastArrowNorthEast(t, e) {
        return {
          top: Zh(t),
          left: t.right - e.width + Qh.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorthWest: function southEastArrowNorthWest(t, e) {
        return {
          top: Zh(t),
          left: t.right - Qh.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      }
    };
    var Xh = n(30),
        tf = n.n(Xh),
        ef = n(31),
        nf = n.n(ef);
    n(83), n(85);
    var of = zl("px");

    var rf =
    /*#__PURE__*/
    function (_Ql36) {
      _inherits(rf, _Ql36);

      _createClass(rf, null, [{
        key: "pluginName",
        get: function get() {
          return "ContextualBalloon";
        }
      }]);

      function rf(t) {
        var _this166;

        _classCallCheck(this, rf);

        _this166 = _possibleConstructorReturn(this, _getPrototypeOf(rf).call(this, t)), _this166.positionLimiter = function () {
          var t = _this166.editor.editing.view,
              e = t.document.selection.editableElement;
          return e ? t.domConverter.mapViewToDom(e.root) : null;
        }, _this166.set("visibleView", null), _this166.view = new Qh(t.locale), t.ui.view.body.add(_this166.view), t.ui.focusTracker.add(_this166.view.element), _this166._viewToStack = new Map(), _this166._idToStack = new Map(), _this166.set("_numberOfStacks", 0), _this166.set("_singleViewMode", !1), _this166._rotatorView = _this166._createRotatorView(), _this166._fakePanelsView = _this166._createFakePanelsView();
        return _this166;
      }

      _createClass(rf, [{
        key: "hasView",
        value: function hasView(t) {
          return Array.from(this._viewToStack.keys()).includes(t);
        }
      }, {
        key: "add",
        value: function add(t) {
          if (this.hasView(t.view)) throw new Gn.b("contextualballoon-add-view-exist: Cannot add configuration of the same view twice.", [this, t]);
          var e = t.stackId || "main";
          if (!this._idToStack.has(e)) return this._idToStack.set(e, new Map([[t.view, t]])), this._viewToStack.set(t.view, this._idToStack.get(e)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t.singleViewMode || this.showStack(e));

          var n = this._idToStack.get(e);

          t.singleViewMode && this.showStack(e), n.set(t.view, t), this._viewToStack.set(t.view, n), n === this._visibleStack && this._showView(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          if (!this.hasView(t)) throw new Gn.b("contextualballoon-remove-view-not-exist: Cannot remove the configuration of a non-existent view.", [this, t]);

          var e = this._viewToStack.get(t);

          this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (1 === e.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(e.values())[e.size - 2])), 1 === e.size ? (this._idToStack.delete(this._getStackId(e)), this._numberOfStacks = this._idToStack.size) : e.delete(t), this._viewToStack.delete(t);
        }
      }, {
        key: "updatePosition",
        value: function updatePosition(t) {
          t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
        }
      }, {
        key: "showStack",
        value: function showStack(t) {
          this.visibleStack = t;

          var e = this._idToStack.get(t);

          if (!e) throw new Gn.b("contextualballoon-showstack-stack-not-exist: Cannot show a stack that does not exist.", this);
          this._visibleStack !== e && this._showView(Array.from(e.values()).pop());
        }
      }, {
        key: "_getStackId",
        value: function _getStackId(t) {
          return Array.from(this._idToStack.entries()).find(function (e) {
            return e[1] === t;
          })[0];
        }
      }, {
        key: "_showNextStack",
        value: function _showNextStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) + 1;
          t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_showPrevStack",
        value: function _showPrevStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) - 1;
          t[e] || (e = t.length - 1), this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_createRotatorView",
        value: function _createRotatorView() {
          var _this167 = this;

          var t = new sf(this.editor.locale),
              e = this.editor.locale.t;
          return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t > 1;
          }), t.on("change:isNavigationVisible", function () {
            return _this167.updatePosition();
          }, {
            priority: "low"
          }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (t, n) {
            if (n < 2) return "";
            var i = Array.from(_this167._idToStack.values()).indexOf(_this167._visibleStack) + 1;
            return e("bn", [i, n]);
          }), t.buttonNextView.on("execute", function () {
            t.focusTracker.isFocused && _this167.editor.editing.view.focus(), _this167._showNextStack();
          }), t.buttonPrevView.on("execute", function () {
            t.focusTracker.isFocused && _this167.editor.editing.view.focus(), _this167._showPrevStack();
          }), t;
        }
      }, {
        key: "_createFakePanelsView",
        value: function _createFakePanelsView() {
          var t = new af(this.editor.locale, this.view);
          return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t >= 2 ? Math.min(t - 1, 2) : 0;
          }), t.listenTo(this.view, "change:top", function () {
            return t.updatePosition();
          }), t.listenTo(this.view, "change:left", function () {
            return t.updatePosition();
          }), this.editor.ui.view.body.add(t), t;
        }
      }, {
        key: "_showView",
        value: function _showView(_ref94) {
          var t = _ref94.view,
              _ref94$balloonClassNa = _ref94.balloonClassName,
              e = _ref94$balloonClassNa === void 0 ? "" : _ref94$balloonClassNa,
              _ref94$withArrow = _ref94.withArrow,
              n = _ref94$withArrow === void 0 ? !0 : _ref94$withArrow,
              _ref94$singleViewMode = _ref94.singleViewMode,
              i = _ref94$singleViewMode === void 0 ? !1 : _ref94$singleViewMode;
          this.view.class = e, this.view.withArrow = n, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), i && (this._singleViewMode = !0);
        }
      }, {
        key: "_getBalloonPosition",
        value: function _getBalloonPosition() {
          var t = Array.from(this._visibleStack.values()).pop().position;
          return t && !t.limiter && (t = Object.assign({}, t, {
            limiter: this.positionLimiter
          })), t;
        }
      }, {
        key: "_visibleStack",
        get: function get() {
          return this._viewToStack.get(this.visibleView);
        }
      }]);

      return rf;
    }(Ql);

    var sf =
    /*#__PURE__*/
    function (_Rl14) {
      _inherits(sf, _Rl14);

      function sf(t) {
        var _this168;

        _classCallCheck(this, sf);

        _this168 = _possibleConstructorReturn(this, _getPrototypeOf(sf).call(this, t));
        var e = t.t,
            n = _this168.bindTemplate;
        _this168.set("isNavigationVisible", !0), _this168.focusTracker = new rl(), _this168.buttonPrevView = _this168._createButtonView(e("bo"), tf.a), _this168.buttonNextView = _this168._createButtonView(e("bp"), nf.a), _this168.content = _this168.createCollection(), _this168.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", function (t) {
                return t ? "" : "ck-hidden";
              })]
            },
            children: [_this168.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: n.to("counter")
              }]
            }, _this168.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: _this168.content
          }]
        });
        return _this168;
      }

      _createClass(sf, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(sf.prototype), "render", this).call(this), this.focusTracker.add(this.element);
        }
      }, {
        key: "showView",
        value: function showView(t) {
          this.hideView(), this.content.add(t);
        }
      }, {
        key: "hideView",
        value: function hideView() {
          this.content.clear();
        }
      }, {
        key: "_createButtonView",
        value: function _createButtonView(t, e) {
          var n = new Hd(this.locale);
          return n.set({
            label: t,
            icon: e,
            tooltip: !0
          }), n;
        }
      }]);

      return sf;
    }(Rl);

    var af =
    /*#__PURE__*/
    function (_Rl15) {
      _inherits(af, _Rl15);

      function af(t, e) {
        var _this169;

        _classCallCheck(this, af);

        _this169 = _possibleConstructorReturn(this, _getPrototypeOf(af).call(this, t));
        var n = _this169.bindTemplate;
        _this169.set("top", 0), _this169.set("left", 0), _this169.set("height", 0), _this169.set("width", 0), _this169.set("numberOfPanels", 0), _this169.content = _this169.createCollection(), _this169._balloonPanelView = e, _this169.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", n.to("numberOfPanels", function (t) {
              return t ? "" : "ck-hidden";
            })],
            style: {
              top: n.to("top", of),
              left: n.to("left", of),
              width: n.to("width", of),
              height: n.to("height", of)
            }
          },
          children: _this169.content
        }), _this169.on("change:numberOfPanels", function (t, e, n, i) {
          n > i ? _this169._addPanels(n - i) : _this169._removePanels(i - n), _this169.updatePosition();
        });
        return _this169;
      }

      _createClass(af, [{
        key: "_addPanels",
        value: function _addPanels(t) {
          for (; t--;) {
            var _t241 = new Rl();

            _t241.setTemplate({
              tag: "div"
            }), this.content.add(_t241), this.registerChild(_t241);
          }
        }
      }, {
        key: "_removePanels",
        value: function _removePanels(t) {
          for (; t--;) {
            var _t242 = this.content.last;
            this.content.remove(_t242), this.deregisterChild(_t242), _t242.destroy();
          }
        }
      }, {
        key: "updatePosition",
        value: function updatePosition() {
          if (this.numberOfPanels) {
            var _this$_balloonPanelVi = this._balloonPanelView,
                _t243 = _this$_balloonPanelVi.top,
                _e213 = _this$_balloonPanelVi.left,
                _ref95 = new Cs(this._balloonPanelView.element),
                _n203 = _ref95.width,
                _i168 = _ref95.height;

            Object.assign(this, {
              top: _t243,
              left: _e213,
              width: _n203,
              height: _i168
            });
          }
        }
      }]);

      return af;
    }(Rl);

    var cf = n(32),
        lf = n.n(cf);

    function df(t) {
      var e = t.editing.view,
          n = Qh.defaultPositions;
      return {
        target: e.domConverter.viewToDom(e.document.selection.getSelectedElement()),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast]
      };
    }

    var uf =
    /*#__PURE__*/
    function (_Ql37) {
      _inherits(uf, _Ql37);

      function uf() {
        _classCallCheck(this, uf);

        return _possibleConstructorReturn(this, _getPrototypeOf(uf).apply(this, arguments));
      }

      _createClass(uf, [{
        key: "init",
        value: function init() {
          this._createButton(), this._createForm();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(uf.prototype), "destroy", this).call(this), this._form.destroy();
        }
      }, {
        key: "_createButton",
        value: function _createButton() {
          var _this170 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("imageTextAlternative", function (n) {
            var i = t.commands.get("imageTextAlternative"),
                o = new Hd(n);
            return o.set({
              label: e("bj"),
              icon: lf.a,
              tooltip: !0
            }), o.bind("isEnabled").to(i, "isEnabled"), _this170.listenTo(o, "execute", function () {
              return _this170._showForm();
            }), o;
          });
        }
      }, {
        key: "_createForm",
        value: function _createForm() {
          var _this171 = this;

          var t = this.editor,
              e = t.editing.view.document;
          this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new Hh(t.locale), this._form.render(), this.listenTo(this._form, "submit", function () {
            t.execute("imageTextAlternative", {
              newValue: _this171._form.labeledInput.inputView.element.value
            }), _this171._hideForm(!0);
          }), this.listenTo(this._form, "cancel", function () {
            _this171._hideForm(!0);
          }), this._form.keystrokes.set("Esc", function (t, e) {
            _this171._hideForm(!0), e();
          }), this.listenTo(t.ui, "update", function () {
            yh(e.selection) ? _this171._isVisible && function (t) {
              var e = t.plugins.get("ContextualBalloon");

              if (yh(t.editing.view.document.selection)) {
                var _n204 = df(t);

                e.updatePosition(_n204);
              }
            }(t) : _this171._hideForm(!0);
          }), Dh({
            emitter: this._form,
            activator: function activator() {
              return _this171._isVisible;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this171._hideForm();
            }
          });
        }
      }, {
        key: "_showForm",
        value: function _showForm() {
          if (this._isVisible) return;
          var t = this.editor,
              e = t.commands.get("imageTextAlternative"),
              n = this._form.labeledInput;
          this._balloon.hasView(this._form) || this._balloon.add({
            view: this._form,
            position: df(t)
          }), n.value = n.inputView.element.value = e.value || "", this._form.labeledInput.select();
        }
      }, {
        key: "_hideForm",
        value: function _hideForm(t) {
          this._isVisible && (this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
        }
      }, {
        key: "_isVisible",
        get: function get() {
          return this._balloon.visibleView == this._form;
        }
      }], [{
        key: "requires",
        get: function get() {
          return [rf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeUI";
        }
      }]);

      return uf;
    }(Ql);

    var hf =
    /*#__PURE__*/
    function (_Ql38) {
      _inherits(hf, _Ql38);

      function hf() {
        _classCallCheck(this, hf);

        return _possibleConstructorReturn(this, _getPrototypeOf(hf).apply(this, arguments));
      }

      _createClass(hf, null, [{
        key: "requires",
        get: function get() {
          return [Rh, uf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternative";
        }
      }]);

      return hf;
    }(Ql);

    n(87);

    var ff =
    /*#__PURE__*/
    function (_Ql39) {
      _inherits(ff, _Ql39);

      function ff() {
        _classCallCheck(this, ff);

        return _possibleConstructorReturn(this, _getPrototypeOf(ff).apply(this, arguments));
      }

      _createClass(ff, null, [{
        key: "requires",
        get: function get() {
          return [Ph, Ih, hf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Image";
        }
      }]);

      return ff;
    }(Ql);

    var mf =
    /*#__PURE__*/
    function (_Rl16) {
      _inherits(mf, _Rl16);

      function mf(t) {
        var _this172;

        _classCallCheck(this, mf);

        _this172 = _possibleConstructorReturn(this, _getPrototypeOf(mf).call(this, t)), _this172.buttonView = new Hd(t), _this172._fileInputView = new pf(t), _this172._fileInputView.bind("acceptedType").to(_assertThisInitialized(_this172)), _this172._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_this172)), _this172._fileInputView.delegate("done").to(_assertThisInitialized(_this172)), _this172.setTemplate({
          tag: "span",
          attributes: {
            class: "ck-file-dialog-button"
          },
          children: [_this172.buttonView, _this172._fileInputView]
        }), _this172.buttonView.on("execute", function () {
          _this172._fileInputView.open();
        });
        return _this172;
      }

      _createClass(mf, [{
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }]);

      return mf;
    }(Rl);

    var pf =
    /*#__PURE__*/
    function (_Rl17) {
      _inherits(pf, _Rl17);

      function pf(t) {
        var _this173;

        _classCallCheck(this, pf);

        _this173 = _possibleConstructorReturn(this, _getPrototypeOf(pf).call(this, t)), _this173.set("acceptedType"), _this173.set("allowMultipleFiles", !1);
        var e = _this173.bindTemplate;

        _this173.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: e.to("acceptedType"),
            multiple: e.to("allowMultipleFiles")
          },
          on: {
            change: e.to(function () {
              _this173.element && _this173.element.files && _this173.element.files.length && _this173.fire("done", _this173.element.files), _this173.element.value = "";
            })
          }
        });

        return _this173;
      }

      _createClass(pf, [{
        key: "open",
        value: function open() {
          this.element.click();
        }
      }]);

      return pf;
    }(Rl);

    var gf = n(33),
        bf = n.n(gf);

    function wf(t) {
      return /^image\/(jpeg|png|gif|bmp)$/.test(t.type);
    }

    function _f(t) {
      return new Promise(function (e, n) {
        var i = t.getAttribute("src");
        fetch(i).then(function (t) {
          return t.blob();
        }).then(function (t) {
          var o = function (t, e) {
            return t.type ? t.type : e.match(/data:(image\/\w+);base64/) ? e.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
          }(t, i),
              r = function (t, e, n) {
            try {
              return new File([t], e, {
                type: n
              });
            } catch (t) {
              return null;
            }
          }(t, "image.".concat(o.replace("image/", "")), o);

          r ? e(r) : n();
        }).catch(n);
      });
    }

    var kf =
    /*#__PURE__*/
    function (_Ql40) {
      _inherits(kf, _Ql40);

      function kf() {
        _classCallCheck(this, kf);

        return _possibleConstructorReturn(this, _getPrototypeOf(kf).apply(this, arguments));
      }

      _createClass(kf, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("imageUpload", function (n) {
            var i = new mf(n),
                o = t.commands.get("imageUpload");
            return i.set({
              acceptedType: "image/*",
              allowMultipleFiles: !0
            }), i.buttonView.set({
              label: e("ap"),
              icon: bf.a,
              tooltip: !0
            }), i.buttonView.bind("isEnabled").to(o), i.on("done", function (e, n) {
              var i = Array.from(n).filter(wf);
              i.length && t.execute("imageUpload", {
                file: i
              });
            }), i;
          });
        }
      }]);

      return kf;
    }(Ql);

    var vf = n(34),
        yf = n.n(vf);
    n(89), n(91), n(93);

    var xf =
    /*#__PURE__*/
    function (_Ql41) {
      _inherits(xf, _Ql41);

      function xf(t) {
        var _this174;

        _classCallCheck(this, xf);

        _this174 = _possibleConstructorReturn(this, _getPrototypeOf(xf).call(this, t)), _this174.placeholder = "data:image/svg+xml;utf8," + encodeURIComponent(yf.a);
        return _this174;
      }

      _createClass(xf, [{
        key: "init",
        value: function init() {
          var _this175 = this;

          this.editor.editing.downcastDispatcher.on("attribute:uploadStatus:image", function () {
            return _this175.uploadStatusChange.apply(_this175, arguments);
          });
        }
      }, {
        key: "uploadStatusChange",
        value: function uploadStatusChange(t, e, n) {
          var i = this.editor,
              o = e.item,
              r = o.getAttribute("uploadId");
          if (!n.consumable.consume(e.item, t.name)) return;
          var s = i.plugins.get(Xd),
              a = r ? e.attributeNewValue : null,
              c = this.placeholder,
              l = i.editing.mapper.toViewElement(o),
              d = n.writer;
          if ("reading" == a) return Af(l, d), void Cf(c, l, d);

          if ("uploading" == a) {
            var _t244 = s.loaders.get(r);

            return Af(l, d), void (_t244 ? (Tf(l, d), function (t, e, n, i) {
              var o = function (t) {
                var e = t.createUIElement("div", {
                  class: "ck-progress-bar"
                });
                return t.setCustomProperty("progressBar", !0, e), e;
              }(e);

              e.insert(e.createPositionAt(t, "end"), o), n.on("change:uploadedPercent", function (t, e, n) {
                i.change(function (t) {
                  t.setStyle("width", n + "%", o);
                });
              });
            }(l, d, _t244, i.editing.view)) : Cf(c, l, d));
          }

          "complete" == a && s.loaders.get(r) && !mo.isEdge && function (t, e, n) {
            var i = e.createUIElement("div", {
              class: "ck-image-upload-complete-icon"
            });
            e.insert(e.createPositionAt(t, "end"), i), setTimeout(function () {
              n.change(function (t) {
                return t.remove(t.createRangeOn(i));
              });
            }, 3e3);
          }(l, d, i.editing.view), function (t, e) {
            Mf(t, e, "progressBar");
          }(l, d), Tf(l, d), function (t, e) {
            e.removeClass("ck-appear", t);
          }(l, d);
        }
      }]);

      return xf;
    }(Ql);

    function Af(t, e) {
      t.hasClass("ck-appear") || e.addClass("ck-appear", t);
    }

    function Cf(t, e, n) {
      e.hasClass("ck-image-upload-placeholder") || n.addClass("ck-image-upload-placeholder", e);
      var i = e.getChild(0);
      i.getAttribute("src") !== t && n.setAttribute("src", t, i), Pf(e, "placeholder") || n.insert(n.createPositionAfter(i), function (t) {
        var e = t.createUIElement("div", {
          class: "ck-upload-placeholder-loader"
        });
        return t.setCustomProperty("placeholder", !0, e), e;
      }(n));
    }

    function Tf(t, e) {
      t.hasClass("ck-image-upload-placeholder") && e.removeClass("ck-image-upload-placeholder", t), Mf(t, e, "placeholder");
    }

    function Pf(t, e) {
      var _iteratorNormalCompletion278 = true;
      var _didIteratorError278 = false;
      var _iteratorError278 = undefined;

      try {
        for (var _iterator278 = t.getChildren()[Symbol.iterator](), _step278; !(_iteratorNormalCompletion278 = (_step278 = _iterator278.next()).done); _iteratorNormalCompletion278 = true) {
          var _n205 = _step278.value;
          if (_n205.getCustomProperty(e)) return _n205;
        }
      } catch (err) {
        _didIteratorError278 = true;
        _iteratorError278 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion278 && _iterator278.return != null) {
            _iterator278.return();
          }
        } finally {
          if (_didIteratorError278) {
            throw _iteratorError278;
          }
        }
      }
    }

    function Mf(t, e, n) {
      var i = Pf(t, n);
      i && e.remove(e.createRangeOn(i));
    }

    var Sf =
    /*#__PURE__*/
    function () {
      function Sf() {
        _classCallCheck(this, Sf);
      }

      _createClass(Sf, [{
        key: "createDocumentFragment",
        value: function createDocumentFragment(t) {
          return new Ao(t);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e, n) {
          return new _i(t, e, n);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new fi(t);
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t._clone(e);
        }
      }, {
        key: "appendChild",
        value: function appendChild(t, e) {
          return e._appendChild(t);
        }
      }, {
        key: "insertChild",
        value: function insertChild(t, e, n) {
          return n._insertChild(t, e);
        }
      }, {
        key: "removeChildren",
        value: function removeChildren(t, e, n) {
          return n._removeChildren(t, e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t.parent;
          return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
        }
      }, {
        key: "replace",
        value: function replace(t, e) {
          var n = t.parent;

          if (n) {
            var _i169 = n.getChildIndex(t);

            return this.removeChildren(_i169, 1, n), this.insertChild(_i169, e, n), !0;
          }

          return !1;
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new _i(t, e.getAttributes(), e.getChildren());
          return this.replace(e, n) ? n : null;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          C(t) && void 0 === n && (n = e), n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Zi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Zi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Zi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Xi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Xi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Xi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new no(t, e, n);
        }
      }]);

      return Sf;
    }();

    var Ef =
    /*#__PURE__*/
    function (_td11) {
      _inherits(Ef, _td11);

      function Ef() {
        _classCallCheck(this, Ef);

        return _possibleConstructorReturn(this, _getPrototypeOf(Ef).apply(this, arguments));
      }

      _createClass(Ef, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = Ch(this.editor.model);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor,
              n = e.model,
              i = e.plugins.get(Xd);
          n.change(function (e) {
            var o = Array.isArray(t.file) ? t.file : [t.file];
            var _iteratorNormalCompletion279 = true;
            var _didIteratorError279 = false;
            var _iteratorError279 = undefined;

            try {
              for (var _iterator279 = o[Symbol.iterator](), _step279; !(_iteratorNormalCompletion279 = (_step279 = _iterator279.next()).done); _iteratorNormalCompletion279 = true) {
                var _t245 = _step279.value;
                If(e, n, i, _t245);
              }
            } catch (err) {
              _didIteratorError279 = true;
              _iteratorError279 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion279 && _iterator279.return != null) {
                  _iterator279.return();
                }
              } finally {
                if (_didIteratorError279) {
                  throw _iteratorError279;
                }
              }
            }
          });
        }
      }]);

      return Ef;
    }(td);

    function If(t, e, n, i) {
      var o = n.createLoader(i);
      o && Ah(t, e, {
        uploadId: o.id
      });
    }

    var Nf =
    /*#__PURE__*/
    function (_Ql42) {
      _inherits(Nf, _Ql42);

      function Nf() {
        _classCallCheck(this, Nf);

        return _possibleConstructorReturn(this, _getPrototypeOf(Nf).apply(this, arguments));
      }

      _createClass(Nf, [{
        key: "init",
        value: function init() {
          var _this176 = this;

          var t = this.editor,
              e = t.model.document,
              n = t.model.schema,
              i = t.conversion,
              o = t.plugins.get(Xd);
          n.extend("image", {
            allowAttributes: ["uploadId", "uploadStatus"]
          }), t.commands.add("imageUpload", new Ef(t)), i.for("upcast").attributeToAttribute({
            view: {
              name: "img",
              key: "uploadId"
            },
            model: "uploadId"
          }), this.listenTo(t.editing.view.document, "clipboardInput", function (e, n) {
            if (function (t) {
              return Array.from(t.types).includes("text/html") && "" !== t.getData("text/html");
            }(n.dataTransfer)) return;
            var i = Array.from(n.dataTransfer.files).filter(function (t) {
              return !!t && wf(t);
            }),
                o = n.targetRanges.map(function (e) {
              return t.editing.mapper.toModelRange(e);
            });
            t.model.change(function (n) {
              n.setSelection(o), i.length && (e.stop(), t.model.enqueueChange("default", function () {
                t.execute("imageUpload", {
                  file: i
                });
              }));
            });
          }), t.plugins.has("Clipboard") && this.listenTo(t.plugins.get("Clipboard"), "inputTransformation", function (e, n) {
            var i = Array.from(t.editing.view.createRangeIn(n.content)).filter(function (t) {
              return function (t) {
                return !(!t.is("element", "img") || !t.getAttribute("src")) && (t.getAttribute("src").match(/^data:image\/\w+;base64,/g) || t.getAttribute("src").match(/^blob:/g));
              }(t.item) && !t.item.getAttribute("uploadProcessed");
            }).map(function (t) {
              return {
                promise: _f(t.item),
                imageElement: t.item
              };
            });
            if (!i.length) return;
            var r = new Sf();
            var _iteratorNormalCompletion280 = true;
            var _didIteratorError280 = false;
            var _iteratorError280 = undefined;

            try {
              for (var _iterator280 = i[Symbol.iterator](), _step280; !(_iteratorNormalCompletion280 = (_step280 = _iterator280.next()).done); _iteratorNormalCompletion280 = true) {
                var _t246 = _step280.value;
                r.setAttribute("uploadProcessed", !0, _t246.imageElement);

                var _e214 = o.createLoader(_t246.promise);

                _e214 && (r.setAttribute("src", "", _t246.imageElement), r.setAttribute("uploadId", _e214.id, _t246.imageElement));
              }
            } catch (err) {
              _didIteratorError280 = true;
              _iteratorError280 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion280 && _iterator280.return != null) {
                  _iterator280.return();
                }
              } finally {
                if (_didIteratorError280) {
                  throw _iteratorError280;
                }
              }
            }
          }), t.editing.view.document.on("dragover", function (t, e) {
            e.preventDefault();
          }), e.on("change", function () {
            var t = e.differ.getChanges({
              includeChangesInGraveyard: !0
            });
            var _iteratorNormalCompletion281 = true;
            var _didIteratorError281 = false;
            var _iteratorError281 = undefined;

            try {
              for (var _iterator281 = t[Symbol.iterator](), _step281; !(_iteratorNormalCompletion281 = (_step281 = _iterator281.next()).done); _iteratorNormalCompletion281 = true) {
                var _e215 = _step281.value;

                if ("insert" == _e215.type && "image" == _e215.name) {
                  var _t247 = _e215.position.nodeAfter,
                      _n206 = "$graveyard" == _e215.position.root.rootName,
                      _i170 = _t247.getAttribute("uploadId");

                  if (!_i170) continue;

                  var _r38 = o.loaders.get(_i170);

                  if (!_r38) continue;
                  _n206 ? _r38.abort() : "idle" == _r38.status && _this176._readAndUpload(_r38, _t247);
                }
              }
            } catch (err) {
              _didIteratorError281 = true;
              _iteratorError281 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion281 && _iterator281.return != null) {
                  _iterator281.return();
                }
              } finally {
                if (_didIteratorError281) {
                  throw _iteratorError281;
                }
              }
            }
          });
        }
      }, {
        key: "_readAndUpload",
        value: function _readAndUpload(t, e) {
          var _this177 = this;

          var n = this.editor,
              i = n.model,
              o = n.locale.t,
              r = n.plugins.get(Xd),
              s = n.plugins.get($u);
          return i.enqueueChange("transparent", function (t) {
            t.setAttribute("uploadStatus", "reading", e);
          }), t.read().then(function (o) {
            var r = n.editing.mapper.toViewElement(e).getChild(0),
                s = t.upload();
            return n.editing.view.change(function (t) {
              t.setAttribute("src", o, r);
            }), i.enqueueChange("transparent", function (t) {
              t.setAttribute("uploadStatus", "uploading", e);
            }), s;
          }).then(function (t) {
            i.enqueueChange("transparent", function (n) {
              n.setAttributes({
                uploadStatus: "complete",
                src: t.default
              }, e), _this177._parseAndSetSrcsetAttributeOnImage(t, e, n);
            }), a();
          }).catch(function (n) {
            if ("error" !== t.status && "aborted" !== t.status) throw n;
            "error" == t.status && n && s.showWarning(n, {
              title: o("av"),
              namespace: "upload"
            }), a(), i.enqueueChange("transparent", function (t) {
              t.remove(e);
            });
          });

          function a() {
            i.enqueueChange("transparent", function (t) {
              t.removeAttribute("uploadId", e), t.removeAttribute("uploadStatus", e);
            }), r.destroyLoader(t);
          }
        }
      }, {
        key: "_parseAndSetSrcsetAttributeOnImage",
        value: function _parseAndSetSrcsetAttributeOnImage(t, e, n) {
          var i = 0;
          var o = Object.keys(t).filter(function (t) {
            var e = parseInt(t, 10);
            if (!isNaN(e)) return i = Math.max(i, e), !0;
          }).map(function (e) {
            return "".concat(t[e], " ").concat(e, "w");
          }).join(", ");
          "" != o && n.setAttribute("srcset", {
            data: o,
            width: i
          }, e);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Xd, $u];
        }
      }]);

      return Nf;
    }(Ql);

    var Of =
    /*#__PURE__*/
    function (_Ql43) {
      _inherits(Of, _Ql43);

      function Of() {
        _classCallCheck(this, Of);

        return _possibleConstructorReturn(this, _getPrototypeOf(Of).apply(this, arguments));
      }

      _createClass(Of, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageUpload";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Nf, kf, xf];
        }
      }]);

      return Of;
    }(Ql);

    var Rf =
    /*#__PURE__*/
    function (_Ql44) {
      _inherits(Rf, _Ql44);

      function Rf() {
        _classCallCheck(this, Rf);

        return _possibleConstructorReturn(this, _getPrototypeOf(Rf).apply(this, arguments));
      }

      _createClass(Rf, null, [{
        key: "requires",
        get: function get() {
          return [oh, ff, Of];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "EasyImage";
        }
      }]);

      return Rf;
    }(Ql);

    var Df =
    /*#__PURE__*/
    function (_td12) {
      _inherits(Df, _td12);

      function Df() {
        _classCallCheck(this, Df);

        return _possibleConstructorReturn(this, _getPrototypeOf(Df).apply(this, arguments));
      }

      _createClass(Df, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = Ru(t.document.selection.getSelectedBlocks());
          this.value = !!e && e.is("paragraph"), this.isEnabled = !!e && Lf(e, t.schema);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document;
          e.change(function (i) {
            var o = (t.selection || n.selection).getSelectedBlocks();
            var _iteratorNormalCompletion282 = true;
            var _didIteratorError282 = false;
            var _iteratorError282 = undefined;

            try {
              for (var _iterator282 = o[Symbol.iterator](), _step282; !(_iteratorNormalCompletion282 = (_step282 = _iterator282.next()).done); _iteratorNormalCompletion282 = true) {
                var _t248 = _step282.value;
                !_t248.is("paragraph") && Lf(_t248, e.schema) && i.rename(_t248, "paragraph");
              }
            } catch (err) {
              _didIteratorError282 = true;
              _iteratorError282 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion282 && _iterator282.return != null) {
                  _iterator282.return();
                }
              } finally {
                if (_didIteratorError282) {
                  throw _iteratorError282;
                }
              }
            }
          });
        }
      }]);

      return Df;
    }(td);

    function Lf(t, e) {
      return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
    }

    var jf =
    /*#__PURE__*/
    function (_Ql45) {
      _inherits(jf, _Ql45);

      function jf() {
        _classCallCheck(this, jf);

        return _possibleConstructorReturn(this, _getPrototypeOf(jf).apply(this, arguments));
      }

      _createClass(jf, [{
        key: "init",
        value: function init() {
          var _this178 = this;

          var t = this.editor,
              e = t.model,
              n = t.data;
          t.commands.add("paragraph", new Df(t)), e.schema.register("paragraph", {
            inheritAllFrom: "$block"
          }), t.conversion.elementToElement({
            model: "paragraph",
            view: "p"
          }), t.conversion.for("upcast").elementToElement({
            model: function model(t, e) {
              return jf.paragraphLikeElements.has(t.name) ? t.isEmpty ? null : e.createElement("paragraph") : null;
            },
            converterPriority: "low"
          }), n.upcastDispatcher.on("element", function (t, e, n) {
            n.consumable.test(e.viewItem, {
              name: e.viewItem.name
            }) && Bf(e.viewItem, e.modelCursor, n.schema) && Object.assign(e, Vf(e.viewItem, e.modelCursor, n));
          }, {
            priority: "low"
          }), n.upcastDispatcher.on("text", function (t, e, n) {
            e.modelRange || Bf(e.viewItem, e.modelCursor, n.schema) && Object.assign(e, Vf(e.viewItem, e.modelCursor, n));
          }, {
            priority: "lowest"
          }), e.document.registerPostFixer(function (t) {
            return _this178._autoparagraphEmptyRoots(t);
          }), t.data.on("ready", function () {
            e.enqueueChange("transparent", function (t) {
              return _this178._autoparagraphEmptyRoots(t);
            });
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "_autoparagraphEmptyRoots",
        value: function _autoparagraphEmptyRoots(t) {
          var e = this.editor.model;
          var _iteratorNormalCompletion283 = true;
          var _didIteratorError283 = false;
          var _iteratorError283 = undefined;

          try {
            for (var _iterator283 = e.document.getRootNames()[Symbol.iterator](), _step283; !(_iteratorNormalCompletion283 = (_step283 = _iterator283.next()).done); _iteratorNormalCompletion283 = true) {
              var _n207 = _step283.value;

              var _i171 = e.document.getRoot(_n207);

              if (_i171.isEmpty && "$graveyard" != _i171.rootName && e.schema.checkChild(_i171, "paragraph")) return t.insertElement("paragraph", _i171), !0;
            }
          } catch (err) {
            _didIteratorError283 = true;
            _iteratorError283 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion283 && _iterator283.return != null) {
                _iterator283.return();
              }
            } finally {
              if (_didIteratorError283) {
                throw _iteratorError283;
              }
            }
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Paragraph";
        }
      }]);

      return jf;
    }(Ql);

    function Vf(t, e, n) {
      var i = n.writer.createElement("paragraph");
      return n.writer.insert(i, e), n.convertItem(t, n.writer.createPositionAt(i, 0));
    }

    function Bf(t, e, n) {
      var i = n.createContext(e);
      return !!n.checkChild(i, "paragraph") && !!n.checkChild(i.push("paragraph"), t);
    }

    jf.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td"]);

    var zf =
    /*#__PURE__*/
    function (_td13) {
      _inherits(zf, _td13);

      function zf(t, e) {
        var _this179;

        _classCallCheck(this, zf);

        _this179 = _possibleConstructorReturn(this, _getPrototypeOf(zf).call(this, t)), _this179.modelElements = e;
        return _this179;
      }

      _createClass(zf, [{
        key: "refresh",
        value: function refresh() {
          var _this180 = this;

          var t = Ru(this.editor.model.document.selection.getSelectedBlocks());
          this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some(function (e) {
            return Ff(t, e, _this180.editor.model.schema);
          });
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document,
              i = t.value;
          e.change(function (t) {
            var o = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
              return Ff(t, i, e.schema);
            });
            var _iteratorNormalCompletion284 = true;
            var _didIteratorError284 = false;
            var _iteratorError284 = undefined;

            try {
              for (var _iterator284 = o[Symbol.iterator](), _step284; !(_iteratorNormalCompletion284 = (_step284 = _iterator284.next()).done); _iteratorNormalCompletion284 = true) {
                var _e216 = _step284.value;
                _e216.is(i) || t.rename(_e216, i);
              }
            } catch (err) {
              _didIteratorError284 = true;
              _iteratorError284 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion284 && _iterator284.return != null) {
                  _iterator284.return();
                }
              } finally {
                if (_didIteratorError284) {
                  throw _iteratorError284;
                }
              }
            }
          });
        }
      }]);

      return zf;
    }(td);

    function Ff(t, e, n) {
      return n.checkChild(t.parent, e) && !n.isObject(t);
    }

    var Uf = "paragraph";

    var Hf =
    /*#__PURE__*/
    function (_Ql46) {
      _inherits(Hf, _Ql46);

      function Hf(t) {
        var _this181;

        _classCallCheck(this, Hf);

        _this181 = _possibleConstructorReturn(this, _getPrototypeOf(Hf).call(this, t)), t.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
        return _this181;
      }

      _createClass(Hf, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.config.get("heading.options"),
              n = [];
          var _iteratorNormalCompletion285 = true;
          var _didIteratorError285 = false;
          var _iteratorError285 = undefined;

          try {
            for (var _iterator285 = e[Symbol.iterator](), _step285; !(_iteratorNormalCompletion285 = (_step285 = _iterator285.next()).done); _iteratorNormalCompletion285 = true) {
              var _i172 = _step285.value;
              _i172.model !== Uf && (t.model.schema.register(_i172.model, {
                inheritAllFrom: "$block"
              }), t.conversion.elementToElement(_i172), n.push(_i172.model));
            }
          } catch (err) {
            _didIteratorError285 = true;
            _iteratorError285 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion285 && _iterator285.return != null) {
                _iterator285.return();
              }
            } finally {
              if (_didIteratorError285) {
                throw _iteratorError285;
              }
            }
          }

          this._addDefaultH1Conversion(t), t.commands.add("heading", new zf(t, n));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
              e = t.commands.get("enter"),
              n = t.config.get("heading.options");
          e && this.listenTo(e, "afterExecute", function (e, i) {
            var o = t.model.document.selection.getFirstPosition().parent;
            n.some(function (t) {
              return o.is(t.model);
            }) && !o.is(Uf) && 0 === o.childCount && i.writer.rename(o, Uf);
          });
        }
      }, {
        key: "_addDefaultH1Conversion",
        value: function _addDefaultH1Conversion(t) {
          t.conversion.for("upcast").elementToElement({
            model: "heading1",
            view: "h1",
            converterPriority: Zn.get("low") + 1
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [jf];
        }
      }]);

      return Hf;
    }(Ql);

    var qf = function qf(t, e) {
      _classCallCheck(this, qf);

      e && Li(this, e), t && this.set(t);
    };

    ci(qf, Fi);

    var Wf =
    /*#__PURE__*/
    function (_Rl18) {
      _inherits(Wf, _Rl18);

      function Wf(t) {
        var _this182;

        _classCallCheck(this, Wf);

        _this182 = _possibleConstructorReturn(this, _getPrototypeOf(Wf).call(this, t));
        var e = _this182.bindTemplate;
        _this182.set("isVisible", !1), _this182.set("position", "se"), _this182.children = _this182.createCollection(), _this182.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", function (t) {
              return "ck-dropdown__panel_".concat(t);
            }), e.if("isVisible", "ck-dropdown__panel-visible")]
          },
          children: _this182.children,
          on: {
            selectstart: e.to(function (t) {
              return t.preventDefault();
            })
          }
        });
        return _this182;
      }

      _createClass(Wf, [{
        key: "focus",
        value: function focus() {
          this.children.length && this.children.first.focus();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          if (this.children.length) {
            var _t249 = this.children.last;
            "function" == typeof _t249.focusLast ? _t249.focusLast() : _t249.focus();
          }
        }
      }]);

      return Wf;
    }(Rl);

    n(95);

    var Yf =
    /*#__PURE__*/
    function (_Rl19) {
      _inherits(Yf, _Rl19);

      function Yf(t, e, n) {
        var _this183;

        _classCallCheck(this, Yf);

        _this183 = _possibleConstructorReturn(this, _getPrototypeOf(Yf).call(this, t));
        var i = _this183.bindTemplate;
        _this183.buttonView = e, _this183.panelView = n, _this183.set("isOpen", !1), _this183.set("isEnabled", !0), _this183.set("class"), _this183.set("panelPosition", "auto"), _this183.focusTracker = new rl(), _this183.keystrokes = new Jc(), _this183.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", i.to("class"), i.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            })]
          },
          children: [e, n]
        }), e.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"]
          }
        });
        return _this183;
      }

      _createClass(Yf, [{
        key: "render",
        value: function render() {
          var _this184 = this;

          _get(_getPrototypeOf(Yf.prototype), "render", this).call(this), this.listenTo(this.buttonView, "open", function () {
            _this184.isOpen = !_this184.isOpen;
          }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", function () {
            if (_this184.isOpen) if ("auto" === _this184.panelPosition) {
              var _t250 = Yf.defaultPanelPositions;
              _this184.panelView.position = qh({
                element: _this184.panelView.element,
                target: _this184.buttonView.element,
                fitInViewport: !0,
                positions: [_t250.southEast, _t250.southWest, _t250.northEast, _t250.northWest]
              }).name;
            } else _this184.panelView.position = _this184.panelPosition;
          }), this.keystrokes.listenTo(this.element), this.focusTracker.add(this.element);

          var t = function t(_t251, e) {
            _this184.isOpen && (_this184.buttonView.focus(), _this184.isOpen = !1, e());
          };

          this.keystrokes.set("arrowdown", function (t, e) {
            _this184.buttonView.isEnabled && !_this184.isOpen && (_this184.isOpen = !0, e());
          }), this.keystrokes.set("arrowright", function (t, e) {
            _this184.isOpen && e();
          }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }]);

      return Yf;
    }(Rl);

    Yf.defaultPanelPositions = {
      southEast: function southEast(t) {
        return {
          top: t.bottom,
          left: t.left,
          name: "se"
        };
      },
      southWest: function southWest(t, e) {
        return {
          top: t.bottom,
          left: t.left - e.width + t.width,
          name: "sw"
        };
      },
      northEast: function northEast(t, e) {
        return {
          top: t.top - e.height,
          left: t.left,
          name: "ne"
        };
      },
      northWest: function northWest(t, e) {
        return {
          top: t.bottom - e.height,
          left: t.left - e.width + t.width,
          name: "nw"
        };
      }
    };
    var $f = n(35),
        Gf = n.n($f);

    var Qf =
    /*#__PURE__*/
    function (_Hd) {
      _inherits(Qf, _Hd);

      function Qf(t) {
        var _this185;

        _classCallCheck(this, Qf);

        _this185 = _possibleConstructorReturn(this, _getPrototypeOf(Qf).call(this, t)), _this185.arrowView = _this185._createArrowView(), _this185.extendTemplate({
          attributes: {
            "aria-haspopup": !0
          }
        }), _this185.delegate("execute").to(_assertThisInitialized(_this185), "open");
        return _this185;
      }

      _createClass(Qf, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Qf.prototype), "render", this).call(this), this.children.add(this.arrowView);
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var t = new Fd();
          return t.content = Gf.a, t.extendTemplate({
            attributes: {
              class: "ck-dropdown__arrow"
            }
          }), t;
        }
      }]);

      return Qf;
    }(Hd);

    n(97);

    var Jf =
    /*#__PURE__*/
    function (_Rl20) {
      _inherits(Jf, _Rl20);

      function Jf() {
        var _this186;

        _classCallCheck(this, Jf);

        _this186 = _possibleConstructorReturn(this, _getPrototypeOf(Jf).call(this)), _this186.items = _this186.createCollection(), _this186.focusTracker = new rl(), _this186.keystrokes = new Jc(), _this186._focusCycler = new Hl({
          focusables: _this186.items,
          focusTracker: _this186.focusTracker,
          keystrokeHandler: _this186.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), _this186.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"]
          },
          children: _this186.items
        });
        return _this186;
      }

      _createClass(Jf, [{
        key: "render",
        value: function render() {
          var _this187 = this;

          _get(_getPrototypeOf(Jf.prototype), "render", this).call(this);

          var _iteratorNormalCompletion286 = true;
          var _didIteratorError286 = false;
          var _iteratorError286 = undefined;

          try {
            for (var _iterator286 = this.items[Symbol.iterator](), _step286; !(_iteratorNormalCompletion286 = (_step286 = _iterator286.next()).done); _iteratorNormalCompletion286 = true) {
              var _t252 = _step286.value;
              this.focusTracker.add(_t252.element);
            }
          } catch (err) {
            _didIteratorError286 = true;
            _iteratorError286 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion286 && _iterator286.return != null) {
                _iterator286.return();
              }
            } finally {
              if (_didIteratorError286) {
                throw _iteratorError286;
              }
            }
          }

          this.items.on("add", function (t, e) {
            _this187.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this187.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }]);

      return Jf;
    }(Rl);

    var Kf =
    /*#__PURE__*/
    function (_Rl21) {
      _inherits(Kf, _Rl21);

      function Kf(t) {
        var _this188;

        _classCallCheck(this, Kf);

        _this188 = _possibleConstructorReturn(this, _getPrototypeOf(Kf).call(this, t)), _this188.children = _this188.createCollection(), _this188.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item"]
          },
          children: _this188.children
        });
        return _this188;
      }

      _createClass(Kf, [{
        key: "focus",
        value: function focus() {
          this.children.first.focus();
        }
      }]);

      return Kf;
    }(Rl);

    var Zf =
    /*#__PURE__*/
    function (_Rl22) {
      _inherits(Zf, _Rl22);

      function Zf(t) {
        var _this189;

        _classCallCheck(this, Zf);

        _this189 = _possibleConstructorReturn(this, _getPrototypeOf(Zf).call(this, t)), _this189.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
        return _this189;
      }

      return Zf;
    }(Rl);

    n(99);

    var Xf =
    /*#__PURE__*/
    function (_Hd2) {
      _inherits(Xf, _Hd2);

      function Xf(t) {
        var _this190;

        _classCallCheck(this, Xf);

        _this190 = _possibleConstructorReturn(this, _getPrototypeOf(Xf).call(this, t)), _this190.toggleSwitchView = _this190._createToggleView(), _this190.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
        return _this190;
      }

      _createClass(Xf, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Xf.prototype), "render", this).call(this), this.children.add(this.toggleSwitchView);
        }
      }, {
        key: "_createToggleView",
        value: function _createToggleView() {
          var t = new Rl();
          return t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle"]
            },
            children: [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__toggle__inner"]
              }
            }]
          }), t;
        }
      }]);

      return Xf;
    }(Hd);

    n(101), n(103);

    function tm(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Qf;
      var n = new e(t),
          i = new Wf(t),
          o = new Yf(t, n, i);
      return n.bind("isEnabled").to(o), n instanceof Qf ? n.bind("isOn").to(o, "isOpen") : n.arrowView.bind("isOn").to(o, "isOpen"), function (t) {
        (function (t) {
          t.on("render", function () {
            Dh({
              emitter: t,
              activator: function activator() {
                return t.isOpen;
              },
              callback: function callback() {
                t.isOpen = !1;
              },
              contextElements: [t.element]
            });
          });
        })(t), function (t) {
          t.on("execute", function (e) {
            e.source instanceof Xf || (t.isOpen = !1);
          });
        }(t), function (t) {
          t.keystrokes.set("arrowdown", function (e, n) {
            t.isOpen && (t.panelView.focus(), n());
          }), t.keystrokes.set("arrowup", function (e, n) {
            t.isOpen && (t.panelView.focusLast(), n());
          });
        }(t);
      }(o), o;
    }

    function em(t, e) {
      var n = t.locale,
          i = t.listView = new Jf(n);
      i.items.bindTo(e).using(function (_ref96) {
        var t = _ref96.type,
            e = _ref96.model;
        if ("separator" === t) return new Zf(n);

        if ("button" === t || "switchbutton" === t) {
          var _o80;

          var _i173 = new Kf(n);

          var _o79;

          return (_o80 = _o79 = "button" === t ? new Hd(n) : new Xf(n)).bind.apply(_o80, _toConsumableArray(Object.keys(e))).to(e), _o79.delegate("execute").to(_i173), _i173.children.add(_o79), _i173;
        }
      }), t.panelView.children.add(i), i.items.delegate("execute").to(t);
    }

    n(18);

    var nm =
    /*#__PURE__*/
    function (_Ql47) {
      _inherits(nm, _Ql47);

      function nm() {
        _classCallCheck(this, nm);

        return _possibleConstructorReturn(this, _getPrototypeOf(nm).apply(this, arguments));
      }

      _createClass(nm, [{
        key: "init",
        value: function init() {
          var _this191 = this;

          var t = this.editor,
              e = t.t,
              n = function (t) {
            var e = t.t,
                n = {
              Paragraph: e("bc"),
              "Heading 1": e("bd"),
              "Heading 2": e("be"),
              "Heading 3": e("bf"),
              "Heading 4": e("bg"),
              "Heading 5": e("bh"),
              "Heading 6": e("bi")
            };
            return t.config.get("heading.options").map(function (t) {
              var e = n[t.title];
              return e && e != t.title && (t.title = e), t;
            });
          }(t),
              i = e("h"),
              o = e("i");

          t.ui.componentFactory.add("heading", function (e) {
            var r = {},
                s = new oo(),
                a = t.commands.get("heading"),
                c = t.commands.get("paragraph"),
                l = [a];
            var _iteratorNormalCompletion287 = true;
            var _didIteratorError287 = false;
            var _iteratorError287 = undefined;

            try {
              var _loop6 = function _loop6() {
                var t = _step287.value;
                var e = {
                  type: "button",
                  model: new qf({
                    label: t.title,
                    class: t.class,
                    withText: !0
                  })
                };
                "paragraph" === t.model ? (e.model.bind("isOn").to(c, "value"), e.model.set("commandName", "paragraph"), l.push(c)) : (e.model.bind("isOn").to(a, "value", function (e) {
                  return e === t.model;
                }), e.model.set({
                  commandName: "heading",
                  commandValue: t.model
                })), s.add(e), r[t.model] = t.title;
              };

              for (var _iterator287 = n[Symbol.iterator](), _step287; !(_iteratorNormalCompletion287 = (_step287 = _iterator287.next()).done); _iteratorNormalCompletion287 = true) {
                _loop6();
              }
            } catch (err) {
              _didIteratorError287 = true;
              _iteratorError287 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion287 && _iterator287.return != null) {
                  _iterator287.return();
                }
              } finally {
                if (_didIteratorError287) {
                  throw _iteratorError287;
                }
              }
            }

            var d = tm(e);
            return em(d, s), d.buttonView.set({
              isOn: !1,
              withText: !0,
              tooltip: o
            }), d.extendTemplate({
              attributes: {
                class: ["ck-heading-dropdown"]
              }
            }), d.bind("isEnabled").toMany(l, "isEnabled", function () {
              for (var _len18 = arguments.length, t = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
                t[_key18] = arguments[_key18];
              }

              return t.some(function (t) {
                return t;
              });
            }), d.buttonView.bind("label").to(a, "value", c, "value", function (t, e) {
              var n = t || e && "paragraph";
              return r[n] ? r[n] : i;
            }), _this191.listenTo(d, "execute", function (e) {
              t.execute(e.source.commandName, e.source.commandValue ? {
                value: e.source.commandValue
              } : void 0), t.editing.view.focus();
            }), d;
          });
        }
      }]);

      return nm;
    }(Ql);

    var im =
    /*#__PURE__*/
    function (_Ql48) {
      _inherits(im, _Ql48);

      function im() {
        _classCallCheck(this, im);

        return _possibleConstructorReturn(this, _getPrototypeOf(im).apply(this, arguments));
      }

      _createClass(im, null, [{
        key: "requires",
        get: function get() {
          return [Hf, nm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Heading";
        }
      }]);

      return im;
    }(Ql);

    function om(t) {
      var _iteratorNormalCompletion288 = true;
      var _didIteratorError288 = false;
      var _iteratorError288 = undefined;

      try {
        for (var _iterator288 = t.getChildren()[Symbol.iterator](), _step288; !(_iteratorNormalCompletion288 = (_step288 = _iterator288.next()).done); _iteratorNormalCompletion288 = true) {
          var _e217 = _step288.value;
          if (_e217 && _e217.is("caption")) return _e217;
        }
      } catch (err) {
        _didIteratorError288 = true;
        _iteratorError288 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion288 && _iterator288.return != null) {
            _iterator288.return();
          }
        } finally {
          if (_didIteratorError288) {
            throw _iteratorError288;
          }
        }
      }

      return null;
    }

    function rm(t) {
      var e = t.parent;
      return "figcaption" == t.name && e && "figure" == e.name && e.hasClass("image") ? {
        name: !0
      } : null;
    }

    var sm =
    /*#__PURE__*/
    function (_Ql49) {
      _inherits(sm, _Ql49);

      function sm() {
        _classCallCheck(this, sm);

        return _possibleConstructorReturn(this, _getPrototypeOf(sm).apply(this, arguments));
      }

      _createClass(sm, [{
        key: "init",
        value: function init() {
          var _this192 = this;

          var t = this.editor,
              e = t.editing.view,
              n = t.model.schema,
              i = t.data,
              o = t.editing,
              r = t.t;
          n.register("caption", {
            allowIn: "image",
            allowContentOf: "$block",
            isLimit: !0
          }), t.model.document.registerPostFixer(function (t) {
            return _this192._insertMissingModelCaptionElement(t);
          }), t.conversion.for("upcast").elementToElement({
            view: rm,
            model: "caption"
          });
          i.downcastDispatcher.on("insert:caption", am(function (t) {
            return t.createContainerElement("figcaption");
          }, !1));

          var s = function (t, e) {
            return function (n) {
              var i = n.createEditableElement("figcaption");
              return n.setCustomProperty("imageCaption", !0, i), cl({
                view: t,
                element: i,
                text: e
              }), _h(i, n);
            };
          }(e, r("au"));

          o.downcastDispatcher.on("insert:caption", am(s)), o.downcastDispatcher.on("insert", this._fixCaptionVisibility(function (t) {
            return t.item;
          }), {
            priority: "high"
          }), o.downcastDispatcher.on("remove", this._fixCaptionVisibility(function (t) {
            return t.position.parent;
          }), {
            priority: "high"
          }), e.document.registerPostFixer(function (t) {
            return _this192._updateCaptionVisibility(t);
          });
        }
      }, {
        key: "_updateCaptionVisibility",
        value: function _updateCaptionVisibility(t) {
          var e = this.editor.editing.mapper,
              n = this._lastSelectedCaption;
          var i;
          var o = this.editor.model.document.selection,
              r = o.getSelectedElement();

          if (r && r.is("image")) {
            var _t253 = om(r);

            i = e.toViewElement(_t253);
          }

          var s = cm(o.getFirstPosition().parent);
          if (s && (i = e.toViewElement(s)), i) return n ? n === i ? dm(i, t) : (lm(n, t), this._lastSelectedCaption = i, dm(i, t)) : (this._lastSelectedCaption = i, dm(i, t));

          if (n) {
            var _e218 = lm(n, t);

            return this._lastSelectedCaption = null, _e218;
          }

          return !1;
        }
      }, {
        key: "_fixCaptionVisibility",
        value: function _fixCaptionVisibility(t) {
          var _this193 = this;

          return function (e, n, i) {
            var o = cm(t(n)),
                r = _this193.editor.editing.mapper,
                s = i.writer;

            if (o) {
              var _t254 = r.toViewElement(o);

              _t254 && (o.childCount ? s.removeClass("ck-hidden", _t254) : s.addClass("ck-hidden", _t254));
            }
          };
        }
      }, {
        key: "_insertMissingModelCaptionElement",
        value: function _insertMissingModelCaptionElement(t) {
          var e = this.editor.model,
              n = e.document.differ.getChanges(),
              i = [];
          var _iteratorNormalCompletion289 = true;
          var _didIteratorError289 = false;
          var _iteratorError289 = undefined;

          try {
            for (var _iterator289 = n[Symbol.iterator](), _step289; !(_iteratorNormalCompletion289 = (_step289 = _iterator289.next()).done); _iteratorNormalCompletion289 = true) {
              var _t255 = _step289.value;

              if ("insert" == _t255.type && "$text" != _t255.name) {
                var _n208 = _t255.position.nodeAfter;

                if (_n208.is("image") && !om(_n208) && i.push(_n208), !_n208.is("image") && _n208.childCount) {
                  var _iteratorNormalCompletion290 = true;
                  var _didIteratorError290 = false;
                  var _iteratorError290 = undefined;

                  try {
                    for (var _iterator290 = e.createRangeIn(_n208).getItems()[Symbol.iterator](), _step290; !(_iteratorNormalCompletion290 = (_step290 = _iterator290.next()).done); _iteratorNormalCompletion290 = true) {
                      var _t256 = _step290.value;
                      _t256.is("image") && !om(_t256) && i.push(_t256);
                    }
                  } catch (err) {
                    _didIteratorError290 = true;
                    _iteratorError290 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion290 && _iterator290.return != null) {
                        _iterator290.return();
                      }
                    } finally {
                      if (_didIteratorError290) {
                        throw _iteratorError290;
                      }
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError289 = true;
            _iteratorError289 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion289 && _iterator289.return != null) {
                _iterator289.return();
              }
            } finally {
              if (_didIteratorError289) {
                throw _iteratorError289;
              }
            }
          }

          for (var _i175 = 0, _i174 = i; _i175 < _i174.length; _i175++) {
            var _e219 = _i174[_i175];
            t.appendElement("caption", _e219);
          }

          return !!i.length;
        }
      }]);

      return sm;
    }(Ql);

    function am(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return function (n, i, o) {
        var r = i.item;

        if ((r.childCount || e) && xh(r.parent)) {
          if (!o.consumable.consume(i.item, "insert")) return;

          var _e220 = o.mapper.toViewElement(i.range.start.parent),
              _n209 = t(o.writer),
              _s24 = o.writer;

          r.childCount || _s24.addClass("ck-hidden", _n209), function (t, e, n, i) {
            var o = i.writer.createPositionAt(n, "end");
            i.writer.insert(o, t), i.mapper.bindElements(e, t);
          }(_n209, i.item, _e220, o);
        }
      };
    }

    function cm(t) {
      var e = t.getAncestors({
        includeSelf: !0
      }).find(function (t) {
        return "caption" == t.name;
      });
      return e && e.parent && "image" == e.parent.name ? e : null;
    }

    function lm(t, e) {
      return !t.childCount && !t.hasClass("ck-hidden") && (e.addClass("ck-hidden", t), !0);
    }

    function dm(t, e) {
      return !!t.hasClass("ck-hidden") && (e.removeClass("ck-hidden", t), !0);
    }

    n(106);

    var um =
    /*#__PURE__*/
    function (_Ql50) {
      _inherits(um, _Ql50);

      function um() {
        _classCallCheck(this, um);

        return _possibleConstructorReturn(this, _getPrototypeOf(um).apply(this, arguments));
      }

      _createClass(um, null, [{
        key: "requires",
        get: function get() {
          return [sm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaption";
        }
      }]);

      return um;
    }(Ql);

    var hm =
    /*#__PURE__*/
    function (_td14) {
      _inherits(hm, _td14);

      function hm(t, e) {
        var _this194;

        _classCallCheck(this, hm);

        _this194 = _possibleConstructorReturn(this, _getPrototypeOf(hm).call(this, t)), _this194.defaultStyle = !1, _this194.styles = e.reduce(function (t, e) {
          return t[e.name] = e, e.isDefault && (_this194.defaultStyle = e.name), t;
        }, {});
        return _this194;
      }

      _createClass(hm, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          if (this.isEnabled = xh(t), t) {
            if (t.hasAttribute("imageStyle")) {
              var _e221 = t.getAttribute("imageStyle");

              this.value = !!this.styles[_e221] && _e221;
            } else this.value = this.defaultStyle;
          } else this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _this195 = this;

          var e = t.value,
              n = this.editor.model,
              i = n.document.selection.getSelectedElement();
          n.change(function (t) {
            _this195.styles[e].isDefault ? t.removeAttribute("imageStyle", i) : t.setAttribute("imageStyle", e, i);
          });
        }
      }]);

      return hm;
    }(td);

    function fm(t, e) {
      var _iteratorNormalCompletion291 = true;
      var _didIteratorError291 = false;
      var _iteratorError291 = undefined;

      try {
        for (var _iterator291 = e[Symbol.iterator](), _step291; !(_iteratorNormalCompletion291 = (_step291 = _iterator291.next()).done); _iteratorNormalCompletion291 = true) {
          var _n210 = _step291.value;
          if (_n210.name === t) return _n210;
        }
      } catch (err) {
        _didIteratorError291 = true;
        _iteratorError291 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion291 && _iterator291.return != null) {
            _iterator291.return();
          }
        } finally {
          if (_didIteratorError291) {
            throw _iteratorError291;
          }
        }
      }
    }

    var mm = n(13),
        pm = n.n(mm),
        gm = n(14),
        bm = n.n(gm),
        wm = n(15),
        _m = n.n(wm),
        km = n(11),
        vm = n.n(km);

    var ym = {
      full: {
        name: "full",
        title: "Full size image",
        icon: pm.a,
        isDefault: !0
      },
      side: {
        name: "side",
        title: "Side image",
        icon: vm.a,
        className: "image-style-side"
      },
      alignLeft: {
        name: "alignLeft",
        title: "Left aligned image",
        icon: bm.a,
        className: "image-style-align-left"
      },
      alignCenter: {
        name: "alignCenter",
        title: "Centered image",
        icon: _m.a,
        className: "image-style-align-center"
      },
      alignRight: {
        name: "alignRight",
        title: "Right aligned image",
        icon: vm.a,
        className: "image-style-align-right"
      }
    },
        xm = {
      full: pm.a,
      left: bm.a,
      right: vm.a,
      center: _m.a
    };

    function Am() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return t.map(Cm);
    }

    function Cm(t) {
      if ("string" == typeof t) {
        var _e222 = t;
        ym[_e222] ? t = Object.assign({}, ym[_e222]) : (bs.a.warn("image-style-not-found: There is no such image style of given name.", {
          name: _e222
        }), t = {
          name: _e222
        });
      } else if (ym[t.name]) {
        var _e223 = ym[t.name],
            _n211 = Object.assign({}, t);

        for (var _i176 in _e223) {
          t.hasOwnProperty(_i176) || (_n211[_i176] = _e223[_i176]);
        }

        t = _n211;
      }

      return "string" == typeof t.icon && xm[t.icon] && (t.icon = xm[t.icon]), t;
    }

    var Tm =
    /*#__PURE__*/
    function (_Ql51) {
      _inherits(Tm, _Ql51);

      function Tm() {
        _classCallCheck(this, Tm);

        return _possibleConstructorReturn(this, _getPrototypeOf(Tm).apply(this, arguments));
      }

      _createClass(Tm, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.data,
              i = t.editing;
          t.config.define("image.styles", ["full", "side"]);
          var o = Am(t.config.get("image.styles"));
          e.extend("image", {
            allowAttributes: "imageStyle"
          });

          var r = function (t) {
            return function (e, n, i) {
              if (!i.consumable.consume(n.item, e.name)) return;
              var o = fm(n.attributeNewValue, t),
                  r = fm(n.attributeOldValue, t),
                  s = i.mapper.toViewElement(n.item),
                  a = i.writer;
              r && a.removeClass(r.className, s), o && a.addClass(o.className, s);
            };
          }(o);

          i.downcastDispatcher.on("attribute:imageStyle:image", r), n.downcastDispatcher.on("attribute:imageStyle:image", r), n.upcastDispatcher.on("element:figure", function (t) {
            var e = t.filter(function (t) {
              return !t.isDefault;
            });
            return function (t, n, i) {
              if (!n.modelRange) return;
              var o = n.viewItem,
                  r = Ru(n.modelRange.getItems());

              if (i.schema.checkAttribute(r, "imageStyle")) {
                var _iteratorNormalCompletion292 = true;
                var _didIteratorError292 = false;
                var _iteratorError292 = undefined;

                try {
                  for (var _iterator292 = e[Symbol.iterator](), _step292; !(_iteratorNormalCompletion292 = (_step292 = _iterator292.next()).done); _iteratorNormalCompletion292 = true) {
                    var _t257 = _step292.value;
                    i.consumable.consume(o, {
                      classes: _t257.className
                    }) && i.writer.setAttribute("imageStyle", _t257.name, r);
                  }
                } catch (err) {
                  _didIteratorError292 = true;
                  _iteratorError292 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion292 && _iterator292.return != null) {
                      _iterator292.return();
                    }
                  } finally {
                    if (_didIteratorError292) {
                      throw _iteratorError292;
                    }
                  }
                }
              }
            };
          }(o), {
            priority: "low"
          }), t.commands.add("imageStyle", new hm(t, o));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleEditing";
        }
      }]);

      return Tm;
    }(Ql);

    n(108);

    var Pm =
    /*#__PURE__*/
    function (_Ql52) {
      _inherits(Pm, _Ql52);

      function Pm() {
        _classCallCheck(this, Pm);

        return _possibleConstructorReturn(this, _getPrototypeOf(Pm).apply(this, arguments));
      }

      _createClass(Pm, [{
        key: "init",
        value: function init() {
          var t = function (t, e) {
            var _iteratorNormalCompletion293 = true;
            var _didIteratorError293 = false;
            var _iteratorError293 = undefined;

            try {
              for (var _iterator293 = t[Symbol.iterator](), _step293; !(_iteratorNormalCompletion293 = (_step293 = _iterator293.next()).done); _iteratorNormalCompletion293 = true) {
                var _n212 = _step293.value;
                e[_n212.title] && (_n212.title = e[_n212.title]);
              }
            } catch (err) {
              _didIteratorError293 = true;
              _iteratorError293 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion293 && _iterator293.return != null) {
                  _iterator293.return();
                }
              } finally {
                if (_didIteratorError293) {
                  throw _iteratorError293;
                }
              }
            }

            return t;
          }(Am(this.editor.config.get("image.styles")), this.localizedDefaultStylesTitles);

          var _iteratorNormalCompletion294 = true;
          var _didIteratorError294 = false;
          var _iteratorError294 = undefined;

          try {
            for (var _iterator294 = t[Symbol.iterator](), _step294; !(_iteratorNormalCompletion294 = (_step294 = _iterator294.next()).done); _iteratorNormalCompletion294 = true) {
              var _e224 = _step294.value;

              this._createButton(_e224);
            }
          } catch (err) {
            _didIteratorError294 = true;
            _iteratorError294 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion294 && _iterator294.return != null) {
                _iterator294.return();
              }
            } finally {
              if (_didIteratorError294) {
                throw _iteratorError294;
              }
            }
          }
        }
      }, {
        key: "_createButton",
        value: function _createButton(t) {
          var _this196 = this;

          var e = this.editor,
              n = "imageStyle:".concat(t.name);
          e.ui.componentFactory.add(n, function (n) {
            var i = e.commands.get("imageStyle"),
                o = new Hd(n);
            return o.set({
              label: t.title,
              icon: t.icon,
              tooltip: !0
            }), o.bind("isEnabled").to(i, "isEnabled"), o.bind("isOn").to(i, "value", function (e) {
              return e === t.name;
            }), _this196.listenTo(o, "execute", function () {
              return e.execute("imageStyle", {
                value: t.name
              });
            }), o;
          });
        }
      }, {
        key: "localizedDefaultStylesTitles",
        get: function get() {
          var t = this.editor.t;
          return {
            "Full size image": t("ah"),
            "Side image": t("ai"),
            "Left aligned image": t("aj"),
            "Centered image": t("ak"),
            "Right aligned image": t("al")
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleUI";
        }
      }]);

      return Pm;
    }(Ql);

    var Mm =
    /*#__PURE__*/
    function (_Ql53) {
      _inherits(Mm, _Ql53);

      function Mm() {
        _classCallCheck(this, Mm);

        return _possibleConstructorReturn(this, _getPrototypeOf(Mm).apply(this, arguments));
      }

      _createClass(Mm, null, [{
        key: "requires",
        get: function get() {
          return [Tm, Pm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageStyle";
        }
      }]);

      return Mm;
    }(Ql);

    var Sm =
    /*#__PURE__*/
    function (_Ql54) {
      _inherits(Sm, _Ql54);

      function Sm() {
        _classCallCheck(this, Sm);

        return _possibleConstructorReturn(this, _getPrototypeOf(Sm).apply(this, arguments));
      }

      _createClass(Sm, [{
        key: "init",
        value: function init() {
          var _this197 = this;

          var t = this.editor;

          if (t.plugins.has("BalloonToolbar")) {
            var _e225 = t.plugins.get("BalloonToolbar");

            this.listenTo(_e225, "show", function (e) {
              (function (t) {
                var e = t.getSelectedElement();
                return !(!e || !gh(e));
              })(t.editing.view.document.selection) && e.stop();
            }, {
              priority: "high"
            });
          }

          this._toolbarDefinitions = new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.listenTo(t.ui, "update", function () {
            _this197._updateToolbarsVisibility();
          }), this.listenTo(t.ui.focusTracker, "change:isFocused", function () {
            _this197._updateToolbarsVisibility();
          }, {
            priority: "low"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Sm.prototype), "destroy", this).call(this);

          var _iteratorNormalCompletion295 = true;
          var _didIteratorError295 = false;
          var _iteratorError295 = undefined;

          try {
            for (var _iterator295 = this._toolbarDefinitions.values()[Symbol.iterator](), _step295; !(_iteratorNormalCompletion295 = (_step295 = _iterator295.next()).done); _iteratorNormalCompletion295 = true) {
              var _t258 = _step295.value;

              _t258.view.destroy();
            }
          } catch (err) {
            _didIteratorError295 = true;
            _iteratorError295 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion295 && _iterator295.return != null) {
                _iterator295.return();
              }
            } finally {
              if (_didIteratorError295) {
                throw _iteratorError295;
              }
            }
          }
        }
      }, {
        key: "register",
        value: function register(t, _ref97) {
          var e = _ref97.items,
              n = _ref97.getRelatedElement,
              _ref97$balloonClassNa = _ref97.balloonClassName,
              i = _ref97$balloonClassNa === void 0 ? "ck-toolbar-container" : _ref97$balloonClassNa;
          var o = this.editor,
              r = new Yl();
          if (this._toolbarDefinitions.has(t)) throw new Gn.b("widget-toolbar-duplicated: Toolbar with the given id was already added.", this, {
            toolbarId: t
          });
          r.fillFromConfig(e, o.ui.componentFactory), this._toolbarDefinitions.set(t, {
            view: r,
            getRelatedElement: n,
            balloonClassName: i
          });
        }
      }, {
        key: "_updateToolbarsVisibility",
        value: function _updateToolbarsVisibility() {
          var t = 0,
              e = null,
              n = null;
          var _iteratorNormalCompletion296 = true;
          var _didIteratorError296 = false;
          var _iteratorError296 = undefined;

          try {
            for (var _iterator296 = this._toolbarDefinitions.values()[Symbol.iterator](), _step296; !(_iteratorNormalCompletion296 = (_step296 = _iterator296.next()).done); _iteratorNormalCompletion296 = true) {
              var _i177 = _step296.value;

              var _o81 = _i177.getRelatedElement(this.editor.editing.view.document.selection);

              if (this.editor.ui.focusTracker.isFocused) {
                if (_o81) {
                  var _r39 = _o81.getAncestors().length;

                  _r39 > t && (t = _r39, e = _o81, n = _i177);
                } else this._isToolbarInBalloon(_i177) && this._hideToolbar(_i177);
              } else this._isToolbarVisible(_i177) && this._hideToolbar(_i177);
            }
          } catch (err) {
            _didIteratorError296 = true;
            _iteratorError296 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion296 && _iterator296.return != null) {
                _iterator296.return();
              }
            } finally {
              if (_didIteratorError296) {
                throw _iteratorError296;
              }
            }
          }

          n && this._showToolbar(n, e);
        }
      }, {
        key: "_hideToolbar",
        value: function _hideToolbar(t) {
          this._balloon.remove(t.view);
        }
      }, {
        key: "_showToolbar",
        value: function _showToolbar(t, e) {
          this._isToolbarVisible(t) ? function (t, e) {
            var n = t.plugins.get("ContextualBalloon"),
                i = Em(t, e);
            n.updatePosition(i);
          }(this.editor, e) : this._isToolbarInBalloon(t) || this._balloon.add({
            view: t.view,
            position: Em(this.editor, e),
            balloonClassName: t.balloonClassName
          });
        }
      }, {
        key: "_isToolbarVisible",
        value: function _isToolbarVisible(t) {
          return this._balloon.visibleView === t.view;
        }
      }, {
        key: "_isToolbarInBalloon",
        value: function _isToolbarInBalloon(t) {
          return this._balloon.hasView(t.view);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [rf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "WidgetToolbarRepository";
        }
      }]);

      return Sm;
    }(Ql);

    function Em(t, e) {
      var n = t.editing.view,
          i = Qh.defaultPositions;
      return {
        target: n.domConverter.mapViewToDom(e),
        positions: [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast]
      };
    }

    var Im =
    /*#__PURE__*/
    function (_Ql55) {
      _inherits(Im, _Ql55);

      function Im() {
        _classCallCheck(this, Im);

        return _possibleConstructorReturn(this, _getPrototypeOf(Im).apply(this, arguments));
      }

      _createClass(Im, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor;
          t.plugins.get(Sm).register("image", {
            items: t.config.get("image.toolbar") || [],
            getRelatedElement: yh
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Sm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageToolbar";
        }
      }]);

      return Im;
    }(Ql);

    function Nm(t, e, n) {
      return n.createRange(Om(t, e, !0, n), Om(t, e, !1, n));
    }

    function Om(t, e, n, i) {
      var o = t.textNode || (n ? t.nodeBefore : t.nodeAfter),
          r = null;

      for (; o && o.getAttribute("linkHref") == e;) {
        r = o, o = n ? o.previousSibling : o.nextSibling;
      }

      return r ? i.createPositionAt(r, n ? "before" : "after") : t;
    }

    var Rm =
    /*#__PURE__*/
    function (_td15) {
      _inherits(Rm, _td15);

      function Rm(t) {
        var _this198;

        _classCallCheck(this, Rm);

        _this198 = _possibleConstructorReturn(this, _getPrototypeOf(Rm).call(this, t)), _this198.manualDecorators = new oo();
        return _this198;
      }

      _createClass(Rm, [{
        key: "restoreManualDecoratorStates",
        value: function restoreManualDecoratorStates() {
          var _iteratorNormalCompletion297 = true;
          var _didIteratorError297 = false;
          var _iteratorError297 = undefined;

          try {
            for (var _iterator297 = this.manualDecorators[Symbol.iterator](), _step297; !(_iteratorNormalCompletion297 = (_step297 = _iterator297.next()).done); _iteratorNormalCompletion297 = true) {
              var _t259 = _step297.value;
              _t259.value = this._getDecoratorStateFromModel(_t259.id);
            }
          } catch (err) {
            _didIteratorError297 = true;
            _iteratorError297 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion297 && _iterator297.return != null) {
                _iterator297.return();
              }
            } finally {
              if (_didIteratorError297) {
                throw _iteratorError297;
              }
            }
          }
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;
          this.value = e.selection.getAttribute("linkHref");
          var _iteratorNormalCompletion298 = true;
          var _didIteratorError298 = false;
          var _iteratorError298 = undefined;

          try {
            for (var _iterator298 = this.manualDecorators[Symbol.iterator](), _step298; !(_iteratorNormalCompletion298 = (_step298 = _iterator298.next()).done); _iteratorNormalCompletion298 = true) {
              var _t260 = _step298.value;
              _t260.value = this._getDecoratorStateFromModel(_t260.id);
            }
          } catch (err) {
            _didIteratorError298 = true;
            _iteratorError298 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion298 && _iterator298.return != null) {
                _iterator298.return();
              }
            } finally {
              if (_didIteratorError298) {
                throw _iteratorError298;
              }
            }
          }

          this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "linkHref");
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = n.document.selection,
              o = [],
              r = [];

          for (var _t261 in e) {
            e[_t261] ? o.push(_t261) : r.push(_t261);
          }

          n.change(function (e) {
            if (i.isCollapsed) {
              var _s25 = i.getFirstPosition();

              if (i.hasAttribute("linkHref")) {
                var _a15 = Nm(_s25, i.getAttribute("linkHref"), n);

                e.setAttribute("linkHref", t, _a15), o.forEach(function (t) {
                  e.setAttribute(t, !0, _a15);
                }), r.forEach(function (t) {
                  e.removeAttribute(t, _a15);
                }), e.setSelection(_a15);
              } else if ("" !== t) {
                var _r40 = Bs(i.getAttributes());

                _r40.set("linkHref", t), o.forEach(function (t) {
                  _r40.set(t, !0);
                });

                var _a16 = e.createText(t, _r40);

                n.insertContent(_a16, _s25), e.setSelection(e.createRangeOn(_a16));
              }
            } else {
              var _s26 = n.schema.getValidRanges(i.getRanges(), "linkHref");

              var _iteratorNormalCompletion299 = true;
              var _didIteratorError299 = false;
              var _iteratorError299 = undefined;

              try {
                var _loop7 = function _loop7() {
                  var n = _step299.value;
                  e.setAttribute("linkHref", t, n), o.forEach(function (t) {
                    e.setAttribute(t, !0, n);
                  }), r.forEach(function (t) {
                    e.removeAttribute(t, n);
                  });
                };

                for (var _iterator299 = _s26[Symbol.iterator](), _step299; !(_iteratorNormalCompletion299 = (_step299 = _iterator299.next()).done); _iteratorNormalCompletion299 = true) {
                  _loop7();
                }
              } catch (err) {
                _didIteratorError299 = true;
                _iteratorError299 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion299 && _iterator299.return != null) {
                    _iterator299.return();
                  }
                } finally {
                  if (_didIteratorError299) {
                    throw _iteratorError299;
                  }
                }
              }
            }
          });
        }
      }, {
        key: "_getDecoratorStateFromModel",
        value: function _getDecoratorStateFromModel(t) {
          return this.editor.model.document.selection.getAttribute(t) || !1;
        }
      }]);

      return Rm;
    }(td);

    var Dm =
    /*#__PURE__*/
    function (_td16) {
      _inherits(Dm, _td16);

      function Dm() {
        _classCallCheck(this, Dm);

        return _possibleConstructorReturn(this, _getPrototypeOf(Dm).apply(this, arguments));
      }

      _createClass(Dm, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this.editor.model.document.selection.hasAttribute("linkHref");
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = this.editor.model,
              n = e.document.selection,
              i = t.commands.get("link");
          e.change(function (t) {
            var o = n.isCollapsed ? [Nm(n.getFirstPosition(), n.getAttribute("linkHref"), e)] : n.getRanges();
            var _iteratorNormalCompletion300 = true;
            var _didIteratorError300 = false;
            var _iteratorError300 = undefined;

            try {
              for (var _iterator300 = o[Symbol.iterator](), _step300; !(_iteratorNormalCompletion300 = (_step300 = _iterator300.next()).done); _iteratorNormalCompletion300 = true) {
                var _e226 = _step300.value;

                if (t.removeAttribute("linkHref", _e226), i) {
                  var _iteratorNormalCompletion301 = true;
                  var _didIteratorError301 = false;
                  var _iteratorError301 = undefined;

                  try {
                    for (var _iterator301 = i.manualDecorators[Symbol.iterator](), _step301; !(_iteratorNormalCompletion301 = (_step301 = _iterator301.next()).done); _iteratorNormalCompletion301 = true) {
                      var _n213 = _step301.value;
                      t.removeAttribute(_n213.id, _e226);
                    }
                  } catch (err) {
                    _didIteratorError301 = true;
                    _iteratorError301 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion301 && _iterator301.return != null) {
                        _iterator301.return();
                      }
                    } finally {
                      if (_didIteratorError301) {
                        throw _iteratorError301;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError300 = true;
              _iteratorError300 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion300 && _iterator300.return != null) {
                  _iterator300.return();
                }
              } finally {
                if (_didIteratorError300) {
                  throw _iteratorError300;
                }
              }
            }
          });
        }
      }]);

      return Dm;
    }(td);

    var Lm = function Lm(t, e, n) {
      var i = -1,
          o = t.length;
      e < 0 && (e = -e > o ? 0 : o + e), (n = n > o ? o : n) < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;

      for (var r = Array(o); ++i < o;) {
        r[i] = t[i + e];
      }

      return r;
    };

    var jm = function jm(t, e, n) {
      var i = t.length;
      return n = void 0 === n ? i : n, !e && n >= i ? t : Lm(t, e, n);
    },
        Vm = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

    var Bm = function Bm(t) {
      return Vm.test(t);
    };

    var zm = function zm(t) {
      return t.split("");
    },
        Fm = "[\\ud800-\\udfff]",
        Um = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        Hm = "\\ud83c[\\udffb-\\udfff]",
        qm = "[^\\ud800-\\udfff]",
        Wm = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        Ym = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        $m = "(?:" + Um + "|" + Hm + ")" + "?",
        Gm = "[\\ufe0e\\ufe0f]?" + $m + ("(?:\\u200d(?:" + [qm, Wm, Ym].join("|") + ")[\\ufe0e\\ufe0f]?" + $m + ")*"),
        Qm = "(?:" + [qm + Um + "?", Um, Wm, Ym, Fm].join("|") + ")",
        Jm = RegExp(Hm + "(?=" + Hm + ")|" + Qm + Gm, "g");

    var Km = function Km(t) {
      return t.match(Jm) || [];
    };

    var Zm = function Zm(t) {
      return Bm(t) ? Km(t) : zm(t);
    };

    var Xm = function Xm(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, o = Array(i); ++n < i;) {
        o[n] = e(t[n], n, t);
      }

      return o;
    },
        tp = 1 / 0,
        ep = o ? o.prototype : void 0,
        np = ep ? ep.toString : void 0;

    var ip = function t(e) {
      if ("string" == typeof e) return e;
      if (Wt(e)) return Xm(e, t) + "";
      if (os(e)) return np ? np.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -tp ? "-0" : n;
    };

    var op = function op(t) {
      return null == t ? "" : ip(t);
    };

    var rp = function (t) {
      return function (e) {
        e = op(e);
        var n = Bm(e) ? Zm(e) : void 0,
            i = n ? n[0] : e.charAt(0),
            o = n ? jm(n, 1).join("") : e.slice(1);
        return i[t]() + o;
      };
    }("toUpperCase");

    var sp = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
        ap = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;

    function cp(t, e) {
      var n = e.createAttributeElement("a", {
        href: t
      }, {
        priority: 5
      });
      return e.setCustomProperty("link", !0, n), n;
    }

    function lp(t) {
      return function (t) {
        return t.replace(sp, "").match(ap);
      }(t = String(t)) ? t : "#";
    }

    var dp =
    /*#__PURE__*/
    function () {
      function dp() {
        _classCallCheck(this, dp);

        this._definitions = new Set();
      }

      _createClass(dp, [{
        key: "add",
        value: function add(t) {
          var _this199 = this;

          Array.isArray(t) ? t.forEach(function (t) {
            return _this199._definitions.add(t);
          }) : this._definitions.add(t);
        }
      }, {
        key: "getDispatcher",
        value: function getDispatcher() {
          var _this200 = this;

          return function (t) {
            t.on("attribute:linkHref", function (t, e, n) {
              if (!n.consumable.test(e.item, "attribute:linkHref")) return;
              var i = n.writer,
                  o = i.document.selection;
              var _iteratorNormalCompletion302 = true;
              var _didIteratorError302 = false;
              var _iteratorError302 = undefined;

              try {
                for (var _iterator302 = _this200._definitions[Symbol.iterator](), _step302; !(_iteratorNormalCompletion302 = (_step302 = _iterator302.next()).done); _iteratorNormalCompletion302 = true) {
                  var _t262 = _step302.value;

                  var _r41 = i.createAttributeElement("a", _t262.attributes, {
                    priority: 5
                  });

                  i.setCustomProperty("link", !0, _r41), _t262.callback(e.attributeNewValue) ? e.item.is("selection") ? i.wrap(o.getFirstRange(), _r41) : i.wrap(n.mapper.toViewRange(e.range), _r41) : i.unwrap(n.mapper.toViewRange(e.range), _r41);
                }
              } catch (err) {
                _didIteratorError302 = true;
                _iteratorError302 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion302 && _iterator302.return != null) {
                    _iterator302.return();
                  }
                } finally {
                  if (_didIteratorError302) {
                    throw _iteratorError302;
                  }
                }
              }
            }, {
              priority: "high"
            });
          };
        }
      }, {
        key: "length",
        get: function get() {
          return this._definitions.size;
        }
      }]);

      return dp;
    }();

    var up = function up(_ref98) {
      var t = _ref98.id,
          e = _ref98.label,
          n = _ref98.attributes;

      _classCallCheck(this, up);

      this.id = t, this.set("value"), this.label = e, this.attributes = n;
    };

    ci(up, Fi);

    var hp =
    /*#__PURE__*/
    function () {
      function hp(t, e, n) {
        var _this201 = this;

        _classCallCheck(this, hp);

        this.model = t, this.attribute = n, this._modelSelection = t.document.selection, this._overrideUid = null, this._isNextGravityRestorationSkipped = !1, e.listenTo(this._modelSelection, "change:range", function (t, e) {
          _this201._isNextGravityRestorationSkipped ? _this201._isNextGravityRestorationSkipped = !1 : _this201._isGravityOverridden && (!e.directChange && fp(_this201._modelSelection.getFirstPosition(), n) || _this201._restoreGravity());
        });
      }

      _createClass(hp, [{
        key: "handleForwardMovement",
        value: function handleForwardMovement(t, e) {
          var n = this.attribute;
          if (!(this._isGravityOverridden || t.isAtStart && this._hasSelectionAttribute)) return gp(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._removeSelectionAttribute(), !0) : mp(t, n) ? (this._preventCaretMovement(e), this._overrideGravity(), !0) : pp(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._overrideGravity(), !0) : void 0;
        }
      }, {
        key: "handleBackwardMovement",
        value: function handleBackwardMovement(t, e) {
          var n = this.attribute;
          return this._isGravityOverridden ? gp(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._restoreGravity(), this._removeSelectionAttribute(), !0) : (this._preventCaretMovement(e), this._restoreGravity(), t.isAtStart && this._removeSelectionAttribute(), !0) : gp(t, n) && !this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._setSelectionAttributeFromTheNodeBefore(t), !0) : t.isAtEnd && pp(t, n) ? this._hasSelectionAttribute ? void (bp(t, n) && (this._skipNextAutomaticGravityRestoration(), this._overrideGravity())) : (this._preventCaretMovement(e), this._setSelectionAttributeFromTheNodeBefore(t), !0) : t.isAtStart ? this._hasSelectionAttribute ? (this._removeSelectionAttribute(), this._preventCaretMovement(e), !0) : void 0 : void (bp(t, n) && (this._skipNextAutomaticGravityRestoration(), this._overrideGravity()));
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          this._overrideUid = this.model.change(function (t) {
            return t.overrideSelectionGravity();
          });
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity() {
          var _this202 = this;

          this.model.change(function (t) {
            t.restoreSelectionGravity(_this202._overrideUid), _this202._overrideUid = null;
          });
        }
      }, {
        key: "_preventCaretMovement",
        value: function _preventCaretMovement(t) {
          t.preventDefault();
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute() {
          var _this203 = this;

          this.model.change(function (t) {
            t.removeSelectionAttribute(_this203.attribute);
          });
        }
      }, {
        key: "_setSelectionAttributeFromTheNodeBefore",
        value: function _setSelectionAttributeFromTheNodeBefore(t) {
          var _this204 = this;

          var e = this.attribute;
          this.model.change(function (n) {
            n.setSelectionAttribute(_this204.attribute, t.nodeBefore.getAttribute(e));
          });
        }
      }, {
        key: "_skipNextAutomaticGravityRestoration",
        value: function _skipNextAutomaticGravityRestoration() {
          this._isNextGravityRestorationSkipped = !0;
        }
      }, {
        key: "_isGravityOverridden",
        get: function get() {
          return !!this._overrideUid;
        }
      }, {
        key: "_hasSelectionAttribute",
        get: function get() {
          return this._modelSelection.hasAttribute(this.attribute);
        }
      }]);

      return hp;
    }();

    function fp(t, e) {
      return mp(t, e) || pp(t, e);
    }

    function mp(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e);
      return !!i && i.hasAttribute(e) && (!o || n.getAttribute(e) !== i.getAttribute(e));
    }

    function pp(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e),
          r = !!i && i.hasAttribute(e);
      return o && (!r || n.getAttribute(e) !== i.getAttribute(e));
    }

    function gp(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e);
      if (!!i && i.hasAttribute(e) && o) return i.getAttribute(e) !== n.getAttribute(e);
    }

    function bp(t, e) {
      return fp(t.getShiftedBy(-1), e);
    }

    n(110);
    var wp = "ck-link_selected",
        _p = "automatic",
        kp = "manual",
        vp = /^(https?:)?\/\//;

    var yp =
    /*#__PURE__*/
    function (_Ql56) {
      _inherits(yp, _Ql56);

      function yp(t) {
        var _this205;

        _classCallCheck(this, yp);

        _this205 = _possibleConstructorReturn(this, _getPrototypeOf(yp).call(this, t)), t.config.define("link", {
          addTargetToExternalLinks: !1
        });
        return _this205;
      }

      _createClass(yp, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: "linkHref"
          }), t.conversion.for("dataDowncast").attributeToElement({
            model: "linkHref",
            view: cp
          }), t.conversion.for("editingDowncast").attributeToElement({
            model: "linkHref",
            view: function view(t, e) {
              return cp(lp(t), e);
            }
          }), t.conversion.for("upcast").elementToAttribute({
            view: {
              name: "a",
              attributes: {
                href: !0
              }
            },
            model: {
              key: "linkHref",
              value: function value(t) {
                return t.getAttribute("href");
              }
            }
          }), t.commands.add("link", new Rm(t)), t.commands.add("unlink", new Dm(t));

          var e = function (t, e) {
            var n = {
              "Open in a new tab": t("bt"),
              Downloadable: t("bu")
            };
            return e.forEach(function (t) {
              return t.label && n[t.label] && (t.label = n[t.label]), t;
            }), e;
          }(t.t, function (t) {
            var e = [];

            if (t) {
              for (var _i178 = 0, _Object$entries = Object.entries(t); _i178 < _Object$entries.length; _i178++) {
                var _ref101 = _Object$entries[_i178];

                var _ref100 = _slicedToArray(_ref101, 2);

                var _n214 = _ref100[0];
                var _i179 = _ref100[1];

                var _t263 = Object.assign({}, _i179, {
                  id: "link".concat(rp(_n214))
                });

                e.push(_t263);
              }
            }

            return e;
          }(t.config.get("link.decorators")));

          this._enableAutomaticDecorators(e.filter(function (t) {
            return t.mode === _p;
          })), this._enableManualDecorators(e.filter(function (t) {
            return t.mode === kp;
          })), function (t, e, n, i) {
            var o = new hp(e, n, i),
                r = e.document.selection;
            n.listenTo(t.document, "keydown", function (t, e) {
              if (!r.isCollapsed) return;
              if (e.shiftKey || e.altKey || e.ctrlKey) return;
              var n = e.keyCode == bo.arrowright,
                  i = e.keyCode == bo.arrowleft;
              if (!n && !i) return;
              var s = r.getFirstPosition();
              var a;
              (a = n ? o.handleForwardMovement(s, e) : o.handleBackwardMovement(s, e)) && t.stop();
            }, {
              priority: Zn.get("high") + 1
            });
          }(t.editing.view, t.model, this, "linkHref"), this._setupLinkHighlight();
        }
      }, {
        key: "_enableAutomaticDecorators",
        value: function _enableAutomaticDecorators(t) {
          var e = this.editor,
              n = new dp();
          e.config.get("link.addTargetToExternalLinks") && n.add({
            id: "linkIsExternal",
            mode: _p,
            callback: function callback(t) {
              return vp.test(t);
            },
            attributes: {
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }), n.add(t), n.length && e.conversion.for("downcast").add(n.getDispatcher());
        }
      }, {
        key: "_enableManualDecorators",
        value: function _enableManualDecorators(t) {
          if (!t.length) return;
          var e = this.editor,
              n = e.commands.get("link").manualDecorators;
          t.forEach(function (t) {
            e.model.schema.extend("$text", {
              allowAttributes: t.id
            }), n.add(new up(t)), e.conversion.for("downcast").attributeToElement({
              model: t.id,
              view: function view(e, i) {
                if (e) {
                  var _e227 = n.get(t.id).attributes,
                      _o82 = i.createAttributeElement("a", _e227, {
                    priority: 5
                  });

                  return i.setCustomProperty("link", !0, _o82), _o82;
                }
              }
            }), e.conversion.for("upcast").elementToAttribute({
              view: {
                name: "a",
                attributes: n.get(t.id).attributes
              },
              model: {
                key: t.id
              }
            });
          });
        }
      }, {
        key: "_setupLinkHighlight",
        value: function _setupLinkHighlight() {
          var t = this.editor,
              e = t.editing.view,
              n = new Set();
          e.document.registerPostFixer(function (e) {
            var i = t.model.document.selection;

            if (i.hasAttribute("linkHref")) {
              var _o83 = Nm(i.getFirstPosition(), i.getAttribute("linkHref"), t.model),
                  _r42 = t.editing.mapper.toViewRange(_o83);

              var _iteratorNormalCompletion303 = true;
              var _didIteratorError303 = false;
              var _iteratorError303 = undefined;

              try {
                for (var _iterator303 = _r42.getItems()[Symbol.iterator](), _step303; !(_iteratorNormalCompletion303 = (_step303 = _iterator303.next()).done); _iteratorNormalCompletion303 = true) {
                  var _t264 = _step303.value;
                  _t264.is("a") && (e.addClass(wp, _t264), n.add(_t264));
                }
              } catch (err) {
                _didIteratorError303 = true;
                _iteratorError303 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion303 && _iterator303.return != null) {
                    _iterator303.return();
                  }
                } finally {
                  if (_didIteratorError303) {
                    throw _iteratorError303;
                  }
                }
              }
            }
          }), t.conversion.for("editingDowncast").add(function (t) {
            function i() {
              e.change(function (t) {
                var _iteratorNormalCompletion304 = true;
                var _didIteratorError304 = false;
                var _iteratorError304 = undefined;

                try {
                  for (var _iterator304 = n.values()[Symbol.iterator](), _step304; !(_iteratorNormalCompletion304 = (_step304 = _iterator304.next()).done); _iteratorNormalCompletion304 = true) {
                    var _e228 = _step304.value;
                    t.removeClass(wp, _e228), n.delete(_e228);
                  }
                } catch (err) {
                  _didIteratorError304 = true;
                  _iteratorError304 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion304 && _iterator304.return != null) {
                      _iterator304.return();
                    }
                  } finally {
                    if (_didIteratorError304) {
                      throw _iteratorError304;
                    }
                  }
                }
              });
            }

            t.on("insert", i, {
              priority: "highest"
            }), t.on("remove", i, {
              priority: "highest"
            }), t.on("attribute", i, {
              priority: "highest"
            }), t.on("selection", i, {
              priority: "highest"
            });
          });
        }
      }]);

      return yp;
    }(Ql);

    var xp =
    /*#__PURE__*/
    function (_ts7) {
      _inherits(xp, _ts7);

      function xp(t) {
        var _this206;

        _classCallCheck(this, xp);

        _this206 = _possibleConstructorReturn(this, _getPrototypeOf(xp).call(this, t)), _this206.domEventType = "click";
        return _this206;
      }

      _createClass(xp, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return xp;
    }(ts);

    n(112);

    var Ap =
    /*#__PURE__*/
    function (_Rl23) {
      _inherits(Ap, _Rl23);

      function Ap(t) {
        var _this207;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        _classCallCheck(this, Ap);

        _this207 = _possibleConstructorReturn(this, _getPrototypeOf(Ap).call(this, t));
        var n = t.t;
        _this207.focusTracker = new rl(), _this207.keystrokes = new Jc(), _this207.urlInputView = _this207._createUrlInput(), _this207.saveButtonView = _this207._createButton(n("bq"), zh.a, "ck-button-save"), _this207.saveButtonView.type = "submit", _this207.cancelButtonView = _this207._createButton(n("br"), Uh.a, "ck-button-cancel", "cancel"), _this207._manualDecoratorSwitches = _this207._createManualDecoratorSwitches(e), _this207.children = _this207._createFormChildren(e), _this207._focusables = new ml(), _this207._focusCycler = new Hl({
          focusables: _this207._focusables,
          focusTracker: _this207.focusTracker,
          keystrokeHandler: _this207.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        var i = ["ck", "ck-link-form"];
        e.length && i.push("ck-link-form_layout-vertical"), _this207.setTemplate({
          tag: "form",
          attributes: {
            class: i,
            tabindex: "-1"
          },
          children: _this207.children
        });
        return _this207;
      }

      _createClass(Ap, [{
        key: "getDecoratorSwitchesState",
        value: function getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce(function (t, e) {
            return t[e.name] = e.isOn, t;
          }, {});
        }
      }, {
        key: "render",
        value: function render() {
          var _this208 = this;

          _get(_getPrototypeOf(Ap.prototype), "render", this).call(this), Vh({
            view: this
          }), [this.urlInputView].concat(_toConsumableArray(this._manualDecoratorSwitches), [this.saveButtonView, this.cancelButtonView]).forEach(function (t) {
            _this208._focusables.add(t), _this208.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var t = this.locale.t,
              e = new Lh(this.locale, jh);
          return e.label = t("bz"), e.inputView.placeholder = "https://example.com", e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new Hd(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }, {
        key: "_createManualDecoratorSwitches",
        value: function _createManualDecoratorSwitches(t) {
          var _this209 = this;

          var e = this.createCollection();
          var _iteratorNormalCompletion305 = true;
          var _didIteratorError305 = false;
          var _iteratorError305 = undefined;

          try {
            var _loop8 = function _loop8() {
              var n = _step305.value;
              var t = new Xf(_this209.locale);
              t.set({
                name: n.id,
                label: n.label,
                withText: !0
              }), t.bind("isOn").to(n, "value"), t.on("execute", function () {
                n.set("value", !t.isOn);
              }), e.add(t);
            };

            for (var _iterator305 = t[Symbol.iterator](), _step305; !(_iteratorNormalCompletion305 = (_step305 = _iterator305.next()).done); _iteratorNormalCompletion305 = true) {
              _loop8();
            }
          } catch (err) {
            _didIteratorError305 = true;
            _iteratorError305 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion305 && _iterator305.return != null) {
                _iterator305.return();
              }
            } finally {
              if (_didIteratorError305) {
                throw _iteratorError305;
              }
            }
          }

          return e;
        }
      }, {
        key: "_createFormChildren",
        value: function _createFormChildren(t) {
          var e = this.createCollection();

          if (e.add(this.urlInputView), t.length) {
            var _t265 = new Rl();

            _t265.setTemplate({
              tag: "ul",
              children: this._manualDecoratorSwitches.map(function (t) {
                return {
                  tag: "li",
                  children: [t],
                  attributes: {
                    class: ["ck", "ck-list__item"]
                  }
                };
              }),
              attributes: {
                class: ["ck", "ck-reset", "ck-list"]
              }
            }), e.add(_t265);
          }

          return e.add(this.saveButtonView), e.add(this.cancelButtonView), e;
        }
      }]);

      return Ap;
    }(Rl);

    var Cp = n(36),
        Tp = n.n(Cp),
        Pp = n(37),
        Mp = n.n(Pp);
    n(114);

    var Sp =
    /*#__PURE__*/
    function (_Rl24) {
      _inherits(Sp, _Rl24);

      function Sp(t) {
        var _this210;

        _classCallCheck(this, Sp);

        _this210 = _possibleConstructorReturn(this, _getPrototypeOf(Sp).call(this, t));
        var e = t.t;
        _this210.focusTracker = new rl(), _this210.keystrokes = new Jc(), _this210.previewButtonView = _this210._createPreviewButton(), _this210.unlinkButtonView = _this210._createButton(e("bv"), Tp.a, "unlink"), _this210.editButtonView = _this210._createButton(e("bw"), Mp.a, "edit"), _this210.set("href"), _this210._focusables = new ml(), _this210._focusCycler = new Hl({
          focusables: _this210._focusables,
          focusTracker: _this210.focusTracker,
          keystrokeHandler: _this210.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this210.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions"],
            tabindex: "-1"
          },
          children: [_this210.previewButtonView, _this210.editButtonView, _this210.unlinkButtonView]
        });
        return _this210;
      }

      _createClass(Sp, [{
        key: "render",
        value: function render() {
          var _this211 = this;

          _get(_getPrototypeOf(Sp.prototype), "render", this).call(this), [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(function (t) {
            _this211._focusables.add(t), _this211.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n) {
          var i = new Hd(this.locale);
          return i.set({
            label: t,
            icon: e,
            tooltip: !0
          }), i.delegate("execute").to(this, n), i;
        }
      }, {
        key: "_createPreviewButton",
        value: function _createPreviewButton() {
          var t = new Hd(this.locale),
              e = this.bindTemplate,
              n = this.t;
          return t.set({
            withText: !0,
            tooltip: n("bx")
          }), t.extendTemplate({
            attributes: {
              class: ["ck", "ck-link-actions__preview"],
              href: e.to("href", function (t) {
                return t && lp(t);
              }),
              target: "_blank"
            }
          }), t.bind("label").to(this, "href", function (t) {
            return t || n("by");
          }), t.bind("isEnabled").to(this, "href", function (t) {
            return !!t;
          }), t.template.tag = "a", t.template.eventListeners = {}, t;
        }
      }]);

      return Sp;
    }(Rl);

    var Ep = n(38),
        Ip = n.n(Ep);
    var Np = "Ctrl+K";

    var Op =
    /*#__PURE__*/
    function (_Ql57) {
      _inherits(Op, _Ql57);

      function Op() {
        _classCallCheck(this, Op);

        return _possibleConstructorReturn(this, _getPrototypeOf(Op).apply(this, arguments));
      }

      _createClass(Op, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.editing.view.addObserver(xp), this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._balloon = t.plugins.get(rf), this._createToolbarLinkButton(), this._enableUserBalloonInteractions();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Op.prototype), "destroy", this).call(this), this.formView.destroy();
        }
      }, {
        key: "_createActionsView",
        value: function _createActionsView() {
          var _this212 = this;

          var t = this.editor,
              e = new Sp(t.locale),
              n = t.commands.get("link"),
              i = t.commands.get("unlink");
          return e.bind("href").to(n, "value"), e.editButtonView.bind("isEnabled").to(n), e.unlinkButtonView.bind("isEnabled").to(i), this.listenTo(e, "edit", function () {
            _this212._addFormView();
          }), this.listenTo(e, "unlink", function () {
            t.execute("unlink"), _this212._hideUI();
          }), e.keystrokes.set("Esc", function (t, e) {
            _this212._hideUI(), e();
          }), e.keystrokes.set(Np, function (t, e) {
            _this212._addFormView(), e();
          }), e;
        }
      }, {
        key: "_createFormView",
        value: function _createFormView() {
          var _this213 = this;

          var t = this.editor,
              e = t.commands.get("link"),
              n = new Ap(t.locale, e.manualDecorators);
          return n.urlInputView.bind("value").to(e, "value"), n.urlInputView.bind("isReadOnly").to(e, "isEnabled", function (t) {
            return !t;
          }), n.saveButtonView.bind("isEnabled").to(e), this.listenTo(n, "submit", function () {
            t.execute("link", n.urlInputView.inputView.element.value, n.getDecoratorSwitchesState()), _this213._closeFormView();
          }), this.listenTo(n, "cancel", function () {
            _this213._closeFormView();
          }), n.keystrokes.set("Esc", function (t, e) {
            _this213._closeFormView(), e();
          }), n;
        }
      }, {
        key: "_createToolbarLinkButton",
        value: function _createToolbarLinkButton() {
          var _this214 = this;

          var t = this.editor,
              e = t.commands.get("link"),
              n = t.t;
          t.keystrokes.set(Np, function (t, n) {
            n(), e.isEnabled && _this214._showUI(!0);
          }), t.ui.componentFactory.add("link", function (t) {
            var i = new Hd(t);
            return i.isEnabled = !0, i.label = n("aw"), i.icon = Ip.a, i.keystroke = Np, i.tooltip = !0, i.bind("isOn", "isEnabled").to(e, "value", "isEnabled"), _this214.listenTo(i, "execute", function () {
              return _this214._showUI(!0);
            }), i;
          });
        }
      }, {
        key: "_enableUserBalloonInteractions",
        value: function _enableUserBalloonInteractions() {
          var _this215 = this;

          var t = this.editor.editing.view.document;
          this.listenTo(t, "click", function () {
            _this215._getSelectedLinkElement() && _this215._showUI();
          }), this.editor.keystrokes.set("Tab", function (t, e) {
            _this215._areActionsVisible && !_this215.actionsView.focusTracker.isFocused && (_this215.actionsView.focus(), e());
          }, {
            priority: "high"
          }), this.editor.keystrokes.set("Esc", function (t, e) {
            _this215._isUIVisible && (_this215._hideUI(), e());
          }), Dh({
            emitter: this.formView,
            activator: function activator() {
              return _this215._isUIInPanel;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this215._hideUI();
            }
          });
        }
      }, {
        key: "_addActionsView",
        value: function _addActionsView() {
          this._areActionsInPanel || this._balloon.add({
            view: this.actionsView,
            position: this._getBalloonPositionData()
          });
        }
      }, {
        key: "_addFormView",
        value: function _addFormView() {
          if (this._isFormInPanel) return;
          var t = this.editor.commands.get("link");
          this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
          }), this._balloon.visibleView === this.formView && this.formView.urlInputView.select(), this.formView.urlInputView.inputView.element.value = t.value || "";
        }
      }, {
        key: "_closeFormView",
        value: function _closeFormView() {
          var t = this.editor.commands.get("link");
          t.restoreManualDecoratorStates(), void 0 !== t.value ? this._removeFormView() : this._hideUI();
        }
      }, {
        key: "_removeFormView",
        value: function _removeFormView() {
          this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus());
        }
      }, {
        key: "_showUI",
        value: function _showUI() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          this.editor.commands.get("link").isEnabled && (this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI());
        }
      }, {
        key: "_hideUI",
        value: function _hideUI() {
          if (!this._isUIInPanel) return;
          var t = this.editor;
          this.stopListening(t.ui, "update"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView);
        }
      }, {
        key: "_startUpdatingUI",
        value: function _startUpdatingUI() {
          var _this216 = this;

          var t = this.editor,
              e = t.editing.view.document;

          var n = this._getSelectedLinkElement(),
              i = o();

          function o() {
            return e.selection.focus.getAncestors().reverse().find(function (t) {
              return t.is("element");
            });
          }

          this.listenTo(t.ui, "update", function () {
            var t = _this216._getSelectedLinkElement(),
                e = o();

            n && !t || !n && e !== i ? _this216._hideUI() : _this216._balloon.updatePosition(_this216._getBalloonPositionData()), n = t, i = e;
          });
        }
      }, {
        key: "_getBalloonPositionData",
        value: function _getBalloonPositionData() {
          var t = this.editor.editing.view,
              e = t.document,
              n = this._getSelectedLinkElement();

          return {
            target: n ? t.domConverter.mapViewToDom(n) : t.domConverter.viewRangeToDom(e.selection.getFirstRange())
          };
        }
      }, {
        key: "_getSelectedLinkElement",
        value: function _getSelectedLinkElement() {
          var t = this.editor.editing.view,
              e = t.document.selection;
          if (e.isCollapsed) return Rp(e.getFirstPosition());
          {
            var _n215 = e.getFirstRange().getTrimmed(),
                _i180 = Rp(_n215.start),
                _o84 = Rp(_n215.end);

            return _i180 && _i180 == _o84 && t.createRangeIn(_i180).getTrimmed().isEqual(_n215) ? _i180 : null;
          }
        }
      }, {
        key: "_isFormInPanel",
        get: function get() {
          return this._balloon.hasView(this.formView);
        }
      }, {
        key: "_areActionsInPanel",
        get: function get() {
          return this._balloon.hasView(this.actionsView);
        }
      }, {
        key: "_areActionsVisible",
        get: function get() {
          return this._balloon.visibleView === this.actionsView;
        }
      }, {
        key: "_isUIInPanel",
        get: function get() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
      }, {
        key: "_isUIVisible",
        get: function get() {
          return this._balloon.visibleView == this.formView || this._areActionsVisible;
        }
      }], [{
        key: "requires",
        get: function get() {
          return [rf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "LinkUI";
        }
      }]);

      return Op;
    }(Ql);

    function Rp(t) {
      return t.getAncestors().find(function (t) {
        return function (t) {
          return t.is("attributeElement") && !!t.getCustomProperty("link");
        }(t);
      });
    }

    var Dp =
    /*#__PURE__*/
    function (_Ql58) {
      _inherits(Dp, _Ql58);

      function Dp() {
        _classCallCheck(this, Dp);

        return _possibleConstructorReturn(this, _getPrototypeOf(Dp).apply(this, arguments));
      }

      _createClass(Dp, null, [{
        key: "requires",
        get: function get() {
          return [yp, Op];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Link";
        }
      }]);

      return Dp;
    }(Ql);

    var Lp =
    /*#__PURE__*/
    function (_td17) {
      _inherits(Lp, _td17);

      function Lp(t, e) {
        var _this217;

        _classCallCheck(this, Lp);

        _this217 = _possibleConstructorReturn(this, _getPrototypeOf(Lp).call(this, t)), _this217.type = "bulleted" == e ? "bulleted" : "numbered";
        return _this217;
      }

      _createClass(Lp, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this218 = this;

          var t = this.editor.model,
              e = t.document,
              n = Array.from(e.selection.getSelectedBlocks()).filter(function (e) {
            return Vp(e, t.schema);
          }),
              i = !0 === this.value;
          t.change(function (t) {
            if (i) {
              var _e229 = n[n.length - 1].nextSibling,
                  _i181 = Number.POSITIVE_INFINITY,
                  _o85 = [];

              for (; _e229 && "listItem" == _e229.name && 0 !== _e229.getAttribute("listIndent");) {
                var _t266 = _e229.getAttribute("listIndent");

                _t266 < _i181 && (_i181 = _t266);

                var _n216 = _t266 - _i181;

                _o85.push({
                  element: _e229,
                  listIndent: _n216
                }), _e229 = _e229.nextSibling;
              }

              _o85 = _o85.reverse();
              var _iteratorNormalCompletion306 = true;
              var _didIteratorError306 = false;
              var _iteratorError306 = undefined;

              try {
                for (var _iterator306 = _o85[Symbol.iterator](), _step306; !(_iteratorNormalCompletion306 = (_step306 = _iterator306.next()).done); _iteratorNormalCompletion306 = true) {
                  var _e230 = _step306.value;
                  t.setAttribute("listIndent", _e230.listIndent, _e230.element);
                }
              } catch (err) {
                _didIteratorError306 = true;
                _iteratorError306 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion306 && _iterator306.return != null) {
                    _iterator306.return();
                  }
                } finally {
                  if (_didIteratorError306) {
                    throw _iteratorError306;
                  }
                }
              }
            }

            if (!i) {
              var _t267 = Number.POSITIVE_INFINITY;
              var _iteratorNormalCompletion307 = true;
              var _didIteratorError307 = false;
              var _iteratorError307 = undefined;

              try {
                for (var _iterator307 = n[Symbol.iterator](), _step307; !(_iteratorNormalCompletion307 = (_step307 = _iterator307.next()).done); _iteratorNormalCompletion307 = true) {
                  var _e231 = _step307.value;
                  _e231.is("listItem") && _e231.getAttribute("listIndent") < _t267 && (_t267 = _e231.getAttribute("listIndent"));
                }
              } catch (err) {
                _didIteratorError307 = true;
                _iteratorError307 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion307 && _iterator307.return != null) {
                    _iterator307.return();
                  }
                } finally {
                  if (_didIteratorError307) {
                    throw _iteratorError307;
                  }
                }
              }

              jp(n, !0, _t267 = 0 === _t267 ? 1 : _t267), jp(n, !1, _t267);
            }

            var _iteratorNormalCompletion308 = true;
            var _didIteratorError308 = false;
            var _iteratorError308 = undefined;

            try {
              for (var _iterator308 = n.reverse()[Symbol.iterator](), _step308; !(_iteratorNormalCompletion308 = (_step308 = _iterator308.next()).done); _iteratorNormalCompletion308 = true) {
                var _e232 = _step308.value;
                i && "listItem" == _e232.name ? t.rename(_e232, "paragraph") : i || "listItem" == _e232.name ? i || "listItem" != _e232.name || _e232.getAttribute("listType") == _this218.type || t.setAttribute("listType", _this218.type, _e232) : (t.setAttributes({
                  listType: _this218.type,
                  listIndent: 0
                }, _e232), t.rename(_e232, "listItem"));
              }
            } catch (err) {
              _didIteratorError308 = true;
              _iteratorError308 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion308 && _iterator308.return != null) {
                  _iterator308.return();
                }
              } finally {
                if (_didIteratorError308) {
                  throw _iteratorError308;
                }
              }
            }
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = Ru(this.editor.model.document.selection.getSelectedBlocks());
          return !!t && t.is("listItem") && t.getAttribute("listType") == this.type;
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var t = this.editor.model.document.selection,
              e = this.editor.model.schema,
              n = Ru(t.getSelectedBlocks());
          return !!n && Vp(n, e);
        }
      }]);

      return Lp;
    }(td);

    function jp(t, e, n) {
      var i = e ? t[0] : t[t.length - 1];

      if (i.is("listItem")) {
        var _o86 = i[e ? "previousSibling" : "nextSibling"],
            _r43 = i.getAttribute("listIndent");

        for (; _o86 && _o86.is("listItem") && _o86.getAttribute("listIndent") >= n;) {
          _r43 > _o86.getAttribute("listIndent") && (_r43 = _o86.getAttribute("listIndent")), _o86.getAttribute("listIndent") == _r43 && t[e ? "unshift" : "push"](_o86), _o86 = _o86[e ? "previousSibling" : "nextSibling"];
        }
      }
    }

    function Vp(t, e) {
      return e.checkChild(t.parent, "listItem") && !e.isObject(t);
    }

    var Bp =
    /*#__PURE__*/
    function (_td18) {
      _inherits(Bp, _td18);

      function Bp(t, e) {
        var _this219;

        _classCallCheck(this, Bp);

        _this219 = _possibleConstructorReturn(this, _getPrototypeOf(Bp).call(this, t)), _this219._indentBy = "forward" == e ? 1 : -1;
        return _this219;
      }

      _createClass(Bp, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this220 = this;

          var t = this.editor.model,
              e = t.document;
          var n = Array.from(e.selection.getSelectedBlocks());
          t.change(function (t) {
            var e = n[n.length - 1];
            var i = e.nextSibling;

            for (; i && "listItem" == i.name && i.getAttribute("listIndent") > e.getAttribute("listIndent");) {
              n.push(i), i = i.nextSibling;
            }

            _this220._indentBy < 0 && (n = n.reverse());
            var _iteratorNormalCompletion309 = true;
            var _didIteratorError309 = false;
            var _iteratorError309 = undefined;

            try {
              for (var _iterator309 = n[Symbol.iterator](), _step309; !(_iteratorNormalCompletion309 = (_step309 = _iterator309.next()).done); _iteratorNormalCompletion309 = true) {
                var _e233 = _step309.value;

                var _n217 = _e233.getAttribute("listIndent") + _this220._indentBy;

                _n217 < 0 ? t.rename(_e233, "paragraph") : t.setAttribute("listIndent", _n217, _e233);
              }
            } catch (err) {
              _didIteratorError309 = true;
              _iteratorError309 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion309 && _iterator309.return != null) {
                  _iterator309.return();
                }
              } finally {
                if (_didIteratorError309) {
                  throw _iteratorError309;
                }
              }
            }
          });
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          var t = Ru(this.editor.model.document.selection.getSelectedBlocks());
          if (!t || !t.is("listItem")) return !1;

          if (this._indentBy > 0) {
            var _e234 = t.getAttribute("listIndent"),
                _n218 = t.getAttribute("listType");

            var _i182 = t.previousSibling;

            for (; _i182 && _i182.is("listItem") && _i182.getAttribute("listIndent") >= _e234;) {
              if (_i182.getAttribute("listIndent") == _e234) return _i182.getAttribute("listType") == _n218;
              _i182 = _i182.previousSibling;
            }

            return !1;
          }

          return !0;
        }
      }]);

      return Bp;
    }(td);

    function zp() {
      var t = !this.isEmpty && ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
      return this.isEmpty || t ? 0 : xi.call(this);
    }

    function Fp(t) {
      return function (e, n, i) {
        var o = i.consumable;
        if (!o.test(n.item, "insert") || !o.test(n.item, "attribute:listType") || !o.test(n.item, "attribute:listIndent")) return;
        o.consume(n.item, "insert"), o.consume(n.item, "attribute:listType"), o.consume(n.item, "attribute:listIndent");
        var r = n.item;
        eg(r, function (t, e) {
          var n = e.mapper,
              i = e.writer,
              o = "numbered" == t.getAttribute("listType") ? "ol" : "ul",
              r = function (t) {
            var e = t.createContainerElement("li");
            return e.getFillerOffset = zp, e;
          }(i),
              s = i.createContainerElement(o, null);

          return i.insert(i.createPositionAt(s, 0), r), n.bindElements(t, r), r;
        }(r, i), i, t);
      };
    }

    function Up(t) {
      return function (e, n, i) {
        var o = i.mapper.toViewPosition(n.position).getLastMatchingPosition(function (t) {
          return !t.item.is("li");
        }).nodeAfter,
            r = i.writer;
        r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
        var s = o.parent,
            a = s.previousSibling,
            c = r.createRangeOn(s),
            l = r.remove(c);
        a && a.nextSibling && tg(r, a, a.nextSibling), ng(i.mapper.toModelElement(o).getAttribute("listIndent") + 1, n.position, c.start, o, i, t);
        var _iteratorNormalCompletion310 = true;
        var _didIteratorError310 = false;
        var _iteratorError310 = undefined;

        try {
          for (var _iterator310 = r.createRangeIn(l).getItems()[Symbol.iterator](), _step310; !(_iteratorNormalCompletion310 = (_step310 = _iterator310.next()).done); _iteratorNormalCompletion310 = true) {
            var _t268 = _step310.value;
            i.mapper.unbindViewElement(_t268);
          }
        } catch (err) {
          _didIteratorError310 = true;
          _iteratorError310 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion310 && _iterator310.return != null) {
              _iterator310.return();
            }
          } finally {
            if (_didIteratorError310) {
              throw _iteratorError310;
            }
          }
        }

        e.stop();
      };
    }

    function Hp(t, e, n) {
      if (!n.consumable.consume(e.item, "attribute:listType")) return;
      var i = n.mapper.toViewElement(e.item),
          o = n.writer;
      o.breakContainer(o.createPositionBefore(i)), o.breakContainer(o.createPositionAfter(i));
      var r = i.parent;
      var s = "numbered" == e.attributeNewValue ? "ol" : "ul";
      tg(o, r = o.rename(s, r), r.nextSibling), tg(o, r.previousSibling, r);
      var _iteratorNormalCompletion311 = true;
      var _didIteratorError311 = false;
      var _iteratorError311 = undefined;

      try {
        for (var _iterator311 = e.item.getChildren()[Symbol.iterator](), _step311; !(_iteratorNormalCompletion311 = (_step311 = _iterator311.next()).done); _iteratorNormalCompletion311 = true) {
          var _t269 = _step311.value;
          n.consumable.consume(_t269, "insert");
        }
      } catch (err) {
        _didIteratorError311 = true;
        _iteratorError311 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion311 && _iterator311.return != null) {
            _iterator311.return();
          }
        } finally {
          if (_didIteratorError311) {
            throw _iteratorError311;
          }
        }
      }
    }

    function qp(t) {
      return function (e, n, i) {
        if (!i.consumable.consume(n.item, "attribute:listIndent")) return;
        var o = i.mapper.toViewElement(n.item),
            r = i.writer;
        r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
        var s = o.parent,
            a = s.previousSibling,
            c = r.createRangeOn(s);
        r.remove(c), a && a.nextSibling && tg(r, a, a.nextSibling), ng(n.attributeOldValue + 1, n.range.start, c.start, o, i, t), eg(n.item, o, i, t);
        var _iteratorNormalCompletion312 = true;
        var _didIteratorError312 = false;
        var _iteratorError312 = undefined;

        try {
          for (var _iterator312 = n.item.getChildren()[Symbol.iterator](), _step312; !(_iteratorNormalCompletion312 = (_step312 = _iterator312.next()).done); _iteratorNormalCompletion312 = true) {
            var _t270 = _step312.value;
            i.consumable.consume(_t270, "insert");
          }
        } catch (err) {
          _didIteratorError312 = true;
          _iteratorError312 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion312 && _iterator312.return != null) {
              _iterator312.return();
            }
          } finally {
            if (_didIteratorError312) {
              throw _iteratorError312;
            }
          }
        }
      };
    }

    function Wp(t, e, n) {
      if ("listItem" != e.item.name) {
        var _t271 = n.mapper.toViewPosition(e.range.start);

        var _i183 = n.writer,
            _o87 = [];

        for (; ("ul" == _t271.parent.name || "ol" == _t271.parent.name) && "li" == (_t271 = _i183.breakContainer(_t271)).parent.name;) {
          var _e235 = _t271,
              _n219 = _i183.createPositionAt(_t271.parent, "end");

          if (!_e235.isEqual(_n219)) {
            var _t272 = _i183.remove(_i183.createRange(_e235, _n219));

            _o87.push(_t272);
          }

          _t271 = _i183.createPositionAfter(_t271.parent);
        }

        if (_o87.length > 0) {
          for (var _e236 = 0; _e236 < _o87.length; _e236++) {
            var _n220 = _t271.nodeBefore;

            if (_t271 = _i183.insert(_t271, _o87[_e236]).end, _e236 > 0) {
              var _e237 = tg(_i183, _n220, _n220.nextSibling);

              _e237 && _e237.parent == _n220 && _t271.offset--;
            }
          }

          tg(_i183, _t271.nodeBefore, _t271.nodeAfter);
        }
      }
    }

    function Yp(t, e, n) {
      var i = n.mapper.toViewPosition(e.position),
          o = i.nodeBefore,
          r = i.nodeAfter;
      tg(n.writer, o, r);
    }

    function $p(t, e, n) {
      if (n.consumable.consume(e.viewItem, {
        name: !0
      })) {
        var _t273 = n.writer,
            _i184 = this.conversionApi.store,
            _o88 = _t273.createElement("listItem");

        _i184.indent = _i184.indent || 0, _t273.setAttribute("listIndent", _i184.indent, _o88);

        var _r44 = e.viewItem.parent && "ol" == e.viewItem.parent.name ? "numbered" : "bulleted";

        _t273.setAttribute("listType", _r44, _o88), _i184.indent++;

        var _s27 = n.splitToAllowedParent(_o88, e.modelCursor);

        if (!_s27) return;

        _t273.insert(_o88, _s27.position);

        var _a17 = function (t, e, n) {
          var i = n.writer,
              o = n.schema;
          var r = i.createPositionAfter(t);
          var _iteratorNormalCompletion313 = true;
          var _didIteratorError313 = false;
          var _iteratorError313 = undefined;

          try {
            for (var _iterator313 = e[Symbol.iterator](), _step313; !(_iteratorNormalCompletion313 = (_step313 = _iterator313.next()).done); _iteratorNormalCompletion313 = true) {
              var _s28 = _step313.value;
              if ("ul" == _s28.name || "ol" == _s28.name) r = n.convertItem(_s28, r).modelCursor;else {
                var _e238 = n.convertItem(_s28, i.createPositionAt(t, "end")),
                    _a18 = _e238.modelRange.start.nodeAfter,
                    _c9 = _a18 && _a18.is("element") && !o.checkChild(t, _a18.name);

                _c9 && (t = _e238.modelCursor.parent.is("listItem") ? _e238.modelCursor.parent : Zp(_e238.modelCursor), r = i.createPositionAfter(t));
              }
            }
          } catch (err) {
            _didIteratorError313 = true;
            _iteratorError313 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion313 && _iterator313.return != null) {
                _iterator313.return();
              }
            } finally {
              if (_didIteratorError313) {
                throw _iteratorError313;
              }
            }
          }

          return r;
        }(_o88, e.viewItem.getChildren(), n);

        _i184.indent--, e.modelRange = _t273.createRange(e.modelCursor, _a17), _s27.cursorParent ? e.modelCursor = _t273.createPositionAt(_s27.cursorParent, 0) : e.modelCursor = e.modelRange.end;
      }
    }

    function Gp(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: !0
      })) {
        var _t274 = Array.from(e.viewItem.getChildren());

        for (var _i185 = 0, _t275 = _t274; _i185 < _t275.length; _i185++) {
          var _e239 = _t275[_i185];
          _e239.is("li") || _e239._remove();
        }
      }
    }

    function Qp(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: !0
      })) {
        if (0 === e.viewItem.childCount) return;

        var _t276 = _toConsumableArray(e.viewItem.getChildren());

        var _n221 = !1,
            _i186 = !0;

        var _iteratorNormalCompletion314 = true;
        var _didIteratorError314 = false;
        var _iteratorError314 = undefined;

        try {
          for (var _iterator314 = _t276[Symbol.iterator](), _step314; !(_iteratorNormalCompletion314 = (_step314 = _iterator314.next()).done); _iteratorNormalCompletion314 = true) {
            var _e240 = _step314.value;
            !_n221 || _e240.is("ul") || _e240.is("ol") || _e240._remove(), _e240.is("text") ? (_i186 && (_e240._data = _e240.data.replace(/^\s+/, "")), (!_e240.nextSibling || _e240.nextSibling.is("ul") || _e240.nextSibling.is("ol")) && (_e240._data = _e240.data.replace(/\s+$/, ""))) : (_e240.is("ul") || _e240.is("ol")) && (_n221 = !0), _i186 = !1;
          }
        } catch (err) {
          _didIteratorError314 = true;
          _iteratorError314 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion314 && _iterator314.return != null) {
              _iterator314.return();
            }
          } finally {
            if (_didIteratorError314) {
              throw _iteratorError314;
            }
          }
        }
      }
    }

    function Jp(t) {
      return function (e, n) {
        if (n.isPhantom) return;
        var i = n.modelPosition.nodeBefore;

        if (i && i.is("listItem")) {
          var _e241 = n.mapper.toViewElement(i),
              _o89 = _e241.getAncestors().find(function (t) {
            return t.is("ul") || t.is("ol");
          }),
              _r45 = t.createPositionAt(_e241, 0).getWalker();

          var _iteratorNormalCompletion315 = true;
          var _didIteratorError315 = false;
          var _iteratorError315 = undefined;

          try {
            for (var _iterator315 = _r45[Symbol.iterator](), _step315; !(_iteratorNormalCompletion315 = (_step315 = _iterator315.next()).done); _iteratorNormalCompletion315 = true) {
              var _t277 = _step315.value;

              if ("elementStart" == _t277.type && _t277.item.is("li")) {
                n.viewPosition = _t277.previousPosition;
                break;
              }

              if ("elementEnd" == _t277.type && _t277.item == _o89) {
                n.viewPosition = _t277.nextPosition;
                break;
              }
            }
          } catch (err) {
            _didIteratorError315 = true;
            _iteratorError315 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion315 && _iterator315.return != null) {
                _iterator315.return();
              }
            } finally {
              if (_didIteratorError315) {
                throw _iteratorError315;
              }
            }
          }
        }
      };
    }

    function Kp(t, _ref102) {
      var _ref103 = _slicedToArray(_ref102, 2),
          e = _ref103[0],
          n = _ref103[1];

      var i,
          o = e.is("documentFragment") ? e.getChild(0) : e;

      if (i = n ? this.createSelection(n) : this.document.selection, o && o.is("listItem")) {
        var _t278 = i.getFirstPosition();

        var _e242 = null;

        if (_t278.parent.is("listItem") ? _e242 = _t278.parent : _t278.nodeBefore && _t278.nodeBefore.is("listItem") && (_e242 = _t278.nodeBefore), _e242) {
          var _t279 = _e242.getAttribute("listIndent");

          if (_t279 > 0) for (; o && o.is("listItem");) {
            o._setAttribute("listIndent", o.getAttribute("listIndent") + _t279), o = o.nextSibling;
          }
        }
      }
    }

    function Zp(t) {
      var e = new Ws({
        startPosition: t
      });
      var n;

      do {
        n = e.next();
      } while (!n.value.item.is("listItem"));

      return n.value.item;
    }

    function Xp(t, e) {
      var n = !!e.sameIndent,
          i = !!e.smallerIndent,
          o = e.listIndent;
      var r = t;

      for (; r && "listItem" == r.name;) {
        var _t280 = r.getAttribute("listIndent");

        if (n && o == _t280 || i && o > _t280) return r;
        r = r.previousSibling;
      }

      return null;
    }

    function tg(t, e, n) {
      return e && n && ("ul" == e.name || "ol" == e.name) && e.name == n.name ? t.mergeContainers(t.createPositionAfter(e)) : null;
    }

    function eg(t, e, n, i) {
      var o = e.parent,
          r = n.mapper,
          s = n.writer;
      var a = r.toViewPosition(i.createPositionBefore(t));
      var c = Xp(t.previousSibling, {
        sameIndent: !0,
        smallerIndent: !0,
        listIndent: t.getAttribute("listIndent")
      }),
          l = t.previousSibling;

      if (c && c.getAttribute("listIndent") == t.getAttribute("listIndent")) {
        var _t281 = r.toViewElement(c);

        a = s.breakContainer(s.createPositionAfter(_t281));
      } else a = l && "listItem" == l.name ? r.toViewPosition(i.createPositionAt(l, "end")) : r.toViewPosition(i.createPositionBefore(t));

      if (a = ig(a), s.insert(a, o), l && "listItem" == l.name) {
        var _t282 = r.toViewElement(l),
            _n222 = s.createRange(s.createPositionAt(_t282, 0), a).getWalker({
          ignoreElementEnd: !0
        });

        var _iteratorNormalCompletion316 = true;
        var _didIteratorError316 = false;
        var _iteratorError316 = undefined;

        try {
          for (var _iterator316 = _n222[Symbol.iterator](), _step316; !(_iteratorNormalCompletion316 = (_step316 = _iterator316.next()).done); _iteratorNormalCompletion316 = true) {
            var _t283 = _step316.value;

            if (_t283.item.is("li")) {
              var _i187 = s.breakContainer(s.createPositionBefore(_t283.item)),
                  _o90 = _t283.item.parent,
                  _r46 = s.createPositionAt(e, "end");

              tg(s, _r46.nodeBefore, _r46.nodeAfter), s.move(s.createRangeOn(_o90), _r46), _n222.position = _i187;
            }
          }
        } catch (err) {
          _didIteratorError316 = true;
          _iteratorError316 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion316 && _iterator316.return != null) {
              _iterator316.return();
            }
          } finally {
            if (_didIteratorError316) {
              throw _iteratorError316;
            }
          }
        }
      } else {
        var _n223 = o.nextSibling;

        if (_n223 && (_n223.is("ul") || _n223.is("ol"))) {
          var _i188 = null;
          var _iteratorNormalCompletion317 = true;
          var _didIteratorError317 = false;
          var _iteratorError317 = undefined;

          try {
            for (var _iterator317 = _n223.getChildren()[Symbol.iterator](), _step317; !(_iteratorNormalCompletion317 = (_step317 = _iterator317.next()).done); _iteratorNormalCompletion317 = true) {
              var _e243 = _step317.value;

              var _n224 = r.toModelElement(_e243);

              if (!(_n224 && _n224.getAttribute("listIndent") > t.getAttribute("listIndent"))) break;
              _i188 = _e243;
            }
          } catch (err) {
            _didIteratorError317 = true;
            _iteratorError317 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion317 && _iterator317.return != null) {
                _iterator317.return();
              }
            } finally {
              if (_didIteratorError317) {
                throw _iteratorError317;
              }
            }
          }

          _i188 && (s.breakContainer(s.createPositionAfter(_i188)), s.move(s.createRangeOn(_i188.parent), s.createPositionAt(e, "end")));
        }
      }

      tg(s, o, o.nextSibling), tg(s, o.previousSibling, o);
    }

    function ng(t, e, n, i, o, r) {
      var s = Xp(e.nodeBefore, {
        sameIndent: !0,
        smallerIndent: !0,
        listIndent: t,
        foo: "b"
      }),
          a = o.mapper,
          c = o.writer,
          l = s ? s.getAttribute("listIndent") : null;
      var d;
      if (s) {
        if (l == t) {
          var _t284 = a.toViewElement(s).parent;
          d = c.createPositionAfter(_t284);
        } else {
          var _t285 = r.createPositionAt(s, "end");

          d = a.toViewPosition(_t285);
        }
      } else d = n;
      d = ig(d);

      for (var _i189 = 0, _arr = _toConsumableArray(i.getChildren()); _i189 < _arr.length; _i189++) {
        var _t286 = _arr[_i189];
        (_t286.is("ul") || _t286.is("ol")) && (d = c.move(c.createRangeOn(_t286), d).end, tg(c, _t286, _t286.nextSibling), tg(c, _t286.previousSibling, _t286));
      }
    }

    function ig(t) {
      return t.getLastMatchingPosition(function (t) {
        return t.item.is("uiElement");
      });
    }

    var og =
    /*#__PURE__*/
    function (_Ql59) {
      _inherits(og, _Ql59);

      function og() {
        _classCallCheck(this, og);

        return _possibleConstructorReturn(this, _getPrototypeOf(og).apply(this, arguments));
      }

      _createClass(og, [{
        key: "init",
        value: function init() {
          var _this221 = this;

          var t = this.editor;
          t.model.schema.register("listItem", {
            inheritAllFrom: "$block",
            allowAttributes: ["listType", "listIndent"]
          });
          var e = t.data,
              n = t.editing;
          t.model.document.registerPostFixer(function (e) {
            return function (t, e) {
              var n = t.document.differ.getChanges(),
                  i = new Map();
              var o = !1;
              var _iteratorNormalCompletion318 = true;
              var _didIteratorError318 = false;
              var _iteratorError318 = undefined;

              try {
                for (var _iterator318 = n[Symbol.iterator](), _step318; !(_iteratorNormalCompletion318 = (_step318 = _iterator318.next()).done); _iteratorNormalCompletion318 = true) {
                  var _t287 = _step318.value;
                  if ("insert" == _t287.type && "listItem" == _t287.name) r(_t287.position);else if ("insert" == _t287.type && "listItem" != _t287.name) {
                    if ("$text" != _t287.name) {
                      var _n226 = _t287.position.nodeAfter;
                      _n226.hasAttribute("listIndent") && (e.removeAttribute("listIndent", _n226), o = !0), _n226.hasAttribute("listType") && (e.removeAttribute("listType", _n226), o = !0);
                    }

                    r(_t287.position.getShiftedBy(_t287.length));
                  } else "remove" == _t287.type && "listItem" == _t287.name ? r(_t287.position) : "attribute" == _t287.type && "listIndent" == _t287.attributeKey ? r(_t287.range.start) : "attribute" == _t287.type && "listType" == _t287.attributeKey && r(_t287.range.start);
                }
              } catch (err) {
                _didIteratorError318 = true;
                _iteratorError318 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion318 && _iterator318.return != null) {
                    _iterator318.return();
                  }
                } finally {
                  if (_didIteratorError318) {
                    throw _iteratorError318;
                  }
                }
              }

              var _iteratorNormalCompletion319 = true;
              var _didIteratorError319 = false;
              var _iteratorError319 = undefined;

              try {
                for (var _iterator319 = i.values()[Symbol.iterator](), _step319; !(_iteratorNormalCompletion319 = (_step319 = _iterator319.next()).done); _iteratorNormalCompletion319 = true) {
                  var _t288 = _step319.value;
                  s(_t288), a(_t288);
                }
              } catch (err) {
                _didIteratorError319 = true;
                _iteratorError319 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion319 && _iterator319.return != null) {
                    _iterator319.return();
                  }
                } finally {
                  if (_didIteratorError319) {
                    throw _iteratorError319;
                  }
                }
              }

              return o;

              function r(t) {
                var e = t.nodeBefore;

                if (e && e.is("listItem")) {
                  var _n225 = e;
                  if (i.has(_n225)) return;

                  for (; _n225.previousSibling && _n225.previousSibling.is("listItem");) {
                    if (_n225 = _n225.previousSibling, i.has(_n225)) return;
                  }

                  i.set(t.nodeBefore, _n225);
                } else {
                  var _e244 = t.nodeAfter;
                  _e244 && _e244.is("listItem") && i.set(_e244, _e244);
                }
              }

              function s(t) {
                var n = 0,
                    i = null;

                for (; t && t.is("listItem");) {
                  var _r47 = t.getAttribute("listIndent");

                  if (_r47 > n) {
                    var _s29 = void 0;

                    null === i ? (i = _r47 - n, _s29 = n) : (i > _r47 && (i = _r47), _s29 = _r47 - i), e.setAttribute("listIndent", _s29, t), o = !0;
                  } else i = null, n = t.getAttribute("listIndent") + 1;

                  t = t.nextSibling;
                }
              }

              function a(t) {
                var n = [],
                    i = null;

                for (; t && t.is("listItem");) {
                  var _r48 = t.getAttribute("listIndent");

                  if (i && i.getAttribute("listIndent") > _r48 && (n = n.slice(0, _r48 + 1)), 0 != _r48) if (n[_r48]) {
                    var _i190 = n[_r48];
                    t.getAttribute("listType") != _i190 && (e.setAttribute("listType", _i190, t), o = !0);
                  } else n[_r48] = t.getAttribute("listType");
                  i = t, t = t.nextSibling;
                }
              }
            }(t.model, e);
          }), n.mapper.registerViewToModelLength("li", rg), e.mapper.registerViewToModelLength("li", rg), n.mapper.on("modelToViewPosition", Jp(n.view)), n.mapper.on("viewToModelPosition", function (t) {
            return function (e, n) {
              var i = n.viewPosition,
                  o = i.parent,
                  r = n.mapper;

              if ("ul" == o.name || "ol" == o.name) {
                if (i.isAtEnd) {
                  var _e245 = r.toModelElement(i.nodeBefore),
                      _o91 = r.getModelLength(i.nodeBefore);

                  n.modelPosition = t.createPositionBefore(_e245).getShiftedBy(_o91);
                } else {
                  var _e246 = r.toModelElement(i.nodeAfter);

                  n.modelPosition = t.createPositionBefore(_e246);
                }

                e.stop();
              } else if ("li" == o.name && i.nodeBefore && ("ul" == i.nodeBefore.name || "ol" == i.nodeBefore.name)) {
                var _s30 = r.toModelElement(o);

                var _a19 = 1,
                    _c10 = i.nodeBefore;

                for (; _c10 && (_c10.is("ul") || _c10.is("ol"));) {
                  _a19 += r.getModelLength(_c10), _c10 = _c10.previousSibling;
                }

                n.modelPosition = t.createPositionBefore(_s30).getShiftedBy(_a19), e.stop();
              }
            };
          }(t.model)), e.mapper.on("modelToViewPosition", Jp(n.view)), n.downcastDispatcher.on("insert", Wp, {
            priority: "high"
          }), n.downcastDispatcher.on("insert:listItem", Fp(t.model)), e.downcastDispatcher.on("insert", Wp, {
            priority: "high"
          }), e.downcastDispatcher.on("insert:listItem", Fp(t.model)), n.downcastDispatcher.on("attribute:listType:listItem", Hp), e.downcastDispatcher.on("attribute:listType:listItem", Hp), n.downcastDispatcher.on("attribute:listIndent:listItem", qp(t.model)), e.downcastDispatcher.on("attribute:listIndent:listItem", qp(t.model)), n.downcastDispatcher.on("remove:listItem", Up(t.model)), n.downcastDispatcher.on("remove", Yp, {
            priority: "low"
          }), e.downcastDispatcher.on("remove:listItem", Up(t.model)), e.downcastDispatcher.on("remove", Yp, {
            priority: "low"
          }), e.upcastDispatcher.on("element:ul", Gp, {
            priority: "high"
          }), e.upcastDispatcher.on("element:ol", Gp, {
            priority: "high"
          }), e.upcastDispatcher.on("element:li", Qp, {
            priority: "high"
          }), e.upcastDispatcher.on("element:li", $p), t.model.on("insertContent", Kp, {
            priority: "high"
          }), t.commands.add("numberedList", new Lp(t, "numbered")), t.commands.add("bulletedList", new Lp(t, "bulleted")), t.commands.add("indentList", new Bp(t, "forward")), t.commands.add("outdentList", new Bp(t, "backward"));
          var i = this.editor.editing.view.document;
          this.listenTo(i, "enter", function (t, e) {
            var n = _this221.editor.model.document,
                i = n.selection.getLastPosition().parent;
            n.selection.isCollapsed && "listItem" == i.name && i.isEmpty && (_this221.editor.execute("outdentList"), e.preventDefault(), t.stop());
          }), this.listenTo(i, "delete", function (t, e) {
            if ("backward" !== e.direction) return;
            var n = _this221.editor.model.document.selection;
            if (!n.isCollapsed) return;
            var i = n.getFirstPosition();
            if (!i.isAtStart) return;
            var o = i.parent;
            "listItem" === o.name && (o.previousSibling && "listItem" === o.previousSibling.name || (_this221.editor.execute("outdentList"), e.preventDefault(), t.stop()));
          }, {
            priority: "high"
          });

          var o = function o(t) {
            return function (e, n) {
              _this221.editor.commands.get(t).isEnabled && (_this221.editor.execute(t), n());
            };
          };

          t.keystrokes.set("Tab", o("indentList")), t.keystrokes.set("Shift+Tab", o("outdentList"));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor.commands,
              e = t.get("indent"),
              n = t.get("outdent");
          e && e.registerChildCommand(t.get("indentList")), n && n.registerChildCommand(t.get("outdentList"));
        }
      }], [{
        key: "requires",
        get: function get() {
          return [jf];
        }
      }]);

      return og;
    }(Ql);

    function rg(t) {
      var e = 1;
      var _iteratorNormalCompletion320 = true;
      var _didIteratorError320 = false;
      var _iteratorError320 = undefined;

      try {
        for (var _iterator320 = t.getChildren()[Symbol.iterator](), _step320; !(_iteratorNormalCompletion320 = (_step320 = _iterator320.next()).done); _iteratorNormalCompletion320 = true) {
          var _n227 = _step320.value;

          if ("ul" == _n227.name || "ol" == _n227.name) {
            var _iteratorNormalCompletion321 = true;
            var _didIteratorError321 = false;
            var _iteratorError321 = undefined;

            try {
              for (var _iterator321 = _n227.getChildren()[Symbol.iterator](), _step321; !(_iteratorNormalCompletion321 = (_step321 = _iterator321.next()).done); _iteratorNormalCompletion321 = true) {
                var _t289 = _step321.value;
                e += rg(_t289);
              }
            } catch (err) {
              _didIteratorError321 = true;
              _iteratorError321 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion321 && _iterator321.return != null) {
                  _iterator321.return();
                }
              } finally {
                if (_didIteratorError321) {
                  throw _iteratorError321;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError320 = true;
        _iteratorError320 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion320 && _iterator320.return != null) {
            _iterator320.return();
          }
        } finally {
          if (_didIteratorError320) {
            throw _iteratorError320;
          }
        }
      }

      return e;
    }

    var sg = n(39),
        ag = n.n(sg),
        cg = n(40),
        lg = n.n(cg);

    var dg =
    /*#__PURE__*/
    function (_Ql60) {
      _inherits(dg, _Ql60);

      function dg() {
        _classCallCheck(this, dg);

        return _possibleConstructorReturn(this, _getPrototypeOf(dg).apply(this, arguments));
      }

      _createClass(dg, [{
        key: "init",
        value: function init() {
          var t = this.editor.t;
          this._addButton("numberedList", t("am"), ag.a), this._addButton("bulletedList", t("an"), lg.a);
        }
      }, {
        key: "_addButton",
        value: function _addButton(t, e, n) {
          var _this222 = this;

          var i = this.editor;
          i.ui.componentFactory.add(t, function (o) {
            var r = i.commands.get(t),
                s = new Hd(o);
            return s.set({
              label: e,
              icon: n,
              tooltip: !0
            }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), _this222.listenTo(s, "execute", function () {
              return i.execute(t);
            }), s;
          });
        }
      }]);

      return dg;
    }(Ql);

    var ug =
    /*#__PURE__*/
    function (_Ql61) {
      _inherits(ug, _Ql61);

      function ug() {
        _classCallCheck(this, ug);

        return _possibleConstructorReturn(this, _getPrototypeOf(ug).apply(this, arguments));
      }

      _createClass(ug, null, [{
        key: "requires",
        get: function get() {
          return [og, dg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "List";
        }
      }]);

      return ug;
    }(Ql);

    function hg(t, e) {
      return function (t) {
        t.on("attribute:url:media", n);
      };

      function n(n, i, o) {
        if (!o.consumable.consume(i.item, n.name)) return;
        var r = i.attributeNewValue,
            s = o.writer,
            a = o.mapper.toViewElement(i.item);
        s.remove(s.createRangeIn(a));
        var c = t.getMediaViewElement(s, r, e);
        s.insert(s.createPositionAt(a, 0), c);
      }
    }

    function fg(t, e, n, i) {
      var o = t.createContainerElement("figure", {
        class: "media"
      });
      return o.getFillerOffset = gg, t.insert(t.createPositionAt(o, 0), e.getMediaViewElement(t, n, i)), o;
    }

    function mg(t) {
      var e = t.getSelectedElement();
      return e && e.is("media") ? e : null;
    }

    function pg(t, e, n) {
      t.change(function (i) {
        var o = i.createElement("media", {
          url: e
        });
        t.insertContent(o, n), i.setSelection(o, "on");
      });
    }

    function gg() {
      return null;
    }

    var bg =
    /*#__PURE__*/
    function (_td19) {
      _inherits(bg, _td19);

      function bg() {
        _classCallCheck(this, bg);

        return _possibleConstructorReturn(this, _getPrototypeOf(bg).apply(this, arguments));
      }

      _createClass(bg, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema,
              i = e.getFirstPosition(),
              o = mg(e);
          var r = i.parent;
          r != r.root && (r = r.parent), this.value = o ? o.getAttribute("url") : null, this.isEnabled = n.checkChild(r, "media");
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document.selection,
              i = mg(n);
          if (i) e.change(function (e) {
            e.setAttribute("url", t, i);
          });else {
            var _i191 = kh(n, e);

            pg(e, t, _i191);
          }
        }
      }]);

      return bg;
    }(td);

    var wg = n(41),
        _g = n.n(wg);

    var kg = "0 0 64 42";

    var vg =
    /*#__PURE__*/
    function () {
      function vg(t, e) {
        _classCallCheck(this, vg);

        var n = e.providers,
            i = e.extraProviders || [],
            o = new Set(e.removeProviders),
            r = n.concat(i).filter(function (t) {
          var e = t.name;
          return e ? !o.has(e) : (bs.a.warn("media-embed-no-provider-name: The configured media provider has no name and cannot be used.", {
            provider: t
          }), !1);
        });
        this.locale = t, this.providerDefinitions = r;
      }

      _createClass(vg, [{
        key: "hasMedia",
        value: function hasMedia(t) {
          return !!this._getMedia(t);
        }
      }, {
        key: "getMediaViewElement",
        value: function getMediaViewElement(t, e, n) {
          return this._getMedia(e).getViewElement(t, n);
        }
      }, {
        key: "_getMedia",
        value: function _getMedia(t) {
          if (!t) return new yg(this.locale);
          t = t.trim();
          var _iteratorNormalCompletion322 = true;
          var _didIteratorError322 = false;
          var _iteratorError322 = undefined;

          try {
            for (var _iterator322 = this.providerDefinitions[Symbol.iterator](), _step322; !(_iteratorNormalCompletion322 = (_step322 = _iterator322.next()).done); _iteratorNormalCompletion322 = true) {
              var _e247 = _step322.value;
              var _n228 = _e247.html;
              var _i192 = _e247.url;
              Array.isArray(_i192) || (_i192 = [_i192]);
              var _iteratorNormalCompletion323 = true;
              var _didIteratorError323 = false;
              var _iteratorError323 = undefined;

              try {
                for (var _iterator323 = _i192[Symbol.iterator](), _step323; !(_iteratorNormalCompletion323 = (_step323 = _iterator323.next()).done); _iteratorNormalCompletion323 = true) {
                  var _e248 = _step323.value;

                  var _i193 = this._getUrlMatches(t, _e248);

                  if (_i193) return new yg(this.locale, t, _i193, _n228);
                }
              } catch (err) {
                _didIteratorError323 = true;
                _iteratorError323 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion323 && _iterator323.return != null) {
                    _iterator323.return();
                  }
                } finally {
                  if (_didIteratorError323) {
                    throw _iteratorError323;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError322 = true;
            _iteratorError322 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion322 && _iterator322.return != null) {
                _iterator322.return();
              }
            } finally {
              if (_didIteratorError322) {
                throw _iteratorError322;
              }
            }
          }

          return null;
        }
      }, {
        key: "_getUrlMatches",
        value: function _getUrlMatches(t, e) {
          var n = t.match(e);
          if (n) return n;
          var i = t.replace(/^https?:\/\//, "");
          return (n = i.match(e)) ? n : (n = (i = i.replace(/^www\./, "")).match(e)) || null;
        }
      }]);

      return vg;
    }();

    var yg =
    /*#__PURE__*/
    function () {
      function yg(t, e, n, i) {
        _classCallCheck(this, yg);

        this.url = this._getValidUrl(e), this._t = t.t, this._match = n, this._previewRenderer = i;
      }

      _createClass(yg, [{
        key: "getViewElement",
        value: function getViewElement(t, e) {
          var n = {};

          if (e.renderForEditingView || e.renderMediaPreview && this.url && this._previewRenderer) {
            this.url && (n["data-oembed-url"] = this.url), e.renderForEditingView && (n.class = "ck-media__wrapper");

            var _i194 = this._getPreviewHtml(e);

            return t.createUIElement("div", n, function (t) {
              var e = this.toDomElement(t);
              return e.innerHTML = _i194, e;
            });
          }

          return this.url && (n.url = this.url), t.createEmptyElement("oembed", n);
        }
      }, {
        key: "_getPreviewHtml",
        value: function _getPreviewHtml(t) {
          return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t.renderForEditingView ? this._getPlaceholderHtml() : "";
        }
      }, {
        key: "_getPlaceholderHtml",
        value: function _getPlaceholderHtml() {
          var t = new Ud(),
              e = new Fd();
          return t.text = this._t("Open media in new tab"), e.content = _g.a, e.viewBox = kg, new gl({
            tag: "div",
            attributes: {
              class: "ck ck-reset_all ck-media__placeholder"
            },
            children: [{
              tag: "div",
              attributes: {
                class: "ck-media__placeholder__icon"
              },
              children: [e]
            }, {
              tag: "a",
              attributes: {
                class: "ck-media__placeholder__url",
                target: "_blank",
                rel: "noopener noreferrer",
                href: this.url
              },
              children: [{
                tag: "span",
                attributes: {
                  class: "ck-media__placeholder__url__text"
                },
                children: [this.url]
              }, t]
            }]
          }).render().outerHTML;
        }
      }, {
        key: "_getValidUrl",
        value: function _getValidUrl(t) {
          return t ? t.match(/^https?/) ? t : "https://" + t : null;
        }
      }]);

      return yg;
    }();

    n(116);

    var xg =
    /*#__PURE__*/
    function (_Ql62) {
      _inherits(xg, _Ql62);

      _createClass(xg, null, [{
        key: "pluginName",
        get: function get() {
          return "MediaEmbedEditing";
        }
      }]);

      function xg(t) {
        var _this223;

        _classCallCheck(this, xg);

        _this223 = _possibleConstructorReturn(this, _getPrototypeOf(xg).call(this, t)), t.config.define("mediaEmbed", {
          providers: [{
            name: "dailymotion",
            url: /^dailymotion\.com\/video\/(\w+)/,
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; ">' + "<iframe src=\"https://www.dailymotion.com/embed/video/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>';
            }
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;">' + "<iframe src=\"https://open.spotify.com/embed/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>';
            }
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://www.youtube.com/embed/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>';
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://player.vimeo.com/video/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
            }
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: /^google\.com\/maps/
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), _this223.registry = new vg(t.locale, t.config.get("mediaEmbed"));
        return _this223;
      }

      _createClass(xg, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.t,
              i = t.conversion,
              o = t.config.get("mediaEmbed.previewsInData"),
              r = this.registry;
          t.commands.add("mediaEmbed", new bg(t)), e.register("media", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["url"]
          }), i.for("dataDowncast").elementToElement({
            model: "media",
            view: function view(t, e) {
              var n = t.getAttribute("url");
              return fg(e, r, n, {
                renderMediaPreview: n && o
              });
            }
          }), i.for("dataDowncast").add(hg(r, {
            renderMediaPreview: o
          })), i.for("editingDowncast").elementToElement({
            model: "media",
            view: function view(t, e) {
              var i = t.getAttribute("url");
              return function (t, e, n) {
                return e.setCustomProperty("media", !0, t), bh(t, e, {
                  label: n
                });
              }(fg(e, r, i, {
                renderForEditingView: !0
              }), e, n("aq"));
            }
          }), i.for("editingDowncast").add(hg(r, {
            renderForEditingView: !0
          })), i.for("upcast").elementToElement({
            view: {
              name: "oembed",
              attributes: {
                url: !0
              }
            },
            model: function model(t, e) {
              var n = t.getAttribute("url");
              if (r.hasMedia(n)) return e.createElement("media", {
                url: n
              });
            }
          }).elementToElement({
            view: {
              name: "div",
              attributes: {
                "data-oembed-url": !0
              }
            },
            model: function model(t, e) {
              var n = t.getAttribute("data-oembed-url");
              if (r.hasMedia(n)) return e.createElement("media", {
                url: n
              });
            }
          });
        }
      }]);

      return xg;
    }(Ql);

    var Ag = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;

    var Cg =
    /*#__PURE__*/
    function (_Ql63) {
      _inherits(Cg, _Ql63);

      _createClass(Cg, null, [{
        key: "requires",
        get: function get() {
          return [Xl, Qd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "AutoMediaEmbed";
        }
      }]);

      function Cg(t) {
        var _this224;

        _classCallCheck(this, Cg);

        _this224 = _possibleConstructorReturn(this, _getPrototypeOf(Cg).call(this, t)), _this224._timeoutId = null, _this224._positionToInsert = null;
        return _this224;
      }

      _createClass(Cg, [{
        key: "init",
        value: function init() {
          var _this225 = this;

          var t = this.editor,
              e = t.model.document;
          this.listenTo(t.plugins.get(Xl), "inputTransformation", function () {
            var t = e.selection.getFirstRange(),
                n = Rc.fromPosition(t.start);
            n.stickiness = "toPrevious";
            var i = Rc.fromPosition(t.end);
            i.stickiness = "toNext", e.once("change:data", function () {
              _this225._embedMediaBetweenPositions(n, i), n.detach(), i.detach();
            }, {
              priority: "high"
            });
          }), t.commands.get("undo").on("execute", function () {
            _this225._timeoutId && (nr.window.clearTimeout(_this225._timeoutId), _this225._positionToInsert.detach(), _this225._timeoutId = null, _this225._positionToInsert = null);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_embedMediaBetweenPositions",
        value: function _embedMediaBetweenPositions(t, e) {
          var _this226 = this;

          var n = this.editor,
              i = n.plugins.get(xg).registry,
              o = new ra(t, e),
              r = o.getWalker({
            ignoreElementEnd: !0
          });
          var s = "";
          var _iteratorNormalCompletion324 = true;
          var _didIteratorError324 = false;
          var _iteratorError324 = undefined;

          try {
            for (var _iterator324 = r[Symbol.iterator](), _step324; !(_iteratorNormalCompletion324 = (_step324 = _iterator324.next()).done); _iteratorNormalCompletion324 = true) {
              var _t290 = _step324.value;
              _t290.item.is("textProxy") && (s += _t290.item.data);
            }
          } catch (err) {
            _didIteratorError324 = true;
            _iteratorError324 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion324 && _iterator324.return != null) {
                _iterator324.return();
              }
            } finally {
              if (_didIteratorError324) {
                throw _iteratorError324;
              }
            }
          }

          if (!(s = s.trim()).match(Ag)) return;
          if (!i.hasMedia(s)) return;
          n.commands.get("mediaEmbed").isEnabled && (this._positionToInsert = Rc.fromPosition(t), this._timeoutId = nr.window.setTimeout(function () {
            n.model.change(function (t) {
              var e;
              _this226._timeoutId = null, t.remove(o), "$graveyard" !== _this226._positionToInsert.root.rootName && (e = _this226._positionToInsert), pg(n.model, s, e), _this226._positionToInsert.detach(), _this226._positionToInsert = null;
            });
          }, 100));
        }
      }]);

      return Cg;
    }(Ql);

    n(118);

    var Tg =
    /*#__PURE__*/
    function (_Rl25) {
      _inherits(Tg, _Rl25);

      function Tg(t, e) {
        var _this227;

        _classCallCheck(this, Tg);

        _this227 = _possibleConstructorReturn(this, _getPrototypeOf(Tg).call(this, e));
        var n = e.t;
        _this227.focusTracker = new rl(), _this227.keystrokes = new Jc(), _this227.urlInputView = _this227._createUrlInput(), _this227.saveButtonView = _this227._createButton(n("bq"), zh.a, "ck-button-save"), _this227.saveButtonView.type = "submit", _this227.cancelButtonView = _this227._createButton(n("br"), Uh.a, "ck-button-cancel", "cancel"), _this227._focusables = new ml(), _this227._focusCycler = new Hl({
          focusables: _this227._focusables,
          focusTracker: _this227.focusTracker,
          keystrokeHandler: _this227.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this227._validators = t, _this227.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form"],
            tabindex: "-1"
          },
          children: [_this227.urlInputView, _this227.saveButtonView, _this227.cancelButtonView]
        });
        return _this227;
      }

      _createClass(Tg, [{
        key: "render",
        value: function render() {
          var _this228 = this;

          _get(_getPrototypeOf(Tg.prototype), "render", this).call(this), Vh({
            view: this
          }), [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this228._focusables.add(t), _this228.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);

          var t = function t(_t291) {
            return _t291.stopPropagation();
          };

          this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t), this.listenTo(this.urlInputView.element, "selectstart", function (t, e) {
            e.stopPropagation();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "isValid",
        value: function isValid() {
          this.resetFormStatus();
          var _iteratorNormalCompletion325 = true;
          var _didIteratorError325 = false;
          var _iteratorError325 = undefined;

          try {
            for (var _iterator325 = this._validators[Symbol.iterator](), _step325; !(_iteratorNormalCompletion325 = (_step325 = _iterator325.next()).done); _iteratorNormalCompletion325 = true) {
              var _t292 = _step325.value;

              var _e249 = _t292(this);

              if (_e249) return this.urlInputView.errorText = _e249, !1;
            }
          } catch (err) {
            _didIteratorError325 = true;
            _iteratorError325 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion325 && _iterator325.return != null) {
                _iterator325.return();
              }
            } finally {
              if (_didIteratorError325) {
                throw _iteratorError325;
              }
            }
          }

          return !0;
        }
      }, {
        key: "resetFormStatus",
        value: function resetFormStatus() {
          this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var _this229 = this;

          var t = this.locale.t,
              e = new Lh(this.locale, jh),
              n = e.inputView;
          return this._urlInputViewInfoDefault = t("ca"), this._urlInputViewInfoTip = t("cb"), e.label = t("cc"), e.infoText = this._urlInputViewInfoDefault, n.placeholder = "https://example.com", n.on("input", function () {
            e.infoText = n.element.value ? _this229._urlInputViewInfoTip : _this229._urlInputViewInfoDefault;
          }), e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new Hd(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }, {
        key: "url",
        get: function get() {
          return this.urlInputView.inputView.element.value.trim();
        },
        set: function set(t) {
          this.urlInputView.inputView.element.value = t.trim();
        }
      }]);

      return Tg;
    }(Rl);

    var Pg = n(42),
        Mg = n.n(Pg);

    var Sg =
    /*#__PURE__*/
    function (_Ql64) {
      _inherits(Sg, _Ql64);

      function Sg() {
        _classCallCheck(this, Sg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Sg).apply(this, arguments));
      }

      _createClass(Sg, [{
        key: "init",
        value: function init() {
          var _this230 = this;

          var t = this.editor,
              e = t.commands.get("mediaEmbed"),
              n = t.plugins.get(xg).registry;
          this.form = new Tg(function (t, e) {
            return [function (e) {
              if (!e.url.length) return t("as");
            }, function (n) {
              if (!e.hasMedia(n.url)) return t("at");
            }];
          }(t.t, n), t.locale), t.ui.componentFactory.add("mediaEmbed", function (n) {
            var i = tm(n);
            return _this230._setUpDropdown(i, _this230.form, e, t), _this230._setUpForm(_this230.form, i, e), i;
          });
        }
      }, {
        key: "_setUpDropdown",
        value: function _setUpDropdown(t, e, n) {
          var i = this.editor,
              o = i.t,
              r = t.buttonView;

          function s() {
            i.editing.view.focus(), t.isOpen = !1;
          }

          t.bind("isEnabled").to(n), t.panelView.children.add(e), r.set({
            label: o("ar"),
            icon: Mg.a,
            tooltip: !0
          }), r.on("open", function () {
            e.url = n.value || "", e.urlInputView.select(), e.focus();
          }, {
            priority: "low"
          }), t.on("submit", function () {
            e.isValid() && (i.execute("mediaEmbed", e.url), s());
          }), t.on("change:isOpen", function () {
            return e.resetFormStatus();
          }), t.on("cancel", function () {
            return s();
          });
        }
      }, {
        key: "_setUpForm",
        value: function _setUpForm(t, e, n) {
          t.delegate("submit", "cancel").to(e), t.urlInputView.bind("value").to(n, "value"), t.urlInputView.bind("isReadOnly").to(n, "isEnabled", function (t) {
            return !t;
          }), t.saveButtonView.bind("isEnabled").to(n);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [xg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbedUI";
        }
      }]);

      return Sg;
    }(Ql);

    n(120);

    var Eg =
    /*#__PURE__*/
    function (_Ql65) {
      _inherits(Eg, _Ql65);

      function Eg() {
        _classCallCheck(this, Eg);

        return _possibleConstructorReturn(this, _getPrototypeOf(Eg).apply(this, arguments));
      }

      _createClass(Eg, null, [{
        key: "requires",
        get: function get() {
          return [xg, Sg, Cg, Ih];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbed";
        }
      }]);

      return Eg;
    }(Ql);

    function Ig(t) {
      return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
        return 1 === e.length ? " " : Array(e.length + 1).join("  ").substr(0, e.length);
      });
    }

    function Ng(t) {
      var e = new DOMParser(),
          n = function (t) {
        return Ig(Ig(t)).replace(/(<span style=['"]mso-spacerun:yes['"]>[\s]*?)[\r\n]+(\s*<\/span>)/g, "$1$2").replace(/<span style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/>(\s*[\r\n]\s*)</g, "><");
      }(function (t) {
        var e = t.match(/<\/body>(.*?)(<\/html>|$)/);
        e && e[1] && (t = t.slice(0, e.index) + t.slice(e.index).replace(e[1], ""));
        return t;
      }(t = t.replace(/<!--\[if gte vml 1]>/g, ""))),
          i = e.parseFromString(n, "text/html");

      !function (t) {
        t.querySelectorAll("span[style*=spacerun]").forEach(function (t) {
          var e = t.childNodes[0].data.length;
          t.innerHTML = Array(e + 1).join("  ").substr(0, e);
        });
      }(i);

      var o = i.body.innerHTML,
          r = function (t) {
        var e = new rr({
          blockFiller: jo
        }),
            n = t.createDocumentFragment(),
            i = t.body.childNodes;

        for (; i.length > 0;) {
          n.appendChild(i[0]);
        }

        return e.domToView(n);
      }(i),
          s = function (t) {
        var e = [],
            n = [],
            i = Array.from(t.getElementsByTagName("style"));

        for (var _i196 = 0, _i195 = i; _i196 < _i195.length; _i196++) {
          var _t293 = _i195[_i196];
          _t293.sheet && _t293.sheet.cssRules && _t293.sheet.cssRules.length && (e.push(_t293.sheet), n.push(_t293.innerHTML));
        }

        return {
          styles: e,
          stylesString: n.join(" ")
        };
      }(i);

      return {
        body: r,
        bodyString: o,
        styles: s.styles,
        stylesString: s.stylesString
      };
    }

    function Og(t, e) {
      if (!t.childCount) return;

      var n = new Sf(),
          i = function (t, e) {
        var n = e.createRangeIn(t),
            i = new bi({
          name: /^p|h\d+$/,
          styles: {
            "mso-list": /.*/
          }
        }),
            o = [];
        var _iteratorNormalCompletion326 = true;
        var _didIteratorError326 = false;
        var _iteratorError326 = undefined;

        try {
          for (var _iterator326 = n[Symbol.iterator](), _step326; !(_iteratorNormalCompletion326 = (_step326 = _iterator326.next()).done); _iteratorNormalCompletion326 = true) {
            var _t294 = _step326.value;

            if ("elementStart" === _t294.type && i.match(_t294.item)) {
              var _e250 = Rg(_t294.item);

              o.push({
                element: _t294.item,
                id: _e250.id,
                order: _e250.order,
                indent: _e250.indent
              });
            }
          }
        } catch (err) {
          _didIteratorError326 = true;
          _iteratorError326 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion326 && _iterator326.return != null) {
              _iterator326.return();
            }
          } finally {
            if (_didIteratorError326) {
              throw _iteratorError326;
            }
          }
        }

        return o;
      }(t, n);

      if (!i.length) return;
      var o = null;
      i.forEach(function (t, r) {
        if (!o || function (t, e) {
          if (t.id !== e.id) return !0;
          var n = e.element.previousSibling;
          if (!n) return !0;
          return !n.is("ul") && !n.is("ol");
        }(i[r - 1], t)) {
          var _i197 = function (t, e) {
            var n = /mso-level-number-format:([^;]*);/gi,
                i = new RegExp("@list l".concat(t.id, ":level").concat(t.indent, "\\s*({[^}]*)"), "gi").exec(e);
            var o = "decimal";

            if (i && i[1]) {
              var _t295 = n.exec(i[1]);

              _t295 && _t295[1] && (o = _t295[1].trim());
            }

            return {
              type: "bullet" !== o && "image" !== o ? "ol" : "ul",
              style: o
            };
          }(t, e);

          o = function (t, e, n) {
            var i = new _i(t.type),
                o = e.parent.getChildIndex(e);
            return n.insertChild(o, i, e.parent), i;
          }(_i197, t.element, n);
        }

        var s = function (t, e) {
          return function (t, e) {
            var n = new bi({
              name: "span",
              styles: {
                "mso-list": "Ignore"
              }
            }),
                i = e.createRangeIn(t);
            var _iteratorNormalCompletion327 = true;
            var _didIteratorError327 = false;
            var _iteratorError327 = undefined;

            try {
              for (var _iterator327 = i[Symbol.iterator](), _step327; !(_iteratorNormalCompletion327 = (_step327 = _iterator327.next()).done); _iteratorNormalCompletion327 = true) {
                var _t296 = _step327.value;
                "elementStart" === _t296.type && n.match(_t296.item) && e.remove(_t296.item);
              }
            } catch (err) {
              _didIteratorError327 = true;
              _iteratorError327 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion327 && _iterator327.return != null) {
                  _iterator327.return();
                }
              } finally {
                if (_didIteratorError327) {
                  throw _iteratorError327;
                }
              }
            }
          }(t, e), e.rename("li", t);
        }(t.element, n);

        n.appendChild(s, o);
      });
    }

    function Rg(t) {
      var e = {},
          n = t.getStyle("mso-list");
      return n && (e.id = parseInt(n.match(/(^|\s+)l(\d+)/i)[2]), e.order = parseInt(n.match(/\s*lfo(\d+)/i)[1]), e.indent = parseInt(n.match(/\s*level(\d+)/i)[1])), e;
    }

    function Dg(t, e) {
      if (!t.childCount) return;
      var n = new Sf();
      !function (t, e, n) {
        var i = n.createRangeIn(e),
            o = new bi({
          name: "img"
        }),
            r = [];
        var _iteratorNormalCompletion328 = true;
        var _didIteratorError328 = false;
        var _iteratorError328 = undefined;

        try {
          for (var _iterator328 = i[Symbol.iterator](), _step328; !(_iteratorNormalCompletion328 = (_step328 = _iterator328.next()).done); _iteratorNormalCompletion328 = true) {
            var _e251 = _step328.value;

            if (o.match(_e251.item)) {
              var _n229 = _e251.item,
                  _i199 = _n229.getAttribute("v:shapes") ? _n229.getAttribute("v:shapes").split(" ") : [];

              _i199.length && _i199.every(function (e) {
                return t.indexOf(e) > -1;
              }) ? r.push(_n229) : _n229.getAttribute("src") || r.push(_n229);
            }
          }
        } catch (err) {
          _didIteratorError328 = true;
          _iteratorError328 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion328 && _iterator328.return != null) {
              _iterator328.return();
            }
          } finally {
            if (_didIteratorError328) {
              throw _iteratorError328;
            }
          }
        }

        for (var _i198 = 0, _r49 = r; _i198 < _r49.length; _i198++) {
          var _t297 = _r49[_i198];
          n.remove(_t297);
        }
      }(function (t, e) {
        var n = e.createRangeIn(t),
            i = new bi({
          name: /v:(.+)/
        }),
            o = [];
        var _iteratorNormalCompletion329 = true;
        var _didIteratorError329 = false;
        var _iteratorError329 = undefined;

        try {
          for (var _iterator329 = n[Symbol.iterator](), _step329; !(_iteratorNormalCompletion329 = (_step329 = _iterator329.next()).done); _iteratorNormalCompletion329 = true) {
            var _t298 = _step329.value;

            var _e252 = _t298.item,
                _n230 = _e252.previousSibling && _e252.previousSibling.name || null;

            i.match(_e252) && _e252.getAttribute("o:gfxdata") && "v:shapetype" !== _n230 && o.push(_t298.item.getAttribute("id"));
          }
        } catch (err) {
          _didIteratorError329 = true;
          _iteratorError329 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion329 && _iterator329.return != null) {
              _iterator329.return();
            }
          } finally {
            if (_didIteratorError329) {
              throw _iteratorError329;
            }
          }
        }

        return o;
      }(t, n), t, n), function (t, e) {
        var n = e.createRangeIn(t),
            i = new bi({
          name: /v:(.+)/
        }),
            o = [];
        var _iteratorNormalCompletion330 = true;
        var _didIteratorError330 = false;
        var _iteratorError330 = undefined;

        try {
          for (var _iterator330 = n[Symbol.iterator](), _step330; !(_iteratorNormalCompletion330 = (_step330 = _iterator330.next()).done); _iteratorNormalCompletion330 = true) {
            var _t299 = _step330.value;
            i.match(_t299.item) && o.push(_t299.item);
          }
        } catch (err) {
          _didIteratorError330 = true;
          _iteratorError330 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion330 && _iterator330.return != null) {
              _iterator330.return();
            }
          } finally {
            if (_didIteratorError330) {
              throw _iteratorError330;
            }
          }
        }

        for (var _i200 = 0, _o92 = o; _i200 < _o92.length; _i200++) {
          var _t300 = _o92[_i200];
          e.remove(_t300);
        }
      }(t, n);

      var i = function (t, e) {
        var n = e.createRangeIn(t),
            i = new bi({
          name: "img"
        }),
            o = [];
        var _iteratorNormalCompletion331 = true;
        var _didIteratorError331 = false;
        var _iteratorError331 = undefined;

        try {
          for (var _iterator331 = n[Symbol.iterator](), _step331; !(_iteratorNormalCompletion331 = (_step331 = _iterator331.next()).done); _iteratorNormalCompletion331 = true) {
            var _t301 = _step331.value;
            i.match(_t301.item) && _t301.item.getAttribute("src").startsWith("file://") && o.push(_t301.item);
          }
        } catch (err) {
          _didIteratorError331 = true;
          _iteratorError331 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion331 && _iterator331.return != null) {
              _iterator331.return();
            }
          } finally {
            if (_didIteratorError331) {
              throw _iteratorError331;
            }
          }
        }

        return o;
      }(t, n);

      i.length && function (t, e, n) {
        if (t.length === e.length) for (var _i201 = 0; _i201 < t.length; _i201++) {
          var _o93 = "data:".concat(e[_i201].type, ";base64,").concat(Lg(e[_i201].hex));

          n.setAttribute("src", _o93, t[_i201]);
        }
      }(i, function (t) {
        if (!t) return [];
        var e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
            n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g"),
            i = t.match(n),
            o = [];

        if (i) {
          var _iteratorNormalCompletion332 = true;
          var _didIteratorError332 = false;
          var _iteratorError332 = undefined;

          try {
            for (var _iterator332 = i[Symbol.iterator](), _step332; !(_iteratorNormalCompletion332 = (_step332 = _iterator332.next()).done); _iteratorNormalCompletion332 = true) {
              var _t302 = _step332.value;

              var _n231 = !1;

              _t302.includes("\\pngblip") ? _n231 = "image/png" : _t302.includes("\\jpegblip") && (_n231 = "image/jpeg"), _n231 && o.push({
                hex: _t302.replace(e, "").replace(/[^\da-fA-F]/g, ""),
                type: _n231
              });
            }
          } catch (err) {
            _didIteratorError332 = true;
            _iteratorError332 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion332 && _iterator332.return != null) {
                _iterator332.return();
              }
            } finally {
              if (_didIteratorError332) {
                throw _iteratorError332;
              }
            }
          }
        }

        return o;
      }(e), n);
    }

    function Lg(t) {
      return btoa(t.match(/\w{2}/g).map(function (t) {
        return String.fromCharCode(parseInt(t, 16));
      }).join(""));
    }

    var jg =
    /*#__PURE__*/
    function (_Ql66) {
      _inherits(jg, _Ql66);

      function jg() {
        _classCallCheck(this, jg);

        return _possibleConstructorReturn(this, _getPrototypeOf(jg).apply(this, arguments));
      }

      _createClass(jg, [{
        key: "init",
        value: function init() {
          var _this231 = this;

          var t = this.editor;
          this.listenTo(t.plugins.get("Clipboard"), "inputTransformation", function (t, e) {
            var n = e.dataTransfer.getData("text/html");
            !0 !== e.pasteFromOfficeProcessed && function (t) {
              return !(!t || !t.match(/<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/gi) && !t.match(/xmlns:o="urn:schemas-microsoft-com/gi));
            }(n) && (e.content = _this231._normalizeWordInput(n, e.dataTransfer), e.pasteFromOfficeProcessed = !0);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_normalizeWordInput",
        value: function _normalizeWordInput(t, e) {
          var _Ng = Ng(t),
              n = _Ng.body,
              i = _Ng.stylesString;

          return Og(n, i), Dg(n, e.getData("text/rtf")), n;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PasteFromOffice";
        }
      }]);

      return jg;
    }(Ql);

    function Vg(t, e) {
      var n = e.parent;

      for (; n;) {
        if (n.name === t) return n;
        n = n.parent;
      }
    }

    function Bg(t, e, n, i) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      e > o ? i.setAttribute(t, e, n) : i.removeAttribute(t, n);
    }

    function zg(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = t.createElement("tableCell", n);
      t.insertElement("paragraph", i), t.insert(i, e);
    }

    function Fg() {
      return function (t) {
        t.on("element:table", function (t, e, n) {
          var i = e.viewItem;
          if (!n.consumable.test(i, {
            name: !0
          })) return;

          var _ref104 = function (t) {
            var e = {
              headingRows: 0,
              headingColumns: 0
            },
                n = [],
                i = [];
            var o;

            for (var _i202 = 0, _Array$from7 = Array.from(t.getChildren()); _i202 < _Array$from7.length; _i202++) {
              var _r50 = _Array$from7[_i202];

              if ("tbody" === _r50.name || "thead" === _r50.name || "tfoot" === _r50.name) {
                "thead" !== _r50.name || o || (o = _r50);

                var _t303 = Array.from(_r50.getChildren()).filter(function (t) {
                  return t.is("element", "tr");
                });

                var _iteratorNormalCompletion333 = true;
                var _didIteratorError333 = false;
                var _iteratorError333 = undefined;

                try {
                  for (var _iterator333 = _t303[Symbol.iterator](), _step333; !(_iteratorNormalCompletion333 = (_step333 = _iterator333.next()).done); _iteratorNormalCompletion333 = true) {
                    var _r51 = _step333.value;
                    if ("thead" === _r51.parent.name && _r51.parent === o) e.headingRows++, n.push(_r51);else {
                      i.push(_r51);

                      var _t304 = Hg(_r51);

                      _t304 > e.headingColumns && (e.headingColumns = _t304);
                    }
                  }
                } catch (err) {
                  _didIteratorError333 = true;
                  _iteratorError333 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion333 && _iterator333.return != null) {
                      _iterator333.return();
                    }
                  } finally {
                    if (_didIteratorError333) {
                      throw _iteratorError333;
                    }
                  }
                }
              }
            }

            return e.rows = [].concat(n, i), e;
          }(i),
              o = _ref104.rows,
              r = _ref104.headingRows,
              s = _ref104.headingColumns,
              a = {};

          s && (a.headingColumns = s), r && (a.headingRows = r);
          var c = n.writer.createElement("table", a),
              l = n.splitToAllowedParent(c, e.modelCursor);

          if (l) {
            if (n.writer.insert(c, l.position), n.consumable.consume(i, {
              name: !0
            }), o.length) o.forEach(function (t) {
              return n.convertItem(t, n.writer.createPositionAt(c, "end"));
            });else {
              var _t305 = n.writer.createElement("tableRow");

              n.writer.insert(_t305, n.writer.createPositionAt(c, "end")), zg(n.writer, n.writer.createPositionAt(_t305, "end"));
            }
            e.modelRange = n.writer.createRange(n.writer.createPositionBefore(c), n.writer.createPositionAfter(c)), l.cursorParent ? e.modelCursor = n.writer.createPositionAt(l.cursorParent, 0) : e.modelCursor = e.modelRange.end;
          }
        });
      };
    }

    function Ug(t) {
      return function (e) {
        e.on("element:".concat(t), function (t, e, n) {
          var i = e.viewItem;
          if (!n.consumable.test(i, {
            name: !0
          })) return;
          var o = n.writer.createElement("tableCell"),
              r = n.splitToAllowedParent(o, e.modelCursor);
          if (!r) return;
          n.writer.insert(o, r.position), n.consumable.consume(i, {
            name: !0
          });
          var s = n.writer.createPositionAt(o, 0);
          n.convertChildren(i, s), o.childCount || n.writer.insertElement("paragraph", s), e.modelRange = n.writer.createRange(n.writer.createPositionBefore(o), n.writer.createPositionAfter(o)), e.modelCursor = e.modelRange.end;
        });
      };
    }

    function Hg(t) {
      var e = 0,
          n = 0;
      var i = Array.from(t.getChildren()).filter(function (t) {
        return "th" === t.name || "td" === t.name;
      });

      for (; n < i.length && "th" === i[n].name;) {
        var _t306 = i[n];
        e += parseInt(_t306.getAttribute("colspan") || 1), n++;
      }

      return e;
    }

    var qg =
    /*#__PURE__*/
    function () {
      function qg(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, qg);

        this.table = t, this.startRow = e.startRow || 0, this.endRow = "number" == typeof e.endRow ? e.endRow : void 0, this.includeSpanned = !!e.includeSpanned, this.column = "number" == typeof e.column ? e.column : void 0, this._skipRows = new Set(), this._row = 0, this._column = 0, this._cell = 0, this._spannedCells = new Map();
      }

      _createClass(qg, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "next",
        value: function next() {
          var t = this.table.getChild(this._row);
          if (!t || this._isOverEndRow()) return {
            done: !0
          };

          if (this._isSpanned(this._row, this._column)) {
            var _t307 = this._column,
                _e253 = this._formatOutValue(void 0, _t307);

            return this._column++, !this.includeSpanned || this._shouldSkipRow() || this._shouldSkipColumn(_t307, 1) ? this.next() : _e253;
          }

          var e = t.getChild(this._cell);
          if (!e) return this._row++, this._column = 0, this._cell = 0, this.next();
          var n = parseInt(e.getAttribute("colspan") || 1),
              i = parseInt(e.getAttribute("rowspan") || 1);
          (n > 1 || i > 1) && this._recordSpans(this._row, this._column, i, n);

          var o = this._column,
              r = this._formatOutValue(e, o, i, n);

          return this._column++, this._cell++, this._shouldSkipRow() || this._shouldSkipColumn(o, n) ? this.next() : r;
        }
      }, {
        key: "skipRow",
        value: function skipRow(t) {
          this._skipRows.add(t);
        }
      }, {
        key: "_isOverEndRow",
        value: function _isOverEndRow() {
          return void 0 !== this.endRow && this._row > this.endRow;
        }
      }, {
        key: "_formatOutValue",
        value: function _formatOutValue(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
          return {
            done: !1,
            value: {
              cell: t,
              row: this._row,
              column: e,
              rowspan: n,
              colspan: i,
              cellIndex: this._cell
            }
          };
        }
      }, {
        key: "_shouldSkipRow",
        value: function _shouldSkipRow() {
          var t = this._row < this.startRow,
              e = this._skipRows.has(this._row);

          return t || e;
        }
      }, {
        key: "_shouldSkipColumn",
        value: function _shouldSkipColumn(t, e) {
          if (void 0 === this.column) return !1;
          var n = t === this.column,
              i = t < this.column && t + e > this.column;
          return !n && !i;
        }
      }, {
        key: "_isSpanned",
        value: function _isSpanned(t, e) {
          if (!this._spannedCells.has(t)) return !1;
          return this._spannedCells.get(t).has(e);
        }
      }, {
        key: "_recordSpans",
        value: function _recordSpans(t, e, n, i) {
          for (var _n232 = e + 1; _n232 <= e + i - 1; _n232++) {
            this._markSpannedCell(t, _n232);
          }

          for (var _o94 = t + 1; _o94 < t + n; _o94++) {
            for (var _t308 = e; _t308 <= e + i - 1; _t308++) {
              this._markSpannedCell(_o94, _t308);
            }
          }
        }
      }, {
        key: "_markSpannedCell",
        value: function _markSpannedCell(t, e) {
          this._spannedCells.has(t) || this._spannedCells.set(t, new Map()), this._spannedCells.get(t).set(e, !0);
        }
      }]);

      return qg;
    }();

    function Wg(t) {
      return !!t.getCustomProperty("table") && gh(t);
    }

    function Yg(t) {
      var e = t.getSelectedElement();
      return e && Wg(e) ? e : null;
    }

    function $g(t) {
      var e = Vg("table", t.getFirstPosition());
      return e && Wg(e.parent) ? e.parent : null;
    }

    function Gg() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:table", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          i.consumable.consume(o, "attribute:headingRows:table"), i.consumable.consume(o, "attribute:headingColumns:table");
          var r = t && t.asWidget,
              s = i.writer.createContainerElement("figure", {
            class: "table"
          }),
              a = i.writer.createContainerElement("table");
          var c;
          i.writer.insert(i.writer.createPositionAt(s, 0), a), r && (c = function (t, e) {
            return e.setCustomProperty("table", !0, t), bh(t, e, {
              hasSelectionHandler: !0
            });
          }(s, i.writer));
          var l = new qg(o),
              d = {
            headingRows: o.getAttribute("headingRows") || 0,
            headingColumns: o.getAttribute("headingColumns") || 0
          },
              u = new Map();
          var _iteratorNormalCompletion334 = true;
          var _didIteratorError334 = false;
          var _iteratorError334 = undefined;

          try {
            for (var _iterator334 = l[Symbol.iterator](), _step334; !(_iteratorNormalCompletion334 = (_step334 = _iterator334.next()).done); _iteratorNormalCompletion334 = true) {
              var _e254 = _step334.value;

              var _n233 = _e254.row,
                  _r52 = _e254.cell,
                  _s31 = rb(ob(_n233, d), a, i),
                  _c11 = o.getChild(_n233),
                  _l5 = u.get(_n233) || nb(_c11, _n233, _s31, i);

              u.set(_n233, _l5), i.consumable.consume(_r52, "insert"), eb(_e254, d, i.writer.createPositionAt(_l5, "end"), i, t);
            }
          } catch (err) {
            _didIteratorError334 = true;
            _iteratorError334 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion334 && _iterator334.return != null) {
                _iterator334.return();
              }
            } finally {
              if (_didIteratorError334) {
                throw _iteratorError334;
              }
            }
          }

          var h = i.mapper.toViewPosition(n.range.start);
          i.mapper.bindElements(o, r ? c : s), i.writer.insert(h, r ? c : s);
        });
      };
    }

    function Qg() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:tableRow", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          var r = o.parent,
              s = lb(i.mapper.toViewElement(r)),
              a = r.getChildIndex(o),
              c = new qg(r, {
            startRow: a,
            endRow: a
          }),
              l = {
            headingRows: r.getAttribute("headingRows") || 0,
            headingColumns: r.getAttribute("headingColumns") || 0
          },
              d = new Map();
          var _iteratorNormalCompletion335 = true;
          var _didIteratorError335 = false;
          var _iteratorError335 = undefined;

          try {
            for (var _iterator335 = c[Symbol.iterator](), _step335; !(_iteratorNormalCompletion335 = (_step335 = _iterator335.next()).done); _iteratorNormalCompletion335 = true) {
              var _e255 = _step335.value;

              var _n234 = rb(ob(a, l), s, i),
                  _r53 = d.get(a) || nb(o, a, _n234, i);

              d.set(a, _r53), i.consumable.consume(_e255.cell, "insert"), eb(_e255, l, i.writer.createPositionAt(_r53, "end"), i, t);
            }
          } catch (err) {
            _didIteratorError335 = true;
            _iteratorError335 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion335 && _iterator335.return != null) {
                _iterator335.return();
              }
            } finally {
              if (_didIteratorError335) {
                throw _iteratorError335;
              }
            }
          }
        });
      };
    }

    function Jg() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:tableCell", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          var r = o.parent,
              s = r.parent,
              a = s.getChildIndex(r),
              c = new qg(s, {
            startRow: a,
            endRow: a
          }),
              l = {
            headingRows: s.getAttribute("headingRows") || 0,
            headingColumns: s.getAttribute("headingColumns") || 0
          };
          var _iteratorNormalCompletion336 = true;
          var _didIteratorError336 = false;
          var _iteratorError336 = undefined;

          try {
            for (var _iterator336 = c[Symbol.iterator](), _step336; !(_iteratorNormalCompletion336 = (_step336 = _iterator336.next()).done); _iteratorNormalCompletion336 = true) {
              var _e256 = _step336.value;

              if (_e256.cell === o) {
                var _n235 = i.mapper.toViewElement(r);

                return void eb(_e256, l, i.writer.createPositionAt(_n235, r.getChildIndex(o)), i, t);
              }
            }
          } catch (err) {
            _didIteratorError336 = true;
            _iteratorError336 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion336 && _iterator336.return != null) {
                _iterator336.return();
              }
            } finally {
              if (_didIteratorError336) {
                throw _iteratorError336;
              }
            }
          }
        });
      };
    }

    function Kg() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = !!t.asWidget;
      return function (t) {
        return t.on("attribute:headingRows:table", function (t, n, i) {
          var o = n.item;
          if (!i.consumable.consume(n.item, t.name)) return;
          var r = lb(i.mapper.toViewElement(o)),
              s = n.attributeOldValue,
              a = n.attributeNewValue;

          if (a > s) {
            var _t309 = Array.from(o.getChildren()).filter(function (_ref105) {
              var t = _ref105.index;
              return c(t, s - 1, a);
            });

            cb(_t309, rb("thead", r, i), i, "end");
            var _iteratorNormalCompletion337 = true;
            var _didIteratorError337 = false;
            var _iteratorError337 = undefined;

            try {
              for (var _iterator337 = _t309[Symbol.iterator](), _step337; !(_iteratorNormalCompletion337 = (_step337 = _iterator337.next()).done); _iteratorNormalCompletion337 = true) {
                var _n236 = _step337.value;
                var _iteratorNormalCompletion338 = true;
                var _didIteratorError338 = false;
                var _iteratorError338 = undefined;

                try {
                  for (var _iterator338 = _n236.getChildren()[Symbol.iterator](), _step338; !(_iteratorNormalCompletion338 = (_step338 = _iterator338.next()).done); _iteratorNormalCompletion338 = true) {
                    var _t310 = _step338.value;
                    Xg(_t310, "th", i, e);
                  }
                } catch (err) {
                  _didIteratorError338 = true;
                  _iteratorError338 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion338 && _iterator338.return != null) {
                      _iterator338.return();
                    }
                  } finally {
                    if (_didIteratorError338) {
                      throw _iteratorError338;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError337 = true;
              _iteratorError337 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion337 && _iterator337.return != null) {
                  _iterator337.return();
                }
              } finally {
                if (_didIteratorError337) {
                  throw _iteratorError337;
                }
              }
            }

            ab("tbody", r, i);
          } else {
            cb(Array.from(o.getChildren()).filter(function (_ref106) {
              var t = _ref106.index;
              return c(t, a - 1, s);
            }).reverse(), rb("tbody", r, i), i, 0);

            var _t311 = new qg(o, {
              startRow: a ? a - 1 : a,
              endRow: s - 1
            }),
                _n237 = {
              headingRows: o.getAttribute("headingRows") || 0,
              headingColumns: o.getAttribute("headingColumns") || 0
            };

            var _iteratorNormalCompletion339 = true;
            var _didIteratorError339 = false;
            var _iteratorError339 = undefined;

            try {
              for (var _iterator339 = _t311[Symbol.iterator](), _step339; !(_iteratorNormalCompletion339 = (_step339 = _iterator339.next()).done); _iteratorNormalCompletion339 = true) {
                var _o95 = _step339.value;
                tb(_o95, _n237, i, e);
              }
            } catch (err) {
              _didIteratorError339 = true;
              _iteratorError339 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion339 && _iterator339.return != null) {
                  _iterator339.return();
                }
              } finally {
                if (_didIteratorError339) {
                  throw _iteratorError339;
                }
              }
            }

            ab("thead", r, i);
          }

          function c(t, e, n) {
            return t > e && t < n;
          }
        });
      };
    }

    function Zg() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = !!t.asWidget;
      return function (t) {
        return t.on("attribute:headingColumns:table", function (t, n, i) {
          var o = n.item;
          if (!i.consumable.consume(n.item, t.name)) return;
          var r = {
            headingRows: o.getAttribute("headingRows") || 0,
            headingColumns: o.getAttribute("headingColumns") || 0
          },
              s = n.attributeOldValue,
              a = n.attributeNewValue,
              c = (s > a ? s : a) - 1;
          var _iteratorNormalCompletion340 = true;
          var _didIteratorError340 = false;
          var _iteratorError340 = undefined;

          try {
            for (var _iterator340 = new qg(o)[Symbol.iterator](), _step340; !(_iteratorNormalCompletion340 = (_step340 = _iterator340.next()).done); _iteratorNormalCompletion340 = true) {
              var _t312 = _step340.value;
              _t312.column > c || tb(_t312, r, i, e);
            }
          } catch (err) {
            _didIteratorError340 = true;
            _iteratorError340 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion340 && _iterator340.return != null) {
                _iterator340.return();
              }
            } finally {
              if (_didIteratorError340) {
                throw _iteratorError340;
              }
            }
          }
        });
      };
    }

    function Xg(t, e, n, i) {
      var o = n.writer,
          r = n.mapper.toViewElement(t);
      if (!r) return;
      var s;

      if (i) {
        s = _h(o.createEditableElement(e, r.getAttributes()), o), o.insert(o.createPositionAfter(r), s), o.move(o.createRangeIn(r), o.createPositionAt(s, 0)), o.remove(o.createRangeOn(r));
      } else s = o.rename(e, r);

      n.mapper.bindElements(t, s);
    }

    function tb(t, e, n, i) {
      var o = t.cell,
          r = ib(t, e),
          s = n.mapper.toViewElement(o);
      s && s.name !== r && Xg(o, r, n, i);
    }

    function eb(t, e, n, i, o) {
      var r = o && o.asWidget,
          s = ib(t, e),
          a = r ? _h(i.writer.createEditableElement(s), i.writer) : i.writer.createContainerElement(s),
          c = t.cell,
          l = c.getChild(0),
          d = 1 === c.childCount && "paragraph" === l.name;

      if (i.writer.insert(n, a), d && !function (t) {
        return !!_toConsumableArray(t.getAttributeKeys()).length;
      }(l)) {
        var _t313 = c.getChild(0),
            _e257 = i.writer.createPositionAt(a, "end");

        if (i.consumable.consume(_t313, "insert"), o.asWidget) {
          var _n238 = i.writer.createContainerElement("span");

          i.mapper.bindElements(_t313, _n238), i.writer.insert(_e257, _n238), i.mapper.bindElements(c, a);
        } else i.mapper.bindElements(c, a), i.mapper.bindElements(_t313, a);
      } else i.mapper.bindElements(c, a);
    }

    function nb(t, e, n, i) {
      i.consumable.consume(t, "insert");
      var o = i.writer.createContainerElement("tr");
      i.mapper.bindElements(t, o);
      var r = t.parent.getAttribute("headingRows") || 0,
          s = r > 0 && e >= r ? e - r : e,
          a = i.writer.createPositionAt(n, s);
      return i.writer.insert(a, o), o;
    }

    function ib(t, e) {
      var n = t.row,
          i = t.column,
          o = e.headingColumns,
          r = e.headingRows;
      return r && r > n ? "th" : o && o > i ? "th" : "td";
    }

    function ob(t, e) {
      return t < e.headingRows ? "thead" : "tbody";
    }

    function rb(t, e, n) {
      var i = sb(t, e);
      return i || function (t, e, n) {
        var i = n.writer.createContainerElement(t),
            o = n.writer.createPositionAt(e, "tbody" == t ? "end" : 0);
        return n.writer.insert(o, i), i;
      }(t, e, n);
    }

    function sb(t, e) {
      var _iteratorNormalCompletion341 = true;
      var _didIteratorError341 = false;
      var _iteratorError341 = undefined;

      try {
        for (var _iterator341 = e.getChildren()[Symbol.iterator](), _step341; !(_iteratorNormalCompletion341 = (_step341 = _iterator341.next()).done); _iteratorNormalCompletion341 = true) {
          var _n239 = _step341.value;
          if (_n239.name == t) return _n239;
        }
      } catch (err) {
        _didIteratorError341 = true;
        _iteratorError341 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion341 && _iterator341.return != null) {
            _iterator341.return();
          }
        } finally {
          if (_didIteratorError341) {
            throw _iteratorError341;
          }
        }
      }
    }

    function ab(t, e, n) {
      var i = sb(t, e);
      i && 0 === i.childCount && n.writer.remove(n.writer.createRangeOn(i));
    }

    function cb(t, e, n, i) {
      var _iteratorNormalCompletion342 = true;
      var _didIteratorError342 = false;
      var _iteratorError342 = undefined;

      try {
        for (var _iterator342 = t[Symbol.iterator](), _step342; !(_iteratorNormalCompletion342 = (_step342 = _iterator342.next()).done); _iteratorNormalCompletion342 = true) {
          var _o96 = _step342.value;

          var _t314 = n.mapper.toViewElement(_o96);

          _t314 && n.writer.move(n.writer.createRangeOn(_t314), n.writer.createPositionAt(e, i));
        }
      } catch (err) {
        _didIteratorError342 = true;
        _iteratorError342 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion342 && _iterator342.return != null) {
            _iterator342.return();
          }
        } finally {
          if (_didIteratorError342) {
            throw _iteratorError342;
          }
        }
      }
    }

    function lb(t) {
      var _iteratorNormalCompletion343 = true;
      var _didIteratorError343 = false;
      var _iteratorError343 = undefined;

      try {
        for (var _iterator343 = t.getChildren()[Symbol.iterator](), _step343; !(_iteratorNormalCompletion343 = (_step343 = _iterator343.next()).done); _iteratorNormalCompletion343 = true) {
          var _e258 = _step343.value;
          if ("table" === _e258.name) return _e258;
        }
      } catch (err) {
        _didIteratorError343 = true;
        _iteratorError343 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion343 && _iterator343.return != null) {
            _iterator343.return();
          }
        } finally {
          if (_didIteratorError343) {
            throw _iteratorError343;
          }
        }
      }
    }

    var db =
    /*#__PURE__*/
    function (_td20) {
      _inherits(db, _td20);

      function db() {
        _classCallCheck(this, db);

        return _possibleConstructorReturn(this, _getPrototypeOf(db).apply(this, arguments));
      }

      _createClass(db, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema,
              i = function (t) {
            var e = t.parent;
            return e === e.root ? e : e.parent;
          }(e.getFirstPosition());

          this.isEnabled = n.checkChild(i, "table");
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document.selection,
              i = this.editor.plugins.get("TableUtils"),
              o = parseInt(t.rows) || 2,
              r = parseInt(t.columns) || 2,
              s = kh(n, e);
          e.change(function (t) {
            var n = i.createTable(t, o, r);
            e.insertContent(n, s), t.setSelection(t.createPositionAt(n.getNodeByPath([0, 0, 0]), 0));
          });
        }
      }]);

      return db;
    }(td);

    var ub =
    /*#__PURE__*/
    function (_td21) {
      _inherits(ub, _td21);

      function ub(t) {
        var _this232;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, ub);

        _this232 = _possibleConstructorReturn(this, _getPrototypeOf(ub).call(this, t)), _this232.order = e.order || "below";
        return _this232;
      }

      _createClass(ub, [{
        key: "refresh",
        value: function refresh() {
          var t = Vg("table", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = Vg("tableCell", e.getFirstPosition()).parent,
              o = i.parent,
              r = o.getChildIndex(i),
              s = "below" === this.order ? r + 1 : r;
          n.insertRows(o, {
            rows: 1,
            at: s
          });
        }
      }]);

      return ub;
    }(td);

    var hb =
    /*#__PURE__*/
    function (_td22) {
      _inherits(hb, _td22);

      function hb(t) {
        var _this233;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, hb);

        _this233 = _possibleConstructorReturn(this, _getPrototypeOf(hb).call(this, t)), _this233.order = e.order || "right";
        return _this233;
      }

      _createClass(hb, [{
        key: "refresh",
        value: function refresh() {
          var t = Vg("table", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = Vg("tableCell", e.getFirstPosition()),
              o = i.parent.parent,
              _n$getCellLocation = n.getCellLocation(i),
              r = _n$getCellLocation.column,
              s = "right" === this.order ? r + 1 : r;

          n.insertColumns(o, {
            columns: 1,
            at: s
          });
        }
      }]);

      return hb;
    }(td);

    var fb =
    /*#__PURE__*/
    function (_td23) {
      _inherits(fb, _td23);

      function fb(t) {
        var _this234;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, fb);

        _this234 = _possibleConstructorReturn(this, _getPrototypeOf(fb).call(this, t)), _this234.direction = e.direction || "horizontally";
        return _this234;
      }

      _createClass(fb, [{
        key: "refresh",
        value: function refresh() {
          var t = Vg("tableCell", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = Vg("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = "horizontally" === this.direction,
              n = this.editor.plugins.get("TableUtils");
          e ? n.splitCellHorizontally(t, 2) : n.splitCellVertically(t, 2);
        }
      }]);

      return fb;
    }(td);

    var mb =
    /*#__PURE__*/
    function (_td24) {
      _inherits(mb, _td24);

      function mb(t, e) {
        var _this235;

        _classCallCheck(this, mb);

        _this235 = _possibleConstructorReturn(this, _getPrototypeOf(mb).call(this, t)), _this235.direction = e.direction, _this235.isHorizontal = "right" == _this235.direction || "left" == _this235.direction;
        return _this235;
      }

      _createClass(mb, [{
        key: "refresh",
        value: function refresh() {
          var t = this._getMergeableCell();

          this.isEnabled = !!t, this.value = t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this236 = this;

          var t = this.editor.model,
              e = Vg("tableCell", t.document.selection.getFirstPosition()),
              n = this.value,
              i = this.direction;
          t.change(function (t) {
            var o = "right" == i || "down" == i,
                r = o ? e : n,
                s = o ? n : e,
                a = s.parent;
            !function (t, e, n) {
              pb(t) || (pb(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end")));
              n.remove(t);
            }(s, r, t);
            var c = _this236.isHorizontal ? "colspan" : "rowspan",
                l = parseInt(e.getAttribute(c) || 1),
                d = parseInt(n.getAttribute(c) || 1);
            t.setAttribute(c, l + d, r), t.setSelection(t.createRangeIn(r)), a.childCount || function (t, e) {
              var n = t.parent,
                  i = n.getChildIndex(t);
              var _iteratorNormalCompletion344 = true;
              var _didIteratorError344 = false;
              var _iteratorError344 = undefined;

              try {
                for (var _iterator344 = new qg(n, {
                  endRow: i
                })[Symbol.iterator](), _step344; !(_iteratorNormalCompletion344 = (_step344 = _iterator344.next()).done); _iteratorNormalCompletion344 = true) {
                  var _ref108 = _step344.value;
                  var _t315 = _ref108.cell;
                  var _o97 = _ref108.row;
                  var _r54 = _ref108.rowspan;

                  var _n240 = _o97 + _r54 - 1 >= i;

                  _n240 && Bg("rowspan", _r54 - 1, _t315, e);
                }
              } catch (err) {
                _didIteratorError344 = true;
                _iteratorError344 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion344 && _iterator344.return != null) {
                    _iterator344.return();
                  }
                } finally {
                  if (_didIteratorError344) {
                    throw _iteratorError344;
                  }
                }
              }

              e.remove(t);
            }(a, t);
          });
        }
      }, {
        key: "_getMergeableCell",
        value: function _getMergeableCell() {
          var t = Vg("tableCell", this.editor.model.document.selection.getFirstPosition());
          if (!t) return;
          var e = this.editor.plugins.get("TableUtils"),
              n = this.isHorizontal ? function (t, e, n) {
            var i = "right" == e ? t.nextSibling : t.previousSibling;
            if (!i) return;

            var o = "right" == e ? t : i,
                r = "right" == e ? i : t,
                _n$getCellLocation2 = n.getCellLocation(o),
                s = _n$getCellLocation2.column,
                _n$getCellLocation3 = n.getCellLocation(r),
                a = _n$getCellLocation3.column,
                c = parseInt(o.getAttribute("colspan") || 1);

            return s + c === a ? i : void 0;
          }(t, this.direction, e) : function (t, e) {
            var n = t.parent,
                i = n.parent,
                o = i.getChildIndex(n);
            if ("down" == e && o === i.childCount - 1 || "up" == e && 0 === o) return;
            var r = parseInt(t.getAttribute("rowspan") || 1),
                s = i.getAttribute("headingRows") || 0;
            if (s && ("down" == e && o + r === s || "up" == e && o === s)) return;

            var a = parseInt(t.getAttribute("rowspan") || 1),
                c = "down" == e ? o + a : o,
                l = _toConsumableArray(new qg(i, {
              endRow: c
            })),
                d = l.find(function (e) {
              return e.cell === t;
            }).column,
                u = l.find(function (_ref109) {
              var t = _ref109.row,
                  n = _ref109.rowspan,
                  i = _ref109.column;
              return i === d && ("down" == e ? t === c : c === t + n);
            });

            return u && u.cell;
          }(t, this.direction);
          if (!n) return;
          var i = this.isHorizontal ? "rowspan" : "colspan",
              o = parseInt(t.getAttribute(i) || 1);
          return parseInt(n.getAttribute(i) || 1) === o ? n : void 0;
        }
      }]);

      return mb;
    }(td);

    function pb(t) {
      return 1 == t.childCount && t.getChild(0).is("paragraph") && t.getChild(0).isEmpty;
    }

    var gb =
    /*#__PURE__*/
    function (_td25) {
      _inherits(gb, _td25);

      function gb() {
        _classCallCheck(this, gb);

        return _possibleConstructorReturn(this, _getPrototypeOf(gb).apply(this, arguments));
      }

      _createClass(gb, [{
        key: "refresh",
        value: function refresh() {
          var t = Vg("tableCell", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t && t.parent.parent.childCount > 1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
              e = Vg("tableCell", t.document.selection.getFirstPosition()).parent,
              n = e.parent,
              i = n.getChildIndex(e),
              o = n.getAttribute("headingRows") || 0;
          t.change(function (t) {
            o && i <= o && Bg("headingRows", o - 1, n, t, 0);

            var r = _toConsumableArray(new qg(n, {
              endRow: i
            })),
                s = new Map();

            r.filter(function (_ref110) {
              var t = _ref110.row,
                  e = _ref110.rowspan;
              return t === i && e > 1;
            }).forEach(function (_ref111) {
              var t = _ref111.column,
                  e = _ref111.cell,
                  n = _ref111.rowspan;
              return s.set(t, {
                cell: e,
                rowspanToSet: n - 1
              });
            }), r.filter(function (_ref112) {
              var t = _ref112.row,
                  e = _ref112.rowspan;
              return t <= i - 1 && t + e > i;
            }).forEach(function (_ref113) {
              var e = _ref113.cell,
                  n = _ref113.rowspan;
              return Bg("rowspan", n - 1, e, t);
            });
            var a = i + 1,
                c = new qg(n, {
              includeSpanned: !0,
              startRow: a,
              endRow: a
            });
            var l;

            for (var _i203 = 0, _arr2 = _toConsumableArray(c); _i203 < _arr2.length; _i203++) {
              var _ref115 = _arr2[_i203];
              var _e259 = _ref115.row;
              var _i204 = _ref115.column;
              var _o98 = _ref115.cell;

              if (s.has(_i204)) {
                var _s$get = s.get(_i204),
                    _o99 = _s$get.cell,
                    _r55 = _s$get.rowspanToSet,
                    _a20 = l ? t.createPositionAfter(l) : t.createPositionAt(n.getChild(_e259), 0);

                t.move(t.createRangeOn(_o99), _a20), Bg("rowspan", _r55, _o99, t), l = _o99;
              } else l = _o98;
            }

            t.remove(e);
          });
        }
      }]);

      return gb;
    }(td);

    var bb =
    /*#__PURE__*/
    function (_td26) {
      _inherits(bb, _td26);

      function bb() {
        _classCallCheck(this, bb);

        return _possibleConstructorReturn(this, _getPrototypeOf(bb).apply(this, arguments));
      }

      _createClass(bb, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = Vg("tableCell", e.getFirstPosition());
          this.isEnabled = !!i && n.getColumns(i.parent.parent) > 1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
              e = Vg("tableCell", t.document.selection.getFirstPosition()),
              n = e.parent,
              i = n.parent,
              o = i.getAttribute("headingColumns") || 0,
              r = i.getChildIndex(n),
              s = _toConsumableArray(new qg(i)),
              a = s.find(function (t) {
            return t.cell === e;
          }).column;

          t.change(function (t) {
            o && r <= o && t.setAttribute("headingColumns", o - 1, i);
            var _iteratorNormalCompletion345 = true;
            var _didIteratorError345 = false;
            var _iteratorError345 = undefined;

            try {
              for (var _iterator345 = s[Symbol.iterator](), _step345; !(_iteratorNormalCompletion345 = (_step345 = _iterator345.next()).done); _iteratorNormalCompletion345 = true) {
                var _ref117 = _step345.value;
                var _e260 = _ref117.cell;
                var _n241 = _ref117.column;
                var _i205 = _ref117.colspan;
                _n241 <= a && _i205 > 1 && _n241 + _i205 > a ? Bg("colspan", _i205 - 1, _e260, t) : _n241 === a && t.remove(_e260);
              }
            } catch (err) {
              _didIteratorError345 = true;
              _iteratorError345 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion345 && _iterator345.return != null) {
                  _iterator345.return();
                }
              } finally {
                if (_didIteratorError345) {
                  throw _iteratorError345;
                }
              }
            }
          });
        }
      }]);

      return bb;
    }(td);

    var wb =
    /*#__PURE__*/
    function (_td27) {
      _inherits(wb, _td27);

      function wb() {
        _classCallCheck(this, wb);

        return _possibleConstructorReturn(this, _getPrototypeOf(wb).apply(this, arguments));
      }

      _createClass(wb, [{
        key: "refresh",
        value: function refresh() {
          var t = Vg("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = !!t;
          this.isEnabled = e, this.value = e && this._isInHeading(t, t.parent.parent);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
              e = Vg("tableCell", t.document.selection.getFirstPosition()).parent,
              n = e.parent,
              i = n.getAttribute("headingRows") || 0,
              o = e.index,
              r = i > o ? o : o + 1;
          t.change(function (t) {
            if (r) {
              var _e261 = function (t, e, n) {
                var i = [],
                    o = new qg(t, {
                  startRow: e > n ? n : 0,
                  endRow: e - 1
                });
                var _iteratorNormalCompletion346 = true;
                var _didIteratorError346 = false;
                var _iteratorError346 = undefined;

                try {
                  for (var _iterator346 = o[Symbol.iterator](), _step346; !(_iteratorNormalCompletion346 = (_step346 = _iterator346.next()).done); _iteratorNormalCompletion346 = true) {
                    var _ref119 = _step346.value;
                    var _t316 = _ref119.row;
                    var _n242 = _ref119.rowspan;
                    var _r56 = _ref119.cell;
                    _n242 > 1 && _t316 + _n242 > e && i.push(_r56);
                  }
                } catch (err) {
                  _didIteratorError346 = true;
                  _iteratorError346 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion346 && _iterator346.return != null) {
                      _iterator346.return();
                    }
                  } finally {
                    if (_didIteratorError346) {
                      throw _iteratorError346;
                    }
                  }
                }

                return i;
              }(n, r, i);

              var _iteratorNormalCompletion347 = true;
              var _didIteratorError347 = false;
              var _iteratorError347 = undefined;

              try {
                for (var _iterator347 = _e261[Symbol.iterator](), _step347; !(_iteratorNormalCompletion347 = (_step347 = _iterator347.next()).done); _iteratorNormalCompletion347 = true) {
                  var _n243 = _step347.value;

                  _b(_n243, r, t);
                }
              } catch (err) {
                _didIteratorError347 = true;
                _iteratorError347 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion347 && _iterator347.return != null) {
                    _iterator347.return();
                  }
                } finally {
                  if (_didIteratorError347) {
                    throw _iteratorError347;
                  }
                }
              }
            }

            Bg("headingRows", r, n, t, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(t, e) {
          var n = parseInt(e.getAttribute("headingRows") || 0);
          return !!n && t.parent.index < n;
        }
      }]);

      return wb;
    }(td);

    function _b(t, e, n) {
      var i = t.parent,
          o = i.parent,
          r = e - i.index,
          s = {},
          a = parseInt(t.getAttribute("rowspan")) - r;
      a > 1 && (s.rowspan = a);

      var c = o.getChildIndex(i),
          l = c + r,
          d = _toConsumableArray(new qg(o, {
        startRow: c,
        endRow: l,
        includeSpanned: !0
      }));

      var u;
      var _iteratorNormalCompletion348 = true;
      var _didIteratorError348 = false;
      var _iteratorError348 = undefined;

      try {
        for (var _iterator348 = d[Symbol.iterator](), _step348; !(_iteratorNormalCompletion348 = (_step348 = _iterator348.next()).done); _iteratorNormalCompletion348 = true) {
          var _ref121 = _step348.value;
          var _e262 = _ref121.row;
          var _i206 = _ref121.column;
          var _r57 = _ref121.cell;
          var _a21 = _ref121.colspan;
          var _c12 = _ref121.cellIndex;

          if (_r57 === t && (u = _i206, _a21 > 1 && (s.colspan = _a21)), void 0 !== u && u === _i206 && _e262 === l) {
            var _t317 = o.getChild(_e262);

            zg(n, n.createPositionAt(_t317, _c12), s);
          }
        }
      } catch (err) {
        _didIteratorError348 = true;
        _iteratorError348 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion348 && _iterator348.return != null) {
            _iterator348.return();
          }
        } finally {
          if (_didIteratorError348) {
            throw _iteratorError348;
          }
        }
      }

      Bg("rowspan", r, t, n);
    }

    var kb =
    /*#__PURE__*/
    function (_td28) {
      _inherits(kb, _td28);

      function kb() {
        _classCallCheck(this, kb);

        return _possibleConstructorReturn(this, _getPrototypeOf(kb).apply(this, arguments));
      }

      _createClass(kb, [{
        key: "refresh",
        value: function refresh() {
          var t = Vg("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = !!t;
          this.isEnabled = e, this.value = e && this._isInHeading(t, t.parent.parent);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
              e = t.document.selection,
              n = this.editor.plugins.get("TableUtils"),
              i = Vg("tableCell", e.getFirstPosition().parent),
              o = i.parent.parent,
              r = parseInt(o.getAttribute("headingColumns") || 0),
              _n$getCellLocation4 = n.getCellLocation(i),
              s = _n$getCellLocation4.column,
              a = r > s ? s : s + 1;

          t.change(function (t) {
            Bg("headingColumns", a, o, t, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(t, e) {
          var n = parseInt(e.getAttribute("headingColumns") || 0),
              i = this.editor.plugins.get("TableUtils"),
              _i$getCellLocation = i.getCellLocation(t),
              o = _i$getCellLocation.column;

          return !!n && o < n;
        }
      }]);

      return kb;
    }(td);

    var vb =
    /*#__PURE__*/
    function (_Ql67) {
      _inherits(vb, _Ql67);

      function vb() {
        _classCallCheck(this, vb);

        return _possibleConstructorReturn(this, _getPrototypeOf(vb).apply(this, arguments));
      }

      _createClass(vb, [{
        key: "getCellLocation",
        value: function getCellLocation(t) {
          var e = t.parent,
              n = e.parent,
              i = n.getChildIndex(e),
              o = new qg(n, {
            startRow: i,
            endRow: i
          });
          var _iteratorNormalCompletion349 = true;
          var _didIteratorError349 = false;
          var _iteratorError349 = undefined;

          try {
            for (var _iterator349 = o[Symbol.iterator](), _step349; !(_iteratorNormalCompletion349 = (_step349 = _iterator349.next()).done); _iteratorNormalCompletion349 = true) {
              var _ref123 = _step349.value;
              var _e263 = _ref123.cell;
              var _n244 = _ref123.row;
              var _i207 = _ref123.column;
              if (_e263 === t) return {
                row: _n244,
                column: _i207
              };
            }
          } catch (err) {
            _didIteratorError349 = true;
            _iteratorError349 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion349 && _iterator349.return != null) {
                _iterator349.return();
              }
            } finally {
              if (_didIteratorError349) {
                throw _iteratorError349;
              }
            }
          }
        }
      }, {
        key: "createTable",
        value: function createTable(t, e, n) {
          var i = t.createElement("table");
          return yb(t, i, 0, e, n), i;
        }
      }, {
        key: "insertRows",
        value: function insertRows(t) {
          var _this237 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = e.at || 0,
              o = e.rows || 1;
          n.change(function (e) {
            var n = t.getAttribute("headingRows") || 0;
            if (n > i && e.setAttribute("headingRows", n + o, t), 0 === i || i === t.childCount) return void yb(e, t, i, o, _this237.getColumns(t));
            var r = new qg(t, {
              endRow: i
            });
            var s = 0;
            var _iteratorNormalCompletion350 = true;
            var _didIteratorError350 = false;
            var _iteratorError350 = undefined;

            try {
              for (var _iterator350 = r[Symbol.iterator](), _step350; !(_iteratorNormalCompletion350 = (_step350 = _iterator350.next()).done); _iteratorNormalCompletion350 = true) {
                var _ref125 = _step350.value;
                var _t318 = _ref125.row;
                var _n245 = _ref125.rowspan;
                var _a22 = _ref125.colspan;
                var _c13 = _ref125.cell;
                _t318 < i && _t318 + _n245 > i && e.setAttribute("rowspan", _n245 + o, _c13), _t318 === i && (s += _a22);
              }
            } catch (err) {
              _didIteratorError350 = true;
              _iteratorError350 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion350 && _iterator350.return != null) {
                  _iterator350.return();
                }
              } finally {
                if (_didIteratorError350) {
                  throw _iteratorError350;
                }
              }
            }

            yb(e, t, i, o, s);
          });
        }
      }, {
        key: "insertColumns",
        value: function insertColumns(t) {
          var _this238 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = e.at || 0,
              o = e.columns || 1;
          n.change(function (e) {
            var n = t.getAttribute("headingColumns");
            i < n && e.setAttribute("headingColumns", n + o, t);

            var r = _this238.getColumns(t);

            if (0 === i || r === i) {
              var _iteratorNormalCompletion351 = true;
              var _didIteratorError351 = false;
              var _iteratorError351 = undefined;

              try {
                for (var _iterator351 = t.getChildren()[Symbol.iterator](), _step351; !(_iteratorNormalCompletion351 = (_step351 = _iterator351.next()).done); _iteratorNormalCompletion351 = true) {
                  var _n246 = _step351.value;
                  xb(o, e, e.createPositionAt(_n246, i ? "end" : 0));
                }
              } catch (err) {
                _didIteratorError351 = true;
                _iteratorError351 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion351 && _iterator351.return != null) {
                    _iterator351.return();
                  }
                } finally {
                  if (_didIteratorError351) {
                    throw _iteratorError351;
                  }
                }
              }

              return;
            }

            var s = new qg(t, {
              column: i,
              includeSpanned: !0
            });
            var _iteratorNormalCompletion352 = true;
            var _didIteratorError352 = false;
            var _iteratorError352 = undefined;

            try {
              for (var _iterator352 = s[Symbol.iterator](), _step352; !(_iteratorNormalCompletion352 = (_step352 = _iterator352.next()).done); _iteratorNormalCompletion352 = true) {
                var _ref127 = _step352.value;
                var _n247 = _ref127.row;
                var _r58 = _ref127.column;
                var _a23 = _ref127.cell;
                var _c14 = _ref127.colspan;
                var _l6 = _ref127.rowspan;
                var _d3 = _ref127.cellIndex;

                if (_r58 !== i) {
                  if (e.setAttribute("colspan", _c14 + o, _a23), s.skipRow(_n247), _l6 > 1) for (var _t319 = _n247 + 1; _t319 < _n247 + _l6; _t319++) {
                    s.skipRow(_t319);
                  }
                } else {
                  var _i208 = e.createPositionAt(t.getChild(_n247), _d3);

                  xb(o, e, _i208);
                }
              }
            } catch (err) {
              _didIteratorError352 = true;
              _iteratorError352 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion352 && _iterator352.return != null) {
                  _iterator352.return();
                }
              } finally {
                if (_didIteratorError352) {
                  throw _iteratorError352;
                }
              }
            }
          });
        }
      }, {
        key: "splitCellVertically",
        value: function splitCellVertically(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model,
              i = t.parent.parent,
              o = parseInt(t.getAttribute("rowspan") || 1),
              r = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (r > 1) {
              var _Ab = Ab(r, e),
                  _i209 = _Ab.newCellsSpan,
                  _s32 = _Ab.updatedSpan;

              Bg("colspan", _s32, t, n);
              var _a24 = {};
              _i209 > 1 && (_a24.colspan = _i209), o > 1 && (_a24.rowspan = o), xb(r > e ? e - 1 : r - 1, n, n.createPositionAfter(t), _a24);
            }

            if (r < e) {
              var _s33 = e - r,
                  _a25 = _toConsumableArray(new qg(i)),
                  _a25$find = _a25.find(function (_ref128) {
                var e = _ref128.cell;
                return e === t;
              }),
                  _c15 = _a25$find.column,
                  _l7 = _a25.filter(function (_ref129) {
                var e = _ref129.cell,
                    n = _ref129.colspan,
                    i = _ref129.column;
                return e !== t && i === _c15 || i < _c15 && i + n > _c15;
              });

              var _iteratorNormalCompletion353 = true;
              var _didIteratorError353 = false;
              var _iteratorError353 = undefined;

              try {
                for (var _iterator353 = _l7[Symbol.iterator](), _step353; !(_iteratorNormalCompletion353 = (_step353 = _iterator353.next()).done); _iteratorNormalCompletion353 = true) {
                  var _ref131 = _step353.value;
                  var _t320 = _ref131.cell;
                  var _e264 = _ref131.colspan;
                  n.setAttribute("colspan", _e264 + _s33, _t320);
                }
              } catch (err) {
                _didIteratorError353 = true;
                _iteratorError353 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion353 && _iterator353.return != null) {
                    _iterator353.return();
                  }
                } finally {
                  if (_didIteratorError353) {
                    throw _iteratorError353;
                  }
                }
              }

              var _d4 = {};
              o > 1 && (_d4.rowspan = o), xb(_s33, n, n.createPositionAfter(t), _d4);

              var _u3 = i.getAttribute("headingColumns") || 0;

              _u3 > _c15 && Bg("headingColumns", _u3 + _s33, i, n);
            }
          });
        }
      }, {
        key: "splitCellHorizontally",
        value: function splitCellHorizontally(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model,
              i = t.parent,
              o = i.parent,
              r = o.getChildIndex(i),
              s = parseInt(t.getAttribute("rowspan") || 1),
              a = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (s > 1) {
              var _i210 = _toConsumableArray(new qg(o, {
                startRow: r,
                endRow: r + s - 1,
                includeSpanned: !0
              })),
                  _Ab2 = Ab(s, e),
                  _c16 = _Ab2.newCellsSpan,
                  _l8 = _Ab2.updatedSpan;

              Bg("rowspan", _l8, t, n);

              var _i210$find = _i210.find(function (_ref132) {
                var e = _ref132.cell;
                return e === t;
              }),
                  _d5 = _i210$find.column,
                  _u4 = {};

              _c16 > 1 && (_u4.rowspan = _c16), a > 1 && (_u4.colspan = a);

              for (var _i212 = 0, _i211 = _i210; _i212 < _i211.length; _i212++) {
                var _ref134 = _i211[_i212];
                var _t321 = _ref134.column;
                var _e265 = _ref134.row;
                var _s34 = _ref134.cellIndex;

                if (_e265 >= r + _l8 && _t321 === _d5 && (_e265 + r + _l8) % _c16 == 0) {
                  xb(1, n, n.createPositionAt(o.getChild(_e265), _s34), _u4);
                }
              }
            }

            if (s < e) {
              var _i213 = e - s,
                  _c17 = _toConsumableArray(new qg(o, {
                startRow: 0,
                endRow: r
              }));

              var _iteratorNormalCompletion354 = true;
              var _didIteratorError354 = false;
              var _iteratorError354 = undefined;

              try {
                for (var _iterator354 = _c17[Symbol.iterator](), _step354; !(_iteratorNormalCompletion354 = (_step354 = _iterator354.next()).done); _iteratorNormalCompletion354 = true) {
                  var _ref136 = _step354.value;
                  var _e266 = _ref136.cell;
                  var _o100 = _ref136.rowspan;
                  var _s35 = _ref136.row;

                  if (_e266 !== t && _s35 + _o100 > r) {
                    var _t322 = _o100 + _i213;

                    n.setAttribute("rowspan", _t322, _e266);
                  }
                }
              } catch (err) {
                _didIteratorError354 = true;
                _iteratorError354 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion354 && _iterator354.return != null) {
                    _iterator354.return();
                  }
                } finally {
                  if (_didIteratorError354) {
                    throw _iteratorError354;
                  }
                }
              }

              var _l9 = {};
              a > 1 && (_l9.colspan = a), yb(n, o, r + 1, _i213, 1, _l9);

              var _d6 = o.getAttribute("headingRows") || 0;

              _d6 > r && Bg("headingRows", _d6 + _i213, o, n);
            }
          });
        }
      }, {
        key: "getColumns",
        value: function getColumns(t) {
          return _toConsumableArray(t.getChild(0).getChildren()).reduce(function (t, e) {
            return t + parseInt(e.getAttribute("colspan") || 1);
          }, 0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableUtils";
        }
      }]);

      return vb;
    }(Ql);

    function yb(t, e, n, i, o) {
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      for (var _s36 = 0; _s36 < i; _s36++) {
        var _i214 = t.createElement("tableRow");

        t.insert(_i214, e, n), xb(o, t, t.createPositionAt(_i214, "end"), r);
      }
    }

    function xb(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      for (var _o101 = 0; _o101 < t; _o101++) {
        zg(e, n, i);
      }
    }

    function Ab(t, e) {
      if (t < e) return {
        newCellsSpan: 1,
        updatedSpan: 1
      };
      var n = Math.floor(t / e);
      return {
        newCellsSpan: n,
        updatedSpan: t - n * e + n
      };
    }

    function Cb(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.differ.getChanges();
          var i = !1;
          var o = new Set();
          var _iteratorNormalCompletion355 = true;
          var _didIteratorError355 = false;
          var _iteratorError355 = undefined;

          try {
            for (var _iterator355 = n[Symbol.iterator](), _step355; !(_iteratorNormalCompletion355 = (_step355 = _iterator355.next()).done); _iteratorNormalCompletion355 = true) {
              var _e267 = _step355.value;

              var _n248 = void 0;

              "table" == _e267.name && "insert" == _e267.type && (_n248 = _e267.position.nodeAfter), "tableRow" != _e267.name && "tableCell" != _e267.name || (_n248 = Vg("table", _e267.position)), Mb(_e267) && (_n248 = Vg("table", _e267.range.start)), _n248 && !o.has(_n248) && (i = Tb(_n248, t) || i, i = Pb(_n248, t) || i, o.add(_n248));
            }
          } catch (err) {
            _didIteratorError355 = true;
            _iteratorError355 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion355 && _iterator355.return != null) {
                _iterator355.return();
              }
            } finally {
              if (_didIteratorError355) {
                throw _iteratorError355;
              }
            }
          }

          return i;
        }(e, t);
      });
    }

    function Tb(t, e) {
      var n = !1;

      var i = function (t) {
        var e = parseInt(t.getAttribute("headingRows") || 0),
            n = t.childCount,
            i = [];
        var _iteratorNormalCompletion356 = true;
        var _didIteratorError356 = false;
        var _iteratorError356 = undefined;

        try {
          for (var _iterator356 = new qg(t)[Symbol.iterator](), _step356; !(_iteratorNormalCompletion356 = (_step356 = _iterator356.next()).done); _iteratorNormalCompletion356 = true) {
            var _ref138 = _step356.value;
            var _o102 = _ref138.row;
            var _r59 = _ref138.rowspan;
            var _s37 = _ref138.cell;
            if (_r59 < 2) continue;

            var _t323 = _o102 < e,
                _a26 = _t323 ? e : n;

            if (_o102 + _r59 > _a26) {
              var _t324 = _a26 - _o102;

              i.push({
                cell: _s37,
                rowspan: _t324
              });
            }
          }
        } catch (err) {
          _didIteratorError356 = true;
          _iteratorError356 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion356 && _iterator356.return != null) {
              _iterator356.return();
            }
          } finally {
            if (_didIteratorError356) {
              throw _iteratorError356;
            }
          }
        }

        return i;
      }(t);

      if (i.length) {
        n = !0;
        var _iteratorNormalCompletion357 = true;
        var _didIteratorError357 = false;
        var _iteratorError357 = undefined;

        try {
          for (var _iterator357 = i[Symbol.iterator](), _step357; !(_iteratorNormalCompletion357 = (_step357 = _iterator357.next()).done); _iteratorNormalCompletion357 = true) {
            var _t325 = _step357.value;
            Bg("rowspan", _t325.rowspan, _t325.cell, e, 1);
          }
        } catch (err) {
          _didIteratorError357 = true;
          _iteratorError357 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion357 && _iterator357.return != null) {
              _iterator357.return();
            }
          } finally {
            if (_didIteratorError357) {
              throw _iteratorError357;
            }
          }
        }
      }

      return n;
    }

    function Pb(t, e) {
      var n = !1;

      var i = function (t) {
        var e = {};
        var _iteratorNormalCompletion358 = true;
        var _didIteratorError358 = false;
        var _iteratorError358 = undefined;

        try {
          for (var _iterator358 = new qg(t, {
            includeSpanned: !0
          })[Symbol.iterator](), _step358; !(_iteratorNormalCompletion358 = (_step358 = _iterator358.next()).done); _iteratorNormalCompletion358 = true) {
            var _ref140 = _step358.value;
            var _n249 = _ref140.row;
            e[_n249] || (e[_n249] = 0), e[_n249] += 1;
          }
        } catch (err) {
          _didIteratorError358 = true;
          _iteratorError358 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion358 && _iterator358.return != null) {
              _iterator358.return();
            }
          } finally {
            if (_didIteratorError358) {
              throw _iteratorError358;
            }
          }
        }

        return e;
      }(t),
          o = i[0];

      if (!Object.values(i).every(function (t) {
        return t === o;
      })) {
        var _o103 = Object.values(i).reduce(function (t, e) {
          return e > t ? e : t;
        }, 0);

        for (var _i215 = 0, _Object$entries2 = Object.entries(i); _i215 < _Object$entries2.length; _i215++) {
          var _ref143 = _Object$entries2[_i215];

          var _ref142 = _slicedToArray(_ref143, 2);

          var _r60 = _ref142[0];
          var _s38 = _ref142[1];

          var _i216 = _o103 - _s38;

          if (_i216) {
            for (var _n250 = 0; _n250 < _i216; _n250++) {
              zg(e, e.createPositionAt(t.getChild(_r60), "end"));
            }

            n = !0;
          }
        }
      }

      return n;
    }

    function Mb(t) {
      var e = "attribute" === t.type,
          n = t.attributeKey;
      return e && ("headingRows" === n || "colspan" === n || "rowspan" === n);
    }

    function Sb(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.differ.getChanges();
          var i = !1;
          var _iteratorNormalCompletion359 = true;
          var _didIteratorError359 = false;
          var _iteratorError359 = undefined;

          try {
            for (var _iterator359 = n[Symbol.iterator](), _step359; !(_iteratorNormalCompletion359 = (_step359 = _iterator359.next()).done); _iteratorNormalCompletion359 = true) {
              var _e268 = _step359.value;
              "remove" == _e268.type && _e268.position.parent.is("tableCell") && (i = Nb(_e268.position.parent, t) || i), "insert" == _e268.type && ("table" == _e268.name && (i = Eb(_e268.position.nodeAfter, t) || i), "tableRow" == _e268.name && (i = Ib(_e268.position.nodeAfter, t) || i), "tableCell" == _e268.name && (i = Nb(_e268.position.nodeAfter, t) || i));
            }
          } catch (err) {
            _didIteratorError359 = true;
            _iteratorError359 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion359 && _iterator359.return != null) {
                _iterator359.return();
              }
            } finally {
              if (_didIteratorError359) {
                throw _iteratorError359;
              }
            }
          }

          return i;
        }(e, t);
      });
    }

    function Eb(t, e) {
      var n = !1;
      var _iteratorNormalCompletion360 = true;
      var _didIteratorError360 = false;
      var _iteratorError360 = undefined;

      try {
        for (var _iterator360 = t.getChildren()[Symbol.iterator](), _step360; !(_iteratorNormalCompletion360 = (_step360 = _iterator360.next()).done); _iteratorNormalCompletion360 = true) {
          var _i217 = _step360.value;
          n = Ib(_i217, e) || n;
        }
      } catch (err) {
        _didIteratorError360 = true;
        _iteratorError360 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion360 && _iterator360.return != null) {
            _iterator360.return();
          }
        } finally {
          if (_didIteratorError360) {
            throw _iteratorError360;
          }
        }
      }

      return n;
    }

    function Ib(t, e) {
      var n = !1;
      var _iteratorNormalCompletion361 = true;
      var _didIteratorError361 = false;
      var _iteratorError361 = undefined;

      try {
        for (var _iterator361 = t.getChildren()[Symbol.iterator](), _step361; !(_iteratorNormalCompletion361 = (_step361 = _iterator361.next()).done); _iteratorNormalCompletion361 = true) {
          var _i218 = _step361.value;
          n = Nb(_i218, e) || n;
        }
      } catch (err) {
        _didIteratorError361 = true;
        _iteratorError361 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion361 && _iterator361.return != null) {
            _iterator361.return();
          }
        } finally {
          if (_didIteratorError361) {
            throw _iteratorError361;
          }
        }
      }

      return n;
    }

    function Nb(t, e) {
      if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
      var n = Array.from(t.getChildren()).filter(function (t) {
        return t.is("text");
      });
      var _iteratorNormalCompletion362 = true;
      var _didIteratorError362 = false;
      var _iteratorError362 = undefined;

      try {
        for (var _iterator362 = n[Symbol.iterator](), _step362; !(_iteratorNormalCompletion362 = (_step362 = _iterator362.next()).done); _iteratorNormalCompletion362 = true) {
          var _t326 = _step362.value;
          e.wrap(e.createRangeOn(_t326), "paragraph");
        }
      } catch (err) {
        _didIteratorError362 = true;
        _iteratorError362 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion362 && _iterator362.return != null) {
            _iterator362.return();
          }
        } finally {
          if (_didIteratorError362) {
            throw _iteratorError362;
          }
        }
      }

      return !!n.length;
    }

    function Ob(t, e) {
      e.view.document.registerPostFixer(function (n) {
        return function (t, e, n, i) {
          var o = !1;

          var r = function (t) {
            var e = Array.from(t._renderer.markedAttributes).filter(function (t) {
              return !!t.parent;
            }).filter(Db).filter(function (t) {
              return Lb(t.parent);
            }),
                n = Array.from(t._renderer.markedChildren).filter(function (t) {
              return !!t.parent;
            }).filter(Lb).reduce(function (t, e) {
              var n = Array.from(e.getChildren()).filter(Db);
              return [].concat(_toConsumableArray(t), _toConsumableArray(n));
            }, []);
            return [].concat(_toConsumableArray(e), _toConsumableArray(n));
          }(i);

          var _iteratorNormalCompletion363 = true;
          var _didIteratorError363 = false;
          var _iteratorError363 = undefined;

          try {
            for (var _iterator363 = r[Symbol.iterator](), _step363; !(_iteratorNormalCompletion363 = (_step363 = _iterator363.next()).done); _iteratorNormalCompletion363 = true) {
              var _e269 = _step363.value;
              o = Rb(_e269, n, t) || o;
            }
          } catch (err) {
            _didIteratorError363 = true;
            _iteratorError363 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion363 && _iterator363.return != null) {
                _iterator363.return();
              }
            } finally {
              if (_didIteratorError363) {
                throw _iteratorError363;
              }
            }
          }

          o && function (t) {
            var e = t.anchor,
                n = t.focus;
            return t.rangeCount && (!e.root.is("rootElement") || !n.root.is("rootElement"));
          }(i.document.selection) && function (t, e, n) {
            var i = Array.from(t.getRanges()).map(function (t) {
              return e.toViewRange(t);
            });
            n.setSelection(i, {
              backward: t.isBackward
            });
          }(e.document.selection, n, t);
          return o;
        }(n, t, e.mapper, e.view);
      });
    }

    function Rb(t, e, n) {
      if (!t.root.is("rootElement")) return !1;

      var i = e.toModelElement(t),
          o = function (t, e) {
        var n = t.childCount > 1,
            i = !!_toConsumableArray(e.getAttributes()).length;
        return n || i ? "p" : "span";
      }(i.parent, i);

      if (t.name !== o) {
        e.unbindViewElement(t);

        var _r61 = n.rename(o, t);

        return e.bindElements(i, _r61), !0;
      }

      return !1;
    }

    function Db(t) {
      return t.is("p") || t.is("span");
    }

    function Lb(t) {
      return t.is("td") || t.is("th");
    }

    n(122);

    var jb =
    /*#__PURE__*/
    function (_Ql68) {
      _inherits(jb, _Ql68);

      function jb() {
        _classCallCheck(this, jb);

        return _possibleConstructorReturn(this, _getPrototypeOf(jb).apply(this, arguments));
      }

      _createClass(jb, [{
        key: "init",
        value: function init() {
          var _this239 = this;

          var t = this.editor,
              e = t.model,
              n = e.schema,
              i = t.conversion;
          n.register("table", {
            allowWhere: "$block",
            allowAttributes: ["headingRows", "headingColumns"],
            isLimit: !0,
            isObject: !0,
            isBlock: !0
          }), n.register("tableRow", {
            allowIn: "table",
            isLimit: !0
          }), n.register("tableCell", {
            allowIn: "tableRow",
            allowAttributes: ["colspan", "rowspan"],
            isLimit: !0
          }), n.extend("$block", {
            allowIn: "tableCell"
          }), n.addChildCheck(function (t, e) {
            if ("table" == e.name && Array.from(t.getNames()).includes("table")) return !1;
          }), i.for("upcast").add(Fg()), i.for("editingDowncast").add(Gg({
            asWidget: !0
          })), i.for("dataDowncast").add(Gg()), i.for("upcast").elementToElement({
            model: "tableRow",
            view: "tr"
          }), i.for("editingDowncast").add(Qg({
            asWidget: !0
          })), i.for("dataDowncast").add(Qg()), i.for("downcast").add(function (t) {
            return t.on("remove:tableRow", function (t, e, n) {
              t.stop();
              var i = n.writer,
                  o = n.mapper,
                  r = o.toViewPosition(e.position).getLastMatchingPosition(function (t) {
                return !t.item.is("tr");
              }).nodeAfter,
                  s = r.parent,
                  a = i.createRangeOn(r),
                  c = i.remove(a);
              var _iteratorNormalCompletion364 = true;
              var _didIteratorError364 = false;
              var _iteratorError364 = undefined;

              try {
                for (var _iterator364 = i.createRangeIn(c).getItems()[Symbol.iterator](), _step364; !(_iteratorNormalCompletion364 = (_step364 = _iterator364.next()).done); _iteratorNormalCompletion364 = true) {
                  var _t327 = _step364.value;
                  o.unbindViewElement(_t327);
                }
              } catch (err) {
                _didIteratorError364 = true;
                _iteratorError364 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion364 && _iterator364.return != null) {
                    _iterator364.return();
                  }
                } finally {
                  if (_didIteratorError364) {
                    throw _iteratorError364;
                  }
                }
              }

              s.childCount || i.remove(i.createRangeOn(s));
            }, {
              priority: "higher"
            });
          }), i.for("upcast").add(Ug("td")), i.for("upcast").add(Ug("th")), i.for("editingDowncast").add(Jg({
            asWidget: !0
          })), i.for("dataDowncast").add(Jg()), i.attributeToAttribute({
            model: "colspan",
            view: "colspan"
          }), i.attributeToAttribute({
            model: "rowspan",
            view: "rowspan"
          }), i.for("editingDowncast").add(Zg({
            asWidget: !0
          })), i.for("dataDowncast").add(Zg()), i.for("editingDowncast").add(Kg({
            asWidget: !0
          })), i.for("dataDowncast").add(Kg()), Ob(t.model, t.editing), t.commands.add("insertTable", new db(t)), t.commands.add("insertTableRowAbove", new ub(t, {
            order: "above"
          })), t.commands.add("insertTableRowBelow", new ub(t, {
            order: "below"
          })), t.commands.add("insertTableColumnLeft", new hb(t, {
            order: "left"
          })), t.commands.add("insertTableColumnRight", new hb(t, {
            order: "right"
          })), t.commands.add("removeTableRow", new gb(t)), t.commands.add("removeTableColumn", new bb(t)), t.commands.add("splitTableCellVertically", new fb(t, {
            direction: "vertically"
          })), t.commands.add("splitTableCellHorizontally", new fb(t, {
            direction: "horizontally"
          })), t.commands.add("mergeTableCellRight", new mb(t, {
            direction: "right"
          })), t.commands.add("mergeTableCellLeft", new mb(t, {
            direction: "left"
          })), t.commands.add("mergeTableCellDown", new mb(t, {
            direction: "down"
          })), t.commands.add("mergeTableCellUp", new mb(t, {
            direction: "up"
          })), t.commands.add("setTableColumnHeader", new kb(t)), t.commands.add("setTableRowHeader", new wb(t)), Cb(e), Sb(e), this.editor.keystrokes.set("Tab", function () {
            return _this239._handleTabOnSelectedTable.apply(_this239, arguments);
          }, {
            priority: "low"
          }), this.editor.keystrokes.set("Tab", this._getTabHandler(!0), {
            priority: "low"
          }), this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(!1), {
            priority: "low"
          });
        }
      }, {
        key: "_handleTabOnSelectedTable",
        value: function _handleTabOnSelectedTable(t, e) {
          var n = this.editor,
              i = n.model.document.selection;

          if (!i.isCollapsed && 1 === i.rangeCount && i.getFirstRange().isFlat) {
            var _t328 = i.getSelectedElement();

            if (!_t328 || !_t328.is("table")) return;
            e(), n.model.change(function (e) {
              e.setSelection(e.createRangeIn(_t328.getChild(0).getChild(0)));
            });
          }
        }
      }, {
        key: "_getTabHandler",
        value: function _getTabHandler(t) {
          var e = this.editor;
          return function (n, i) {
            var o = Vg("tableCell", e.model.document.selection.getFirstPosition());
            if (!o) return;
            i();
            var r = o.parent,
                s = r.parent,
                a = s.getChildIndex(r),
                c = r.getChildIndex(o),
                l = 0 === c;
            if (!t && l && 0 === a) return;
            var d = c === r.childCount - 1,
                u = a === s.childCount - 1;
            if (t && u && d && (e.execute("insertTableRowBelow"), a === s.childCount - 1)) return;
            var h;

            if (t && d) {
              var _t329 = s.getChild(a + 1);

              h = _t329.getChild(0);
            } else if (!t && l) {
              var _t330 = s.getChild(a - 1);

              h = _t330.getChild(_t330.childCount - 1);
            } else h = r.getChild(c + (t ? 1 : -1));

            e.model.change(function (t) {
              t.setSelection(t.createRangeIn(h));
            });
          };
        }
      }], [{
        key: "requires",
        get: function get() {
          return [vb];
        }
      }]);

      return jb;
    }(Ql);

    n(124);

    var Vb =
    /*#__PURE__*/
    function (_Rl26) {
      _inherits(Vb, _Rl26);

      function Vb(t) {
        var _this240;

        _classCallCheck(this, Vb);

        _this240 = _possibleConstructorReturn(this, _getPrototypeOf(Vb).call(this, t));
        var e = _this240.bindTemplate;
        _this240.items = _this240.createCollection(), _this240.set("rows", 0), _this240.set("columns", 0), _this240.bind("label").to(_assertThisInitialized(_this240), "columns", _assertThisInitialized(_this240), "rows", function (t, e) {
          return "".concat(e, " x ").concat(t);
        }), _this240.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            children: _this240.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__label"]
            },
            children: [{
              text: e.to("label")
            }]
          }],
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function () {
              _this240.fire("execute");
            })
          }
        });

        var _loop9 = function _loop9(_t331) {
          var e = new Bb();
          e.on("over", function () {
            var e = Math.floor(_t331 / 10),
                n = _t331 % 10;
            _this240.set("rows", e + 1), _this240.set("columns", n + 1);
          }), _this240.items.add(e);
        };

        for (var _t331 = 0; _t331 < 100; _t331++) {
          _loop9(_t331);
        }

        _this240.on("change:columns", function () {
          _this240._highlightGridBoxes();
        }), _this240.on("change:rows", function () {
          _this240._highlightGridBoxes();
        });
        return _this240;
      }

      _createClass(Vb, [{
        key: "focus",
        value: function focus() {}
      }, {
        key: "focusLast",
        value: function focusLast() {}
      }, {
        key: "_highlightGridBoxes",
        value: function _highlightGridBoxes() {
          var t = this.rows,
              e = this.columns;
          this.items.map(function (n, i) {
            var o = Math.floor(i / 10) < t && i % 10 < e;
            n.set("isOn", o);
          });
        }
      }]);

      return Vb;
    }(Rl);

    var Bb =
    /*#__PURE__*/
    function (_Rl27) {
      _inherits(Bb, _Rl27);

      function Bb(t) {
        var _this241;

        _classCallCheck(this, Bb);

        _this241 = _possibleConstructorReturn(this, _getPrototypeOf(Bb).call(this, t));
        var e = _this241.bindTemplate;
        _this241.set("isOn", !1), _this241.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-insert-table-dropdown-grid-box", e.if("isOn", "ck-on")]
          },
          on: {
            mouseover: e.to("over")
          }
        });
        return _this241;
      }

      return Bb;
    }(Rl);

    var zb = n(43),
        Fb = n.n(zb),
        Ub = n(44),
        Hb = n.n(Ub),
        qb = n(45),
        Wb = n.n(qb),
        Yb = n(46),
        $b = n.n(Yb);

    var Gb =
    /*#__PURE__*/
    function (_Ql69) {
      _inherits(Gb, _Ql69);

      function Gb() {
        _classCallCheck(this, Gb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Gb).apply(this, arguments));
      }

      _createClass(Gb, [{
        key: "init",
        value: function init() {
          var _this242 = this;

          var t = this.editor,
              e = this.editor.t;
          t.ui.componentFactory.add("insertTable", function (n) {
            var i = t.commands.get("insertTable"),
                o = tm(n);
            o.bind("isEnabled").to(i), o.buttonView.set({
              icon: Fb.a,
              label: e("j"),
              tooltip: !0
            });
            var r = new Vb(n);
            return o.panelView.children.add(r), r.delegate("execute").to(o), o.buttonView.on("open", function () {
              r.rows = 0, r.columns = 0;
            }), o.on("execute", function () {
              t.execute("insertTable", {
                rows: r.rows,
                columns: r.columns
              }), t.editing.view.focus();
            }), o;
          }), t.ui.componentFactory.add("tableColumn", function (t) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableColumnHeader",
                label: e("k"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "insertTableColumnLeft",
                label: e("l")
              }
            }, {
              type: "button",
              model: {
                commandName: "insertTableColumnRight",
                label: e("m")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableColumn",
                label: e("n")
              }
            }];
            return _this242._prepareDropdown(e("o"), Hb.a, n, t);
          }), t.ui.componentFactory.add("tableRow", function (t) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableRowHeader",
                label: e("p"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowBelow",
                label: e("q")
              }
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowAbove",
                label: e("r")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableRow",
                label: e("s")
              }
            }];
            return _this242._prepareDropdown(e("t"), Wb.a, n, t);
          }), t.ui.componentFactory.add("mergeTableCells", function (t) {
            var n = [{
              type: "button",
              model: {
                commandName: "mergeTableCellUp",
                label: e("u")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellRight",
                label: e("v")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellDown",
                label: e("w")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellLeft",
                label: e("x")
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellVertically",
                label: e("y")
              }
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellHorizontally",
                label: e("z")
              }
            }];
            return _this242._prepareDropdown(e("aa"), $b.a, n, t);
          });
        }
      }, {
        key: "_prepareDropdown",
        value: function _prepareDropdown(t, e, n, i) {
          var o = this.editor,
              r = tm(i),
              s = [],
              a = new oo();
          var _iteratorNormalCompletion365 = true;
          var _didIteratorError365 = false;
          var _iteratorError365 = undefined;

          try {
            for (var _iterator365 = n[Symbol.iterator](), _step365; !(_iteratorNormalCompletion365 = (_step365 = _iterator365.next()).done); _iteratorNormalCompletion365 = true) {
              var _t332 = _step365.value;
              Qb(_t332, o, s, a);
            }
          } catch (err) {
            _didIteratorError365 = true;
            _iteratorError365 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion365 && _iterator365.return != null) {
                _iterator365.return();
              }
            } finally {
              if (_didIteratorError365) {
                throw _iteratorError365;
              }
            }
          }

          return em(r, a), r.buttonView.set({
            label: t,
            icon: e,
            tooltip: !0
          }), r.bind("isEnabled").toMany(s, "isEnabled", function () {
            for (var _len19 = arguments.length, t = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
              t[_key19] = arguments[_key19];
            }

            return t.some(function (t) {
              return t;
            });
          }), this.listenTo(r, "execute", function (t) {
            o.execute(t.source.commandName), o.editing.view.focus();
          }), r;
        }
      }]);

      return Gb;
    }(Ql);

    function Qb(t, e, n, i) {
      var o = t.model = new qf(t.model),
          _t$model = t.model,
          r = _t$model.commandName,
          s = _t$model.bindIsOn;

      if ("separator" !== t.type) {
        var _t333 = e.commands.get(r);

        n.push(_t333), o.set({
          commandName: r
        }), o.bind("isEnabled").to(_t333), s && o.bind("isOn").to(_t333, "value");
      }

      o.set({
        withText: !0
      }), i.add(t);
    }

    n(126);

    var Jb =
    /*#__PURE__*/
    function (_Ql70) {
      _inherits(Jb, _Ql70);

      function Jb() {
        _classCallCheck(this, Jb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Jb).apply(this, arguments));
      }

      _createClass(Jb, null, [{
        key: "requires",
        get: function get() {
          return [jb, Gb, Ih];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Table";
        }
      }]);

      return Jb;
    }(Ql);

    var Kb =
    /*#__PURE__*/
    function (_Ql71) {
      _inherits(Kb, _Ql71);

      function Kb() {
        _classCallCheck(this, Kb);

        return _possibleConstructorReturn(this, _getPrototypeOf(Kb).apply(this, arguments));
      }

      _createClass(Kb, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
              e = t.plugins.get(Sm),
              n = t.config.get("table.contentToolbar"),
              i = t.config.get("table.tableToolbar");
          n && e.register("tableContent", {
            items: n,
            getRelatedElement: $g
          }), i && e.register("table", {
            items: i,
            getRelatedElement: Yg
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Sm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "TableToolbar";
        }
      }]);

      return Kb;
    }(Ql);

    var Zb = ["left", "right", "center", "justify"];

    function Xb(t) {
      return Zb.includes(t);
    }

    function tw(t) {
      return "left" === t;
    }

    var ew = "alignment";

    var nw =
    /*#__PURE__*/
    function (_td29) {
      _inherits(nw, _td29);

      function nw() {
        _classCallCheck(this, nw);

        return _possibleConstructorReturn(this, _getPrototypeOf(nw).apply(this, arguments));
      }

      _createClass(nw, [{
        key: "refresh",
        value: function refresh() {
          var t = Ru(this.editor.model.document.selection.getSelectedBlocks());
          this.isEnabled = !!t && this._canBeAligned(t), this.value = this.isEnabled && t.hasAttribute("alignment") ? t.getAttribute("alignment") : "left";
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this243 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document,
              i = t.value;
          e.change(function (t) {
            var e = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
              return _this243._canBeAligned(t);
            }),
                o = e[0].getAttribute("alignment");
            tw(i) || o === i || !i ? function (t, e) {
              var _iteratorNormalCompletion366 = true;
              var _didIteratorError366 = false;
              var _iteratorError366 = undefined;

              try {
                for (var _iterator366 = t[Symbol.iterator](), _step366; !(_iteratorNormalCompletion366 = (_step366 = _iterator366.next()).done); _iteratorNormalCompletion366 = true) {
                  var _n251 = _step366.value;
                  e.removeAttribute(ew, _n251);
                }
              } catch (err) {
                _didIteratorError366 = true;
                _iteratorError366 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion366 && _iterator366.return != null) {
                    _iterator366.return();
                  }
                } finally {
                  if (_didIteratorError366) {
                    throw _iteratorError366;
                  }
                }
              }
            }(e, t) : function (t, e, n) {
              var _iteratorNormalCompletion367 = true;
              var _didIteratorError367 = false;
              var _iteratorError367 = undefined;

              try {
                for (var _iterator367 = t[Symbol.iterator](), _step367; !(_iteratorNormalCompletion367 = (_step367 = _iterator367.next()).done); _iteratorNormalCompletion367 = true) {
                  var _i219 = _step367.value;
                  e.setAttribute(ew, n, _i219);
                }
              } catch (err) {
                _didIteratorError367 = true;
                _iteratorError367 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion367 && _iterator367.return != null) {
                    _iterator367.return();
                  }
                } finally {
                  if (_didIteratorError367) {
                    throw _iteratorError367;
                  }
                }
              }
            }(e, t, i);
          });
        }
      }, {
        key: "_canBeAligned",
        value: function _canBeAligned(t) {
          return this.editor.model.schema.checkAttribute(t, ew);
        }
      }]);

      return nw;
    }(td);

    var iw =
    /*#__PURE__*/
    function (_Ql72) {
      _inherits(iw, _Ql72);

      function iw(t) {
        var _this244;

        _classCallCheck(this, iw);

        _this244 = _possibleConstructorReturn(this, _getPrototypeOf(iw).call(this, t)), t.config.define("alignment", {
          options: [].concat(Zb)
        });
        return _this244;
      }

      _createClass(iw, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.config.get("alignment.options").filter(Xb);
          e.extend("$block", {
            allowAttributes: "alignment"
          }), t.model.schema.setAttributeProperties("alignment", {
            isFormatting: !0
          });

          var i = function (t) {
            var e = {
              model: {
                key: "alignment",
                values: t.slice()
              },
              view: {}
            };
            var _iteratorNormalCompletion368 = true;
            var _didIteratorError368 = false;
            var _iteratorError368 = undefined;

            try {
              for (var _iterator368 = t[Symbol.iterator](), _step368; !(_iteratorNormalCompletion368 = (_step368 = _iterator368.next()).done); _iteratorNormalCompletion368 = true) {
                var _n252 = _step368.value;
                e.view[_n252] = {
                  key: "style",
                  value: {
                    "text-align": _n252
                  }
                };
              }
            } catch (err) {
              _didIteratorError368 = true;
              _iteratorError368 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion368 && _iterator368.return != null) {
                  _iterator368.return();
                }
              } finally {
                if (_didIteratorError368) {
                  throw _iteratorError368;
                }
              }
            }

            return e;
          }(n.filter(function (t) {
            return !tw(t);
          }));

          t.conversion.attributeToAttribute(i), t.commands.add("alignment", new nw(t));
        }
      }]);

      return iw;
    }(Ql);

    var ow = n(16),
        rw = n.n(ow),
        sw = n(47),
        aw = n.n(sw),
        cw = n(48),
        lw = n.n(cw),
        dw = n(49),
        uw = n.n(dw);
    var hw = new Map([["left", rw.a], ["right", aw.a], ["center", lw.a], ["justify", uw.a]]);

    var fw =
    /*#__PURE__*/
    function (_Ql73) {
      _inherits(fw, _Ql73);

      function fw() {
        _classCallCheck(this, fw);

        return _possibleConstructorReturn(this, _getPrototypeOf(fw).apply(this, arguments));
      }

      _createClass(fw, [{
        key: "init",
        value: function init() {
          var _this245 = this;

          var t = this.editor,
              e = t.ui.componentFactory,
              n = t.t,
              i = t.config.get("alignment.options");
          i.filter(Xb).forEach(function (t) {
            return _this245._addButton(t);
          }), e.add("alignment", function (t) {
            var o = tm(t),
                r = i.map(function (t) {
              return e.create("alignment:".concat(t));
            });
            !function (t, e) {
              var n = t.toolbarView = new Yl();
              t.extendTemplate({
                attributes: {
                  class: ["ck-toolbar-dropdown"]
                }
              }), e.map(function (t) {
                return n.items.add(t);
              }), t.panelView.children.add(n), n.items.delegate("execute").to(t);
            }(o, r), o.buttonView.set({
              label: n("af"),
              tooltip: !0
            }), o.toolbarView.isVertical = !0, o.extendTemplate({
              attributes: {
                class: "ck-alignment-dropdown"
              }
            });
            var s = rw.a;
            return o.buttonView.bind("icon").toMany(r, "isOn", function () {
              for (var _len20 = arguments.length, t = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
                t[_key20] = arguments[_key20];
              }

              var e = t.findIndex(function (t) {
                return t;
              });
              return e < 0 ? s : r[e].icon;
            }), o.bind("isEnabled").toMany(r, "isEnabled", function () {
              for (var _len21 = arguments.length, t = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
                t[_key21] = arguments[_key21];
              }

              return t.some(function (t) {
                return t;
              });
            }), o;
          });
        }
      }, {
        key: "_addButton",
        value: function _addButton(t) {
          var _this246 = this;

          var e = this.editor;
          e.ui.componentFactory.add("alignment:".concat(t), function (n) {
            var i = e.commands.get("alignment"),
                o = new Hd(n);
            return o.set({
              label: _this246.localizedOptionTitles[t],
              icon: hw.get(t),
              tooltip: !0
            }), o.bind("isEnabled").to(i), o.bind("isOn").to(i, "value", function (e) {
              return e === t;
            }), _this246.listenTo(o, "execute", function () {
              e.execute("alignment", {
                value: t
              }), e.editing.view.focus();
            }), o;
          });
        }
      }, {
        key: "localizedOptionTitles",
        get: function get() {
          var t = this.editor.t;
          return {
            left: t("ab"),
            right: t("ac"),
            center: t("ad"),
            justify: t("ae")
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "AlignmentUI";
        }
      }]);

      return fw;
    }(Ql);

    var mw =
    /*#__PURE__*/
    function (_Ql74) {
      _inherits(mw, _Ql74);

      function mw() {
        _classCallCheck(this, mw);

        return _possibleConstructorReturn(this, _getPrototypeOf(mw).apply(this, arguments));
      }

      _createClass(mw, null, [{
        key: "requires",
        get: function get() {
          return [iw, fw];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Alignment";
        }
      }]);

      return mw;
    }(Ql);

    var pw = "Expected a function";

    var gw = function gw(t, e, n) {
      var i = !0,
          o = !0;
      if ("function" != typeof t) throw new TypeError(pw);
      return z(n) && (i = "leading" in n ? !!n.leading : i, o = "trailing" in n ? !!n.trailing : o), ps(t, e, {
        leading: i,
        maxWait: e,
        trailing: o
      });
    };

    var bw =
    /*#__PURE__*/
    function (_Ql75) {
      _inherits(bw, _Ql75);

      function bw(t) {
        var _this247;

        _classCallCheck(this, bw);

        _this247 = _possibleConstructorReturn(this, _getPrototypeOf(bw).call(this, t)), _this247.set("characters", 0), _this247.set("words", 0), _this247.set("_wordsLabel"), _this247.set("_charactersLabel"), _this247._config = t.config.get("wordCount") || {}, _this247._outputView;
        return _this247;
      }

      _createClass(bw, [{
        key: "init",
        value: function init() {
          var _this248 = this;

          this.editor.model.document.on("change:data", gw(this._calculateWordsAndCharacters.bind(this), 250)), "function" == typeof this._config.onUpdate && this.on("update", function (t, e) {
            _this248._config.onUpdate(e);
          }), Wn(this._config.container) && this._config.container.appendChild(this.wordCountContainer);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._outputView.element.remove(), this._outputView.destroy(), _get(_getPrototypeOf(bw.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_calculateWordsAndCharacters",
        value: function _calculateWordsAndCharacters() {
          var t = function t(e) {
            if (e.is("text") || e.is("textProxy")) return e.data;
            var n = "",
                i = null;
            var _iteratorNormalCompletion369 = true;
            var _didIteratorError369 = false;
            var _iteratorError369 = undefined;

            try {
              for (var _iterator369 = e.getChildren()[Symbol.iterator](), _step369; !(_iteratorNormalCompletion369 = (_step369 = _iterator369.next()).done); _iteratorNormalCompletion369 = true) {
                var _o104 = _step369.value;

                var _e270 = t(_o104);

                i && i.is("element") && (n += "\n"), n += _e270, i = _o104;
              }
            } catch (err) {
              _didIteratorError369 = true;
              _iteratorError369 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion369 && _iterator369.return != null) {
                  _iterator369.return();
                }
              } finally {
                if (_didIteratorError369) {
                  throw _iteratorError369;
                }
              }
            }

            return n;
          }(this.editor.model.document.getRoot());

          this.characters = t.length, this.words = (t.match(/[0-9A-Z_a-z\xC0-\u017E]+/g) || []).length, this.fire("update", {
            words: this.words,
            characters: this.characters
          });
        }
      }, {
        key: "wordCountContainer",
        get: function get() {
          var t = this.editor,
              e = t.t,
              n = t.config.get("wordCount.displayWords"),
              i = t.config.get("wordCount.displayCharacters"),
              o = gl.bind(this, this),
              r = [];
          return this._outputView || (this._outputView = new Rl(), (n || void 0 === n) && (this.bind("_wordsLabel").to(this, "words", function (t) {
            return e("b", [t]);
          }), r.push({
            tag: "div",
            children: [{
              text: [o.to("_wordsLabel")]
            }],
            attributes: {
              class: "ck-word-count__words"
            }
          })), (i || void 0 === i) && (this.bind("_charactersLabel").to(this, "characters", function (t) {
            return e("c", [t]);
          }), r.push({
            tag: "div",
            children: [{
              text: [o.to("_charactersLabel")]
            }],
            attributes: {
              class: "ck-word-count__characters"
            }
          })), this._outputView.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-word-count"]
            },
            children: r
          }), this._outputView.render()), this._outputView.element;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "WordCount";
        }
      }]);

      return bw;
    }(Ql);

    var ww =
    /*#__PURE__*/
    function () {
      function ww(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var n = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, ww);

        this.loader = t, this.uploadAction = e, this.setLoaderUploadProgress = this.setLoaderUploadProgress.bind(this), this.setLoadingAction = n;
      }

      _createClass(ww, [{
        key: "setLoaderUploadProgress",
        value: function setLoaderUploadProgress(t) {
          this.loader.uploadTotal = t.total, this.loader.uploaded = t.loaded;
        }
      }, {
        key: "upload",
        value: function () {
          var _upload = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee3() {
            var t, _e271;

            return _regeneratorRuntime.wrap(function _callee3$(_context37) {
              while (1) {
                switch (_context37.prev = _context37.next) {
                  case 0:
                    _context37.next = 2;
                    return this.loader.file;

                  case 2:
                    t = _context37.sent;

                    if (this.uploadAction) {
                      _context37.next = 5;
                      break;
                    }

                    throw new Error("Upload action is missing in S3ActionBasedUploadAdapter!");

                  case 5:
                    this.setLoadingAction(!0);
                    _context37.prev = 6;
                    _context37.next = 9;
                    return this.uploadAction(this.setLoaderUploadProgress)(t);

                  case 9:
                    _e271 = _context37.sent;

                    if (_e271.href) {
                      _context37.next = 12;
                      break;
                    }

                    throw new Error('Returned value should contain object with href key, ie. { href: "https://foo.com" }');

                  case 12:
                    return _context37.abrupt("return", (this.setLoadingAction(!1), {
                      default: _e271.href
                    }));

                  case 15:
                    _context37.prev = 15;
                    _context37.t0 = _context37["catch"](6);
                    throw this.setLoadingAction(!1), new Error(_context37.t0);

                  case 18:
                  case "end":
                    return _context37.stop();
                }
              }
            }, _callee3, this, [[6, 15]]);
          }));

          function upload() {
            return _upload.apply(this, arguments);
          }

          return upload;
        }()
      }, {
        key: "abort",
        value: function abort() {}
      }]);

      return ww;
    }();

    var _w = function _w(t, e) {
      return (
        /*#__PURE__*/
        function (_Ql76) {
          _inherits(_class2, _Ql76);

          function _class2() {
            _classCallCheck(this, _class2);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
          }

          _createClass(_class2, [{
            key: "init",
            value: function init() {
              if (!t) throw new Error("Upload action is missing in S3ActionBasedUpload!");

              this.editor.plugins.get("FileRepository").createUploadAdapter = function (n) {
                return new ww(n, t, e);
              };
            }
          }], [{
            key: "pluginName",
            get: function get() {
              return "S3ActionBasedUpload";
            }
          }]);

          return _class2;
        }(Ql)
      );
    };

    var kw = ["heading", "|", "bold", "italic", "underline", "blockQuote", "link", "bulletedList", "numberedList", "imageUpload", "alignment", "undo", "redo"];

    e.default = function (t) {
      var e = _w(t.uploadAction, t.setLoadingAction);

      return (
        /*#__PURE__*/
        function (_Gl) {
          _inherits(_class3, _Gl);

          function _class3() {
            _classCallCheck(this, _class3);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class3).apply(this, arguments));
          }

          _createClass(_class3, null, [{
            key: "builtinPlugins",
            get: function get() {
              return [mw, Jd, ru, du, _u, Tu, Ou, Hu, Ku, Rf, im, ff, um, Mm, Im, Of, Dp, ug, Eg, jf, jg, Jb, Kb, bw, e];
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                toolbar: {
                  items: kw
                },
                alignment: {
                  options: ["left", "right", "center"]
                },
                image: {
                  toolbar: ["imageStyle:full", "imageStyle:side", "|", "imageTextAlternative"]
                },
                table: {
                  contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
                },
                language: "en"
              };
            }
          }]);

          return _class3;
        }(Gl)
      );
    };
  }]).default;
});